import { getCurrentScope as ld, onScopeDispose as dd, unref as B, isRef as Le, toRefs as y3, customRef as M3, onMounted as et, nextTick as Jt, getCurrentInstance as To, watch as he, computed as z, ref as U, reactive as Mo, watchEffect as C3, inject as Ci, defineComponent as oe, openBlock as p, createElementBlock as g, normalizeClass as ee, createElementVNode as h, pushScopeId as ei, popScopeId as ti, resolveComponent as e1, createBlock as J, resolveDynamicComponent as Ce, withCtx as G, renderSlot as Y, createVNode as q, createCommentVNode as X, markRaw as I, createStaticVNode as Rr, Transition as Xe, createTextVNode as xe, toDisplayString as ne, Fragment as _e, renderList as Ie, onUnmounted as Zr, useCssVars as Nn, useSlots as cd, Teleport as c1, normalizeStyle as en, TransitionGroup as Br, createSlots as Pn, onBeforeMount as ud, withModifiers as Ye, h as hd, shallowRef as fd, Text as b3, defineOptions as x3, withDirectives as it, vModelCheckbox as md, shallowReadonly as No, normalizeProps as Vr, guardReactiveProps as Fr, withKeys as pd, vModelDynamic as S3, toRaw as I3, onBeforeUnmount as Hr, vShow as Xt, isReactive as A3, isReadonly as k3, provide as Ka, vModelRadio as E3, mergeProps as P3, vModelText as T3 } from "vue";
function ji(t) {
  return ld() ? (dd(t), !0) : !1;
}
function ye(t) {
  return typeof t == "function" ? t() : B(t);
}
const Ur = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const O3 = (t) => typeof t < "u", L3 = (t) => t != null, D3 = Object.prototype.toString, N3 = (t) => D3.call(t) === "[object Object]", pt = () => {
}, R3 = /* @__PURE__ */ Z3();
function Z3() {
  var t, e;
  return Ur && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function _d(t, e) {
  function n(...o) {
    return new Promise((i, r) => {
      Promise.resolve(t(() => e.apply(this, o), { fn: e, thisArg: this, args: o })).then(i).catch(r);
    });
  }
  return n;
}
function B3(t, e = {}) {
  let n, o, i = pt;
  const r = (s) => {
    clearTimeout(s), i(), i = pt;
  };
  return (s) => {
    const l = ye(t), d = ye(e.maxWait);
    return n && r(n), l <= 0 || d !== void 0 && d <= 0 ? (o && (r(o), o = null), Promise.resolve(s())) : new Promise((c, u) => {
      i = e.rejectOnCancel ? u : c, d && !o && (o = setTimeout(() => {
        n && r(n), o = null, c(s());
      }, d)), n = setTimeout(() => {
        o && r(o), o = null, c(s());
      }, l);
    });
  };
}
function V3(...t) {
  let e = 0, n, o = !0, i = pt, r, a, s, l, d;
  !Le(t[0]) && typeof t[0] == "object" ? { delay: a, trailing: s = !0, leading: l = !0, rejectOnCancel: d = !1 } = t[0] : [a, s = !0, l = !0, d = !1] = t;
  const c = () => {
    n && (clearTimeout(n), n = void 0, i(), i = pt);
  };
  return (f) => {
    const m = ye(a), v = Date.now() - e, _ = () => r = f();
    return c(), m <= 0 ? (e = Date.now(), _()) : (v > m && (l || !o) ? (e = Date.now(), _()) : s && (r = new Promise((w, $) => {
      i = d ? $ : w, n = setTimeout(() => {
        e = Date.now(), o = !0, w(_()), c();
      }, Math.max(0, m - v));
    })), !l && !n && (n = setTimeout(() => o = !0, m)), o = !1, r);
  };
}
function F3(t, e) {
  var n;
  if (typeof t == "number")
    return t + e;
  const o = ((n = t.match(/^-?\d+\.?\d*/)) == null ? void 0 : n[0]) || "", i = t.slice(o.length), r = Number.parseFloat(o) + e;
  return Number.isNaN(r) ? t : r + i;
}
function H3(t) {
  return To();
}
function bi(t, e = 200, n = {}) {
  return _d(
    B3(e, n),
    t
  );
}
function U3(t, e = 200, n = !1, o = !0, i = !1) {
  return _d(
    V3(e, n, o, i),
    t
  );
}
function z3(t, e = {}) {
  if (!Le(t))
    return y3(t);
  const n = Array.isArray(t.value) ? Array.from({ length: t.value.length }) : {};
  for (const o in t.value)
    n[o] = M3(() => ({
      get() {
        return t.value[o];
      },
      set(i) {
        var r;
        if ((r = ye(e.replaceRef)) != null ? r : !0)
          if (Array.isArray(t.value)) {
            const s = [...t.value];
            s[o] = i, t.value = s;
          } else {
            const s = { ...t.value, [o]: i };
            Object.setPrototypeOf(s, Object.getPrototypeOf(t.value)), t.value = s;
          }
        else
          t.value[o] = i;
      }
    }));
  return n;
}
function vd(t, e = !0, n) {
  H3() ? et(t, n) : e ? t() : Jt(t);
}
function mt(t) {
  var e;
  const n = ye(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
const yn = Ur ? window : void 0;
function St(...t) {
  let e, n, o, i;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([n, o, i] = t, e = yn) : [e, n, o, i] = t, !e)
    return pt;
  Array.isArray(n) || (n = [n]), Array.isArray(o) || (o = [o]);
  const r = [], a = () => {
    r.forEach((c) => c()), r.length = 0;
  }, s = (c, u, f, m) => (c.addEventListener(u, f, m), () => c.removeEventListener(u, f, m)), l = he(
    () => [mt(e), ye(i)],
    ([c, u]) => {
      if (a(), !c)
        return;
      const f = N3(u) ? { ...u } : u;
      r.push(
        ...n.flatMap((m) => o.map((v) => s(c, m, v, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    l(), a();
  };
  return ji(d), d;
}
let qa = !1;
function D1(t, e, n = {}) {
  const { window: o = yn, ignore: i = [], capture: r = !0, detectIframe: a = !1 } = n;
  if (!o)
    return pt;
  R3 && !qa && (qa = !0, Array.from(o.document.body.children).forEach((f) => f.addEventListener("click", pt)), o.document.documentElement.addEventListener("click", pt));
  let s = !0;
  const l = (f) => i.some((m) => {
    if (typeof m == "string")
      return Array.from(o.document.querySelectorAll(m)).some((v) => v === f.target || f.composedPath().includes(v));
    {
      const v = mt(m);
      return v && (f.target === v || f.composedPath().includes(v));
    }
  }), c = [
    St(o, "click", (f) => {
      const m = mt(t);
      if (!(!m || m === f.target || f.composedPath().includes(m))) {
        if (f.detail === 0 && (s = !l(f)), !s) {
          s = !0;
          return;
        }
        e(f);
      }
    }, { passive: !0, capture: r }),
    St(o, "pointerdown", (f) => {
      const m = mt(t);
      s = !l(f) && !!(m && !f.composedPath().includes(m));
    }, { passive: !0 }),
    a && St(o, "blur", (f) => {
      setTimeout(() => {
        var m;
        const v = mt(t);
        ((m = o.document.activeElement) == null ? void 0 : m.tagName) === "IFRAME" && !(v != null && v.contains(o.document.activeElement)) && e(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => c.forEach((f) => f());
}
function W3() {
  const t = U(!1), e = To();
  return e && et(() => {
    t.value = !0;
  }, e), t;
}
function zr(t) {
  const e = W3();
  return z(() => (e.value, !!t()));
}
function v1(t, e = {}) {
  const { window: n = yn } = e, o = zr(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let i;
  const r = U(!1), a = (d) => {
    r.value = d.matches;
  }, s = () => {
    i && ("removeEventListener" in i ? i.removeEventListener("change", a) : i.removeListener(a));
  }, l = C3(() => {
    o.value && (s(), i = n.matchMedia(ye(t)), "addEventListener" in i ? i.addEventListener("change", a) : i.addListener(a), r.value = i.matches);
  });
  return ji(() => {
    l(), s(), i = void 0;
  }), r;
}
function j3(t, e = {}) {
  function n(c, u) {
    let f = ye(t[ye(c)]);
    return u != null && (f = F3(f, u)), typeof f == "number" && (f = `${f}px`), f;
  }
  const { window: o = yn, strategy: i = "min-width" } = e;
  function r(c) {
    return o ? o.matchMedia(c).matches : !1;
  }
  const a = (c) => v1(() => `(min-width: ${n(c)})`, e), s = (c) => v1(() => `(max-width: ${n(c)})`, e), l = Object.keys(t).reduce((c, u) => (Object.defineProperty(c, u, {
    get: () => i === "min-width" ? a(u) : s(u),
    enumerable: !0,
    configurable: !0
  }), c), {});
  function d() {
    const c = Object.keys(t).map((u) => [u, a(u)]);
    return z(() => c.filter(([, u]) => u.value).map(([u]) => u));
  }
  return Object.assign(l, {
    greaterOrEqual: a,
    smallerOrEqual: s,
    greater(c) {
      return v1(() => `(min-width: ${n(c, 0.1)})`, e);
    },
    smaller(c) {
      return v1(() => `(max-width: ${n(c, -0.1)})`, e);
    },
    between(c, u) {
      return v1(() => `(min-width: ${n(c)}) and (max-width: ${n(u, -0.1)})`, e);
    },
    isGreater(c) {
      return r(`(min-width: ${n(c, 0.1)})`);
    },
    isGreaterOrEqual(c) {
      return r(`(min-width: ${n(c)})`);
    },
    isSmaller(c) {
      return r(`(max-width: ${n(c, -0.1)})`);
    },
    isSmallerOrEqual(c) {
      return r(`(max-width: ${n(c)})`);
    },
    isInBetween(c, u) {
      return r(`(min-width: ${n(c)}) and (max-width: ${n(u, -0.1)})`);
    },
    current: d,
    active() {
      const c = d();
      return z(() => c.value.length === 0 ? "" : c.value.at(-1));
    }
  });
}
function G3(t) {
  return JSON.parse(JSON.stringify(t));
}
function Y3(t, e = {}) {
  var n, o;
  const {
    pointerTypes: i,
    preventDefault: r,
    stopPropagation: a,
    exact: s,
    onMove: l,
    onEnd: d,
    onStart: c,
    initialValue: u,
    axis: f = "both",
    draggingElement: m = yn,
    containerElement: v,
    handle: _ = t
  } = e, w = U(
    (n = ye(u)) != null ? n : { x: 0, y: 0 }
  ), $ = U(), y = (C) => i ? i.includes(C.pointerType) : !0, M = (C) => {
    ye(r) && C.preventDefault(), ye(a) && C.stopPropagation();
  }, S = (C) => {
    var E;
    if (C.button !== 0 || ye(e.disabled) || !y(C) || ye(s) && C.target !== ye(t))
      return;
    const A = ye(v), T = (E = A == null ? void 0 : A.getBoundingClientRect) == null ? void 0 : E.call(A), k = ye(t).getBoundingClientRect(), L = {
      x: C.clientX - (A ? k.left - T.left + A.scrollLeft : k.left),
      y: C.clientY - (A ? k.top - T.top + A.scrollTop : k.top)
    };
    (c == null ? void 0 : c(L, C)) !== !1 && ($.value = L, M(C));
  }, x = (C) => {
    if (ye(e.disabled) || !y(C) || !$.value)
      return;
    const E = ye(v), A = ye(t).getBoundingClientRect();
    let { x: T, y: k } = w.value;
    (f === "x" || f === "both") && (T = C.clientX - $.value.x, E && (T = Math.min(Math.max(0, T), E.scrollWidth - A.width))), (f === "y" || f === "both") && (k = C.clientY - $.value.y, E && (k = Math.min(Math.max(0, k), E.scrollHeight - A.height))), w.value = {
      x: T,
      y: k
    }, l == null || l(w.value, C), M(C);
  }, b = (C) => {
    ye(e.disabled) || !y(C) || $.value && ($.value = void 0, d == null || d(w.value, C), M(C));
  };
  if (Ur) {
    const C = { capture: (o = e.capture) != null ? o : !0 };
    St(_, "pointerdown", S, C), St(m, "pointermove", x, C), St(m, "pointerup", b, C);
  }
  return {
    ...z3(w),
    position: w,
    isDragging: z(() => !!$.value),
    style: z(
      () => `left:${w.value.x}px;top:${w.value.y}px;`
    )
  };
}
function gd(t, e, n = {}) {
  const { window: o = yn, ...i } = n;
  let r;
  const a = zr(() => o && "ResizeObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = z(() => Array.isArray(t) ? t.map((u) => mt(u)) : [mt(t)]), d = he(
    l,
    (u) => {
      if (s(), a.value && o) {
        r = new ResizeObserver(e);
        for (const f of u)
          f && r.observe(f, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    s(), d();
  };
  return ji(c), {
    isSupported: a,
    stop: c
  };
}
function X3(t, e = { width: 0, height: 0 }, n = {}) {
  const { window: o = yn, box: i = "content-box" } = n, r = z(() => {
    var u, f;
    return (f = (u = mt(t)) == null ? void 0 : u.namespaceURI) == null ? void 0 : f.includes("svg");
  }), a = U(e.width), s = U(e.height), { stop: l } = gd(
    t,
    ([u]) => {
      const f = i === "border-box" ? u.borderBoxSize : i === "content-box" ? u.contentBoxSize : u.devicePixelContentBoxSize;
      if (o && r.value) {
        const m = mt(t);
        if (m) {
          const v = m.getBoundingClientRect();
          a.value = v.width, s.value = v.height;
        }
      } else if (f) {
        const m = Array.isArray(f) ? f : [f];
        a.value = m.reduce((v, { inlineSize: _ }) => v + _, 0), s.value = m.reduce((v, { blockSize: _ }) => v + _, 0);
      } else
        a.value = u.contentRect.width, s.value = u.contentRect.height;
    },
    n
  );
  vd(() => {
    const u = mt(t);
    u && (a.value = "offsetWidth" in u ? u.offsetWidth : e.width, s.value = "offsetHeight" in u ? u.offsetHeight : e.height);
  });
  const d = he(
    () => mt(t),
    (u) => {
      a.value = u ? e.width : 0, s.value = u ? e.height : 0;
    }
  );
  function c() {
    l(), d();
  }
  return {
    width: a,
    height: s,
    stop: c
  };
}
function K3(t, e, n = {}) {
  const {
    root: o,
    rootMargin: i = "0px",
    threshold: r = 0.1,
    window: a = yn,
    immediate: s = !0
  } = n, l = zr(() => a && "IntersectionObserver" in a), d = z(() => {
    const v = ye(t);
    return (Array.isArray(v) ? v : [v]).map(mt).filter(L3);
  });
  let c = pt;
  const u = U(s), f = l.value ? he(
    () => [d.value, mt(o), u.value],
    ([v, _]) => {
      if (c(), !u.value || !v.length)
        return;
      const w = new IntersectionObserver(
        e,
        {
          root: mt(_),
          rootMargin: i,
          threshold: r
        }
      );
      v.forEach(($) => $ && w.observe($)), c = () => {
        w.disconnect(), c = pt;
      };
    },
    { immediate: s, flush: "post" }
  ) : pt, m = () => {
    c(), f(), u.value = !1;
  };
  return ji(m), {
    isSupported: l,
    isActive: u,
    pause() {
      c(), u.value = !1;
    },
    resume() {
      u.value = !0;
    },
    stop: m
  };
}
const Ja = 1;
function q3(t, e = {}) {
  const {
    throttle: n = 0,
    idle: o = 200,
    onStop: i = pt,
    onScroll: r = pt,
    offset: a = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: s = {
      capture: !1,
      passive: !0
    },
    behavior: l = "auto",
    window: d = yn,
    onError: c = (C) => {
      console.error(C);
    }
  } = e, u = U(0), f = U(0), m = z({
    get() {
      return u.value;
    },
    set(C) {
      _(C, void 0);
    }
  }), v = z({
    get() {
      return f.value;
    },
    set(C) {
      _(void 0, C);
    }
  });
  function _(C, E) {
    var A, T, k, L;
    if (!d)
      return;
    const V = ye(t);
    if (!V)
      return;
    (k = V instanceof Document ? d.document.body : V) == null || k.scrollTo({
      top: (A = ye(E)) != null ? A : v.value,
      left: (T = ye(C)) != null ? T : m.value,
      behavior: ye(l)
    });
    const O = ((L = V == null ? void 0 : V.document) == null ? void 0 : L.documentElement) || (V == null ? void 0 : V.documentElement) || V;
    m != null && (u.value = O.scrollLeft), v != null && (f.value = O.scrollTop);
  }
  const w = U(!1), $ = Mo({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), y = Mo({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), M = (C) => {
    w.value && (w.value = !1, y.left = !1, y.right = !1, y.top = !1, y.bottom = !1, i(C));
  }, S = bi(M, n + o), x = (C) => {
    var E;
    if (!d)
      return;
    const A = ((E = C == null ? void 0 : C.document) == null ? void 0 : E.documentElement) || (C == null ? void 0 : C.documentElement) || mt(C), { display: T, flexDirection: k } = getComputedStyle(A), L = A.scrollLeft;
    y.left = L < u.value, y.right = L > u.value;
    const V = Math.abs(L) <= (a.left || 0), O = Math.abs(L) + A.clientWidth >= A.scrollWidth - (a.right || 0) - Ja;
    T === "flex" && k === "row-reverse" ? ($.left = O, $.right = V) : ($.left = V, $.right = O), u.value = L;
    let D = A.scrollTop;
    C === d.document && !D && (D = d.document.body.scrollTop), y.top = D < f.value, y.bottom = D > f.value;
    const P = Math.abs(D) <= (a.top || 0), F = Math.abs(D) + A.clientHeight >= A.scrollHeight - (a.bottom || 0) - Ja;
    T === "flex" && k === "column-reverse" ? ($.top = F, $.bottom = P) : ($.top = P, $.bottom = F), f.value = D;
  }, b = (C) => {
    var E;
    if (!d)
      return;
    const A = (E = C.target.documentElement) != null ? E : C.target;
    x(A), w.value = !0, S(C), r(C);
  };
  return St(
    t,
    "scroll",
    n ? U3(b, n, !0, !1) : b,
    s
  ), vd(() => {
    try {
      const C = ye(t);
      if (!C)
        return;
      x(C);
    } catch (C) {
      c(C);
    }
  }), St(
    t,
    "scrollend",
    M,
    s
  ), {
    x: m,
    y: v,
    isScrolling: w,
    arrivedState: $,
    directions: y,
    measure() {
      const C = ye(t);
      d && C && x(C);
    }
  };
}
function Wr(t, e = {}) {
  const {
    threshold: n = 50,
    onSwipe: o,
    onSwipeEnd: i,
    onSwipeStart: r,
    passive: a = !0,
    window: s = yn
  } = e, l = Mo({ x: 0, y: 0 }), d = Mo({ x: 0, y: 0 }), c = z(() => l.x - d.x), u = z(() => l.y - d.y), { max: f, abs: m } = Math, v = z(() => f(m(c.value), m(u.value)) >= n), _ = U(!1), w = z(() => v.value ? m(c.value) > m(u.value) ? c.value > 0 ? "left" : "right" : u.value > 0 ? "up" : "down" : "none"), $ = (A) => [A.touches[0].clientX, A.touches[0].clientY], y = (A, T) => {
    l.x = A, l.y = T;
  }, M = (A, T) => {
    d.x = A, d.y = T;
  };
  let S;
  const x = J3(s == null ? void 0 : s.document);
  a ? S = x ? { passive: !0 } : { capture: !1 } : S = x ? { passive: !1, capture: !0 } : { capture: !0 };
  const b = (A) => {
    _.value && (i == null || i(A, w.value)), _.value = !1;
  }, C = [
    St(t, "touchstart", (A) => {
      if (A.touches.length !== 1)
        return;
      S.capture && !S.passive && A.preventDefault();
      const [T, k] = $(A);
      y(T, k), M(T, k), r == null || r(A);
    }, S),
    St(t, "touchmove", (A) => {
      if (A.touches.length !== 1)
        return;
      const [T, k] = $(A);
      M(T, k), !_.value && v.value && (_.value = !0), _.value && (o == null || o(A));
    }, S),
    St(t, ["touchend", "touchcancel"], b, S)
  ];
  return {
    isPassiveEventSupported: x,
    isSwiping: _,
    direction: w,
    coordsStart: l,
    coordsEnd: d,
    lengthX: c,
    lengthY: u,
    stop: () => C.forEach((A) => A())
  };
}
function J3(t) {
  if (!t)
    return !1;
  let e = !1;
  const n = {
    get passive() {
      return e = !0, !1;
    }
  };
  return t.addEventListener("x", pt, n), t.removeEventListener("x", pt), e;
}
function Q3(t) {
  var e;
  const n = U(t == null ? void 0 : t.element), o = U(t == null ? void 0 : t.input), i = (e = t == null ? void 0 : t.styleProp) != null ? e : "height", r = U(1);
  function a() {
    var s;
    if (!n.value)
      return;
    let l = "";
    n.value.style[i] = "1px", r.value = (s = n.value) == null ? void 0 : s.scrollHeight, t != null && t.styleTarget ? ye(t.styleTarget).style[i] = `${r.value}px` : l = `${r.value}px`, n.value.style[i] = l;
  }
  return he([o, n], () => Jt(a), { immediate: !0 }), he(r, () => {
    var s;
    return (s = t == null ? void 0 : t.onResize) == null ? void 0 : s.call(t);
  }), gd(n, () => a()), t != null && t.watch && he(t.watch, a, { immediate: !0, deep: !0 }), {
    textarea: n,
    input: o,
    triggerResize: a
  };
}
function me(t, e, n, o = {}) {
  var i, r, a;
  const {
    clone: s = !1,
    passive: l = !1,
    eventName: d,
    deep: c = !1,
    defaultValue: u,
    shouldEmit: f
  } = o, m = To(), v = n || (m == null ? void 0 : m.emit) || ((i = m == null ? void 0 : m.$emit) == null ? void 0 : i.bind(m)) || ((a = (r = m == null ? void 0 : m.proxy) == null ? void 0 : r.$emit) == null ? void 0 : a.bind(m == null ? void 0 : m.proxy));
  let _ = d;
  e || (e = "modelValue"), _ = _ || `update:${e.toString()}`;
  const w = (M) => s ? typeof s == "function" ? s(M) : G3(M) : M, $ = () => O3(t[e]) ? w(t[e]) : u, y = (M) => {
    f ? f(M) && v(_, M) : v(_, M);
  };
  if (l) {
    const M = $(), S = U(M);
    let x = !1;
    return he(
      () => t[e],
      (b) => {
        x || (x = !0, S.value = w(b), Jt(() => x = !1));
      }
    ), he(
      S,
      (b) => {
        !x && (b !== t[e] || c) && y(b);
      },
      { deep: c }
    ), S;
  } else
    return z({
      get() {
        return $();
      },
      set(M) {
        y(M);
      }
    });
}
var qe = /* @__PURE__ */ ((t) => (t.mobile = "mobile", t.tablet = "tablet", t.desktop = "desktop", t.desktopLarge = "desktopLarge", t.mobileUp = "mobileUp", t.tabletUp = "tabletUp", t))(qe || {});
const eu = () => ({ config: Ci("ProfeatUI") }), nt = () => {
  const { config: t } = eu(), e = {
    [qe.mobile]: 720,
    [qe.tablet]: 1024,
    [qe.desktop]: 1440
  };
  t != null && t.breakpoints && Object.assign(e, t.breakpoints);
  const { smaller: n, between: o, greaterOrEqual: i } = j3(e);
  return {
    [qe.mobile]: n(qe.mobile),
    [qe.tablet]: o(qe.mobile, qe.tablet),
    [qe.desktop]: o(qe.tablet, qe.desktop),
    [qe.desktopLarge]: i(qe.desktop),
    [qe.mobileUp]: i(qe.mobile),
    [qe.tabletUp]: i(qe.tablet)
  };
}, tu = (t) => (ei("data-v-bf39fcc2"), t = t(), ti(), t), nu = /* @__PURE__ */ tu(() => /* @__PURE__ */ h("svg", { viewBox: "0 0 43 43" }, [
  /* @__PURE__ */ h("circle", {
    class: "loader-circle",
    fill: "none",
    "stroke-linecap": "round",
    "transform-origin": "center",
    stroke: "none",
    cx: "21.5",
    cy: "21.5",
    r: "16",
    "stroke-width": "3",
    "stroke-dasharray": "160",
    "stroke-dashoffset": "160"
  })
], -1)), ou = [
  nu
], iu = /* @__PURE__ */ oe({
  name: "PLoader",
  __name: "PLoader",
  props: {
    size: { default: "normal" },
    color: { default: "primary" },
    absolute: { type: Boolean }
  },
  setup(t) {
    return (e, n) => (p(), g("div", {
      class: ee(["p-loader", { absolute: e.absolute }])
    }, [
      h("div", {
        class: ee(["p-loader-wrapper", `size-${e.size}`, `color-${e.color}`])
      }, ou, 2)
    ], 2));
  }
}), ae = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [o, i] of e)
    n[o] = i;
  return n;
}, _t = /* @__PURE__ */ ae(iu, [["__scopeId", "data-v-bf39fcc2"]]), ru = { class: "main" }, au = {
  key: 0,
  class: "loader"
}, su = /* @__PURE__ */ oe({
  name: "PButton",
  __name: "index",
  props: {
    variant: { default: "default" },
    size: { default: "small" },
    color: {},
    disabled: { type: Boolean },
    loading: { type: Boolean },
    href: {},
    to: {},
    nuxt: { type: Boolean },
    type: { default: "button" },
    block: { type: Boolean }
  },
  setup(t) {
    const e = t, n = z(() => e.nuxt ? e1("NuxtLink") : e.href ? "a" : e.to ? e1("RouterLink") : "button"), o = z(() => i.value === "primary" ? "secondary" : "primary"), i = z(() => e.color || (e.variant === "text" ? "black" : "primary"));
    return (r, a) => {
      const s = _t;
      return p(), J(Ce(n.value), {
        class: ee(["p-button", `variant-${r.variant}`, `size-${r.size}`, `color-${i.value}`, { disabled: r.disabled, loading: r.loading, block: r.block }]),
        href: r.href,
        to: r.to,
        disabled: r.disabled || r.loading,
        type: r.type,
        onClick: a[0] || (a[0] = (l) => {
          var d, c;
          return (c = (d = l.currentTarget).blur) == null ? void 0 : c.call(d);
        })
      }, {
        default: G(() => [
          Y(r.$slots, "left"),
          h("span", ru, [
            Y(r.$slots, "default")
          ]),
          Y(r.$slots, "right"),
          r.loading ? (p(), g("div", au, [
            q(s, {
              color: o.value,
              size: "small"
            }, null, 8, ["color"])
          ])) : X("", !0)
        ]),
        _: 3
      }, 8, ["class", "href", "to", "disabled", "type"]);
    };
  }
}), vt = /* @__PURE__ */ ae(su, [["__scopeId", "data-v-1718202a"]]), lu = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, du = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.293 3.293a1 1 0 0 1 1.414 0L10 8.586l5.293-5.293a1 1 0 1 1 1.414 1.414L11.414 10l5.293 5.293a1 1 0 0 1-1.414 1.414L10 11.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L8.586 10 3.293 4.707a1 1 0 0 1 0-1.414Z",
  "clip-rule": "evenodd"
}, null, -1), cu = [
  du
];
function uu(t, e) {
  return p(), g("svg", lu, [...cu]);
}
const Gi = I({ name: "icon-cross-md", render: uu }), hu = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}, fu = ["clip-path"], mu = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M7.524 3.266a.614.614 0 0 1 0 .9L4.397 7.064a.593.593 0 0 0-.143.192.555.555 0 0 0 .135.652c.06.056.131.1.21.13A.684.684 0 0 0 5.3 7.9l3.615-3.348c.36-.333.561-.784.561-1.255 0-.471-.202-.923-.561-1.256a1.997 1.997 0 0 0-1.356-.52c-.508 0-.996.187-1.355.52L2.589 5.39c-.303.274-.544.6-.71.96a2.77 2.77 0 0 0-.015 2.282c.16.363.398.692.697.97.299.276.654.495 1.046.644a3.417 3.417 0 0 0 2.463-.014c.39-.154.742-.377 1.037-.658l3.197-2.96a.614.614 0 1 1 .835.9L8.01 10.412a4.51 4.51 0 0 1-1.452.898 4.784 4.784 0 0 1-3.423 0 4.51 4.51 0 0 1-1.451-.898 4.137 4.137 0 0 1-.97-1.344 3.88 3.88 0 0 1-.34-1.586c0-.544.116-1.083.34-1.585.225-.503.555-.96.97-1.344L5.3 1.206a3.335 3.335 0 0 1 2.247-.83 3.326 3.326 0 0 1 2.232.866c.592.548.928 1.29.935 2.066a2.846 2.846 0 0 1-.897 2.082L6.204 8.739c-.178.164-.39.295-.622.384a2.05 2.05 0 0 1-1.468 0 1.934 1.934 0 0 1-.622-.385 1.773 1.773 0 0 1-.415-.576 1.663 1.663 0 0 1 0-1.359c.096-.215.238-.411.416-.576L6.69 3.266a.614.614 0 0 1 .834 0Z"
}, null, -1), pu = [
  mu
], _u = ["id"], vu = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), gu = [
  vu
];
function $u(t, e) {
  return p(), g("svg", hu, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...pu], 8, fu),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...gu], 8, _u)
    ])
  ]);
}
const wu = I({ name: "icon-AttachmentXS", render: $u, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), yu = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}, Mu = ["clip-path"], Cu = /* @__PURE__ */ h("path", { d: "M3.75 6.375a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM4.5 7.875a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM6 6.375a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM6.75 7.875a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM8.25 6.375a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" }, null, -1), bu = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  d: "M2.85 0a.6.6 0 0 0-.6.6v1.65a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h7.5a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5h-.001V.6a.6.6 0 0 0-1.2 0v1.65H3.45V.6a.6.6 0 0 0-.6-.6Zm-.6 3.45h7.5a.3.3 0 0 1 .3.3v6a.3.3 0 0 1-.3.3h-7.5a.3.3 0 0 1-.3-.3v-6a.3.3 0 0 1 .3-.3Z",
  "clip-rule": "evenodd"
}, null, -1), xu = [
  Cu,
  bu
], Su = ["id"], Iu = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), Au = [
  Iu
];
function ku(t, e) {
  return p(), g("svg", yu, [
    h("g", {
      fill: "currentColor",
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...xu], 8, Mu),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Au], 8, Su)
    ])
  ]);
}
const Eu = I({ name: "icon-CalendarXS", render: ku, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Pu = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}, Tu = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6 .3a2.55 2.55 0 0 0-2.55 2.55v3a2.55 2.55 0 1 0 5.1 0v-3A2.55 2.55 0 0 0 6 .3Zm-.955 1.595a1.35 1.35 0 0 1 2.305.955v3a1.35 1.35 0 0 1-2.7 0v-3c0-.358.142-.701.395-.955Z",
  "clip-rule": "evenodd"
}, null, -1), Ou = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M9.75 5.7a.6.6 0 0 0-.6.6v.299l-.002.126A3 3 0 0 1 6.15 9.6H5.85l-.126-.002A3 3 0 0 1 2.85 6.6v-.305l-.005-.072v-.005A.6.6 0 0 0 1.65 6.3v.3l.002.144v.003a4.2 4.2 0 0 0 3.748 4.03v.628l.005.072v.005A.6.6 0 0 0 6.6 11.4v-.624A4.2 4.2 0 0 0 10.35 6.6v-.305l-.005-.072v-.005A.6.6 0 0 0 9.75 5.7Z"
}, null, -1), Lu = [
  Tu,
  Ou
];
function Du(t, e) {
  return p(), g("svg", Pu, [...Lu]);
}
const Nu = I({ name: "icon-MicrophoneXS", render: Du }), Ru = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}, Zu = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.196 1.8c-.247 0-.474.074-.664.2a.6.6 0 0 1-.664-1 2.4 2.4 0 1 1 2.127 4.263.6.6 0 0 1-.4-1.131 1.2 1.2 0 0 0-.4-2.332ZM4.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM1.8 4.5a2.7 2.7 0 1 1 5.4 0 2.7 2.7 0 0 1-5.4 0Zm6.967 1.895a.6.6 0 0 1 .769-.359c1.826.664 1.867 2.181 1.867 2.282 0 .874-.708 1.582-1.581 1.582h-.137a.6.6 0 0 1 0-1.2h.137c.21 0 .38-.17.382-.38-.004-.073-.076-.792-1.078-1.156a.6.6 0 0 1-.36-.769Zm-5.91 1.028a.6.6 0 0 1-.09.844c-1.212.979-.985 1.732-.863 1.932l.045.001h5.102l.045-.001c.122-.2.35-.953-.862-1.932a.6.6 0 1 1 .754-.934c1.662 1.343 1.699 2.957.94 3.742-.294.304-.686.325-.877.325H1.95c-.19 0-.583-.021-.877-.325-.758-.785-.722-2.399.94-3.742a.6.6 0 0 1 .844.09Z",
  "clip-rule": "evenodd"
}, null, -1), Bu = [
  Zu
];
function Vu(t, e) {
  return p(), g("svg", Ru, [...Bu]);
}
const Fu = I({ name: "icon-PeopleXS", render: Vu }), Hu = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}, Uu = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.003 1.5a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6Zm-3 1.8a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm.713 3.51a.6.6 0 0 1-.065.846c-1.642 1.407-1.265 2.567-1.045 2.84l.008.001a.592.592 0 0 0 .064.003h6.71a.592.592 0 0 0 .063-.003h.008c.22-.274.597-1.434-1.045-2.841a.6.6 0 1 1 .781-.912c2.035 1.745 1.966 3.756 1.084 4.631-.296.295-.68.325-.892.325h-6.71c-.211 0-.595-.03-.891-.325C.904 10.5.836 8.49 2.87 6.745a.6.6 0 0 1 .846.065Z",
  "clip-rule": "evenodd"
}, null, -1), zu = [
  Uu
];
function Wu(t, e) {
  return p(), g("svg", Hu, [...zu]);
}
const ju = I({ name: "icon-ProfileXS", render: Wu }), Gu = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}, Yu = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.346.787a.692.692 0 0 0-.941-.005.617.617 0 0 0-.005.906l.256.244H2.562c-.556 0-1.007.43-1.007.96V4.81c0 .353.301.64.672.64.37 0 .671-.287.671-.64v-1.6h5.758l-.256.244a.617.617 0 0 0 .005.906.692.692 0 0 0 .94-.004l1.16-1.107a.928.928 0 0 0 0-1.357L9.345.787Zm.43 5.768c-.37 0-.67.287-.67.64V8.78H3.346l.256-.244a.617.617 0 0 0-.005-.905.692.692 0 0 0-.94.004L1.495 8.743a.928.928 0 0 0-.002 1.355l1.16 1.113a.693.693 0 0 0 .949.002.618.618 0 0 0-.005-.908l-.247-.23h6.09c.556 0 1.007-.43 1.007-.96v-1.92c0-.353-.3-.64-.67-.64Z",
  "clip-rule": "evenodd"
}, null, -1), Xu = [
  Yu
];
function Ku(t, e) {
  return p(), g("svg", Gu, [...Xu]);
}
const qu = I({ name: "icon-RepeatXS", render: Ku }), Ju = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}, Qu = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.8.6a.6.6 0 0 1 .6.6v2.743h3.045v-.086c0-.347.143-.676.39-.916a1.32 1.32 0 0 1 .918-.37h2.74c.34 0 .671.131.918.37.247.24.39.569.39.916V5.23c0 .347-.143.676-.39.915-.247.24-.578.37-.918.37h-2.74a1.32 1.32 0 0 1-.918-.37 1.275 1.275 0 0 1-.39-.915v-.086H2.4v3.6c0 .016.007.036.025.054a.12.12 0 0 0 .083.032h2.937v-.086c0-.347.143-.676.39-.916a1.32 1.32 0 0 1 .918-.37h2.74c.34 0 .671.131.918.37.247.24.39.569.39.916v1.371c0 .347-.143.676-.39.916-.247.239-.578.37-.918.37h-2.74c-.34 0-.671-.131-.918-.37a1.275 1.275 0 0 1-.39-.916v-.085H2.508a1.32 1.32 0 0 1-.918-.37 1.275 1.275 0 0 1-.39-.916V1.2a.6.6 0 0 1 .6-.6Zm4.845 9.514c0 .017.007.037.025.054a.12.12 0 0 0 .083.032h2.74a.12.12 0 0 0 .082-.032.075.075 0 0 0 .025-.054V8.743a.075.075 0 0 0-.025-.054.12.12 0 0 0-.082-.032h-2.74a.12.12 0 0 0-.083.032.075.075 0 0 0-.025.054v1.371Zm0-4.885c0 .016.007.036.025.054a.12.12 0 0 0 .083.031h2.74a.12.12 0 0 0 .082-.031.075.075 0 0 0 .025-.054V3.857a.075.075 0 0 0-.025-.054.12.12 0 0 0-.082-.032h-2.74a.12.12 0 0 0-.083.032.075.075 0 0 0-.025.054V5.23Z",
  "clip-rule": "evenodd"
}, null, -1), e6 = [
  Qu
];
function t6(t, e) {
  return p(), g("svg", Ju, [...e6]);
}
const n6 = I({ name: "icon-SubtaskXS", render: t6 }), o6 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}, i6 = ["clip-path"], r6 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0Zm2.237 8.486c-.544.5-1.286.795-2.171.795a3.279 3.279 0 0 1-2.93-4.756 3.278 3.278 0 0 1 2.93-1.808c.884 0 1.626.326 2.195.855l-.94.941a1.77 1.77 0 0 0-1.254-.49c-.854 0-1.578.577-1.836 1.353A1.974 1.974 0 0 0 4.128 6c0 .217.037.427.103.624.258.776.982 1.353 1.835 1.353.442 0 .817-.117 1.11-.314.348-.233.578-.58.655-.99H6.066v-1.27h3.09c.038.215.058.439.058.67 0 1.001-.357 1.84-.977 2.413Z"
}, null, -1), a6 = [
  r6
], s6 = ["id"], l6 = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), d6 = [
  l6
];
function c6(t, e) {
  return p(), g("svg", o6, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...a6], 8, i6),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...d6], 8, s6)
    ])
  ]);
}
const u6 = I({ name: "icon-FilledGoogleXS", render: c6, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), h6 = {
  component: "",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, f6 = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.888 2.215a.75.75 0 0 1 1.031.813L9.785 9.906a.988.988 0 0 1-1.446.714 29.216 29.216 0 0 1-1.945-1.147c-.34-.223-1.382-.935-1.254-1.442C5.25 7.597 7 5.968 8 5c.393-.38.214-.6-.25-.25-1.151.869-2.999 2.19-3.61 2.562-.539.328-.82.384-1.156.328a7.66 7.66 0 0 1-1.645-.452c-.627-.26-.597-1.122 0-1.373l8.55-3.6Z",
  fill: "currentColor"
}, null, -1), m6 = [
  f6
];
function p6(t, e) {
  return p(), g("svg", h6, [...m6]);
}
const _6 = I({ name: "icon-FilledTelegramXS", render: p6 }), v6 = {
  component: "",
  width: "12",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g6 = ["clip-path"], $6 = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6 2.1a1.4 1.4 0 0 0-1.308.9h2.616A1.4 1.4 0 0 0 6 2.1ZM6 .9A2.6 2.6 0 0 0 3.448 3H1.733C1.043 3 .6 3.606.6 4.2v6c0 .594.443 1.2 1.133 1.2h8.534c.69 0 1.133-.606 1.133-1.2v-6c0-.594-.443-1.2-1.133-1.2H8.552A2.6 2.6 0 0 0 6 .9Zm4.2 3.3H1.8v6h8.4v-6ZM5.4 5.4a.6.6 0 1 0 0 1.2h1.2a.6.6 0 1 0 0-1.2H5.4Z",
  fill: "currentColor"
}, null, -1), w6 = [
  $6
], y6 = ["id"], M6 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M0 0h12v12H0z"
}, null, -1), C6 = [
  M6
];
function b6(t, e) {
  return p(), g("svg", v6, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...w6], 8, g6),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...C6], 8, y6)
    ])
  ]);
}
const x6 = I({ name: "icon-SuitcaseXS", render: b6, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), S6 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}, I6 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.8 1.8a.6.6 0 0 1 .6-.6h1.2a.6.6 0 0 1 0 1.2H5.4a.6.6 0 0 1-.6-.6ZM5.4 0a1.8 1.8 0 0 0-1.697 1.2H3A1.8 1.8 0 0 0 1.2 3v7.2A1.8 1.8 0 0 0 3 12h6a1.8 1.8 0 0 0 1.8-1.8V3A1.8 1.8 0 0 0 9 1.2h-.702A1.8 1.8 0 0 0 6.6 0H5.4ZM3 2.4h.703A1.8 1.8 0 0 0 5.4 3.6h1.2a1.8 1.8 0 0 0 1.698-1.2H9a.6.6 0 0 1 .6.6v7.2a.6.6 0 0 1-.6.6H3a.6.6 0 0 1-.6-.6V3a.6.6 0 0 1 .6-.6ZM7.65 6.399a.6.6 0 0 0-.897-.798L5.6 6.897 5.25 6.5a.6.6 0 1 0-.897.798l.8.9a.6.6 0 0 0 .897 0l1.6-1.8Z",
  "clip-rule": "evenodd"
}, null, -1), A6 = [
  I6
];
function k6(t, e) {
  return p(), g("svg", S6, [...A6]);
}
const E6 = I({ name: "icon-TaskXS", render: k6 }), P6 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, T6 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M10.4 2H3.2v12h9.6V5.2h-2a.4.4 0 0 1-.4-.4V2Zm-8.8-.806C1.6.755 1.958.4 2.4.4h8.608a.4.4 0 0 1 .312.15l2.992 3.74a.4.4 0 0 1 .088.25v10.254a.8.8 0 0 1-.794.806H2.394a.8.8 0 0 1-.794-.794V1.194ZM7.2 8V6.8c0-.22.18-.4.4-.4h.8c.221 0 .4.18.4.4V8H10c.221 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H8.8v1.2a.4.4 0 0 1-.4.4h-.8a.4.4 0 0 1-.4-.4V9.6H6a.4.4 0 0 1-.4-.4v-.8c0-.22.18-.4.4-.4h1.2Z"
}, null, -1), O6 = [
  T6
];
function L6(t, e) {
  return p(), g("svg", P6, [...O6]);
}
const D6 = I({ name: "icon-AddFileSm", render: L6 }), N6 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, R6 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.604 4.4a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4-2.4a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Zm-3.05 7.08a.8.8 0 0 1-.086 1.127c-2.19 1.877-1.687 3.423-1.393 3.788l.01.001c.022.002.05.004.085.004h5.273a.8.8 0 0 1 0 1.6H3.17c-.282 0-.794-.04-1.19-.433C.807 14 .714 11.318 3.427 8.993a.8.8 0 0 1 1.129.086ZM12.3 10.5h1.4a.7.7 0 1 1 0 1.4h-1.4v1.4a.7.7 0 0 1-1.4 0v-1.4H9.5a.7.7 0 0 1 0-1.4h1.4V9.1a.7.7 0 1 1 1.4 0v1.4Z",
  "clip-rule": "evenodd"
}, null, -1), Z6 = [
  R6
];
function B6(t, e) {
  return p(), g("svg", N6, [...Z6]);
}
const V6 = I({ name: "icon-AddPeopleSm", render: B6 }), F6 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, H6 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m6.325 3.343-4.09 4.091a.8.8 0 0 0 0 1.132l4.09 4.09a.8.8 0 1 0 1.132-1.13L4.73 8.8H13a.8.8 0 0 0 0-1.6H4.73l2.726-2.725a.8.8 0 1 0-1.132-1.132Z",
  "clip-rule": "evenodd"
}, null, -1), U6 = [
  H6
];
function z6(t, e) {
  return p(), g("svg", F6, [...U6]);
}
const W6 = I({ name: "icon-ArrowBackSm", render: z6 }), j6 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, G6 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.156 8 8.73 4.525A.881.881 0 0 0 9 3.893a.88.88 0 0 0-.27-.631A.933.933 0 0 0 8.08 3a.933.933 0 0 0-.65.262l-4.116 4a1.022 1.022 0 0 0 0 1.475l4.117 4.001a.933.933 0 0 0 .65.262.933.933 0 0 0 .65-.262.88.88 0 0 0 .269-.631.88.88 0 0 0-.27-.632L5.157 8Zm4 0 3.575-3.475A.88.88 0 0 0 13 3.893a.88.88 0 0 0-.27-.631.933.933 0 0 0-.65-.262.933.933 0 0 0-.65.262l-4.116 4a1.022 1.022 0 0 0 0 1.475l4.117 4.001a.933.933 0 0 0 .65.262.933.933 0 0 0 .65-.262.88.88 0 0 0 .269-.631.88.88 0 0 0-.27-.632L9.157 8Z",
  "clip-rule": "evenodd"
}, null, -1), Y6 = [
  G6
];
function X6(t, e) {
  return p(), g("svg", j6, [...Y6]);
}
const K6 = I({ name: "icon-ArrowDoubleLeftSm", render: X6 }), q6 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, J6 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.844 8 3.27 4.525A.881.881 0 0 1 3 3.893a.88.88 0 0 1 .27-.631A.933.933 0 0 1 3.92 3c.243 0 .477.094.65.262l4.116 4a1.022 1.022 0 0 1 0 1.475l-4.117 4.001a.933.933 0 0 1-.65.262.933.933 0 0 1-.65-.262.88.88 0 0 1-.269-.631.88.88 0 0 1 .27-.632L6.843 8Zm4 0L7.27 4.525A.881.881 0 0 1 7 3.893a.88.88 0 0 1 .27-.631A.933.933 0 0 1 7.92 3c.243 0 .477.094.65.262l4.116 4a1.022 1.022 0 0 1 0 1.475l-4.117 4.001a.933.933 0 0 1-.65.262.933.933 0 0 1-.65-.262.88.88 0 0 1-.269-.631.88.88 0 0 1 .27-.632L10.843 8Z",
  "clip-rule": "evenodd"
}, null, -1), Q6 = [
  J6
];
function e4(t, e) {
  return p(), g("svg", q6, [...Q6]);
}
const t4 = I({ name: "icon-ArrowDoubleRightSm", render: e4 }), n4 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, o4 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M11.333 6.251 8 9.585 4.666 6.25a.857.857 0 0 0-1.212 1.212l3.839 3.839a1 1 0 0 0 1.414 0l3.838-3.839a.857.857 0 1 0-1.212-1.212Z"
}, null, -1), i4 = [
  o4
];
function r4(t, e) {
  return p(), g("svg", n4, [...i4]);
}
const a4 = I({ name: "icon-ArrowDownSm", render: r4 }), s4 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, l4 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m3.243 9.575 4.091 4.09a.8.8 0 0 0 1.132 0l4.09-4.09a.8.8 0 0 0-1.13-1.132L8.7 11.17V2.9a.8.8 0 0 0-1.6 0v8.269L4.374 8.443a.8.8 0 1 0-1.13 1.132Z",
  "clip-rule": "evenodd"
}, null, -1), d4 = [
  l4
];
function c4(t, e) {
  return p(), g("svg", s4, [...d4]);
}
const u4 = I({ name: "icon-ArrowDown2Sm", render: c4 }), h4 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, f4 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M10.73 4.525 7.157 8l3.575 3.475a.88.88 0 0 1 .269.632.88.88 0 0 1-.27.631.933.933 0 0 1-.65.262.933.933 0 0 1-.65-.262l-4.116-4a1.022 1.022 0 0 1 0-1.475l4.117-4.001A.933.933 0 0 1 10.08 3c.244 0 .477.094.65.262a.88.88 0 0 1 .269.631.88.88 0 0 1-.27.632Z"
}, null, -1), m4 = [
  f4
];
function p4(t, e) {
  return p(), g("svg", h4, [...m4]);
}
const _4 = I({ name: "icon-ArrowLeftSm", render: p4 }), v4 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, g4 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M5.27 4.525 8.843 8 5.27 11.475a.88.88 0 0 0-.269.632.88.88 0 0 0 .27.631.933.933 0 0 0 .65.262.933.933 0 0 0 .65-.262l4.116-4a1.022 1.022 0 0 0 0-1.475L6.569 3.262A.933.933 0 0 0 5.92 3a.933.933 0 0 0-.65.262.88.88 0 0 0-.269.631c0 .237.097.465.27.632Z"
}, null, -1), $4 = [
  g4
];
function w4(t, e) {
  return p(), g("svg", v4, [...$4]);
}
const y4 = I({ name: "icon-ArrowRightSm", render: w4 }), M4 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, C4 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m9.475 3.343 4.09 4.091a.8.8 0 0 1 0 1.132l-4.09 4.09a.8.8 0 1 1-1.132-1.13L11.07 8.8H2.8a.8.8 0 1 1 0-1.6h8.269L8.343 4.475a.8.8 0 1 1 1.132-1.132Z",
  "clip-rule": "evenodd"
}, null, -1), b4 = [
  C4
];
function x4(t, e) {
  return p(), g("svg", M4, [...b4]);
}
const S4 = I({ name: "icon-ArrowToSm", render: x4 }), I4 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, A4 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m3.243 6.425 4.091-4.09a.8.8 0 0 1 1.132 0l4.09 4.09a.8.8 0 0 1-1.13 1.132L8.7 4.83V13.1a.8.8 0 0 1-1.6 0V4.831L4.374 7.557a.8.8 0 0 1-1.13-1.132Z",
  "clip-rule": "evenodd"
}, null, -1), k4 = [
  A4
];
function E4(t, e) {
  return p(), g("svg", I4, [...k4]);
}
const P4 = I({ name: "icon-ArrowUp2Sm", render: E4 }), T4 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, O4 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M11.333 10.344 8 7.01l-3.334 3.334A.857.857 0 0 1 3.454 9.13l3.839-3.838a1 1 0 0 1 1.414 0l3.838 3.838a.857.857 0 1 1-1.212 1.213Z"
}, null, -1), L4 = [
  O4
];
function D4(t, e) {
  return p(), g("svg", T4, [...L4]);
}
const N4 = I({ name: "icon-ArrowUpSm", render: D4 }), R4 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Z4 = ["clip-path"], B4 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M10.032 4.354c.35.324.35.877 0 1.201l-4.17 3.863a.79.79 0 0 0-.19.257.74.74 0 0 0 .18.869.86.86 0 0 0 .28.172.911.911 0 0 0 .658-.005.858.858 0 0 0 .277-.177l4.82-4.463c.479-.444.748-1.046.748-1.674 0-.628-.27-1.23-.749-1.674a2.663 2.663 0 0 0-1.807-.693c-.678 0-1.328.25-1.808.693L3.452 7.187a3.95 3.95 0 0 0-.946 1.28c-.22.481-.336.998-.34 1.52-.003.522.105 1.04.32 1.523.214.483.53.922.928 1.292.399.369.873.661 1.395.86a4.559 4.559 0 0 0 3.285-.02 4.287 4.287 0 0 0 1.382-.876l4.263-3.948a.819.819 0 0 1 1.113 1.201l-4.171 3.863a6.015 6.015 0 0 1-1.935 1.197 6.378 6.378 0 0 1-2.282.421 6.378 6.378 0 0 1-2.283-.42 6.015 6.015 0 0 1-1.934-1.198A5.516 5.516 0 0 1 .954 12.09 5.172 5.172 0 0 1 .5 9.976c0-.725.154-1.443.454-2.114.3-.67.739-1.279 1.293-1.792l4.82-4.463A4.447 4.447 0 0 1 10.063.5a4.435 4.435 0 0 1 2.975 1.156c.79.731 1.238 1.72 1.248 2.755.01 1.034-.42 2.031-1.196 2.775L8.27 11.652c-.237.22-.519.394-.829.513a2.732 2.732 0 0 1-1.956 0 2.578 2.578 0 0 1-.83-.514 2.364 2.364 0 0 1-.554-.768 2.217 2.217 0 0 1 0-1.812c.13-.287.317-.548.555-.768L8.92 4.354a.819.819 0 0 1 1.112 0Z"
}, null, -1), V4 = [
  B4
], F4 = ["id"], H4 = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), U4 = [
  H4
];
function z4(t, e) {
  return p(), g("svg", R4, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...V4], 8, Z4),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...U4], 8, F4)
    ])
  ]);
}
const W4 = I({ name: "icon-AttachmentSm", render: z4, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), j4 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, G4 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M4.49 2.4a.766.766 0 1 1 1.056 1.109l-.753.717h4.154c1.378 0 2.7.521 3.677 1.45a4.849 4.849 0 0 1 1.526 3.512c0 1.318-.55 2.581-1.526 3.511a5.334 5.334 0 0 1-3.677 1.451H4.015a.752.752 0 0 1 0-1.503h4.932c.968 0 1.895-.366 2.577-1.016a3.374 3.374 0 0 0 1.063-2.443c0-.915-.382-1.794-1.063-2.443a3.738 3.738 0 0 0-2.577-1.016H4.793l.753.717a.766.766 0 0 1-1.056 1.11l-2.593-2.47a.15.15 0 0 1 0-.217l2.593-2.47Z"
}, null, -1), Y4 = [
  G4
];
function X4(t, e) {
  return p(), g("svg", j4, [...Y4]);
}
const K4 = I({ name: "icon-BackSm", render: X4 }), q4 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, J4 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.753 5.044a5.174 5.174 0 0 0 7.203 7.203L3.753 5.044Zm1.291-1.291 7.203 7.203a5.174 5.174 0 0 0-7.203-7.203ZM1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Z",
  "clip-rule": "evenodd"
}, null, -1), Q4 = [
  J4
];
function eh(t, e) {
  return p(), g("svg", q4, [...Q4]);
}
const th = I({ name: "icon-BanSm", render: eh }), nh = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, oh = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M9 1.333a.998.998 0 0 1-.333.746v1.254H12a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.333a2 2 0 0 1 2-2h3.333V2.08A1 1 0 1 1 9 1.333ZM4 4.667a.667.667 0 0 0-.667.666V12a.667.667 0 0 0 .667.667h8a.667.667 0 0 0 .667-.667V5.333A.667.667 0 0 0 12 4.667H4ZM1.333 7.333a.667.667 0 1 0-1.333 0V10a.667.667 0 1 0 1.333 0V7.333Zm13.334 0a.667.667 0 1 1 1.333 0V10a.667.667 0 0 1-1.333 0V7.333ZM6 9.667a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
}, null, -1), ih = [
  oh
];
function rh(t, e) {
  return p(), g("svg", nh, [...ih]);
}
const ah = I({ name: "icon-BotSm", render: rh }), sh = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, lh = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.84 1A2.4 2.4 0 0 0 2.78 2.165L1.342 4.564A2.4 2.4 0 0 0 1 5.799V13a2.4 2.4 0 0 0 2.4 2.4H13a2.4 2.4 0 0 0 2.4-2.4V5.799a2.4 2.4 0 0 0-.342-1.235l-1.44-2.399A2.4 2.4 0 0 0 11.562 1H4.839Zm-.687 1.988A.8.8 0 0 1 4.84 2.6H7.4V5H2.946l1.207-2.012ZM9 5h4.454l-1.207-2.012a.8.8 0 0 0-.686-.388H9V5Zm-6.4 8V6.6h11.2V13a.8.8 0 0 1-.8.8H3.4a.8.8 0 0 1-.8-.8ZM5 8.2a.8.8 0 1 0 0 1.6h2a.8.8 0 1 0 0-1.6H5Z",
  "clip-rule": "evenodd"
}, null, -1), dh = [
  lh
];
function ch(t, e) {
  return p(), g("svg", sh, [...dh]);
}
const uh = I({ name: "icon-BoxSm", render: ch }), hh = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, fh = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M.8 2.4a.8.8 0 0 1 .8-.8h12.8a.8.8 0 0 1 0 1.6H1.6a.8.8 0 0 1-.8-.8ZM.8 8a.8.8 0 0 1 .8-.8h12.8a.8.8 0 0 1 0 1.6H1.6A.8.8 0 0 1 .8 8Zm0 5.6a.8.8 0 0 1 .8-.8h12.8a.8.8 0 0 1 0 1.6H1.6a.8.8 0 0 1-.8-.8Z"
}, null, -1), mh = [
  fh
];
function ph(t, e) {
  return p(), g("svg", hh, [...mh]);
}
const _h = I({ name: "icon-BurgerSm", render: ph }), vh = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, gh = ["clip-path"], $h = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.2.8a.8.8 0 0 1 1.6 0v2.4h6.4V.8a.8.8 0 0 1 1.6 0v2.4h.8a1.6 1.6 0 0 1 1.6 1.6v8.8a1.6 1.6 0 0 1-1.6 1.6H2.4a1.6 1.6 0 0 1-1.6-1.6V4.8a1.6 1.6 0 0 1 1.6-1.6h.8V.8Zm8.8 4H2.4v8.8h11.2V4.8H12ZM5.2 6.4a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Z",
  "clip-rule": "evenodd"
}, null, -1), wh = [
  $h
], yh = ["id"], Mh = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Ch = [
  Mh
];
function bh(t, e) {
  return p(), g("svg", vh, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...wh], 8, gh),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Ch], 8, yh)
    ])
  ]);
}
const xh = I({ name: "icon-CalendarEventSm", render: bh, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Sh = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Ih = ["clip-path"], Ah = /* @__PURE__ */ h("path", { d: "M5.173 10.287v.023h2.274v1.023H3.759v-.96l1.606-1.536c.323-.31.55-.569.68-.777.132-.211.199-.432.199-.664 0-.516-.278-.774-.832-.774-.482 0-.943.192-1.383.575V6.11a2.968 2.968 0 0 1 1.648-.473c.573 0 1.02.145 1.34.434.323.286.485.674.485 1.164 0 .653-.392 1.33-1.176 2.027l-1.152 1.024ZM8.56 11.212v-1.015c.294.192.649.289 1.063.289.432 0 .765-.146 1-.438.237-.294.357-.71.36-1.25l-.024-.008c-.248.368-.624.551-1.13.551-.458 0-.838-.16-1.14-.48-.3-.32-.45-.736-.45-1.246 0-.597.184-1.075.552-1.434.367-.362.842-.543 1.425-.543.6 0 1.076.227 1.43.68.357.453.535 1.101.535 1.945 0 1-.214 1.779-.644 2.336-.427.555-1.025.832-1.793.832-.456 0-.85-.073-1.184-.219Zm1.621-4.633a.644.644 0 0 0-.527.262c-.138.172-.207.395-.207.668 0 .284.068.508.203.672a.697.697 0 0 0 .559.242.666.666 0 0 0 .523-.23.863.863 0 0 0 .203-.586c0-.295-.071-.54-.215-.735-.14-.195-.32-.293-.539-.293Z" }, null, -1), kh = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  d: "M14 3.333H2V14h12V3.333ZM2 2C1.264 2 .667 2.597.667 3.333V14c0 .736.597 1.333 1.333 1.333h12c.737 0 1.334-.597 1.334-1.333V3.333C15.334 2.597 14.737 2 14 2H2Z",
  "clip-rule": "evenodd"
}, null, -1), Eh = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  d: "M5.134 0c.368 0 .666.298.666.667v1.481a.667.667 0 0 1-1.333 0V.667c0-.369.299-.667.667-.667ZM11.356 0c.368 0 .667.298.667.667v1.481a.667.667 0 0 1-1.333 0V.667c0-.369.298-.667.666-.667Z",
  "clip-rule": "evenodd"
}, null, -1), Ph = [
  Ah,
  kh,
  Eh
], Th = ["id"], Oh = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Lh = [
  Oh
];
function Dh(t, e) {
  return p(), g("svg", Sh, [
    h("g", {
      fill: "currentColor",
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...Ph], 8, Ih),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Lh], 8, Th)
    ])
  ]);
}
const Nh = I({ name: "icon-CalendarNumberSm", render: Dh, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Rh = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Zh = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.22 11a2.78 2.78 0 0 1 5.56 0 2.78 2.78 0 0 1-5.56 0ZM11 7a4.001 4.001 0 0 0 0 8 4.001 4.001 0 0 0 0-8Zm.383 2.478a.508.508 0 1 0-1.017 0v1.39c0 .216.072.421.164.583a1.2 1.2 0 0 0 .417.437l1.05.627a.508.508 0 1 0 .521-.874l-1.05-.627L11.45 11a.286.286 0 0 1-.063-.111l-.005-.021V9.478Z",
  "clip-rule": "evenodd"
}, null, -1), Bh = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 .8a.8.8 0 1 1 1.6 0V3h6.798V.8a.8.8 0 0 1 1.6 0V3H13a2 2 0 0 1 2 2v1.2a.8.8 0 0 1-1.6 0V5a.4.4 0 0 0-.4-.4H3a.4.4 0 0 0-.4.4v8c0 .22.18.4.4.4h3.2a.8.8 0 0 1 0 1.6H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2V.8Z",
  "clip-rule": "evenodd"
}, null, -1), Vh = [
  Zh,
  Bh
];
function Fh(t, e) {
  return p(), g("svg", Rh, [...Vh]);
}
const Hh = I({ name: "icon-CalendarPostponedSm", render: Fh }), Uh = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, zh = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M5 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
}, null, -1), Wh = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.8 0a.8.8 0 0 0-.8.8V3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-.002V.8a.8.8 0 1 0-1.6 0V3H4.6V.8a.8.8 0 0 0-.8-.8ZM3 4.6h10c.22 0 .4.18.4.4v8a.4.4 0 0 1-.4.4H3a.4.4 0 0 1-.4-.4V5c0-.22.18-.4.4-.4Z",
  "clip-rule": "evenodd"
}, null, -1), jh = [
  zh,
  Wh
];
function Gh(t, e) {
  return p(), g("svg", Uh, [...jh]);
}
const Yh = I({ name: "icon-CalendarSm", render: Gh }), Xh = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Kh = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 .8a.8.8 0 1 1 1.6 0V3h6.798V.8a.8.8 0 0 1 1.6 0V3H13a2 2 0 0 1 2 2v1.2a.8.8 0 0 1-1.6 0V5a.4.4 0 0 0-.4-.4H3a.4.4 0 0 0-.4.4v8c0 .22.18.4.4.4h3.2a.8.8 0 0 1 0 1.6H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2V.8Z",
  "clip-rule": "evenodd"
}, null, -1), qh = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.773 8.326 8.796 9.468a.458.458 0 0 0-.226.392v2.28a.45.45 0 0 0 .223.39l1.978 1.142h.001c.143.082.315.08.451.002l1.978-1.142a.458.458 0 0 0 .226-.392V9.86a.454.454 0 0 0-.226-.392l-1.975-1.14h-.001a.454.454 0 0 0-.452-.002Zm-.6-1.039a1.654 1.654 0 0 1 1.648-.001l.002.001 1.984 1.146c.504.296.82.834.82 1.427v2.28c0 .588-.315 1.13-.82 1.427l-.004.003-1.98 1.143a1.654 1.654 0 0 1-1.647.001l-.003-.001-1.98-1.143a1.65 1.65 0 0 1-.823-1.43V9.86c0-.588.315-1.13.82-1.427l.003-.003 1.98-1.143ZM11 9.4a.6.6 0 0 1 .6.6v1a.6.6 0 1 1-1.2 0v-1a.6.6 0 0 1 .6-.6Zm.6 3a.6.6 0 1 0-1.2 0v.033a.6.6 0 0 0 1.2 0V12.4Z",
  "clip-rule": "evenodd"
}, null, -1), Jh = [
  Kh,
  qh
];
function Qh(t, e) {
  return p(), g("svg", Xh, [...Jh]);
}
const e5 = I({ name: "icon-CalendarWarningSm", render: Qh }), t5 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, n5 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M10.427 3.2c0-.442.356-.8.795-.8h3.182c.44 0 .796.358.796.8 0 .442-.356.8-.796.8h-3.182a.798.798 0 0 1-.795-.8ZM10.427 8c0-.442.356-.8.795-.8h3.182c.44 0 .796.358.796.8 0 .442-.356.8-.796.8h-3.182a.798.798 0 0 1-.795-.8ZM.88 12.8c0-.442.357-.8.796-.8h12.728c.44 0 .796.358.796.8 0 .442-.356.8-.796.8H1.676a.798.798 0 0 1-.795-.8Z"
}, null, -1), o5 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.8 4c0-1.325 1.068-2.4 2.386-2.4h3.262A2.393 2.393 0 0 1 8.834 4v3.28c0 1.325-1.068 2.4-2.386 2.4H3.186A2.393 2.393 0 0 1 .8 7.28V4Zm2.386-.8a.798.798 0 0 0-.795.8v3.28c0 .442.356.8.795.8h3.262c.44 0 .795-.358.795-.8V4c0-.442-.356-.8-.795-.8H3.186Z",
  "clip-rule": "evenodd"
}, null, -1), i5 = [
  n5,
  o5
];
function r5(t, e) {
  return p(), g("svg", t5, [...i5]);
}
const a5 = I({ name: "icon-CardSm", render: r5 }), s5 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, l5 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.526 2.4H10.475c.43 0 .841-.001 1.209.135.32.12.604.313.825.564.253.286.382.655.518 1.043l.031.09.536 1.52.49-.231c.38-.18.844-.034 1.035.326.19.361.036.8-.345.98l-.231.11c.141.155.263.326.363.511.17.316.235.648.265.998.03.334.03.743.03 1.23V11.402c0 .227 0 .438-.04.63-.163.772-.8 1.376-1.617 1.53-.201.037-.425.037-.665.037H12.5c-.981 0-1.802-.651-2.008-1.522H5.508C5.303 12.95 4.482 13.6 3.5 13.6h-.379c-.24 0-.463 0-.665-.037-.816-.154-1.454-.758-1.616-1.53-.04-.191-.04-.403-.04-.63V9.675c0-.486 0-.895.03-1.23.03-.35.095-.681.265-.997.1-.185.221-.356.363-.511l-.231-.11c-.381-.18-.536-.619-.345-.98.19-.36.654-.507 1.035-.326l.49.232.536-1.521.031-.09c.136-.388.265-.757.518-1.043.22-.25.505-.444.825-.564.368-.136.778-.136 1.209-.135Zm-1.6 3.656a47.2 47.2 0 0 1 .7-.004h6.748c.253 0 .486 0 .7.004l-.48-1.363c-.189-.538-.229-.612-.269-.657a.514.514 0 0 0-.206-.141c-.058-.022-.145-.034-.744-.034h-4.75c-.598 0-.686.012-.743.034a.514.514 0 0 0-.207.14c-.04.046-.08.12-.269.658l-.48 1.363Zm-.472 1.48c-.274.02-.4.058-.479.097a1.128 1.128 0 0 0-.506.478c-.04.076-.08.194-.102.454-.023.267-.024.616-.024 1.14v1.643c0 .318.004.37.01.4.04.192.2.343.404.382.031.006.086.01.422.01H3.5a.501.501 0 0 0 .515-.488c0-.571.489-1.035 1.093-1.035h5.785c.604 0 1.093.464 1.093 1.035 0 .27.23.487.514.487h.322c.335 0 .39-.003.421-.01a.501.501 0 0 0 .404-.382c.007-.03.01-.081.01-.4V9.705c0-.523 0-.872-.023-1.14-.023-.259-.062-.377-.103-.453a1.129 1.129 0 0 0-.506-.478c-.079-.039-.204-.076-.478-.097a17.452 17.452 0 0 0-1.204-.023H4.658c-.553 0-.921 0-1.204.023Zm-.725 1.073c0-.404.345-.73.771-.73H5.43c.426 0 .771.326.771.73 0 .403-.345.73-.771.73H3.5c-.426 0-.771-.327-.771-.73Zm7.071 0c0-.404.346-.73.772-.73H12.5c.426 0 .772.326.772.73 0 .403-.346.73-.772.73h-1.928c-.426 0-.772-.327-.772-.73Z",
  "clip-rule": "evenodd"
}, null, -1), d5 = [
  l5
];
function c5(t, e) {
  return p(), g("svg", s5, [...d5]);
}
const u5 = I({ name: "icon-CarSm", render: c5 }), h5 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, f5 = ["clip-path"], m5 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.488.8a6.1 6.1 0 0 0-4.305 1.776A6.05 6.05 0 0 0 .4 6.863c0 2.245 1.107 3.939 2.668 5.258 1.56 1.318 3.574 2.264 5.395 3.018a.788.788 0 0 0 1.089-.73v-1.483a6.1 6.1 0 0 0 4.265-1.776A6.05 6.05 0 0 0 15.6 6.863a6.05 6.05 0 0 0-1.783-4.287A6.1 6.1 0 0 0 9.512.8H6.488Zm-3.18 2.897a4.506 4.506 0 0 1 3.18-1.312h3.024a4.513 4.513 0 0 1 3.18 1.312 4.476 4.476 0 0 1 1.316 3.166 4.46 4.46 0 0 1-1.317 3.166 4.497 4.497 0 0 1-3.179 1.312h-.756a.794.794 0 0 0-.796.792v1.053c-2.063-.937-3.551-1.844-4.526-2.85-.982-1.012-1.442-2.125-1.442-3.473 0-1.188.473-2.326 1.316-3.166Z",
  "clip-rule": "evenodd"
}, null, -1), p5 = [
  m5
], _5 = ["id"], v5 = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), g5 = [
  v5
];
function $5(t, e) {
  return p(), g("svg", h5, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...p5], 8, f5),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...g5], 8, _5)
    ])
  ]);
}
const w5 = I({ name: "icon-ChatSm", render: $5, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), y5 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, M5 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M12.251 4.251 7.108 9.836 3.963 6.75a.857.857 0 1 0-1.212 1.212l3.65 3.59a1 1 0 0 0 1.414 0l5.648-6.09a.857.857 0 1 0-1.212-1.212Z"
}, null, -1), C5 = [
  M5
];
function b5(t, e) {
  return p(), g("svg", y5, [...C5]);
}
const x5 = I({ name: "icon-CheckSm", render: b5 }), S5 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, I5 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15.303 4.031a.9.9 0 0 1 0 1.273l-6.666 6.667a.9.9 0 0 1-1.273 0L4.03 8.637a.9.9 0 0 1 1.272-1.272L8 10.062l6.03-6.03a.9.9 0 0 1 1.273 0Z",
  "clip-rule": "evenodd"
}, null, -1), A5 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.97 4.031a.9.9 0 0 1 0 1.273L8.637 8.637a.9.9 0 0 1-1.273-1.272l3.333-3.334a.9.9 0 0 1 1.273 0ZM.697 7.365a.9.9 0 0 1 1.273 0l3.333 3.333a.9.9 0 1 1-1.272 1.273L.697 8.637a.9.9 0 0 1 0-1.272Z",
  "clip-rule": "evenodd"
}, null, -1), k5 = [
  I5,
  A5
];
function E5(t, e) {
  return p(), g("svg", S5, [...k5]);
}
const P5 = I({ name: "icon-ChecksSm", render: E5 }), T5 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, O5 = ["clip-path"], L5 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.216 8a5.784 5.784 0 1 1 11.567 0A5.784 5.784 0 0 1 2.216 8ZM8 .8a7.2 7.2 0 1 0 0 14.4A7.2 7.2 0 0 0 8 .8Zm2.966 6.166a.8.8 0 0 0-1.132-1.132L7.2 8.47 6.165 7.434a.8.8 0 1 0-1.13 1.132l1.6 1.6a.8.8 0 0 0 1.13 0l3.2-3.2Z",
  "clip-rule": "evenodd"
}, null, -1), D5 = [
  L5
], N5 = ["id"], R5 = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Z5 = [
  R5
];
function B5(t, e) {
  return p(), g("svg", T5, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...D5], 8, O5),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Z5], 8, N5)
    ])
  ]);
}
const V5 = I({ name: "icon-CircleCheckSm", render: B5, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), F5 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, H5 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.11 2.86a.8.8 0 0 0-1.552-.387L5.89 13.139a.8.8 0 0 0 1.552.388L10.11 2.861ZM5.233 4.769a.8.8 0 0 1 0 1.131L3.132 8l2.1 2.101a.8.8 0 0 1-1.13 1.131L1.434 8.566a.8.8 0 0 1 0-1.132L4.1 4.768a.8.8 0 0 1 1.132 0Zm5.535 0a.8.8 0 0 1 1.131 0l2.667 2.666a.8.8 0 0 1 0 1.132l-2.667 2.666a.8.8 0 0 1-1.131-1.131L12.868 8l-2.1-2.101a.8.8 0 0 1 0-1.131Z",
  "clip-rule": "evenodd"
}, null, -1), U5 = [
  H5
];
function z5(t, e) {
  return p(), g("svg", F5, [...U5]);
}
const W5 = I({ name: "icon-CodeSm", render: z5 }), j5 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, G5 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.8 4.8a.8.8 0 0 1 .8-.8h9.6a.8.8 0 0 1 .8.8v.003c.195-.008.39 0 .584.026.48.064.941.232 1.343.496s.734.618.96 1.038c.226.421.334.892.31 1.369-.024.476-.18.933-.446 1.33-.265.398-.63.72-1.053.95a3.27 3.27 0 0 1-1.382.383c-.224.012-.45.001-.67-.032a5.189 5.189 0 0 1-1.069 1.708A4.798 4.798 0 0 1 7.086 13.6H5.715a4.799 4.799 0 0 1-3.492-1.53A5.301 5.301 0 0 1 .8 8.437V4.8Zm1.723 4.597a3.63 3.63 0 0 0 .864 1.576A3.199 3.199 0 0 0 5.715 12h1.371c.863 0 1.702-.363 2.327-1.027a3.701 3.701 0 0 0 .987-2.537v-.04c-.392-.245-.936-.405-1.589-.396H8.79c-.815-.011-1.461.241-1.853.594C6.192 9.265 5.133 9.613 4 9.6a4.91 4.91 0 0 1-1.477-.203ZM12 8.004V6.406c.124-.01.249-.007.373.01.25.033.482.12.675.246.193.127.337.286.429.458.091.17.131.352.122.53-.01.178-.068.358-.179.524a1.344 1.344 0 0 1-.482.43 1.67 1.67 0 0 1-.95.19c.008-.12.012-.238.012-.358v-.432ZM10.4 5.6v1.042A4.865 4.865 0 0 0 8.8 6.4c-1.132-.013-2.191.335-2.936 1.006-.39.353-1.038.605-1.853.594H3.99c-.652.009-1.197-.15-1.589-.396V5.6h8Z",
  "clip-rule": "evenodd"
}, null, -1), Y5 = [
  G5
];
function X5(t, e) {
  return p(), g("svg", j5, [...Y5]);
}
const K5 = I({ name: "icon-CoffeeSm", render: X5 }), q5 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, J5 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M2.4 12.8a.8.8 0 0 0 .8-.8V4a.8.8 0 1 0-1.6 0v8a.8.8 0 0 0 .8.8ZM7.348 8.8l2.037 1.98a.705.705 0 0 1 .215.505c0 .19-.078.372-.215.506a.746.746 0 0 1-1.04 0L5.05 8.59a.817.817 0 0 1 0-1.18l3.294-3.2a.746.746 0 0 1 1.04 0 .705.705 0 0 1 0 1.01L7.348 7.2H13.6a.8.8 0 0 1 0 1.6H7.348Z"
}, null, -1), Q5 = [
  J5
];
function e8(t, e) {
  return p(), g("svg", q5, [...Q5]);
}
const t8 = I({ name: "icon-CollapseLeftSm", render: e8 }), n8 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, o8 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M13.6 3.2a.8.8 0 0 0-.8.8v8a.8.8 0 0 0 1.6 0V4a.8.8 0 0 0-.8-.8ZM8.652 7.2 6.615 5.22a.705.705 0 0 1 0-1.01.746.746 0 0 1 1.04 0l3.294 3.2a.817.817 0 0 1 0 1.18l-3.294 3.2a.746.746 0 0 1-1.04 0 .705.705 0 0 1 0-1.01L8.652 8.8H2.4a.8.8 0 1 1 0-1.6h6.252Z"
}, null, -1), i8 = [
  o8
];
function r8(t, e) {
  return p(), g("svg", n8, [...i8]);
}
const a8 = I({ name: "icon-CollapseRightSm", render: r8 }), s8 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, l8 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.867 1.2A2.267 2.267 0 0 0 1.6 3.467v5.866A2.267 2.267 0 0 0 3.867 11.6H4v.933A2.267 2.267 0 0 0 6.267 14.8h5.866a2.267 2.267 0 0 0 2.267-2.267V6.667A2.267 2.267 0 0 0 12.133 4.4H12v-.933A2.267 2.267 0 0 0 9.733 1.2H3.867ZM10.4 4.4v-.933a.666.666 0 0 0-.667-.667H3.867a.667.667 0 0 0-.667.667v5.866a.667.667 0 0 0 .667.667H4V6.667A2.267 2.267 0 0 1 6.267 4.4H10.4Zm-4.8 6.4v1.733c0 .369.299.667.667.667h5.866a.667.667 0 0 0 .667-.667V6.667A.667.667 0 0 0 12.133 6H6.267a.667.667 0 0 0-.667.667V10.8Z",
  "clip-rule": "evenodd"
}, null, -1), d8 = [
  l8
];
function c8(t, e) {
  return p(), g("svg", s8, [...d8]);
}
const u8 = I({ name: "icon-CopySm", render: c8 }), h8 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, f8 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M12.546 11.334 9.212 8l3.334-3.334a.857.857 0 1 0-1.213-1.212L8 6.788 4.666 3.454a.857.857 0 1 0-1.212 1.212L6.788 8l-3.334 3.334a.857.857 0 1 0 1.212 1.212L8 9.212l3.333 3.334a.857.857 0 0 0 1.213-1.212Z"
}, null, -1), m8 = [
  f8
];
function p8(t, e) {
  return p(), g("svg", h8, [...m8]);
}
const _8 = I({ name: "icon-CrossSm", render: p8 }), v8 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, g8 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.259.721a1.4 1.4 0 0 0-1.872.335l-3.585 4.74H2.2a1.4 1.4 0 0 0-1.4 1.4v6a1.4 1.4 0 0 0 1.4 1.4h9.936a1.4 1.4 0 0 0 1.271-.813L15.1 9.095c.085-.184.17-.473.17-.676V6.651c0-.773-.897-1.356-1.67-1.356H9.53l.957-2.451a1.4 1.4 0 0 0-.55-1.687L9.26.72ZM5.018 6.84 8.55 2.168l.385.247-1.002 2.572a1.4 1.4 0 0 0 1.304 1.908H13.6V8.42l-1.592 4.576H4.9V6.977a1.4 1.4 0 0 0 .118-.137ZM3.3 7.395h-.9v5.6h.9v-5.6Z",
  "clip-rule": "evenodd"
}, null, -1), $8 = [
  g8
];
function w8(t, e) {
  return p(), g("svg", v8, [...$8]);
}
const y8 = I({ name: "icon-CudosSm", render: w8 }), M8 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, C8 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.26 15.374a1.4 1.4 0 0 1-1.873-.334L3.802 10.3H2.2A1.4 1.4 0 0 1 .8 8.9v-6a1.4 1.4 0 0 1 1.4-1.4h9.937a1.4 1.4 0 0 1 1.27.813L15.1 7c.085.184.171.473.171.676v1.768c0 .773-.898 1.356-1.67 1.356H9.53l.956 2.451a1.4 1.4 0 0 1-.549 1.688l-.679.435ZM5.017 9.255l3.534 4.672.385-.247-1.003-2.571A1.4 1.4 0 0 1 9.238 9.2H13.6V7.676L12.01 3.1H4.9v6.019c.042.042.082.088.118.136ZM3.3 8.7h-.9V3.1h.9v5.6Z",
  "clip-rule": "evenodd"
}, null, -1), b8 = [
  C8
];
function x8(t, e) {
  return p(), g("svg", M8, [...b8]);
}
const S8 = I({ name: "icon-DislikeSm", render: x8 }), I8 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, A8 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.25 1.388a.8.8 0 0 1 .906-.577l4.267.728a.804.804 0 0 1 .054.011h1.046a.803.803 0 0 1 .054-.011L12.843.81a.8.8 0 0 1 .906.577l1.405 5.111a1.552 1.552 0 0 1-.03.852A1.516 1.516 0 0 1 13.678 8.4c-.253 1.713-.66 3.1-1.256 4.108-.699 1.179-1.702 1.892-3 1.892H6.578c-1.298 0-2.301-.713-3-1.892C2.982 11.5 2.575 10.114 2.321 8.4a1.503 1.503 0 0 1-.993-.367l-.001-.001.523-.605-.521.607-.001-.001a1.516 1.516 0 0 1-.452-.682 1.552 1.552 0 0 1-.03-.852L2.25 1.388Zm1.561 6.08L7.629 3.15h.742l3.818 4.318a.794.794 0 0 0-.005.038c-.233 1.958-.63 3.328-1.139 4.186-.486.821-1.024 1.108-1.623 1.108H8.8v-.7a.805.805 0 0 0-.012-.136c.116-.063.226-.146.326-.251.312-.33.397-.75.397-1.113a.8.8 0 0 0-.8-.8H7.29a.8.8 0 0 0-.8.8c0 .363.085.784.397 1.113.1.106.21.188.325.25a.805.805 0 0 0-.011.137v.7h-.622c-.599 0-1.137-.287-1.623-1.108-.509-.858-.906-2.228-1.139-4.186a.82.82 0 0 0-.005-.039ZM8.035 10.6A.27.27 0 0 0 8 10.572a.27.27 0 0 0-.035.028h.07Zm2.228-7.726 3.243 3.668-1.108-4.032-2.135.364Zm-4.526 0L3.6 2.51 2.493 6.542l3.244-3.668Zm.84 3.176a.8.8 0 0 1 .8.8v.008a.8.8 0 1 1-1.6 0V6.85a.8.8 0 0 1 .8-.8Zm2.845 0a.8.8 0 0 1 .8.8v.008a.8.8 0 1 1-1.6 0V6.85a.8.8 0 0 1 .8-.8Z",
  "clip-rule": "evenodd"
}, null, -1), k8 = [
  A8
];
function E8(t, e) {
  return p(), g("svg", I8, [...k8]);
}
const P8 = I({ name: "icon-DogSm", render: E8 }), T8 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, O8 = ["clip-path"], L8 = /* @__PURE__ */ h("path", { d: "M1.6 10.4a.8.8 0 0 1 .8.8v1.6a.8.8 0 0 0 .8.8h9.6a.8.8 0 0 0 .8-.8v-1.6a.8.8 0 0 1 1.6 0v1.6a2.4 2.4 0 0 1-2.4 2.4H3.2a2.4 2.4 0 0 1-2.4-2.4v-1.6a.8.8 0 0 1 .8-.8Z" }, null, -1), D8 = /* @__PURE__ */ h("path", { d: "M8 .8a.8.8 0 0 1 .8.8v7.669l2.634-2.635a.8.8 0 0 1 1.132 1.132l-4 4a.8.8 0 0 1-1.132 0l-4-4a.8.8 0 1 1 1.131-1.132L7.2 9.27V1.6A.8.8 0 0 1 8 .8Z" }, null, -1), N8 = [
  L8,
  D8
], R8 = ["id"], Z8 = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), B8 = [
  Z8
];
function V8(t, e) {
  return p(), g("svg", T8, [
    h("g", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-path": "url(#" + t.idMap.a + ")",
      "clip-rule": "evenodd"
    }, [...N8], 8, O8),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...B8], 8, R8)
    ])
  ]);
}
const F8 = I({ name: "icon-DownloadSm", render: V8, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), H8 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, U8 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M7.009 11.325a.777.777 0 1 1-1.1-1.099l1.45-1.448H1.777a.778.778 0 1 1 0-1.556h5.58L5.91 5.774a.777.777 0 1 1 1.099-1.099l2.617 2.618a1 1 0 0 1 0 1.414L7.01 11.325Z"
}, null, -1), z8 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M12.444 15a1.5 1.5 0 0 0 1.1-.457A1.5 1.5 0 0 0 14 13.444V2.556a1.5 1.5 0 0 0-.457-1.1A1.5 1.5 0 0 0 12.444 1H7.778a.778.778 0 1 0 0 1.556h3.666a1 1 0 0 1 1 1v8.888a1 1 0 0 1-1 1H7.778a.778.778 0 0 0 0 1.556h4.666Z"
}, null, -1), W8 = [
  U8,
  z8
];
function j8(t, e) {
  return p(), g("svg", H8, [...W8]);
}
const G8 = I({ name: "icon-EnterSm", render: j8 }), Y8 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, X8 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 2.6a5.4 5.4 0 1 0 0 10.8A5.4 5.4 0 0 0 8 2.6ZM8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Z",
  "clip-rule": "evenodd"
}, null, -1), K8 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M9 8a1 1 0 1 1-2 0V5a1 1 0 0 1 2 0v3ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
}, null, -1), q8 = [
  X8,
  K8
];
function J8(t, e) {
  return p(), g("svg", Y8, [...q8]);
}
const Q8 = I({ name: "icon-ErrorSm", render: J8 }), e7 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, t7 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M13.2 3.2a.8.8 0 0 0-.8.8v8a.8.8 0 0 0 1.6 0V4a.8.8 0 0 0-.8-.8ZM4.548 7.2l2.037-1.98a.705.705 0 0 0 .215-.505.705.705 0 0 0-.215-.506.746.746 0 0 0-1.04 0L2.25 7.41a.817.817 0 0 0 0 1.18l3.294 3.2a.746.746 0 0 0 1.04 0 .705.705 0 0 0 0-1.01L4.548 8.8H10.8a.8.8 0 0 0 0-1.6H4.548Z"
}, null, -1), n7 = [
  t7
];
function o7(t, e) {
  return p(), g("svg", e7, [...n7]);
}
const i7 = I({ name: "icon-ExtendLeftSm", render: o7 }), r7 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, a7 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M2.8 12.8a.8.8 0 0 0 .8-.8V4A.8.8 0 1 0 2 4v8a.8.8 0 0 0 .8.8ZM11.452 8.8l-2.037 1.98a.705.705 0 0 0-.215.505c0 .19.077.372.215.506a.746.746 0 0 0 1.04 0L13.75 8.59a.817.817 0 0 0 0-1.18l-3.294-3.2a.746.746 0 0 0-1.04 0 .705.705 0 0 0-.215.505c0 .19.077.371.215.505l2.037 1.98H5.2a.8.8 0 0 0 0 1.6h6.252Z"
}, null, -1), s7 = [
  a7
];
function l7(t, e) {
  return p(), g("svg", r7, [...s7]);
}
const d7 = I({ name: "icon-ExtendRightSm", render: l7 }), c7 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, u7 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M9.6 2H3.2v12h9.6V5.2H10a.4.4 0 0 1-.4-.4V2Zm-8-.806C1.6.755 1.958.4 2.4.4h7.834a.4.4 0 0 1 .283.117l3.766 3.766a.4.4 0 0 1 .117.283v10.228a.8.8 0 0 1-.794.806H2.394a.8.8 0 0 1-.794-.794V1.194Z"
}, null, -1), h7 = [
  u7
];
function f7(t, e) {
  return p(), g("svg", c7, [...h7]);
}
const m7 = I({ name: "icon-FileSm", render: f7 }), p7 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, _7 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.6 4c0-.442.374-.8.835-.8h11.13c.461 0 .835.358.835.8 0 .442-.374.8-.835.8H2.435c-.461 0-.835-.358-.835-.8Zm2.226 4c0-.442.374-.8.835-.8h6.678c.461 0 .835.358.835.8 0 .442-.373.8-.835.8H4.661c-.46 0-.835-.358-.835-.8Zm2.505 3.2c-.461 0-.835.358-.835.8 0 .442.374.8.835.8H9.67c.461 0 .835-.358.835-.8 0-.442-.374-.8-.835-.8H6.33Z",
  "clip-rule": "evenodd"
}, null, -1), v7 = [
  _7
];
function g7(t, e) {
  return p(), g("svg", p7, [...v7]);
}
const $7 = I({ name: "icon-FilterSortOffSm", render: g7 }), w7 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, y7 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.333 3.2H2.435c-.461 0-.835.358-.835.8 0 .442.374.8.835.8H8c0-.569.119-1.11.333-1.6Zm6.012 1.086a.835.835 0 0 1-.78.514H9.6c0-.615.231-1.175.611-1.6h3.354c.09 0 .177.014.258.039.253.295.436.653.522 1.047ZM8.8 7.2H4.66c-.46 0-.835.358-.835.8 0 .442.374.8.835.8h6.678a.87.87 0 0 0 .21-.025A3.996 3.996 0 0 1 8.798 7.2ZM5.496 12c0-.442.374-.8.835-.8H9.67c.461 0 .835.358.835.8 0 .442-.374.8-.835.8H6.33c-.46 0-.834-.358-.834-.8Z",
  "clip-rule": "evenodd"
}, null, -1), M7 = /* @__PURE__ */ h("circle", {
  cx: "12",
  cy: "4.8",
  r: "2.4",
  fill: "currentColor"
}, null, -1), C7 = [
  y7,
  M7
];
function b7(t, e) {
  return p(), g("svg", w7, [...C7]);
}
const x7 = I({ name: "icon-FilterSortOnSm", render: b7 }), S7 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, I7 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.039 3.778v4.298a4.217 4.217 0 0 1 4.535.912 2.59 2.59 0 0 0 3.387.214V4.903a4.218 4.218 0 0 1-4.535-.912 2.59 2.59 0 0 0-3.387-.213Zm0 6.172a2.588 2.588 0 0 1 3.387.214 4.225 4.225 0 0 0 5.928 0 .825.825 0 0 0 .246-.588V3.403a.823.823 0 0 0-.502-.758.817.817 0 0 0-.891.17 2.59 2.59 0 0 1-3.633 0 4.225 4.225 0 0 0-5.928 0 .825.825 0 0 0-.246.588v10.974c0 .454.367.823.82.823.452 0 .819-.368.819-.823V9.95Z",
  "clip-rule": "evenodd"
}, null, -1), A7 = [
  I7
];
function k7(t, e) {
  return p(), g("svg", S7, [...A7]);
}
const E7 = I({ name: "icon-FlagSm", render: k7 }), P7 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, T7 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.8 3.2H3.2v9.6h9.6V3.2ZM3.2 1.6a1.6 1.6 0 0 0-1.6 1.6v9.6a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6V3.2a1.6 1.6 0 0 0-1.6-1.6H3.2Z",
  "clip-rule": "evenodd"
}, null, -1), O7 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.667 4.2a.8.8 0 0 1 .8.8v.867h1.066V5a.8.8 0 1 1 1.6 0v.867h.534a.8.8 0 1 1 0 1.6h-.534v1.066h.534a.8.8 0 1 1 0 1.6h-.534V11a.8.8 0 0 1-1.6 0v-.867H7.467V11a.8.8 0 0 1-1.6 0v-.867h-.534a.8.8 0 1 1 0-1.6h.534V7.467h-.534a.8.8 0 1 1 0-1.6h.534V5a.8.8 0 0 1 .8-.8Zm.8 3.267v1.066h1.066V7.467H7.467Z",
  "clip-rule": "evenodd"
}, null, -1), L7 = [
  T7,
  O7
];
function D7(t, e) {
  return p(), g("svg", P7, [...L7]);
}
const N7 = I({ name: "icon-HashSm", render: D7 }), R7 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Z7 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.333 4.667c0-.737.597-1.334 1.334-1.334h6.666c.737 0 1.334.597 1.334 1.334V8.39l-.196-.195-.009-.009c-.401-.386-.905-.633-1.462-.633-.557 0-1.06.247-1.462.633l-.01.01-.195.194-1.528-1.528-.01-.01c-.401-.386-.904-.632-1.462-.632-.557 0-1.06.246-1.462.633l-.01.009L3.334 8.39V4.667Zm6.943 4.666.19-.19c.205-.196.39-.256.534-.256.144 0 .329.06.534.256l1.133 1.133v1.057c0 .737-.597 1.334-1.334 1.334H4.667a1.333 1.333 0 0 1-1.334-1.334v-1.057L5.8 7.81c.205-.196.39-.257.533-.257.144 0 .33.061.534.257l1.995 1.995 1.333 1.333a.667.667 0 1 0 .943-.943l-.862-.862Zm3.724.668v1.332A2.667 2.667 0 0 1 11.333 14H4.667A2.667 2.667 0 0 1 2 11.333V4.667A2.667 2.667 0 0 1 4.667 2h6.666A2.667 2.667 0 0 1 14 4.667V10Zm-4-5.334A.667.667 0 1 0 10 6h.007a.667.667 0 0 0 0-1.333H10Z",
  "clip-rule": "evenodd"
}, null, -1), B7 = [
  Z7
];
function V7(t, e) {
  return p(), g("svg", R7, [...B7]);
}
const F7 = I({ name: "icon-ImageSm", render: V7 }), H7 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, U7 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 13.4A5.4 5.4 0 1 0 8 2.6a5.4 5.4 0 0 0 0 10.8ZM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z",
  "clip-rule": "evenodd"
}, null, -1), z7 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M7 8a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V8ZM7 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
}, null, -1), W7 = [
  U7,
  z7
];
function j7(t, e) {
  return p(), g("svg", H7, [...W7]);
}
const G7 = I({ name: "icon-InfoSm", render: j7 }), Y7 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, X7 = ["clip-path"], K7 = /* @__PURE__ */ h("path", { d: "M14 3.333H2V14h12V3.333ZM2 2C1.264 2 .667 2.597.667 3.333V14c0 .736.597 1.333 1.333 1.333h12c.737 0 1.334-.597 1.334-1.333V3.333C15.334 2.597 14.737 2 14 2H2Z" }, null, -1), q7 = /* @__PURE__ */ h("path", { d: "M5.334 0C5.702 0 6 .298 6 .667V2a.667.667 0 0 1-1.333 0V.667c0-.369.298-.667.667-.667ZM10.667 0c.368 0 .667.298.667.667V2A.667.667 0 0 1 10 2V.667C10 .298 10.3 0 10.667 0ZM12.667 8.667a4.667 4.667 0 1 1-9.333 0 4.667 4.667 0 0 1 9.333 0ZM8 12a3.333 3.333 0 1 0 0-6.667A3.333 3.333 0 0 0 8 12Z" }, null, -1), J7 = /* @__PURE__ */ h("path", { d: "M7.667 6.667c.368 0 .667.298.667.666v1.334h1.333a.667.667 0 1 1 0 1.333H8.334A1.333 1.333 0 0 1 7 8.667V7.333c0-.368.299-.666.667-.666Z" }, null, -1), Q7 = [
  K7,
  q7,
  J7
], ef = ["id"], tf = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), nf = [
  tf
];
function of(t, e) {
  return p(), g("svg", Y7, [
    h("g", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-path": "url(#" + t.idMap.a + ")",
      "clip-rule": "evenodd"
    }, [...Q7], 8, X7),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...nf], 8, ef)
    ])
  ]);
}
const rf = I({ name: "icon-LaterSm", render: of, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), af = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, sf = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.213 12.254c0-.452.346-.818.774-.818h4.025c.428 0 .774.366.774.818 0 .452-.346.818-.774.818H5.987c-.428 0-.774-.366-.774-.818ZM5.884 14.382c0-.452.346-.819.774-.819H9.34c.428 0 .775.367.775.819 0 .452-.347.818-.775.818H6.658c-.428 0-.774-.366-.774-.818ZM5.475 3.2c-.47.43-.74 1.066-.726 1.95.012.828.241 1.348.78 1.917l.037.04c.306.322.638.672.863 1.147.243.515.333 1.102.333 1.873 0 .452-.347.818-.774.818-.428 0-.775-.366-.775-.818 0-.647-.077-.946-.17-1.14-.1-.215-.254-.388-.61-.763-.803-.85-1.213-1.767-1.232-3.048-.02-1.277.383-2.413 1.262-3.215C5.324 1.175 6.543.8 8 .8c1.457 0 2.676.375 3.537 1.16.879.803 1.282 1.939 1.263 3.216-.02 1.282-.43 2.199-1.233 3.048-.355.375-.509.548-.61.762-.092.195-.17.494-.17 1.141 0 .452-.347.818-.774.818-.428 0-.774-.366-.774-.818 0-.771.09-1.358.333-1.873.225-.475.556-.824.862-1.147l.038-.04c.538-.57.767-1.089.78-1.916.012-.885-.256-1.522-.727-1.952-.489-.446-1.298-.762-2.525-.762-1.226 0-2.036.316-2.525.762Z",
  "clip-rule": "evenodd"
}, null, -1), lf = [
  sf
];
function df(t, e) {
  return p(), g("svg", af, [...lf]);
}
const cf = I({ name: "icon-LightBulbSm", render: df }), uf = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, hf = ["clip-path"], ff = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M12.88 9.909a.5.5 0 0 1-.708 0l-.424-.424a.5.5 0 0 1 0-.707L12.526 8A3.199 3.199 0 1 0 8 3.474l-.778.778a.5.5 0 0 1-.707 0l-.424-.424a.5.5 0 0 1 0-.707l.778-.778a4.8 4.8 0 0 1 6.788 6.788l-.778.778Zm-2.971 2.263a.5.5 0 0 1 0 .707l-.778.778a4.8 4.8 0 1 1-6.788-6.788l.778-.778a.5.5 0 0 1 .707 0l.424.424a.5.5 0 0 1 0 .707L3.475 8A3.2 3.2 0 1 0 8 12.526l.778-.778a.5.5 0 0 1 .707 0l.424.424Zm0-7.213a.5.5 0 0 1 .707 0l.425.425a.5.5 0 0 1 0 .707l-4.95 4.95a.5.5 0 0 1-.707 0l-.424-.425a.5.5 0 0 1 0-.707l4.949-4.95Z"
}, null, -1), mf = [
  ff
], pf = ["id"], _f = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), vf = [
  _f
];
function gf(t, e) {
  return p(), g("svg", uf, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...mf], 8, hf),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...vf], 8, pf)
    ])
  ]);
}
const $f = I({ name: "icon-LinkSm", render: gf, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), wf = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, yf = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M2 14c-.334 0-.617-.117-.85-.35a1.155 1.155 0 0 1-.35-.85c0-.333.117-.617.35-.85.233-.233.516-.35.85-.35.333 0 .616.117.85.35.233.234.35.517.35.85 0 .333-.117.616-.35.85-.234.233-.517.35-.85.35Zm3.2-.4a.4.4 0 0 1-.4-.4v-.8c0-.22.179-.4.4-.4h9.6c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H5.2ZM2 9.2c-.334 0-.617-.117-.85-.35A1.155 1.155 0 0 1 .8 8c0-.333.117-.617.35-.85.233-.233.516-.35.85-.35.333 0 .616.117.85.35.233.233.35.517.35.85 0 .333-.117.617-.35.85-.234.233-.517.35-.85.35Zm3.2-.4a.4.4 0 0 1-.4-.4v-.8c0-.22.179-.4.4-.4h9.6c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H5.2ZM2 4.4c-.334 0-.617-.117-.85-.35A1.155 1.155 0 0 1 .8 3.2c0-.333.117-.617.35-.85.233-.233.516-.35.85-.35.333 0 .616.117.85.35.233.233.35.517.35.85 0 .333-.117.617-.35.85-.234.233-.517.35-.85.35ZM5.2 4a.4.4 0 0 1-.4-.4v-.8c0-.22.179-.4.4-.4h9.6c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H5.2Z"
}, null, -1), Mf = [
  yf
];
function Cf(t, e) {
  return p(), g("svg", wf, [...Mf]);
}
const bf = I({ name: "icon-ListSm", render: Cf }), xf = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Sf = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.334 4.133a.533.533 0 0 0-.408.19L8 7.704l5.074-3.383a.531.531 0 0 0-.407-.189H3.334ZM13.2 6.161 8.444 9.332a.8.8 0 0 1-.888 0L2.8 6.162v5.171a.534.534 0 0 0 .534.534h9.333a.533.533 0 0 0 .533-.534V6.161ZM1.825 3.158c.4-.4.943-.625 1.509-.625h9.333A2.133 2.133 0 0 1 14.8 4.667v6.666a2.133 2.133 0 0 1-2.133 2.134H3.334A2.133 2.133 0 0 1 1.2 11.333V4.667c0-.566.225-1.109.625-1.509Z",
  "clip-rule": "evenodd"
}, null, -1), If = [
  Sf
];
function Af(t, e) {
  return p(), g("svg", xf, [...If]);
}
const kf = I({ name: "icon-MailSm", render: Af }), Ef = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Pf = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 0C6.99 0 6.02.367 5.306 1.021 4.59 1.675 4.19 2.562 4.19 3.487V7.59c0 .925.401 1.812 1.116 2.466.714.654 1.683 1.021 2.694 1.021 1.01 0 1.98-.367 2.694-1.021.715-.654 1.116-1.541 1.116-2.466V3.487c0-.925-.401-1.812-1.116-2.466C9.98.367 9.011 0 8 0ZM6.574 2.182c.378-.346.891-.541 1.426-.541.535 0 1.048.195 1.426.54.379.347.591.817.591 1.306V7.59c0 .49-.212.959-.59 1.305-.379.347-.892.541-1.427.541a2.116 2.116 0 0 1-1.426-.54 1.77 1.77 0 0 1-.591-1.306V3.487c0-.49.212-.959.59-1.305Z",
  "clip-rule": "evenodd"
}, null, -1), Tf = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M13.604 7.385a.94.94 0 0 0-.634.24.787.787 0 0 0-.263.58v.409l-.004.173c-.048 1.057-.54 2.056-1.375 2.789-.835.733-1.947 1.142-3.104 1.142h-.446l-.19-.003c-1.154-.044-2.246-.495-3.047-1.259-.8-.764-1.248-1.782-1.248-2.84v-.418L3.286 8.1l-.001-.006a.806.806 0 0 0-.323-.525.953.953 0 0 0-.627-.182.932.932 0 0 0-.594.258.784.784 0 0 0-.241.56v.41l.004.198v.003c.054 1.414.676 2.76 1.748 3.78 1.023.975 2.388 1.586 3.851 1.73v.86l.008.098v.007a.806.806 0 0 0 .323.525c.176.131.4.196.627.182a.932.932 0 0 0 .594-.258.784.784 0 0 0 .242-.56v-.854c1.501-.148 2.896-.787 3.927-1.802C13.9 11.46 14.5 10.065 14.5 8.615v-.417l-.007-.097-.001-.007a.803.803 0 0 0-.3-.507.946.946 0 0 0-.588-.202Z"
}, null, -1), Of = [
  Pf,
  Tf
];
function Lf(t, e) {
  return p(), g("svg", Ef, [...Of]);
}
const Df = I({ name: "icon-MicrophoneSm", render: Lf }), Nf = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Rf = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M13.571 7.143H2.428a.857.857 0 0 0 0 1.714h11.143a.857.857 0 0 0 0-1.714Z"
}, null, -1), Zf = [
  Rf
];
function Bf(t, e) {
  return p(), g("svg", Nf, [...Zf]);
}
const Vf = I({ name: "icon-MinusSm", render: Bf }), Ff = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Hf = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.333 2.667C5.333 2.298 5.631 2 6 2h6.666c.368 0 .667.298.667.667v8.666A2.667 2.667 0 1 1 12 9.023V6H6.666v5.333a2.667 2.667 0 1 1-1.333-2.31V2.667Zm1.333 2H12V3.333H6.666v1.334Zm4 5.333a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667ZM4 10a1.333 1.333 0 1 1 0 2.667A1.333 1.333 0 0 1 4 10Z",
  "clip-rule": "evenodd"
}, null, -1), Uf = [
  Hf
];
function zf(t, e) {
  return p(), g("svg", Ff, [...Uf]);
}
const Wf = I({ name: "icon-MusicSm", render: zf }), jf = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Gf = ["clip-path"], Yf = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.4.8A1.6 1.6 0 0 0 .8 2.4v11.2a1.6 1.6 0 0 0 1.6 1.6h6.868a1.6 1.6 0 0 0 1.132-.469L14.73 10.4c.3-.3.469-.707.469-1.131V2.4A1.6 1.6 0 0 0 13.6.8H2.4ZM13.6 8V2.4H2.4v11.2H8v-4A1.6 1.6 0 0 1 9.6 8h4Zm-4 5.269V9.6h3.668L9.6 13.269Z",
  "clip-rule": "evenodd"
}, null, -1), Xf = [
  Yf
], Kf = ["id"], qf = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Jf = [
  qf
];
function Qf(t, e) {
  return p(), g("svg", jf, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...Xf], 8, Gf),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Jf], 8, Kf)
    ])
  ]);
}
const em = I({ name: "icon-NoteSm", render: Qf, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), tm = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, nm = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.004.7c1.75 0 3.043.655 3.88 1.709.814 1.025 1.131 2.344 1.131 3.591 0 1.437.185 2.15.403 2.612.11.235.243.432.408.653.044.06.094.125.148.195.134.173.29.377.435.59.6.88.438 1.804 0 2.447-.396.58-1.098 1.053-1.81 1.053h-2.62a2 2 0 0 1-3.956 0h-2.62c-.714 0-1.416-.472-1.811-1.053-.438-.643-.6-1.566 0-2.447.145-.213.301-.417.435-.59l.148-.195c.165-.22.297-.418.408-.653.218-.462.403-1.175.403-2.612 0-1.248.319-2.567 1.135-3.592C4.96 1.355 6.255.7 8.004.7ZM3.403 11.95h9.195c.001 0 .02 0 .058-.013a.67.67 0 0 0 .139-.065.966.966 0 0 0 .291-.276.6.6 0 0 0 .114-.306.547.547 0 0 0-.114-.34c-.118-.174-.227-.315-.346-.47a21.88 21.88 0 0 1-.196-.257 5.275 5.275 0 0 1-.574-.929c-.356-.756-.555-1.73-.555-3.294 0-1.003-.258-1.934-.784-2.596C10.128 2.77 9.316 2.3 8.004 2.3c-1.312 0-2.126.47-2.631 1.105-.528.662-.787 1.593-.787 2.595 0 1.563-.199 2.538-.556 3.294-.176.374-.38.67-.573.93l-.196.256c-.12.155-.228.296-.347.47a.546.546 0 0 0-.113.34.6.6 0 0 0 .113.306c.077.112.182.21.292.276a.67.67 0 0 0 .14.065c.037.012.056.013.057.013Z",
  "clip-rule": "evenodd"
}, null, -1), om = [
  nm
];
function im(t, e) {
  return p(), g("svg", tm, [...om]);
}
const rm = I({ name: "icon-NotificationSm", render: im }), am = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, sm = ["clip-path"], lm = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.991 13.544a5.341 5.341 0 0 1-3.743-4.358 1.847 1.847 0 0 1 .744-1.76 1.864 1.864 0 0 1 .39-1.75l.45-.515c1.33-1.518 3.545-1.52 4.905-.302l.14-3.133a1.822 1.822 0 0 1 3.636.165v.164a1.81 1.81 0 0 1 2.577 1.96l-1.224 8.128.14 2.23c.054.695-.466 1.301-1.16 1.355l-5.383.343c-.694.054-1.306-.39-1.36-1.085l-.112-1.442ZM6.426 8.08a1.068 1.068 0 0 0-1.488-.982 1.08 1.08 0 0 0-.244.149l-.26.208-.017.014c-.104.076-.55-.026-.678-.039a.52.52 0 0 1-.34-.863l.061-.07.223-.254.142-.162.025-.03c.16-.183.343-.33.537-.441 1.059-.61 2.502-.186 2.993 1.045l.495 1.236.034.084h.9l.408-6.083.004-.043c.013-.12.07-.23.162-.308.065-.055.097-.05.153-.04a.63.63 0 0 0 .18.01c.114-.003.248-.006.312.06a.471.471 0 0 1 .133.321v6.083h.9l.794-4.378.012-.041a.459.459 0 1 1 .894.21l-.009.043-1.24 8.22-2.638.226-.594.046-2.2.146-.612-.17a3.99 3.99 0 0 1-2.882-3.281.499.499 0 0 1 .494-.57h.12c.126 0 .562.206.625.318l.092.166.04.073.344.616a1.133 1.133 0 0 0 2.125-.552V8.08Zm5.066 5.418.063.808-5.029.39-.063-.808 5.03-.39Z",
  "clip-rule": "evenodd"
}, null, -1), dm = [
  lm
], cm = ["id"], um = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), hm = [
  um
];
function fm(t, e) {
  return p(), g("svg", am, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...dm], 8, sm),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...hm], 8, cm)
    ])
  ]);
}
const mm = I({ name: "icon-OkSm", render: fm, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), pm = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, _m = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M2.4 15.2c-.44 0-.817-.156-1.13-.47A1.543 1.543 0 0 1 .8 13.6V2.4c0-.44.156-.817.47-1.13C1.582.957 1.96.8 2.4.8h4.8a.8.8 0 0 1 0 1.6H2.4v11.2h4.8a.8.8 0 0 1 0 1.6H2.4Zm9.38-3.78a.8.8 0 0 1-1.13-1.13l1.49-1.49H6.4a.8.8 0 0 1 0-1.6h5.74l-1.49-1.49a.799.799 0 1 1 1.13-1.13l2.713 2.713a1 1 0 0 1 0 1.414L11.78 11.42Z"
}, null, -1), vm = [
  _m
];
function gm(t, e) {
  return p(), g("svg", pm, [...vm]);
}
const $m = I({ name: "icon-OutSm", render: gm }), wm = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, ym = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.658 3.655a.727.727 0 0 0-.727.727v2.894a.72.72 0 0 1-.21.51L2.505 8l.214.214a.72.72 0 0 1 .211.51v2.894a.727.727 0 0 0 .727.727.72.72 0 0 1 0 1.44 2.167 2.167 0 0 1-2.167-2.167V9.022l-.513-.513a.72.72 0 0 1 0-1.018l.513-.513V4.382a2.167 2.167 0 0 1 2.167-2.167.72.72 0 0 1 0 1.44Zm7.963-.72a.72.72 0 0 1 .72-.72 2.167 2.167 0 0 1 2.167 2.167v2.596l.513.513a.72.72 0 0 1 0 1.018l-.513.513v2.596a2.167 2.167 0 0 1-2.167 2.167.72.72 0 1 1 0-1.44.727.727 0 0 0 .727-.727V8.724a.72.72 0 0 1 .211-.51L13.494 8l-.215-.214a.72.72 0 0 1-.21-.51V4.382a.727.727 0 0 0-.728-.727.72.72 0 0 1-.72-.72ZM5.6 8.8a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6ZM8.8 8a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Zm1.6.8a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Z",
  "clip-rule": "evenodd"
}, null, -1), Mm = [
  ym
];
function Cm(t, e) {
  return p(), g("svg", wm, [...Mm]);
}
const bm = I({ name: "icon-ParametrSm", render: Cm }), xm = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Sm = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.927 2.4c-.328 0-.63.098-.884.266a.8.8 0 1 1-.886-1.332 3.2 3.2 0 1 1 2.837 5.684.8.8 0 0 1-.533-1.509 1.601 1.601 0 0 0-.534-3.109ZM6 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM2.4 6a3.6 3.6 0 1 1 7.2 0 3.6 3.6 0 0 1-7.2 0Zm9.289 2.527a.8.8 0 0 1 1.025-.479c2.435.885 2.49 2.908 2.49 3.043a2.11 2.11 0 0 1-2.109 2.11h-.182a.8.8 0 1 1 0-1.6h.182c.28 0 .508-.227.51-.507-.006-.098-.1-1.056-1.438-1.542a.8.8 0 0 1-.478-1.025Zm-7.88 1.37a.8.8 0 0 1-.12 1.125c-1.616 1.306-1.313 2.31-1.15 2.576a.991.991 0 0 0 .06.002h6.803c.023 0 .043 0 .06-.002.162-.266.466-1.27-1.15-2.576a.8.8 0 1 1 1.005-1.244c2.217 1.79 2.265 3.942 1.254 4.988-.392.406-.915.434-1.17.434H2.6c-.255 0-.777-.028-1.17-.434C.42 13.72.468 11.568 2.684 9.778a.8.8 0 0 1 1.125.12Z",
  "clip-rule": "evenodd"
}, null, -1), Im = [
  Sm
];
function Am(t, e) {
  return p(), g("svg", xm, [...Im]);
}
const km = I({ name: "icon-PeopleSm", render: Am }), Em = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Pm = ["clip-path"], Tm = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.106 2.4a.706.706 0 0 0-.705.686A11.247 11.247 0 0 0 12.915 13.6a.706.706 0 0 0 .685-.706v-2.47l-2.629-1.052-.779 1.298a.8.8 0 0 1-1.04.306 9.082 9.082 0 0 1-4.128-4.128.8.8 0 0 1 .306-1.04l1.298-.779L5.576 2.4h-2.47Zm-1.63-.925A2.306 2.306 0 0 1 3.106.8h3.012a.8.8 0 0 1 .743.503l1.506 3.765a.8.8 0 0 1-.332.983l-1.22.731a7.483 7.483 0 0 0 2.403 2.402l.732-1.22a.8.8 0 0 1 .983-.33l3.764 1.506a.8.8 0 0 1 .503.742v3.012a2.305 2.305 0 0 1-2.354 2.304A12.847 12.847 0 0 1 .8 3.106c0-.612.243-1.198.676-1.63Zm9.159-.44a.8.8 0 0 1 1.131 0L12.8 2.068l1.035-1.035a.8.8 0 0 1 1.131 1.132L13.932 3.2l1.034 1.034a.8.8 0 0 1-1.131 1.132L12.8 4.33l-1.034 1.035a.8.8 0 0 1-1.131-1.132L11.669 3.2l-1.034-1.034a.8.8 0 0 1 0-1.132Z",
  "clip-rule": "evenodd"
}, null, -1), Om = [
  Tm
], Lm = ["id"], Dm = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Nm = [
  Dm
];
function Rm(t, e) {
  return p(), g("svg", Em, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...Om], 8, Pm),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Nm], 8, Lm)
    ])
  ]);
}
const Zm = I({ name: "icon-PhoneMissedSm", render: Rm, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Bm = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Vm = ["clip-path"], Fm = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.106 2.4a.706.706 0 0 0-.706.686A11.247 11.247 0 0 0 12.914 13.6a.706.706 0 0 0 .686-.706v-2.47l-2.63-1.052-.778 1.298a.8.8 0 0 1-1.04.306 9.082 9.082 0 0 1-4.129-4.128.8.8 0 0 1 .306-1.04l1.299-.779L5.576 2.4h-2.47Zm-1.63-.925A2.306 2.306 0 0 1 3.105.8h3.011a.8.8 0 0 1 .743.503l1.506 3.765a.8.8 0 0 1-.331.983l-1.22.731a7.483 7.483 0 0 0 2.402 2.402l.732-1.22a.8.8 0 0 1 .983-.33l3.765 1.506a.8.8 0 0 1 .503.742v3.012a2.305 2.305 0 0 1-2.355 2.304A12.847 12.847 0 0 1 .8 3.106c0-.612.243-1.198.675-1.63Z",
  "clip-rule": "evenodd"
}, null, -1), Hm = [
  Fm
], Um = ["id"], zm = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Wm = [
  zm
];
function jm(t, e) {
  return p(), g("svg", Bm, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...Hm], 8, Vm),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Wm], 8, Um)
    ])
  ]);
}
const Gm = I({ name: "icon-PhoneSm", render: jm, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Ym = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Xm = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 2.4c-.951 0-1.88.28-2.67.801a4.753 4.753 0 0 0-1.766 2.128 4.684 4.684 0 0 0-.272 2.734 4.721 4.721 0 0 0 1.31 2.425l2.971 2.938a.608.608 0 0 0 .855 0l2.97-2.938a4.721 4.721 0 0 0 1.31-2.425 4.684 4.684 0 0 0-.272-2.734A4.754 4.754 0 0 0 10.67 3.2 4.843 4.843 0 0 0 8 2.4Zm-3.552-.534a6.443 6.443 0 0 1 7.104 0 6.353 6.353 0 0 1 2.36 2.845 6.284 6.284 0 0 1 .365 3.667 6.322 6.322 0 0 1-1.754 3.248l-2.97 2.938a2.209 2.209 0 0 1-3.104 0l-2.971-2.938a6.322 6.322 0 0 1-1.755-3.248 6.284 6.284 0 0 1 .365-3.667 6.353 6.353 0 0 1 2.36-2.845ZM8 6a1.2 1.2 0 1 0 0 2.4A1.2 1.2 0 0 0 8 6ZM5.2 7.2a2.8 2.8 0 1 1 5.6 0 2.8 2.8 0 0 1-5.6 0Z",
  "clip-rule": "evenodd"
}, null, -1), Km = [
  Xm
];
function qm(t, e) {
  return p(), g("svg", Ym, [...Km]);
}
const Jm = I({ name: "icon-PinSm", render: qm }), Qm = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, ep = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 13.4A5.4 5.4 0 1 0 8 2.6a5.4 5.4 0 0 0 0 10.8ZM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z",
  "clip-rule": "evenodd"
}, null, -1), tp = [
  ep
];
function np(t, e) {
  return p(), g("svg", Qm, [...tp]);
}
const op = I({ name: "icon-PlaceholderSm", render: np }), ip = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, rp = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M13.571 7.143H8.857V2.429a.857.857 0 1 0-1.714 0v4.714H2.428a.857.857 0 0 0 0 1.714h4.715v4.714a.857.857 0 1 0 1.714 0V8.857h4.714a.857.857 0 0 0 0-1.714Z"
}, null, -1), ap = [
  rp
];
function sp(t, e) {
  return p(), g("svg", ip, [...ap]);
}
const lp = I({ name: "icon-PlusSm", render: sp }), dp = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cp = /* @__PURE__ */ h("path", {
  d: "M13.572 7.143H8.857V2.428a.857.857 0 0 0-1.714 0v4.715H2.429a.857.857 0 1 0 0 1.714h4.714v4.714a.857.857 0 0 0 1.714 0V8.857h4.715a.857.857 0 1 0 0-1.714Z",
  fill: "currentColor"
}, null, -1), up = [
  cp
];
function hp(t, e) {
  return p(), g("svg", dp, [...up]);
}
const fp = I({ name: "icon-PlusMd", render: hp }), mp = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, pp = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.004 2a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Zm-4 2.4a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm.95 4.68a.8.8 0 0 1-.086 1.127c-2.19 1.877-1.687 3.423-1.393 3.788l.01.001c.022.002.05.004.085.004h8.946a.787.787 0 0 0 .095-.005c.294-.365.797-1.911-1.392-3.788a.8.8 0 0 1 1.041-1.214c2.713 2.325 2.62 5.007 1.446 6.174-.396.393-.907.433-1.19.433H3.57c-.282 0-.794-.04-1.19-.433C1.207 14 1.114 11.318 3.827 8.993a.8.8 0 0 1 1.128.086Z",
  "clip-rule": "evenodd"
}, null, -1), _p = [
  pp
];
function vp(t, e) {
  return p(), g("svg", mp, [..._p]);
}
const gp = I({ name: "icon-ProfileSm", render: vp }), $p = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, wp = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.604.4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2.4 4a2.4 2.4 0 1 1 4.8 0 2.4 2.4 0 0 1-4.8 0Z",
  "clip-rule": "evenodd"
}, null, -1), yp = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M4.467 10.207a.8.8 0 1 0-1.041-1.214C.713 11.318.806 14 1.98 15.167c.396.393.907.433 1.19.433h5.273a.8.8 0 0 0 0-1.6H3.17a.788.788 0 0 1-.085-.004l-.01-.001c-.294-.365-.797-1.911 1.392-3.788ZM12.89 12.055l-.9.86a.705.705 0 0 0-.215.505c0 .19.078.371.216.505a.746.746 0 0 0 1.04 0l2.169-2.08a.817.817 0 0 0 0-1.18L13.03 8.59a.746.746 0 0 0-1.04 0 .705.705 0 0 0-.215.506c0 .19.078.371.216.505l.897.855H9.243a.8.8 0 0 0 0 1.6h3.647Z"
}, null, -1), Mp = [
  wp,
  yp
];
function Cp(t, e) {
  return p(), g("svg", $p, [...Mp]);
}
const bp = I({ name: "icon-ReassignSm", render: Cp }), xp = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Sp = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.778 1.928A6.2 6.2 0 0 0 3.467 3.83v-.498a.8.8 0 0 0-1.6 0V6a.8.8 0 0 0 .8.8h.315a.79.79 0 0 0 .036 0h2.315a.8.8 0 1 0 0-1.6h-.938a4.6 4.6 0 0 1 8.146 2.243.8.8 0 1 0 1.585-.22 6.2 6.2 0 0 0-5.348-5.295ZM3.46 8.557a.8.8 0 1 0-1.585.22 6.2 6.2 0 0 0 10.66 3.392v.498a.8.8 0 1 0 1.6 0V10a.8.8 0 0 0-.8-.8h-2.667a.8.8 0 0 0 0 1.6h.938a4.6 4.6 0 0 1-8.146-2.243Z",
  "clip-rule": "evenodd"
}, null, -1), Ip = [
  Sp
];
function Ap(t, e) {
  return p(), g("svg", xp, [...Ip]);
}
const $d = I({ name: "icon-RefreshSm", render: Ap }), kp = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Ep = ["clip-path"], Pp = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M12.537 4.76H6.8a4.8 4.8 0 1 0 0 9.6h6.4a.8.8 0 0 1 0 1.6H6.8a6.4 6.4 0 0 1 0-12.8h5.737l-1.463-1.463A.8.8 0 1 1 12.206.566l2.828 2.828a.8.8 0 0 1 0 1.132l-2.829 2.828a.8.8 0 0 1-1.13-1.13l1.463-1.464Z"
}, null, -1), Tp = [
  Pp
], Op = ["id"], Lp = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Dp = [
  Lp
];
function Np(t, e) {
  return p(), g("svg", kp, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...Tp], 8, Ep),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Dp], 8, Op)
    ])
  ]);
}
const Rp = I({ name: "icon-ReopenSm", render: Np, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Zp = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Bp = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.662 2.004a.73.73 0 1 0-1.033 1.034l.28.279h-6.66a1.1 1.1 0 0 0-1.1 1.1v2.199a.734.734 0 0 0 1.468 0V4.783h6.292l-.28.28a.73.73 0 1 0 1.034 1.032l1.267-1.268a1.1 1.1 0 0 0 0-1.555l-1.268-1.268Zm.471 6.613a.733.733 0 0 0-.733.733v1.816H5.108l.279-.279a.73.73 0 1 0-1.033-1.033l-1.27 1.27a1.1 1.1 0 0 0-.003 1.553l1.267 1.277a.732.732 0 1 0 1.033-1.039l-.27-.265h6.655a1.1 1.1 0 0 0 1.1-1.1v-2.2a.733.733 0 0 0-.733-.733Z",
  "clip-rule": "evenodd"
}, null, -1), Vp = [
  Bp
];
function Fp(t, e) {
  return p(), g("svg", Zp, [...Vp]);
}
const Hp = I({ name: "icon-RepeatSm", render: Fp }), Up = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, zp = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.993 1.893a6.134 6.134 0 0 1 6.1 5.336.8.8 0 0 1-1.586.208 4.533 4.533 0 1 0-.91 3.363h-1.63a.8.8 0 0 1 0-1.6H13.3a.8.8 0 0 1 .8.8v3.333a.8.8 0 1 1-1.6 0v-1.126A6.134 6.134 0 1 1 7.993 1.893Z",
  "clip-rule": "evenodd"
}, null, -1), Wp = [
  zp
];
function jp(t, e) {
  return p(), g("svg", Up, [...Wp]);
}
const Gp = I({ name: "icon-RotateSm", render: jp }), Yp = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Xp = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.095 2.4a.8.8 0 0 1 .8-.8h5.086a3.343 3.343 0 0 1 0 6.686H5.695v1.79h4.286a.8.8 0 0 1 0 1.6H5.695v2.59a.8.8 0 0 1-1.6 0v-2.59H3.2a.8.8 0 0 1 0-1.6h.895v-1.79H3.2a.8.8 0 1 1 0-1.6h.895V2.4Zm1.6 4.286h4.286a1.743 1.743 0 1 0 0-3.486H5.695v3.486Z",
  "clip-rule": "evenodd"
}, null, -1), Kp = [
  Xp
];
function qp(t, e) {
  return p(), g("svg", Yp, [...Kp]);
}
const Jp = I({ name: "icon-RubelSm", render: qp }), Qp = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, e9 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.927 1.2a5.726 5.726 0 1 0 3.51 10.25l3.141 3.14a.716.716 0 1 0 1.013-1.012l-3.14-3.14A5.726 5.726 0 0 0 6.926 1.2ZM2.632 6.926a4.295 4.295 0 1 1 8.59 0 4.295 4.295 0 0 1-8.59 0Z",
  "clip-rule": "evenodd"
}, null, -1), t9 = [
  e9
];
function n9(t, e) {
  return p(), g("svg", Qp, [...t9]);
}
const o9 = I({ name: "icon-SearchSm", render: n9 }), i9 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, r9 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.706 2.255a.75.75 0 0 0-.98-.954L1.746 5.628a1.117 1.117 0 0 0-.072 2.047l4.434 2.217 2.217 4.435a1.116 1.116 0 0 0 2.047-.072l4.334-12ZM6.518 8.42 3.126 6.724l7.965-2.876L6.518 8.42ZM7.58 9.48l1.697 3.393 2.877-7.966L7.579 9.48Z",
  "clip-rule": "evenodd"
}, null, -1), a9 = [
  r9
];
function s9(t, e) {
  return p(), g("svg", i9, [...a9]);
}
const l9 = I({ name: "icon-SendSm", render: s9 }), d9 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, c9 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.9 1.6c-1.324 0-2.441.887-2.788 2.1H1.5a.6.6 0 0 0-.6.6v.4a.6.6 0 0 0 .6.6h1.612a2.901 2.901 0 0 0 5.576 0H14.5a.6.6 0 0 0 .6-.6v-.4a.6.6 0 0 0-.6-.6H8.688A2.901 2.901 0 0 0 5.9 1.6ZM4.6 4.5a1.3 1.3 0 1 1 2.6 0 1.3 1.3 0 0 1-2.6 0ZM10.1 8.6a2.901 2.901 0 0 0-2.788 2.1H1.5a.6.6 0 0 0-.6.6v.4a.6.6 0 0 0 .6.6h5.812a2.901 2.901 0 0 0 5.576 0H14.5a.6.6 0 0 0 .6-.6v-.4a.6.6 0 0 0-.6-.6h-1.612A2.901 2.901 0 0 0 10.1 8.6Zm-1.3 2.9a1.3 1.3 0 1 1 2.6 0 1.3 1.3 0 0 1-2.6 0Z",
  "clip-rule": "evenodd"
}, null, -1), u9 = [
  c9
];
function h9(t, e) {
  return p(), g("svg", d9, [...u9]);
}
const f9 = I({ name: "icon-Settings2Sm", render: h9 }), m9 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, p9 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.979 2.174C5.979 1.415 6.594.8 7.352.8h1.295c.759 0 1.374.615 1.374 1.374v.521l.25.12.301-.324a1.374 1.374 0 0 1 1.976-.033l.98.98c.561.56.532 1.478-.062 2.002l-.296.262.135.277h.521c.759 0 1.374.615 1.374 1.374v1.294c0 .76-.615 1.374-1.374 1.374h-.521l-.135.277.296.262c.594.524.623 1.441.063 2.002l-.981.98c-.55.55-1.446.535-1.976-.033l-.302-.324-.249.12v.521c0 .759-.615 1.374-1.374 1.374H7.352a1.374 1.374 0 0 1-1.373-1.374v-.521l-.25-.12-.301.324a1.374 1.374 0 0 1-1.976.034l-.981-.981a1.374 1.374 0 0 1 .063-2.002l.296-.262-.135-.277h-.521A1.374 1.374 0 0 1 .8 8.647V7.353c0-.76.615-1.374 1.374-1.374h.521l.135-.277-.296-.262a1.374 1.374 0 0 1-.063-2.002l.981-.98a1.374 1.374 0 0 1 1.976.033l.301.324.25-.12v-.521Zm1.453.079v.492c0 .52-.294.996-.76 1.229h-.001l-.434.207c-.53.219-1.139.087-1.53-.332l-.286-.306-.863.863.278.246c.452.398.591 1.044.345 1.593l-.001.002-.207.425c-.232.466-.708.76-1.228.76h-.492v1.136h.492c.52 0 .996.294 1.228.76l.208.427c.246.55.107 1.195-.345 1.593l-.278.246.863.863.286-.306c.391-.419 1-.55 1.53-.332l.004.002.431.205c.466.233.76.709.76 1.23v.491h1.136v-.492c0-.52.294-.996.76-1.229l.434-.207a1.374 1.374 0 0 1 1.53.332l.286.306.864-.863-.279-.246a1.374 1.374 0 0 1-.344-1.593v-.002l.207-.424v-.001c.233-.466.709-.76 1.229-.76h.492V7.432h-.492c-.52 0-.996-.294-1.229-.76l-.207-.427a1.374 1.374 0 0 1 .344-1.593l.279-.246-.864-.863-.286.306c-.39.419-1 .55-1.53.332l-.003-.002-.432-.205a1.374 1.374 0 0 1-.759-1.23v-.491H7.432Z",
  "clip-rule": "evenodd"
}, null, -1), _9 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 6.72a1.28 1.28 0 1 0 0 2.56 1.28 1.28 0 0 0 0-2.56ZM5.28 8a2.72 2.72 0 1 1 5.44 0 2.72 2.72 0 0 1-5.44 0Z",
  "clip-rule": "evenodd"
}, null, -1), v9 = [
  p9,
  _9
];
function g9(t, e) {
  return p(), g("svg", m9, [...v9]);
}
const $9 = I({ name: "icon-SettingsSm", render: g9 }), w9 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, y9 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m9.835 2.166 1.53 1.53c-.262-.041-.545-.08-.842-.11-1.336-.142-3.14-.171-4.48.498C4.997 4.607 4.4 5.62 4.072 6.38a7.586 7.586 0 0 0-.453 1.44l-.005.029-.002.008v.005L4.4 8l-.788-.137a.8.8 0 0 0 1.576.276v-.001l.003-.013.012-.061a5.985 5.985 0 0 1 .339-1.05c.277-.643.68-1.23 1.216-1.498.896-.448 2.291-.478 3.596-.34.582.062 1.109.152 1.507.232L9.835 7.434a.8.8 0 0 0 1.13 1.132l3.2-3.2a.801.801 0 0 0 0-1.132l-3.2-3.2a.8.8 0 1 0-1.13 1.132ZM2 9.6a.8.8 0 0 1 .8.8v2.32c0 .265.215.48.48.48h9.44a.48.48 0 0 0 .48-.48V10.4a.8.8 0 0 1 1.6 0v2.8a1.6 1.6 0 0 1-1.6 1.6H2.8a1.6 1.6 0 0 1-1.6-1.6v-2.8a.8.8 0 0 1 .8-.8Z",
  "clip-rule": "evenodd"
}, null, -1), M9 = [
  y9
];
function C9(t, e) {
  return p(), g("svg", w9, [...M9]);
}
const b9 = I({ name: "icon-ShareSm", render: C9 }), x9 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, S9 = ["clip-path"], I9 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 2.4a5.6 5.6 0 1 0 0 11.2A5.6 5.6 0 0 0 8 2.4ZM.8 8a7.2 7.2 0 1 1 14.4 0A7.2 7.2 0 0 1 .8 8Zm4.4-1.333a.8.8 0 0 1 .8-.8h.006a.8.8 0 1 1 0 1.6H6a.8.8 0 0 1-.8-.8Zm4 0a.8.8 0 0 1 .8-.8h.007a.8.8 0 0 1 0 1.6H10a.8.8 0 0 1-.8-.8ZM5.773 9.429a.8.8 0 0 1 1.132.011 1.534 1.534 0 0 0 2.19 0 .8.8 0 0 1 1.143 1.12 3.134 3.134 0 0 1-4.476 0 .8.8 0 0 1 .011-1.131Z",
  "clip-rule": "evenodd"
}, null, -1), A9 = [
  I9
], k9 = ["id"], E9 = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), P9 = [
  E9
];
function T9(t, e) {
  return p(), g("svg", x9, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...A9], 8, S9),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...P9], 8, k9)
    ])
  ]);
}
const O9 = I({ name: "icon-SmileSm", render: T9, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), L9 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, D9 = ["clip-path"], N9 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.244 1.348a7.2 7.2 0 0 1 9.5 4.13.816.816 0 0 1 .089.252 7.2 7.2 0 1 1-13.666 0 .804.804 0 0 1 .089-.252 7.184 7.184 0 0 1 1.653-2.57 7.2 7.2 0 0 1 2.335-1.56ZM2.502 6.937a5.6 5.6 0 0 0 1.47 4.954l1.016-1.17-1.02-3.216-1.466-.568Zm3.05.27.9 2.837h3.096l.9-2.837L8 5.432 5.552 7.207ZM8.8 4.037l2.702 1.957 1.47-.57A5.6 5.6 0 0 0 8.8 2.457v1.58Zm-1.6-1.58a5.6 5.6 0 0 0-4.173 2.967l1.471.57L7.2 4.036V2.457Zm6.298 4.48-1.467.568-1.003 3.164 1.01 1.211a5.6 5.6 0 0 0 1.46-4.943Zm-2.723 5.927-1.017-1.22H6.305l-1.066 1.228A5.61 5.61 0 0 0 8 13.6a5.598 5.598 0 0 0 2.776-.736Z",
  "clip-rule": "evenodd"
}, null, -1), R9 = [
  N9
], Z9 = ["id"], B9 = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), V9 = [
  B9
];
function F9(t, e) {
  return p(), g("svg", L9, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...R9], 8, D9),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...V9], 8, Z9)
    ])
  ]);
}
const H9 = I({ name: "icon-SoccerSm", render: F9, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), U9 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, z9 = ["clip-path"], W9 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.4 2.4a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4ZM9.6 3.6a2.8 2.8 0 1 1 .758 1.916L6.384 7.701a2.832 2.832 0 0 1 0 .598l3.974 2.185a2.8 2.8 0 1 1-.716 1.431.773.773 0 0 1-.028-.014L5.76 9.782a2.8 2.8 0 1 1 0-3.564l3.854-2.12a.81.81 0 0 1 .028-.013A2.818 2.818 0 0 1 9.6 3.6Zm-6 3.2a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Zm8.8 4.4a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Z",
  "clip-rule": "evenodd"
}, null, -1), j9 = [
  W9
], G9 = ["id"], Y9 = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), X9 = [
  Y9
];
function K9(t, e) {
  return p(), g("svg", U9, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...j9], 8, z9),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...X9], 8, G9)
    ])
  ]);
}
const q9 = I({ name: "icon-SocialsSm", render: K9, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), J9 = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Q9 = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.2 1.6a.8.8 0 1 0 0 1.6h1.6a.8.8 0 1 0 0-1.6H7.2Zm-2.263 0A2.401 2.401 0 0 1 7.2 0h1.6a2.4 2.4 0 0 1 2.263 1.6H12A2.4 2.4 0 0 1 14.4 4v9.6A2.4 2.4 0 0 1 12 16H4a2.4 2.4 0 0 1-2.4-2.4V4A2.4 2.4 0 0 1 4 1.6h.937Zm0 1.6H4a.8.8 0 0 0-.8.8v9.6a.8.8 0 0 0 .8.8h8a.8.8 0 0 0 .8-.8V4a.8.8 0 0 0-.8-.8h-.937A2.4 2.4 0 0 1 8.8 4.8H7.2a2.401 2.401 0 0 1-2.263-1.6Zm.663 4a.8.8 0 0 1 .8.8v4a.8.8 0 0 1-1.6 0V8a.8.8 0 0 1 .8-.8Zm4.8 1.6a.8.8 0 0 1 .8.8V12a.8.8 0 0 1-1.6 0V9.6a.8.8 0 0 1 .8-.8ZM8 10.4a.8.8 0 0 1 .8.8v.8a.8.8 0 0 1-1.6 0v-.8a.8.8 0 0 1 .8-.8Z",
  "clip-rule": "evenodd"
}, null, -1), e_ = [
  Q9
];
function t_(t, e) {
  return p(), g("svg", J9, [...e_]);
}
const n_ = I({ name: "icon-StatisticSm", render: t_ }), o_ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, i_ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.4.8a.8.8 0 0 1 .8.8v3.657h4.06v-.114c0-.463.19-.902.52-1.221.329-.319.77-.494 1.224-.494h3.653c.454 0 .895.175 1.223.494.33.32.52.758.52 1.22v1.83a1.7 1.7 0 0 1-.52 1.22c-.328.319-.769.494-1.223.494H9.004c-.455 0-.895-.175-1.224-.494a1.7 1.7 0 0 1-.52-1.22v-.115H3.2v4.8a.1.1 0 0 0 .033.072.16.16 0 0 0 .11.042H7.26v-.114c0-.463.19-.901.52-1.22.329-.32.77-.494 1.224-.494h3.653c.454 0 .895.175 1.223.493.33.32.52.758.52 1.221v1.829a1.7 1.7 0 0 1-.52 1.22c-.328.32-.769.494-1.223.494H9.004c-.455 0-.895-.175-1.224-.493a1.7 1.7 0 0 1-.52-1.221v-.115H3.343c-.454 0-.895-.174-1.223-.493a1.7 1.7 0 0 1-.52-1.22V1.6a.8.8 0 0 1 .8-.8Zm6.46 12.686a.1.1 0 0 0 .033.072.159.159 0 0 0 .11.042h3.654a.159.159 0 0 0 .11-.042.1.1 0 0 0 .033-.072v-1.829a.1.1 0 0 0-.033-.072.16.16 0 0 0-.11-.042H9.004a.16.16 0 0 0-.11.042.1.1 0 0 0-.034.072v1.829Zm0-6.515a.1.1 0 0 0 .033.072.16.16 0 0 0 .11.043h3.654a.159.159 0 0 0 .11-.043.1.1 0 0 0 .033-.072V5.143a.1.1 0 0 0-.033-.072.159.159 0 0 0-.11-.043H9.004a.16.16 0 0 0-.11.043.1.1 0 0 0-.034.072V6.97Z",
  "clip-rule": "evenodd"
}, null, -1), r_ = [
  i_
];
function a_(t, e) {
  return p(), g("svg", o_, [...r_]);
}
const s_ = I({ name: "icon-SubtaskSm", render: a_ }), l_ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, d_ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 2.8c-.796 0-1.476.498-1.744 1.2h3.488A1.867 1.867 0 0 0 8 2.8Zm0-1.6A3.468 3.468 0 0 0 4.597 4H2.311C1.39 4 .8 4.808.8 5.6v8c0 .793.59 1.6 1.51 1.6H13.69c.92 0 1.51-.807 1.51-1.6v-8c0-.792-.59-1.6-1.51-1.6h-2.287A3.468 3.468 0 0 0 8 1.2Zm5.6 4.4H2.4v8h11.2v-8ZM7.2 7.2a.8.8 0 0 0 0 1.6h1.6a.8.8 0 1 0 0-1.6H7.2Z",
  "clip-rule": "evenodd"
}, null, -1), c_ = [
  d_
];
function u_(t, e) {
  return p(), g("svg", l_, [...c_]);
}
const h_ = I({ name: "icon-SuitcaseSm", render: u_ }), f_ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, m_ = ["clip-path"], p_ = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  d: "M1.688 1.688A3.032 3.032 0 0 1 3.83.8h2.925c.608 0 1.19.242 1.62.671l6.152 6.151a2.294 2.294 0 0 1 0 3.243m0 0-3.663 3.663a2.294 2.294 0 0 1-3.243 0l-6.15-6.15A2.292 2.292 0 0 1 .8 6.755V3.832c0-.804.32-1.576.888-2.144m2.143.628a1.516 1.516 0 0 0-1.515 1.516v2.924c0 .206.081.404.227.55l6.151 6.15a.777.777 0 0 0 1.099 0l3.663-3.663a.777.777 0 0 0 0-1.099l-6.151-6.15a.777.777 0 0 0-.549-.228H3.831Z",
  "clip-rule": "evenodd"
}, null, -1), __ = /* @__PURE__ */ h("path", { d: "M6.105 4.968a1.137 1.137 0 1 1-2.274 0 1.137 1.137 0 0 1 2.274 0Z" }, null, -1), v_ = [
  p_,
  __
], g_ = ["id"], $_ = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), w_ = [
  $_
];
function y_(t, e) {
  return p(), g("svg", f_, [
    h("g", {
      fill: "currentColor",
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...v_], 8, m_),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...w_], 8, g_)
    ])
  ]);
}
const M_ = I({ name: "icon-TagSm", render: y_, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), C_ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, b_ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.4 2.4a.8.8 0 0 1 .8-.8h1.6a.8.8 0 1 1 0 1.6H7.2a.8.8 0 0 1-.8-.8ZM7.2 0a2.401 2.401 0 0 0-2.263 1.6H4A2.4 2.4 0 0 0 1.6 4v9.6A2.4 2.4 0 0 0 4 16h8a2.4 2.4 0 0 0 2.4-2.4V4A2.4 2.4 0 0 0 12 1.6h-.937A2.4 2.4 0 0 0 8.8 0H7.2ZM4 3.2h.937c.33.932 1.218 1.6 2.263 1.6h1.6a2.4 2.4 0 0 0 2.263-1.6H12a.8.8 0 0 1 .8.8v9.6a.8.8 0 0 1-.8.8H4a.8.8 0 0 1-.8-.8V4a.8.8 0 0 1 .8-.8Zm6.198 5.331A.8.8 0 1 0 9.002 7.47L7.467 9.196l-.469-.527A.8.8 0 0 0 5.802 9.73l1.067 1.2a.8.8 0 0 0 1.196 0l2.133-2.4Z",
  "clip-rule": "evenodd"
}, null, -1), x_ = [
  b_
];
function S_(t, e) {
  return p(), g("svg", C_, [...x_]);
}
const I_ = I({ name: "icon-TaskSm", render: S_ }), A_ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, k_ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.6 2.88c0-.707.573-1.28 1.28-1.28h10.24c.707 0 1.28.573 1.28 1.28v10.24a1.28 1.28 0 0 1-1.28 1.28H2.88a1.28 1.28 0 0 1-1.28-1.28V2.88Zm1.6.32h9.6v9.6H3.2V3.2Zm5.71.96a.728.728 0 0 0-.684.479l-2.234 6.127a.8.8 0 0 0 .751 1.074h.04a.8.8 0 0 0 .76-.547L9.6 5.119a.728.728 0 0 0-.691-.959Z",
  "clip-rule": "evenodd"
}, null, -1), E_ = [
  k_
];
function P_(t, e) {
  return p(), g("svg", A_, [...E_]);
}
const T_ = I({ name: "icon-TemplateSm", render: P_ }), O_ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, L_ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.7 8A7.3 7.3 0 0 1 8 .7a.8.8 0 0 1 0 1.6A5.7 5.7 0 1 0 13.7 8a.8.8 0 0 1 1.6 0A7.3 7.3 0 1 1 .7 8Z",
  "clip-rule": "evenodd"
}, null, -1), D_ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.35 4.7a.8.8 0 0 1 .8.8v2.708l1.776 1.115a.8.8 0 0 1-.851 1.354l-2.15-1.35a.8.8 0 0 1-.375-.677V5.5a.8.8 0 0 1 .8-.8Z",
  "clip-rule": "evenodd"
}, null, -1), N_ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M12.1 2.4a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0ZM14.45 4.8a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Z"
}, null, -1), R_ = [
  L_,
  D_,
  N_
];
function Z_(t, e) {
  return p(), g("svg", O_, [...R_]);
}
const B_ = I({ name: "icon-TimerSm", render: Z_ }), V_ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, F_ = ["clip-path"], H_ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.244 1.348a7.2 7.2 0 1 1 5.511 13.304 7.2 7.2 0 0 1-5.51-13.304ZM8 2.4a5.6 5.6 0 1 0 0 11.2A5.6 5.6 0 0 0 8 2.4ZM8 4a.8.8 0 0 1 .8.8v2.772l2.044 1.362a.8.8 0 0 1-.888 1.332l-2.4-1.6A.8.8 0 0 1 7.2 8V4.8A.8.8 0 0 1 8 4Z",
  "clip-rule": "evenodd"
}, null, -1), U_ = [
  H_
], z_ = ["id"], W_ = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), j_ = [
  W_
];
function G_(t, e) {
  return p(), g("svg", V_, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...U_], 8, F_),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...j_], 8, z_)
    ])
  ]);
}
const Y_ = I({ name: "icon-TimeSm", render: G_, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), X_ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, K_ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.2 3.5v-1A1.8 1.8 0 0 1 6 .7h4a1.8 1.8 0 0 1 1.8 1.8v1H14a.8.8 0 0 1 0 1.6h-.729l-.424 8.49a1.8 1.8 0 0 1-1.798 1.71H4.951a1.8 1.8 0 0 1-1.797-1.71L2.729 5.1H2a.8.8 0 1 1 0-1.6h2.2Zm1.6-1c0-.11.09-.2.2-.2h4c.11 0 .2.09.2.2v1H5.8v-1ZM4.331 5.1h7.338l-.42 8.41a.2.2 0 0 1-.2.19H4.951a.2.2 0 0 1-.2-.19l-.42-8.41Z",
  "clip-rule": "evenodd"
}, null, -1), q_ = [
  K_
];
function J_(t, e) {
  return p(), g("svg", X_, [...q_]);
}
const Q_ = I({ name: "icon-TrashSm", render: J_ }), ev = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, tv = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.667 5.333c0-.368.298-.666.667-.666h5.333c.368 0 .667.298.667.666v5.334a.667.667 0 0 1-.667.666H3.334a.667.667 0 0 1-.667-.666V5.333Zm8 5.079v.255a2 2 0 0 1-2 2H3.334a2 2 0 0 1-2-2V5.333a2 2 0 0 1 2-2h5.333a2 2 0 0 1 2 2v.255l2.07-1.035a1.333 1.333 0 0 1 1.93 1.192v4.51a1.333 1.333 0 0 1-1.93 1.192l-2.07-1.035Zm0-1.49 2.667 1.332V5.746l-2.667 1.333V8.92Z",
  "clip-rule": "evenodd"
}, null, -1), nv = [
  tv
];
function ov(t, e) {
  return p(), g("svg", ev, [...nv]);
}
const iv = I({ name: "icon-VideoSm", render: ov }), rv = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, av = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.834 6.101a.8.8 0 0 1 1.132 0l.767.768.768-.768a.8.8 0 0 1 1.131 1.131L12.864 8l.768.768a.8.8 0 0 1-1.131 1.131l-.768-.768-.768.768a.8.8 0 0 1-1.13-1.131L10.601 8l-.768-.768a.8.8 0 0 1 0-1.131ZM6.392 3.695 4.33 6.37a.8.8 0 0 1-.634.311H2.4v2.636h1.297a.8.8 0 0 1 .634.311l2.06 2.676v-8.61Zm-.267-1.993a1.354 1.354 0 0 1 1.683.563c.152.256.216.553.184.846v9.778a1.37 1.37 0 0 1-.92 1.44 1.354 1.354 0 0 1-1.598-.593l-2.17-2.819H2.298c-.4 0-.782-.16-1.063-.443A1.51 1.51 0 0 1 .8 9.412V6.588c0-.397.156-.779.436-1.062.28-.283.663-.444 1.063-.444h1.004l2.171-2.818c.15-.252.378-.45.651-.562Z",
  "clip-rule": "evenodd"
}, null, -1), sv = [
  av
];
function lv(t, e) {
  return p(), g("svg", rv, [...sv]);
}
const dv = I({ name: "icon-VolumeOffSm", render: lv }), cv = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, uv = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.392 3.695 4.33 6.37a.8.8 0 0 1-.634.311H2.4v2.636h1.297a.8.8 0 0 1 .634.311l2.06 2.676v-8.61Zm-.267-1.993a1.354 1.354 0 0 1 1.683.563c.152.256.216.553.184.846v9.778a1.37 1.37 0 0 1-.92 1.44 1.354 1.354 0 0 1-1.598-.593l-2.17-2.819H2.298c-.4 0-.782-.16-1.063-.443A1.51 1.51 0 0 1 .8 9.412V6.588c0-.397.156-.779.436-1.062.28-.283.663-.444 1.063-.444h1.004l2.171-2.818c.15-.252.378-.45.651-.562Zm4.653 1.128a.8.8 0 0 1 1.125-.119 6.8 6.8 0 0 1 1.862 2.358c.437.916.635 1.917.635 2.931s-.198 2.015-.635 2.93a6.8 6.8 0 0 1-1.862 2.359.8.8 0 1 1-1.006-1.245 5.199 5.199 0 0 0 0-8.088.8.8 0 0 1-.12-1.126ZM8.96 4.854a.8.8 0 0 1 1.12-.16 4.134 4.134 0 0 1 0 6.614.8.8 0 0 1-.96-1.28 2.534 2.534 0 0 0 0-4.054.8.8 0 0 1-.16-1.12Z",
  "clip-rule": "evenodd"
}, null, -1), hv = [
  uv
];
function fv(t, e) {
  return p(), g("svg", cv, [...hv]);
}
const mv = I({ name: "icon-VolumeSm", render: fv }), pv = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, _v = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2 2.667c0-.737.597-1.334 1.333-1.334h9.334c.736 0 1.333.597 1.333 1.334v10.666c0 .737-.597 1.334-1.333 1.334H3.333A1.333 1.333 0 0 1 2 13.333V2.667Zm10.667 0H3.333v10.666h9.334V2.667Z",
  "clip-rule": "evenodd"
}, null, -1), vv = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.667 10.667c0-.368.298-.667.666-.667h3.334a.667.667 0 0 1 0 1.333H5.333a.667.667 0 0 1-.666-.666ZM4.667 8c0-.368.298-.667.666-.667H10a.667.667 0 1 1 0 1.334H5.333A.667.667 0 0 1 4.667 8ZM4.667 5.333c0-.368.298-.666.666-.666H10A.667.667 0 1 1 10 6H5.333a.667.667 0 0 1-.666-.667Z",
  "clip-rule": "evenodd"
}, null, -1), gv = [
  _v,
  vv
];
function $v(t, e) {
  return p(), g("svg", pv, [...gv]);
}
const wv = I({ name: "icon-WABATemplateSm", render: $v }), yv = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Mv = ["clip-path"], Cv = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.597 1.597A2.267 2.267 0 0 1 3.2.933h8A1.467 1.467 0 0 1 12.666 2.4v1.733h.134A1.467 1.467 0 0 1 14.266 5.6v1.733h.134c.368 0 .666.299.666.667v3.2a.667.667 0 0 1-.666.667h-.134V13.6a1.467 1.467 0 0 1-1.466 1.467H3.2A2.267 2.267 0 0 1 .933 12.8V3.2c0-.601.239-1.178.664-1.603Zm.67 3.669V12.8a.934.934 0 0 0 .933.933h9.6a.133.133 0 0 0 .133-.133v-1.733H11.2a2.267 2.267 0 1 1 0-4.534h1.733V5.6a.133.133 0 0 0-.133-.133H3.2c-.325 0-.643-.07-.934-.201Zm9.066-1.133H3.2a.933.933 0 1 1 0-1.866h8a.134.134 0 0 1 .133.133v1.733ZM11.2 8.667a.933.933 0 1 0 0 1.866h2.533V8.667H11.2Z",
  "clip-rule": "evenodd"
}, null, -1), bv = [
  Cv
], xv = ["id"], Sv = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Iv = [
  Sv
];
function Av(t, e) {
  return p(), g("svg", yv, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...bv], 8, Mv),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Iv], 8, xv)
    ])
  ]);
}
const kv = I({ name: "icon-WalletSm", render: Av, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Ev = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Pv = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.993 1.179a2.133 2.133 0 0 0-1.862 1.093l-4.73 8.16a.8.8 0 0 0-.049.1 2.133 2.133 0 0 0 1.981 2.935h9.339a2.134 2.134 0 0 0 1.963-2.934.794.794 0 0 0-.05-.1l-4.73-8.161a2.133 2.133 0 0 0-1.862-1.093Zm-4.66 10.688h-.036a.534.534 0 0 1-.477-.692l4.699-8.107.008-.014a.533.533 0 0 1 .933 0l.008.014 4.698 8.107a.533.533 0 0 1-.503.692h-9.33ZM8.8 6a.8.8 0 1 0-1.6 0v1.333a.8.8 0 1 0 1.6 0V6Zm0 4a.8.8 0 1 0-1.6 0v.007a.8.8 0 0 0 1.6 0V10Z",
  "clip-rule": "evenodd"
}, null, -1), Tv = [
  Pv
];
function Ov(t, e) {
  return p(), g("svg", Ev, [...Tv]);
}
const Lv = I({ name: "icon-WarningSm", render: Ov }), Dv = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Nv = ["clip-path"], Rv = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.6 2.4H2.4V4h11.2V2.4ZM2.4.8A1.6 1.6 0 0 0 .8 2.4V4a1.6 1.6 0 0 0 1.6 1.6h11.2A1.6 1.6 0 0 0 15.2 4V2.4A1.6 1.6 0 0 0 13.6.8H2.4ZM13.6 8H2.4v3.2h11.2V8ZM2.4 6.4A1.6 1.6 0 0 0 .8 8v3.2a1.6 1.6 0 0 0 1.6 1.6h11.2a1.6 1.6 0 0 0 1.6-1.6V8a1.6 1.6 0 0 0-1.6-1.6H2.4Zm0 8.8h11.2v3.2H2.4v-3.2Zm-1.6 0a1.6 1.6 0 0 1 1.6-1.6h11.2a1.6 1.6 0 0 1 1.6 1.6v3.2a1.6 1.6 0 0 1-1.6 1.6H2.4a1.6 1.6 0 0 1-1.6-1.6v-3.2Z",
  "clip-rule": "evenodd"
}, null, -1), Zv = [
  Rv
], Bv = ["id"], Vv = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Fv = [
  Vv
];
function Hv(t, e) {
  return p(), g("svg", Dv, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...Zv], 8, Nv),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Fv], 8, Bv)
    ])
  ]);
}
const Uv = I({ name: "icon-WeekSm", render: Hv, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), zv = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Wv = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.568 1.436a.8.8 0 0 1 .232.562V6a.8.8 0 0 1-1.6 0V3.931L9.566 7.566a.8.8 0 1 1-1.131-1.132L12.069 2.8H10a.8.8 0 1 1 0-1.6h4c.22 0 .42.089.564.233l.004.003ZM7.566 8.434a.8.8 0 0 1 0 1.132L3.932 13.2H6a.8.8 0 0 1 0 1.6H1.998a.797.797 0 0 1-.562-.233l-.003-.003A.797.797 0 0 1 1.2 14v-4a.8.8 0 1 1 1.6 0v2.069l3.635-3.635a.8.8 0 0 1 1.13 0Z",
  "clip-rule": "evenodd"
}, null, -1), jv = [
  Wv
];
function Gv(t, e) {
  return p(), g("svg", zv, [...jv]);
}
const Yv = I({ name: "icon-FullscreenSm", render: Gv }), Xv = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Kv = ["clip-path"], qv = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.716 1.357a7.175 7.175 0 0 0-7.46 12.005h-1.47a.9.9 0 1 0 0 1.8h3.906a.9.9 0 0 0 .9-.9V10.357a.9.9 0 1 0-1.8 0v1.942a5.374 5.374 0 0 1 5.251-9.271.9.9 0 1 0 .673-1.67Zm3.197 2.874a.9.9 0 0 0-1.8 0v.008a.9.9 0 1 0 1.8 0V4.23Zm-5.096 9.085a.9.9 0 0 1 .9.9v.008a.9.9 0 0 1-1.8 0v-.008a.9.9 0 0 1 .9-.9Zm3.9-.327a.9.9 0 1 0-1.8 0v.008a.9.9 0 0 0 1.8 0v-.008Zm1.077-3.455a.9.9 0 0 1 .9.9v.008a.9.9 0 0 1-1.8 0v-.008a.9.9 0 0 1 .9-.9Zm1.345-2.303a.9.9 0 0 0-1.8 0v.008a.9.9 0 1 0 1.8 0V7.23Z",
  "clip-rule": "evenodd"
}, null, -1), Jv = [
  qv
], Qv = ["id"], eg = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), tg = [
  eg
];
function ng(t, e) {
  return p(), g("svg", Xv, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...Jv], 8, Kv),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...tg], 8, Qv)
    ])
  ]);
}
const og = I({ name: "icon-RotateLeftSm", render: ng, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), ig = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, rg = ["clip-path"], ag = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.284 1.357a7.175 7.175 0 0 1 7.46 12.005h1.47a.9.9 0 0 1 0 1.8h-3.906a.9.9 0 0 1-.9-.9V10.357a.9.9 0 1 1 1.8 0v1.942a5.375 5.375 0 0 0-5.251-9.271.9.9 0 0 1-.673-1.67ZM2.087 4.23a.9.9 0 0 1 1.8 0v.008a.9.9 0 1 1-1.8 0V4.23Zm5.096 9.085a.9.9 0 0 0-.9.9v.008a.9.9 0 0 0 1.8 0v-.008a.9.9 0 0 0-.9-.9Zm-3.9-.327a.9.9 0 1 1 1.8 0v.008a.9.9 0 1 1-1.8 0v-.008ZM2.206 9.534a.9.9 0 0 0-.9.9v.008a.9.9 0 0 0 1.8 0v-.008a.9.9 0 0 0-.9-.9ZM.861 7.231a.9.9 0 1 1 1.8 0v.008a.9.9 0 0 1-1.8 0V7.23Z",
  "clip-rule": "evenodd"
}, null, -1), sg = [
  ag
], lg = ["id"], dg = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), cg = [
  dg
];
function ug(t, e) {
  return p(), g("svg", ig, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...sg], 8, rg),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...cg], 8, lg)
    ])
  ]);
}
const hg = I({ name: "icon-RotateRightSm", render: ug, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), fg = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, mg = ["clip-path"], pg = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.972 1.476a1.12 1.12 0 0 1 2.056 0l-.664.292.664-.292 1.543 3.508 3.64.452c.998.125 1.287 1.332.641 1.958l-2.715 2.634.723 3.814c.164.865-.752 1.742-1.67 1.204L8 13.173l-3.19 1.873c-.917.538-1.833-.339-1.67-1.204l.724-3.814-2.716-2.634c-.645-.626-.357-1.833.641-1.958l3.64-.452 1.543-3.508.718.316-.718-.316ZM8 3.113 6.788 5.87a1.127 1.127 0 0 1-.891.668l-2.955.367 2.21 2.144c.283.274.399.668.328 1.04l-.577 3.047 2.533-1.487c.35-.205.78-.205 1.128 0l2.533 1.487-.577-3.046c-.07-.373.046-.767.328-1.04l2.21-2.145-2.954-.367a1.127 1.127 0 0 1-.891-.668L8 3.113Z",
  "clip-rule": "evenodd"
}, null, -1), _g = [
  pg
], vg = ["id"], gg = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), $g = [
  gg
];
function wg(t, e) {
  return p(), g("svg", fg, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [..._g], 8, mg),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...$g], 8, vg)
    ])
  ]);
}
const yg = I({ name: "icon-StarSm", render: wg, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Mg = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Cg = ["clip-path"], bg = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M5.408 11.6 8 9.008l2.592 2.592 1.008-1.008L9.008 8 11.6 5.408 10.592 4.4 8 6.992 5.408 4.4 4.4 5.408 6.992 8 4.4 10.592 5.408 11.6ZM8 15.2c-.996 0-1.932-.19-2.808-.567a7.282 7.282 0 0 1-2.286-1.539 7.266 7.266 0 0 1-1.539-2.286A7.024 7.024 0 0 1 .8 8c0-.996.189-1.932.567-2.808a7.282 7.282 0 0 1 1.539-2.286 7.266 7.266 0 0 1 2.286-1.539A7.024 7.024 0 0 1 8 .8c.996 0 1.932.19 2.808.567a7.282 7.282 0 0 1 2.286 1.539 7.277 7.277 0 0 1 1.54 2.286c.377.876.566 1.812.566 2.808 0 .996-.19 1.932-.568 2.808a7.282 7.282 0 0 1-1.538 2.286 7.277 7.277 0 0 1-2.286 1.54A6.999 6.999 0 0 1 8 15.2Zm0-1.44c1.608 0 2.97-.558 4.086-1.674C13.202 10.97 13.76 9.608 13.76 8s-.558-2.97-1.674-4.086C10.97 2.798 9.608 2.24 8 2.24s-2.97.558-4.086 1.674C2.798 5.03 2.24 6.392 2.24 8s.558 2.97 1.674 4.086C5.03 13.202 6.392 13.76 8 13.76Z"
}, null, -1), xg = [
  bg
], Sg = ["id"], Ig = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Ag = [
  Ig
];
function kg(t, e) {
  return p(), g("svg", Mg, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...xg], 8, Cg),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Ag], 8, Sg)
    ])
  ]);
}
const Eg = I({ name: "icon-CancelSm", render: kg, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Pg = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tg = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.536 4.578c.261.125.426.38.426.659v5.526c0 .407-.345.737-.77.737-.424 0-.769-.33-.769-.737V6.711l-.692.497A.792.792 0 0 1 .654 7.06a.717.717 0 0 1 .154-1.032L2.73 4.647a.797.797 0 0 1 .805-.07Zm1.772.659c0-.407.344-.737.769-.737H8.24c.396 0 .775.15 1.054.418.28.268.437.631.437 1.01v1.381c0 .379-.157.742-.437 1.01-.28.267-.658.418-1.054.418H6.846v1.29h2.116c.424 0 .769.33.769.736 0 .407-.345.737-.77.737H6.799c-.395 0-.774-.15-1.054-.418a1.398 1.398 0 0 1-.436-1.01V8.691c0-.379.157-.742.436-1.01.28-.267.659-.418 1.054-.418h1.394v-1.29H6.077c-.425 0-.77-.33-.77-.736Zm5.769 0c0-.407.344-.737.77-.737h1.802c.49 0 .962.187 1.309.52.347.332.542.783.542 1.253v.69c0 .375-.123.737-.349 1.037.226.3.349.662.349 1.036v.691c0 .47-.195.921-.542 1.254-.347.332-.818.519-1.309.519h-1.803c-.425 0-.77-.33-.77-.737s.345-.737.77-.737h1.803a.32.32 0 0 0 .221-.087.293.293 0 0 0 .091-.212v-.69a.293.293 0 0 0-.091-.212.32.32 0 0 0-.221-.088h-1.082c-.425 0-.769-.33-.769-.737s.345-.737.77-.737h1.081a.32.32 0 0 0 .221-.088.293.293 0 0 0 .091-.211v-.691a.293.293 0 0 0-.091-.212.32.32 0 0 0-.221-.087h-1.803c-.425 0-.77-.33-.77-.737Z",
  fill: "currentColor"
}, null, -1), Og = [
  Tg
];
function Lg(t, e) {
  return p(), g("svg", Pg, [...Og]);
}
const Dg = I({ name: "icon-NumbersSm", render: Lg }), Ng = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rg = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.377 8a5.623 5.623 0 1 1 11.246 0A5.623 5.623 0 0 1 2.377 8ZM8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Z",
  fill: "currentColor"
}, null, -1), Zg = /* @__PURE__ */ h("path", {
  d: "M11.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z",
  fill: "currentColor"
}, null, -1), Bg = [
  Rg,
  Zg
];
function Vg(t, e) {
  return p(), g("svg", Ng, [...Bg]);
}
const Fg = I({ name: "icon-RadioButtonSm", render: Vg }), Hg = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ug = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 2.556c-.374 0-.763.17-1.07.525-.31.359-.501.868-.501 1.419v1.944H9.57V4.5c0-.551-.19-1.06-.5-1.419-.308-.355-.697-.525-1.071-.525Zm3.143 3.888V4.5c0-.893-.306-1.769-.88-2.431C9.687 1.403 8.876 1 8 1c-.876 0-1.687.403-2.263 1.069-.574.662-.88 1.538-.88 2.431v1.944h-.224c-.579 0-1.125.24-1.522.652-.395.41-.611.96-.611 1.526v4.2c0 .566.216 1.116.611 1.527.397.412.943.651 1.522.651h6.734a2.11 2.11 0 0 0 1.522-.651c.395-.411.611-.961.611-1.527v-4.2c0-.565-.216-1.115-.611-1.526a2.11 2.11 0 0 0-1.522-.652h-.224ZM4.633 8a.532.532 0 0 0-.384.169.655.655 0 0 0-.178.453v4.2c0 .177.068.34.178.454a.532.532 0 0 0 .384.168h6.734a.532.532 0 0 0 .384-.168.655.655 0 0 0 .178-.454v-4.2a.655.655 0 0 0-.178-.453.532.532 0 0 0-.384-.169H4.633Zm2.256 1.622a1.58 1.58 0 0 1 2.222 0 1.548 1.548 0 0 1 0 2.2 1.58 1.58 0 0 1-2.222 0 1.548 1.548 0 0 1 0-2.2Z",
  fill: "currentColor"
}, null, -1), zg = [
  Ug
];
function Wg(t, e) {
  return p(), g("svg", Hg, [...zg]);
}
const jg = I({ name: "icon-LockSm", render: Wg }), Gg = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yg = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.637 3.125c-.94 0-1.84.365-2.503 1.014A3.412 3.412 0 0 0 4.1 6.579V8a.818.818 0 0 1-.823.813A.818.818 0 0 1 2.453 8V6.578c0-1.349.548-2.641 1.52-3.593A5.238 5.238 0 0 1 7.638 1.5c1.372 0 2.69.533 3.662 1.485a5.037 5.037 0 0 1 1.496 3.09l.802-.785a.831.831 0 0 1 1.164.005.805.805 0 0 1-.005 1.15l-2.18 2.132a.831.831 0 0 1-1.16 0l-2.18-2.133a.805.805 0 0 1-.004-1.149.831.831 0 0 1 1.165-.005l.726.711a3.426 3.426 0 0 0-.983-1.862 3.58 3.58 0 0 0-2.503-1.014Zm-5.968 7.558a2.299 2.299 0 0 1 1.608-.652c.601 0 1.18.234 1.607.652.428.419.67.988.67 1.583 0 .594-.242 1.164-.67 1.582a2.3 2.3 0 0 1-1.607.652 2.3 2.3 0 0 1-1.608-.652A2.214 2.214 0 0 1 1 12.266c0-.595.242-1.164.67-1.583Zm1.608.973a.64.64 0 0 0-.448.181.6.6 0 0 0 0 .857.64.64 0 0 0 .896 0 .6.6 0 0 0 0-.857.64.64 0 0 0-.448-.18Zm7.112-.973a2.299 2.299 0 0 1 1.607-.652c.602 0 1.18.234 1.608.652.428.419.67.988.67 1.583 0 .594-.242 1.164-.67 1.582a2.3 2.3 0 0 1-1.607.652 2.3 2.3 0 0 1-1.608-.652 2.214 2.214 0 0 1-.67-1.582c0-.595.242-1.164.67-1.583Zm1.607.973a.64.64 0 0 0-.447.181.6.6 0 0 0 0 .857.64.64 0 0 0 .895 0 .6.6 0 0 0 .182-.428.6.6 0 0 0-.182-.429.64.64 0 0 0-.448-.18Z",
  fill: "currentColor"
}, null, -1), Xg = [
  Yg
];
function Kg(t, e) {
  return p(), g("svg", Gg, [...Xg]);
}
const qg = I({ name: "icon-StagesSm", render: Kg }), Jg = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qg = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.335 3.333a2.58 2.58 0 0 1 2.169.246c.124.075.243.16.356.255L4.515 5.822A1.513 1.513 0 0 0 4 6.954c0 .427.183.824.487 1.108l.432.4a2.28 2.28 0 0 0 3.074 0l.794-.738c.32-.297.765-.474 1.24-.474.477 0 .922.177 1.242.474l.003.003 1.072.986-.446.466-1.079-1.08a.8.8 0 1 0-1.131 1.132l1.103 1.104-1.229 1.283-1.082-1.082a.8.8 0 1 0-1.13 1.132l1.105 1.106-.449.47L3.253 8.28l-.004-.005a2.965 2.965 0 0 1-.64-1.004 3.128 3.128 0 0 1 .06-2.391c.164-.371.4-.699.687-.964a2.71 2.71 0 0 1 .98-.583Zm8.992 4.11a3.128 3.128 0 0 0 .005-2.55c-.166-.368-.4-.695-.686-.96a2.71 2.71 0 0 0-.976-.581 2.58 2.58 0 0 0-2.163.237 2.82 2.82 0 0 0-.85.787.8.8 0 0 1-.166.172l-.012.011-2.83 2.398.36.334a.68.68 0 0 0 .894 0l.794-.738a3.425 3.425 0 0 1 2.33-.903c.864 0 1.703.318 2.33.901l.002.002.968.89Zm-4.743 7.51 5.28-5.513a4.567 4.567 0 0 0 1.027-1.59 4.73 4.73 0 0 0-.098-3.608 4.537 4.537 0 0 0-1.061-1.484 4.31 4.31 0 0 0-1.553-.923 4.18 4.18 0 0 0-3.491.38 4.358 4.358 0 0 0-.678.5 4.36 4.36 0 0 0-.68-.507 4.18 4.18 0 0 0-3.5-.392 4.31 4.31 0 0 0-1.56.924c-.45.416-.812.924-1.064 1.49a4.728 4.728 0 0 0-.09 3.618c.222.576.557 1.101.984 1.54l5.328 5.565a.8.8 0 0 0 1.156 0Z",
  fill: "currentColor"
}, null, -1), e$ = [
  Qg
];
function t$(t, e) {
  return p(), g("svg", Jg, [...e$]);
}
const n$ = I({ name: "icon-HeartHandshakeSm", render: t$ }), o$ = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, i$ = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.111 3.714c-.412 0-.808.18-1.1.502a1.807 1.807 0 0 0-.455 1.213V8h3.11V5.429c0-.455-.163-.891-.455-1.213a1.486 1.486 0 0 0-1.1-.502ZM7.222 5.43c0-.91-.328-1.782-.911-2.425C5.728 2.361 4.936 2 4.111 2c-.825 0-1.616.361-2.2 1.004A3.614 3.614 0 0 0 1 5.43v7.714c0 .473.348.857.778.857.43 0 .778-.384.778-.857V9.714h3.11v3.429c0 .473.349.857.778.857.43 0 .778-.384.778-.857V5.429ZM9.689 8.147c.583-.643 1.375-1.004 2.2-1.004a2.9 2.9 0 0 1 1.624.504c.122-.297.394-.504.71-.504.429 0 .777.384.777.857v5.143c0 .473-.348.857-.778.857-.315 0-.587-.207-.709-.504A2.9 2.9 0 0 1 11.89 14c-.825 0-1.617-.361-2.2-1.004a3.614 3.614 0 0 1-.911-2.425c0-.909.328-1.781.911-2.424Zm2.2.71c-.413 0-.808.18-1.1.502a1.807 1.807 0 0 0-.456 1.212c0 .455.164.891.456 1.213.292.321.687.502 1.1.502.412 0 .808-.18 1.1-.502.292-.322.455-.758.455-1.213 0-.454-.163-.89-.455-1.212a1.486 1.486 0 0 0-1.1-.502Z",
  fill: "currentColor"
}, null, -1), r$ = [
  i$
];
function a$(t, e) {
  return p(), g("svg", o$, [...r$]);
}
const s$ = I({ name: "icon-TextSm", render: a$ }), l$ = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, d$ = /* @__PURE__ */ h("path", {
  d: "M6.324 13.6a.397.397 0 0 1-.394-.4v-.8c0-.22.176-.4.394-.4h8.282c.217 0 .394.18.394.4v.8c0 .22-.177.4-.394.4H6.324Zm0-4.8a.397.397 0 0 1-.394-.4v-.8c0-.22.176-.4.394-.4h8.282c.217 0 .394.18.394.4v.8c0 .22-.177.4-.394.4H6.324Zm0-4.8a.397.397 0 0 1-.394-.4v-.8c0-.22.176-.4.394-.4h8.282c.217 0 .394.18.394.4v.8c0 .22-.177.4-.394.4H6.324Z",
  fill: "currentColor"
}, null, -1), c$ = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.736 2.199a.659.659 0 0 1 0 .96L3.158 4.67a.733.733 0 0 1-1.004 0l-.946-.905a.659.659 0 0 1 0-.961.733.733 0 0 1 1.004 0l.444.425L3.732 2.2a.733.733 0 0 1 1.004 0ZM4.736 6.789a.659.659 0 0 1 0 .96L3.158 9.26a.733.733 0 0 1-1.004 0l-.946-.906a.659.659 0 0 1 0-.96.733.733 0 0 1 1.004 0l.444.425 1.076-1.03a.733.733 0 0 1 1.004 0ZM4.736 11.33a.659.659 0 0 1 0 .961l-1.578 1.51a.733.733 0 0 1-1.004 0l-.946-.906a.659.659 0 0 1 0-.96.732.732 0 0 1 1.004 0l.444.425 1.076-1.03a.732.732 0 0 1 1.004 0Z",
  fill: "currentColor"
}, null, -1), u$ = [
  d$,
  c$
];
function h$(t, e) {
  return p(), g("svg", l$, [...u$]);
}
const f$ = I({ name: "icon-ListCheckSm", render: h$ }), m$ = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p$ = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.54 3.03a.51.51 0 0 0-.51.51v8.92a.51.51 0 0 0 .51.51h8.92a.51.51 0 0 0 .51-.51V3.54a.51.51 0 0 0-.51-.51H3.54Zm-1.443-.933A2.04 2.04 0 0 1 3.54 1.5h8.922A2.04 2.04 0 0 1 14.5 3.54v8.92a2.039 2.039 0 0 1-2.04 2.04H3.54a2.039 2.039 0 0 1-2.04-2.04V3.54c0-.542.215-1.06.597-1.443Zm9.311 3.45a.765.765 0 0 1 0 1.082l-3.823 3.824a.765.765 0 0 1-1.082 0L4.592 8.54a.765.765 0 0 1 1.081-1.082L7.044 8.83l3.283-3.282a.765.765 0 0 1 1.081 0Z",
  fill: "currentColor"
}, null, -1), _$ = [
  p$
];
function v$(t, e) {
  return p(), g("svg", m$, [..._$]);
}
const g$ = I({ name: "icon-SquareCheckSm", render: v$ }), $$ = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, w$ = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.503 5c-.79 0-1.55.314-2.111.876a3.005 3.005 0 0 0 0 4.248c.56.562 1.32.876 2.11.876h4.995c.79 0 1.55-.314 2.111-.876a3.006 3.006 0 0 0 0-4.248A2.984 2.984 0 0 0 10.498 5H5.502Zm-3.187-.18A4.504 4.504 0 0 1 5.503 3.5h4.994A4.504 4.504 0 0 1 15 8a4.499 4.499 0 0 1-4.503 4.5H5.503A4.504 4.504 0 0 1 1 8c0-1.191.473-2.335 1.316-3.18ZM8.665 6.41a2.28 2.28 0 0 1 3.21 0 2.24 2.24 0 0 1 0 3.182 2.28 2.28 0 0 1-3.21 0 2.24 2.24 0 0 1 0-3.182Zm1.605.841a.76.76 0 0 0-.535.22.747.747 0 0 0 0 1.06.76.76 0 0 0 1.07 0 .747.747 0 0 0 0-1.06.76.76 0 0 0-.535-.22Z",
  fill: "currentColor"
}, null, -1), y$ = [
  w$
];
function M$(t, e) {
  return p(), g("svg", $$, [...y$]);
}
const C$ = I({ name: "icon-ToggleSm", render: M$ }), b$ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, x$ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.774.5C5.61.5 3.855 2.267 3.855 4.447s1.755 3.948 3.92 3.948c2.164 0 3.918-1.768 3.918-3.948C11.693 2.267 9.94.5 7.774.5ZM5.423 4.447A2.36 2.36 0 0 1 7.774 2.08a2.36 2.36 0 0 1 2.352 2.368 2.36 2.36 0 0 1-2.352 2.369 2.36 2.36 0 0 1-2.351-2.369Z",
  "clip-rule": "evenodd"
}, null, -1), S$ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M4.701 10.178a.794.794 0 0 0 .085-1.113.78.78 0 0 0-1.105-.085c-2.658 2.294-2.568 4.94-1.416 6.093.387.388.888.427 1.165.427h5.166a.787.787 0 0 0 .784-.79c0-.436-.35-.789-.784-.789H3.43a.782.782 0 0 1-.083-.004l-.01-.001c-.288-.36-.78-1.886 1.364-3.738Z"
}, null, -1), I$ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m12.473 9.823-.24.475a.784.784 0 0 1-.588.425l-.49.069.339.323c.19.182.278.449.233.71l-.085.484.475-.245a.779.779 0 0 1 .713 0l.475.245-.085-.484a.793.793 0 0 1 .233-.71l.338-.323-.489-.07a.784.784 0 0 1-.589-.424l-.24-.475Zm-.54-2.066a1.039 1.039 0 0 1 1.468.418v.002l.525 1.04 1.18.168h.001a1.038 1.038 0 0 1 .862 1.282 1.04 1.04 0 0 1-.289.498l-.002.001-.841.803.197 1.127a1.041 1.041 0 0 1-.952 1.217 1.038 1.038 0 0 1-.548-.113l-1.06-.546-1.065.547a1.039 1.039 0 0 1-1.499-1.095l.002-.01.198-1.127-.84-.801-.001-.001a1.04 1.04 0 0 1 .572-1.782l1.18-.168.525-1.042a1.04 1.04 0 0 1 .387-.418Z",
  "clip-rule": "evenodd"
}, null, -1), A$ = [
  x$,
  S$,
  I$
];
function k$(t, e) {
  return p(), g("svg", b$, [...A$]);
}
const E$ = I({ name: "icon-UserStarSm", render: k$ }), P$ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, T$ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.54 2.696A5.507 5.507 0 0 0 2.55 7.25h2.362a9.859 9.859 0 0 1 1.629-4.555Zm2.92 0A9.86 9.86 0 0 1 11.09 7.25h2.362a5.506 5.506 0 0 0-3.99-4.555Zm.12 4.555A8.359 8.359 0 0 0 8 3.227a8.359 8.359 0 0 0-1.58 4.024h3.16Zm-3.16 1.5h3.16A8.359 8.359 0 0 1 8 12.774a8.359 8.359 0 0 1-1.58-4.023Zm-1.508 0H2.551a5.507 5.507 0 0 0 3.99 4.555A9.859 9.859 0 0 1 4.912 8.75Zm4.549 4.555a9.86 9.86 0 0 0 1.628-4.555h2.362a5.507 5.507 0 0 1-3.99 4.555ZM1 8a7 7 0 1 1 14.001 0A7 7 0 0 1 1 8Z",
  "clip-rule": "evenodd"
}, null, -1), O$ = [
  T$
];
function L$(t, e) {
  return p(), g("svg", P$, [...O$]);
}
const D$ = I({ name: "icon-WorldSm", render: L$ }), N$ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, R$ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.766 3.766a.8.8 0 1 0-1.132-1.132l-2 2a.8.8 0 0 0 0 1.132l2 2a.8.8 0 1 0 1.132-1.132L5.13 6H12.8a.8.8 0 0 0 0-1.6H5.13l.635-.634ZM10.868 10l-.634-.634a.8.8 0 0 1 1.132-1.132l2 2a.8.8 0 0 1 0 1.132l-2 2a.8.8 0 0 1-1.132-1.132l.634-.634H3.2a.8.8 0 0 1 0-1.6h7.668Z",
  "clip-rule": "evenodd"
}, null, -1), Z$ = [
  R$
];
function B$(t, e) {
  return p(), g("svg", N$, [...Z$]);
}
const V$ = I({ name: "icon-ArrowLeftRightSm", render: B$ }), F$ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, H$ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M1.498 5.442a.75.75 0 0 1 1.06.056C4.015 7.118 5.812 7.917 8 7.917s3.985-.8 5.443-2.419a.75.75 0 0 1 1.115 1.004 9.477 9.477 0 0 1-1.21 1.133l1.278 1.936a.75.75 0 0 1-1.252.826L12.09 8.45a8.16 8.16 0 0 1-1.613.64l.268 2.15a.75.75 0 1 1-1.488.186l-.257-2.059a9.882 9.882 0 0 1-1.997 0l-.258 2.06a.75.75 0 1 1-1.488-.187l.269-2.15a8.162 8.162 0 0 1-1.61-.637l-1.288 1.96a.75.75 0 0 1-1.253-.825l1.282-1.95a9.468 9.468 0 0 1-1.213-1.136.75.75 0 0 1 .055-1.06Z"
}, null, -1), U$ = [
  H$
];
function z$(t, e) {
  return p(), g("svg", F$, [...U$]);
}
const W$ = I({ name: "icon-EyeClosedSm", render: z$ }), j$ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, G$ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 5.917a2.083 2.083 0 1 0 0 4.166 2.083 2.083 0 0 0 0-4.166Zm-.412 1.67a.583.583 0 1 1 .825.825.583.583 0 0 1-.825-.824Z",
  "clip-rule": "evenodd"
}, null, -1), Y$ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 3.25c-2.742 0-4.953 1.548-6.643 4.364a.75.75 0 0 0 0 .772C3.047 11.202 5.258 12.75 8 12.75s4.953-1.548 6.643-4.364a.75.75 0 0 0 0-.772C12.953 4.798 10.742 3.25 8 3.25Zm0 8c-1.95 0-3.658-1.004-5.116-3.25C4.342 5.754 6.05 4.75 8 4.75c1.95 0 3.658 1.004 5.116 3.25C11.658 10.246 9.95 11.25 8 11.25Z",
  "clip-rule": "evenodd"
}, null, -1), X$ = [
  G$,
  Y$
];
function K$(t, e) {
  return p(), g("svg", j$, [...X$]);
}
const q$ = I({ name: "icon-EyeSm", render: K$ }), J$ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Q$ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.8 3.2a1.6 1.6 0 0 1 1.6-1.6h4.8a1.6 1.6 0 0 1 1.28.64l.72.96H14a1.2 1.2 0 0 1 1.2 1.2v8.8a1.2 1.2 0 0 1-1.2 1.2H2a1.2 1.2 0 0 1-1.2-1.2v-10Zm8.01 1.6H2.4v8h11.2v-8H8.81Z",
  "clip-rule": "evenodd"
}, null, -1), ew = [
  Q$
];
function tw(t, e) {
  return p(), g("svg", J$, [...ew]);
}
const nw = I({ name: "icon-FolderSm", render: tw }), ow = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, iw = ["clip-path"], rw = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M11.772 5.813a17.49 17.49 0 0 0-.768-.83l-.2-.185.097-.082a2.16 2.16 0 0 0 .617-2.393A2.68 2.68 0 0 0 9.029.801v1.371a1.371 1.371 0 0 1 1.207.686c.116.274 0 .576-.322.898-.048.055-.103.09-.151.137-2.057-1.652-4.313-2.585-5.417-1.48a1.48 1.48 0 0 0-.28.404v.068l-.124.364L.918 12.23A2.249 2.249 0 0 0 3.05 15.2a2.2 2.2 0 0 0 .686-.117l9.407-3.12a.685.685 0 0 0 .295-.212l.144-.123c.98-.988.35-2.887-.967-4.731a4.545 4.545 0 0 1 2.585-.61V4.914a5.786 5.786 0 0 0-3.428.898Zm-8.434 7.968a.885.885 0 0 1-1.117-1.118l.932-2.811a7.337 7.337 0 0 0 2.942 3.01l-2.757.919Zm4.8-1.598a6.082 6.082 0 0 1-4.32-4.313l.686-2.057.041.062c.076.15.172.308.268.466.096.158.11.199.178.302.068.103.226.329.35.5.123.172.13.192.205.288.076.096.295.377.453.563l.198.24c.234.267.48.528.741.795.26.267.466.439.686.686l.226.192.535.432.253.192c.192.137.377.274.57.397l.212.137c.247.151.494.295.734.419h.034l-2.05.7Zm4.463-1.529h-.04c-.474.26-2.442-.39-4.656-2.612-.233-.234-.453-.46-.652-.686l-.198-.24-.364-.439-.199-.274c-.089-.13-.185-.254-.267-.377l-.178-.288-.2-.323c-.054-.096-.095-.185-.143-.274-.048-.089-.103-.178-.144-.274a2.27 2.27 0 0 1-.096-.247c-.034-.089-.076-.178-.103-.26-.027-.083-.034-.13-.055-.213a4.45 4.45 0 0 1-.048-.22 1.55 1.55 0 0 1 0-.178.686.686 0 0 1 0-.164l.076-.213c.246-.247 1.529 0 3.243 1.303-.29.131-.602.212-.92.24v1.371a4.422 4.422 0 0 0 2.058-.644l.329.315c.288.288.555.583.809.878a3.649 3.649 0 0 0-.412 2.331l1.372-.267a2.448 2.448 0 0 1 0-.768c.21.317.395.65.555.994.384.905.357 1.412.233 1.529Z"
}, null, -1), aw = [
  rw
], sw = ["id"], lw = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), dw = [
  lw
];
function cw(t, e) {
  return p(), g("svg", ow, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...aw], 8, iw),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...dw], 8, sw)
    ])
  ]);
}
const uw = I({ name: "icon-PartySm", render: cw, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), hw = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, fw = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.722 1.718a.8.8 0 0 1 1.132 0l2.143 2.143a.795.795 0 0 1 .226.682.796.796 0 0 1-.226.45l-2.143 2.144a.8.8 0 0 1-1.132-1.132l.778-.778h-1.924a2.773 2.773 0 0 0-2.272 1.184l-.365.522c-.29.416-.65.777-1.063 1.068.41.29.77.65 1.06 1.064l.367.525a2.773 2.773 0 0 0 2.272 1.183H12.5l-.778-.778a.8.8 0 0 1 1.132-1.132l2.143 2.144a.796.796 0 0 1 .227.674.797.797 0 0 1-.227.458l-2.143 2.143a.8.8 0 0 1-1.132-1.131l.778-.778h-1.925a4.373 4.373 0 0 1-3.582-1.865l-.368-.525A2.773 2.773 0 0 0 4.367 8.8H1.569a.8.8 0 0 1-.8-.8.8.8 0 0 1 .8-.8h2.798a2.773 2.773 0 0 0 2.26-1.184l.365-.521a4.373 4.373 0 0 1 3.584-1.868H12.5l-.778-.778a.8.8 0 0 1 0-1.131Z",
  "clip-rule": "evenodd"
}, null, -1), mw = [
  fw
];
function pw(t, e) {
  return p(), g("svg", hw, [...mw]);
}
const _w = I({ name: "icon-ConditionSm", render: pw }), vw = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, gw = ["clip-path"], $w = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.488.8a6.1 6.1 0 0 0-4.305 1.776A6.05 6.05 0 0 0 .4 6.863c0 2.245 1.107 3.939 2.668 5.258 1.56 1.318 3.574 2.264 5.395 3.018a.788.788 0 0 0 1.089-.73v-1.483a6.1 6.1 0 0 0 4.265-1.776A6.05 6.05 0 0 0 15.6 6.863a6.05 6.05 0 0 0-1.783-4.287A6.1 6.1 0 0 0 9.512.8H6.488Zm-3.18 2.897a4.506 4.506 0 0 1 3.18-1.312h3.024a4.513 4.513 0 0 1 3.18 1.312 4.476 4.476 0 0 1 1.316 3.166 4.46 4.46 0 0 1-1.317 3.166 4.497 4.497 0 0 1-3.179 1.312h-.756a.794.794 0 0 0-.796.792v1.053c-2.063-.937-3.551-1.844-4.526-2.85-.982-1.012-1.442-2.125-1.442-3.473 0-1.188.473-2.326 1.316-3.166Zm5.359 2.526 1.306 1.09a.667.667 0 0 0 .854-1.025l-2.4-2a.667.667 0 0 0-.854 0l-2.4 2a.667.667 0 0 0 .854 1.024l1.306-1.089V9.6a.667.667 0 1 0 1.334 0V6.223Z",
  "clip-rule": "evenodd"
}, null, -1), ww = [
  $w
], yw = ["id"], Mw = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Cw = [
  Mw
];
function bw(t, e) {
  return p(), g("svg", vw, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...ww], 8, gw),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Cw], 8, yw)
    ])
  ]);
}
const xw = I({ name: "icon-OutgoingChatSm", render: bw, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Sw = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Iw = ["clip-path"], Aw = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.488.8a6.1 6.1 0 0 0-4.305 1.776A6.05 6.05 0 0 0 .4 6.863c0 2.245 1.107 3.939 2.668 5.258 1.56 1.318 3.574 2.264 5.395 3.018a.788.788 0 0 0 1.089-.73v-1.483a6.1 6.1 0 0 0 4.265-1.776A6.05 6.05 0 0 0 15.6 6.863a6.05 6.05 0 0 0-1.783-4.287A6.1 6.1 0 0 0 9.512.8H6.488Zm-3.18 2.897a4.506 4.506 0 0 1 3.18-1.312h3.024a4.513 4.513 0 0 1 3.18 1.312 4.476 4.476 0 0 1 1.316 3.166 4.46 4.46 0 0 1-1.317 3.166 4.497 4.497 0 0 1-3.179 1.312h-.756a.794.794 0 0 0-.796.792v1.053c-2.063-.937-3.551-1.844-4.526-2.85-.982-1.012-1.442-2.125-1.442-3.473 0-1.188.473-2.326 1.316-3.166Zm4.025 4.48V4.8a.667.667 0 1 1 1.334 0v3.377l1.306-1.09a.667.667 0 0 1 .854 1.025l-2.4 2a.667.667 0 0 1-.854 0l-2.4-2a.667.667 0 0 1 .854-1.024l1.306 1.089Z",
  "clip-rule": "evenodd"
}, null, -1), kw = [
  Aw
], Ew = ["id"], Pw = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}, null, -1), Tw = [
  Pw
];
function Ow(t, e) {
  return p(), g("svg", Sw, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...kw], 8, Iw),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Tw], 8, Ew)
    ])
  ]);
}
const Lw = I({ name: "icon-IncomingChatSm", render: Ow, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Dw = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Nw = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.99.907a.8.8 0 0 1 .545.758v4.127h3.607a.8.8 0 0 1 .637 1.284l-5.876 7.743a.8.8 0 0 1-1.437-.484v-4.127H2.859a.8.8 0 0 1-.638-1.284l5.876-7.743A.8.8 0 0 1 8.99.907Zm-4.52 7.7h2.796a.8.8 0 0 1 .8.8v2.55l3.464-4.565H8.735a.8.8 0 0 1-.8-.8v-2.55L4.47 8.608Z",
  "clip-rule": "evenodd"
}, null, -1), Rw = [
  Nw
];
function Zw(t, e) {
  return p(), g("svg", Dw, [...Rw]);
}
const Bw = I({ name: "icon-LightningSm", render: Zw }), Vw = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Fw = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.774.5C5.61.5 3.855 2.267 3.855 4.447s1.755 3.948 3.92 3.948c2.164 0 3.918-1.768 3.918-3.948C11.693 2.267 9.94.5 7.774.5ZM5.423 4.447A2.36 2.36 0 0 1 7.774 2.08a2.36 2.36 0 0 1 2.352 2.368 2.36 2.36 0 0 1-2.352 2.369 2.36 2.36 0 0 1-2.351-2.369Z",
  "clip-rule": "evenodd"
}, null, -1), Hw = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M4.701 10.178a.794.794 0 0 0 .085-1.113.78.78 0 0 0-1.105-.085c-2.658 2.294-2.568 4.94-1.416 6.093.387.388.888.427 1.165.427h5.166a.787.787 0 0 0 .784-.79c0-.436-.35-.789-.784-.789H3.43a.782.782 0 0 1-.083-.004l-.01-.001c-.288-.36-.78-1.886 1.364-3.738Z"
}, null, -1), Uw = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.452 9.202a3.25 3.25 0 1 1 4.596 4.596 3.25 3.25 0 0 1-4.596-4.596Zm2.298.548a1.75 1.75 0 0 0-1.649 2.336l2.235-2.235a1.75 1.75 0 0 0-.586-.101Zm1.648 1.16-2.238 2.238a1.749 1.749 0 0 0 2.238-2.238Z",
  "clip-rule": "evenodd"
}, null, -1), zw = [
  Fw,
  Hw,
  Uw
];
function Ww(t, e) {
  return p(), g("svg", Vw, [...zw]);
}
const jw = I({ name: "icon-UserCancelSm", render: Ww }), Gw = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Yw = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.6 0a2.401 2.401 0 0 0-2.263 1.6H2.4A2.4 2.4 0 0 0 0 4v9.6A2.4 2.4 0 0 0 2.4 16h3.493c.51 0 .844-.557.7-1.047-.09-.31-.364-.553-.687-.553H2.4a.8.8 0 0 1-.8-.8V4a.8.8 0 0 1 .8-.8h.937c.329.932 1.218 1.6 2.263 1.6h1.6a2.401 2.401 0 0 0 2.263-1.6h.937a.8.8 0 0 1 .8.8v1.906c0 .323.243.596.553.687.49.144 1.047-.19 1.047-.7V4a2.4 2.4 0 0 0-2.4-2.4h-.937A2.401 2.401 0 0 0 7.2 0H5.6Zm-.8 2.4a.8.8 0 0 1 .8-.8h1.6a.8.8 0 1 1 0 1.6H5.6a.8.8 0 0 1-.8-.8Z",
  "clip-rule": "evenodd"
}, null, -1), Xw = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M13.124 7.026a.554.554 0 0 1 .752.003l.928.885c.315.3.315.786 0 1.086l-.928.885a.554.554 0 0 1-.752.003.493.493 0 0 1-.004-.725l.205-.194H8.718v1.279c0 .283-.24.512-.537.512a.525.525 0 0 1-.537-.512V8.713c0-.424.36-.768.806-.768h4.875l-.205-.194a.493.493 0 0 1 .004-.725ZM13.684 12.156c0-.283.24-.512.537-.512.296 0 .537.23.537.512v1.536c0 .424-.36.767-.806.767H9.08l.198.185c.213.2.214.525.003.726-.21.2-.55.2-.76 0l-.927-.892a.743.743 0 0 1 .002-1.083l.93-.887a.553.553 0 0 1 .753-.004.493.493 0 0 1 .003.725l-.204.195h4.606v-1.268Z"
}, null, -1), Kw = [
  Yw,
  Xw
];
function qw(t, e) {
  return p(), g("svg", Gw, [...Kw]);
}
const Jw = I({ name: "icon-RepeatTaskSm", render: qw }), Qw = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, ey = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M3.8 0a.8.8 0 0 0-.8.8V3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3.2a.8.8 0 0 0 0-1.6H3a.4.4 0 0 1-.4-.4V5c0-.22.18-.4.4-.4h10c.22 0 .4.045.4.266 0 .295.239.534.534.534h.532A.534.534 0 0 0 15 4.866C15 3.762 14.105 3 13 3h-.002V.8a.8.8 0 1 0-1.6 0V3H4.6V.8a.8.8 0 0 0-.8-.8Z"
}, null, -1), ty = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M13.924 6.226a.554.554 0 0 1 .752.003l.928.885c.315.3.315.786 0 1.086l-.928.885a.554.554 0 0 1-.752.003.493.493 0 0 1-.004-.725l.205-.194H9.518v1.279c0 .283-.24.512-.537.512a.525.525 0 0 1-.537-.512V7.913c0-.424.36-.768.806-.768h4.875l-.205-.194a.493.493 0 0 1 .004-.725ZM14.484 11.356c0-.283.24-.512.537-.512.296 0 .537.23.537.512v1.536c0 .424-.36.767-.806.767H9.88l.198.185c.213.2.214.525.003.726-.21.2-.55.2-.76 0l-.927-.892a.743.743 0 0 1 .002-1.084l.93-.886a.553.553 0 0 1 .753-.004.493.493 0 0 1 .003.725l-.204.195h4.606v-1.268Z"
}, null, -1), ny = [
  ey,
  ty
];
function oy(t, e) {
  return p(), g("svg", Qw, [...ny]);
}
const iy = I({ name: "icon-RepeatEventSm", render: oy }), ry = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ay = /* @__PURE__ */ h("path", {
  d: "M5.874 2.489c0-.452-.567-.661-.866-.319L.74 6.859A.802.802 0 0 0 .739 8l4.264 4.565c.322.318.87.093.87-.357V9.771c3.253 0 6.437 1.64 8.761 4.055.38.394 1.031.064.827-.441-1.56-3.863-4.85-7.708-9.587-8.378",
  fill: "currentColor"
}, null, -1), sy = [
  ay
];
function ly(t, e) {
  return p(), g("svg", ry, [...sy]);
}
const dy = I({ name: "icon-FilledReplySm", render: ly }), cy = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, uy = ["clip-path"], hy = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.657 13.657A8 8 0 1 1 2.343 2.342a8 8 0 0 1 11.314 11.315ZM6.656 8l3.575-3.475a.88.88 0 0 0 .269-.632.88.88 0 0 0-.27-.631A.933.933 0 0 0 9.58 3a.933.933 0 0 0-.65.262l-4.116 4a1.022 1.022 0 0 0 0 1.475l4.117 4.001a.933.933 0 0 0 .65.262.933.933 0 0 0 .65-.262.88.88 0 0 0 .269-.631.88.88 0 0 0-.27-.632L6.657 8Z",
  "clip-rule": "evenodd"
}, null, -1), fy = [
  hy
], my = ["id"], py = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 16h16V0H0z"
}, null, -1), _y = [
  py
];
function vy(t, e) {
  return p(), g("svg", cy, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...fy], 8, uy),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [..._y], 8, my)
    ])
  ]);
}
const gy = I({ name: "icon-FilledArrowLeftSm", render: vy, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), $y = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, wy = ["clip-path"], yy = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.343 13.657A8 8 0 1 0 13.657 2.343 8 8 0 0 0 2.343 13.657ZM9.344 8 5.77 4.525a.88.88 0 0 1-.269-.632c0-.237.097-.464.27-.631A.933.933 0 0 1 6.42 3c.243 0 .477.094.65.262l4.116 4a1.022 1.022 0 0 1 0 1.475l-4.117 4.001a.933.933 0 0 1-.65.262.933.933 0 0 1-.65-.262.881.881 0 0 1-.269-.631c0-.237.097-.465.27-.632L9.343 8Z",
  "clip-rule": "evenodd"
}, null, -1), My = [
  yy
], Cy = ["id"], by = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M16 16H0V0h16z"
}, null, -1), xy = [
  by
];
function Sy(t, e) {
  return p(), g("svg", $y, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...My], 8, wy),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...xy], 8, Cy)
    ])
  ]);
}
const Iy = I({ name: "icon-FilledArrowRightSm", render: Sy, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Ay = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, ky = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M13.657 13.657A8 8 0 1 1 2.343 2.342a8 8 0 0 1 11.314 11.315Z"
}, null, -1), Ey = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 16A8 8 0 1 0 8-.001 8 8 0 0 0 8 16Zm1.137-8 3.127 3.127a.804.804 0 0 1-1.137 1.137L8 9.137l-3.127 3.127a.804.804 0 0 1-1.137-1.137L6.863 8 3.736 4.873a.804.804 0 1 1 1.137-1.137L8 6.863l3.127-3.127a.804.804 0 1 1 1.137 1.137L9.137 8Z",
  "clip-rule": "evenodd"
}, null, -1), Py = [
  ky,
  Ey
];
function Ty(t, e) {
  return p(), g("svg", Ay, [...Py]);
}
const Oy = I({ name: "icon-FilledCrossSm", render: Ty }), Ly = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Dy = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15 2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14Zm-1.5 2a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h11Zm-6 8a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z",
  "clip-rule": "evenodd"
}, null, -1), Ny = [
  Dy
];
function Ry(t, e) {
  return p(), g("svg", Ly, [...Ny]);
}
const Zy = I({ name: "icon-FilledDesktopSm", render: Ry }), By = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Vy = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.6 3.2H.8A.8.8 0 0 0 0 4v8.8a.8.8 0 0 0 .8.8h6.8v-2.4H2a.4.4 0 0 1-.4-.4V5.2c0-.22.18-.4.4-.4h5.6V3.2Zm-2 9.2c0-.22.18-.4.4-.4h.8a.4.4 0 0 1 0 .8H6a.4.4 0 0 1-.4-.4ZM8 2.523c0-.51.358-.923.8-.923h6.4c.442 0 .8.413.8.923v10.954c0 .51-.358.923-.8.923H8.8c-.442 0-.8-.413-.8-.923V2.523Zm1.6 1.139c0-.255.18-.462.4-.462h.8c0 .22.18.4.4.4h1.6a.4.4 0 0 0 .4-.4h.8c.22 0 .4.207.4.462v8.676c0 .255-.18.462-.4.462h-4c-.22 0-.4-.207-.4-.462V3.662Z",
  "clip-rule": "evenodd"
}, null, -1), Fy = [
  Vy
];
function Hy(t, e) {
  return p(), g("svg", By, [...Fy]);
}
const Uy = I({ name: "icon-FilledDevicesSm", render: Hy }), zy = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Wy = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.9 1a3.1 3.1 0 0 0-2.19.908l-.805.804-.002.002-.003.003-7.66 7.66a.818.818 0 0 0-.24.579v3.226c0 .452.366.818.818.818h3.226a.818.818 0 0 0 .578-.24l8.47-8.47A3.1 3.1 0 0 0 11.901 1Zm-1.034 2.064a1.464 1.464 0 0 1 2.07 2.07l-.229.229-2.07-2.07.229-.23Zm-8.231 8.23L9.481 4.45l2.07 2.07-6.845 6.846-2.071-2.07Z",
  "clip-rule": "evenodd"
}, null, -1), jy = [
  Wy
];
function Gy(t, e) {
  return p(), g("svg", zy, [...jy]);
}
const Yy = I({ name: "icon-FilledEditSm", render: Gy }), Xy = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Ky = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M8 1a7 7 0 1 0 .001 14.001A7 7 0 0 0 8 1Zm2.61 9.9c-.635.584-1.5.928-2.533.928a3.825 3.825 0 0 1-3.42-5.548 3.824 3.824 0 0 1 3.42-2.11c1.03 0 1.896.38 2.56.997L9.541 6.266a2.066 2.066 0 0 0-1.463-.572c-.997 0-1.84.673-2.142 1.578-.077.23-.12.475-.12.728s.043.498.12.728c.301.905 1.145 1.578 2.14 1.578.516 0 .954-.136 1.296-.365a1.76 1.76 0 0 0 .764-1.157h-2.06v-1.48h3.605a4.4 4.4 0 0 1 .069.782c0 1.167-.417 2.147-1.14 2.814Z"
}, null, -1), qy = [
  Ky
];
function Jy(t, e) {
  return p(), g("svg", Xy, [...qy]);
}
const Qy = I({ name: "icon-FilledGoogleSm", render: Jy }), eM = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, tM = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H3Zm1.5 2a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-7ZM8 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
  "clip-rule": "evenodd"
}, null, -1), nM = [
  tM
];
function oM(t, e) {
  return p(), g("svg", eM, [...nM]);
}
const iM = I({ name: "icon-FilledMobileSm", render: oM }), rM = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, aM = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M2.556 6.5C1.7 6.5 1 7.175 1 8s.7 1.5 1.556 1.5C3.41 9.5 4.11 8.825 4.11 8s-.7-1.5-1.555-1.5Zm10.888 0c-.855 0-1.555.675-1.555 1.5s.7 1.5 1.555 1.5C14.3 9.5 15 8.825 15 8s-.7-1.5-1.556-1.5ZM8 6.5c-.856 0-1.556.675-1.556 1.5S7.144 9.5 8 9.5c.856 0 1.556-.675 1.556-1.5S8.856 6.5 8 6.5Z"
}, null, -1), sM = [
  aM
];
function lM(t, e) {
  return p(), g("svg", rM, [...sM]);
}
const dM = I({ name: "icon-FilledMoreSm", render: lM }), cM = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, uM = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M6.667 2.8c0 .718-.597 1.3-1.334 1.3C4.597 4.1 4 3.518 4 2.8c0-.718.597-1.3 1.333-1.3.737 0 1.334.582 1.334 1.3ZM12 2.8c0 .718-.597 1.3-1.333 1.3-.737 0-1.334-.582-1.334-1.3 0-.718.597-1.3 1.334-1.3.736 0 1.333.582 1.333 1.3ZM6.667 8c0 .718-.597 1.3-1.334 1.3C4.597 9.3 4 8.718 4 8c0-.718.597-1.3 1.333-1.3.737 0 1.334.582 1.334 1.3ZM12 8c0 .718-.597 1.3-1.333 1.3-.737 0-1.334-.582-1.334-1.3 0-.718.597-1.3 1.334-1.3C11.403 6.7 12 7.282 12 8ZM6.667 13.2c0 .718-.597 1.3-1.334 1.3C4.597 14.5 4 13.918 4 13.2c0-.718.597-1.3 1.333-1.3.737 0 1.334.582 1.334 1.3ZM12 13.2c0 .718-.597 1.3-1.333 1.3-.737 0-1.334-.582-1.334-1.3 0-.718.597-1.3 1.334-1.3.736 0 1.333.582 1.333 1.3Z"
}, null, -1), hM = [
  uM
];
function fM(t, e) {
  return p(), g("svg", cM, [...hM]);
}
const mM = I({ name: "icon-FilledMoveSm", render: fM }), pM = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, _M = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M3.5 2A1.5 1.5 0 0 0 2 3.5v9A1.5 1.5 0 0 0 3.5 14H5a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 5 2H3.5ZM11 2a1.5 1.5 0 0 0-1.5 1.5v9A1.5 1.5 0 0 0 11 14h1.5a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 2H11Z"
}, null, -1), vM = [
  _M
];
function gM(t, e) {
  return p(), g("svg", pM, [...vM]);
}
const $M = I({ name: "icon-FilledPauseSm", render: gM }), wM = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, yM = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M8 7.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM11.867 8.232c-.307-.432-.91-.462-1.355-.174-1.717 1.113-3.307 1.113-5.024 0-.444-.288-1.048-.258-1.355.174-1.486 2.095-1.343 4.315-.527 5.342.307.387.704.426.923.426h6.942c.22 0 .616-.04.923-.426.816-1.027.96-3.247-.527-5.342Z"
}, null, -1), MM = [
  yM
];
function CM(t, e) {
  return p(), g("svg", wM, [...MM]);
}
const bM = I({ name: "icon-FilledPersonSm", render: CM }), xM = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, SM = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M13.25 6.642c1 .604 1 2.112 0 2.716l-9 5.43C3.25 15.39 2 14.637 2 13.43V2.57C2 1.363 3.25.609 4.25 1.212l9 5.43Z"
}, null, -1), IM = [
  SM
];
function AM(t, e) {
  return p(), g("svg", xM, [...IM]);
}
const wd = I({ name: "icon-FilledPlaySm", render: AM }), kM = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, EM = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M8.157 12.26a.32.32 0 0 0-.313 0l-3.94 2.207a.32.32 0 0 1-.47-.342l.88-4.43a.32.32 0 0 0-.097-.297L.9 6.332a.32.32 0 0 1 .18-.552l4.484-.532a.32.32 0 0 0 .253-.184L7.71.964a.32.32 0 0 1 .58 0l1.893 4.1a.32.32 0 0 0 .252.184l4.485.532a.32.32 0 0 1 .18.552l-3.316 3.066a.32.32 0 0 0-.097.298l.88 4.429a.32.32 0 0 1-.47.341l-3.94-2.205Z"
}, null, -1), PM = [
  EM
];
function TM(t, e) {
  return p(), g("svg", kM, [...PM]);
}
const OM = I({ name: "icon-FilledStarSm", render: TM }), LM = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, DM = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M12.286 2H3.714C2.768 2 2 2.768 2 3.714v8.572C2 13.233 2.768 14 3.714 14h8.572c.947 0 1.714-.768 1.714-1.714V3.714C14 2.768 13.232 2 12.286 2Z"
}, null, -1), NM = [
  DM
];
function RM(t, e) {
  return p(), g("svg", LM, [...NM]);
}
const ZM = I({ name: "icon-FilledStopSm", render: RM }), BM = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, VM = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M10.4 7.193c.647-.446 1.1-1.18 1.1-1.86 0-1.506-1.166-2.666-2.666-2.666H4.667V12H9.36c1.394 0 2.474-1.133 2.474-2.527a2.49 2.49 0 0 0-1.434-2.28Zm-3.733-2.86h2c.553 0 1 .447 1 1 0 .554-.447 1-1 1h-2v-2Zm2.333 6H6.667v-2H9c.554 0 1 .447 1 1 0 .554-.446 1-1 1Z"
}, null, -1), FM = [
  VM
];
function HM(t, e) {
  return p(), g("svg", BM, [...FM]);
}
const UM = I({ name: "icon-FilledTextStyleBoldSm", render: HM }), zM = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, WM = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M6.667 2.667v2H8.14L5.86 10H4v2h5.333v-2H7.86l2.28-5.333H12v-2H6.667Z"
}, null, -1), jM = [
  WM
];
function GM(t, e) {
  return p(), g("svg", zM, [...jM]);
}
const YM = I({ name: "icon-FilledTextStyleItalicSm", render: GM }), XM = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, KM = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M6.667 12.667h2.666v-2H6.667v2Zm-3.334-10v2h3.334v2h2.666v-2h3.334v-2H3.333ZM2 9.333h12V8H2v1.333Z"
}, null, -1), qM = [
  KM
];
function JM(t, e) {
  return p(), g("svg", XM, [...qM]);
}
const QM = I({ name: "icon-FilledTextStyleStrikethroughSm", render: JM }), eC = {
  component: "",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tC = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 4h-1.126a4.002 4.002 0 0 0-7.748 0H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2.626a4.002 4.002 0 0 0 7.748 0h1.854C12.281 5.437 12 4.765 12 4ZM5 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM.5 14h8.626a4.002 4.002 0 0 1 7.748 0H19.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2.626a4.002 4.002 0 0 1-7.748 0H.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM13 13a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
  fill: "currentColor"
}, null, -1), nC = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 4h-1.126a4.002 4.002 0 0 0-7.748 0H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2.626a4.002 4.002 0 0 0 7.748 0h1.854C12.281 5.437 12 4.765 12 4ZM5 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM.5 14h8.626a4.002 4.002 0 0 1 7.748 0H19.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2.626a4.002 4.002 0 0 1-7.748 0H.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM13 13a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
  fill: "currentColor"
}, null, -1), oC = /* @__PURE__ */ h("circle", {
  cx: "17",
  cy: "4",
  r: "3",
  fill: "currentColor"
}, null, -1), iC = [
  tC,
  nC,
  oC
];
function rC(t, e) {
  return p(), g("svg", eC, [...iC]);
}
const aC = I({ name: "icon-FilterOnMd", render: rC }), sC = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, lC = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M13 2.5H4v15h12v-11h-2.5A.5.5 0 0 1 13 6V2.5ZM2 1.492C2 .944 2.447.5 2.999.5h10.76a.5.5 0 0 1 .391.188l3.74 4.675a.5.5 0 0 1 .11.312v12.818a1 1 0 0 1-.993 1.007H2.993A1 1 0 0 1 2 18.508V1.492ZM9 10V8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V10h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H11v1.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V12H7.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H9Z"
}, null, -1), dC = [
  lC
];
function cC(t, e) {
  return p(), g("svg", sC, [...dC]);
}
const uC = I({ name: "icon-AddFileMd", render: cC }), hC = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, fC = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17.572 8.943h-6.886V2.057a1.057 1.057 0 0 0-2.115 0v6.886H2.057a1.057 1.057 0 0 0 0 2.114h6.514v6.886a1.057 1.057 0 0 0 2.115 0v-6.886h6.886a1.057 1.057 0 1 0 0-2.114Z",
  "clip-rule": "evenodd"
}, null, -1), mC = [
  fC
];
function pC(t, e) {
  return p(), g("svg", hC, [...mC]);
}
const yd = I({ name: "icon-AddMd", render: pC }), _C = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, vC = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.505 5.5a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-3.812 8.85a1 1 0 0 1-.109 1.41c-2.736 2.345-2.107 4.278-1.74 4.734l.013.001a.984.984 0 0 0 .106.005h6.59a1 1 0 1 1 0 2h-6.59c-.354 0-.993-.05-1.487-.541-1.47-1.46-1.585-4.811 1.807-7.718a1 1 0 0 1 1.41.108Zm9.682 1.775h1.75a.875.875 0 1 1 0 1.75h-1.75v1.75a.875.875 0 1 1-1.75 0v-1.75h-1.75a.875.875 0 1 1 0-1.75h1.75v-1.75a.875.875 0 1 1 1.75 0v1.75Z",
  "clip-rule": "evenodd"
}, null, -1), gC = [
  vC
];
function $C(t, e) {
  return p(), g("svg", _C, [...gC]);
}
const wC = I({ name: "icon-AddPeopleMd", render: $C }), yC = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, MC = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.707 4.707a1 1 0 0 0-1.414-1.414l-6 6a1 1 0 0 0 0 1.414l6 6a1 1 0 0 0 1.414-1.414L5.414 10l5.293-5.293Zm6 0a1 1 0 0 0-1.414-1.414l-6 6a1 1 0 0 0 0 1.414l6 6a1 1 0 0 0 1.414-1.414L11.414 10l5.293-5.293Z",
  "clip-rule": "evenodd"
}, null, -1), CC = [
  MC
];
function bC(t, e) {
  return p(), g("svg", yC, [...CC]);
}
const xC = I({ name: "icon-ArrowDoubleLeftMd", render: bC }), SC = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, IC = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.293 15.293a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6a1 1 0 0 0-1.414 1.414L8.586 10l-5.293 5.293Zm6 0a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6a1 1 0 0 0-1.414 1.414L14.586 10l-5.293 5.293Z",
  "clip-rule": "evenodd"
}, null, -1), AC = [
  IC
];
function kC(t, e) {
  return p(), g("svg", SC, [...AC]);
}
const EC = I({ name: "icon-ArrowDoubleRightMd", render: kC }), PC = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, TC = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M3.923 10.244a.833.833 0 1 0-1.179 1.179l6.667 6.666a.833.833 0 0 0 1.178 0l6.667-6.666a.833.833 0 1 0-1.179-1.179l-5.244 5.244V2.5a.833.833 0 1 0-1.666 0v12.988l-5.244-5.244Z"
}, null, -1), OC = [
  TC
];
function LC(t, e) {
  return p(), g("svg", PC, [...OC]);
}
const DC = I({ name: "icon-ArrowDownMd", render: LC }), NC = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, RC = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.293 6.293a1 1 0 0 1 1.414 0L10 11.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z",
  "clip-rule": "evenodd"
}, null, -1), ZC = [
  RC
];
function BC(t, e) {
  return p(), g("svg", NC, [...ZC]);
}
const VC = I({ name: "icon-ArrowDownShortMd", render: BC }), FC = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, HC = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M9.756 3.923a.833.833 0 1 0-1.179-1.179L1.911 9.411a.833.833 0 0 0 0 1.178l6.666 6.667a.833.833 0 1 0 1.179-1.179l-5.244-5.244H17.5a.833.833 0 1 0 0-1.666H4.512l5.244-5.244Z"
}, null, -1), UC = [
  HC
];
function zC(t, e) {
  return p(), g("svg", FC, [...UC]);
}
const Md = I({ name: "icon-ArrowLeftMd", render: zC }), WC = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, jC = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.707 3.293a1 1 0 0 1 0 1.414L8.414 10l5.293 5.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z",
  "clip-rule": "evenodd"
}, null, -1), GC = [
  jC
];
function YC(t, e) {
  return p(), g("svg", WC, [...GC]);
}
const XC = I({ name: "icon-ArrowLeftShortMd", render: YC }), KC = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, qC = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M10.244 3.923a.833.833 0 0 1 1.179-1.179l6.666 6.667a.833.833 0 0 1 0 1.178l-6.666 6.667a.833.833 0 1 1-1.179-1.179l5.244-5.244H2.5a.833.833 0 0 1 0-1.666h12.988l-5.244-5.244Z"
}, null, -1), JC = [
  qC
];
function QC(t, e) {
  return p(), g("svg", KC, [...JC]);
}
const eb = I({ name: "icon-ArrowRightMd", render: QC }), tb = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, nb = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.293 16.707a1 1 0 0 1 0-1.414L11.586 10 6.293 4.707a1 1 0 0 1 1.414-1.414l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0Z",
  "clip-rule": "evenodd"
}, null, -1), ob = [
  nb
];
function ib(t, e) {
  return p(), g("svg", tb, [...ob]);
}
const rb = I({ name: "icon-ArrowRightShortMd", render: ib }), ab = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, sb = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M16.077 9.756a.833.833 0 1 0 1.179-1.179l-6.667-6.666a.833.833 0 0 0-1.178 0L2.744 8.577a.833.833 0 1 0 1.179 1.179l5.244-5.244V17.5a.833.833 0 0 0 1.666 0V4.512l5.244 5.244Z"
}, null, -1), lb = [
  sb
];
function db(t, e) {
  return p(), g("svg", ab, [...lb]);
}
const cb = I({ name: "icon-ArrowUpMd", render: db }), ub = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, hb = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.293 13.707a1 1 0 0 0 1.414 0L10 8.414l5.293 5.293a1 1 0 0 0 1.414-1.414l-6-6a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 0 1.414Z",
  "clip-rule": "evenodd"
}, null, -1), fb = [
  hb
];
function mb(t, e) {
  return p(), g("svg", ub, [...fb]);
}
const pb = I({ name: "icon-ArrowUpShortMd", render: mb }), _b = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, vb = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M12.486 5.428a1 1 0 0 1 0 1.43l-5.051 4.939a.999.999 0 0 0-.312.71.98.98 0 0 0 .299.715 1.023 1.023 0 0 0 .732.293 1.04 1.04 0 0 0 .726-.305l5.783-5.653a2.965 2.965 0 0 0 .899-2.12c0-.796-.323-1.559-.899-2.12a3.103 3.103 0 0 0-2.168-.88c-.814 0-1.594.317-2.17.88L4.544 8.97a4.995 4.995 0 0 0-1.136 1.622 4.902 4.902 0 0 0-.024 3.854 4.991 4.991 0 0 0 1.114 1.636 5.121 5.121 0 0 0 1.673 1.09 5.214 5.214 0 0 0 3.942-.026 5.116 5.116 0 0 0 1.66-1.11l5.083-4.97a1 1 0 0 1 1.398 0l.016.016a1 1 0 0 1 0 1.43l-5.052 4.939a7.168 7.168 0 0 1-2.322 1.516 7.299 7.299 0 0 1-5.477 0 7.17 7.17 0 0 1-2.322-1.516 6.988 6.988 0 0 1-1.551-2.27 6.861 6.861 0 0 1 0-5.355c.36-.85.887-1.62 1.551-2.27L8.88 1.903A5.174 5.174 0 0 1 12.476.5a5.17 5.17 0 0 1 3.57 1.464 4.942 4.942 0 0 1 1.497 3.49 4.939 4.939 0 0 1-1.435 3.515l-5.782 5.656c-.285.279-.623.5-.995.65a3.127 3.127 0 0 1-3.343-.65 2.996 2.996 0 0 1-.665-.973 2.941 2.941 0 0 1 0-2.296c.154-.364.38-.694.665-.973l5.084-4.97a1 1 0 0 1 1.398 0l.015.015Z"
}, null, -1), gb = [
  vb
];
function $b(t, e) {
  return p(), g("svg", _b, [...gb]);
}
const wb = I({ name: "icon-AttachmentMd", render: $b }), yb = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Mb = ["clip-path"], Cb = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M4.328 5.95H11.5a6 6 0 1 1 0 12h-8a1 1 0 1 0 0 2h8a8 8 0 1 0 0-16H4.328l1.829-1.829A1 1 0 0 0 4.743.707L1.207 4.243a1 1 0 0 0 0 1.414l3.536 3.536a1 1 0 1 0 1.414-1.414L4.327 5.95Z"
}, null, -1), bb = [
  Cb
], xb = ["id"], Sb = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}, null, -1), Ib = [
  Sb
];
function Ab(t, e) {
  return p(), g("svg", yb, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...bb], 8, Mb),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Ib], 8, xb)
    ])
  ]);
}
const kb = I({ name: "icon-BackMd", render: Ab, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Eb = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Pb = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.691 6.305a6.467 6.467 0 0 0 9.003 9.004L4.692 6.305Zm1.614-1.614 9.004 9.004a6.467 6.467 0 0 0-9.004-9.003ZM1.25 10a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Z",
  "clip-rule": "evenodd"
}, null, -1), Tb = [
  Pb
];
function Ob(t, e) {
  return p(), g("svg", Eb, [...Tb]);
}
const Lb = I({ name: "icon-BanMd", render: Ob }), Db = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Nb = ["clip-path"], Rb = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M11.25 1.667c0 .37-.16.702-.417.931v1.569H15a2.5 2.5 0 0 1 2.5 2.5V15a2.5 2.5 0 0 1-2.5 2.5H5A2.5 2.5 0 0 1 2.5 15V6.667a2.5 2.5 0 0 1 2.5-2.5h4.167V2.598a1.25 1.25 0 1 1 2.083-.931ZM5 5.833a.833.833 0 0 0-.833.834V15a.833.833 0 0 0 .833.833h10a.834.834 0 0 0 .833-.833V6.667A.834.834 0 0 0 15 5.833H5ZM1.667 9.167a.833.833 0 0 0-1.667 0V12.5a.833.833 0 0 0 1.667 0V9.167Zm16.666 0a.833.833 0 0 1 1.667 0V12.5a.833.833 0 0 1-1.667 0V9.167ZM7.5 12.083a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
}, null, -1), Zb = [
  Rb
], Bb = ["id"], Vb = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}, null, -1), Fb = [
  Vb
];
function Hb(t, e) {
  return p(), g("svg", Db, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...Zb], 8, Nb),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...Fb], 8, Bb)
    ])
  ]);
}
const Ub = I({ name: "icon-BotMd", render: Hb, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), zb = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Wb = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.8 1a3 3 0 0 0-2.573 1.457l-1.8 2.998A3 3 0 0 0 1 6.998V16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6.998a3 3 0 0 0-.427-1.543l-1.8-2.998A3 3 0 0 0 14.201 1H5.799Zm-.858 2.486A1 1 0 0 1 5.799 3H9v3H3.433l1.509-2.514ZM11 6h5.567l-1.509-2.514A1 1 0 0 0 14.201 3H11v3ZM3 16V8h14v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm3-6a1 1 0 1 0 0 2h2.5a1 1 0 1 0 0-2H6Z",
  "clip-rule": "evenodd"
}, null, -1), jb = [
  Wb
];
function Gb(t, e) {
  return p(), g("svg", zb, [...jb]);
}
const Yb = I({ name: "icon-BoxMd", render: Gb }), Xb = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Kb = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M1 3a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Zm0 7a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Zm0 7a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z"
}, null, -1), qb = [
  Kb
];
function Jb(t, e) {
  return p(), g("svg", Xb, [...qb]);
}
const Qb = I({ name: "icon-BurgerMd", render: Jb }), ex = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, tx = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4 1a1 1 0 0 1 2 0v3h8V1a1 1 0 1 1 2 0v3h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V1Zm11 5H3v11h14V6h-2ZM6.5 8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
  "clip-rule": "evenodd"
}, null, -1), nx = [
  tx
];
function ox(t, e) {
  return p(), g("svg", ex, [...nx]);
}
const ix = I({ name: "icon-CalendarEventMd", render: ox }), rx = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, ax = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M6.25 10.625a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM7.5 13.125a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM10 10.625a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM11.25 13.125a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM13.75 10.625a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
}, null, -1), sx = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.75 0a1 1 0 0 0-1 1v2.75a2.5 2.5 0 0 0-2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h12.5a2.5 2.5 0 0 0 2.5-2.5v-10a2.5 2.5 0 0 0-2.5-2.5h-.002V1a1 1 0 1 0-2 0v2.75H5.75V1a1 1 0 0 0-1-1Zm-1 5.75h12.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3.75a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), lx = [
  ax,
  sx
];
function dx(t, e) {
  return p(), g("svg", rx, [...lx]);
}
const cx = I({ name: "icon-CalendarMd", render: dx }), ux = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, hx = ["clip-path"], fx = /* @__PURE__ */ h("path", { d: "M6.467 12.858v.03h2.841v1.279H4.7v-1.201l2.007-1.92c.404-.387.687-.71.85-.971.166-.264.249-.54.249-.83 0-.645-.347-.967-1.04-.967-.603 0-1.179.24-1.729.718V7.638a3.71 3.71 0 0 1 2.06-.59c.717 0 1.275.18 1.675.542.404.358.606.843.606 1.455 0 .817-.49 1.661-1.47 2.534l-1.44 1.28ZM10.7 14.015v-1.27c.368.242.81.362 1.328.362.54 0 .957-.182 1.25-.547.296-.368.446-.889.45-1.562l-.03-.01c-.31.459-.78.688-1.411.688-.573 0-1.048-.2-1.426-.6-.374-.4-.561-.92-.561-1.558 0-.745.23-1.343.688-1.792.46-.452 1.053-.678 1.782-.678.749 0 1.345.283 1.787.85.446.566.67 1.376.67 2.43 0 1.25-.27 2.224-.806 2.92-.534.694-1.281 1.04-2.241 1.04-.57 0-1.063-.09-1.48-.273Zm2.026-5.79a.805.805 0 0 0-.659.326c-.172.215-.259.494-.259.835 0 .355.085.635.254.84.173.202.406.303.699.303a.832.832 0 0 0 .654-.288c.17-.195.254-.44.254-.733 0-.367-.09-.673-.269-.918-.176-.244-.4-.366-.674-.366Z" }, null, -1), mx = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  d: "M17.5 4.167h-15V17.5h15V4.167ZM2.5 2.5c-.92 0-1.667.746-1.667 1.667V17.5c0 .92.747 1.667 1.667 1.667h15c.92 0 1.667-.747 1.667-1.667V4.167c0-.92-.746-1.667-1.667-1.667h-15Z",
  "clip-rule": "evenodd"
}, null, -1), px = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  d: "M6.417 0c.46 0 .833.373.833.833v1.852a.833.833 0 0 1-1.666 0V.833c0-.46.373-.833.833-.833ZM14.195 0c.46 0 .833.373.833.833v1.852a.833.833 0 0 1-1.666 0V.833c0-.46.373-.833.833-.833Z",
  "clip-rule": "evenodd"
}, null, -1), _x = [
  fx,
  mx,
  px
], vx = ["id"], gx = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}, null, -1), $x = [
  gx
];
function wx(t, e) {
  return p(), g("svg", ux, [
    h("g", {
      fill: "currentColor",
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [..._x], 8, hx),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...$x], 8, vx)
    ])
  ]);
}
const yx = I({ name: "icon-CalendarNumberMd", render: wx, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), Mx = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Cx = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.275 13.75a3.476 3.476 0 0 1 3.475-3.475 3.476 3.476 0 0 1 3.475 3.475 3.476 3.476 0 0 1-3.475 3.475 3.476 3.476 0 0 1-3.475-3.475Zm3.475-5c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5Zm.479 3.098a.636.636 0 1 0-1.271 0v1.737c0 .27.09.526.205.728.115.202.29.41.52.547h.002l1.311.783a.636.636 0 0 0 .652-1.091l-1.314-.784c0-.001-.008-.006-.02-.019a.372.372 0 0 1-.08-.14l-.005-.026v-1.736Z",
  "clip-rule": "evenodd"
}, null, -1), bx = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.75 1a1 1 0 0 1 2 0v2.75h8.498V1a1 1 0 0 1 2 0v2.75h.002a2.5 2.5 0 0 1 2.5 2.5v1.5a1 1 0 1 1-2 0v-1.5a.5.5 0 0 0-.5-.5H3.75a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4a1 1 0 1 1 0 2h-4a2.5 2.5 0 0 1-2.5-2.5v-10a2.5 2.5 0 0 1 2.5-2.5V1Z",
  "clip-rule": "evenodd"
}, null, -1), xx = [
  Cx,
  bx
];
function Sx(t, e) {
  return p(), g("svg", Mx, [...xx]);
}
const Ix = I({ name: "icon-CalendarPostponedMd", render: Sx }), Ax = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, kx = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.75 1a1 1 0 0 1 2 0v2.75h8.498V1a1 1 0 0 1 2 0v2.75h.002a2.5 2.5 0 0 1 2.5 2.5v1.5a1 1 0 1 1-2 0v-1.5a.5.5 0 0 0-.5-.5H3.75a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4a1 1 0 1 1 0 2h-4a2.5 2.5 0 0 1-2.5-2.5v-10a2.5 2.5 0 0 1 2.5-2.5V1Z",
  "clip-rule": "evenodd"
}, null, -1), Ex = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m13.467 10.408-2.472 1.427a.572.572 0 0 0-.283.49v2.85c0 .204.109.39.28.488l2.472 1.427v.001c.18.102.394.1.565.001l2.472-1.427a.573.573 0 0 0 .282-.49v-2.85c0-.2-.105-.385-.282-.49l-2.469-1.426h-.001a.568.568 0 0 0-.564-.001Zm-.75-1.3a2.068 2.068 0 0 1 2.06 0h.002l2.48 1.433a2.067 2.067 0 0 1 1.024 1.784v2.85c0 .735-.393 1.413-1.024 1.784l-.005.003-2.475 1.43a2.068 2.068 0 0 1-2.06 0h-.002l-2.475-1.43a2.062 2.062 0 0 1-1.03-1.787v-2.85c0-.735.394-1.413 1.025-1.784l.005-.003 2.475-1.43Zm1.033 2.642a.75.75 0 0 1 .75.75v1.25a.75.75 0 1 1-1.5 0V12.5a.75.75 0 0 1 .75-.75Zm.75 3.75a.75.75 0 1 0-1.5 0v.042a.75.75 0 0 0 1.5 0V15.5Z",
  "clip-rule": "evenodd"
}, null, -1), Px = [
  kx,
  Ex
];
function Tx(t, e) {
  return p(), g("svg", Ax, [...Px]);
}
const Ox = I({ name: "icon-CalendarWarningMd", render: Tx }), Lx = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Dx = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M13.034 4c0-.552.445-1 .994-1h3.978c.549 0 .994.448.994 1s-.445 1-.994 1h-3.978a.997.997 0 0 1-.994-1ZM13.034 10c0-.552.445-1 .994-1h3.978c.549 0 .994.448.994 1s-.445 1-.994 1h-3.978a.997.997 0 0 1-.994-1ZM1.101 16c0-.552.445-1 .994-1h15.91c.55 0 .995.448.995 1s-.445 1-.994 1H2.096a.997.997 0 0 1-.995-1Z"
}, null, -1), Nx = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1 5c0-1.657 1.336-3 2.983-3H8.06a2.992 2.992 0 0 1 2.983 3v4.1c0 1.657-1.335 3-2.983 3H3.983A2.992 2.992 0 0 1 1 9.1V5Zm2.983-1a.997.997 0 0 0-.994 1v4.1c0 .552.445 1 .994 1H8.06c.55 0 .995-.448.995-1V5c0-.552-.446-1-.995-1H3.983Z",
  "clip-rule": "evenodd"
}, null, -1), Rx = [
  Dx,
  Nx
];
function Zx(t, e) {
  return p(), g("svg", Lx, [...Rx]);
}
const Bx = I({ name: "icon-CardMd", render: Zx }), Vx = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Fx = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.907 3h6.186c.539 0 1.052-.002 1.511.17.4.148.755.39 1.032.703.316.359.477.82.647 1.304l.04.112.669 1.902.612-.29c.477-.226 1.056-.043 1.294.408.238.451.045 1-.431 1.225l-.29.137c.178.194.33.408.455.64.212.393.294.809.332 1.246.036.418.036.929.036 1.537V14.254c0 .283 0 .548-.05.786-.203.966-1 1.721-2.02 1.913C16.678 17 16.4 17 16.1 17H15.625c-1.227 0-2.253-.814-2.51-1.902h-6.23C6.628 16.186 5.602 17 4.375 17H3.901c-.3 0-.58 0-.831-.047-1.02-.192-1.817-.947-2.02-1.913-.05-.238-.05-.503-.05-.787V12.094c0-.608 0-1.119.036-1.537.038-.437.12-.853.332-1.247a3.19 3.19 0 0 1 .454-.64l-.289-.136c-.476-.225-.67-.774-.431-1.225.238-.45.817-.634 1.294-.408l.612.29.67-1.902.04-.112c.169-.484.33-.945.646-1.304.277-.313.631-.555 1.032-.704C5.856 3 6.368 3 6.906 3ZM4.908 7.57c.267-.005.558-.005.875-.005h8.434c.316 0 .608 0 .875.004l-.6-1.702c-.236-.673-.286-.766-.336-.822a.643.643 0 0 0-.258-.176c-.072-.027-.181-.043-.93-.043H7.032c-.749 0-.858.016-.93.043a.643.643 0 0 0-.258.176c-.05.056-.1.15-.337.822l-.599 1.702Zm-.591 1.85c-.343.026-.5.073-.599.12a1.41 1.41 0 0 0-.632.6c-.05.093-.1.242-.128.566-.029.335-.03.77-.03 1.425v2.054c0 .397.005.462.013.499.05.241.25.43.505.478.039.007.108.012.527.012h.402c.355 0 .643-.273.643-.609 0-.714.612-1.293 1.366-1.293h7.232c.754 0 1.366.579 1.366 1.293 0 .336.288.609.643.609h.402c.42 0 .488-.005.527-.012a.627.627 0 0 0 .505-.478c.008-.037.012-.102.012-.5v-2.053c0-.655 0-1.09-.03-1.425-.027-.324-.077-.473-.127-.567a1.41 1.41 0 0 0-.633-.598c-.099-.048-.255-.095-.598-.122-.353-.027-.814-.028-1.505-.028H5.822c-.691 0-1.152.001-1.505.028ZM3.41 10.76c0-.504.432-.913.964-.913h2.41c.533 0 .965.409.965.913s-.432.913-.964.913h-2.41c-.533 0-.965-.409-.965-.913Zm8.839 0c0-.504.432-.913.964-.913h2.41c.533 0 .965.409.965.913s-.432.913-.964.913h-2.41c-.533 0-.965-.409-.965-.913Z",
  "clip-rule": "evenodd"
}, null, -1), Hx = [
  Fx
];
function Ux(t, e) {
  return p(), g("svg", Vx, [...Hx]);
}
const Cd = I({ name: "icon-CarMd", render: Ux }), zx = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Wx = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.11 1a7.626 7.626 0 0 0-5.381 2.22A7.563 7.563 0 0 0 .5 8.579c0 2.807 1.384 4.923 3.335 6.572 1.95 1.648 4.467 2.83 6.744 3.773a.986.986 0 0 0 1.36-.913v-1.854c2.001-.013 3.917-.81 5.332-2.22A7.563 7.563 0 0 0 19.5 8.58c0-2.01-.802-3.938-2.229-5.36A7.626 7.626 0 0 0 11.891 1H8.11ZM4.136 4.621a5.632 5.632 0 0 1 3.974-1.64h3.78a5.641 5.641 0 0 1 3.974 1.64A5.596 5.596 0 0 1 17.51 8.58a5.577 5.577 0 0 1-1.646 3.957 5.623 5.623 0 0 1-3.974 1.64h-.945a.993.993 0 0 0-.995.99v1.316c-2.578-1.17-4.439-2.304-5.657-3.56-1.227-1.267-1.803-2.658-1.803-4.343 0-1.485.592-2.908 1.646-3.958Z",
  "clip-rule": "evenodd"
}, null, -1), jx = [
  Wx
];
function Gx(t, e) {
  return p(), g("svg", zx, [...jx]);
}
const Yx = I({ name: "icon-ChatMd", render: Gx }), Xx = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Kx = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M18.19 4.776a1 1 0 0 1 .034 1.414L9.03 15.844a2 2 0 0 1-3.033-.16L1.707 10.11a1 1 0 1 1 1.586-1.22l4.288 5.575 9.195-9.655a1 1 0 0 1 1.414-.034Z",
  "clip-rule": "evenodd"
}, null, -1), qx = [
  Kx
];
function Jx(t, e) {
  return p(), g("svg", Xx, [...qx]);
}
const Qx = I({ name: "icon-CheckMd", render: Jx }), eS = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, tS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M19.13 5.039c.439.44.439 1.152 0 1.591l-8.334 8.333c-.44.44-1.152.44-1.591 0l-4.167-4.166A1.125 1.125 0 1 1 6.63 9.206L10 12.576l7.538-7.537c.44-.44 1.152-.44 1.591 0Z",
  "clip-rule": "evenodd"
}, null, -1), nS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.963 5.039c.439.44.439 1.152 0 1.591l-4.167 4.167a1.125 1.125 0 1 1-1.591-1.591l4.166-4.167c.44-.44 1.152-.44 1.591 0ZM.87 9.206c.44-.44 1.152-.44 1.591 0l4.167 4.166a1.125 1.125 0 0 1-1.59 1.591L.87 10.797a1.125 1.125 0 0 1 0-1.591Z",
  "clip-rule": "evenodd"
}, null, -1), oS = [
  tS,
  nS
];
function iS(t, e) {
  return p(), g("svg", eS, [...oS]);
}
const rS = I({ name: "icon-ChecksMd", render: iS }), aS = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, sS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.77 10a7.23 7.23 0 1 1 14.46 0 7.23 7.23 0 0 1-14.46 0ZM10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm3.707 7.707a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
  "clip-rule": "evenodd"
}, null, -1), lS = [
  sS
];
function dS(t, e) {
  return p(), g("svg", aS, [...lS]);
}
const cS = I({ name: "icon-CircleCheckMd", render: dS }), uS = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, hS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.637 3.576a1 1 0 0 0-1.94-.485L7.363 16.424a1 1 0 1 0 1.94.485l3.334-13.333ZM6.54 5.96a1 1 0 0 1 0 1.414L3.914 10l2.626 2.626a1 1 0 1 1-1.414 1.414l-3.333-3.333a1 1 0 0 1 0-1.414L5.126 5.96a1 1 0 0 1 1.414 0Zm6.92 0a1 1 0 0 1 1.414 0l3.333 3.333a1 1 0 0 1 0 1.414l-3.333 3.333a1 1 0 1 1-1.415-1.414L16.086 10l-2.627-2.626a1 1 0 0 1 0-1.414Z",
  "clip-rule": "evenodd"
}, null, -1), fS = [
  hS
];
function mS(t, e) {
  return p(), g("svg", uS, [...fS]);
}
const pS = I({ name: "icon-CodeMd", render: mS }), _S = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, vS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.004c.243-.01.487 0 .73.033.6.08 1.176.29 1.678.62s.918.772 1.2 1.297c.282.527.418 1.115.388 1.71a3.297 3.297 0 0 1-.558 1.665c-.331.495-.786.9-1.316 1.185a4.088 4.088 0 0 1-1.727.48c-.28.015-.562.001-.838-.04a6.487 6.487 0 0 1-1.336 2.134C12.074 16.305 10.506 17 8.857 17H7.143c-1.649 0-3.217-.695-4.364-1.912C1.634 13.874 1 12.238 1 10.546V6Zm2.154 5.747a4.538 4.538 0 0 0 1.08 1.97C5.016 14.545 6.064 15 7.143 15h1.714c1.08 0 2.127-.454 2.91-1.284A4.627 4.627 0 0 0 13 10.546v-.051c-.49-.306-1.17-.506-1.986-.494h-.028c-1.019-.015-1.827.3-2.316.742-.93.839-2.255 1.273-3.67 1.256a6.133 6.133 0 0 1-1.846-.252ZM15 10.004V8.007c.154-.012.31-.009.465.012.314.042.604.15.845.309.24.158.42.357.536.572.114.213.164.44.152.662a1.297 1.297 0 0 1-.223.656 1.68 1.68 0 0 1-.603.537 2.087 2.087 0 0 1-1.187.236c.01-.147.015-.296.015-.445v-.542ZM13 7v1.302A6.082 6.082 0 0 0 11 8c-1.415-.016-2.74.418-3.67 1.257-.489.442-1.297.757-2.316.743h-.028C4.171 10.01 3.49 9.81 3 9.505V7h10Z",
  "clip-rule": "evenodd"
}, null, -1), gS = [
  vS
];
function $S(t, e) {
  return p(), g("svg", _S, [...gS]);
}
const bd = I({ name: "icon-CoffeeMd", render: $S }), wS = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, yS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M3 16a1 1 0 0 0 1-1V5a1 1 0 1 0-2 0v10a1 1 0 0 0 1 1ZM9.185 11l2.546 2.475a.88.88 0 0 1 .269.632.88.88 0 0 1-.27.631.933.933 0 0 1-.65.262.933.933 0 0 1-.65-.262l-4.116-4a1.022 1.022 0 0 1 0-1.475l4.117-4.001A.933.933 0 0 1 11.08 5c.244 0 .477.094.65.262a.88.88 0 0 1 .269.631.88.88 0 0 1-.27.632L9.186 9H17a1 1 0 1 1 0 2H9.185Z"
}, null, -1), MS = [
  yS
];
function CS(t, e) {
  return p(), g("svg", wS, [...MS]);
}
const bS = I({ name: "icon-CollapseLeftMd", render: CS }), xS = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, SS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M17 4a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1ZM10.815 9 8.27 6.525A.881.881 0 0 1 8 5.893a.88.88 0 0 1 .27-.631A.933.933 0 0 1 8.92 5c.243 0 .477.094.65.262l4.116 4a1.022 1.022 0 0 1 0 1.475l-4.117 4.001a.933.933 0 0 1-.65.262.933.933 0 0 1-.65-.262.88.88 0 0 1-.269-.631.88.88 0 0 1 .27-.632L10.814 11H3a1 1 0 1 1 0-2h7.815Z"
}, null, -1), IS = [
  SS
];
function AS(t, e) {
  return p(), g("svg", xS, [...IS]);
}
const kS = I({ name: "icon-CollapseRightMd", render: AS }), ES = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, PS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.833 1.5A2.833 2.833 0 0 0 2 4.333v7.334A2.833 2.833 0 0 0 4.833 14.5H5v1.167A2.833 2.833 0 0 0 7.833 18.5h7.334A2.833 2.833 0 0 0 18 15.667V8.333A2.833 2.833 0 0 0 15.167 5.5H15V4.333A2.833 2.833 0 0 0 12.167 1.5H4.833ZM13 5.5V4.333a.833.833 0 0 0-.833-.833H4.833A.833.833 0 0 0 4 4.333v7.334a.833.833 0 0 0 .833.833H5V8.333A2.833 2.833 0 0 1 7.833 5.5H13Zm-6 8v2.167c0 .46.373.833.833.833h7.334c.46 0 .833-.373.833-.833V8.333a.833.833 0 0 0-.833-.833H7.833A.833.833 0 0 0 7 8.333V13.5Z",
  "clip-rule": "evenodd"
}, null, -1), TS = [
  PS
];
function OS(t, e) {
  return p(), g("svg", ES, [...TS]);
}
const LS = I({ name: "icon-CopyMd", render: OS }), DS = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, NS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.293 3.293a1 1 0 0 1 1.414 0L10 8.586l5.293-5.293a1 1 0 1 1 1.414 1.414L11.414 10l5.293 5.293a1 1 0 0 1-1.414 1.414L10 11.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L8.586 10 3.293 4.707a1 1 0 0 1 0-1.414Z",
  "clip-rule": "evenodd"
}, null, -1), RS = [
  NS
];
function ZS(t, e) {
  return p(), g("svg", DS, [...RS]);
}
const jr = I({ name: "icon-CrossMd", render: ZS }), BS = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, VS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.574.902a1.75 1.75 0 0 0-2.34.417L4.753 7.244H2.75A1.75 1.75 0 0 0 1 8.994v7.5c0 .967.784 1.75 1.75 1.75h12.42a1.75 1.75 0 0 0 1.589-1.016l2.116-5.859c.106-.23.213-.591.213-.845v-2.21c0-.966-1.122-1.695-2.088-1.695h-5.087l1.195-3.064a1.75 1.75 0 0 0-.686-2.11l-.848-.543ZM6.273 8.55l4.416-5.84.482.309-1.254 3.214a1.75 1.75 0 0 0 1.63 2.386H17v1.905l-1.99 5.72H6.126V8.721c.053-.054.102-.11.148-.171Zm-2.148.694H3v7h1.125v-7Z",
  "clip-rule": "evenodd"
}, null, -1), FS = [
  VS
];
function HS(t, e) {
  return p(), g("svg", BS, [...FS]);
}
const US = I({ name: "icon-CudosMd", render: HS }), zS = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, WS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.574 19.217a1.75 1.75 0 0 1-2.34-.417l-4.481-5.925H2.75A1.75 1.75 0 0 1 1 11.125v-7.5c0-.966.784-1.75 1.75-1.75h12.42a1.75 1.75 0 0 1 1.59 1.016l2.115 5.859c.107.23.214.591.214.845v2.21c0 .966-1.122 1.695-2.089 1.695h-5.086l1.195 3.064a1.75 1.75 0 0 1-.686 2.11l-.849.543ZM6.273 11.57l4.417 5.84.481-.309-1.254-3.214a1.75 1.75 0 0 1 1.63-2.386H17V9.595l-1.99-5.72H6.126v7.523c.053.054.102.11.148.171Zm-2.148-.694H3v-7h1.125v7Z",
  "clip-rule": "evenodd"
}, null, -1), jS = [
  WS
];
function GS(t, e) {
  return p(), g("svg", zS, [...jS]);
}
const YS = I({ name: "icon-DislikeMd", render: GS }), XS = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, KS = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.813 1.735a1 1 0 0 1 1.132-.72l5.334.909c.023.003.045.008.067.014h1.308c.022-.006.044-.01.067-.014l5.334-.91a1 1 0 0 1 1.132.721l1.755 6.39a1.94 1.94 0 0 1-.037 1.065 1.896 1.896 0 0 1-1.807 1.31c-.317 2.142-.825 3.876-1.57 5.135C14.653 17.108 13.4 18 11.777 18H8.222c-1.622 0-2.876-.892-3.749-2.365-.746-1.26-1.254-2.993-1.57-5.135a1.88 1.88 0 0 1-1.243-.459l-.001-.001.653-.757-.65.76-.002-.002a1.896 1.896 0 0 1-.565-.852 1.94 1.94 0 0 1-.037-1.065l1.755-6.389Zm1.951 7.6 4.773-5.398h.926l4.773 5.397a.933.933 0 0 0-.006.048c-.29 2.449-.788 4.16-1.423 5.233C13.199 15.641 12.526 16 11.778 16H11v-.875c0-.058-.005-.115-.014-.17a1.65 1.65 0 0 0 .407-.314c.39-.411.496-.937.496-1.391a1 1 0 0 0-1-1H9.111a1 1 0 0 0-1 1c0 .454.107.98.497 1.391.125.132.262.235.407.314-.01.055-.015.112-.015.17V16h-.778c-.748 0-1.42-.359-2.028-1.385-.636-1.072-1.133-2.784-1.423-5.233a1.009 1.009 0 0 0-.007-.048Zm5.28 3.915a.358.358 0 0 0-.044-.035.36.36 0 0 0-.043.035h.087Zm2.785-9.657 4.054 4.584-1.385-5.04-2.67.456Zm-5.658 0-2.67-.455-1.384 5.04 4.054-4.585Zm1.051 3.97a1 1 0 0 1 1 1v.009a1 1 0 0 1-2 0v-.01a1 1 0 0 1 1-1Zm3.556 0a1 1 0 0 1 1 1v.009a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1Z",
  "clip-rule": "evenodd"
}, null, -1), qS = [
  KS
];
function JS(t, e) {
  return p(), g("svg", XS, [...qS]);
}
const xd = I({ name: "icon-DogMd", render: JS }), QS = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, eI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2 13a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2a1 1 0 1 1 2 0v2a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2a1 1 0 0 1 1-1Z",
  "clip-rule": "evenodd"
}, null, -1), tI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 1a1 1 0 0 1 1 1v9.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L9 11.586V2a1 1 0 0 1 1-1Z",
  "clip-rule": "evenodd"
}, null, -1), nI = [
  eI,
  tI
];
function oI(t, e) {
  return p(), g("svg", QS, [...nI]);
}
const iI = I({ name: "icon-DownloadMd", render: oI }), rI = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, aI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M8.76 14.156a.971.971 0 1 1-1.373-1.373l1.81-1.81H2.223a.972.972 0 0 1 0-1.945h6.976l-1.81-1.81A.971.971 0 0 1 8.76 5.843l3.272 3.272a1.25 1.25 0 0 1 0 1.768L8.76 14.156Z"
}, null, -1), sI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M15.556 18.75c.534 0 .992-.19 1.373-.57.38-.382.571-.84.571-1.374V3.194c0-.534-.19-.992-.57-1.373a1.875 1.875 0 0 0-1.374-.571H9.722a.972.972 0 0 0 0 1.944h4.584c.69 0 1.25.56 1.25 1.25v11.112c0 .69-.56 1.25-1.25 1.25H9.722a.972.972 0 1 0 0 1.944h5.834Z"
}, null, -1), lI = [
  aI,
  sI
];
function dI(t, e) {
  return p(), g("svg", rI, [...lI]);
}
const cI = I({ name: "icon-EnterMd", render: dI }), uI = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, hI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 3.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM1.5 10a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0ZM10 5.667a1 1 0 0 1 1 1V10a1 1 0 1 1-2 0V6.667a1 1 0 0 1 1-1Zm0 6.666a1 1 0 0 0 0 2h.008a1 1 0 1 0 0-2H10Z",
  "clip-rule": "evenodd"
}, null, -1), fI = [
  hI
];
function mI(t, e) {
  return p(), g("svg", uI, [...fI]);
}
const Sd = I({ name: "icon-ErrorMd", render: mI }), pI = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, _I = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M16.5 4a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1ZM5.685 9 8.23 6.525a.881.881 0 0 0 .269-.632.88.88 0 0 0-.27-.631A.933.933 0 0 0 7.58 5a.933.933 0 0 0-.65.262l-4.116 4a1.022 1.022 0 0 0 0 1.475l4.117 4.001a.933.933 0 0 0 .65.262.933.933 0 0 0 .65-.262.88.88 0 0 0 .269-.631.88.88 0 0 0-.27-.632L5.686 11H13.5a1 1 0 1 0 0-2H5.685Z"
}, null, -1), vI = [
  _I
];
function gI(t, e) {
  return p(), g("svg", pI, [...vI]);
}
const $I = I({ name: "icon-ExtendLeftMd", render: gI }), wI = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, yI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M3.5 16a1 1 0 0 0 1-1V5a1 1 0 1 0-2 0v10a1 1 0 0 0 1 1ZM14.315 11l-2.546 2.475a.88.88 0 0 0-.269.632.88.88 0 0 0 .27.631.933.933 0 0 0 .65.262.933.933 0 0 0 .65-.262l4.116-4a1.022 1.022 0 0 0 0-1.475l-4.117-4.001A.933.933 0 0 0 12.42 5a.933.933 0 0 0-.65.262.88.88 0 0 0-.269.631.88.88 0 0 0 .27.632L14.314 9H6.5a1 1 0 0 0 0 2h7.815Z"
}, null, -1), MI = [
  yI
];
function CI(t, e) {
  return p(), g("svg", wI, [...MI]);
}
const bI = I({ name: "icon-ExtendRightMd", render: CI }), xI = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, SI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M12 2.5H4v15h12v-11h-3.5A.5.5 0 0 1 12 6V2.5ZM2 1.492C2 .944 2.447.5 2.999.5h9.794a.5.5 0 0 1 .353.146l4.708 4.708a.5.5 0 0 1 .146.353v12.786a1 1 0 0 1-.993 1.007H2.993A1 1 0 0 1 2 18.508V1.492Z"
}, null, -1), II = [
  SI
];
function AI(t, e) {
  return p(), g("svg", xI, [...II]);
}
const Id = I({ name: "icon-FileMd", render: AI }), kI = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, EI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2 5c0-.552.467-1 1.043-1h13.913C17.533 4 18 4.448 18 5s-.467 1-1.044 1H3.043C2.467 6 2 5.552 2 5Zm2.783 5c0-.552.467-1 1.043-1h8.348c.577 0 1.044.448 1.044 1s-.467 1-1.044 1H5.826c-.576 0-1.043-.448-1.043-1Zm3.13 4c-.576 0-1.043.448-1.043 1s.467 1 1.043 1h4.174c.577 0 1.044-.448 1.044-1s-.467-1-1.044-1H7.913Z",
  "clip-rule": "evenodd"
}, null, -1), PI = [
  EI
];
function TI(t, e) {
  return p(), g("svg", kI, [...PI]);
}
const OI = I({ name: "icon-FilterSortOffMd", render: TI }), LI = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, DI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.416 4H3.043C2.467 4 2 4.448 2 5s.467 1 1.043 1H10c0-.711.148-1.388.416-2Zm7.515 1.358c-.15.375-.53.642-.975.642H12c0-.768.289-1.47.764-2h4.192c.113 0 .221.017.323.049.316.369.545.816.652 1.309ZM11 9H5.826c-.576 0-1.043.448-1.043 1s.467 1 1.043 1h8.348c.09 0 .178-.011.261-.031A4.996 4.996 0 0 1 11 9Zm-4.13 6c0-.552.467-1 1.043-1h4.174c.577 0 1.044.448 1.044 1s-.467 1-1.044 1H7.913c-.576 0-1.043-.448-1.043-1Z",
  "clip-rule": "evenodd"
}, null, -1), NI = /* @__PURE__ */ h("circle", {
  cx: "15",
  cy: "6",
  r: "3",
  fill: "currentColor"
}, null, -1), RI = [
  DI,
  NI
];
function ZI(t, e) {
  return p(), g("svg", LI, [...RI]);
}
const BI = I({ name: "icon-FilterSortOnMd", render: ZI }), VI = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, FI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M0 5.5a.5.5 0 0 0 .5.5h2.626a4.002 4.002 0 0 0 7.748 0H19.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-8.626a4.002 4.002 0 0 0-7.748 0H.5a.5.5 0 0 0-.5.5v1ZM7 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm2.126 7H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h8.626a4.002 4.002 0 0 0 7.748 0H19.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2.626a4.002 4.002 0 0 0-7.748 0ZM15 15a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
  "clip-rule": "evenodd"
}, null, -1), HI = [
  FI
];
function UI(t, e) {
  return p(), g("svg", VI, [...HI]);
}
const zI = I({ name: "icon-FiltresMd", render: UI }), WI = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, jI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.049 4.722v5.373a5.273 5.273 0 0 1 5.668 1.14 3.237 3.237 0 0 0 4.234.267V6.13a5.272 5.272 0 0 1-5.668-1.14 3.237 3.237 0 0 0-4.234-.267Zm0 7.716a3.235 3.235 0 0 1 4.234.267 5.281 5.281 0 0 0 7.41 0c.196-.194.307-.459.307-.735V4.254c0-.414-.247-.788-.628-.948-.38-.16-.819-.077-1.114.213a3.237 3.237 0 0 1-4.54 0A5.281 5.281 0 0 0 7.011 2a5.281 5.281 0 0 0-3.705 1.52A1.031 1.031 0 0 0 3 4.253v13.717C3 18.54 3.459 19 4.024 19c.566 0 1.025-.46 1.025-1.029v-5.533Z",
  "clip-rule": "evenodd"
}, null, -1), GI = [
  jI
];
function YI(t, e) {
  return p(), g("svg", WI, [...GI]);
}
const Ad = I({ name: "icon-FlagMd", render: YI }), XI = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, KI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16 4H4v12h12V4ZM4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Z",
  "clip-rule": "evenodd"
}, null, -1), qI = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.333 5.25a1 1 0 0 1 1 1v1.083h1.334V6.25a1 1 0 1 1 2 0v1.083h.666a1 1 0 1 1 0 2h-.666v1.334h.666a1 1 0 1 1 0 2h-.666v1.083a1 1 0 1 1-2 0v-1.083H9.333v1.083a1 1 0 1 1-2 0v-1.083h-.666a1 1 0 1 1 0-2h.666V9.333h-.666a1 1 0 1 1 0-2h.666V6.25a1 1 0 0 1 1-1Zm1 4.083v1.334h1.334V9.333H9.333Z",
  "clip-rule": "evenodd"
}, null, -1), JI = [
  KI,
  qI
];
function QI(t, e) {
  return p(), g("svg", XI, [...JI]);
}
const kd = I({ name: "icon-HashMd", render: QI }), eA = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, tA = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.167 5.833c0-.92.746-1.666 1.666-1.666h8.334c.92 0 1.666.746 1.666 1.666v4.655l-.244-.244-.011-.011c-.502-.483-1.131-.791-1.828-.791-.697 0-1.326.308-1.828.79l-.011.012-.244.244-1.911-1.91-.012-.012c-.502-.483-1.13-.79-1.827-.79-.697 0-1.326.307-1.828.79l-.012.011-1.91 1.911V5.833Zm8.678 5.834.238-.238c.256-.245.487-.32.667-.32.18 0 .41.075.667.32l1.416 1.416v1.322c0 .92-.746 1.666-1.666 1.666H5.833c-.92 0-1.666-.746-1.666-1.666v-1.322L7.25 9.762c.256-.244.487-.32.667-.32.18 0 .41.076.667.32l2.493 2.494 1.667 1.666a.833.833 0 1 0 1.179-1.178l-1.078-1.077Zm4.655.834v1.666a3.333 3.333 0 0 1-3.333 3.333H5.833A3.333 3.333 0 0 1 2.5 14.167V5.833A3.333 3.333 0 0 1 5.833 2.5h8.334A3.333 3.333 0 0 1 17.5 5.833v6.668Zm-5-6.668a.833.833 0 0 0 0 1.667h.008a.833.833 0 1 0 0-1.667H12.5Z",
  "clip-rule": "evenodd"
}, null, -1), nA = [
  tA
];
function oA(t, e) {
  return p(), g("svg", eA, [...nA]);
}
const iA = I({ name: "icon-ImageMd", render: oA }), rA = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, aA = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 3.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM1.5 10a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0ZM9 6.667a1 1 0 0 1 1-1h.008a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1ZM9.167 9A1 1 0 0 0 9 10.986v2.347a1 1 0 0 0 1 1h.833A1 1 0 0 0 11 12.347V10a1 1 0 0 0-1-1h-.833Z",
  "clip-rule": "evenodd"
}, null, -1), sA = [
  aA
];
function lA(t, e) {
  return p(), g("svg", rA, [...sA]);
}
const Ed = I({ name: "icon-InfoMd", render: lA }), dA = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, cA = ["clip-path"], uA = /* @__PURE__ */ h("path", { d: "M17.5 4.167h-15V17.5h15V4.167ZM2.5 2.5c-.92 0-1.667.746-1.667 1.667V17.5c0 .92.747 1.667 1.667 1.667h15c.92 0 1.667-.747 1.667-1.667V4.167c0-.92-.746-1.667-1.667-1.667h-15Z" }, null, -1), hA = /* @__PURE__ */ h("path", { d: "M6.667 0c.46 0 .833.373.833.833V2.5a.833.833 0 1 1-1.667 0V.833c0-.46.374-.833.834-.833ZM13.334 0c.46 0 .833.373.833.833V2.5a.833.833 0 1 1-1.667 0V.833c0-.46.373-.833.834-.833ZM15.834 10.833a5.833 5.833 0 1 1-11.667 0 5.833 5.833 0 0 1 11.667 0ZM10 15a4.167 4.167 0 1 0 0-8.333A4.167 4.167 0 0 0 10 15Z" }, null, -1), fA = /* @__PURE__ */ h("path", { d: "M9.584 8.333c.46 0 .833.373.833.834v1.666h1.667a.833.833 0 0 1 0 1.667h-1.667c-.92 0-1.667-.746-1.667-1.667V9.167c0-.46.373-.834.834-.834Z" }, null, -1), mA = [
  uA,
  hA,
  fA
], pA = ["id"], _A = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}, null, -1), vA = [
  _A
];
function gA(t, e) {
  return p(), g("svg", dA, [
    h("g", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-path": "url(#" + t.idMap.a + ")",
      "clip-rule": "evenodd"
    }, [...mA], 8, cA),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...vA], 8, pA)
    ])
  ]);
}
const $A = I({ name: "icon-LaterMd", render: gA, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), wA = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, yA = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.516 15.318c0-.565.433-1.023.968-1.023h5.031c.535 0 .968.458.968 1.023s-.433 1.022-.968 1.022H7.484c-.535 0-.968-.457-.968-1.022ZM7.354 17.977c0-.565.434-1.023.968-1.023h3.355c.534 0 .967.458.967 1.023S12.211 19 11.677 19H8.322c-.534 0-.968-.458-.968-1.023ZM6.844 4c-.59.537-.924 1.333-.908 2.438.015 1.035.301 1.684.975 2.395l.047.05c.382.404.796.841 1.077 1.435.305.643.417 1.377.417 2.34 0 .566-.433 1.024-.968 1.024-.534 0-.968-.458-.968-1.023 0-.809-.097-1.183-.212-1.426-.126-.268-.318-.484-.762-.953-1.004-1.061-1.517-2.208-1.541-3.81-.024-1.597.48-3.017 1.578-4.02C6.655 1.469 8.179 1 10 1c1.821 0 3.345.468 4.421 1.45C15.52 3.454 16.023 4.874 16 6.47c-.024 1.602-.537 2.749-1.541 3.81-.443.469-.635.685-.762.953-.115.243-.212.618-.213 1.426 0 .565-.433 1.023-.967 1.023-.535 0-.968-.458-.968-1.023 0-.965.113-1.698.417-2.341.28-.594.695-1.031 1.077-1.435l.047-.05c.673-.711.96-1.36.975-2.395.016-1.105-.319-1.901-.908-2.439-.61-.558-1.623-.953-3.156-.953-1.533 0-2.545.396-3.156.953Z",
  "clip-rule": "evenodd"
}, null, -1), MA = [
  yA
];
function CA(t, e) {
  return p(), g("svg", wA, [...MA]);
}
const Pd = I({ name: "icon-LightBulbMd", render: CA }), bA = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, xA = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M16.01 12.474a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.707l1.06-1.06A4 4 0 0 0 10 4.343l-1.06 1.06a.5.5 0 0 1-.708 0l-.707-.706a.5.5 0 0 1 0-.708l1.06-1.06a6 6 0 0 1 8.486 8.485l-1.06 1.06Zm-3.536 2.83a.5.5 0 0 1 0 .707l-1.06 1.06a6.001 6.001 0 1 1-8.485-8.485l1.06-1.06a.5.5 0 0 1 .707 0l.707.706a.5.5 0 0 1 0 .708L4.343 10A4 4 0 1 0 10 15.657l1.06-1.06a.5.5 0 0 1 .707 0l.707.706Zm0-9.193a.5.5 0 0 1 .707 0l.708.707a.5.5 0 0 1 0 .708l-6.364 6.363a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.708l6.363-6.363Z"
}, null, -1), SA = [
  xA
];
function IA(t, e) {
  return p(), g("svg", bA, [...SA]);
}
const AA = I({ name: "icon-LinkMd", render: IA }), kA = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, EA = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M2.5 17.5c-.417 0-.77-.146-1.062-.438A1.444 1.444 0 0 1 1 16c0-.417.146-.77.438-1.062A1.444 1.444 0 0 1 2.5 14.5c.417 0 .77.146 1.062.438.292.291.438.645.438 1.062 0 .417-.146.77-.438 1.062A1.444 1.444 0 0 1 2.5 17.5Zm4-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-12Zm-4-5.5c-.417 0-.77-.146-1.062-.438A1.444 1.444 0 0 1 1 10c0-.417.146-.77.438-1.062A1.444 1.444 0 0 1 2.5 8.5c.417 0 .77.146 1.062.438C3.854 9.229 4 9.583 4 10c0 .417-.146.77-.438 1.062A1.444 1.444 0 0 1 2.5 11.5Zm4-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-12Zm-4-5.5c-.417 0-.77-.146-1.062-.438A1.444 1.444 0 0 1 1 4c0-.417.146-.77.438-1.062A1.444 1.444 0 0 1 2.5 2.5c.417 0 .77.146 1.062.438C3.854 3.229 4 3.583 4 4c0 .417-.146.77-.438 1.062A1.444 1.444 0 0 1 2.5 5.5Zm4-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-12Z"
}, null, -1), PA = [
  EA
];
function TA(t, e) {
  return p(), g("svg", kA, [...PA]);
}
const OA = I({ name: "icon-ListMd", render: TA }), LA = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, DA = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.167 5.167a.667.667 0 0 0-.51.236L10 9.631l6.343-4.228a.667.667 0 0 0-.51-.236H4.167ZM16.5 7.702l-5.945 3.963a1 1 0 0 1-1.11 0L3.5 7.702v6.465a.667.667 0 0 0 .667.666h11.666a.667.667 0 0 0 .667-.666V7.702ZM2.281 3.948c.5-.5 1.178-.781 1.886-.781h11.666A2.667 2.667 0 0 1 18.5 5.833v8.334a2.667 2.667 0 0 1-2.667 2.666H4.167A2.667 2.667 0 0 1 1.5 14.167V5.833c0-.707.281-1.385.781-1.885Z",
  "clip-rule": "evenodd"
}, null, -1), NA = [
  DA
];
function RA(t, e) {
  return p(), g("svg", LA, [...NA]);
}
const Td = I({ name: "icon-MailMd", render: RA }), ZA = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, BA = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 .5a4.25 4.25 0 0 0-4.25 4.25v5a4.25 4.25 0 1 0 8.5 0v-5A4.25 4.25 0 0 0 10 .5ZM8.41 3.159a2.25 2.25 0 0 1 3.84 1.591v5a2.25 2.25 0 1 1-4.5 0v-5c0-.597.237-1.169.66-1.591Z",
  "clip-rule": "evenodd"
}, null, -1), VA = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M16.25 9.5a1 1 0 0 0-1 1v.498l-.004.21A5 5 0 0 1 10.25 16h-.498l-.21-.004A5 5 0 0 1 4.75 11v-.509l-.008-.119-.001-.008a1 1 0 0 0-1.991.136v.5l.004.24v.005A7 7 0 0 0 9 17.96v1.049l.008.119.001.008A1 1 0 0 0 11 19v-1.04A7 7 0 0 0 17.25 11v-.509l-.008-.119-.001-.008a1 1 0 0 0-.991-.864Z"
}, null, -1), FA = [
  BA,
  VA
];
function HA(t, e) {
  return p(), g("svg", ZA, [...FA]);
}
const UA = I({ name: "icon-MicrophoneMd", render: HA }), zA = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, WA = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17.572 8.943H2.056a1.057 1.057 0 0 0 0 2.114h15.514a1.057 1.057 0 0 0 0-2.114Z",
  "clip-rule": "evenodd"
}, null, -1), jA = [
  WA
];
function GA(t, e) {
  return p(), g("svg", zA, [...jA]);
}
const YA = I({ name: "icon-MinusMd", render: GA }), XA = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, KA = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.667 3.333c0-.46.373-.833.833-.833h8.333c.46 0 .833.373.833.833v10.834A3.333 3.333 0 1 1 15 11.279V7.5H8.333v6.667a3.333 3.333 0 1 1-1.667-2.888V3.333Zm1.666 2.5H15V4.167H8.333v1.666Zm5 6.667a1.667 1.667 0 1 1 0 3.333 1.667 1.667 0 0 1 0-3.333ZM5 12.5a1.667 1.667 0 1 1 0 3.333A1.667 1.667 0 0 1 5 12.5Z",
  "clip-rule": "evenodd"
}, null, -1), qA = [
  KA
];
function JA(t, e) {
  return p(), g("svg", XA, [...qA]);
}
const Od = I({ name: "icon-MusicMd", render: JA }), QA = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, ek = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 1a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.586A2 2 0 0 0 13 18.414L18.414 13A2 2 0 0 0 19 11.586V3a2 2 0 0 0-2-2H3Zm14 9V3H3v14h7v-5a2 2 0 0 1 2-2h5Zm-5 6.586V12h4.586L12 16.586Z",
  "clip-rule": "evenodd"
}, null, -1), tk = [
  ek
];
function nk(t, e) {
  return p(), g("svg", QA, [...tk]);
}
const ok = I({ name: "icon-NoteMd", render: nk }), ik = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, rk = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.005.875c2.187 0 3.804.818 4.85 2.136 1.018 1.281 1.414 2.93 1.414 4.489 0 1.796.23 2.687.503 3.265.139.294.304.54.51.816.055.074.118.156.186.244.166.217.362.471.543.737.75 1.101.548 2.255 0 3.06-.494.725-1.372 1.315-2.263 1.315h-3.276a2.5 2.5 0 0 1-4.944 0H4.253c-.891 0-1.769-.59-2.263-1.316-.548-.804-.75-1.958 0-3.059.18-.266.376-.52.543-.737l.186-.244c.206-.276.371-.522.51-.816.272-.578.503-1.469.503-3.265 0-1.56.399-3.209 1.42-4.49C6.198 1.693 7.817.875 10.004.875ZM4.253 14.937h11.495s.025 0 .072-.015a.83.83 0 0 0 .173-.082c.138-.083.27-.204.365-.344a.75.75 0 0 0 .142-.384c.004-.103-.018-.242-.142-.424-.148-.218-.284-.394-.434-.588-.076-.1-.157-.204-.244-.321a6.596 6.596 0 0 1-.717-1.161c-.446-.946-.694-2.164-.694-4.118 0-1.254-.323-2.418-.98-3.245-.63-.792-1.644-1.38-3.284-1.38s-2.658.588-3.29 1.38c-.659.829-.983 1.992-.983 3.245 0 1.954-.248 3.172-.694 4.118-.22.467-.475.836-.717 1.16-.088.118-.168.222-.245.322-.15.194-.285.37-.433.588-.124.182-.147.321-.142.424a.75.75 0 0 0 .142.383c.095.14.227.262.364.345.067.04.127.066.174.082.047.015.071.015.072.015Z",
  "clip-rule": "evenodd"
}, null, -1), ak = [
  rk
];
function sk(t, e) {
  return p(), g("svg", ik, [...ak]);
}
const lk = I({ name: "icon-NotificationMd", render: sk }), dk = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, ck = ["clip-path"], uk = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.24 16.93a6.677 6.677 0 0 1-4.68-5.448 2.308 2.308 0 0 1 .93-2.199 2.33 2.33 0 0 1 .488-2.187l.563-.644c1.662-1.898 4.43-1.9 6.13-.378l.175-3.916a2.278 2.278 0 0 1 4.546.206v.205a2.263 2.263 0 0 1 3.22 2.45l-1.53 10.16.176 2.788a1.576 1.576 0 0 1-1.45 1.693l-6.728.43c-.868.067-1.633-.49-1.7-1.358l-.14-1.802ZM8.034 10.1a1.335 1.335 0 0 0-1.86-1.228 1.35 1.35 0 0 0-.306.186l-.324.26-.022.018c-.13.096-.688-.033-.848-.049a.65.65 0 0 1-.425-1.078l.077-.088.278-.317.178-.203.031-.037c.2-.229.428-.412.671-.552 1.323-.762 3.127-.232 3.742 1.306l.618 1.545.043.106h1.126l.509-7.604.005-.054a.589.589 0 0 1 .202-.384c.081-.07.122-.063.192-.05a.785.785 0 0 0 .225.011c.141-.003.31-.007.39.076a.59.59 0 0 1 .166.401v7.604h1.126l.991-5.473.015-.051a.574.574 0 1 1 1.118.263l-.011.053-1.55 10.274-3.298.284-.742.058-2.75.182-.765-.213a4.988 4.988 0 0 1-3.603-4.102.624.624 0 0 1 .618-.712H4c.157 0 .702.258.78.397l.116.209.05.09.43.77a1.416 1.416 0 0 0 2.657-.689v-1.21Zm6.332 6.772.078 1.01-6.286.488-.078-1.01 6.286-.488Z",
  "clip-rule": "evenodd"
}, null, -1), hk = [
  uk
], fk = ["id"], mk = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}, null, -1), pk = [
  mk
];
function _k(t, e) {
  return p(), g("svg", dk, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...hk], 8, ck),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...pk], 8, fk)
    ])
  ]);
}
const vk = I({ name: "icon-OkMd", render: _k, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), gk = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, $k = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M3 19c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 0 1 1 17V3c0-.55.196-1.021.587-1.413A1.928 1.928 0 0 1 3 1h6a1 1 0 1 1 0 2H3v14h6a1 1 0 1 1 0 2H3Zm11.725-4.725a.999.999 0 0 1-1.412-1.413L15.175 11H8a1 1 0 1 1 0-2h7.175l-1.862-1.862a.999.999 0 0 1 1.412-1.413l3.568 3.568a1 1 0 0 1 0 1.414l-3.568 3.568Z"
}, null, -1), wk = [
  $k
];
function yk(t, e) {
  return p(), g("svg", gk, [...wk]);
}
const Mk = I({ name: "icon-OutMd", render: yk }), Ck = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, bk = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.573 4.569a.909.909 0 0 0-.909.909v3.618a.9.9 0 0 1-.263.636L3.133 10l.268.268a.9.9 0 0 1 .263.636v3.618a.91.91 0 0 0 .91.91.9.9 0 1 1 0 1.8 2.709 2.709 0 0 1-2.71-2.71v-3.245l-.64-.64a.9.9 0 0 1 0-1.273l.64-.641V5.478a2.709 2.709 0 0 1 2.71-2.71.9.9 0 0 1 0 1.8Zm9.954-.9a.9.9 0 0 1 .9-.9 2.709 2.709 0 0 1 2.709 2.709v3.245l.64.64a.9.9 0 0 1 0 1.273l-.64.641v3.245a2.709 2.709 0 0 1-2.709 2.71.9.9 0 0 1 0-1.8.91.91 0 0 0 .909-.91v-3.617a.9.9 0 0 1 .264-.637l.268-.268-.268-.268a.9.9 0 0 1-.264-.636V5.478a.91.91 0 0 0-.909-.91.9.9 0 0 1-.9-.9ZM7 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  "clip-rule": "evenodd"
}, null, -1), xk = [
  bk
];
function Sk(t, e) {
  return p(), g("svg", Ck, [...xk]);
}
const Ik = I({ name: "icon-ParametrMd", render: Sk }), Ak = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, kk = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.659 3c-.41 0-.789.123-1.105.333a1 1 0 0 1-1.108-1.666 4 4 0 1 1 3.546 7.105 1 1 0 1 1-.666-1.886A2.001 2.001 0 0 0 13.659 3ZM7.5 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM3 7.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm11.611 3.158a1 1 0 0 1 1.282-.598c3.043 1.107 3.113 3.635 3.113 3.804a2.636 2.636 0 0 1-2.637 2.636h-.228a1 1 0 0 1 0-2h.228c.35 0 .635-.283.637-.633-.007-.122-.126-1.32-1.797-1.927a1 1 0 0 1-.598-1.282Zm-9.85 1.714a1 1 0 0 1-.15 1.406c-2.02 1.632-1.641 2.887-1.438 3.22l.075.002h8.504c.03 0 .054 0 .075-.002.203-.333.582-1.588-1.438-3.22a1 1 0 0 1 1.257-1.556c2.771 2.239 2.832 4.928 1.567 6.236-.49.507-1.143.542-1.461.542H3.248c-.318 0-.97-.035-1.461-.543C.522 17.15.583 14.46 3.354 12.223a1 1 0 0 1 1.406.15Z",
  "clip-rule": "evenodd"
}, null, -1), Ek = [
  kk
];
function Pk(t, e) {
  return p(), g("svg", Ak, [...Ek]);
}
const Tk = I({ name: "icon-PeopleMd", render: Pk }), Ok = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Lk = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.882 3A.882.882 0 0 0 3 3.857 14.059 14.059 0 0 0 16.143 17a.883.883 0 0 0 .857-.882V13.03l-3.287-1.315-.973 1.623a1 1 0 0 1-1.3.382 11.353 11.353 0 0 1-5.16-5.16 1 1 0 0 1 .382-1.3l1.623-.973L6.97 3H3.882ZM1.844 1.844A2.882 2.882 0 0 1 3.882 1h3.765a1 1 0 0 1 .929.629l1.882 4.705a1 1 0 0 1-.414 1.23l-1.525.914a9.353 9.353 0 0 0 3.003 3.002l.915-1.524a1 1 0 0 1 1.229-.414l4.705 1.883a1 1 0 0 1 .629.928v3.765a2.883 2.883 0 0 1-2.943 2.88A16.06 16.06 0 0 1 1 3.882c0-.764.304-1.497.844-2.038Z",
  "clip-rule": "evenodd"
}, null, -1), Dk = [
  Lk
];
function Nk(t, e) {
  return p(), g("svg", Ok, [...Dk]);
}
const Ld = I({ name: "icon-PhoneMd", render: Nk }), Rk = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Zk = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.882 3A.882.882 0 0 0 3 3.857 14.059 14.059 0 0 0 16.143 17a.883.883 0 0 0 .857-.882V13.03l-3.287-1.315-.973 1.623a1 1 0 0 1-1.3.382 11.353 11.353 0 0 1-5.16-5.16 1 1 0 0 1 .382-1.3l1.623-.973L6.97 3H3.882ZM1.844 1.844A2.882 2.882 0 0 1 3.882 1h3.765a1 1 0 0 1 .929.629l1.882 4.705a1 1 0 0 1-.414 1.23l-1.525.914a9.353 9.353 0 0 0 3.003 3.002l.915-1.524a1 1 0 0 1 1.229-.414l4.705 1.883a1 1 0 0 1 .629.928v3.765a2.883 2.883 0 0 1-2.943 2.88A16.06 16.06 0 0 1 1 3.882c0-.764.304-1.497.844-2.038Zm11.449-.551a1 1 0 0 1 1.414 0L16 2.586l1.293-1.293a1 1 0 1 1 1.414 1.414L17.414 4l1.293 1.293a1 1 0 0 1-1.414 1.414L16 5.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L14.586 4l-1.293-1.293a1 1 0 0 1 0-1.414Z",
  "clip-rule": "evenodd"
}, null, -1), Bk = [
  Zk
];
function Vk(t, e) {
  return p(), g("svg", Rk, [...Bk]);
}
const Fk = I({ name: "icon-PhoneMissedMd", render: Vk }), Hk = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Uk = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 3c-1.19 0-2.35.349-3.338 1.001a5.941 5.941 0 0 0-2.207 2.66 5.855 5.855 0 0 0-.34 3.417 5.902 5.902 0 0 0 1.638 3.032l3.714 3.672a.76.76 0 0 0 1.067 0l3.713-3.672a5.901 5.901 0 0 0 1.638-3.032 5.854 5.854 0 0 0-.34-3.417A5.941 5.941 0 0 0 13.338 4 6.054 6.054 0 0 0 10 3Zm-4.44-.667A8.054 8.054 0 0 1 10 1c1.58 0 3.125.463 4.44 1.333a7.941 7.941 0 0 1 2.95 3.555 7.855 7.855 0 0 1 .456 4.585 7.902 7.902 0 0 1-2.193 4.059l-3.713 3.672a2.76 2.76 0 0 1-3.88 0l-3.713-3.672a7.902 7.902 0 0 1-2.193-4.06 7.855 7.855 0 0 1 .456-4.584 7.941 7.941 0 0 1 2.95-3.555ZM10 7.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM6.5 9a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z",
  "clip-rule": "evenodd"
}, null, -1), zk = [
  Uk
];
function Wk(t, e) {
  return p(), g("svg", Hk, [...zk]);
}
const jk = I({ name: "icon-PinMd", render: Wk }), Gk = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Yk = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M10 19a9 9 0 1 1 0-18 9 9 0 0 1 0 18Zm0-2a7.001 7.001 0 0 0 4.95-11.95A7 7 0 1 0 10 17Z"
}, null, -1), Xk = [
  Yk
];
function Kk(t, e) {
  return p(), g("svg", Gk, [...Xk]);
}
const qk = I({ name: "icon-PlaceholderMd", render: Kk }), Jk = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Qk = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.005 2.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm1.188 5.85a1 1 0 0 1-.109 1.41c-2.736 2.345-2.107 4.278-1.74 4.734l.013.001a.984.984 0 0 0 .106.005h11.182a.983.983 0 0 0 .12-.006c.366-.456.994-2.39-1.742-4.735a1 1 0 1 1 1.302-1.518c3.391 2.907 3.276 6.259 1.807 7.718-.495.491-1.134.541-1.487.541H4.463c-.354 0-.993-.05-1.487-.541-1.47-1.46-1.585-4.811 1.807-7.718a1 1 0 0 1 1.41.108Z",
  "clip-rule": "evenodd"
}, null, -1), eE = [
  Qk
];
function tE(t, e) {
  return p(), g("svg", Jk, [...eE]);
}
const Gr = I({ name: "icon-ProfileMd", render: tE }), nE = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, oE = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.505.5a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
  "clip-rule": "evenodd"
}, null, -1), iE = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M5.584 12.76a1 1 0 1 0-1.301-1.52C.89 14.149 1.007 17.5 2.476 18.96c.494.491 1.133.541 1.487.541h6.59a1 1 0 1 0 0-2h-6.59a.984.984 0 0 1-.106-.005l-.013-.002c-.367-.455-.996-2.388 1.74-4.734ZM16.112 15.07l-1.123 1.073a.881.881 0 0 0-.27.632.88.88 0 0 0 .27.632.933.933 0 0 0 .65.262.933.933 0 0 0 .65-.262l2.711-2.6a1.022 1.022 0 0 0 0-1.475l-2.711-2.596a.933.933 0 0 0-.65-.261.933.933 0 0 0-.65.261.88.88 0 0 0-.27.632c0 .237.098.464.27.632l1.12 1.07h-4.555a1 1 0 0 0 0 2h4.558Z"
}, null, -1), rE = [
  oE,
  iE
];
function aE(t, e) {
  return p(), g("svg", nE, [...rE]);
}
const sE = I({ name: "icon-ReassignMd", render: aE }), lE = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, dE = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.973 2.41a7.75 7.75 0 0 0-6.64 2.379v-.622a1 1 0 0 0-2 0V7.5a1 1 0 0 0 1 1h3.334a1 1 0 1 0 0-2H5.494a5.75 5.75 0 0 1 10.183 2.804 1 1 0 1 0 1.98-.275 7.75 7.75 0 0 0-6.684-6.62Zm-6.649 8.286a1 1 0 0 0-1.98.275 7.75 7.75 0 0 0 13.323 4.24v.622a1 1 0 1 0 2 0V12.5a1 1 0 0 0-1-1h-3.333a1 1 0 1 0 0 2h1.172a5.75 5.75 0 0 1-10.182-2.804Z",
  "clip-rule": "evenodd"
}, null, -1), cE = [
  dE
];
function uE(t, e) {
  return p(), g("svg", lE, [...cE]);
}
const hE = I({ name: "icon-RefreshMd", render: uE }), fE = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, mE = ["clip-path"], pE = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M15.672 5.95H8.5a6 6 0 1 0 0 12h8a1 1 0 1 1 0 2h-8a8 8 0 0 1 0-16h7.172l-1.829-1.829A1 1 0 1 1 15.257.707l3.536 3.536a1 1 0 0 1 0 1.414l-3.536 3.536a1 1 0 0 1-1.414-1.414l1.829-1.829Z"
}, null, -1), _E = [
  pE
], vE = ["id"], gE = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}, null, -1), $E = [
  gE
];
function wE(t, e) {
  return p(), g("svg", fE, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [..._E], 8, mE),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...$E], 8, vE)
    ])
  ]);
}
const yE = I({ name: "icon-ReopenMd", render: wE, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), ME = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, CE = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.578 2.506a.913.913 0 1 0-1.291 1.291l.349.349H5.312c-.76 0-1.375.616-1.375 1.375V8.27a.917.917 0 1 0 1.834 0V5.979h7.865l-.349.349a.913.913 0 1 0 1.291 1.291l1.585-1.585a1.375 1.375 0 0 0 0-1.944l-1.585-1.584Zm.588 8.265a.917.917 0 0 0-.916.916v2.271H6.385l.349-.35a.913.913 0 1 0-1.291-1.29l-1.589 1.588a1.375 1.375 0 0 0-.003 1.94l1.584 1.596a.915.915 0 1 0 1.291-1.298l-.337-.331h8.319c.76 0 1.375-.616 1.375-1.375v-2.75a.916.916 0 0 0-.917-.917Z",
  "clip-rule": "evenodd"
}, null, -1), bE = [
  CE
];
function xE(t, e) {
  return p(), g("svg", ME, [...bE]);
}
const SE = I({ name: "icon-RepeatMd", render: xE }), IE = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, AE = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.992 2.366a7.667 7.667 0 0 1 7.624 6.67 1 1 0 0 1-1.983.26 5.667 5.667 0 1 0-1.136 4.204h-2.039a1 1 0 1 1 0-2h4.167a1 1 0 0 1 1 1v4.167a1 1 0 0 1-2 0v-1.409A7.668 7.668 0 0 1 2.407 9.082a7.667 7.667 0 0 1 7.585-6.716Z",
  "clip-rule": "evenodd"
}, null, -1), kE = [
  AE
];
function EE(t, e) {
  return p(), g("svg", IE, [...kE]);
}
const PE = I({ name: "icon-RotateMd", render: EE }), TE = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, OE = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.119 3a1 1 0 0 1 1-1h6.357a4.179 4.179 0 0 1 0 8.357H7.12v2.238h5.357a1 1 0 1 1 0 2H7.12v3.238a1 1 0 1 1-2 0v-3.238H4a1 1 0 1 1 0-2h1.119v-2.238H4a1 1 0 1 1 0-2h1.119V3Zm2 5.357h5.357a2.179 2.179 0 0 0 0-4.357H7.12v4.357Z",
  "clip-rule": "evenodd"
}, null, -1), LE = [
  OE
];
function DE(t, e) {
  return p(), g("svg", TE, [...LE]);
}
const NE = I({ name: "icon-RubelMd", render: DE }), RE = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, ZE = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.658 1.5a7.158 7.158 0 1 0 4.39 12.813l3.925 3.925a.895.895 0 1 0 1.265-1.265l-3.925-3.926A7.158 7.158 0 0 0 8.657 1.5ZM3.289 8.658a5.368 5.368 0 1 1 10.737 0 5.368 5.368 0 0 1-10.737 0Z",
  "clip-rule": "evenodd"
}, null, -1), BE = [
  ZE
];
function VE(t, e) {
  return p(), g("svg", RE, [...BE]);
}
const FE = I({ name: "icon-SearchMd", render: VE }), HE = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, UE = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17.533 1.667a.834.834 0 0 1 .74 1.144l-5.406 14.972a1.292 1.292 0 0 1-2.367.08l-2.788-5.575L2.136 9.5a1.292 1.292 0 0 1 .08-2.367l14.99-5.413a.832.832 0 0 1 .327-.053Zm-3.264 2.886L3.643 8.39l4.526 2.263 6.1-6.1ZM9.347 11.83l6.1-6.099-3.837 10.625-2.263-4.526Z",
  "clip-rule": "evenodd"
}, null, -1), zE = [
  UE
];
function WE(t, e) {
  return p(), g("svg", HE, [...zE]);
}
const jE = I({ name: "icon-SendMd", render: WE }), GE = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, YE = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.474 2.717C7.474 1.77 8.242 1 9.19 1h1.618c.949 0 1.718.769 1.718 1.717v.652l.31.15.378-.405a1.717 1.717 0 0 1 2.47-.042l1.226 1.226c.7.7.665 1.847-.078 2.502l-.37.327.168.347h.652c.948 0 1.717.768 1.717 1.717v1.618c0 .949-.769 1.718-1.717 1.718h-.652l-.169.346.37.327c.744.655.78 1.801.079 2.502l-1.226 1.226a1.717 1.717 0 0 1-2.47-.042l-.377-.404-.311.15v.65c0 .95-.77 1.718-1.718 1.718H9.191a1.717 1.717 0 0 1-1.717-1.717v-.652l-.312-.15-.377.405c-.663.71-1.783.729-2.47.042L3.09 15.702c-.7-.7-.665-1.847.078-2.502l.37-.327-.168-.346h-.652A1.717 1.717 0 0 1 1 10.809V9.191c0-.949.769-1.717 1.717-1.717h.652l.169-.347-.37-.327a1.717 1.717 0 0 1-.079-2.502l1.226-1.226a1.717 1.717 0 0 1 2.47.042l.377.405.312-.15v-.652Zm1.816.1v.614c0 .65-.368 1.245-.95 1.536H8.34l-.542.259a1.717 1.717 0 0 1-1.913-.415l-.357-.382-1.08 1.079.348.307c.565.497.74 1.305.431 1.991l-.001.003-.258.531c-.29.582-.886.95-1.536.95h-.615v1.42h.615c.65 0 1.245.368 1.536.95l.26.534a1.717 1.717 0 0 1-.432 1.991l-.347.307 1.079 1.08.357-.383a1.717 1.717 0 0 1 1.913-.415l.004.002.54.257c.581.29.949.886.949 1.536v.615h1.42v-.615c0-.65.368-1.245.95-1.536h.001l.542-.259a1.717 1.717 0 0 1 1.913.415l.357.383 1.08-1.08-.349-.307a1.717 1.717 0 0 1-.43-1.991l.001-.003.258-.53v-.001c.29-.582.886-.95 1.536-.95h.615V9.29h-.615c-.65 0-1.245-.368-1.536-.95l-.26-.534a1.717 1.717 0 0 1 .431-1.991l.348-.307-1.079-1.08-.357.383a1.717 1.717 0 0 1-1.913.415l-.004-.002-.54-.257a1.717 1.717 0 0 1-.949-1.536v-.615H9.29Z",
  "clip-rule": "evenodd"
}, null, -1), XE = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 8.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2ZM6.6 10a3.4 3.4 0 1 1 6.8 0 3.4 3.4 0 0 1-6.8 0Z",
  "clip-rule": "evenodd"
}, null, -1), KE = [
  YE,
  XE
];
function qE(t, e) {
  return p(), g("svg", GE, [...KE]);
}
const JE = I({ name: "icon-SettingsMd", render: qE }), QE = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, eP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m12.293 2.707 1.912 1.912c-.327-.05-.68-.098-1.052-.137-1.67-.177-3.925-.214-5.6.624C6.247 5.758 5.5 7.025 5.09 7.974a9.48 9.48 0 0 0-.566 1.802l-.007.035-.002.01v.006l-.001.001L5.5 10l-.985-.171a1 1 0 0 0 1.97.345v-.002l.003-.016.016-.076a7.483 7.483 0 0 1 .423-1.313c.347-.804.85-1.537 1.52-1.873 1.12-.56 2.864-.596 4.496-.423.727.076 1.386.19 1.883.289l-2.533 2.533a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4a1 1 0 1 0-1.414 1.414ZM2.5 12a1 1 0 0 1 1 1v2.9a.6.6 0 0 0 .6.6h11.8a.6.6 0 0 0 .6-.6V13a1 1 0 1 1 2 0v3.5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V13a1 1 0 0 1 1-1Z",
  "clip-rule": "evenodd"
}, null, -1), tP = [
  eP
];
function nP(t, e) {
  return p(), g("svg", QE, [...tP]);
}
const oP = I({ name: "icon-ShareMd", render: nP }), iP = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, rP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-9 7a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5.5-1.667a1 1 0 0 1 1-1h.008a1 1 0 1 1 0 2H7.5a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h.008a1 1 0 1 1 0 2H12.5a1 1 0 0 1-1-1Zm-4.283 3.453a1 1 0 0 1 1.414.014 1.916 1.916 0 0 0 2.738 0 1 1 0 0 1 1.429 1.4 3.919 3.919 0 0 1-5.596 0 1 1 0 0 1 .015-1.414Z",
  "clip-rule": "evenodd"
}, null, -1), aP = [
  rP
];
function sP(t, e) {
  return p(), g("svg", iP, [...aP]);
}
const Dd = I({ name: "icon-SmileMd", render: sP }), lP = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, dP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.556 1.685A9 9 0 0 1 18.43 6.848a1.006 1.006 0 0 1 .111.315 9 9 0 1 1-17.082 0 1.004 1.004 0 0 1 .111-.315 8.984 8.984 0 0 1 2.066-3.212 9 9 0 0 1 2.92-1.95ZM3.127 8.671a7 7 0 0 0 1.839 6.193l1.27-1.463-1.275-4.02-1.834-.71Zm3.813.337 1.125 3.548h3.87l1.125-3.548L10 6.791 6.94 9.008ZM11 5.045l3.377 2.448 1.839-.713A6.999 6.999 0 0 0 11 3.072v1.973ZM9 3.072A7 7 0 0 0 3.784 6.78l1.839.713L9 5.045V3.072Zm7.873 5.599-1.834.71-1.254 3.955 1.262 1.514a7 7 0 0 0 1.826-6.18Zm-3.404 7.41-1.27-1.525H7.88L6.55 16.09A7.012 7.012 0 0 0 10 17a7.001 7.001 0 0 0 3.469-.92Z",
  "clip-rule": "evenodd"
}, null, -1), cP = [
  dP
];
function uP(t, e) {
  return p(), g("svg", lP, [...cP]);
}
const Nd = I({ name: "icon-SoccerMd", render: uP }), hP = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, fP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM12 4.5a3.5 3.5 0 1 1 .948 2.395L7.98 9.625a3.54 3.54 0 0 1 0 .75l4.968 2.73a3.5 3.5 0 1 1-.896 1.79 1.002 1.002 0 0 1-.034-.019L7.2 12.227a3.5 3.5 0 1 1 0-4.455l4.818-2.648c.011-.007.023-.012.034-.018A3.526 3.526 0 0 1 12 4.5Zm-7.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
  "clip-rule": "evenodd"
}, null, -1), mP = [
  fP
];
function pP(t, e) {
  return p(), g("svg", hP, [...mP]);
}
const _P = I({ name: "icon-SocialsMd", render: pP }), vP = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, gP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H9ZM6.17 2A3.001 3.001 0 0 1 9 0h2c1.306 0 2.418.835 2.83 2H15a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1.17Zm0 2H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 11 6H9a3.001 3.001 0 0 1-2.83-2ZM7 9a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Zm6 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-3 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1Z",
  "clip-rule": "evenodd"
}, null, -1), $P = [
  gP
];
function wP(t, e) {
  return p(), g("svg", vP, [...$P]);
}
const yP = I({ name: "icon-StatisticMd", render: wP }), MP = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, CP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 1a1 1 0 0 1 1 1v4.571h5.075v-.143c0-.578.238-1.126.65-1.526.41-.398.962-.616 1.53-.616h4.566c.568 0 1.119.218 1.53.616.412.4.649.948.649 1.526v2.286c0 .579-.238 1.127-.65 1.526a2.199 2.199 0 0 1-1.53.617h-4.565a2.198 2.198 0 0 1-1.53-.617c-.412-.399-.65-.947-.65-1.526v-.143H4v6c0 .028.011.061.041.09.032.03.08.053.138.053h4.896v-.143c0-.578.238-1.127.65-1.526.41-.398.962-.617 1.53-.617h4.566c.568 0 1.119.219 1.53.617.412.4.649.948.649 1.526v2.286c0 .579-.238 1.127-.65 1.526a2.199 2.199 0 0 1-1.53.617h-4.565a2.199 2.199 0 0 1-1.53-.617c-.412-.399-.65-.947-.65-1.526v-.143H4.18a2.198 2.198 0 0 1-1.53-.616C2.237 15.698 2 15.15 2 14.57V2a1 1 0 0 1 1-1Zm8.075 15.857c0 .028.011.06.042.09.031.03.08.053.138.053h4.566a.2.2 0 0 0 .138-.053.126.126 0 0 0 .041-.09v-2.286a.126.126 0 0 0-.041-.09.2.2 0 0 0-.138-.053h-4.566a.199.199 0 0 0-.138.053.126.126 0 0 0-.042.09v2.286Zm0-8.143c0 .028.011.06.042.09.031.03.08.053.138.053h4.566a.2.2 0 0 0 .138-.053.126.126 0 0 0 .041-.09V6.428a.126.126 0 0 0-.041-.09.2.2 0 0 0-.138-.052h-4.566a.199.199 0 0 0-.138.052.126.126 0 0 0-.042.09v2.286Z",
  "clip-rule": "evenodd"
}, null, -1), bP = [
  CP
];
function xP(t, e) {
  return p(), g("svg", MP, [...bP]);
}
const SP = I({ name: "icon-SubtaskMd", render: xP }), IP = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, AP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 3.5c-.995 0-1.845.623-2.18 1.5h4.36A2.334 2.334 0 0 0 10 3.5Zm0-2A4.335 4.335 0 0 0 5.747 5H2.889C1.739 5 1 6.01 1 7v10c0 .99.738 2 1.889 2H17.11C18.261 19 19 17.99 19 17V7c0-.99-.738-2-1.889-2h-2.858A4.335 4.335 0 0 0 10 1.5ZM17 7H3v10h14V7ZM9 9a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H9Z",
  "clip-rule": "evenodd"
}, null, -1), kP = [
  AP
];
function EP(t, e) {
  return p(), g("svg", IP, [...kP]);
}
const PP = I({ name: "icon-SuitcaseMd", render: EP }), TP = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, OP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.11 2.11A3.79 3.79 0 0 1 4.79 1h3.655c.76 0 1.489.302 2.026.84l7.69 7.688a2.866 2.866 0 0 1 0 4.053m0 0-4.58 4.58a2.866 2.866 0 0 1-4.053 0l-7.689-7.69A2.866 2.866 0 0 1 1 8.446V4.79c0-1.005.4-1.968 1.11-2.68m2.68.786a1.895 1.895 0 0 0-1.895 1.894v3.656a.97.97 0 0 0 .284.687l7.689 7.689a.972.972 0 0 0 1.373 0l4.58-4.58a.971.971 0 0 0 0-1.373L9.13 3.179a.971.971 0 0 0-.686-.284H4.79Z",
  "clip-rule": "evenodd"
}, null, -1), LP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M7.631 6.21a1.421 1.421 0 1 1-2.842 0 1.421 1.421 0 0 1 2.843 0Z"
}, null, -1), DP = [
  OP,
  LP
];
function NP(t, e) {
  return p(), g("svg", TP, [...DP]);
}
const RP = I({ name: "icon-TagMd", render: NP }), ZP = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, BP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1-3a3.001 3.001 0 0 0-2.83 2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3h-1.17A3.001 3.001 0 0 0 11 0H9ZM5 4h1.17A3.001 3.001 0 0 0 9 6h2a3.001 3.001 0 0 0 2.83-2H15a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm7.747 6.664a1 1 0 0 0-1.494-1.328l-1.92 2.159-.586-.66a1 1 0 0 0-1.494 1.33l1.333 1.5a1 1 0 0 0 1.495 0l2.666-3Z",
  "clip-rule": "evenodd"
}, null, -1), VP = [
  BP
];
function FP(t, e) {
  return p(), g("svg", ZP, [...VP]);
}
const HP = I({ name: "icon-TaskMd", render: FP }), UP = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, zP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2 3.6A1.6 1.6 0 0 1 3.6 2h12.8A1.6 1.6 0 0 1 18 3.6v12.8a1.6 1.6 0 0 1-1.6 1.6H3.6A1.6 1.6 0 0 1 2 16.4V3.6ZM4 4h12v12H4V4Zm7.137 1.2a.91.91 0 0 0-.855.598l-2.793 7.66a1 1 0 0 0 .94 1.342h.05a1 1 0 0 0 .949-.684L12 6.398a.91.91 0 0 0-.864-1.198Z",
  "clip-rule": "evenodd"
}, null, -1), WP = [
  zP
];
function jP(t, e) {
  return p(), g("svg", UP, [...WP]);
}
const GP = I({ name: "icon-TemplateMd", render: jP }), YP = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, XP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.556 1.685a9 9 0 1 1 6.888 16.63 9 9 0 0 1-6.888-16.63ZM10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm0 2a1 1 0 0 1 1 1v3.465l2.555 1.703a1 1 0 0 1-1.11 1.664l-3-2A1 1 0 0 1 9 10V6a1 1 0 0 1 1-1Z",
  "clip-rule": "evenodd"
}, null, -1), KP = [
  XP
];
function qP(t, e) {
  return p(), g("svg", YP, [...KP]);
}
const Rd = I({ name: "icon-TimeMd", render: qP }), JP = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, QP = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.875 10A9.125 9.125 0 0 1 10 .875a1 1 0 1 1 0 2A7.125 7.125 0 1 0 17.125 10a1 1 0 1 1 2 0 9.125 9.125 0 1 1-18.25 0Z",
  "clip-rule": "evenodd"
}, null, -1), eT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.187 5.875a1 1 0 0 1 1 1v3.384l2.22 1.394a1 1 0 1 1-1.064 1.694l-2.687-1.688a1 1 0 0 1-.469-.847V6.875a1 1 0 0 1 1-1Z",
  "clip-rule": "evenodd"
}, null, -1), tT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M15.125 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM18.063 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
}, null, -1), nT = [
  QP,
  eT,
  tT
];
function oT(t, e) {
  return p(), g("svg", JP, [...nT]);
}
const iT = I({ name: "icon-TimerMd", render: oT }), rT = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, aT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1 4.5a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z",
  "clip-rule": "evenodd"
}, null, -1), sT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.933 3.502a1 1 0 0 1 1.065.931L5.936 17.5h8.128l.938-13.067a1 1 0 0 1 1.996.134l-.938 13.066a2 2 0 0 1-1.996 1.867H5.936a2 2 0 0 1-1.996-1.867L3.002 4.567a1 1 0 0 1 .931-1.065Z",
  "clip-rule": "evenodd"
}, null, -1), lT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5 2.5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2a1 1 0 1 1-2 0v-2H7v2a1 1 0 0 1-2 0v-2Z",
  "clip-rule": "evenodd"
}, null, -1), dT = [
  aT,
  sT,
  lT
];
function cT(t, e) {
  return p(), g("svg", rT, [...dT]);
}
const uT = I({ name: "icon-TrashMd", render: cT }), hT = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, fT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.333 6.667c0-.46.373-.834.833-.834h6.667c.46 0 .833.373.833.834v6.666c0 .46-.373.834-.833.834H4.166a.833.833 0 0 1-.833-.834V6.667Zm10 6.348v.318a2.5 2.5 0 0 1-2.5 2.5H4.166a2.5 2.5 0 0 1-2.5-2.5V6.667a2.5 2.5 0 0 1 2.5-2.5h6.667a2.5 2.5 0 0 1 2.5 2.5v.318l2.588-1.294a1.667 1.667 0 0 1 2.412 1.49v5.637a1.667 1.667 0 0 1-2.411 1.49l-2.589-1.293Zm0-1.863 3.333 1.666V7.182L13.333 8.85v2.303Z",
  "clip-rule": "evenodd"
}, null, -1), mT = [
  fT
];
function pT(t, e) {
  return p(), g("svg", hT, [...mT]);
}
const Zd = I({ name: "icon-VideoMd", render: pT }), _T = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, vT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.99 4.618 5.414 7.963a1 1 0 0 1-.793.39H3v3.294h1.621a1 1 0 0 1 .793.39l2.576 3.345V4.618Zm-.333-2.49a1.693 1.693 0 0 1 2.103.704c.19.319.27.69.23 1.057v12.222a1.71 1.71 0 0 1-1.149 1.8 1.693 1.693 0 0 1-1.998-.741l-2.714-3.523H2.874c-.5 0-.978-.2-1.329-.555A1.887 1.887 0 0 1 1 11.765v-3.53c0-.496.195-.973.545-1.327a1.87 1.87 0 0 1 1.329-.555h1.255L6.843 2.83a1.7 1.7 0 0 1 .814-.703Zm5.815 1.41a1 1 0 0 1 1.407-.15 8.5 8.5 0 0 1 2.327 2.949C17.752 7.48 18 8.732 18 10c0 1.268-.248 2.52-.794 3.663a8.5 8.5 0 0 1-2.327 2.948 1 1 0 0 1-1.258-1.555 6.502 6.502 0 0 0 0-10.112 1 1 0 0 1-.149-1.406ZM11.2 6.067a1 1 0 0 1 1.4-.2 5.166 5.166 0 0 1 0 8.266 1 1 0 1 1-1.2-1.6 3.166 3.166 0 0 0 0-5.066 1 1 0 0 1-.2-1.4Z",
  "clip-rule": "evenodd"
}, null, -1), gT = [
  vT
];
function $T(t, e) {
  return p(), g("svg", _T, [...gT]);
}
const Bd = I({ name: "icon-VolumeMd", render: $T }), wT = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, yT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.293 7.626a1 1 0 0 1 1.414 0l.96.96.96-.96A1 1 0 1 1 17.04 9.04l-.96.96.96.96a1 1 0 1 1-1.414 1.414l-.96-.96-.959.96a1 1 0 0 1-1.414-1.414l.96-.96-.96-.96a1 1 0 0 1 0-1.414ZM7.99 4.618 5.414 7.963a1 1 0 0 1-.793.39H3v3.294h1.621a1 1 0 0 1 .793.39l2.576 3.345V4.618Zm-.333-2.49a1.693 1.693 0 0 1 2.103.704c.19.319.27.69.23 1.057v12.222a1.71 1.71 0 0 1-1.149 1.8 1.693 1.693 0 0 1-1.998-.741l-2.714-3.523H2.874c-.5 0-.978-.2-1.329-.555A1.887 1.887 0 0 1 1 11.765v-3.53c0-.496.195-.973.545-1.327a1.87 1.87 0 0 1 1.329-.555h1.255L6.843 2.83a1.7 1.7 0 0 1 .814-.703Z",
  "clip-rule": "evenodd"
}, null, -1), MT = [
  yT
];
function CT(t, e) {
  return p(), g("svg", wT, [...MT]);
}
const Vd = I({ name: "icon-VolumeOffMd", render: CT }), bT = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, xT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.5 3.333c0-.92.746-1.666 1.667-1.666h11.666c.92 0 1.667.746 1.667 1.666v13.334c0 .92-.746 1.666-1.667 1.666H4.167c-.92 0-1.667-.746-1.667-1.666V3.333Zm13.333 0H4.167v13.334h11.666V3.333Z",
  "clip-rule": "evenodd"
}, null, -1), ST = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.833 13.333c0-.46.373-.833.834-.833h4.166a.833.833 0 1 1 0 1.667H6.667a.833.833 0 0 1-.834-.834ZM5.833 10c0-.46.373-.833.834-.833H12.5a.833.833 0 0 1 0 1.666H6.667A.833.833 0 0 1 5.833 10ZM5.833 6.667c0-.46.373-.834.834-.834H12.5a.833.833 0 0 1 0 1.667H6.667a.833.833 0 0 1-.834-.833Z",
  "clip-rule": "evenodd"
}, null, -1), IT = [
  xT,
  ST
];
function AT(t, e) {
  return p(), g("svg", bT, [...IT]);
}
const kT = I({ name: "icon-WABATemplateMd", render: AT }), ET = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, PT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.996 1.997A2.833 2.833 0 0 1 4 1.167h10A1.833 1.833 0 0 1 15.833 3v2.167H16A1.833 1.833 0 0 1 17.833 7v2.167H18c.46 0 .833.373.833.833v4c0 .46-.373.833-.833.833h-.167V17A1.834 1.834 0 0 1 16 18.833H4A2.833 2.833 0 0 1 1.167 16V4c0-.751.298-1.472.83-2.003Zm.837 4.585V16A1.167 1.167 0 0 0 4 17.167h12a.167.167 0 0 0 .166-.167v-2.167H14a2.833 2.833 0 0 1 0-5.666h2.166V7A.167.167 0 0 0 16 6.833H4c-.406 0-.804-.087-1.167-.251Zm11.334-1.415H4a1.167 1.167 0 1 1 0-2.334h10a.167.167 0 0 1 .166.167v2.167ZM14 10.833a1.167 1.167 0 0 0 0 2.334h3.166v-2.334H14Z",
  "clip-rule": "evenodd"
}, null, -1), TT = [
  PT
];
function OT(t, e) {
  return p(), g("svg", ET, [...TT]);
}
const LT = I({ name: "icon-WalletMd", render: OT }), DT = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, NT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.992 1.474a2.667 2.667 0 0 0-2.328 1.365L1.75 13.04c-.023.04-.043.082-.06.125a2.667 2.667 0 0 0 2.333 3.667 1 1 0 0 0 .097 0l.046.001H15.84a2.667 2.667 0 0 0 2.454-3.666.999.999 0 0 0-.062-.127L12.32 2.84a2.667 2.667 0 0 0-2.328-1.366Zm-5.825 13.36H4.12a.667.667 0 0 1-.596-.865L9.399 3.835l.01-.018a.667.667 0 0 1 1.166 0l.01.018 5.873 10.133a.667.667 0 0 1-.629.865H4.167ZM11 7.5a1 1 0 1 0-2 0v1.667a1 1 0 0 0 2 0V7.5Zm0 5a1 1 0 1 0-2 0v.008a1 1 0 1 0 2 0V12.5Z",
  "clip-rule": "evenodd"
}, null, -1), RT = [
  NT
];
function ZT(t, e) {
  return p(), g("svg", DT, [...RT]);
}
const Fd = I({ name: "icon-WarningMd", render: ZT }), BT = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, VT = ["clip-path"], FT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17 3H3v2h14V3ZM3 1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3Zm14 9H3v4h14v-4ZM3 8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H3Zm0 11h14v4H3v-4Zm-2 0a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-4Z",
  "clip-rule": "evenodd"
}, null, -1), HT = [
  FT
], UT = ["id"], zT = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}, null, -1), WT = [
  zT
];
function jT(t, e) {
  return p(), g("svg", BT, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...HT], 8, VT),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...WT], 8, UT)
    ])
  ]);
}
const GT = I({ name: "icon-WeekMd", render: jT, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), YT = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, XT = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M18.21 1.795a.995.995 0 0 1 .29.702V7.5a1 1 0 1 1-2 0V4.914l-4.543 4.543a1 1 0 1 1-1.414-1.414L15.086 3.5H12.5a1 1 0 1 1 0-2h5c.275 0 .524.111.705.29l.004.005Zm-8.753 8.748a1 1 0 0 1 0 1.414L4.914 16.5H7.5a1 1 0 1 1 0 2H2.497a.997.997 0 0 1-.702-.29l-.004-.005A.997.997 0 0 1 1.5 17.5v-5a1 1 0 1 1 2 0v2.586l4.543-4.543a1 1 0 0 1 1.414 0Z",
  "clip-rule": "evenodd"
}, null, -1), KT = [
  XT
];
function qT(t, e) {
  return p(), g("svg", YT, [...KT]);
}
const JT = I({ name: "icon-FullscreenMd", render: qT }), QT = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, eO = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.348 1.812a8.843 8.843 0 0 0-8.942 15.016H2.232a1 1 0 1 0 0 2h4.883a1 1 0 0 0 1-1V12.945a1 1 0 1 0-2 0v2.673A6.843 6.843 0 0 1 12.6 3.668a1 1 0 0 0 .747-1.856Zm3.917 3.477a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0v-.01Zm-6.243 11.48a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1Zm4.75-.533a1 1 0 1 0-2 0v.01a1 1 0 0 0 2 0v-.01Zm1.47-4.193a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1Zm1.557-3.004a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0v-.01Z",
  "clip-rule": "evenodd"
}, null, -1), tO = [
  eO
];
function nO(t, e) {
  return p(), g("svg", QT, [...tO]);
}
const oO = I({ name: "icon-RotateLeftMd", render: nO }), iO = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, rO = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.652 1.812a8.843 8.843 0 0 1 8.942 15.016h2.174a1 1 0 1 1 0 2h-4.883a1 1 0 0 1-1-1V12.945a1 1 0 1 1 2 0v2.673A6.842 6.842 0 0 0 7.4 3.668a1 1 0 1 1-.747-1.856ZM2.734 5.289a1 1 0 0 1 2 0v.01a1 1 0 1 1-2 0v-.01Zm6.244 11.48a1 1 0 0 0-1 1v.01a1 1 0 1 0 2 0v-.01a1 1 0 0 0-1-1Zm-4.75-.533a1 1 0 1 1 2 0v.01a1 1 0 1 1-2 0v-.01Zm-1.47-4.193a1 1 0 0 0-1 1v.01a1 1 0 1 0 2 0v-.01a1 1 0 0 0-1-1ZM1.201 9.039a1 1 0 1 1 2 0v.01a1 1 0 0 1-2 0v-.01Z",
  "clip-rule": "evenodd"
}, null, -1), aO = [
  rO
];
function sO(t, e) {
  return p(), g("svg", iO, [...aO]);
}
const lO = I({ name: "icon-RotateRightMd", render: sO }), dO = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, cO = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.715 1.845a1.4 1.4 0 0 1 2.57 0l-.83.365.83-.365 1.928 4.385 4.55.566c1.248.155 1.61 1.664.802 2.447l-3.394 3.292.903 4.768c.205 1.081-.94 2.177-2.087 1.504L10 16.467l-3.987 2.34c-1.147.673-2.292-.423-2.087-1.504l.903-4.768-3.394-3.292c-.807-.783-.446-2.292.801-2.447l4.55-.566 1.93-4.385.897.395-.898-.395ZM10 3.892 8.484 7.338a1.409 1.409 0 0 1-1.113.835l-3.694.459 2.764 2.68c.352.341.498.834.41 1.3l-.722 3.808 3.166-1.859a1.39 1.39 0 0 1 1.41 0l3.166 1.859-.721-3.808a1.44 1.44 0 0 1 .41-1.3l2.763-2.68-3.694-.46a1.409 1.409 0 0 1-1.113-.834L10 3.892Z",
  "clip-rule": "evenodd"
}, null, -1), uO = [
  cO
];
function hO(t, e) {
  return p(), g("svg", dO, [...uO]);
}
const fO = I({ name: "icon-StarMd", render: hO }), mO = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, pO = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M6.76 14.5 10 11.26l3.24 3.24 1.26-1.26L11.26 10l3.24-3.24-1.26-1.26L10 8.74 6.76 5.5 5.5 6.76 8.74 10 5.5 13.24l1.26 1.26ZM10 19a8.759 8.759 0 0 1-3.51-.71 9.103 9.103 0 0 1-2.858-1.922A9.082 9.082 0 0 1 1.71 13.51 8.78 8.78 0 0 1 1 10c0-1.245.236-2.415.71-3.51a9.103 9.103 0 0 1 1.922-2.858A9.082 9.082 0 0 1 6.49 1.71 8.78 8.78 0 0 1 10 1c1.245 0 2.415.236 3.51.71a9.103 9.103 0 0 1 2.857 1.922 9.095 9.095 0 0 1 1.925 2.858A8.748 8.748 0 0 1 19 10a8.759 8.759 0 0 1-.71 3.51 9.103 9.103 0 0 1-1.922 2.857 9.095 9.095 0 0 1-2.858 1.925A8.748 8.748 0 0 1 10 19Zm0-1.8c2.01 0 3.713-.697 5.107-2.092C16.503 13.712 17.2 12.01 17.2 10s-.697-3.713-2.092-5.107C13.712 3.498 12.01 2.8 10 2.8s-3.713.698-5.107 2.093C3.498 6.287 2.8 7.99 2.8 10c0 2.01.698 3.713 2.093 5.107C6.287 16.503 7.99 17.2 10 17.2Z"
}, null, -1), _O = [
  pO
];
function vO(t, e) {
  return p(), g("svg", mO, [..._O]);
}
const gO = I({ name: "icon-CancelMd", render: vO }), $O = {
  component: "",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wO = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.346 5.6c.33.16.539.489.539.847v7.106a.961.961 0 0 1-.975.947.961.961 0 0 1-.974-.947v-5.21l-.877.639a.993.993 0 0 1-1.364-.19.93.93 0 0 1 .195-1.326l2.436-1.777a.997.997 0 0 1 1.02-.089Zm2.244.847a.96.96 0 0 1 .974-.947h2.74c.501 0 .981.193 1.335.538.354.344.553.81.553 1.298v1.776c0 .487-.199.954-.553 1.298a1.915 1.915 0 0 1-1.334.537H8.538v1.658h2.68a.96.96 0 0 1 .974.948.961.961 0 0 1-.974.947h-2.74c-.501 0-.981-.193-1.335-.538a1.81 1.81 0 0 1-.553-1.297v-1.777c0-.487.199-.954.553-1.298a1.915 1.915 0 0 1 1.335-.537h1.766V7.395h-2.68a.961.961 0 0 1-.974-.948Zm7.308 0a.96.96 0 0 1 .974-.947h2.284c.621 0 1.218.24 1.657.668.44.427.687 1.007.687 1.612v.888c0 .481-.157.946-.442 1.332.285.386.442.851.442 1.332v.888c0 .605-.247 1.185-.687 1.612a2.379 2.379 0 0 1-1.657.668h-2.284a.961.961 0 0 1-.974-.947.96.96 0 0 1 .974-.948h2.284c.104 0 .205-.04.28-.113a.38.38 0 0 0 .115-.272v-.888a.38.38 0 0 0-.116-.272.401.401 0 0 0-.28-.113h-1.37a.961.961 0 0 1-.974-.947.96.96 0 0 1 .974-.947h1.37c.105 0 .206-.04.28-.113a.38.38 0 0 0 .116-.272V7.78a.38.38 0 0 0-.116-.273.401.401 0 0 0-.28-.112h-2.283a.961.961 0 0 1-.974-.948Z"
}, null, -1), yO = [
  wO
];
function MO(t, e) {
  return p(), g("svg", $O, [...yO]);
}
const CO = I({ name: "icon-NumbersMd", render: MO }), bO = {
  component: "",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xO = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.77 10a7.23 7.23 0 1 1 14.46 0 7.23 7.23 0 0 1-14.46 0ZM10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z",
  fill: "currentColor"
}, null, -1), SO = /* @__PURE__ */ h("path", {
  d: "M14.5 10a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z",
  fill: "currentColor"
}, null, -1), IO = [
  xO,
  SO
];
function AO(t, e) {
  return p(), g("svg", bO, [...IO]);
}
const kO = I({ name: "icon-RadioButtonMd", render: AO }), EO = {
  component: "",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PO = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 3c-.476 0-.97.22-1.362.676C8.243 4.137 8 4.79 8 5.5V8h4V5.5c0-.709-.243-1.363-.638-1.824C10.971 3.219 10.476 3 10 3Zm4 5V5.5c0-1.148-.39-2.274-1.12-3.126C12.148 1.518 11.116 1 10 1s-2.147.518-2.88 1.374C6.39 3.226 6 4.352 6 5.5V8h-.286c-.736 0-1.431.307-1.936.838A2.847 2.847 0 0 0 3 10.8v5.4c0 .727.275 1.434.778 1.962.505.53 1.2.838 1.936.838h8.572c.736 0 1.431-.308 1.936-.838A2.846 2.846 0 0 0 17 16.2v-5.4c0-.727-.275-1.434-.778-1.962A2.674 2.674 0 0 0 14.286 8H14Zm-8.286 2a.674.674 0 0 0-.488.217A.847.847 0 0 0 5 10.8v5.4c0 .227.087.436.226.583a.674.674 0 0 0 .488.217h8.572c.173 0 .35-.072.488-.217A.847.847 0 0 0 15 16.2v-5.4a.847.847 0 0 0-.226-.583.674.674 0 0 0-.488-.217H5.714Zm2.872 2.086a2 2 0 1 1 2.828 2.828 2 2 0 0 1-2.828-2.828Z",
  fill: "currentColor"
}, null, -1), TO = [
  PO
];
function OO(t, e) {
  return p(), g("svg", EO, [...TO]);
}
const LO = I({ name: "icon-LockMd", render: OO }), DO = {
  component: "",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NO = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.559 4c-1.142 0-2.235.45-3.04 1.248A4.228 4.228 0 0 0 5.265 8.25V10a1 1 0 1 1-2 0V8.25c0-1.66.665-3.25 1.846-4.422A6.317 6.317 0 0 1 9.56 2c1.666 0 3.267.656 4.448 1.828a6.233 6.233 0 0 1 1.815 3.803l.974-.966a1 1 0 1 1 1.408 1.42l-2.647 2.625a1 1 0 0 1-1.408 0l-2.647-2.625a1 1 0 0 1 1.408-1.42l.883.875a4.235 4.235 0 0 0-1.195-2.292A4.317 4.317 0 0 0 9.558 4Zm-7.246 9.303a2.772 2.772 0 0 1 3.904 0 2.743 2.743 0 0 1 0 3.895 2.772 2.772 0 0 1-3.904 0 2.743 2.743 0 0 1 0-3.896ZM4.265 14.5c-.206 0-.401.081-.544.223a.743.743 0 0 0 0 1.054.772.772 0 0 0 1.087 0 .743.743 0 0 0 0-1.054.772.772 0 0 0-.543-.223Zm8.636-1.197a2.772 2.772 0 0 1 3.904 0 2.743 2.743 0 0 1 0 3.895 2.772 2.772 0 0 1-3.904 0 2.743 2.743 0 0 1 0-3.896Zm1.952 1.197c-.206 0-.401.081-.544.223a.743.743 0 0 0 0 1.054.772.772 0 0 0 1.088 0 .743.743 0 0 0 0-1.054.772.772 0 0 0-.544-.223Z",
  fill: "currentColor"
}, null, -1), RO = [
  NO
];
function ZO(t, e) {
  return p(), g("svg", DO, [...RO]);
}
const BO = I({ name: "icon-StagesMd", render: ZO }), VO = {
  component: "",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, FO = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.419 4.167c.447-.15.918-.2 1.383-.147.464.052.917.206 1.327.453.156.094.305.201.445.32l-2.93 2.484-.035.03C5.23 7.663 5 8.159 5 8.693s.229 1.03.61 1.385l.538.501a2.849 2.849 0 0 0 3.843 0l.992-.923c.4-.372.957-.592 1.552-.592.594 0 1.151.22 1.551.592l.004.004 1.34 1.233-.558.581-1.348-1.348a1 1 0 0 0-1.415 1.414l1.38 1.38-1.537 1.604L10.6 13.17a1 1 0 0 0-1.414 1.414l1.383 1.383-.562.586-5.94-6.204-.007-.007a3.707 3.707 0 0 1-.8-1.254A3.91 3.91 0 0 1 3.335 6.1c.206-.464.5-.874.86-1.205.359-.332.776-.579 1.224-.728Zm11.24 5.138a3.913 3.913 0 0 0 .006-3.187 3.67 3.67 0 0 0-.858-1.201 3.387 3.387 0 0 0-1.22-.727c-.446-.15-.915-.2-1.378-.15-.464.05-.915.202-1.326.447-.41.244-.773.579-1.061.984a.997.997 0 0 1-.206.212l-.018.016-3.536 2.998.448.417c.301.28.818.28 1.119 0l.992-.923a4.281 4.281 0 0 1 2.914-1.128c1.08 0 2.127.398 2.911 1.126l.002.002 1.21 1.114Zm-5.93 9.387 6.6-6.892a.989.989 0 0 0 .061-.059 5.71 5.71 0 0 0 1.222-1.929 5.912 5.912 0 0 0-.122-4.509 5.671 5.671 0 0 0-1.326-1.855 5.387 5.387 0 0 0-1.94-1.155 5.225 5.225 0 0 0-2.233-.241 5.282 5.282 0 0 0-2.132.717c-.302.18-.586.39-.847.624a5.451 5.451 0 0 0-.85-.633 5.284 5.284 0 0 0-2.137-.727 5.225 5.225 0 0 0-2.24.237 5.386 5.386 0 0 0-1.947 1.155 5.67 5.67 0 0 0-1.33 1.861 5.91 5.91 0 0 0-.113 4.523 5.706 5.706 0 0 0 1.23 1.927l6.66 6.956a1 1 0 0 0 1.445 0Z",
  fill: "currentColor"
}, null, -1), HO = [
  FO
];
function UO(t, e) {
  return p(), g("svg", VO, [...HO]);
}
const zO = I({ name: "icon-HeartHandshakeMd", render: UO }), WO = {
  component: "",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jO = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5 5a2 2 0 0 0-2 2v3h4V7a2 2 0 0 0-2-2Zm4 2a4 4 0 0 0-8 0v9a1 1 0 1 0 2 0v-4h4v4a1 1 0 1 0 2 0V7ZM12.172 10.172a4 4 0 0 1 4.916-.584A1 1 0 0 1 19 10v6a1 1 0 0 1-1.912.412 4 4 0 0 1-4.916-6.24ZM15 11a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
  fill: "currentColor"
}, null, -1), GO = [
  jO
];
function YO(t, e) {
  return p(), g("svg", WO, [...GO]);
}
const XO = I({ name: "icon-TextMd", render: YO }), KO = {
  component: "",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qO = /* @__PURE__ */ h("path", {
  d: "M8.5 17a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-10Zm0-6a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-10Zm0-6a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-10Z",
  fill: "currentColor"
}, null, -1), JO = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.205 2.29a1 1 0 0 1 .004 1.415l-2.187 2.2a1 1 0 0 1-1.419 0l-1.312-1.32a1 1 0 0 1 1.418-1.41l.603.607 1.479-1.487a1 1 0 0 1 1.414-.004ZM6.205 8.29a1 1 0 0 1 .004 1.415l-2.187 2.2a1 1 0 0 1-1.419 0l-1.312-1.32a1 1 0 0 1 1.418-1.41l.603.607 1.479-1.487a1 1 0 0 1 1.414-.004ZM6.205 14.29a1 1 0 0 1 .004 1.415l-2.187 2.2a1 1 0 0 1-1.419 0l-1.312-1.32a1 1 0 0 1 1.418-1.41l.603.607 1.479-1.487a1 1 0 0 1 1.414-.004Z",
  fill: "currentColor"
}, null, -1), QO = [
  qO,
  JO
];
function eL(t, e) {
  return p(), g("svg", KO, [...QO]);
}
const tL = I({ name: "icon-ListCheckMd", render: eL }), nL = {
  component: "",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oL = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.167 3.5a.667.667 0 0 0-.667.667v11.666a.667.667 0 0 0 .667.667h11.666a.666.666 0 0 0 .667-.667V4.167a.666.666 0 0 0-.667-.667H4.167ZM2.28 2.281c.5-.5 1.178-.781 1.886-.781h11.666A2.667 2.667 0 0 1 18.5 4.167v11.666a2.667 2.667 0 0 1-2.667 2.667H4.167A2.667 2.667 0 0 1 1.5 15.833V4.167c0-.708.281-1.386.781-1.886Zm12.176 4.512a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 0 1 1.414-1.414l1.793 1.793 4.293-4.293a1 1 0 0 1 1.414 0Z",
  fill: "currentColor"
}, null, -1), iL = [
  oL
];
function rL(t, e) {
  return p(), g("svg", nL, [...iL]);
}
const aL = I({ name: "icon-SquareCheckMd", render: rL }), sL = {
  component: "",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lL = /* @__PURE__ */ h("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.7 6a3.925 3.925 0 0 0-2.79 1.168A4.026 4.026 0 0 0 2.75 10c0 1.064.419 2.083 1.16 2.832A3.925 3.925 0 0 0 6.7 14h6.6a3.925 3.925 0 0 0 2.79-1.168A4.026 4.026 0 0 0 17.25 10a4.026 4.026 0 0 0-1.16-2.832A3.925 3.925 0 0 0 13.3 6H6.7Zm-4.21-.24A5.925 5.925 0 0 1 6.7 4h6.6c1.581 0 3.096.635 4.21 1.76A6.026 6.026 0 0 1 19.25 10a6.026 6.026 0 0 1-1.74 4.24A5.925 5.925 0 0 1 13.3 16H6.7a5.925 5.925 0 0 1-4.21-1.76A6.026 6.026 0 0 1 .75 10c0-1.588.624-3.113 1.74-4.24Zm8.389 2.119a3 3 0 1 1 4.242 4.242 3 3 0 0 1-4.242-4.242ZM13 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
  fill: "currentColor"
}, null, -1), dL = [
  lL
];
function cL(t, e) {
  return p(), g("svg", sL, [...dL]);
}
const uL = I({ name: "icon-ToggleMd", render: cL }), hL = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, fL = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.505.5a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
  "clip-rule": "evenodd"
}, null, -1), mL = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M5.584 12.76a1 1 0 1 0-1.301-1.52C.89 14.149 1.007 17.5 2.476 18.96c.494.491 1.133.541 1.487.541h6.59a1 1 0 1 0 0-2h-6.59a.984.984 0 0 1-.106-.005l-.013-.002c-.367-.455-.996-2.388 1.74-4.734Z"
}, null, -1), pL = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m15.5 12.309-.305.602a1 1 0 0 1-.752.537l-.624.089.432.408a1 1 0 0 1 .297.9l-.108.612.606-.309a1 1 0 0 1 .91 0l.605.31-.108-.613a1 1 0 0 1 .297-.9l.432-.408-.624-.089a1 1 0 0 1-.752-.537l-.305-.602Zm-.689-2.617a1.333 1.333 0 0 1 1.873.53v.002l.67 1.317 1.506.213h.001a1.33 1.33 0 0 1 1.071.888 1.31 1.31 0 0 1-.34 1.367l-.002.002-1.074 1.016.252 1.428a1.309 1.309 0 0 1-.537 1.301 1.33 1.33 0 0 1-1.377.097l-1.353-.692-1.358.694a1.333 1.333 0 0 1-1.825-.661 1.312 1.312 0 0 1-.088-.727l.002-.01.253-1.43-1.072-1.015h-.001a1.315 1.315 0 0 1-.344-1.37 1.316 1.316 0 0 1 1.074-.888l1.505-.213.67-1.319c.113-.221.285-.404.494-.53Z",
  "clip-rule": "evenodd"
}, null, -1), _L = [
  fL,
  mL,
  pL
];
function vL(t, e) {
  return p(), g("svg", hL, [..._L]);
}
const gL = I({ name: "icon-UserStarMd", render: vL }), $L = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, wL = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.72 3.379a7.006 7.006 0 0 0-4.65 5.619h2.786c.19-1.996.83-3.917 1.865-5.62Zm4.555 0a13.236 13.236 0 0 1 1.865 5.619h2.785a7.006 7.006 0 0 0-4.65-5.62Zm-.146 5.619a11.237 11.237 0 0 0-2.131-5.426 11.237 11.237 0 0 0-2.132 5.426h4.263Zm-4.263 2h4.263a11.237 11.237 0 0 1-2.131 5.426 11.237 11.237 0 0 1-2.132-5.426Zm-2.01 0H3.07a7.006 7.006 0 0 0 4.65 5.619 13.237 13.237 0 0 1-1.865-5.619Zm6.419 5.619a13.237 13.237 0 0 0 1.865-5.619h2.785a7.006 7.006 0 0 1-4.65 5.619Zm-2.277 2.379a8.998 8.998 0 1 1 8.998-8.998v.003a8.998 8.998 0 0 1-8.998 8.995Z",
  "clip-rule": "evenodd"
}, null, -1), yL = [
  wL
];
function ML(t, e) {
  return p(), g("svg", $L, [...yL]);
}
const CL = I({ name: "icon-WorldMd", render: ML }), bL = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, xL = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.207 4.707a1 1 0 0 0-1.414-1.414l-2.5 2.5a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 1.414-1.414L6.414 7.5H16a1 1 0 1 0 0-2H6.414l.793-.793Zm6.379 7.793-.793-.793a1 1 0 0 1 1.414-1.414l2.5 2.5a1 1 0 0 1 0 1.414l-2.5 2.5a1 1 0 0 1-1.414-1.414l.793-.793H4a1 1 0 1 1 0-2h9.586Z",
  "clip-rule": "evenodd"
}, null, -1), SL = [
  xL
];
function IL(t, e) {
  return p(), g("svg", bL, [...SL]);
}
const AL = I({ name: "icon-ArrowLeftRightMd", render: IL }), kL = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, EL = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M1.942 6.88a.833.833 0 0 1 1.177.063C4.961 8.989 7.235 10 10 10c2.766 0 5.04-1.011 6.882-3.057a.833.833 0 0 1 1.238 1.114c-.495.55-1.02 1.038-1.574 1.463l1.65 2.501a.833.833 0 1 1-1.39.918l-1.659-2.512a10.1 10.1 0 0 1-2.166.86l.347 2.776a.833.833 0 0 1-1.654.207l-.334-2.676a12.201 12.201 0 0 1-2.677 0l-.335 2.676a.833.833 0 0 1-1.654-.207l.347-2.776a10.107 10.107 0 0 1-2.16-.857l-1.664 2.528a.833.833 0 0 1-1.392-.916L3.46 9.524a11.688 11.688 0 0 1-1.58-1.467.833.833 0 0 1 .063-1.176Z"
}, null, -1), PL = [
  EL
];
function TL(t, e) {
  return p(), g("svg", kL, [...PL]);
}
const OL = I({ name: "icon-EyeClosedMd", render: TL }), LL = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, DL = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-.59 1.91a.833.833 0 1 1 1.18 1.18.833.833 0 0 1-1.18-1.18Z",
  "clip-rule": "evenodd"
}, null, -1), NL = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 4.167c-3.38 0-6.115 1.905-8.215 5.404a.833.833 0 0 0 0 .858c2.1 3.5 4.835 5.404 8.215 5.404s6.115-1.905 8.214-5.404a.833.833 0 0 0 0-.858c-2.1-3.5-4.834-5.404-8.214-5.404Zm0 10c-2.5 0-4.675-1.3-6.52-4.167C5.326 7.132 7.5 5.833 10 5.833c2.499 0 4.675 1.3 6.519 4.167-1.844 2.868-4.02 4.167-6.52 4.167Z",
  "clip-rule": "evenodd"
}, null, -1), RL = [
  DL,
  NL
];
function ZL(t, e) {
  return p(), g("svg", LL, [...RL]);
}
const BL = I({ name: "icon-EyeMd", render: ZL }), VL = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, FL = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1 4a2 2 0 0 1 2-2h6a2 2 0 0 1 1.6.8l.9 1.2h6A1.5 1.5 0 0 1 19 5.5v11a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 16.5V4Zm10.012 2H3v10h14V6h-5.988Z",
  "clip-rule": "evenodd"
}, null, -1), HL = [
  FL
];
function UL(t, e) {
  return p(), g("svg", VL, [...HL]);
}
const zL = I({ name: "icon-FolderMd", render: UL }), WL = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, jL = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M14.715 7.266a21.775 21.775 0 0 0-.96-1.037l-.249-.231.12-.103a2.7 2.7 0 0 0 .772-2.991A3.352 3.352 0 0 0 11.287 1v1.714a1.714 1.714 0 0 1 1.508.857c.146.343 0 .72-.403 1.123-.06.069-.128.112-.188.172C9.633 2.8 6.813 1.635 5.434 3.015a1.851 1.851 0 0 0-.352.506v.086l-.155.454-3.78 11.228A2.811 2.811 0 0 0 3.814 19a2.75 2.75 0 0 0 .857-.146l11.759-3.9a.856.856 0 0 0 .368-.265l.18-.154c1.226-1.235.438-3.609-1.208-5.914A5.682 5.682 0 0 1 19 7.858V6.144a7.233 7.233 0 0 0-4.285 1.122Zm-10.542 9.96a1.105 1.105 0 0 1-1.397-1.397l1.166-3.514a9.17 9.17 0 0 0 3.677 3.762l-3.446 1.149Zm6-1.997a7.602 7.602 0 0 1-5.4-5.391l.857-2.572.052.078c.094.188.214.385.334.582.12.198.137.249.223.378.085.128.283.411.437.625.154.214.163.24.257.36s.368.472.566.703l.248.3c.292.334.6.66.926.994.325.335.582.549.857.857l.283.24.668.54.317.24c.24.172.472.343.711.497l.266.172c.309.188.617.368.917.523h.043l-2.563.874Zm5.579-1.911H15.7c-.59.325-3.05-.489-5.819-3.266a18.501 18.501 0 0 1-.814-.857l-.249-.3-.454-.549-.248-.342c-.112-.163-.232-.318-.335-.472l-.222-.36-.249-.403c-.069-.12-.12-.231-.18-.342-.06-.112-.129-.223-.18-.343a2.838 2.838 0 0 1-.12-.309c-.043-.111-.094-.223-.128-.326-.035-.102-.043-.162-.069-.265-.026-.103-.043-.189-.06-.275a1.94 1.94 0 0 1 0-.222.857.857 0 0 1 0-.206l.094-.266c.309-.308 1.911 0 4.054 1.629a3.54 3.54 0 0 1-1.148.3v1.714a5.528 5.528 0 0 0 2.57-.806l.412.394c.36.36.694.729 1.011 1.098a4.56 4.56 0 0 0-.514 2.914l1.714-.335a3.06 3.06 0 0 1 0-.96c.262.397.494.813.694 1.243.48 1.132.446 1.766.292 1.912Z"
}, null, -1), GL = [
  jL
];
function YL(t, e) {
  return p(), g("svg", WL, [...GL]);
}
const XL = I({ name: "icon-PartyMd", render: YL }), KL = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, qL = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.652 2.147a1 1 0 0 1 1.415 0l2.68 2.68a.996.996 0 0 1 .282.852.996.996 0 0 1-.283.562l-2.68 2.68a1 1 0 1 1-1.414-1.415l.973-.972H13.22a3.466 3.466 0 0 0-2.84 1.48l-.456.652c-.364.52-.814.971-1.33 1.335.514.363.963.812 1.326 1.33l.459.656a3.465 3.465 0 0 0 2.84 1.48h2.406l-.973-.974a1 1 0 1 1 1.415-1.414l2.68 2.68a.995.995 0 0 1 .283.843.997.997 0 0 1-.284.571l-2.68 2.68a1 1 0 0 1-1.414-1.414l.973-.973h-2.407a5.464 5.464 0 0 1-4.478-2.332l-.459-.655A3.467 3.467 0 0 0 5.458 11H1.961a1 1 0 0 1-1-1 1 1 0 0 1 1-1H5.459a3.466 3.466 0 0 0 2.825-1.48l.456-.652a5.466 5.466 0 0 1 4.48-2.334h2.405l-.973-.973a1 1 0 0 1 0-1.414Z",
  "clip-rule": "evenodd"
}, null, -1), JL = [
  qL
];
function QL(t, e) {
  return p(), g("svg", KL, [...JL]);
}
const eD = I({ name: "icon-ConditionMd", render: QL }), tD = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, nD = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.11 1a7.626 7.626 0 0 0-5.381 2.22A7.563 7.563 0 0 0 .5 8.579c0 2.807 1.384 4.923 3.335 6.572 1.95 1.648 4.467 2.83 6.744 3.773a.986.986 0 0 0 1.36-.913v-1.854c2.001-.013 3.917-.81 5.332-2.22A7.563 7.563 0 0 0 19.5 8.58c0-2.01-.802-3.938-2.229-5.36A7.626 7.626 0 0 0 11.891 1H8.11ZM4.136 4.621a5.632 5.632 0 0 1 3.974-1.64h3.78a5.641 5.641 0 0 1 3.974 1.64A5.596 5.596 0 0 1 17.51 8.58a5.577 5.577 0 0 1-1.646 3.957 5.623 5.623 0 0 1-3.974 1.64h-.945a.993.993 0 0 0-.995.99v1.316c-2.578-1.17-4.439-2.304-5.657-3.56-1.227-1.267-1.803-2.658-1.803-4.343 0-1.485.592-2.908 1.646-3.958Zm6.697 3.158 1.633 1.361a.833.833 0 0 0 1.068-1.28l-3-2.5a.833.833 0 0 0-1.067 0l-3 2.5a.833.833 0 1 0 1.066 1.28l1.634-1.36V12a.833.833 0 0 0 1.666 0V7.78Z",
  "clip-rule": "evenodd"
}, null, -1), oD = [
  nD
];
function iD(t, e) {
  return p(), g("svg", tD, [...oD]);
}
const rD = I({ name: "icon-OutgoingChatMd", render: iD }), aD = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, sD = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.11 1a7.626 7.626 0 0 0-5.381 2.22A7.563 7.563 0 0 0 .5 8.579c0 2.807 1.384 4.923 3.335 6.572 1.95 1.648 4.467 2.83 6.744 3.773a.986.986 0 0 0 1.36-.913v-1.854c2.001-.013 3.917-.81 5.332-2.22A7.563 7.563 0 0 0 19.5 8.58c0-2.01-.802-3.938-2.229-5.36A7.626 7.626 0 0 0 11.891 1H8.11ZM4.136 4.621a5.632 5.632 0 0 1 3.974-1.64h3.78a5.641 5.641 0 0 1 3.974 1.64A5.596 5.596 0 0 1 17.51 8.58a5.577 5.577 0 0 1-1.646 3.957 5.623 5.623 0 0 1-3.974 1.64h-.945a.993.993 0 0 0-.995.99v1.316c-2.578-1.17-4.439-2.304-5.657-3.56-1.227-1.267-1.803-2.658-1.803-4.343 0-1.485.592-2.908 1.646-3.958Zm5.03 5.6V6a.833.833 0 1 1 1.667 0v4.22l1.633-1.36a.833.833 0 0 1 1.068 1.28l-3 2.5a.833.833 0 0 1-1.067 0l-3-2.5a.833.833 0 0 1 1.066-1.28l1.634 1.36Z",
  "clip-rule": "evenodd"
}, null, -1), lD = [
  sD
];
function dD(t, e) {
  return p(), g("svg", aD, [...lD]);
}
const cD = I({ name: "icon-IncomingChatMd", render: dD }), uD = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, hD = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.238 1.133a1 1 0 0 1 .68.948v5.16h4.51a1 1 0 0 1 .796 1.604L9.88 18.523a1 1 0 0 1-1.796-.604v-5.16h-4.51a1 1 0 0 1-.796-1.604l7.345-9.678a1 1 0 0 1 1.116-.344Zm-5.65 9.627h3.495a1 1 0 0 1 1 1v3.187l4.33-5.707H10.92a1 1 0 0 1-1-1V5.053L5.588 10.76Z",
  "clip-rule": "evenodd"
}, null, -1), fD = [
  hD
];
function mD(t, e) {
  return p(), g("svg", uD, [...fD]);
}
const pD = I({ name: "icon-LightningMd", render: mD }), _D = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, vD = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.505.5a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
  "clip-rule": "evenodd"
}, null, -1), gD = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M5.584 12.76a1 1 0 1 0-1.301-1.52C.89 14.149 1.007 17.5 2.476 18.96c.494.491 1.133.541 1.487.541h6.59a1 1 0 1 0 0-2h-6.59a.984.984 0 0 1-.106-.005l-.013-.002c-.367-.455-.996-2.388 1.74-4.734Z"
}, null, -1), $D = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.745 11.245a4.25 4.25 0 1 1 6.01 6.01 4.25 4.25 0 0 1-6.01-6.01ZM15.75 12a2.25 2.25 0 0 0-2.132 2.968l2.85-2.85A2.247 2.247 0 0 0 15.75 12Zm2.132 1.532-2.85 2.85a2.247 2.247 0 0 0 2.309-.541 2.25 2.25 0 0 0 .541-2.31Z",
  "clip-rule": "evenodd"
}, null, -1), wD = [
  vD,
  gD,
  $D
];
function yD(t, e) {
  return p(), g("svg", _D, [...wD]);
}
const MD = I({ name: "icon-UserCancelMd", render: yD }), CD = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, bD = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7 0a3.001 3.001 0 0 0-2.83 2H3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h4.367c.638 0 1.054-.696.875-1.308-.114-.389-.455-.692-.86-.692H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1.17A3.001 3.001 0 0 0 7 6h2a3.001 3.001 0 0 0 2.83-2H13a1 1 0 0 1 1 1v2.382c0 .405.303.746.692.86.612.18 1.308-.237 1.308-.875V5a3 3 0 0 0-3-3h-1.17A3.001 3.001 0 0 0 9 0H7ZM6 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
  "clip-rule": "evenodd"
}, null, -1), xD = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M16.405 8.782a.692.692 0 0 1 .94.005l1.16 1.105a.928.928 0 0 1 0 1.357l-1.16 1.107a.692.692 0 0 1-.94.004.617.617 0 0 1-.005-.906l.256-.243h-5.758v1.599c0 .353-.3.64-.671.64-.371 0-.672-.287-.672-.64V10.89c0-.53.451-.96 1.007-.96h6.094l-.256-.243a.617.617 0 0 1 .005-.906ZM17.105 15.195c0-.353.3-.64.671-.64.37 0 .671.287.671.64v1.92c0 .53-.45.96-1.006.96h-6.09l.246.23a.618.618 0 0 1 .005.908.693.693 0 0 1-.95-.002l-1.16-1.113a.928.928 0 0 1 .003-1.355l1.163-1.108c.259-.248.679-.25.94-.005a.617.617 0 0 1 .005.906l-.256.244h5.758v-1.585Z"
}, null, -1), SD = [
  bD,
  xD
];
function ID(t, e) {
  return p(), g("svg", CD, [...SD]);
}
const AD = I({ name: "icon-RepeatTaskMd", render: ID }), kD = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, ED = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M4.75 0a1 1 0 0 0-1 1v2.75a2.5 2.5 0 0 0-2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h4a1 1 0 1 0 0-2h-4a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h12.5c.276 0 .5.057.5.333 0 .368.299.667.667.667h.666a.667.667 0 0 0 .667-.667c0-1.38-1.12-2.333-2.5-2.333h-.002V1a1 1 0 1 0-2 0v2.75H5.75V1a1 1 0 0 0-1-1Z"
}, null, -1), PD = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M17.405 7.782a.692.692 0 0 1 .94.005l1.16 1.105a.928.928 0 0 1 0 1.357l-1.16 1.107a.692.692 0 0 1-.94.004.617.617 0 0 1-.005-.906l.256-.243h-5.758v1.599c0 .353-.3.64-.671.64-.371 0-.671-.287-.671-.64V9.89c0-.53.45-.96 1.006-.96h6.094l-.256-.243a.617.617 0 0 1 .005-.906ZM18.105 14.195c0-.353.3-.64.671-.64.37 0 .671.287.671.64v1.92c0 .53-.45.96-1.006.96h-6.09l.246.23a.618.618 0 0 1 .005.908.693.693 0 0 1-.95-.002l-1.16-1.113a.928.928 0 0 1 .003-1.355l1.163-1.108c.259-.248.679-.25.94-.005a.617.617 0 0 1 .005.906l-.256.244h5.758v-1.585Z"
}, null, -1), TD = [
  ED,
  PD
];
function OD(t, e) {
  return p(), g("svg", kD, [...TD]);
}
const LD = I({ name: "icon-RepeatEventMd", render: OD }), DD = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, ND = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20ZM9.73 6.525 7.186 9H15a1 1 0 1 1 0 2H7.185l2.546 2.475a.88.88 0 0 1 .269.632.88.88 0 0 1-.27.631.933.933 0 0 1-.65.262.933.933 0 0 1-.65-.262l-4.116-4a1.022 1.022 0 0 1 0-1.475l4.117-4.001A.933.933 0 0 1 9.08 5c.244 0 .477.094.65.262a.88.88 0 0 1 .269.631.881.881 0 0 1-.27.632Z",
  "clip-rule": "evenodd"
}, null, -1), RD = [
  ND
];
function ZD(t, e) {
  return p(), g("svg", DD, [...RD]);
}
const BD = I({ name: "icon-FilledArrowLeftMd", render: ZD }), VD = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, FD = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm.27-13.475L12.814 9H5a1 1 0 1 0 0 2h7.815l-2.546 2.475a.88.88 0 0 0-.269.632.88.88 0 0 0 .27.631.933.933 0 0 0 .65.262.933.933 0 0 0 .65-.262l4.116-4a1.022 1.022 0 0 0 0-1.475l-4.117-4.001A.933.933 0 0 0 10.92 5a.933.933 0 0 0-.65.262.88.88 0 0 0-.269.631.88.88 0 0 0 .27.632Z",
  "clip-rule": "evenodd"
}, null, -1), HD = [
  FD
];
function UD(t, e) {
  return p(), g("svg", VD, [...HD]);
}
const zD = I({ name: "icon-FilledArrowRightMd", render: UD }), WD = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, jD = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17.071 17.071A10 10 0 1 1 2.93 2.928 10 10 0 0 1 17.07 17.071ZM11.212 10l3.334 3.334a.857.857 0 0 1-1.212 1.212L10 11.212l-3.334 3.334a.857.857 0 0 1-1.212-1.212L8.788 10 5.454 6.666a.857.857 0 0 1 1.212-1.212L10 8.788l3.334-3.334a.857.857 0 1 1 1.212 1.212L11.212 10Z",
  "clip-rule": "evenodd"
}, null, -1), GD = [
  jD
];
function YD(t, e) {
  return p(), g("svg", WD, [...GD]);
}
const XD = I({ name: "icon-FilledCrossMd", render: YD }), KD = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, qD = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17.875 3C18.496 3 19 3.522 19 4.167v11.666c0 .645-.504 1.167-1.125 1.167H2.125C1.504 17 1 16.478 1 15.833V4.167C1 3.522 1.504 3 2.125 3h15.75Zm-1.688 2.333c.311 0 .563.261.563.584v7a.573.573 0 0 1-.563.583H3.813a.573.573 0 0 1-.562-.583v-7c0-.322.252-.584.563-.584h12.374Zm-6.75 9.334a.573.573 0 0 0-.562.583c0 .322.252.583.563.583h1.124c.311 0 .563-.26.563-.583a.573.573 0 0 0-.563-.583H9.438Z",
  "clip-rule": "evenodd"
}, null, -1), JD = [
  qD
];
function QD(t, e) {
  return p(), g("svg", KD, [...JD]);
}
const eN = I({ name: "icon-FilledDesktopMd", render: QD }), tN = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, nN = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.5 4H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h8.5v-3h-7a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h7V4ZM7 15.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM10 3.154C10 2.517 10.448 2 11 2h8c.552 0 1 .517 1 1.154v13.692c0 .637-.448 1.154-1 1.154h-8c-.552 0-1-.517-1-1.154V3.154Zm2 1.423c0-.319.224-.577.5-.577h1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5h1c.276 0 .5.258.5.577v10.846c0 .319-.224.577-.5.577h-5c-.276 0-.5-.258-.5-.577V4.577Z",
  "clip-rule": "evenodd"
}, null, -1), oN = [
  nN
];
function iN(t, e) {
  return p(), g("svg", tN, [...oN]);
}
const rN = I({ name: "icon-FilledDevicesMd", render: iN }), aN = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, sN = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.876 1.25a3.874 3.874 0 0 0-2.74 1.135L11.132 3.39l-.002.003-.004.003-9.576 9.576c-.191.192-.299.452-.299.723v4.033c0 .564.458 1.022 1.022 1.022h4.033c.271 0 .531-.108.723-.3L17.615 7.864a3.874 3.874 0 0 0-2.739-6.613Zm-1.294 2.58a1.83 1.83 0 1 1 2.588 2.588l-.286.286-2.588-2.588.286-.286ZM3.294 14.118l8.557-8.557 2.588 2.588-8.557 8.557-2.588-2.588Z",
  "clip-rule": "evenodd"
}, null, -1), lN = [
  sN
];
function dN(t, e) {
  return p(), g("svg", aN, [...lN]);
}
const cN = I({ name: "icon-FilledEditMd", render: dN }), uN = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, hN = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M10 1.25a8.75 8.75 0 1 0 .001 17.501A8.75 8.75 0 0 0 10 1.25Zm3.262 12.375c-.793.73-1.875 1.16-3.166 1.16A4.782 4.782 0 0 1 5.312 10a4.786 4.786 0 0 1 4.784-4.787c1.289 0 2.37.474 3.2 1.246l-1.37 1.373c-.496-.475-1.127-.715-1.828-.715-1.246 0-2.301.842-2.678 1.973-.096.287-.15.594-.15.91 0 .316.054.623.15.91.377 1.131 1.432 1.973 2.676 1.973.644 0 1.191-.17 1.619-.457a2.2 2.2 0 0 0 .955-1.446h-2.574V9.13h4.506c.056.314.085.64.085.978 0 1.46-.521 2.684-1.425 3.518Z"
}, null, -1), fN = [
  hN
];
function mN(t, e) {
  return p(), g("svg", uN, [...fN]);
}
const pN = I({ name: "icon-FilledGoogleMd", render: mN }), _N = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, vN = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.167 1C3.522 1 3 1.504 3 2.125v15.75C3 18.496 3.522 19 4.167 19h11.666c.645 0 1.167-.504 1.167-1.125V2.125C17 1.504 16.478 1 15.833 1H4.167Zm1.75 2.25a.573.573 0 0 0-.584.563v10.124c0 .311.261.563.584.563h8.166a.573.573 0 0 0 .584-.563V3.813a.573.573 0 0 0-.584-.563H5.917ZM10 15.625c-.644 0-1.167.504-1.167 1.125s.523 1.125 1.167 1.125 1.167-.504 1.167-1.125-.523-1.125-1.167-1.125Z",
  "clip-rule": "evenodd"
}, null, -1), gN = [
  vN
];
function $N(t, e) {
  return p(), g("svg", _N, [...gN]);
}
const wN = I({ name: "icon-FilledMobileMd", render: $N }), yN = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, MN = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M3 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm14 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
}, null, -1), CN = [
  MN
];
function bN(t, e) {
  return p(), g("svg", yN, [...CN]);
}
const xN = I({ name: "icon-FilledMoreMd", render: bN }), SN = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, IN = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M8.333 3.5c0 .897-.746 1.625-1.666 1.625C5.747 5.125 5 4.397 5 3.5s.746-1.625 1.667-1.625c.92 0 1.666.728 1.666 1.625ZM15 3.5c0 .897-.746 1.625-1.667 1.625-.92 0-1.666-.728-1.666-1.625s.746-1.625 1.666-1.625c.92 0 1.667.728 1.667 1.625ZM8.333 10c0 .898-.746 1.625-1.666 1.625C5.747 11.625 5 10.898 5 10c0-.897.746-1.625 1.667-1.625.92 0 1.666.728 1.666 1.625ZM15 10c0 .898-.746 1.625-1.667 1.625-.92 0-1.666-.727-1.666-1.625 0-.897.746-1.625 1.666-1.625.92 0 1.667.728 1.667 1.625ZM8.333 16.5c0 .898-.746 1.625-1.666 1.625-.92 0-1.667-.727-1.667-1.625s.746-1.625 1.667-1.625c.92 0 1.666.727 1.666 1.625ZM15 16.5c0 .898-.746 1.625-1.667 1.625-.92 0-1.666-.727-1.666-1.625s.746-1.625 1.666-1.625c.92 0 1.667.727 1.667 1.625Z"
}, null, -1), AN = [
  IN
];
function kN(t, e) {
  return p(), g("svg", SN, [...AN]);
}
const EN = I({ name: "icon-FilledMoveMd", render: kN }), PN = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, TN = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4ZM14 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-2Z"
}, null, -1), ON = [
  TN
];
function LN(t, e) {
  return p(), g("svg", PN, [...ON]);
}
const Yr = I({ name: "icon-FilledPauseMd", render: LN }), DN = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, NN = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M10 9.375a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5ZM14.833 10.29c-.383-.54-1.138-.577-1.693-.217-2.146 1.39-4.134 1.39-6.28 0-.555-.36-1.31-.322-1.693.217-1.859 2.619-1.68 5.394-.66 6.678.384.483.88.532 1.154.532h8.678c.274 0 .77-.049 1.154-.532 1.02-1.284 1.199-4.06-.66-6.678Z"
}, null, -1), RN = [
  NN
];
function ZN(t, e) {
  return p(), g("svg", DN, [...RN]);
}
const BN = I({ name: "icon-FilledPersonMd", render: ZN }), VN = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, FN = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M17 8.255c1.333.775 1.333 2.715 0 3.49L5 18.727c-1.333.776-3-.194-3-1.745V3.018C2 1.467 3.667.498 5 1.273l12 6.982Z"
}, null, -1), HN = [
  FN
];
function UN(t, e) {
  return p(), g("svg", VN, [...HN]);
}
const Xr = I({ name: "icon-FilledPlayMd", render: UN }), zN = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, WN = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M2 9a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2Zm1-2h4V3H3v4ZM2 19a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2Zm1-2h4v-4H3v4Zm9-8a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6Zm1-2h4V3h-4v4Zm4 12v-2h2v2h-2Zm-6-6v-2h2v2h-2Zm2 2v-2h2v2h-2Zm-2 2v-2h2v2h-2Zm2 2v-2h2v2h-2Zm2-2v-2h2v2h-2Zm0-4v-2h2v2h-2Zm2 2v-2h2v2h-2Z"
}, null, -1), jN = [
  WN
];
function GN(t, e) {
  return p(), g("svg", zN, [...jN]);
}
const YN = I({ name: "icon-FilledQRMd", render: GN }), XN = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, KN = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M10.195 15.326a.4.4 0 0 0-.39 0l-4.926 2.757a.4.4 0 0 1-.587-.427l1.1-5.536a.4.4 0 0 0-.121-.372L1.126 7.915a.4.4 0 0 1 .224-.69l5.606-.665a.4.4 0 0 0 .316-.23l2.365-5.126a.4.4 0 0 1 .726 0l2.365 5.126a.4.4 0 0 0 .316.23l5.606.665a.4.4 0 0 1 .224.69l-4.144 3.833a.4.4 0 0 0-.121.372l1.1 5.536a.4.4 0 0 1-.588.427l-4.926-2.757Z"
}, null, -1), qN = [
  KN
];
function JN(t, e) {
  return p(), g("svg", XN, [...qN]);
}
const QN = I({ name: "icon-FilledStarMd", render: JN }), eR = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, tR = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M15.357 2.5H4.643C3.459 2.5 2.5 3.46 2.5 4.643v10.714c0 1.184.96 2.143 2.143 2.143h10.714c1.184 0 2.143-.96 2.143-2.143V4.643c0-1.184-.96-2.143-2.143-2.143Z"
}, null, -1), nR = [
  tR
];
function oR(t, e) {
  return p(), g("svg", eR, [...nR]);
}
const iR = I({ name: "icon-FilledStopMd", render: oR }), rR = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, aR = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M13 8.992c.809-.559 1.375-1.475 1.375-2.325 0-1.884-1.458-3.334-3.333-3.334H5.834V15H11.7c1.742 0 3.092-1.417 3.092-3.158 0-1.267-.717-2.35-1.792-2.85ZM8.334 5.417h2.5c.691 0 1.25.558 1.25 1.25 0 .691-.559 1.25-1.25 1.25h-2.5v-2.5Zm2.916 7.5H8.334v-2.5h2.916c.692 0 1.25.558 1.25 1.25 0 .691-.558 1.25-1.25 1.25Z"
}, null, -1), sR = [
  aR
];
function lR(t, e) {
  return p(), g("svg", rR, [...sR]);
}
const dR = I({ name: "icon-FilledTextStyleBoldMd", render: lR }), cR = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, uR = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M8.333 3.333v2.5h1.842L7.325 12.5H5V15h6.667v-2.5H9.825l2.85-6.667H15v-2.5H8.333Z"
}, null, -1), hR = [
  uR
];
function fR(t, e) {
  return p(), g("svg", cR, [...hR]);
}
const mR = I({ name: "icon-FilledTextStyleItalicMd", render: fR }), pR = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, _R = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M8.333 15.833h3.334v-2.5H8.333v2.5Zm-4.166-12.5v2.5h4.166v2.5h3.334v-2.5h4.166v-2.5H4.167ZM2.5 11.667h15V10h-15v1.667Z"
}, null, -1), vR = [
  _R
];
function gR(t, e) {
  return p(), g("svg", pR, [...vR]);
}
const $R = I({ name: "icon-FilledTextStyleStrikethroughMd", render: gR }), wR = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, yR = /* @__PURE__ */ h("path", {
  fill: "#4285F4",
  d: "M18.991 10.168c0-.737-.06-1.275-.194-1.833H10.18v3.328h5.059c-.102.827-.653 2.073-1.877 2.91l-.017.112 2.725 2.062.189.019c1.734-1.565 2.733-3.867 2.733-6.598Z"
}, null, -1), MR = /* @__PURE__ */ h("path", {
  fill: "#34A853",
  d: "M10.18 18.938c2.478 0 4.558-.797 6.078-2.172l-2.897-2.193c-.775.528-1.815.897-3.182.897a5.514 5.514 0 0 1-5.222-3.727l-.107.009-2.834 2.143-.037.1c1.51 2.93 4.61 4.943 8.2 4.943Z"
}, null, -1), CR = /* @__PURE__ */ h("path", {
  fill: "#FBBC05",
  d: "M4.957 11.743a5.408 5.408 0 0 1-.306-1.774c0-.618.112-1.216.296-1.774l-.005-.119L2.073 5.9l-.094.044A8.81 8.81 0 0 0 1 9.969c0 1.445.357 2.81.98 4.026l2.977-2.252Z"
}, null, -1), bR = /* @__PURE__ */ h("path", {
  fill: "#EB4335",
  d: "M10.18 4.468c1.723 0 2.886.728 3.549 1.335l2.59-2.471C14.73 1.887 12.658 1 10.18 1c-3.59 0-6.69 2.013-8.2 4.943l2.968 2.252a5.537 5.537 0 0 1 5.232-3.727Z"
}, null, -1), xR = [
  yR,
  MR,
  CR,
  bR
];
function SR(t, e) {
  return p(), g("svg", wR, [...xR]);
}
const IR = I({ name: "icon-GoogleMd", render: SR }), AR = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, kR = /* @__PURE__ */ h("path", {
  fill: "#F1F5F9",
  d: "M10.502 0h-.004C5.26 0 1 4.26 1 9.5a9.43 9.43 0 0 0 1.809 5.568l-1.206 2.62a.6.6 0 0 0 .752.815l2.921-1.073A9.417 9.417 0 0 0 10.502 19C15.74 19 20 14.738 20 9.5S15.74 0 10.502 0Z"
}, null, -1), ER = /* @__PURE__ */ h("circle", {
  cx: "10.167",
  cy: "9.667",
  r: "6.667",
  fill: "#fff"
}, null, -1), PR = /* @__PURE__ */ h("path", {
  fill: "#65CF72",
  d: "M10.419 1.667h-.004C6.05 1.667 2.5 5.217 2.5 9.583c0 1.732.558 3.337 1.507 4.64l-.986 2.941 3.042-.972A7.849 7.849 0 0 0 10.42 17.5c4.365 0 7.914-3.552 7.914-7.917s-3.55-7.916-7.914-7.916Zm4.606 11.179c-.19.54-.949.987-1.553 1.117-.414.088-.954.159-2.773-.595-2.327-.964-3.825-3.329-3.942-3.482-.112-.153-.94-1.252-.94-2.388s.577-1.689.81-1.926c.19-.195.506-.284.809-.284.098 0 .186.004.265.008.233.01.35.024.503.391.19.46.656 1.597.711 1.713.057.117.113.275.034.429-.074.158-.14.228-.256.363-.117.135-.228.237-.345.382-.106.126-.227.26-.093.493.135.227.6.986 1.285 1.596.884.787 1.6 1.038 1.856 1.145.191.08.419.06.558-.088.178-.191.396-.508.619-.82.158-.223.358-.25.568-.172.214.075 1.345.634 1.577.75.233.116.386.172.443.27.055.098.055.558-.136 1.098Z"
}, null, -1), TR = [
  kR,
  ER,
  PR
];
function OR(t, e) {
  return p(), g("svg", AR, [...TR]);
}
const LR = I({ name: "icon-WhatsAppMd", render: OR }), DR = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, NR = ["clip-path"], RR = /* @__PURE__ */ h("path", {
  fill: "#2BABEE",
  "fill-rule": "evenodd",
  d: "M16.48 3.692a1.25 1.25 0 0 1 1.72 1.355L16.31 16.51c-.184 1.106-1.397 1.74-2.412 1.189a48.624 48.624 0 0 1-3.241-1.912c-.567-.37-2.303-1.558-2.09-2.403.184-.723 3.1-3.438 4.767-5.052.654-.634.356-1-.416-.416-1.92 1.448-4.999 3.65-6.017 4.27-.898.547-1.367.64-1.927.547-1.021-.17-1.969-.433-2.742-.754-1.045-.433-.994-1.87-.001-2.288l14.25-6Z",
  "clip-rule": "evenodd"
}, null, -1), ZR = [
  RR
], BR = ["id"], VR = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}, null, -1), FR = [
  VR
];
function HR(t, e) {
  return p(), g("svg", DR, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...ZR], 8, NR),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...FR], 8, BR)
    ])
  ]);
}
const UR = I({ name: "icon-TelegramMd", render: HR, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), zR = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, WR = ["clip-path"], jR = /* @__PURE__ */ Rr('<path fill="#E05F8F" d="M1.756 5.146a.964.964 0 0 0 .664-.253.883.883 0 0 0 .204-.289.85.85 0 0 0-.204-.971.964.964 0 0 0-.664-.254c-.505.007-.911.4-.911.884 0 .483.406.876.911.883Zm14.171-.749a.964.964 0 0 0 .663-.255.882.882 0 0 0 .203-.288.85.85 0 0 0-.204-.97.963.963 0 0 0-.662-.255c-.505.008-.911.401-.911.884s.406.877.912.884Z"></path><path fill="#FCC954" d="M16.678 15.754a.963.963 0 0 0 .664-.254.85.85 0 0 0 0-1.26.963.963 0 0 0-.664-.254c-.505.007-.911.4-.911.884 0 .483.406.876.912.884ZM5.535 1.768a.964.964 0 0 0 .663-.255.85.85 0 0 0 0-1.258A.964.964 0 0 0 5.536 0c-.506.007-.912.401-.912.884s.406.877.911.884Z"></path><path fill="#2DB2E3" d="M11.014 7.907a.751.751 0 0 1-.317-.07.718.718 0 0 1-.253-.195.66.66 0 0 1-.132-.592 3.53 3.53 0 0 0 .07-.332 2.065 2.065 0 0 1-.681.142 2.432 2.432 0 0 1-1.118-.201 1.709 1.709 0 0 1-.75-.663c-.346-.57-.316-1.322.075-1.913a1.83 1.83 0 0 1 1.686-.82c.527.038.988.227 1.358.55.067-.181.132-.376.193-.582.378-1.273.502-2.552.503-2.564a.667.667 0 0 1 .257-.468.732.732 0 0 1 .528-.157c.19.017.366.105.489.245a.67.67 0 0 1 .164.504c-.005.058-.138 1.42-.552 2.817-.209.704-.456 1.3-.736 1.775.021.106.037.215.05.327a4.698 4.698 0 0 1-.134 1.675.689.689 0 0 1-.257.376.745.745 0 0 1-.443.146Zm-1.572-3.27c-.075 0-.207.02-.313.18-.101.154-.12.364-.046.49.1.165.395.18.562.173.19-.006.383-.12.573-.327a1.204 1.204 0 0 0-.111-.18.806.806 0 0 0-.625-.335l-.04-.002Z"></path><path fill="#F0A420" d="M8.934 9.797C5.94 7.541 2.808 6.564 1.941 7.614a.94.94 0 0 0-.188.382v.002c-.012.047-.02.095-.026.143L.03 17.626c-.272 1.523 1.307 2.743 2.81 2.171l9.197-3.5c.162-.062.56-.297.67-.427a.926.926 0 0 0 .081-.086c.867-1.05-.86-3.73-3.855-5.987Z"></path><path fill="#FCC954" d="M12.786 15.784c.867-1.051-.858-3.732-3.854-5.987C5.937 7.54 2.805 6.564 1.938 7.615c-.867 1.05.858 3.731 3.854 5.987 2.995 2.256 6.127 3.232 6.994 2.182Z"></path><path fill="#F0A420" d="M12.266 15.17c.711-.862-.856-3.176-3.501-5.168C6.119 8.01 3.398 7.094 2.686 7.956c-.712.863.856 3.176 3.501 5.169 2.646 1.992 5.367 2.908 6.079 2.045Z"></path><path fill="#1C7EF1" d="M5.94 18.617c-1.12.005-2.031-.53-3.137-1.362-1.287-.97-2.141-2.13-2.209-2.79L.23 16.503c.17.582.744 1.32 1.579 1.948.694.522 1.394.881 2.12.931l2.012-.766Zm-1.12-3.701c-2.143-1.615-3.536-3.468-3.497-4.528l-.356 1.988c.028.946 1.186 2.476 2.833 3.717 1.477 1.111 3.015 1.893 4.193 1.743l2-.761c-1.612.106-3.312-.758-5.172-2.16Z"></path><path fill="#2DB2E3" d="M9.261 10.825a.965.965 0 0 0 .662-.254.883.883 0 0 0 .204-.288.85.85 0 0 0-.204-.97.964.964 0 0 0-.662-.255c-.506.007-.911.4-.911.884 0 .483.405.876.911.883Z"></path><path fill="#E05F8F" d="m14.252 9.105.007-.008.047-.046c.07-.067.143-.13.218-.191.279-.222.582-.414.906-.57.791-.382 1.97-.694 3.515-.354.464.102.927-.174 1.034-.618.107-.443-.182-.885-.647-.988-2-.44-3.59-.037-4.681.49a6.486 6.486 0 0 0-1.239.78 5.04 5.04 0 0 0-.449.41l-.01.01-.002.003-.002.002.653.538-.654-.537a.799.799 0 0 0 .096 1.153.891.891 0 0 0 1.208-.074ZM5.707 3.227a.895.895 0 0 0-.247-.249.94.94 0 0 0-.686-.148.944.944 0 0 0-.595.36.859.859 0 0 0-.155.655c.02.113.064.222.128.32.034.05.718 1.108.858 2.557.143 1.473-.31 2.826-1.348 4.04.35.424.77.865 1.25 1.306.666-.734 1.166-1.523 1.494-2.357a6.746 6.746 0 0 0 .426-3.235c-.194-1.782-1.006-3.068-1.125-3.249Z"></path><path fill="#2DB2E3" d="M17.206 11.686c.468.116.8.242.943.301a.962.962 0 0 0 1.09-.084.891.891 0 0 0 .233-.294.852.852 0 0 0-.082-.884.923.923 0 0 0-.46-.328c-.44-.187-2.103-.815-4.301-.704a10.12 10.12 0 0 0-4.23 1.165c-1.255.661-2.421 1.598-3.48 2.793.505.344 1.031.658 1.576.94 1.787-1.945 3.85-3 6.148-3.14.862-.05 1.726.03 2.563.235Z"></path>', 10), GR = [
  jR
], YR = ["id"], XR = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}, null, -1), KR = [
  XR
];
function qR(t, e) {
  return p(), g("svg", zR, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...GR], 8, WR),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...KR], 8, YR)
    ])
  ]);
}
const JR = I({ name: "icon-ConfettiMd", render: qR, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), QR = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, eZ = ["clip-path"], tZ = /* @__PURE__ */ Rr('<path fill="#E05F5F" d="M9.875 19.75a8.295 8.295 0 1 0 0-16.59 8.295 8.295 0 0 0 0 16.59Z"></path><path fill="#fff" d="M9.875 17.38a5.925 5.925 0 1 0 0-11.85 5.925 5.925 0 0 0 0 11.85Z"></path><path fill="#FCC954" d="M.216 5.71C-.365 3.906.246 1.852 1.822.738c1.575-1.115 3.624-.931 4.992.313.429.392.383 1.106-.083 1.435L1.516 6.167c-.474.329-1.117.105-1.3-.457Zm19.318 0c.581-1.804-.03-3.858-1.606-4.972-1.575-1.115-3.624-.931-4.993.313-.428.392-.382 1.106.084 1.435l5.215 3.681c.474.329 1.117.105 1.3-.457Z"></path><path fill="#E05F5F" d="M8.823 11.411a.79.79 0 0 1 1.096-.218l2.37 1.58a.79.79 0 0 1-.877 1.314l-2.37-1.58a.79.79 0 0 1-.22-1.096Z"></path><path fill="#212121" d="M9.48 7.11a.79.79 0 0 1 .79.79v3.95a.79.79 0 0 1-1.58 0V7.9a.79.79 0 0 1 .79-.79Z"></path>', 5), nZ = [
  tZ
], oZ = ["id"], iZ = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}, null, -1), rZ = [
  iZ
];
function aZ(t, e) {
  return p(), g("svg", QR, [
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...nZ], 8, eZ),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...rZ], 8, oZ)
    ])
  ]);
}
const sZ = I({ name: "icon-ClockMd", render: aZ, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), lZ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, dZ = /* @__PURE__ */ h("path", {
  fill: "#F0A420",
  d: "M7 16c.384 1.73 1.575 3 3 3s2.616-1.27 3-3H7ZM10.274 4.09a1.055 1.055 0 0 1-1.055-1.055v-1.73a1.055 1.055 0 0 1 2.11 0v1.73c0 .582-.473 1.055-1.055 1.055Z"
}, null, -1), cZ = /* @__PURE__ */ h("path", {
  fill: "#FCC954",
  d: "M17.25 13.277c-.6-.483-.962-1.204-1.113-1.969l-1.08-5.562C14.574 3.28 12.461 1.506 10 1.5c-2.462.006-4.575 1.781-5.056 4.246l-1.081 5.562c-.15.764-.513 1.486-1.113 1.969a2.363 2.363 0 0 0-.875 1.844v.77c0 .34.269.609.594.609H17.53c.332 0 .594-.27.594-.608v-.771c0-.753-.344-1.412-.875-1.844Z"
}, null, -1), uZ = [
  dZ,
  cZ
];
function hZ(t, e) {
  return p(), g("svg", lZ, [...uZ]);
}
const fZ = I({ name: "icon-BellMd", render: hZ }), mZ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, pZ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M2.003 11.716c.037-1.843.056-2.764.668-3.552.124-.156.262-.3.413-.431.752-.636 1.746-.636 3.733-.636.71 0 1.065 0 1.403-.092.07-.02.14-.042.209-.067.33-.121.627-.33 1.22-.746 2.338-1.645 3.508-2.467 4.489-2.11.188.069.37.168.533.29.848.635.913 2.115 1.042 5.073.042.851.069 1.703.08 2.555 0 .521-.032 1.46-.08 2.555-.13 2.958-.194 4.438-1.042 5.073-.163.122-.342.22-.533.29-.982.357-2.15-.465-4.49-2.11-.592-.416-.89-.625-1.22-.746a2.613 2.613 0 0 0-.208-.067c-.338-.092-.693-.092-1.403-.092-1.987 0-2.98 0-3.733-.636a3.143 3.143 0 0 1-.413-.43c-.612-.79-.63-1.71-.668-3.553-.004-.19-.004-.378 0-.568Z"
}, null, -1), _Z = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M19.49 5.552a.66.66 0 0 1 .97.094l-.53.471.53-.47.003.002.003.004.007.009.079.112c.047.071.11.173.186.305.149.264.339.652.526 1.171C21.64 8.291 22 9.851 22 12c0 2.15-.36 3.71-.736 4.75-.187.52-.377.907-.526 1.172-.081.144-.17.283-.265.417l-.007.009-.003.003-.001.002s-.001.001-.531-.47l.53.471a.66.66 0 0 1-.971.094.77.77 0 0 1-.09-1.035l.03-.041c.026-.04.07-.11.125-.207.166-.302.307-.618.422-.943.314-.871.644-2.253.644-4.222 0-1.97-.33-3.35-.644-4.222a6.29 6.29 0 0 0-.422-.942 3.172 3.172 0 0 0-.157-.253m-1.641 1.833c.333-.197.753-.07.938.286v.002l.003.003.003.007.01.018.024.053c.018.042.042.099.07.17.053.145.12.35.185.62.13.54.252 1.337.252 2.425 0 1.089-.122 1.886-.252 2.426-.065.27-.132.475-.186.619-.028.075-.06.15-.094.223l-.01.018-.002.007-.002.003v.002s-.001.001-.604-.356l.603.357c-.185.355-.605.483-.938.286-.33-.196-.45-.638-.272-.991l.004-.01.035-.085c.032-.086.08-.23.13-.438.1-.416.208-1.09.208-2.06 0-.971-.108-1.645-.208-2.06a3.767 3.767 0 0 0-.165-.524l-.004-.01a.76.76 0 0 1 .272-.991Z",
  "clip-rule": "evenodd"
}, null, -1), vZ = [
  pZ,
  _Z
];
function gZ(t, e) {
  return p(), g("svg", mZ, [...vZ]);
}
const Yi = I({ name: "icon-AudioLg", render: gZ }), $Z = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, wZ = ["id"], yZ = /* @__PURE__ */ h("path", {
  fill: "#91A0AE",
  d: "M3 4.5a3 3 0 0 1 3-3h8.451a3 3 0 0 1 2.004.767L18.3 3.923l1.704 1.53A3 3 0 0 1 21 7.684V19.5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-15Z"
}, null, -1), MZ = [
  yZ
], CZ = ["mask"], bZ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M3 4.5a3 3 0 0 1 3-3h8.451a3 3 0 0 1 2.004.767L18.3 3.923l1.704 1.53A3 3 0 0 1 21 7.684V19.5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-15Z"
}, null, -1), xZ = /* @__PURE__ */ h("path", {
  fill: "#D0DBE4",
  d: "M16.5 6.347H21L15.6 1.5v4.038c0 .446.403.808.9.808Z",
  opacity: ".32"
}, null, -1), SZ = /* @__PURE__ */ h("path", {
  fill: "#D0DBE4",
  d: "M7 11c0-.552.48-1 1.071-1h7.858c.591 0 1.071.448 1.071 1s-.48 1-1.071 1H8.07C7.48 12 7 11.552 7 11ZM7 15c0-.552.488-1 1.09-1h5.82c.602 0 1.09.448 1.09 1s-.488 1-1.09 1H8.09C7.489 16 7 15.552 7 15Z",
  opacity: ".64"
}, null, -1), IZ = [
  bZ,
  xZ,
  SZ
];
function AZ(t, e) {
  return p(), g("svg", $Z, [
    h("mask", {
      id: t.idMap.a,
      width: "18",
      height: "22",
      x: "3",
      y: "1",
      maskUnits: "userSpaceOnUse",
      style: { "mask-type": "alpha" }
    }, [...MZ], 8, wZ),
    h("g", {
      mask: "url(#" + t.idMap.a + ")"
    }, [...IZ], 8, CZ)
  ]);
}
const t1 = I({ name: "icon-FileLg", render: AZ, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), kZ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, EZ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M20.106 6.959A2 2 0 0 1 23 8.747v6.765a2 2 0 0 1-2.894 1.788 1 1 0 0 1-.296-.225l-2.56-2.325v-5l2.56-2.566a1 1 0 0 1 .296-.225ZM1 7.75a3 3 0 0 1 3-3h8.75a3 3 0 0 1 3 3v8.5a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-8.5Z",
  "clip-rule": "evenodd"
}, null, -1), PZ = [
  EZ
];
function TZ(t, e) {
  return p(), g("svg", kZ, [...PZ]);
}
const Kr = I({ name: "icon-VideoLg", render: TZ }), OZ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, LZ = /* @__PURE__ */ Rr('<path fill="#0066DA" d="m2.664 19.12.97 1.704c.202.358.492.64.832.845.975-1.257 1.653-2.222 2.035-2.894.388-.682.865-1.75 1.43-3.201-1.524-.204-2.679-.306-3.465-.306-.754 0-1.91.102-3.465.306 0 .397.1.794.302 1.152l1.361 2.395Z"></path><path fill="#EA4335" d="M19.536 21.67c.34-.206.63-.488.832-.846l.403-.704 1.928-3.394c.198-.35.302-.748.302-1.152-1.564-.204-2.717-.306-3.458-.306-.796 0-1.95.102-3.459.306.559 1.46 1.03 2.527 1.411 3.201.386.68 1.066 1.645 2.041 2.894Z"></path><path fill="#00832D" d="M12 8.403c1.127-1.384 1.904-2.451 2.33-3.202.344-.604.722-1.569 1.134-2.894A2.189 2.189 0 0 0 14.33 2H9.668c-.403 0-.794.115-1.134.307.525 1.52.97 2.602 1.336 3.245.404.711 1.114 1.661 2.13 2.85Z"></path><path fill="#2684FC" d="M16.071 15.574h-8.14l-3.465 6.095c.34.205.731.308 1.134.308h12.802c.403 0 .794-.116 1.134-.308l-3.465-6.095Z"></path><path fill="#00AC47" d="M12.001 8.403 8.536 2.307c-.34.205-.63.487-.832.846l-6.4 11.268A2.35 2.35 0 0 0 1 15.574h6.93l4.07-7.171Z"></path><path fill="#FFBA00" d="m19.497 8.787-3.2-5.635a2.306 2.306 0 0 0-.832-.845L12 8.403l4.07 7.17h6.918c0-.396-.101-.793-.303-1.152l-3.188-5.634Z"></path>', 6), DZ = [
  LZ
];
function NZ(t, e) {
  return p(), g("svg", OZ, [...DZ]);
}
const RZ = I({ name: "icon-GoogleDriveLg", render: NZ }), ZZ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}, BZ = ["fill"], VZ = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M12.368 15.887a3.518 3.518 0 1 1 7.035 0 3.518 3.518 0 0 1-7.035 0Zm-1.902 0a5.419 5.419 0 1 0 10.838 0 5.419 5.419 0 0 0-10.838 0m9.787-5.634a1.267 1.267 0 1 0 1.267-1.265h-.001a1.267 1.267 0 0 0-1.266 1.265Zm-8.631 14.225c-1.03-.047-1.588-.219-1.96-.364a3.279 3.279 0 0 1-1.214-.789c-.37-.369-.598-.72-.79-1.213-.144-.371-.316-.93-.362-1.96-.051-1.112-.062-1.446-.062-4.265 0-2.818.011-3.151.062-4.264.047-1.03.22-1.587.363-1.96a3.28 3.28 0 0 1 .79-1.214c.368-.37.72-.598 1.213-.79.371-.144.93-.316 1.96-.362 1.112-.052 1.446-.062 4.263-.062s3.152.011 4.265.062c1.03.047 1.587.22 1.96.363.493.19.844.42 1.214.79.37.368.597.72.79 1.213.144.371.316.93.362 1.96.051 1.113.062 1.446.062 4.265 0 2.818-.01 3.151-.062 4.264-.047 1.03-.219 1.589-.363 1.96a3.27 3.27 0 0 1-.79 1.213 3.28 3.28 0 0 1-1.213.79c-.372.145-.93.316-1.96.363-1.112.05-1.446.061-4.265.061-2.818 0-3.151-.01-4.263-.061m-.088-19.08c-1.123.051-1.89.23-2.561.49a5.18 5.18 0 0 0-1.87 1.217 5.153 5.153 0 0 0-1.217 1.87c-.26.67-.439 1.438-.49 2.561-.052 1.126-.064 1.485-.064 4.351 0 2.866.012 3.226.064 4.351.051 1.124.23 1.891.49 2.562a5.16 5.16 0 0 0 1.217 1.87 5.185 5.185 0 0 0 1.87 1.217c.672.26 1.438.439 2.561.49 1.126.05 1.485.064 4.351.064 2.866 0 3.226-.012 4.351-.064 1.124-.051 1.891-.23 2.562-.49a5.19 5.19 0 0 0 1.87-1.218 5.17 5.17 0 0 0 1.217-1.87c.26-.67.44-1.437.49-2.56.05-1.127.063-1.486.063-4.352 0-2.866-.012-3.225-.063-4.35-.051-1.124-.23-1.892-.49-2.562a5.19 5.19 0 0 0-1.218-1.87A5.163 5.163 0 0 0 22.8 5.888c-.672-.26-1.44-.44-2.562-.49-1.125-.052-1.485-.064-4.35-.064-2.866 0-3.226.012-4.352.064"
}, null, -1), FZ = ["id"], HZ = /* @__PURE__ */ h("stop", { "stop-color": "#FD5" }, null, -1), UZ = /* @__PURE__ */ h("stop", {
  offset: ".1",
  "stop-color": "#FD5"
}, null, -1), zZ = /* @__PURE__ */ h("stop", {
  offset: ".5",
  "stop-color": "#FF543E"
}, null, -1), WZ = /* @__PURE__ */ h("stop", {
  offset: "1",
  "stop-color": "#C837AB"
}, null, -1), jZ = [
  HZ,
  UZ,
  zZ,
  WZ
];
function GZ(t, e) {
  return p(), g("svg", ZZ, [
    h("rect", {
      width: "32",
      height: "32",
      fill: "url(#" + t.idMap.a + ")",
      rx: "16"
    }, null, 8, BZ),
    VZ,
    h("defs", null, [
      h("radialGradient", {
        id: t.idMap.a,
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(0 -31.7144 29.4969 0 8.5 34.465)",
        gradientUnits: "userSpaceOnUse"
      }, [...jZ], 8, FZ)
    ])
  ]);
}
const YZ = I({ name: "icon-InstagramXL", render: GZ, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), XZ = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}, KZ = ["fill"], qZ = ["fill"], JZ = /* @__PURE__ */ h("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M13.627 11.493c-.181-.401-.371-.41-.543-.415-.139-.005-.3-.005-.463-.005a.89.89 0 0 0-.644.3c-.223.24-.844.821-.844 2.007 0 1.18.867 2.325.987 2.486.12.162 1.674 2.666 4.125 3.63 2.04.803 2.457.642 2.897.6.44-.041 1.428-.581 1.632-1.144.199-.563.199-1.042.139-1.144-.06-.101-.223-.161-.464-.281-.24-.12-1.427-.701-1.65-.784-.222-.079-.384-.12-.542.12-.162.24-.626.78-.765.94-.139.162-.283.18-.524.06-.24-.12-1.02-.373-1.942-1.194-.718-.637-1.205-1.426-1.344-1.665-.139-.24-.014-.37.107-.49.107-.105.24-.28.361-.42.12-.137.163-.239.241-.4.08-.162.042-.3-.018-.42-.06-.115-.533-1.306-.746-1.78Z",
  "clip-rule": "evenodd"
}, null, -1), QZ = ["id"], eB = /* @__PURE__ */ h("stop", { "stop-color": "#20B038" }, null, -1), tB = /* @__PURE__ */ h("stop", {
  offset: "1",
  "stop-color": "#60D66A"
}, null, -1), nB = [
  eB,
  tB
], oB = ["id"], iB = /* @__PURE__ */ h("stop", { "stop-color": "#F9F9F9" }, null, -1), rB = /* @__PURE__ */ h("stop", {
  offset: "1",
  "stop-color": "#fff"
}, null, -1), aB = [
  iB,
  rB
];
function sB(t, e) {
  return p(), g("svg", XZ, [
    h("rect", {
      width: "32",
      height: "32",
      fill: "url(#" + t.idMap.a + ")",
      rx: "16"
    }, null, 8, KZ),
    h("path", {
      fill: "url(#" + t.idMap.b + ")",
      d: "m6.294 25.309 1.372-4.982a9.526 9.526 0 0 1-1.288-4.811c0-5.305 4.338-9.618 9.663-9.618a9.614 9.614 0 0 1 6.837 2.818 9.514 9.514 0 0 1 2.827 6.804c0 5.305-4.338 9.618-9.668 9.618h-.005a9.71 9.71 0 0 1-4.62-1.172L6.293 25.31Zm5.363-3.082.292.176a8.086 8.086 0 0 0 4.088 1.116h.005c4.426 0 8.032-3.584 8.032-7.994a7.937 7.937 0 0 0-2.35-5.655 7.99 7.99 0 0 0-5.683-2.344c-4.426-.004-8.032 3.58-8.032 7.99 0 1.508.422 2.98 1.229 4.253l.19.304-.812 2.948 3.04-.794Z"
    }, null, 8, qZ),
    JZ,
    h("defs", null, [
      h("linearGradient", {
        id: t.idMap.a,
        x1: "15.999",
        x2: "15.999",
        y1: "31.998",
        y2: "-.001",
        gradientUnits: "userSpaceOnUse"
      }, [...nB], 8, QZ),
      h("linearGradient", {
        id: t.idMap.b,
        x1: "16.002",
        x2: "16.002",
        y1: "25.307",
        y2: "5.898",
        gradientUnits: "userSpaceOnUse"
      }, [...aB], 8, oB)
    ])
  ]);
}
const lB = I({ name: "icon-WhatsAppXL", render: sB, data() {
  const t = () => Math.random().toString(36).substr(2, 10);
  return { idMap: { a: "uicons-" + t(), b: "uicons-" + t() } };
} }), dB = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}, cB = ["fill"], uB = /* @__PURE__ */ h("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M7.241 15.832c4.665-2.032 7.775-3.372 9.331-4.02 4.444-1.847 5.367-2.168 5.969-2.18.132-.001.428.031.62.187a.674.674 0 0 1 .227.433c.022.125.048.409.027.63-.24 2.53-1.282 8.67-1.813 11.503-.224 1.2-.666 1.601-1.093 1.64-.93.086-1.635-.613-2.535-1.203-1.408-.923-2.203-1.498-3.57-2.399-1.58-1.04-.556-1.613.344-2.548.236-.245 4.33-3.968 4.409-4.306.01-.042.02-.2-.074-.283-.094-.083-.232-.055-.332-.032-.141.032-2.39 1.519-6.749 4.46-.638.44-1.216.653-1.735.642-.571-.013-1.67-.324-2.487-.589-1.002-.326-1.798-.498-1.729-1.051.036-.288.433-.583 1.19-.884Z",
  "clip-rule": "evenodd"
}, null, -1), hB = ["id"], fB = /* @__PURE__ */ h("stop", { "stop-color": "#2AABEE" }, null, -1), mB = /* @__PURE__ */ h("stop", {
  offset: "1",
  "stop-color": "#229ED9"
}, null, -1), pB = [
  fB,
  mB
];
function _B(t, e) {
  return p(), g("svg", dB, [
    h("rect", {
      width: "32",
      height: "32",
      fill: "url(#" + t.idMap.a + ")",
      rx: "16"
    }, null, 8, cB),
    uB,
    h("defs", null, [
      h("linearGradient", {
        id: t.idMap.a,
        x1: "16",
        x2: "16",
        y1: "0",
        y2: "31.763",
        gradientUnits: "userSpaceOnUse"
      }, [...pB], 8, hB)
    ])
  ]);
}
const vB = I({ name: "icon-TelegramXL", render: _B, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), gB = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}, $B = ["fill"], wB = ["fill"], yB = ["fill"], MB = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "m5.088 18.91-1.693-5.82h1.554l.877 3.813h.049l1.002-3.812h1.268l1.002 3.82h.049l.88-3.82h1.551l-1.69 5.818H8.582l-1.048-3.528h-.046L6.44 18.909H5.088ZM12.834 18.91h-1.511l1.963-5.82h1.872l1.963 5.82H15.61l-1.367-4.353h-.045l-1.364 4.352Zm.718-2.29h1.339l.335 1.067h-2.01l.336-1.068ZM17.747 18.91v-5.82h2.427c.435 0 .8.063 1.093.186.296.123.517.295.665.517.15.221.225.478.225.77 0 .221-.047.419-.14.593-.092.173-.22.316-.383.43a1.532 1.532 0 0 1-.566.238v.057c.235.011.452.075.651.19.2.116.362.276.483.483a1.4 1.4 0 0 1 .182.727c0 .313-.08.592-.239.838-.159.245-.389.438-.69.58-.301.14-.667.21-1.097.21h-2.61Zm1.407-1.134h.87c.304 0 .528-.058.672-.174a.582.582 0 0 0 .22-.483.693.693 0 0 0-.106-.386.676.676 0 0 0-.298-.253 1.08 1.08 0 0 0-.463-.09h-.895v1.386Zm0-2.293h.778c.154 0 .29-.026.41-.077a.59.59 0 0 0 .38-.571.56.56 0 0 0-.207-.46c-.139-.112-.325-.168-.56-.168h-.801v1.276ZM24.319 18.91h-1.512l1.963-5.82h1.872l1.963 5.82h-1.51l-1.367-4.353h-.046l-1.363 4.352Zm.717-2.29h1.34l.335 1.067H24.7l.335-1.068Z"
}, null, -1), CB = ["id"], bB = /* @__PURE__ */ h("stop", { "stop-color": "#20B038" }, null, -1), xB = /* @__PURE__ */ h("stop", {
  offset: "1",
  "stop-color": "#60D66A"
}, null, -1), SB = [
  bB,
  xB
], IB = ["id"], AB = /* @__PURE__ */ h("stop", { "stop-color": "#F9F9F9" }, null, -1), kB = /* @__PURE__ */ h("stop", {
  offset: "1",
  "stop-color": "#fff"
}, null, -1), EB = [
  AB,
  kB
], PB = ["id"], TB = /* @__PURE__ */ h("stop", { "stop-color": "#20B038" }, null, -1), OB = /* @__PURE__ */ h("stop", {
  offset: "1",
  "stop-color": "#60D66A"
}, null, -1), LB = [
  TB,
  OB
];
function DB(t, e) {
  return p(), g("svg", gB, [
    h("rect", {
      width: "32",
      height: "32",
      fill: "url(#" + t.idMap.a + ")",
      rx: "16"
    }, null, 8, $B),
    h("path", {
      fill: "url(#" + t.idMap.b + ")",
      d: "m6.294 25.41 1.372-4.981a9.526 9.526 0 0 1-1.288-4.811C6.378 10.313 10.716 6 16.04 6a9.614 9.614 0 0 1 6.837 2.818 9.514 9.514 0 0 1 2.827 6.804c0 5.305-4.338 9.618-9.668 9.618h-.005a9.71 9.71 0 0 1-4.62-1.172l-5.118 1.343Zm5.363-3.08.292.175a8.084 8.084 0 0 0 4.088 1.116h.005c4.426 0 8.032-3.584 8.032-7.994a7.937 7.937 0 0 0-2.35-5.655 7.99 7.99 0 0 0-5.683-2.344c-4.426-.004-8.032 3.58-8.032 7.99 0 1.508.422 2.98 1.229 4.253l.19.304-.812 2.948 3.04-.794Z"
    }, null, 8, wB),
    h("path", {
      fill: "url(#" + t.idMap.c + ")",
      d: "M0 0h26v10H0z",
      transform: "translate(3 11)"
    }, null, 8, yB),
    MB,
    h("defs", null, [
      h("linearGradient", {
        id: t.idMap.a,
        x1: "15.999",
        x2: "15.999",
        y1: "31.998",
        y2: "-.001",
        gradientUnits: "userSpaceOnUse"
      }, [...SB], 8, CB),
      h("linearGradient", {
        id: t.idMap.b,
        x1: "16.002",
        x2: "16.002",
        y1: "25.409",
        y2: "6",
        gradientUnits: "userSpaceOnUse"
      }, [...EB], 8, IB),
      h("linearGradient", {
        id: t.idMap.c,
        x1: "13",
        x2: "13",
        y1: "21",
        y2: "-11",
        gradientUnits: "userSpaceOnUse"
      }, [...LB], 8, PB)
    ])
  ]);
}
const NB = I({ name: "icon-WhatsAppBusinessApiXL", render: DB, data() {
  const t = () => Math.random().toString(36).substr(2, 10);
  return { idMap: { a: "uicons-" + t(), b: "uicons-" + t(), c: "uicons-" + t() } };
} }), RB = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}, ZB = /* @__PURE__ */ h("rect", {
  width: "32",
  height: "32",
  fill: "currentColor",
  rx: "6.4"
}, null, -1), BB = ["clip-path"], VB = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "m27.2 16-2.783-3.733a15.16 15.16 0 0 1-8.814 2.817c-2.916 0-5.766-.852-8.218-2.424l-2.584 3.865c3.18 2.096 6.958 3.21 10.802 3.21 4.242 0 8.218-1.31 11.598-3.734Z"
}, null, -1), FB = [
  VB
], HB = ["id"], UB = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M4.8 4.8h22.4v22.4H4.8z"
}, null, -1), zB = [
  UB
];
function WB(t, e) {
  return p(), g("svg", RB, [
    ZB,
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...FB], 8, BB),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...zB], 8, HB)
    ])
  ]);
}
const jB = I({ name: "icon-ProductLogo", render: WB, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), GB = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none",
  viewBox: "0 0 48 48"
}, YB = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14 6a8 8 0 0 0-8 8v20a8 8 0 0 0 8 8h20a8 8 0 0 0 8-8V14a8 8 0 0 0-8-8H14Zm-4 8a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v11.139l-.586-.553a1.392 1.392 0 0 0-.027-.027c-1.205-1.16-2.715-1.899-4.387-1.899-1.672 0-3.182.74-4.387 1.899l-.027.027-.586.585-4.586-4.585a1.744 1.744 0 0 0-.027-.027c-1.205-1.16-2.715-1.899-4.387-1.899-1.672 0-3.182.74-4.387 1.899a1.75 1.75 0 0 0-.027.027L10 26.03V14Z",
  "clip-rule": "evenodd"
}, null, -1), XB = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M34 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
}, null, -1), KB = [
  YB,
  XB
];
function qB(t, e) {
  return p(), g("svg", GB, [...KB]);
}
const JB = I({ name: "icon-ImageXXL", render: qB }), QB = {
  component: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none",
  viewBox: "0 0 48 48"
}, eV = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M40.212 13.918A4 4 0 0 1 46 17.494v13.53a4 4 0 0 1-5.788 3.576 1.999 1.999 0 0 1-.591-.45L34.5 29.5v-10l5.12-5.133c.168-.185.369-.338.592-.45ZM2 15.5a6 6 0 0 1 6-6h17.5a6 6 0 0 1 6 6v17a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6v-17Z",
  "clip-rule": "evenodd"
}, null, -1), tV = [
  eV
];
function nV(t, e) {
  return p(), g("svg", QB, [...tV]);
}
const oV = I({ name: "icon-VideoXXL", render: nV }), iV = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rV = /* @__PURE__ */ h("rect", {
  x: "1",
  y: "1",
  width: "14",
  height: "14",
  rx: "3",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1), aV = [
  rV
];
function sV(t, e) {
  return p(), g("svg", iV, [...aV]);
}
const Hd = I({ name: "icon-CheckboxDefault", render: sV }), lV = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dV = ["clip-path"], cV = /* @__PURE__ */ h("rect", {
  width: "16",
  height: "16",
  rx: "4",
  fill: "currentColor"
}, null, -1), uV = /* @__PURE__ */ h("path", {
  d: "M12.251 4.25104L7.10819 9.8356L3.96323 6.75108C3.80249 6.59033 3.58447 6.50003 3.35714 6.50003C3.12981 6.50003 2.9118 6.59033 2.75105 6.75108C2.59031 6.91182 2.5 7.12984 2.5 7.35717C2.5 7.5845 2.59031 7.80252 2.75105 7.96326L6.40109 11.5529C6.79161 11.9434 7.42478 11.9434 7.8153 11.5529L13.4632 5.46322C13.624 5.30248 13.7143 5.08446 13.7143 4.85713C13.7143 4.6298 13.624 4.41178 13.4632 4.25104C13.3025 4.09029 13.0845 3.99999 12.8571 3.99999C12.6298 3.99999 12.4118 4.09029 12.251 4.25104Z",
  fill: "white"
}, null, -1), hV = [
  cV,
  uV
], fV = ["id"], mV = /* @__PURE__ */ h("rect", {
  width: "16",
  height: "16",
  fill: "white"
}, null, -1), pV = [
  mV
];
function _V(t, e) {
  return p(), g("svg", lV, [
    h("g", {
      "clip-path": "url(#" + t.idMap.clip0_1610_16423 + ")"
    }, [...hV], 8, dV),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.clip0_1610_16423
      }, [...pV], 8, fV)
    ])
  ]);
}
const Ud = I({ name: "icon-CheckboxActive", render: _V, data() {
  return { idMap: { clip0_1610_16423: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), vV = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gV = /* @__PURE__ */ h("rect", {
  x: "1",
  y: "1",
  width: "14",
  height: "14",
  rx: "7",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1), $V = [
  gV
];
function wV(t, e) {
  return p(), g("svg", vV, [...$V]);
}
const zd = I({ name: "icon-RadioDefault", render: wV }), yV = {
  component: "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MV = /* @__PURE__ */ h("rect", {
  width: "16",
  height: "16",
  rx: "8",
  fill: "currentColor"
}, null, -1), CV = /* @__PURE__ */ h("rect", {
  x: "5",
  y: "5",
  width: "6",
  height: "6",
  rx: "3",
  fill: "white"
}, null, -1), bV = [
  MV,
  CV
];
function xV(t, e) {
  return p(), g("svg", yV, [...bV]);
}
const Wd = I({ name: "icon-RadioActive", render: xV }), SV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconAddFileMd: uC,
  IconAddFileSm: D6,
  IconAddMd: yd,
  IconAddPeopleMd: wC,
  IconAddPeopleSm: V6,
  IconArrowBackSm: W6,
  IconArrowDoubleLeftMd: xC,
  IconArrowDoubleLeftSm: K6,
  IconArrowDoubleRightMd: EC,
  IconArrowDoubleRightSm: t4,
  IconArrowDown2Sm: u4,
  IconArrowDownMd: DC,
  IconArrowDownShortMd: VC,
  IconArrowDownSm: a4,
  IconArrowLeftMd: Md,
  IconArrowLeftRightMd: AL,
  IconArrowLeftRightSm: V$,
  IconArrowLeftShortMd: XC,
  IconArrowLeftSm: _4,
  IconArrowRightMd: eb,
  IconArrowRightShortMd: rb,
  IconArrowRightSm: y4,
  IconArrowToSm: S4,
  IconArrowUp2Sm: P4,
  IconArrowUpMd: cb,
  IconArrowUpShortMd: pb,
  IconArrowUpSm: N4,
  IconAttachmentMd: wb,
  IconAttachmentSm: W4,
  IconAttachmentXS: wu,
  IconAudioLg: Yi,
  IconBackMd: kb,
  IconBackSm: K4,
  IconBanMd: Lb,
  IconBanSm: th,
  IconBellMd: fZ,
  IconBotMd: Ub,
  IconBotSm: ah,
  IconBoxMd: Yb,
  IconBoxSm: uh,
  IconBurgerMd: Qb,
  IconBurgerSm: _h,
  IconCalendarEventMd: ix,
  IconCalendarEventSm: xh,
  IconCalendarMd: cx,
  IconCalendarNumberMd: yx,
  IconCalendarNumberSm: Nh,
  IconCalendarPostponedMd: Ix,
  IconCalendarPostponedSm: Hh,
  IconCalendarSm: Yh,
  IconCalendarWarningMd: Ox,
  IconCalendarWarningSm: e5,
  IconCalendarXS: Eu,
  IconCancelMd: gO,
  IconCancelSm: Eg,
  IconCarMd: Cd,
  IconCarSm: u5,
  IconCardMd: Bx,
  IconCardSm: a5,
  IconChatMd: Yx,
  IconChatSm: w5,
  IconCheckMd: Qx,
  IconCheckSm: x5,
  IconCheckboxActive: Ud,
  IconCheckboxDefault: Hd,
  IconChecksMd: rS,
  IconChecksSm: P5,
  IconCircleCheckMd: cS,
  IconCircleCheckSm: V5,
  IconClockMd: sZ,
  IconCodeMd: pS,
  IconCodeSm: W5,
  IconCoffeeMd: bd,
  IconCoffeeSm: K5,
  IconCollapseLeftMd: bS,
  IconCollapseLeftSm: t8,
  IconCollapseRightMd: kS,
  IconCollapseRightSm: a8,
  IconConditionMd: eD,
  IconConditionSm: _w,
  IconConfettiMd: JR,
  IconCopyMd: LS,
  IconCopySm: u8,
  IconCrossMd: jr,
  IconCrossSm: _8,
  IconCudosMd: US,
  IconCudosSm: y8,
  IconDislikeMd: YS,
  IconDislikeSm: S8,
  IconDogMd: xd,
  IconDogSm: P8,
  IconDownloadMd: iI,
  IconDownloadSm: F8,
  IconEnterMd: cI,
  IconEnterSm: G8,
  IconErrorMd: Sd,
  IconErrorSm: Q8,
  IconExtendLeftMd: $I,
  IconExtendLeftSm: i7,
  IconExtendRightMd: bI,
  IconExtendRightSm: d7,
  IconEyeClosedMd: OL,
  IconEyeClosedSm: W$,
  IconEyeMd: BL,
  IconEyeSm: q$,
  IconFileLg: t1,
  IconFileMd: Id,
  IconFileSm: m7,
  IconFilledArrowLeftMd: BD,
  IconFilledArrowLeftSm: gy,
  IconFilledArrowRightMd: zD,
  IconFilledArrowRightSm: Iy,
  IconFilledCrossMd: XD,
  IconFilledCrossSm: Oy,
  IconFilledDesktopMd: eN,
  IconFilledDesktopSm: Zy,
  IconFilledDevicesMd: rN,
  IconFilledDevicesSm: Uy,
  IconFilledEditMd: cN,
  IconFilledEditSm: Yy,
  IconFilledGoogleMd: pN,
  IconFilledGoogleSm: Qy,
  IconFilledGoogleXS: u6,
  IconFilledMobileMd: wN,
  IconFilledMobileSm: iM,
  IconFilledMoreMd: xN,
  IconFilledMoreSm: dM,
  IconFilledMoveMd: EN,
  IconFilledMoveSm: mM,
  IconFilledPauseMd: Yr,
  IconFilledPauseSm: $M,
  IconFilledPersonMd: BN,
  IconFilledPersonSm: bM,
  IconFilledPlayMd: Xr,
  IconFilledPlaySm: wd,
  IconFilledQRMd: YN,
  IconFilledReplySm: dy,
  IconFilledStarMd: QN,
  IconFilledStarSm: OM,
  IconFilledStopMd: iR,
  IconFilledStopSm: ZM,
  IconFilledTelegramXS: _6,
  IconFilledTextStyleBoldMd: dR,
  IconFilledTextStyleBoldSm: UM,
  IconFilledTextStyleItalicMd: mR,
  IconFilledTextStyleItalicSm: YM,
  IconFilledTextStyleStrikethroughMd: $R,
  IconFilledTextStyleStrikethroughSm: QM,
  IconFilterOnMd: aC,
  IconFilterSortOffMd: OI,
  IconFilterSortOffSm: $7,
  IconFilterSortOnMd: BI,
  IconFilterSortOnSm: x7,
  IconFiltresMd: zI,
  IconFlagMd: Ad,
  IconFlagSm: E7,
  IconFolderMd: zL,
  IconFolderSm: nw,
  IconFullscreenMd: JT,
  IconFullscreenSm: Yv,
  IconGoogleDriveLg: RZ,
  IconGoogleMd: IR,
  IconHashMd: kd,
  IconHashSm: N7,
  IconHeartHandshakeMd: zO,
  IconHeartHandshakeSm: n$,
  IconImageMd: iA,
  IconImageSm: F7,
  IconImageXXL: JB,
  IconIncomingChatMd: cD,
  IconIncomingChatSm: Lw,
  IconInfoMd: Ed,
  IconInfoSm: G7,
  IconInstagramXL: YZ,
  IconLaterMd: $A,
  IconLaterSm: rf,
  IconLightBulbMd: Pd,
  IconLightBulbSm: cf,
  IconLightningMd: pD,
  IconLightningSm: Bw,
  IconLinkMd: AA,
  IconLinkSm: $f,
  IconListCheckMd: tL,
  IconListCheckSm: f$,
  IconListMd: OA,
  IconListSm: bf,
  IconLockMd: LO,
  IconLockSm: jg,
  IconMailMd: Td,
  IconMailSm: kf,
  IconMicrophoneMd: UA,
  IconMicrophoneSm: Df,
  IconMicrophoneXS: Nu,
  IconMinusMd: YA,
  IconMinusSm: Vf,
  IconMusicMd: Od,
  IconMusicSm: Wf,
  IconNoteMd: ok,
  IconNoteSm: em,
  IconNotificationMd: lk,
  IconNotificationSm: rm,
  IconNumbersMd: CO,
  IconNumbersSm: Dg,
  IconOkMd: vk,
  IconOkSm: mm,
  IconOutMd: Mk,
  IconOutSm: $m,
  IconOutgoingChatMd: rD,
  IconOutgoingChatSm: xw,
  IconParametrMd: Ik,
  IconParametrSm: bm,
  IconPartyMd: XL,
  IconPartySm: uw,
  IconPeopleMd: Tk,
  IconPeopleSm: km,
  IconPeopleXS: Fu,
  IconPhoneMd: Ld,
  IconPhoneMissedMd: Fk,
  IconPhoneMissedSm: Zm,
  IconPhoneSm: Gm,
  IconPinMd: jk,
  IconPinSm: Jm,
  IconPlaceholderMd: qk,
  IconPlaceholderSm: op,
  IconPlusMd: fp,
  IconPlusSm: lp,
  IconProductLogo: jB,
  IconProfileMd: Gr,
  IconProfileSm: gp,
  IconProfileXS: ju,
  IconRadioActive: Wd,
  IconRadioButtonMd: kO,
  IconRadioButtonSm: Fg,
  IconRadioDefault: zd,
  IconReassignMd: sE,
  IconReassignSm: bp,
  IconRefreshMd: hE,
  IconRefreshSm: $d,
  IconReopenMd: yE,
  IconReopenSm: Rp,
  IconRepeatEventMd: LD,
  IconRepeatEventSm: iy,
  IconRepeatMd: SE,
  IconRepeatSm: Hp,
  IconRepeatTaskMd: AD,
  IconRepeatTaskSm: Jw,
  IconRepeatXS: qu,
  IconRotateLeftMd: oO,
  IconRotateLeftSm: og,
  IconRotateMd: PE,
  IconRotateRightMd: lO,
  IconRotateRightSm: hg,
  IconRotateSm: Gp,
  IconRubelMd: NE,
  IconRubelSm: Jp,
  IconSearchMd: FE,
  IconSearchSm: o9,
  IconSendMd: jE,
  IconSendSm: l9,
  IconSettings2Sm: f9,
  IconSettingsMd: JE,
  IconSettingsSm: $9,
  IconShareMd: oP,
  IconShareSm: b9,
  IconSmileMd: Dd,
  IconSmileSm: O9,
  IconSoccerMd: Nd,
  IconSoccerSm: H9,
  IconSocialsMd: _P,
  IconSocialsSm: q9,
  IconSquareCheckMd: aL,
  IconSquareCheckSm: g$,
  IconStagesMd: BO,
  IconStagesSm: qg,
  IconStarMd: fO,
  IconStarSm: yg,
  IconStatisticMd: yP,
  IconStatisticSm: n_,
  IconSubtaskMd: SP,
  IconSubtaskSm: s_,
  IconSubtaskXS: n6,
  IconSuitcaseMd: PP,
  IconSuitcaseSm: h_,
  IconSuitcaseXS: x6,
  IconTagMd: RP,
  IconTagSm: M_,
  IconTaskMd: HP,
  IconTaskSm: I_,
  IconTaskXS: E6,
  IconTelegramMd: UR,
  IconTelegramXL: vB,
  IconTemplateMd: GP,
  IconTemplateSm: T_,
  IconTextMd: XO,
  IconTextSm: s$,
  IconTimeMd: Rd,
  IconTimeSm: Y_,
  IconTimerMd: iT,
  IconTimerSm: B_,
  IconToggleMd: uL,
  IconToggleSm: C$,
  IconTrashMd: uT,
  IconTrashSm: Q_,
  IconUserCancelMd: MD,
  IconUserCancelSm: jw,
  IconUserStarMd: gL,
  IconUserStarSm: E$,
  IconVideoLg: Kr,
  IconVideoMd: Zd,
  IconVideoSm: iv,
  IconVideoXXL: oV,
  IconVolumeMd: Bd,
  IconVolumeOffMd: Vd,
  IconVolumeOffSm: dv,
  IconVolumeSm: mv,
  IconWABATemplateMd: kT,
  IconWABATemplateSm: wv,
  IconWalletMd: LT,
  IconWalletSm: kv,
  IconWarningMd: Fd,
  IconWarningSm: Lv,
  IconWeekMd: GT,
  IconWeekSm: Uv,
  IconWhatsAppBusinessApiXL: NB,
  IconWhatsAppMd: LR,
  IconWhatsAppXL: lB,
  IconWorldMd: CL,
  IconWorldSm: D$
}, Symbol.toStringTag, { value: "Module" })), IV = { class: "alert-left" }, AV = {
  key: 0,
  class: "alert-icon"
}, kV = { class: "alert-text" }, EV = /* @__PURE__ */ oe({
  name: "PAlert",
  __name: "index",
  props: {
    color: { default: "info" },
    showCross: { type: Boolean },
    modelValue: { type: Boolean, default: void 0 },
    buttonText: {},
    hideLeftIcon: { type: Boolean },
    hideRightIcon: { type: Boolean }
  },
  emits: ["update:modelValue", "click:button", "click:close"],
  setup(t, { emit: e }) {
    const n = {
      warning: Fd,
      info: Ed,
      error: Sd
    }, o = t, i = e, r = o.modelValue === void 0 ? U(!0) : me(o, "modelValue", i), a = z(() => n[o.color]), s = () => {
      i("click:close"), r.value = !1;
    };
    return (l, d) => {
      const c = Gi, u = vt;
      return p(), J(Xe, { name: "fade" }, {
        default: G(() => [
          B(r) ? (p(), g("div", {
            key: 0,
            class: ee(["p-alert", l.color])
          }, [
            h("div", IV, [
              l.hideLeftIcon ? X("", !0) : (p(), g("div", AV, [
                Y(l.$slots, "leftIcon", {}, () => [
                  (p(), J(Ce(a.value)))
                ], !0)
              ])),
              h("div", kV, [
                Y(l.$slots, "default", {}, void 0, !0)
              ])
            ]),
            l.hideRightIcon ? X("", !0) : Y(l.$slots, "rightIcon", { key: 0 }, () => [
              h("div", {
                class: ee(["alert-right", { "with-cross": l.showCross }])
              }, [
                l.showCross ? (p(), J(u, {
                  key: 0,
                  variant: "text",
                  class: "alert-cross",
                  onClick: s
                }, {
                  default: G(() => [
                    q(c)
                  ]),
                  _: 1
                })) : Y(l.$slots, "button", { key: 1 }, () => [
                  l.buttonText ? (p(), J(u, {
                    key: 0,
                    size: "x-small",
                    color: "secondary-white",
                    onClick: d[0] || (d[0] = (f) => i("click:button"))
                  }, {
                    default: G(() => [
                      xe(ne(l.buttonText), 1)
                    ]),
                    _: 1
                  })) : X("", !0)
                ], !0)
              ], 2)
            ], !0)
          ], 2)) : X("", !0)
        ]),
        _: 3
      });
    };
  }
}), jd = /* @__PURE__ */ ae(EV, [["__scopeId", "data-v-697823c2"]]), PV = { class: "p-alert-container" }, TV = /* @__PURE__ */ oe({
  name: "PAlertContainer",
  __name: "PAlertContainer",
  props: {
    alerts: {}
  },
  setup(t) {
    return (e, n) => {
      const o = jd;
      return p(), g("div", PV, [
        (p(!0), g(_e, null, Ie(e.alerts, (i, r) => (p(), J(o, {
          key: r,
          modelValue: i.showAlert,
          "onUpdate:modelValue": (a) => i.showAlert = a,
          "button-text": i.buttonText,
          "show-cross": i.showCross,
          color: i.color,
          "onClick:button": i["click:button"],
          "onClick:close": i["click:close"]
        }, {
          default: G(() => [
            xe(ne(i.text), 1)
          ]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "button-text", "show-cross", "color", "onClick:button", "onClick:close"]))), 128))
      ]);
    };
  }
}), OV = /* @__PURE__ */ ae(TV, [["__scopeId", "data-v-e5ce772e"]]);
function st(t, e, n, o) {
  return new (n || (n = Promise))(function(i, r) {
    function a(d) {
      try {
        l(o.next(d));
      } catch (c) {
        r(c);
      }
    }
    function s(d) {
      try {
        l(o.throw(d));
      } catch (c) {
        r(c);
      }
    }
    function l(d) {
      var c;
      d.done ? i(d.value) : (c = d.value, c instanceof n ? c : new n(function(u) {
        u(c);
      })).then(a, s);
    }
    l((o = o.apply(t, e || [])).next());
  });
}
class ni {
  constructor() {
    this.listeners = {};
  }
  on(e, n, o) {
    if (this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set()), this.listeners[e].add(n), o == null ? void 0 : o.once) {
      const i = () => {
        this.un(e, i), this.un(e, n);
      };
      return this.on(e, i), i;
    }
    return () => this.un(e, n);
  }
  un(e, n) {
    var o;
    (o = this.listeners[e]) === null || o === void 0 || o.delete(n);
  }
  once(e, n) {
    return this.on(e, n, { once: !0 });
  }
  unAll() {
    this.listeners = {};
  }
  emit(e, ...n) {
    this.listeners[e] && this.listeners[e].forEach((o) => o(...n));
  }
}
const Qa = { decode: function(t, e) {
  return st(this, void 0, void 0, function* () {
    const n = new AudioContext({ sampleRate: e });
    return n.decodeAudioData(t).finally(() => n.close());
  });
}, createBuffer: function(t, e) {
  return typeof t[0] == "number" && (t = [t]), function(n) {
    const o = n[0];
    if (o.some((i) => i > 1 || i < -1)) {
      const i = o.length;
      let r = 0;
      for (let a = 0; a < i; a++) {
        const s = Math.abs(o[a]);
        s > r && (r = s);
      }
      for (const a of n) for (let s = 0; s < i; s++) a[s] /= r;
    }
  }(t), { duration: e, length: t[0].length, sampleRate: t[0].length / e, numberOfChannels: t.length, getChannelData: (n) => t == null ? void 0 : t[n], copyFromChannel: AudioBuffer.prototype.copyFromChannel, copyToChannel: AudioBuffer.prototype.copyToChannel };
} };
function Gd(t, e) {
  const n = e.xmlns ? document.createElementNS(e.xmlns, t) : document.createElement(t);
  for (const [o, i] of Object.entries(e)) if (o === "children") for (const [r, a] of Object.entries(e)) typeof a == "string" ? n.appendChild(document.createTextNode(a)) : n.appendChild(Gd(r, a));
  else o === "style" ? Object.assign(n.style, i) : o === "textContent" ? n.textContent = i : n.setAttribute(o, i.toString());
  return n;
}
function es(t, e, n) {
  const o = Gd(t, e || {});
  return n == null || n.appendChild(o), o;
}
var LV = Object.freeze({ __proto__: null, createElement: es, default: es });
const DV = { fetchBlob: function(t, e, n) {
  return st(this, void 0, void 0, function* () {
    const o = yield fetch(t, n);
    if (o.status >= 400) throw new Error(`Failed to fetch ${t}: ${o.status} (${o.statusText})`);
    return function(i, r) {
      st(this, void 0, void 0, function* () {
        if (!i.body || !i.headers) return;
        const a = i.body.getReader(), s = Number(i.headers.get("Content-Length")) || 0;
        let l = 0;
        const d = (u) => st(this, void 0, void 0, function* () {
          l += (u == null ? void 0 : u.length) || 0;
          const f = Math.round(l / s * 100);
          r(f);
        }), c = () => st(this, void 0, void 0, function* () {
          let u;
          try {
            u = yield a.read();
          } catch {
            return;
          }
          u.done || (d(u.value), yield c());
        });
        c();
      });
    }(o.clone(), e), o.blob();
  });
} };
let NV = class extends ni {
  constructor(e) {
    super(), this.isExternalMedia = !1, e.media ? (this.media = e.media, this.isExternalMedia = !0) : this.media = document.createElement("audio"), e.mediaControls && (this.media.controls = !0), e.autoplay && (this.media.autoplay = !0), e.playbackRate != null && this.onMediaEvent("canplay", () => {
      e.playbackRate != null && (this.media.playbackRate = e.playbackRate);
    }, { once: !0 });
  }
  onMediaEvent(e, n, o) {
    return this.media.addEventListener(e, n, o), () => this.media.removeEventListener(e, n, o);
  }
  getSrc() {
    return this.media.currentSrc || this.media.src || "";
  }
  revokeSrc() {
    const e = this.getSrc();
    e.startsWith("blob:") && URL.revokeObjectURL(e);
  }
  canPlayType(e) {
    return this.media.canPlayType(e) !== "";
  }
  setSrc(e, n) {
    const o = this.getSrc();
    if (e && o === e) return;
    this.revokeSrc();
    const i = n instanceof Blob && (this.canPlayType(n.type) || !e) ? URL.createObjectURL(n) : e;
    try {
      this.media.src = i;
    } catch {
      this.media.src = e;
    }
  }
  destroy() {
    this.media.pause(), this.isExternalMedia || (this.media.remove(), this.revokeSrc(), this.media.src = "", this.media.load());
  }
  setMediaElement(e) {
    this.media = e;
  }
  play() {
    return st(this, void 0, void 0, function* () {
      return this.media.play();
    });
  }
  pause() {
    this.media.pause();
  }
  isPlaying() {
    return !this.media.paused && !this.media.ended;
  }
  setTime(e) {
    this.media.currentTime = e;
  }
  getDuration() {
    return this.media.duration;
  }
  getCurrentTime() {
    return this.media.currentTime;
  }
  getVolume() {
    return this.media.volume;
  }
  setVolume(e) {
    this.media.volume = e;
  }
  getMuted() {
    return this.media.muted;
  }
  setMuted(e) {
    this.media.muted = e;
  }
  getPlaybackRate() {
    return this.media.playbackRate;
  }
  isSeeking() {
    return this.media.seeking;
  }
  setPlaybackRate(e, n) {
    n != null && (this.media.preservesPitch = n), this.media.playbackRate = e;
  }
  getMediaElement() {
    return this.media;
  }
  setSinkId(e) {
    return this.media.setSinkId(e);
  }
}, N0 = class R0 extends ni {
  constructor(e, n) {
    super(), this.timeouts = [], this.isScrollable = !1, this.audioData = null, this.resizeObserver = null, this.lastContainerWidth = 0, this.isDragging = !1, this.subscriptions = [], this.subscriptions = [], this.options = e;
    const o = this.parentFromOptionsContainer(e.container);
    this.parent = o;
    const [i, r] = this.initHtml();
    o.appendChild(i), this.container = i, this.scrollContainer = r.querySelector(".scroll"), this.wrapper = r.querySelector(".wrapper"), this.canvasWrapper = r.querySelector(".canvases"), this.progressWrapper = r.querySelector(".progress"), this.cursor = r.querySelector(".cursor"), n && r.appendChild(n), this.initEvents();
  }
  parentFromOptionsContainer(e) {
    let n;
    if (typeof e == "string" ? n = document.querySelector(e) : e instanceof HTMLElement && (n = e), !n) throw new Error("Container not found");
    return n;
  }
  initEvents() {
    const e = (n) => {
      const o = this.wrapper.getBoundingClientRect(), i = n.clientX - o.left, r = n.clientY - o.top;
      return [i / o.width, r / o.height];
    };
    if (this.wrapper.addEventListener("click", (n) => {
      const [o, i] = e(n);
      this.emit("click", o, i);
    }), this.wrapper.addEventListener("dblclick", (n) => {
      const [o, i] = e(n);
      this.emit("dblclick", o, i);
    }), this.options.dragToSeek !== !0 && typeof this.options.dragToSeek != "object" || this.initDrag(), this.scrollContainer.addEventListener("scroll", () => {
      const { scrollLeft: n, scrollWidth: o, clientWidth: i } = this.scrollContainer, r = n / o, a = (n + i) / o;
      this.emit("scroll", r, a, n, n + i);
    }), typeof ResizeObserver == "function") {
      const n = this.createDelay(100);
      this.resizeObserver = new ResizeObserver(() => {
        n().then(() => this.onContainerResize()).catch(() => {
        });
      }), this.resizeObserver.observe(this.scrollContainer);
    }
  }
  onContainerResize() {
    const e = this.parent.clientWidth;
    e === this.lastContainerWidth && this.options.height !== "auto" || (this.lastContainerWidth = e, this.reRender());
  }
  initDrag() {
    this.subscriptions.push(function(e, n, o, i, r = 3, a = 0, s = 100) {
      if (!e) return () => {
      };
      const l = matchMedia("(pointer: coarse)").matches;
      let d = () => {
      };
      const c = (u) => {
        if (u.button !== a) return;
        u.preventDefault(), u.stopPropagation();
        let f = u.clientX, m = u.clientY, v = !1;
        const _ = Date.now(), w = (x) => {
          if (x.preventDefault(), x.stopPropagation(), l && Date.now() - _ < s) return;
          const b = x.clientX, C = x.clientY, E = b - f, A = C - m;
          if (v || Math.abs(E) > r || Math.abs(A) > r) {
            const T = e.getBoundingClientRect(), { left: k, top: L } = T;
            v || (o == null || o(f - k, m - L), v = !0), n(E, A, b - k, C - L), f = b, m = C;
          }
        }, $ = (x) => {
          if (v) {
            const b = x.clientX, C = x.clientY, E = e.getBoundingClientRect(), { left: A, top: T } = E;
            i == null || i(b - A, C - T);
          }
          d();
        }, y = (x) => {
          x.relatedTarget && x.relatedTarget !== document.documentElement || $(x);
        }, M = (x) => {
          v && (x.stopPropagation(), x.preventDefault());
        }, S = (x) => {
          v && x.preventDefault();
        };
        document.addEventListener("pointermove", w), document.addEventListener("pointerup", $), document.addEventListener("pointerout", y), document.addEventListener("pointercancel", y), document.addEventListener("touchmove", S, { passive: !1 }), document.addEventListener("click", M, { capture: !0 }), d = () => {
          document.removeEventListener("pointermove", w), document.removeEventListener("pointerup", $), document.removeEventListener("pointerout", y), document.removeEventListener("pointercancel", y), document.removeEventListener("touchmove", S), setTimeout(() => {
            document.removeEventListener("click", M, { capture: !0 });
          }, 10);
        };
      };
      return e.addEventListener("pointerdown", c), () => {
        d(), e.removeEventListener("pointerdown", c);
      };
    }(this.wrapper, (e, n, o) => {
      this.emit("drag", Math.max(0, Math.min(1, o / this.wrapper.getBoundingClientRect().width)));
    }, (e) => {
      this.isDragging = !0, this.emit("dragstart", Math.max(0, Math.min(1, e / this.wrapper.getBoundingClientRect().width)));
    }, (e) => {
      this.isDragging = !1, this.emit("dragend", Math.max(0, Math.min(1, e / this.wrapper.getBoundingClientRect().width)));
    }));
  }
  getHeight(e, n) {
    var o;
    const i = ((o = this.audioData) === null || o === void 0 ? void 0 : o.numberOfChannels) || 1;
    if (e == null) return 128;
    if (!isNaN(Number(e))) return Number(e);
    if (e === "auto") {
      const r = this.parent.clientHeight || 128;
      return n != null && n.every((a) => !a.overlay) ? r / i : r;
    }
    return 128;
  }
  initHtml() {
    const e = document.createElement("div"), n = e.attachShadow({ mode: "open" });
    return n.innerHTML = `
      <style>
        :host {
          user-select: none;
          min-width: 1px;
        }
        :host audio {
          display: block;
          width: 100%;
        }
        :host .scroll {
          overflow-x: auto;
          overflow-y: hidden;
          width: 100%;
          position: relative;
        }
        :host .noScrollbar {
          scrollbar-color: transparent;
          scrollbar-width: none;
        }
        :host .noScrollbar::-webkit-scrollbar {
          display: none;
          -webkit-appearance: none;
        }
        :host .wrapper {
          position: relative;
          overflow: visible;
          z-index: 2;
        }
        :host .canvases {
          min-height: ${this.getHeight(this.options.height, this.options.splitChannels)}px;
        }
        :host .canvases > div {
          position: relative;
        }
        :host canvas {
          display: block;
          position: absolute;
          top: 0;
          image-rendering: pixelated;
        }
        :host .progress {
          pointer-events: none;
          position: absolute;
          z-index: 2;
          top: 0;
          left: 0;
          width: 0;
          height: 100%;
          overflow: hidden;
        }
        :host .progress > div {
          position: relative;
        }
        :host .cursor {
          pointer-events: none;
          position: absolute;
          z-index: 5;
          top: 0;
          left: 0;
          height: 100%;
          border-radius: 2px;
        }
      </style>

      <div class="scroll" part="scroll">
        <div class="wrapper" part="wrapper">
          <div class="canvases" part="canvases"></div>
          <div class="progress" part="progress"></div>
          <div class="cursor" part="cursor"></div>
        </div>
      </div>
    `, [e, n];
  }
  setOptions(e) {
    if (this.options.container !== e.container) {
      const n = this.parentFromOptionsContainer(e.container);
      n.appendChild(this.container), this.parent = n;
    }
    e.dragToSeek !== !0 && typeof this.options.dragToSeek != "object" || this.initDrag(), this.options = e, this.reRender();
  }
  getWrapper() {
    return this.wrapper;
  }
  getWidth() {
    return this.scrollContainer.clientWidth;
  }
  getScroll() {
    return this.scrollContainer.scrollLeft;
  }
  setScroll(e) {
    this.scrollContainer.scrollLeft = e;
  }
  setScrollPercentage(e) {
    const { scrollWidth: n } = this.scrollContainer, o = n * e;
    this.setScroll(o);
  }
  destroy() {
    var e, n;
    this.subscriptions.forEach((o) => o()), this.container.remove(), (e = this.resizeObserver) === null || e === void 0 || e.disconnect(), (n = this.unsubscribeOnScroll) === null || n === void 0 || n.call(this);
  }
  createDelay(e = 10) {
    let n, o;
    const i = () => {
      n && clearTimeout(n), o && o();
    };
    return this.timeouts.push(i), () => new Promise((r, a) => {
      i(), o = a, n = setTimeout(() => {
        n = void 0, o = void 0, r();
      }, e);
    });
  }
  convertColorValues(e) {
    if (!Array.isArray(e)) return e || "";
    if (e.length < 2) return e[0] || "";
    const n = document.createElement("canvas"), o = n.getContext("2d"), i = n.height * (window.devicePixelRatio || 1), r = o.createLinearGradient(0, 0, 0, i), a = 1 / (e.length - 1);
    return e.forEach((s, l) => {
      const d = l * a;
      r.addColorStop(d, s);
    }), r;
  }
  getPixelRatio() {
    return Math.max(1, window.devicePixelRatio || 1);
  }
  renderBarWaveform(e, n, o, i) {
    const r = e[0], a = e[1] || e[0], s = r.length, { width: l, height: d } = o.canvas, c = d / 2, u = this.getPixelRatio(), f = n.barWidth ? n.barWidth * u : 1, m = n.barGap ? n.barGap * u : n.barWidth ? f / 2 : 0, v = n.barRadius || 0, _ = l / (f + m) / s, w = v && "roundRect" in o ? "roundRect" : "rect";
    o.beginPath();
    let $ = 0, y = 0, M = 0;
    for (let S = 0; S <= s; S++) {
      const x = Math.round(S * _);
      if (x > $) {
        const E = Math.round(y * c * i), A = E + Math.round(M * c * i) || 1;
        let T = c - E;
        n.barAlign === "top" ? T = 0 : n.barAlign === "bottom" && (T = d - A), o[w]($ * (f + m), T, f, A, v), $ = x, y = 0, M = 0;
      }
      const b = Math.abs(r[S] || 0), C = Math.abs(a[S] || 0);
      b > y && (y = b), C > M && (M = C);
    }
    o.fill(), o.closePath();
  }
  renderLineWaveform(e, n, o, i) {
    const r = (a) => {
      const s = e[a] || e[0], l = s.length, { height: d } = o.canvas, c = d / 2, u = o.canvas.width / l;
      o.moveTo(0, c);
      let f = 0, m = 0;
      for (let v = 0; v <= l; v++) {
        const _ = Math.round(v * u);
        if (_ > f) {
          const $ = c + (Math.round(m * c * i) || 1) * (a === 0 ? -1 : 1);
          o.lineTo(f, $), f = _, m = 0;
        }
        const w = Math.abs(s[v] || 0);
        w > m && (m = w);
      }
      o.lineTo(f, c);
    };
    o.beginPath(), r(0), r(1), o.fill(), o.closePath();
  }
  renderWaveform(e, n, o) {
    if (o.fillStyle = this.convertColorValues(n.waveColor), n.renderFunction) return void n.renderFunction(e, o);
    let i = n.barHeight || 1;
    if (n.normalize) {
      const r = Array.from(e[0]).reduce((a, s) => Math.max(a, Math.abs(s)), 0);
      i = r ? 1 / r : 1;
    }
    n.barWidth || n.barGap || n.barAlign ? this.renderBarWaveform(e, n, o, i) : this.renderLineWaveform(e, n, o, i);
  }
  renderSingleCanvas(e, n, o, i, r, a, s) {
    const l = this.getPixelRatio(), d = document.createElement("canvas");
    d.width = Math.round(o * l), d.height = Math.round(i * l), d.style.width = `${o}px`, d.style.height = `${i}px`, d.style.left = `${Math.round(r)}px`, a.appendChild(d);
    const c = d.getContext("2d");
    if (this.renderWaveform(e, n, c), d.width > 0 && d.height > 0) {
      const u = d.cloneNode(), f = u.getContext("2d");
      f.drawImage(d, 0, 0), f.globalCompositeOperation = "source-in", f.fillStyle = this.convertColorValues(n.progressColor), f.fillRect(0, 0, d.width, d.height), s.appendChild(u);
    }
  }
  renderMultiCanvas(e, n, o, i, r, a) {
    const s = this.getPixelRatio(), { clientWidth: l } = this.scrollContainer;
    if (l * s >= o) return void this.renderSingleCanvas(e, n, l, i, 0, r, a);
    const d = o / s;
    let c = Math.min(R0.MAX_CANVAS_WIDTH, l, d), u = {};
    if (n.barWidth || n.barGap) {
      const w = n.barWidth || 0.5, $ = w + (n.barGap || w / 2);
      c % $ != 0 && (c = Math.floor(c / $) * $);
    }
    const f = (w) => {
      if (w < 0 || w >= m || u[w]) return;
      u[w] = !0;
      const $ = w * c, y = Math.min(d - $, c);
      if (y <= 0) return;
      const M = e.map((S) => {
        const x = Math.floor($ / d * S.length), b = Math.floor(($ + y) / d * S.length);
        return S.slice(x, b);
      });
      this.renderSingleCanvas(M, n, y, i, $, r, a);
    }, m = Math.ceil(d / c), v = this.scrollContainer.scrollLeft / d, _ = Math.floor(v * m);
    f(_ - 1), f(_), f(_ + 1), m > 1 && (this.unsubscribeOnScroll = this.on("scroll", () => {
      const { scrollLeft: w } = this.scrollContainer, $ = Math.floor(w / d * m);
      Object.keys(u).length > R0.MAX_NODES && (r.innerHTML = "", a.innerHTML = "", u = {}), f($ - 1), f($), f($ + 1);
    }));
  }
  renderChannel(e, n, o, i) {
    var { overlay: r } = n, a = function(c, u) {
      var f = {};
      for (var m in c) Object.prototype.hasOwnProperty.call(c, m) && u.indexOf(m) < 0 && (f[m] = c[m]);
      if (c != null && typeof Object.getOwnPropertySymbols == "function") {
        var v = 0;
        for (m = Object.getOwnPropertySymbols(c); v < m.length; v++) u.indexOf(m[v]) < 0 && Object.prototype.propertyIsEnumerable.call(c, m[v]) && (f[m[v]] = c[m[v]]);
      }
      return f;
    }(n, ["overlay"]);
    const s = document.createElement("div"), l = this.getHeight(a.height, a.splitChannels);
    s.style.height = `${l}px`, r && i > 0 && (s.style.marginTop = `-${l}px`), this.canvasWrapper.style.minHeight = `${l}px`, this.canvasWrapper.appendChild(s);
    const d = s.cloneNode();
    this.progressWrapper.appendChild(d), this.renderMultiCanvas(e, a, o, l, s, d);
  }
  render(e) {
    return st(this, void 0, void 0, function* () {
      var n;
      this.timeouts.forEach((l) => l()), this.timeouts = [], this.canvasWrapper.innerHTML = "", this.progressWrapper.innerHTML = "", this.options.width != null && (this.scrollContainer.style.width = typeof this.options.width == "number" ? `${this.options.width}px` : this.options.width);
      const o = this.getPixelRatio(), i = this.scrollContainer.clientWidth, r = Math.ceil(e.duration * (this.options.minPxPerSec || 0));
      this.isScrollable = r > i;
      const a = this.options.fillParent && !this.isScrollable, s = (a ? i : r) * o;
      if (this.wrapper.style.width = a ? "100%" : `${r}px`, this.scrollContainer.style.overflowX = this.isScrollable ? "auto" : "hidden", this.scrollContainer.classList.toggle("noScrollbar", !!this.options.hideScrollbar), this.cursor.style.backgroundColor = `${this.options.cursorColor || this.options.progressColor}`, this.cursor.style.width = `${this.options.cursorWidth}px`, this.audioData = e, this.emit("render"), this.options.splitChannels) for (let l = 0; l < e.numberOfChannels; l++) {
        const d = Object.assign(Object.assign({}, this.options), (n = this.options.splitChannels) === null || n === void 0 ? void 0 : n[l]);
        this.renderChannel([e.getChannelData(l)], d, s, l);
      }
      else {
        const l = [e.getChannelData(0)];
        e.numberOfChannels > 1 && l.push(e.getChannelData(1)), this.renderChannel(l, this.options, s, 0);
      }
      Promise.resolve().then(() => this.emit("rendered"));
    });
  }
  reRender() {
    var e;
    if ((e = this.unsubscribeOnScroll) === null || e === void 0 || e.call(this), delete this.unsubscribeOnScroll, !this.audioData) return;
    const { scrollWidth: n } = this.scrollContainer, { right: o } = this.progressWrapper.getBoundingClientRect();
    if (this.render(this.audioData), this.isScrollable && n !== this.scrollContainer.scrollWidth) {
      const { right: i } = this.progressWrapper.getBoundingClientRect();
      let r = i - o;
      r *= 2, r = r < 0 ? Math.floor(r) : Math.ceil(r), r /= 2, this.scrollContainer.scrollLeft += r;
    }
  }
  zoom(e) {
    this.options.minPxPerSec = e, this.reRender();
  }
  scrollIntoView(e, n = !1) {
    const { scrollLeft: o, scrollWidth: i, clientWidth: r } = this.scrollContainer, a = e * i, s = o, l = o + r, d = r / 2;
    if (this.isDragging)
      a + 30 > l ? this.scrollContainer.scrollLeft += 30 : a - 30 < s && (this.scrollContainer.scrollLeft -= 30);
    else {
      (a < s || a > l) && (this.scrollContainer.scrollLeft = a - (this.options.autoCenter ? d : 0));
      const c = a - o - d;
      n && this.options.autoCenter && c > 0 && (this.scrollContainer.scrollLeft += Math.min(c, 10));
    }
    {
      const c = this.scrollContainer.scrollLeft, u = c / i, f = (c + r) / i;
      this.emit("scroll", u, f, c, c + r);
    }
  }
  renderProgress(e, n) {
    if (isNaN(e)) return;
    const o = 100 * e;
    this.canvasWrapper.style.clipPath = `polygon(${o}% 0, 100% 0, 100% 100%, ${o}% 100%)`, this.progressWrapper.style.width = `${o}%`, this.cursor.style.left = `${o}%`, this.cursor.style.transform = `translateX(-${Math.round(o) === 100 ? this.options.cursorWidth : 0}px)`, this.isScrollable && this.options.autoScroll && this.scrollIntoView(e, n);
  }
  exportImage(e, n, o) {
    return st(this, void 0, void 0, function* () {
      const i = this.canvasWrapper.querySelectorAll("canvas");
      if (!i.length) throw new Error("No waveform data");
      if (o === "dataURL") {
        const r = Array.from(i).map((a) => a.toDataURL(e, n));
        return Promise.resolve(r);
      }
      return Promise.all(Array.from(i).map((r) => new Promise((a, s) => {
        r.toBlob((l) => {
          l ? a(l) : s(new Error("Could not export image"));
        }, e, n);
      })));
    });
  }
};
N0.MAX_CANVAS_WIDTH = 8e3, N0.MAX_NODES = 10;
let RV = class extends ni {
  constructor() {
    super(...arguments), this.unsubscribe = () => {
    };
  }
  start() {
    this.unsubscribe = this.on("tick", () => {
      requestAnimationFrame(() => {
        this.emit("tick");
      });
    }), this.emit("tick");
  }
  stop() {
    this.unsubscribe();
  }
  destroy() {
    this.unsubscribe();
  }
}, ts = class extends ni {
  constructor(e = new AudioContext()) {
    super(), this.bufferNode = null, this.playStartTime = 0, this.playedDuration = 0, this._muted = !1, this._playbackRate = 1, this._duration = void 0, this.buffer = null, this.currentSrc = "", this.paused = !0, this.crossOrigin = null, this.seeking = !1, this.autoplay = !1, this.addEventListener = this.on, this.removeEventListener = this.un, this.audioContext = e, this.gainNode = this.audioContext.createGain(), this.gainNode.connect(this.audioContext.destination);
  }
  load() {
    return st(this, void 0, void 0, function* () {
    });
  }
  get src() {
    return this.currentSrc;
  }
  set src(e) {
    if (this.currentSrc = e, this._duration = void 0, !e) return this.buffer = null, void this.emit("emptied");
    fetch(e).then((n) => {
      if (n.status >= 400) throw new Error(`Failed to fetch ${e}: ${n.status} (${n.statusText})`);
      return n.arrayBuffer();
    }).then((n) => this.currentSrc !== e ? null : this.audioContext.decodeAudioData(n)).then((n) => {
      this.currentSrc === e && (this.buffer = n, this.emit("loadedmetadata"), this.emit("canplay"), this.autoplay && this.play());
    });
  }
  _play() {
    var e;
    if (!this.paused) return;
    this.paused = !1, (e = this.bufferNode) === null || e === void 0 || e.disconnect(), this.bufferNode = this.audioContext.createBufferSource(), this.buffer && (this.bufferNode.buffer = this.buffer), this.bufferNode.playbackRate.value = this._playbackRate, this.bufferNode.connect(this.gainNode);
    let n = this.playedDuration * this._playbackRate;
    n >= this.duration && (n = 0, this.playedDuration = 0), this.bufferNode.start(this.audioContext.currentTime, n), this.playStartTime = this.audioContext.currentTime, this.bufferNode.onended = () => {
      this.currentTime >= this.duration && (this.pause(), this.emit("ended"));
    };
  }
  _pause() {
    var e;
    this.paused = !0, (e = this.bufferNode) === null || e === void 0 || e.stop(), this.playedDuration += this.audioContext.currentTime - this.playStartTime;
  }
  play() {
    return st(this, void 0, void 0, function* () {
      this.paused && (this._play(), this.emit("play"));
    });
  }
  pause() {
    this.paused || (this._pause(), this.emit("pause"));
  }
  stopAt(e) {
    var n, o;
    const i = e - this.currentTime;
    (n = this.bufferNode) === null || n === void 0 || n.stop(this.audioContext.currentTime + i), (o = this.bufferNode) === null || o === void 0 || o.addEventListener("ended", () => {
      this.bufferNode = null, this.pause();
    }, { once: !0 });
  }
  setSinkId(e) {
    return st(this, void 0, void 0, function* () {
      return this.audioContext.setSinkId(e);
    });
  }
  get playbackRate() {
    return this._playbackRate;
  }
  set playbackRate(e) {
    this._playbackRate = e, this.bufferNode && (this.bufferNode.playbackRate.value = e);
  }
  get currentTime() {
    return (this.paused ? this.playedDuration : this.playedDuration + (this.audioContext.currentTime - this.playStartTime)) * this._playbackRate;
  }
  set currentTime(e) {
    const n = !this.paused;
    n && this._pause(), this.playedDuration = e / this._playbackRate, n && this._play(), this.emit("seeking"), this.emit("timeupdate");
  }
  get duration() {
    var e, n;
    return (e = this._duration) !== null && e !== void 0 ? e : ((n = this.buffer) === null || n === void 0 ? void 0 : n.duration) || 0;
  }
  set duration(e) {
    this._duration = e;
  }
  get volume() {
    return this.gainNode.gain.value;
  }
  set volume(e) {
    this.gainNode.gain.value = e, this.emit("volumechange");
  }
  get muted() {
    return this._muted;
  }
  set muted(e) {
    this._muted !== e && (this._muted = e, this._muted ? this.gainNode.disconnect() : this.gainNode.connect(this.audioContext.destination));
  }
  canPlayType(e) {
    return /^(audio|video)\//.test(e);
  }
  getGainNode() {
    return this.gainNode;
  }
  getChannelData() {
    const e = [];
    if (!this.buffer) return e;
    const n = this.buffer.numberOfChannels;
    for (let o = 0; o < n; o++) e.push(this.buffer.getChannelData(o));
    return e;
  }
};
const ZV = { waveColor: "#999", progressColor: "#555", cursorWidth: 1, minPxPerSec: 0, fillParent: !0, interact: !0, dragToSeek: !1, autoScroll: !0, autoCenter: !0, sampleRate: 8e3 };
let Z0 = class Yd extends NV {
  static create(e) {
    return new Yd(e);
  }
  constructor(e) {
    const n = e.media || (e.backend === "WebAudio" ? new ts() : void 0);
    super({ media: n, mediaControls: e.mediaControls, autoplay: e.autoplay, playbackRate: e.audioRate }), this.plugins = [], this.decodedData = null, this.subscriptions = [], this.mediaSubscriptions = [], this.abortController = null, this.options = Object.assign({}, ZV, e), this.timer = new RV();
    const o = n ? void 0 : this.getMediaElement();
    this.renderer = new N0(this.options, o), this.initPlayerEvents(), this.initRendererEvents(), this.initTimerEvents(), this.initPlugins();
    const i = this.options.url || this.getSrc() || "";
    Promise.resolve().then(() => {
      this.emit("init");
      const { peaks: r, duration: a } = this.options;
      (i || r && a) && this.load(i, r, a).catch(() => null);
    });
  }
  updateProgress(e = this.getCurrentTime()) {
    return this.renderer.renderProgress(e / this.getDuration(), this.isPlaying()), e;
  }
  initTimerEvents() {
    this.subscriptions.push(this.timer.on("tick", () => {
      if (!this.isSeeking()) {
        const e = this.updateProgress();
        this.emit("timeupdate", e), this.emit("audioprocess", e);
      }
    }));
  }
  initPlayerEvents() {
    this.isPlaying() && (this.emit("play"), this.timer.start()), this.mediaSubscriptions.push(this.onMediaEvent("timeupdate", () => {
      const e = this.updateProgress();
      this.emit("timeupdate", e);
    }), this.onMediaEvent("play", () => {
      this.emit("play"), this.timer.start();
    }), this.onMediaEvent("pause", () => {
      this.emit("pause"), this.timer.stop();
    }), this.onMediaEvent("emptied", () => {
      this.timer.stop();
    }), this.onMediaEvent("ended", () => {
      this.emit("finish");
    }), this.onMediaEvent("seeking", () => {
      this.emit("seeking", this.getCurrentTime());
    }), this.onMediaEvent("error", (e) => {
      this.emit("error", e.error);
    }));
  }
  initRendererEvents() {
    this.subscriptions.push(this.renderer.on("click", (e, n) => {
      this.options.interact && (this.seekTo(e), this.emit("interaction", e * this.getDuration()), this.emit("click", e, n));
    }), this.renderer.on("dblclick", (e, n) => {
      this.emit("dblclick", e, n);
    }), this.renderer.on("scroll", (e, n, o, i) => {
      const r = this.getDuration();
      this.emit("scroll", e * r, n * r, o, i);
    }), this.renderer.on("render", () => {
      this.emit("redraw");
    }), this.renderer.on("rendered", () => {
      this.emit("redrawcomplete");
    }), this.renderer.on("dragstart", (e) => {
      this.emit("dragstart", e);
    }), this.renderer.on("dragend", (e) => {
      this.emit("dragend", e);
    }));
    {
      let e;
      this.subscriptions.push(this.renderer.on("drag", (n) => {
        if (!this.options.interact) return;
        let o;
        this.renderer.renderProgress(n), clearTimeout(e), this.isPlaying() ? o = 0 : this.options.dragToSeek === !0 ? o = 200 : typeof this.options.dragToSeek == "object" && this.options.dragToSeek !== void 0 && (o = this.options.dragToSeek.debounceTime), e = setTimeout(() => {
          this.seekTo(n);
        }, o), this.emit("interaction", n * this.getDuration()), this.emit("drag", n);
      }));
    }
  }
  initPlugins() {
    var e;
    !((e = this.options.plugins) === null || e === void 0) && e.length && this.options.plugins.forEach((n) => {
      this.registerPlugin(n);
    });
  }
  unsubscribePlayerEvents() {
    this.mediaSubscriptions.forEach((e) => e()), this.mediaSubscriptions = [];
  }
  setOptions(e) {
    this.options = Object.assign({}, this.options, e), this.renderer.setOptions(this.options), e.audioRate && this.setPlaybackRate(e.audioRate), e.mediaControls != null && (this.getMediaElement().controls = e.mediaControls);
  }
  registerPlugin(e) {
    return e._init(this), this.plugins.push(e), this.subscriptions.push(e.once("destroy", () => {
      this.plugins = this.plugins.filter((n) => n !== e);
    })), e;
  }
  getWrapper() {
    return this.renderer.getWrapper();
  }
  getWidth() {
    return this.renderer.getWidth();
  }
  getScroll() {
    return this.renderer.getScroll();
  }
  setScroll(e) {
    return this.renderer.setScroll(e);
  }
  setScrollTime(e) {
    const n = e / this.getDuration();
    this.renderer.setScrollPercentage(n);
  }
  getActivePlugins() {
    return this.plugins;
  }
  loadAudio(e, n, o, i) {
    return st(this, void 0, void 0, function* () {
      var r;
      if (this.emit("load", e), !this.options.media && this.isPlaying() && this.pause(), this.decodedData = null, !n && !o) {
        const s = this.options.fetchParams || {};
        window.AbortController && !s.signal && (this.abortController = new AbortController(), s.signal = (r = this.abortController) === null || r === void 0 ? void 0 : r.signal);
        const l = (d) => this.emit("loading", d);
        n = yield DV.fetchBlob(e, l, s);
      }
      this.setSrc(e, n);
      const a = yield new Promise((s) => {
        const l = i || this.getDuration();
        l ? s(l) : this.mediaSubscriptions.push(this.onMediaEvent("loadedmetadata", () => s(this.getDuration()), { once: !0 }));
      });
      if (!e && !n) {
        const s = this.getMediaElement();
        s instanceof ts && (s.duration = a);
      }
      if (o) this.decodedData = Qa.createBuffer(o, a || 0);
      else if (n) {
        const s = yield n.arrayBuffer();
        this.decodedData = yield Qa.decode(s, this.options.sampleRate);
      }
      this.decodedData && (this.emit("decode", this.getDuration()), this.renderer.render(this.decodedData)), this.emit("ready", this.getDuration());
    });
  }
  load(e, n, o) {
    return st(this, void 0, void 0, function* () {
      try {
        return yield this.loadAudio(e, void 0, n, o);
      } catch (i) {
        throw this.emit("error", i), i;
      }
    });
  }
  loadBlob(e, n, o) {
    return st(this, void 0, void 0, function* () {
      try {
        return yield this.loadAudio("", e, n, o);
      } catch (i) {
        throw this.emit("error", i), i;
      }
    });
  }
  zoom(e) {
    if (!this.decodedData) throw new Error("No audio loaded");
    this.renderer.zoom(e), this.emit("zoom", e);
  }
  getDecodedData() {
    return this.decodedData;
  }
  exportPeaks({ channels: e = 2, maxLength: n = 8e3, precision: o = 1e4 } = {}) {
    if (!this.decodedData) throw new Error("The audio has not been decoded yet");
    const i = Math.min(e, this.decodedData.numberOfChannels), r = [];
    for (let a = 0; a < i; a++) {
      const s = this.decodedData.getChannelData(a), l = [], d = s.length / n;
      for (let c = 0; c < n; c++) {
        const u = s.slice(Math.floor(c * d), Math.ceil((c + 1) * d));
        let f = 0;
        for (let m = 0; m < u.length; m++) {
          const v = u[m];
          Math.abs(v) > Math.abs(f) && (f = v);
        }
        l.push(Math.round(f * o) / o);
      }
      r.push(l);
    }
    return r;
  }
  getDuration() {
    let e = super.getDuration() || 0;
    return e !== 0 && e !== 1 / 0 || !this.decodedData || (e = this.decodedData.duration), e;
  }
  toggleInteraction(e) {
    this.options.interact = e;
  }
  setTime(e) {
    super.setTime(e), this.updateProgress(e), this.emit("timeupdate", e);
  }
  seekTo(e) {
    const n = this.getDuration() * e;
    this.setTime(n);
  }
  playPause() {
    return st(this, void 0, void 0, function* () {
      return this.isPlaying() ? this.pause() : this.play();
    });
  }
  stop() {
    this.pause(), this.setTime(0);
  }
  skip(e) {
    this.setTime(this.getCurrentTime() + e);
  }
  empty() {
    this.load("", [[0]], 1e-3);
  }
  setMediaElement(e) {
    this.unsubscribePlayerEvents(), super.setMediaElement(e), this.initPlayerEvents();
  }
  exportImage() {
    return st(this, arguments, void 0, function* (e = "image/png", n = 1, o = "dataURL") {
      return this.renderer.exportImage(e, n, o);
    });
  }
  destroy() {
    var e;
    this.emit("destroy"), (e = this.abortController) === null || e === void 0 || e.abort(), this.plugins.forEach((n) => n.destroy()), this.subscriptions.forEach((n) => n()), this.unsubscribePlayerEvents(), this.timer.destroy(), this.renderer.destroy(), super.destroy();
  }
};
Z0.BasePlugin = class extends ni {
  constructor(t) {
    super(), this.subscriptions = [], this.options = t;
  }
  onInit() {
  }
  _init(t) {
    this.wavesurfer = t, this.onInit();
  }
  destroy() {
    this.emit("destroy"), this.subscriptions.forEach((t) => t());
  }
}, Z0.dom = LV;
const BV = { class: "audio-container" }, VV = { class: "wave-container" }, FV = { class: "audio-wave-container" }, HV = {
  key: 0,
  class: "wave-loader"
}, UV = { class: "audio-time" }, zV = /* @__PURE__ */ oe({
  name: "PAudioPlayer",
  __name: "PAudioPlayer",
  props: {
    src: {},
    isTimeBottom: { type: Boolean },
    isAudioFromServer: { type: Boolean }
  },
  emits: ["endPlaying", "startPlaying"],
  setup(t, { expose: e }) {
    const n = t, o = U(""), i = U(!1), r = U(!1), a = U(!0), s = U(0), l = U(null), d = U(""), c = {
      height: 24,
      barRadius: 2,
      barWidth: 2,
      barGap: 2,
      progressColor: getComputedStyle(document.documentElement).getPropertyValue("--color-primary"),
      waveColor: "#91a0ae",
      cursorColor: "transparent",
      fillParent: !0,
      hideScrollbar: !0
    }, u = (b) => {
      const C = Math.round(b), E = Math.floor(C / 60), A = C % 60, T = String(E).padStart(2, "0"), k = String(A).padStart(2, "0");
      return `${T}:${k}`;
    };
    et(async () => {
      n.isAudioFromServer && (c.fetchParams = {
        credentials: "include"
      });
      const b = Object.assign({ container: d.value }, c);
      l.value = Z0.create(b), l.value.load(n.src), l.value && (l.value.on("ready", () => {
        var C;
        a.value = !1, (C = l.value) != null && C.getDuration() && (s.value = l.value.getDuration());
      }), l.value.on("audioprocess", function() {
        s.value = l.value.getDuration() - l.value.getCurrentTime();
      }), l.value.on("finish", function() {
        i.value = !1, o.value = u(0), l.value.stop(), l.value.seekTo(0), s.value = l.value.getDuration();
      }));
    }), Zr(() => {
      l.value.destroy();
    });
    const f = z(() => i.value ? Yr : Xr), m = () => {
      r.value = !1;
    }, v = (b) => {
      r.value = !0, typeof TouchEvent < "u" && b instanceof TouchEvent && b.cancelable && b.preventDefault();
    }, _ = (b) => {
      r.value && $(
        b,
        "move"
        /* move */
      );
    }, w = (b) => $(
      b,
      "click"
      /* click */
    ), $ = (b, C) => {
      const E = d.value;
      if (E && E instanceof HTMLElement) {
        const A = E.getBoundingClientRect();
        let T;
        if (C === "click")
          T = b instanceof MouseEvent ? b.clientX : b.touches[0].clientX;
        else if (typeof MouseEvent < "u" && b instanceof MouseEvent)
          T = b.clientX;
        else if (typeof TouchEvent < "u" && b instanceof TouchEvent && b.touches.length)
          T = b.touches[0].clientX;
        else if (typeof PointerEvent < "u" && b instanceof PointerEvent)
          T = b.clientX;
        else
          return;
        const k = T - A.left, L = A.width;
        let V = k / L;
        if (V = Math.min(1, Math.max(0, V)), l.value) {
          l.value.seekTo(V);
          const O = l.value.getDuration() * V;
          o.value = u(O), s.value = l.value.getDuration() - l.value.getCurrentTime();
        }
      }
    }, y = () => {
      var b;
      (b = l.value) == null || b.stop(), i.value = !1;
    }, M = () => {
      var b;
      (b = l.value) == null || b.pause(), i.value = !1;
    }, S = () => {
      var b;
      (b = l.value) == null || b.play(), i.value = !0;
    }, x = () => {
      if (!a.value) {
        if (!i.value) {
          S();
          return;
        }
        M();
      }
    };
    return e({
      stopAudio: y,
      pauseAudio: M,
      playAudio: S
    }), (b, C) => {
      const E = _t;
      return p(), g("div", {
        class: ee(["p-audio-player", { "time-bottom": b.isTimeBottom }])
      }, [
        h("div", BV, [
          h("div", VV, [
            h("div", {
              class: "toggle",
              onClick: x
            }, [
              (p(), J(Ce(f.value)))
            ]),
            h("div", FV, [
              a.value ? (p(), g("div", HV, [
                q(E, {
                  absolute: "",
                  size: "small"
                })
              ])) : X("", !0),
              h("div", {
                id: "audio-player",
                ref_key: "wavesurferMain",
                ref: d,
                class: "audio-wave",
                onMousedown: v,
                onMousemove: _,
                onMouseup: m,
                onMouseleave: m,
                onTouchstart: v,
                onTouchmove: _,
                onTouchend: m,
                onClick: w
              }, null, 544)
            ])
          ]),
          h("div", UV, ne(u(s.value)), 1)
        ]),
        Y(b.$slots, "icon", {}, void 0, !0)
      ], 2);
    };
  }
}), WV = /* @__PURE__ */ ae(zV, [["__scopeId", "data-v-685a0190"]]), jV = ["src"], GV = {
  key: 3,
  class: "overlay"
};
var B0 = /* @__PURE__ */ ((t) => (t.pink = "pink", t.blue = "blue", t.purple = "purple", t.orange = "orange", t.green = "green", t))(B0 || {});
const YV = /* @__PURE__ */ oe({
  name: "PAvatar",
  __name: "PAvatar",
  props: {
    name: {},
    src: {},
    size: { default: "medium" },
    randomColor: { type: Boolean },
    icon: { default: Gr },
    overlay: { type: Boolean }
  },
  setup(t) {
    Nn((r) => ({
      "89bffc1e": r.size
    }));
    const e = t, n = z(() => e.size === "x-small" ? "16px" : "20px"), o = z(() => {
      var a;
      const r = (a = e == null ? void 0 : e.name) == null ? void 0 : a.trim().split(/\s+/).slice(0, 2).map((s) => s[0]).join("").toUpperCase();
      return r == null ? void 0 : r.slice(-r.length - 2);
    }), i = U(
      "blue"
      /* blue */
    );
    return et(() => {
      if (e.randomColor) {
        const r = Object.keys(B0).length;
        i.value = Object.values(B0)[Math.floor(Math.random() * r)];
      }
    }), (r, a) => (p(), g("div", {
      class: ee(`p-avatar color-${i.value} size-${r.size}`)
    }, [
      r.src ? (p(), g("img", {
        key: 0,
        src: r.src
      }, null, 8, jV)) : r.name ? (p(), g("div", {
        key: 1,
        class: ee(`initials size-${r.size}`)
      }, ne(o.value), 3)) : !r.name && !r.src ? (p(), J(Ce(r.icon), {
        key: 2,
        width: n.value,
        height: n.value
      }, null, 8, ["width", "height"])) : X("", !0),
      r.overlay ? (p(), g("div", GV, [
        Y(r.$slots, "overlay", {
          width: n.value,
          height: n.value
        }, void 0, !0)
      ])) : X("", !0)
    ], 2));
  }
}), Xi = /* @__PURE__ */ ae(YV, [["__scopeId", "data-v-2aa9792c"]]), XV = { class: "p-counter" }, KV = /* @__PURE__ */ oe({
  name: "PCounter",
  __name: "index",
  props: {
    value: {},
    color: { default: "primary" },
    size: { default: "small" }
  },
  setup(t) {
    const e = t, n = cd(), o = z(() => !!n.default), i = z(() => {
      const { value: r } = e;
      return String(+r > 99 ? "+99" : r);
    });
    return (r, a) => (p(), g("div", XV, [
      Y(r.$slots, "default", {}, void 0, !0),
      h("div", {
        class: ee(["counter", `color-${r.color}`, `size-${r.size}`, { floating: o.value }])
      }, ne(i.value), 3)
    ]));
  }
}), qV = /* @__PURE__ */ ae(KV, [["__scopeId", "data-v-d0560a6a"]]), JV = /* @__PURE__ */ oe({
  name: "PBottomBar",
  __name: "PBottomBar",
  props: {
    borded: { type: Boolean },
    elevated: { type: Boolean },
    noPadding: { type: Boolean }
  },
  setup(t) {
    return (e, n) => (p(), g("div", {
      class: ee(["p-bottom-bar", { borded: e.borded, elevated: e.elevated, "no-padding": e.noPadding }])
    }, [
      Y(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), QV = /* @__PURE__ */ ae(JV, [["__scopeId", "data-v-9df1fdf3"]]), eF = { class: "p-bottom-sheet" }, tF = ["data-ios-app"], nF = {
  key: 0,
  class: "p-bottom-sheet-touch-zone"
}, oF = { key: 0 }, iF = /* @__PURE__ */ oe({
  name: "PBottomSheet",
  __name: "PBottomSheet",
  props: {
    modelValue: { type: Boolean },
    maxHeight: {},
    loading: { type: Boolean },
    fullscreen: { type: Boolean },
    noPadding: { type: Boolean },
    closeOnSelfClick: { type: Boolean },
    closeOnClickOutside: { type: Boolean, default: !0 },
    swipeAvailable: { type: Boolean },
    autoHeight: { type: Boolean },
    to: { default: ".p-teleport-container" }
  },
  emits: ["update:modelValue", "click:outside", "swipe:start", "swipe:end"],
  setup(t, { emit: e }) {
    const n = t, o = e, { mobile: i, tablet: r } = nt(), { isIosApp: a } = p0(), s = me(n, "modelValue", o), l = U(), d = U(), c = U({ transform: "", transition: "" }), u = U(!1), f = z(() => n.fullscreen ? { maxHeight: "100%" } : {
      height: n.autoHeight ? "auto" : "",
      maxHeight: n.maxHeight ? `${n.maxHeight}px` : ""
    }), m = z(() => n.swipeAvailable && (r || i)), v = z(() => s.value && !n.fullscreen), _ = () => {
      if (!n.closeOnClickOutside) {
        o("click:outside");
        return;
      }
      s.value = !1;
    }, w = () => new Promise((x) => window.requestAnimationFrame(x)), $ = async () => {
      n.closeOnSelfClick && (await w(), s.value = !1);
    }, y = z(() => m.value ? {
      threshold: 0,
      onSwipeStart(x) {
        o("swipe:start", x);
      },
      onSwipe() {
        M.value === "down" && (c.value.transform = `translateY(${-S.value}px)`);
      },
      onSwipeEnd(x) {
        var b;
        M.value === "down" && (c.value.transition = "all 0.2s ease-in-out", c.value.transform = `translateY(${(b = l.value) == null ? void 0 : b.offsetHeight}px)`, setTimeout(() => {
          c.value.transform = "", c.value.transition = "", s.value = !1, o("swipe:end", x);
        }, 200));
      }
    } : {}), { direction: M, lengthY: S } = Wr(d, y.value);
    return et(() => u.value = !0), (x, b) => {
      const C = _t;
      return u.value ? (p(), J(c1, {
        key: 0,
        to: x.to
      }, [
        h("div", eF, [
          q(Xe, {
            name: "fade",
            appear: ""
          }, {
            default: G(() => [
              v.value ? (p(), g("div", {
                key: 0,
                class: "p-bottom-sheet-overlay",
                onClick: _
              })) : X("", !0)
            ]),
            _: 1
          }),
          q(Xe, {
            name: "slide-up",
            appear: ""
          }, {
            default: G(() => [
              B(s) ? (p(), g("div", {
                key: 0,
                ref_key: "bottomSheet",
                ref: l,
                class: ee(["p-bottom-sheet-wrapper", { fullscreen: x.fullscreen, "auto-height": x.autoHeight }]),
                style: en({ ...c.value, ...f.value }),
                "data-ios-app": B(a),
                onClick: $
              }, [
                h("div", {
                  ref_key: "bottomSheetHeader",
                  ref: d,
                  class: "p-bottom-sheet-header"
                }, [
                  m.value ? (p(), g("div", nF)) : X("", !0),
                  Y(x.$slots, "header", {}, void 0, !0)
                ], 512),
                h("div", {
                  class: ee(["p-bottom-sheet-content", { mobile: B(i), "no-padding": x.noPadding }])
                }, [
                  x.loading ? (p(), J(C, {
                    key: 0,
                    absolute: ""
                  })) : Y(x.$slots, "default", { key: 1 }, void 0, !0)
                ], 2),
                x.$slots.footer ? (p(), g("div", oF, [
                  Y(x.$slots, "footer", {}, void 0, !0)
                ])) : X("", !0)
              ], 14, tF)) : X("", !0)
            ]),
            _: 3
          })
        ])
      ], 8, ["to"])) : X("", !0);
    };
  }
}), Ki = /* @__PURE__ */ ae(iF, [["__scopeId", "data-v-20f76963"]]), rF = ["disabled"], aF = { class: "icon" }, sF = {
  key: 0,
  class: "text"
}, lF = /* @__PURE__ */ oe({
  name: "PButtonFloating",
  __name: "PButtonFloating",
  props: {
    size: { default: "small" },
    disabled: { type: Boolean },
    placement: { default: "right" },
    position: { default: "absolute" },
    color: { default: "secondary-white" }
  },
  setup(t) {
    Nn((n) => ({
      "2d5ef14a": e.position
    }));
    const e = t;
    return (n, o) => (p(), g("button", {
      class: ee(["button-floating", `color-${n.color}`, n.size, n.placement]),
      disabled: n.disabled,
      onClick: o[0] || (o[0] = (i) => i.currentTarget.blur())
    }, [
      h("div", aF, [
        Y(n.$slots, "default", {}, void 0, !0)
      ]),
      n.$slots.text ? (p(), g("div", sF, [
        Y(n.$slots, "text", {}, void 0, !0)
      ])) : X("", !0)
    ], 10, rF));
  }
}), Xd = /* @__PURE__ */ ae(lF, [["__scopeId", "data-v-e42b4f73"]]);
function bn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Kd(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var Vt = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, n1 = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, qr, dt, Ee, Kt = 1e8, Se = 1 / Kt, V0 = Math.PI * 2, dF = V0 / 4, cF = 0, qd = Math.sqrt, uF = Math.cos, hF = Math.sin, tt = function(e) {
  return typeof e == "string";
}, Ne = function(e) {
  return typeof e == "function";
}, On = function(e) {
  return typeof e == "number";
}, Jr = function(e) {
  return typeof e > "u";
}, gn = function(e) {
  return typeof e == "object";
}, It = function(e) {
  return e !== !1;
}, Qr = function() {
  return typeof window < "u";
}, li = function(e) {
  return Ne(e) || tt(e);
}, Jd = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, ct = Array.isArray, F0 = /(?:-?\.?\d|\.)+/gi, Qd = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, Uo = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, v0 = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, ec = /[+-]=-?[.\d]+/, tc = /[^,'"\[\]\s]+/gi, fF = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, Te, dn, H0, ea, Ht = {}, xi = {}, nc, oc = function(e) {
  return (xi = Co(e, Ht)) && Pt;
}, ta = function(e, n) {
  return console.warn("Invalid property", e, "set to", n, "Missing plugin? gsap.registerPlugin()");
}, N1 = function(e, n) {
  return !n && console.warn(e);
}, ic = function(e, n) {
  return e && (Ht[e] = n) && xi && (xi[e] = n) || Ht;
}, R1 = function() {
  return 0;
}, mF = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, _i = {
  suppressEvents: !0,
  kill: !1
}, pF = {
  suppressEvents: !0
}, na = {}, Yn = [], U0 = {}, rc, Lt = {}, g0 = {}, ns = 30, vi = [], oa = "", ia = function(e) {
  var n = e[0], o, i;
  if (gn(n) || Ne(n) || (e = [e]), !(o = (n._gsap || {}).harness)) {
    for (i = vi.length; i-- && !vi[i].targetTest(n); )
      ;
    o = vi[i];
  }
  for (i = e.length; i--; )
    e[i] && (e[i]._gsap || (e[i]._gsap = new kc(e[i], o))) || e.splice(i, 1);
  return e;
}, go = function(e) {
  return e._gsap || ia(qt(e))[0]._gsap;
}, ac = function(e, n, o) {
  return (o = e[n]) && Ne(o) ? e[n]() : Jr(o) && e.getAttribute && e.getAttribute(n) || o;
}, At = function(e, n) {
  return (e = e.split(",")).forEach(n) || e;
}, Fe = function(e) {
  return Math.round(e * 1e5) / 1e5 || 0;
}, Qe = function(e) {
  return Math.round(e * 1e7) / 1e7 || 0;
}, Yo = function(e, n) {
  var o = n.charAt(0), i = parseFloat(n.substr(2));
  return e = parseFloat(e), o === "+" ? e + i : o === "-" ? e - i : o === "*" ? e * i : e / i;
}, _F = function(e, n) {
  for (var o = n.length, i = 0; e.indexOf(n[i]) < 0 && ++i < o; )
    ;
  return i < o;
}, Si = function() {
  var e = Yn.length, n = Yn.slice(0), o, i;
  for (U0 = {}, Yn.length = 0, o = 0; o < e; o++)
    i = n[o], i && i._lazy && (i.render(i._lazy[0], i._lazy[1], !0)._lazy = 0);
}, sc = function(e, n, o, i) {
  Yn.length && !dt && Si(), e.render(n, o, dt && n < 0 && (e._initted || e._startAt)), Yn.length && !dt && Si();
}, lc = function(e) {
  var n = parseFloat(e);
  return (n || n === 0) && (e + "").match(tc).length < 2 ? n : tt(e) ? e.trim() : e;
}, dc = function(e) {
  return e;
}, Qt = function(e, n) {
  for (var o in n)
    o in e || (e[o] = n[o]);
  return e;
}, vF = function(e) {
  return function(n, o) {
    for (var i in o)
      i in n || i === "duration" && e || i === "ease" || (n[i] = o[i]);
  };
}, Co = function(e, n) {
  for (var o in n)
    e[o] = n[o];
  return e;
}, os = function t(e, n) {
  for (var o in n)
    o !== "__proto__" && o !== "constructor" && o !== "prototype" && (e[o] = gn(n[o]) ? t(e[o] || (e[o] = {}), n[o]) : n[o]);
  return e;
}, Ii = function(e, n) {
  var o = {}, i;
  for (i in e)
    i in n || (o[i] = e[i]);
  return o;
}, P1 = function(e) {
  var n = e.parent || Te, o = e.keyframes ? vF(ct(e.keyframes)) : Qt;
  if (It(e.inherit))
    for (; n; )
      o(e, n.vars.defaults), n = n.parent || n._dp;
  return e;
}, gF = function(e, n) {
  for (var o = e.length, i = o === n.length; i && o-- && e[o] === n[o]; )
    ;
  return o < 0;
}, cc = function(e, n, o, i, r) {
  var a = e[i], s;
  if (r)
    for (s = n[r]; a && a[r] > s; )
      a = a._prev;
  return a ? (n._next = a._next, a._next = n) : (n._next = e[o], e[o] = n), n._next ? n._next._prev = n : e[i] = n, n._prev = a, n.parent = n._dp = e, n;
}, qi = function(e, n, o, i) {
  o === void 0 && (o = "_first"), i === void 0 && (i = "_last");
  var r = n._prev, a = n._next;
  r ? r._next = a : e[o] === n && (e[o] = a), a ? a._prev = r : e[i] === n && (e[i] = r), n._next = n._prev = n.parent = null;
}, Kn = function(e, n) {
  e.parent && (!n || e.parent.autoRemoveChildren) && e.parent.remove && e.parent.remove(e), e._act = 0;
}, $o = function(e, n) {
  if (e && (!n || n._end > e._dur || n._start < 0))
    for (var o = e; o; )
      o._dirty = 1, o = o.parent;
  return e;
}, $F = function(e) {
  for (var n = e.parent; n && n.parent; )
    n._dirty = 1, n.totalDuration(), n = n.parent;
  return e;
}, z0 = function(e, n, o, i) {
  return e._startAt && (dt ? e._startAt.revert(_i) : e.vars.immediateRender && !e.vars.autoRevert || e._startAt.render(n, !0, i));
}, wF = function t(e) {
  return !e || e._ts && t(e.parent);
}, is = function(e) {
  return e._repeat ? o1(e._tTime, e = e.duration() + e._rDelay) * e : 0;
}, o1 = function(e, n) {
  var o = Math.floor(e /= n);
  return e && o === e ? o - 1 : o;
}, Ai = function(e, n) {
  return (e - n._start) * n._ts + (n._ts >= 0 ? 0 : n._dirty ? n.totalDuration() : n._tDur);
}, Ji = function(e) {
  return e._end = Qe(e._start + (e._tDur / Math.abs(e._ts || e._rts || Se) || 0));
}, Qi = function(e, n) {
  var o = e._dp;
  return o && o.smoothChildTiming && e._ts && (e._start = Qe(o._time - (e._ts > 0 ? n / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - n) / -e._ts)), Ji(e), o._dirty || $o(o, e)), e;
}, uc = function(e, n) {
  var o;
  if ((n._time || !n._dur && n._initted || n._start < e._time && (n._dur || !n.add)) && (o = Ai(e.rawTime(), n), (!n._dur || oi(0, n.totalDuration(), o) - n._tTime > Se) && n.render(o, !0)), $o(e, n)._dp && e._initted && e._time >= e._dur && e._ts) {
    if (e._dur < e.duration())
      for (o = e; o._dp; )
        o.rawTime() >= 0 && o.totalTime(o._tTime), o = o._dp;
    e._zTime = -Se;
  }
}, un = function(e, n, o, i) {
  return n.parent && Kn(n), n._start = Qe((On(o) ? o : o || e !== Te ? Gt(e, o, n) : e._time) + n._delay), n._end = Qe(n._start + (n.totalDuration() / Math.abs(n.timeScale()) || 0)), cc(e, n, "_first", "_last", e._sort ? "_start" : 0), W0(n) || (e._recent = n), i || uc(e, n), e._ts < 0 && Qi(e, e._tTime), e;
}, hc = function(e, n) {
  return (Ht.ScrollTrigger || ta("scrollTrigger", n)) && Ht.ScrollTrigger.create(n, e);
}, fc = function(e, n, o, i, r) {
  if (aa(e, n, r), !e._initted)
    return 1;
  if (!o && e._pt && !dt && (e._dur && e.vars.lazy !== !1 || !e._dur && e.vars.lazy) && rc !== Nt.frame)
    return Yn.push(e), e._lazy = [r, i], 1;
}, yF = function t(e) {
  var n = e.parent;
  return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || t(n));
}, W0 = function(e) {
  var n = e.data;
  return n === "isFromStart" || n === "isStart";
}, MF = function(e, n, o, i) {
  var r = e.ratio, a = n < 0 || !n && (!e._start && yF(e) && !(!e._initted && W0(e)) || (e._ts < 0 || e._dp._ts < 0) && !W0(e)) ? 0 : 1, s = e._rDelay, l = 0, d, c, u;
  if (s && e._repeat && (l = oi(0, e._tDur, n), c = o1(l, s), e._yoyo && c & 1 && (a = 1 - a), c !== o1(e._tTime, s) && (r = 1 - a, e.vars.repeatRefresh && e._initted && e.invalidate())), a !== r || dt || i || e._zTime === Se || !n && e._zTime) {
    if (!e._initted && fc(e, n, i, o, l))
      return;
    for (u = e._zTime, e._zTime = n || (o ? Se : 0), o || (o = n && !u), e.ratio = a, e._from && (a = 1 - a), e._time = 0, e._tTime = l, d = e._pt; d; )
      d.r(a, d.d), d = d._next;
    n < 0 && z0(e, n, o, !0), e._onUpdate && !o && Zt(e, "onUpdate"), l && e._repeat && !o && e.parent && Zt(e, "onRepeat"), (n >= e._tDur || n < 0) && e.ratio === a && (a && Kn(e, 1), !o && !dt && (Zt(e, a ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()));
  } else e._zTime || (e._zTime = n);
}, CF = function(e, n, o) {
  var i;
  if (o > n)
    for (i = e._first; i && i._start <= o; ) {
      if (i.data === "isPause" && i._start > n)
        return i;
      i = i._next;
    }
  else
    for (i = e._last; i && i._start >= o; ) {
      if (i.data === "isPause" && i._start < n)
        return i;
      i = i._prev;
    }
}, i1 = function(e, n, o, i) {
  var r = e._repeat, a = Qe(n) || 0, s = e._tTime / e._tDur;
  return s && !i && (e._time *= a / e._dur), e._dur = a, e._tDur = r ? r < 0 ? 1e10 : Qe(a * (r + 1) + e._rDelay * r) : a, s > 0 && !i && Qi(e, e._tTime = e._tDur * s), e.parent && Ji(e), o || $o(e.parent, e), e;
}, rs = function(e) {
  return e instanceof ft ? $o(e) : i1(e, e._dur);
}, bF = {
  _start: 0,
  endTime: R1,
  totalDuration: R1
}, Gt = function t(e, n, o) {
  var i = e.labels, r = e._recent || bF, a = e.duration() >= Kt ? r.endTime(!1) : e._dur, s, l, d;
  return tt(n) && (isNaN(n) || n in i) ? (l = n.charAt(0), d = n.substr(-1) === "%", s = n.indexOf("="), l === "<" || l === ">" ? (s >= 0 && (n = n.replace(/=/, "")), (l === "<" ? r._start : r.endTime(r._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) * (d ? (s < 0 ? r : o).totalDuration() / 100 : 1)) : s < 0 ? (n in i || (i[n] = a), i[n]) : (l = parseFloat(n.charAt(s - 1) + n.substr(s + 1)), d && o && (l = l / 100 * (ct(o) ? o[0] : o).totalDuration()), s > 1 ? t(e, n.substr(0, s - 1), o) + l : a + l)) : n == null ? a : +n;
}, T1 = function(e, n, o) {
  var i = On(n[1]), r = (i ? 2 : 1) + (e < 2 ? 0 : 1), a = n[r], s, l;
  if (i && (a.duration = n[1]), a.parent = o, e) {
    for (s = a, l = o; l && !("immediateRender" in s); )
      s = l.vars.defaults || {}, l = It(l.vars.inherit) && l.parent;
    a.immediateRender = It(s.immediateRender), e < 2 ? a.runBackwards = 1 : a.startAt = n[r - 1];
  }
  return new ze(n[0], a, n[r + 1]);
}, to = function(e, n) {
  return e || e === 0 ? n(e) : n;
}, oi = function(e, n, o) {
  return o < e ? e : o > n ? n : o;
}, lt = function(e, n) {
  return !tt(e) || !(n = fF.exec(e)) ? "" : n[1];
}, xF = function(e, n, o) {
  return to(o, function(i) {
    return oi(e, n, i);
  });
}, j0 = [].slice, mc = function(e, n) {
  return e && gn(e) && "length" in e && (!n && !e.length || e.length - 1 in e && gn(e[0])) && !e.nodeType && e !== dn;
}, SF = function(e, n, o) {
  return o === void 0 && (o = []), e.forEach(function(i) {
    var r;
    return tt(i) && !n || mc(i, 1) ? (r = o).push.apply(r, qt(i)) : o.push(i);
  }) || o;
}, qt = function(e, n, o) {
  return Ee && !n && Ee.selector ? Ee.selector(e) : tt(e) && !o && (H0 || !r1()) ? j0.call((n || ea).querySelectorAll(e), 0) : ct(e) ? SF(e, o) : mc(e) ? j0.call(e, 0) : e ? [e] : [];
}, G0 = function(e) {
  return e = qt(e)[0] || N1("Invalid scope") || {}, function(n) {
    var o = e.current || e.nativeElement || e;
    return qt(n, o.querySelectorAll ? o : o === e ? N1("Invalid scope") || ea.createElement("div") : e);
  };
}, pc = function(e) {
  return e.sort(function() {
    return 0.5 - Math.random();
  });
}, _c = function(e) {
  if (Ne(e))
    return e;
  var n = gn(e) ? e : {
    each: e
  }, o = wo(n.ease), i = n.from || 0, r = parseFloat(n.base) || 0, a = {}, s = i > 0 && i < 1, l = isNaN(i) || s, d = n.axis, c = i, u = i;
  return tt(i) ? c = u = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[i] || 0 : !s && l && (c = i[0], u = i[1]), function(f, m, v) {
    var _ = (v || n).length, w = a[_], $, y, M, S, x, b, C, E, A;
    if (!w) {
      if (A = n.grid === "auto" ? 0 : (n.grid || [1, Kt])[1], !A) {
        for (C = -Kt; C < (C = v[A++].getBoundingClientRect().left) && A < _; )
          ;
        A < _ && A--;
      }
      for (w = a[_] = [], $ = l ? Math.min(A, _) * c - 0.5 : i % A, y = A === Kt ? 0 : l ? _ * u / A - 0.5 : i / A | 0, C = 0, E = Kt, b = 0; b < _; b++)
        M = b % A - $, S = y - (b / A | 0), w[b] = x = d ? Math.abs(d === "y" ? S : M) : qd(M * M + S * S), x > C && (C = x), x < E && (E = x);
      i === "random" && pc(w), w.max = C - E, w.min = E, w.v = _ = (parseFloat(n.amount) || parseFloat(n.each) * (A > _ ? _ - 1 : d ? d === "y" ? _ / A : A : Math.max(A, _ / A)) || 0) * (i === "edges" ? -1 : 1), w.b = _ < 0 ? r - _ : r, w.u = lt(n.amount || n.each) || 0, o = o && _ < 0 ? Sc(o) : o;
    }
    return _ = (w[f] - w.min) / w.max || 0, Qe(w.b + (o ? o(_) : _) * w.v) + w.u;
  };
}, Y0 = function(e) {
  var n = Math.pow(10, ((e + "").split(".")[1] || "").length);
  return function(o) {
    var i = Qe(Math.round(parseFloat(o) / e) * e * n);
    return (i - i % 1) / n + (On(o) ? 0 : lt(o));
  };
}, vc = function(e, n) {
  var o = ct(e), i, r;
  return !o && gn(e) && (i = o = e.radius || Kt, e.values ? (e = qt(e.values), (r = !On(e[0])) && (i *= i)) : e = Y0(e.increment)), to(n, o ? Ne(e) ? function(a) {
    return r = e(a), Math.abs(r - a) <= i ? r : a;
  } : function(a) {
    for (var s = parseFloat(r ? a.x : a), l = parseFloat(r ? a.y : 0), d = Kt, c = 0, u = e.length, f, m; u--; )
      r ? (f = e[u].x - s, m = e[u].y - l, f = f * f + m * m) : f = Math.abs(e[u] - s), f < d && (d = f, c = u);
    return c = !i || d <= i ? e[c] : a, r || c === a || On(a) ? c : c + lt(a);
  } : Y0(e));
}, gc = function(e, n, o, i) {
  return to(ct(e) ? !n : o === !0 ? !!(o = 0) : !i, function() {
    return ct(e) ? e[~~(Math.random() * e.length)] : (o = o || 1e-5) && (i = o < 1 ? Math.pow(10, (o + "").length - 2) : 1) && Math.floor(Math.round((e - o / 2 + Math.random() * (n - e + o * 0.99)) / o) * o * i) / i;
  });
}, IF = function() {
  for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++)
    n[o] = arguments[o];
  return function(i) {
    return n.reduce(function(r, a) {
      return a(r);
    }, i);
  };
}, AF = function(e, n) {
  return function(o) {
    return e(parseFloat(o)) + (n || lt(o));
  };
}, kF = function(e, n, o) {
  return wc(e, n, 0, 1, o);
}, $c = function(e, n, o) {
  return to(o, function(i) {
    return e[~~n(i)];
  });
}, EF = function t(e, n, o) {
  var i = n - e;
  return ct(e) ? $c(e, t(0, e.length), n) : to(o, function(r) {
    return (i + (r - e) % i) % i + e;
  });
}, PF = function t(e, n, o) {
  var i = n - e, r = i * 2;
  return ct(e) ? $c(e, t(0, e.length - 1), n) : to(o, function(a) {
    return a = (r + (a - e) % r) % r || 0, e + (a > i ? r - a : a);
  });
}, Z1 = function(e) {
  for (var n = 0, o = "", i, r, a, s; ~(i = e.indexOf("random(", n)); )
    a = e.indexOf(")", i), s = e.charAt(i + 7) === "[", r = e.substr(i + 7, a - i - 7).match(s ? tc : F0), o += e.substr(n, i - n) + gc(s ? r : +r[0], s ? 0 : +r[1], +r[2] || 1e-5), n = a + 1;
  return o + e.substr(n, e.length - n);
}, wc = function(e, n, o, i, r) {
  var a = n - e, s = i - o;
  return to(r, function(l) {
    return o + ((l - e) / a * s || 0);
  });
}, TF = function t(e, n, o, i) {
  var r = isNaN(e + n) ? 0 : function(m) {
    return (1 - m) * e + m * n;
  };
  if (!r) {
    var a = tt(e), s = {}, l, d, c, u, f;
    if (o === !0 && (i = 1) && (o = null), a)
      e = {
        p: e
      }, n = {
        p: n
      };
    else if (ct(e) && !ct(n)) {
      for (c = [], u = e.length, f = u - 2, d = 1; d < u; d++)
        c.push(t(e[d - 1], e[d]));
      u--, r = function(v) {
        v *= u;
        var _ = Math.min(f, ~~v);
        return c[_](v - _);
      }, o = n;
    } else i || (e = Co(ct(e) ? [] : {}, e));
    if (!c) {
      for (l in n)
        ra.call(s, e, l, "get", n[l]);
      r = function(v) {
        return da(v, s) || (a ? e.p : e);
      };
    }
  }
  return to(o, r);
}, as = function(e, n, o) {
  var i = e.labels, r = Kt, a, s, l;
  for (a in i)
    s = i[a] - n, s < 0 == !!o && s && r > (s = Math.abs(s)) && (l = a, r = s);
  return l;
}, Zt = function(e, n, o) {
  var i = e.vars, r = i[n], a = Ee, s = e._ctx, l, d, c;
  if (r)
    return l = i[n + "Params"], d = i.callbackScope || e, o && Yn.length && Si(), s && (Ee = s), c = l ? r.apply(d, l) : r.call(d), Ee = a, c;
}, I1 = function(e) {
  return Kn(e), e.scrollTrigger && e.scrollTrigger.kill(!!dt), e.progress() < 1 && Zt(e, "onInterrupt"), e;
}, zo, yc = [], Mc = function(e) {
  if (e)
    if (e = !e.name && e.default || e, Qr() || e.headless) {
      var n = e.name, o = Ne(e), i = n && !o && e.init ? function() {
        this._props = [];
      } : e, r = {
        init: R1,
        render: da,
        add: ra,
        kill: YF,
        modifier: GF,
        rawVars: 0
      }, a = {
        targetTest: 0,
        get: 0,
        getSetter: la,
        aliases: {},
        register: 0
      };
      if (r1(), e !== i) {
        if (Lt[n])
          return;
        Qt(i, Qt(Ii(e, r), a)), Co(i.prototype, Co(r, Ii(e, a))), Lt[i.prop = n] = i, e.targetTest && (vi.push(i), na[n] = 1), n = (n === "css" ? "CSS" : n.charAt(0).toUpperCase() + n.substr(1)) + "Plugin";
      }
      ic(n, i), e.register && e.register(Pt, i, kt);
    } else
      yc.push(e);
}, be = 255, A1 = {
  aqua: [0, be, be],
  lime: [0, be, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, be],
  navy: [0, 0, 128],
  white: [be, be, be],
  olive: [128, 128, 0],
  yellow: [be, be, 0],
  orange: [be, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [be, 0, 0],
  pink: [be, 192, 203],
  cyan: [0, be, be],
  transparent: [be, be, be, 0]
}, $0 = function(e, n, o) {
  return e += e < 0 ? 1 : e > 1 ? -1 : 0, (e * 6 < 1 ? n + (o - n) * e * 6 : e < 0.5 ? o : e * 3 < 2 ? n + (o - n) * (2 / 3 - e) * 6 : n) * be + 0.5 | 0;
}, Cc = function(e, n, o) {
  var i = e ? On(e) ? [e >> 16, e >> 8 & be, e & be] : 0 : A1.black, r, a, s, l, d, c, u, f, m, v;
  if (!i) {
    if (e.substr(-1) === "," && (e = e.substr(0, e.length - 1)), A1[e])
      i = A1[e];
    else if (e.charAt(0) === "#") {
      if (e.length < 6 && (r = e.charAt(1), a = e.charAt(2), s = e.charAt(3), e = "#" + r + r + a + a + s + s + (e.length === 5 ? e.charAt(4) + e.charAt(4) : "")), e.length === 9)
        return i = parseInt(e.substr(1, 6), 16), [i >> 16, i >> 8 & be, i & be, parseInt(e.substr(7), 16) / 255];
      e = parseInt(e.substr(1), 16), i = [e >> 16, e >> 8 & be, e & be];
    } else if (e.substr(0, 3) === "hsl") {
      if (i = v = e.match(F0), !n)
        l = +i[0] % 360 / 360, d = +i[1] / 100, c = +i[2] / 100, a = c <= 0.5 ? c * (d + 1) : c + d - c * d, r = c * 2 - a, i.length > 3 && (i[3] *= 1), i[0] = $0(l + 1 / 3, r, a), i[1] = $0(l, r, a), i[2] = $0(l - 1 / 3, r, a);
      else if (~e.indexOf("="))
        return i = e.match(Qd), o && i.length < 4 && (i[3] = 1), i;
    } else
      i = e.match(F0) || A1.transparent;
    i = i.map(Number);
  }
  return n && !v && (r = i[0] / be, a = i[1] / be, s = i[2] / be, u = Math.max(r, a, s), f = Math.min(r, a, s), c = (u + f) / 2, u === f ? l = d = 0 : (m = u - f, d = c > 0.5 ? m / (2 - u - f) : m / (u + f), l = u === r ? (a - s) / m + (a < s ? 6 : 0) : u === a ? (s - r) / m + 2 : (r - a) / m + 4, l *= 60), i[0] = ~~(l + 0.5), i[1] = ~~(d * 100 + 0.5), i[2] = ~~(c * 100 + 0.5)), o && i.length < 4 && (i[3] = 1), i;
}, bc = function(e) {
  var n = [], o = [], i = -1;
  return e.split(Xn).forEach(function(r) {
    var a = r.match(Uo) || [];
    n.push.apply(n, a), o.push(i += a.length + 1);
  }), n.c = o, n;
}, ss = function(e, n, o) {
  var i = "", r = (e + i).match(Xn), a = n ? "hsla(" : "rgba(", s = 0, l, d, c, u;
  if (!r)
    return e;
  if (r = r.map(function(f) {
    return (f = Cc(f, n, 1)) && a + (n ? f[0] + "," + f[1] + "%," + f[2] + "%," + f[3] : f.join(",")) + ")";
  }), o && (c = bc(e), l = o.c, l.join(i) !== c.c.join(i)))
    for (d = e.replace(Xn, "1").split(Uo), u = d.length - 1; s < u; s++)
      i += d[s] + (~l.indexOf(s) ? r.shift() || a + "0,0,0,0)" : (c.length ? c : r.length ? r : o).shift());
  if (!d)
    for (d = e.split(Xn), u = d.length - 1; s < u; s++)
      i += d[s] + r[s];
  return i + d[u];
}, Xn = function() {
  var t = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", e;
  for (e in A1)
    t += "|" + e + "\\b";
  return new RegExp(t + ")", "gi");
}(), OF = /hsl[a]?\(/, xc = function(e) {
  var n = e.join(" "), o;
  if (Xn.lastIndex = 0, Xn.test(n))
    return o = OF.test(n), e[1] = ss(e[1], o), e[0] = ss(e[0], o, bc(e[1])), !0;
}, B1, Nt = function() {
  var t = Date.now, e = 500, n = 33, o = t(), i = o, r = 1e3 / 240, a = r, s = [], l, d, c, u, f, m, v = function _(w) {
    var $ = t() - i, y = w === !0, M, S, x, b;
    if (($ > e || $ < 0) && (o += $ - n), i += $, x = i - o, M = x - a, (M > 0 || y) && (b = ++u.frame, f = x - u.time * 1e3, u.time = x = x / 1e3, a += M + (M >= r ? 4 : r - M), S = 1), y || (l = d(_)), S)
      for (m = 0; m < s.length; m++)
        s[m](x, f, b, w);
  };
  return u = {
    time: 0,
    frame: 0,
    tick: function() {
      v(!0);
    },
    deltaRatio: function(w) {
      return f / (1e3 / (w || 60));
    },
    wake: function() {
      nc && (!H0 && Qr() && (dn = H0 = window, ea = dn.document || {}, Ht.gsap = Pt, (dn.gsapVersions || (dn.gsapVersions = [])).push(Pt.version), oc(xi || dn.GreenSockGlobals || !dn.gsap && dn || {}), yc.forEach(Mc)), c = typeof requestAnimationFrame < "u" && requestAnimationFrame, l && u.sleep(), d = c || function(w) {
        return setTimeout(w, a - u.time * 1e3 + 1 | 0);
      }, B1 = 1, v(2));
    },
    sleep: function() {
      (c ? cancelAnimationFrame : clearTimeout)(l), B1 = 0, d = R1;
    },
    lagSmoothing: function(w, $) {
      e = w || 1 / 0, n = Math.min($ || 33, e);
    },
    fps: function(w) {
      r = 1e3 / (w || 240), a = u.time * 1e3 + r;
    },
    add: function(w, $, y) {
      var M = $ ? function(S, x, b, C) {
        w(S, x, b, C), u.remove(M);
      } : w;
      return u.remove(w), s[y ? "unshift" : "push"](M), r1(), M;
    },
    remove: function(w, $) {
      ~($ = s.indexOf(w)) && s.splice($, 1) && m >= $ && m--;
    },
    _listeners: s
  }, u;
}(), r1 = function() {
  return !B1 && Nt.wake();
}, ve = {}, LF = /^[\d.\-M][\d.\-,\s]/, DF = /["']/g, NF = function(e) {
  for (var n = {}, o = e.substr(1, e.length - 3).split(":"), i = o[0], r = 1, a = o.length, s, l, d; r < a; r++)
    l = o[r], s = r !== a - 1 ? l.lastIndexOf(",") : l.length, d = l.substr(0, s), n[i] = isNaN(d) ? d.replace(DF, "").trim() : +d, i = l.substr(s + 1).trim();
  return n;
}, RF = function(e) {
  var n = e.indexOf("(") + 1, o = e.indexOf(")"), i = e.indexOf("(", n);
  return e.substring(n, ~i && i < o ? e.indexOf(")", o + 1) : o);
}, ZF = function(e) {
  var n = (e + "").split("("), o = ve[n[0]];
  return o && n.length > 1 && o.config ? o.config.apply(null, ~e.indexOf("{") ? [NF(n[1])] : RF(e).split(",").map(lc)) : ve._CE && LF.test(e) ? ve._CE("", e) : o;
}, Sc = function(e) {
  return function(n) {
    return 1 - e(1 - n);
  };
}, Ic = function t(e, n) {
  for (var o = e._first, i; o; )
    o instanceof ft ? t(o, n) : o.vars.yoyoEase && (!o._yoyo || !o._repeat) && o._yoyo !== n && (o.timeline ? t(o.timeline, n) : (i = o._ease, o._ease = o._yEase, o._yEase = i, o._yoyo = n)), o = o._next;
}, wo = function(e, n) {
  return e && (Ne(e) ? e : ve[e] || ZF(e)) || n;
}, Oo = function(e, n, o, i) {
  o === void 0 && (o = function(l) {
    return 1 - n(1 - l);
  }), i === void 0 && (i = function(l) {
    return l < 0.5 ? n(l * 2) / 2 : 1 - n((1 - l) * 2) / 2;
  });
  var r = {
    easeIn: n,
    easeOut: o,
    easeInOut: i
  }, a;
  return At(e, function(s) {
    ve[s] = Ht[s] = r, ve[a = s.toLowerCase()] = o;
    for (var l in r)
      ve[a + (l === "easeIn" ? ".in" : l === "easeOut" ? ".out" : ".inOut")] = ve[s + "." + l] = r[l];
  }), r;
}, Ac = function(e) {
  return function(n) {
    return n < 0.5 ? (1 - e(1 - n * 2)) / 2 : 0.5 + e((n - 0.5) * 2) / 2;
  };
}, w0 = function t(e, n, o) {
  var i = n >= 1 ? n : 1, r = (o || (e ? 0.3 : 0.45)) / (n < 1 ? n : 1), a = r / V0 * (Math.asin(1 / i) || 0), s = function(c) {
    return c === 1 ? 1 : i * Math.pow(2, -10 * c) * hF((c - a) * r) + 1;
  }, l = e === "out" ? s : e === "in" ? function(d) {
    return 1 - s(1 - d);
  } : Ac(s);
  return r = V0 / r, l.config = function(d, c) {
    return t(e, d, c);
  }, l;
}, y0 = function t(e, n) {
  n === void 0 && (n = 1.70158);
  var o = function(a) {
    return a ? --a * a * ((n + 1) * a + n) + 1 : 0;
  }, i = e === "out" ? o : e === "in" ? function(r) {
    return 1 - o(1 - r);
  } : Ac(o);
  return i.config = function(r) {
    return t(e, r);
  }, i;
};
At("Linear,Quad,Cubic,Quart,Quint,Strong", function(t, e) {
  var n = e < 5 ? e + 1 : e;
  Oo(t + ",Power" + (n - 1), e ? function(o) {
    return Math.pow(o, n);
  } : function(o) {
    return o;
  }, function(o) {
    return 1 - Math.pow(1 - o, n);
  }, function(o) {
    return o < 0.5 ? Math.pow(o * 2, n) / 2 : 1 - Math.pow((1 - o) * 2, n) / 2;
  });
});
ve.Linear.easeNone = ve.none = ve.Linear.easeIn;
Oo("Elastic", w0("in"), w0("out"), w0());
(function(t, e) {
  var n = 1 / e, o = 2 * n, i = 2.5 * n, r = function(s) {
    return s < n ? t * s * s : s < o ? t * Math.pow(s - 1.5 / e, 2) + 0.75 : s < i ? t * (s -= 2.25 / e) * s + 0.9375 : t * Math.pow(s - 2.625 / e, 2) + 0.984375;
  };
  Oo("Bounce", function(a) {
    return 1 - r(1 - a);
  }, r);
})(7.5625, 2.75);
Oo("Expo", function(t) {
  return t ? Math.pow(2, 10 * (t - 1)) : 0;
});
Oo("Circ", function(t) {
  return -(qd(1 - t * t) - 1);
});
Oo("Sine", function(t) {
  return t === 1 ? 1 : -uF(t * dF) + 1;
});
Oo("Back", y0("in"), y0("out"), y0());
ve.SteppedEase = ve.steps = Ht.SteppedEase = {
  config: function(e, n) {
    e === void 0 && (e = 1);
    var o = 1 / e, i = e + (n ? 0 : 1), r = n ? 1 : 0, a = 1 - Se;
    return function(s) {
      return ((i * oi(0, a, s) | 0) + r) * o;
    };
  }
};
n1.ease = ve["quad.out"];
At("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(t) {
  return oa += t + "," + t + "Params,";
});
var kc = function(e, n) {
  this.id = cF++, e._gsap = this, this.target = e, this.harness = n, this.get = n ? n.get : ac, this.set = n ? n.getSetter : la;
}, V1 = /* @__PURE__ */ function() {
  function t(n) {
    this.vars = n, this._delay = +n.delay || 0, (this._repeat = n.repeat === 1 / 0 ? -2 : n.repeat || 0) && (this._rDelay = n.repeatDelay || 0, this._yoyo = !!n.yoyo || !!n.yoyoEase), this._ts = 1, i1(this, +n.duration, 1, 1), this.data = n.data, Ee && (this._ctx = Ee, Ee.data.push(this)), B1 || Nt.wake();
  }
  var e = t.prototype;
  return e.delay = function(o) {
    return o || o === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + o - this._delay), this._delay = o, this) : this._delay;
  }, e.duration = function(o) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? o + (o + this._rDelay) * this._repeat : o) : this.totalDuration() && this._dur;
  }, e.totalDuration = function(o) {
    return arguments.length ? (this._dirty = 0, i1(this, this._repeat < 0 ? o : (o - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, e.totalTime = function(o, i) {
    if (r1(), !arguments.length)
      return this._tTime;
    var r = this._dp;
    if (r && r.smoothChildTiming && this._ts) {
      for (Qi(this, o), !r._dp || r.parent || uc(r, this); r && r.parent; )
        r.parent._time !== r._start + (r._ts >= 0 ? r._tTime / r._ts : (r.totalDuration() - r._tTime) / -r._ts) && r.totalTime(r._tTime, !0), r = r.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && o < this._tDur || this._ts < 0 && o > 0 || !this._tDur && !o) && un(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== o || !this._dur && !i || this._initted && Math.abs(this._zTime) === Se || !o && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = o), sc(this, o, i)), this;
  }, e.time = function(o, i) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), o + is(this)) % (this._dur + this._rDelay) || (o ? this._dur : 0), i) : this._time;
  }, e.totalProgress = function(o, i) {
    return arguments.length ? this.totalTime(this.totalDuration() * o, i) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
  }, e.progress = function(o, i) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - o : o) + is(this), i) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, e.iteration = function(o, i) {
    var r = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (o - 1) * r, i) : this._repeat ? o1(this._tTime, r) + 1 : 1;
  }, e.timeScale = function(o, i) {
    if (!arguments.length)
      return this._rts === -Se ? 0 : this._rts;
    if (this._rts === o)
      return this;
    var r = this.parent && this._ts ? Ai(this.parent._time, this) : this._tTime;
    return this._rts = +o || 0, this._ts = this._ps || o === -Se ? 0 : this._rts, this.totalTime(oi(-Math.abs(this._delay), this._tDur, r), i !== !1), Ji(this), $F(this);
  }, e.paused = function(o) {
    return arguments.length ? (this._ps !== o && (this._ps = o, o ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (r1(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== Se && (this._tTime -= Se)))), this) : this._ps;
  }, e.startTime = function(o) {
    if (arguments.length) {
      this._start = o;
      var i = this.parent || this._dp;
      return i && (i._sort || !this.parent) && un(i, this, o - this._delay), this;
    }
    return this._start;
  }, e.endTime = function(o) {
    return this._start + (It(o) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, e.rawTime = function(o) {
    var i = this.parent || this._dp;
    return i ? o && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Ai(i.rawTime(o), this) : this._tTime : this._tTime;
  }, e.revert = function(o) {
    o === void 0 && (o = pF);
    var i = dt;
    return dt = o, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(o), this.totalTime(-0.01, o.suppressEvents)), this.data !== "nested" && o.kill !== !1 && this.kill(), dt = i, this;
  }, e.globalTime = function(o) {
    for (var i = this, r = arguments.length ? o : i.rawTime(); i; )
      r = i._start + r / (Math.abs(i._ts) || 1), i = i._dp;
    return !this.parent && this._sat ? this._sat.globalTime(o) : r;
  }, e.repeat = function(o) {
    return arguments.length ? (this._repeat = o === 1 / 0 ? -2 : o, rs(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, e.repeatDelay = function(o) {
    if (arguments.length) {
      var i = this._time;
      return this._rDelay = o, rs(this), i ? this.time(i) : this;
    }
    return this._rDelay;
  }, e.yoyo = function(o) {
    return arguments.length ? (this._yoyo = o, this) : this._yoyo;
  }, e.seek = function(o, i) {
    return this.totalTime(Gt(this, o), It(i));
  }, e.restart = function(o, i) {
    return this.play().totalTime(o ? -this._delay : 0, It(i));
  }, e.play = function(o, i) {
    return o != null && this.seek(o, i), this.reversed(!1).paused(!1);
  }, e.reverse = function(o, i) {
    return o != null && this.seek(o || this.totalDuration(), i), this.reversed(!0).paused(!1);
  }, e.pause = function(o, i) {
    return o != null && this.seek(o, i), this.paused(!0);
  }, e.resume = function() {
    return this.paused(!1);
  }, e.reversed = function(o) {
    return arguments.length ? (!!o !== this.reversed() && this.timeScale(-this._rts || (o ? -Se : 0)), this) : this._rts < 0;
  }, e.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -Se, this;
  }, e.isActive = function() {
    var o = this.parent || this._dp, i = this._start, r;
    return !!(!o || this._ts && this._initted && o.isActive() && (r = o.rawTime(!0)) >= i && r < this.endTime(!0) - Se);
  }, e.eventCallback = function(o, i, r) {
    var a = this.vars;
    return arguments.length > 1 ? (i ? (a[o] = i, r && (a[o + "Params"] = r), o === "onUpdate" && (this._onUpdate = i)) : delete a[o], this) : a[o];
  }, e.then = function(o) {
    var i = this;
    return new Promise(function(r) {
      var a = Ne(o) ? o : dc, s = function() {
        var d = i.then;
        i.then = null, Ne(a) && (a = a(i)) && (a.then || a === i) && (i.then = d), r(a), i.then = d;
      };
      i._initted && i.totalProgress() === 1 && i._ts >= 0 || !i._tTime && i._ts < 0 ? s() : i._prom = s;
    });
  }, e.kill = function() {
    I1(this);
  }, t;
}();
Qt(V1.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -Se,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var ft = /* @__PURE__ */ function(t) {
  Kd(e, t);
  function e(o, i) {
    var r;
    return o === void 0 && (o = {}), r = t.call(this, o) || this, r.labels = {}, r.smoothChildTiming = !!o.smoothChildTiming, r.autoRemoveChildren = !!o.autoRemoveChildren, r._sort = It(o.sortChildren), Te && un(o.parent || Te, bn(r), i), o.reversed && r.reverse(), o.paused && r.paused(!0), o.scrollTrigger && hc(bn(r), o.scrollTrigger), r;
  }
  var n = e.prototype;
  return n.to = function(i, r, a) {
    return T1(0, arguments, this), this;
  }, n.from = function(i, r, a) {
    return T1(1, arguments, this), this;
  }, n.fromTo = function(i, r, a, s) {
    return T1(2, arguments, this), this;
  }, n.set = function(i, r, a) {
    return r.duration = 0, r.parent = this, P1(r).repeatDelay || (r.repeat = 0), r.immediateRender = !!r.immediateRender, new ze(i, r, Gt(this, a), 1), this;
  }, n.call = function(i, r, a) {
    return un(this, ze.delayedCall(0, i, r), a);
  }, n.staggerTo = function(i, r, a, s, l, d, c) {
    return a.duration = r, a.stagger = a.stagger || s, a.onComplete = d, a.onCompleteParams = c, a.parent = this, new ze(i, a, Gt(this, l)), this;
  }, n.staggerFrom = function(i, r, a, s, l, d, c) {
    return a.runBackwards = 1, P1(a).immediateRender = It(a.immediateRender), this.staggerTo(i, r, a, s, l, d, c);
  }, n.staggerFromTo = function(i, r, a, s, l, d, c, u) {
    return s.startAt = a, P1(s).immediateRender = It(s.immediateRender), this.staggerTo(i, r, s, l, d, c, u);
  }, n.render = function(i, r, a) {
    var s = this._time, l = this._dirty ? this.totalDuration() : this._tDur, d = this._dur, c = i <= 0 ? 0 : Qe(i), u = this._zTime < 0 != i < 0 && (this._initted || !d), f, m, v, _, w, $, y, M, S, x, b, C;
    if (this !== Te && c > l && i >= 0 && (c = l), c !== this._tTime || a || u) {
      if (s !== this._time && d && (c += this._time - s, i += this._time - s), f = c, S = this._start, M = this._ts, $ = !M, u && (d || (s = this._zTime), (i || !r) && (this._zTime = i)), this._repeat) {
        if (b = this._yoyo, w = d + this._rDelay, this._repeat < -1 && i < 0)
          return this.totalTime(w * 100 + i, r, a);
        if (f = Qe(c % w), c === l ? (_ = this._repeat, f = d) : (_ = ~~(c / w), _ && _ === c / w && (f = d, _--), f > d && (f = d)), x = o1(this._tTime, w), !s && this._tTime && x !== _ && this._tTime - x * w - this._dur <= 0 && (x = _), b && _ & 1 && (f = d - f, C = 1), _ !== x && !this._lock) {
          var E = b && x & 1, A = E === (b && _ & 1);
          if (_ < x && (E = !E), s = E ? 0 : c % d ? d : c, this._lock = 1, this.render(s || (C ? 0 : Qe(_ * w)), r, !d)._lock = 0, this._tTime = c, !r && this.parent && Zt(this, "onRepeat"), this.vars.repeatRefresh && !C && (this.invalidate()._lock = 1), s && s !== this._time || $ !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (d = this._dur, l = this._tDur, A && (this._lock = 2, s = E ? d : -1e-4, this.render(s, !0), this.vars.repeatRefresh && !C && this.invalidate()), this._lock = 0, !this._ts && !$)
            return this;
          Ic(this, C);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (y = CF(this, Qe(s), Qe(f)), y && (c -= f - (f = y._start))), this._tTime = c, this._time = f, this._act = !M, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = i, s = 0), !s && f && !r && !_ && (Zt(this, "onStart"), this._tTime !== c))
        return this;
      if (f >= s && i >= 0)
        for (m = this._first; m; ) {
          if (v = m._next, (m._act || f >= m._start) && m._ts && y !== m) {
            if (m.parent !== this)
              return this.render(i, r, a);
            if (m.render(m._ts > 0 ? (f - m._start) * m._ts : (m._dirty ? m.totalDuration() : m._tDur) + (f - m._start) * m._ts, r, a), f !== this._time || !this._ts && !$) {
              y = 0, v && (c += this._zTime = -Se);
              break;
            }
          }
          m = v;
        }
      else {
        m = this._last;
        for (var T = i < 0 ? i : f; m; ) {
          if (v = m._prev, (m._act || T <= m._end) && m._ts && y !== m) {
            if (m.parent !== this)
              return this.render(i, r, a);
            if (m.render(m._ts > 0 ? (T - m._start) * m._ts : (m._dirty ? m.totalDuration() : m._tDur) + (T - m._start) * m._ts, r, a || dt && (m._initted || m._startAt)), f !== this._time || !this._ts && !$) {
              y = 0, v && (c += this._zTime = T ? -Se : Se);
              break;
            }
          }
          m = v;
        }
      }
      if (y && !r && (this.pause(), y.render(f >= s ? 0 : -Se)._zTime = f >= s ? 1 : -1, this._ts))
        return this._start = S, Ji(this), this.render(i, r, a);
      this._onUpdate && !r && Zt(this, "onUpdate", !0), (c === l && this._tTime >= this.totalDuration() || !c && s) && (S === this._start || Math.abs(M) !== Math.abs(this._ts)) && (this._lock || ((i || !d) && (c === l && this._ts > 0 || !c && this._ts < 0) && Kn(this, 1), !r && !(i < 0 && !s) && (c || s || !l) && (Zt(this, c === l && i >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(c < l && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, n.add = function(i, r) {
    var a = this;
    if (On(r) || (r = Gt(this, r, i)), !(i instanceof V1)) {
      if (ct(i))
        return i.forEach(function(s) {
          return a.add(s, r);
        }), this;
      if (tt(i))
        return this.addLabel(i, r);
      if (Ne(i))
        i = ze.delayedCall(0, i);
      else
        return this;
    }
    return this !== i ? un(this, i, r) : this;
  }, n.getChildren = function(i, r, a, s) {
    i === void 0 && (i = !0), r === void 0 && (r = !0), a === void 0 && (a = !0), s === void 0 && (s = -Kt);
    for (var l = [], d = this._first; d; )
      d._start >= s && (d instanceof ze ? r && l.push(d) : (a && l.push(d), i && l.push.apply(l, d.getChildren(!0, r, a)))), d = d._next;
    return l;
  }, n.getById = function(i) {
    for (var r = this.getChildren(1, 1, 1), a = r.length; a--; )
      if (r[a].vars.id === i)
        return r[a];
  }, n.remove = function(i) {
    return tt(i) ? this.removeLabel(i) : Ne(i) ? this.killTweensOf(i) : (qi(this, i), i === this._recent && (this._recent = this._last), $o(this));
  }, n.totalTime = function(i, r) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Qe(Nt.time - (this._ts > 0 ? i / this._ts : (this.totalDuration() - i) / -this._ts))), t.prototype.totalTime.call(this, i, r), this._forcing = 0, this) : this._tTime;
  }, n.addLabel = function(i, r) {
    return this.labels[i] = Gt(this, r), this;
  }, n.removeLabel = function(i) {
    return delete this.labels[i], this;
  }, n.addPause = function(i, r, a) {
    var s = ze.delayedCall(0, r || R1, a);
    return s.data = "isPause", this._hasPause = 1, un(this, s, Gt(this, i));
  }, n.removePause = function(i) {
    var r = this._first;
    for (i = Gt(this, i); r; )
      r._start === i && r.data === "isPause" && Kn(r), r = r._next;
  }, n.killTweensOf = function(i, r, a) {
    for (var s = this.getTweensOf(i, a), l = s.length; l--; )
      Hn !== s[l] && s[l].kill(i, r);
    return this;
  }, n.getTweensOf = function(i, r) {
    for (var a = [], s = qt(i), l = this._first, d = On(r), c; l; )
      l instanceof ze ? _F(l._targets, s) && (d ? (!Hn || l._initted && l._ts) && l.globalTime(0) <= r && l.globalTime(l.totalDuration()) > r : !r || l.isActive()) && a.push(l) : (c = l.getTweensOf(s, r)).length && a.push.apply(a, c), l = l._next;
    return a;
  }, n.tweenTo = function(i, r) {
    r = r || {};
    var a = this, s = Gt(a, i), l = r, d = l.startAt, c = l.onStart, u = l.onStartParams, f = l.immediateRender, m, v = ze.to(a, Qt({
      ease: r.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: s,
      overwrite: "auto",
      duration: r.duration || Math.abs((s - (d && "time" in d ? d.time : a._time)) / a.timeScale()) || Se,
      onStart: function() {
        if (a.pause(), !m) {
          var w = r.duration || Math.abs((s - (d && "time" in d ? d.time : a._time)) / a.timeScale());
          v._dur !== w && i1(v, w, 0, 1).render(v._time, !0, !0), m = 1;
        }
        c && c.apply(v, u || []);
      }
    }, r));
    return f ? v.render(0) : v;
  }, n.tweenFromTo = function(i, r, a) {
    return this.tweenTo(r, Qt({
      startAt: {
        time: Gt(this, i)
      }
    }, a));
  }, n.recent = function() {
    return this._recent;
  }, n.nextLabel = function(i) {
    return i === void 0 && (i = this._time), as(this, Gt(this, i));
  }, n.previousLabel = function(i) {
    return i === void 0 && (i = this._time), as(this, Gt(this, i), 1);
  }, n.currentLabel = function(i) {
    return arguments.length ? this.seek(i, !0) : this.previousLabel(this._time + Se);
  }, n.shiftChildren = function(i, r, a) {
    a === void 0 && (a = 0);
    for (var s = this._first, l = this.labels, d; s; )
      s._start >= a && (s._start += i, s._end += i), s = s._next;
    if (r)
      for (d in l)
        l[d] >= a && (l[d] += i);
    return $o(this);
  }, n.invalidate = function(i) {
    var r = this._first;
    for (this._lock = 0; r; )
      r.invalidate(i), r = r._next;
    return t.prototype.invalidate.call(this, i);
  }, n.clear = function(i) {
    i === void 0 && (i = !0);
    for (var r = this._first, a; r; )
      a = r._next, this.remove(r), r = a;
    return this._dp && (this._time = this._tTime = this._pTime = 0), i && (this.labels = {}), $o(this);
  }, n.totalDuration = function(i) {
    var r = 0, a = this, s = a._last, l = Kt, d, c, u;
    if (arguments.length)
      return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -i : i));
    if (a._dirty) {
      for (u = a.parent; s; )
        d = s._prev, s._dirty && s.totalDuration(), c = s._start, c > l && a._sort && s._ts && !a._lock ? (a._lock = 1, un(a, s, c - s._delay, 1)._lock = 0) : l = c, c < 0 && s._ts && (r -= c, (!u && !a._dp || u && u.smoothChildTiming) && (a._start += c / a._ts, a._time -= c, a._tTime -= c), a.shiftChildren(-c, !1, -1 / 0), l = 0), s._end > r && s._ts && (r = s._end), s = d;
      i1(a, a === Te && a._time > r ? a._time : r, 1, 1), a._dirty = 0;
    }
    return a._tDur;
  }, e.updateRoot = function(i) {
    if (Te._ts && (sc(Te, Ai(i, Te)), rc = Nt.frame), Nt.frame >= ns) {
      ns += Vt.autoSleep || 120;
      var r = Te._first;
      if ((!r || !r._ts) && Vt.autoSleep && Nt._listeners.length < 2) {
        for (; r && !r._ts; )
          r = r._next;
        r || Nt.sleep();
      }
    }
  }, e;
}(V1);
Qt(ft.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var BF = function(e, n, o, i, r, a, s) {
  var l = new kt(this._pt, e, n, 0, 1, Dc, null, r), d = 0, c = 0, u, f, m, v, _, w, $, y;
  for (l.b = o, l.e = i, o += "", i += "", ($ = ~i.indexOf("random(")) && (i = Z1(i)), a && (y = [o, i], a(y, e, n), o = y[0], i = y[1]), f = o.match(v0) || []; u = v0.exec(i); )
    v = u[0], _ = i.substring(d, u.index), m ? m = (m + 1) % 5 : _.substr(-5) === "rgba(" && (m = 1), v !== f[c++] && (w = parseFloat(f[c - 1]) || 0, l._pt = {
      _next: l._pt,
      p: _ || c === 1 ? _ : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: w,
      c: v.charAt(1) === "=" ? Yo(w, v) - w : parseFloat(v) - w,
      m: m && m < 4 ? Math.round : 0
    }, d = v0.lastIndex);
  return l.c = d < i.length ? i.substring(d, i.length) : "", l.fp = s, (ec.test(i) || $) && (l.e = 0), this._pt = l, l;
}, ra = function(e, n, o, i, r, a, s, l, d, c) {
  Ne(i) && (i = i(r || 0, e, a));
  var u = e[n], f = o !== "get" ? o : Ne(u) ? d ? e[n.indexOf("set") || !Ne(e["get" + n.substr(3)]) ? n : "get" + n.substr(3)](d) : e[n]() : u, m = Ne(u) ? d ? zF : Oc : sa, v;
  if (tt(i) && (~i.indexOf("random(") && (i = Z1(i)), i.charAt(1) === "=" && (v = Yo(f, i) + (lt(f) || 0), (v || v === 0) && (i = v))), !c || f !== i || X0)
    return !isNaN(f * i) && i !== "" ? (v = new kt(this._pt, e, n, +f || 0, i - (f || 0), typeof u == "boolean" ? jF : Lc, 0, m), d && (v.fp = d), s && v.modifier(s, this, e), this._pt = v) : (!u && !(n in e) && ta(n, i), BF.call(this, e, n, f, i, m, l || Vt.stringFilter, d));
}, VF = function(e, n, o, i, r) {
  if (Ne(e) && (e = O1(e, r, n, o, i)), !gn(e) || e.style && e.nodeType || ct(e) || Jd(e))
    return tt(e) ? O1(e, r, n, o, i) : e;
  var a = {}, s;
  for (s in e)
    a[s] = O1(e[s], r, n, o, i);
  return a;
}, Ec = function(e, n, o, i, r, a) {
  var s, l, d, c;
  if (Lt[e] && (s = new Lt[e]()).init(r, s.rawVars ? n[e] : VF(n[e], i, r, a, o), o, i, a) !== !1 && (o._pt = l = new kt(o._pt, r, e, 0, 1, s.render, s, 0, s.priority), o !== zo))
    for (d = o._ptLookup[o._targets.indexOf(r)], c = s._props.length; c--; )
      d[s._props[c]] = l;
  return s;
}, Hn, X0, aa = function t(e, n, o) {
  var i = e.vars, r = i.ease, a = i.startAt, s = i.immediateRender, l = i.lazy, d = i.onUpdate, c = i.runBackwards, u = i.yoyoEase, f = i.keyframes, m = i.autoRevert, v = e._dur, _ = e._startAt, w = e._targets, $ = e.parent, y = $ && $.data === "nested" ? $.vars.targets : w, M = e._overwrite === "auto" && !qr, S = e.timeline, x, b, C, E, A, T, k, L, V, O, D, P, F;
  if (S && (!f || !r) && (r = "none"), e._ease = wo(r, n1.ease), e._yEase = u ? Sc(wo(u === !0 ? r : u, n1.ease)) : 0, u && e._yoyo && !e._repeat && (u = e._yEase, e._yEase = e._ease, e._ease = u), e._from = !S && !!i.runBackwards, !S || f && !i.stagger) {
    if (L = w[0] ? go(w[0]).harness : 0, P = L && i[L.prop], x = Ii(i, na), _ && (_._zTime < 0 && _.progress(1), n < 0 && c && s && !m ? _.render(-1, !0) : _.revert(c && v ? _i : mF), _._lazy = 0), a) {
      if (Kn(e._startAt = ze.set(w, Qt({
        data: "isStart",
        overwrite: !1,
        parent: $,
        immediateRender: !0,
        lazy: !_ && It(l),
        startAt: null,
        delay: 0,
        onUpdate: d && function() {
          return Zt(e, "onUpdate");
        },
        stagger: 0
      }, a))), e._startAt._dp = 0, e._startAt._sat = e, n < 0 && (dt || !s && !m) && e._startAt.revert(_i), s && v && n <= 0 && o <= 0) {
        n && (e._zTime = n);
        return;
      }
    } else if (c && v && !_) {
      if (n && (s = !1), C = Qt({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: s && !_ && It(l),
        immediateRender: s,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: $
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, x), P && (C[L.prop] = P), Kn(e._startAt = ze.set(w, C)), e._startAt._dp = 0, e._startAt._sat = e, n < 0 && (dt ? e._startAt.revert(_i) : e._startAt.render(-1, !0)), e._zTime = n, !s)
        t(e._startAt, Se, Se);
      else if (!n)
        return;
    }
    for (e._pt = e._ptCache = 0, l = v && It(l) || l && !v, b = 0; b < w.length; b++) {
      if (A = w[b], k = A._gsap || ia(w)[b]._gsap, e._ptLookup[b] = O = {}, U0[k.id] && Yn.length && Si(), D = y === w ? b : y.indexOf(A), L && (V = new L()).init(A, P || x, e, D, y) !== !1 && (e._pt = E = new kt(e._pt, A, V.name, 0, 1, V.render, V, 0, V.priority), V._props.forEach(function(N) {
        O[N] = E;
      }), V.priority && (T = 1)), !L || P)
        for (C in x)
          Lt[C] && (V = Ec(C, x, e, D, A, y)) ? V.priority && (T = 1) : O[C] = E = ra.call(e, A, C, "get", x[C], D, y, 0, i.stringFilter);
      e._op && e._op[b] && e.kill(A, e._op[b]), M && e._pt && (Hn = e, Te.killTweensOf(A, O, e.globalTime(n)), F = !e.parent, Hn = 0), e._pt && l && (U0[k.id] = 1);
    }
    T && Nc(e), e._onInit && e._onInit(e);
  }
  e._onUpdate = d, e._initted = (!e._op || e._pt) && !F, f && n <= 0 && S.render(Kt, !0, !0);
}, FF = function(e, n, o, i, r, a, s, l) {
  var d = (e._pt && e._ptCache || (e._ptCache = {}))[n], c, u, f, m;
  if (!d)
    for (d = e._ptCache[n] = [], f = e._ptLookup, m = e._targets.length; m--; ) {
      if (c = f[m][n], c && c.d && c.d._pt)
        for (c = c.d._pt; c && c.p !== n && c.fp !== n; )
          c = c._next;
      if (!c)
        return X0 = 1, e.vars[n] = "+=0", aa(e, s), X0 = 0, l ? N1(n + " not eligible for reset") : 1;
      d.push(c);
    }
  for (m = d.length; m--; )
    u = d[m], c = u._pt || u, c.s = (i || i === 0) && !r ? i : c.s + (i || 0) + a * c.c, c.c = o - c.s, u.e && (u.e = Fe(o) + lt(u.e)), u.b && (u.b = c.s + lt(u.b));
}, HF = function(e, n) {
  var o = e[0] ? go(e[0]).harness : 0, i = o && o.aliases, r, a, s, l;
  if (!i)
    return n;
  r = Co({}, n);
  for (a in i)
    if (a in r)
      for (l = i[a].split(","), s = l.length; s--; )
        r[l[s]] = r[a];
  return r;
}, UF = function(e, n, o, i) {
  var r = n.ease || i || "power1.inOut", a, s;
  if (ct(n))
    s = o[e] || (o[e] = []), n.forEach(function(l, d) {
      return s.push({
        t: d / (n.length - 1) * 100,
        v: l,
        e: r
      });
    });
  else
    for (a in n)
      s = o[a] || (o[a] = []), a === "ease" || s.push({
        t: parseFloat(e),
        v: n[a],
        e: r
      });
}, O1 = function(e, n, o, i, r) {
  return Ne(e) ? e.call(n, o, i, r) : tt(e) && ~e.indexOf("random(") ? Z1(e) : e;
}, Pc = oa + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", Tc = {};
At(Pc + ",id,stagger,delay,duration,paused,scrollTrigger", function(t) {
  return Tc[t] = 1;
});
var ze = /* @__PURE__ */ function(t) {
  Kd(e, t);
  function e(o, i, r, a) {
    var s;
    typeof i == "number" && (r.duration = i, i = r, r = null), s = t.call(this, a ? i : P1(i)) || this;
    var l = s.vars, d = l.duration, c = l.delay, u = l.immediateRender, f = l.stagger, m = l.overwrite, v = l.keyframes, _ = l.defaults, w = l.scrollTrigger, $ = l.yoyoEase, y = i.parent || Te, M = (ct(o) || Jd(o) ? On(o[0]) : "length" in i) ? [o] : qt(o), S, x, b, C, E, A, T, k;
    if (s._targets = M.length ? ia(M) : N1("GSAP target " + o + " not found. https://gsap.com", !Vt.nullTargetWarn) || [], s._ptLookup = [], s._overwrite = m, v || f || li(d) || li(c)) {
      if (i = s.vars, S = s.timeline = new ft({
        data: "nested",
        defaults: _ || {},
        targets: y && y.data === "nested" ? y.vars.targets : M
      }), S.kill(), S.parent = S._dp = bn(s), S._start = 0, f || li(d) || li(c)) {
        if (C = M.length, T = f && _c(f), gn(f))
          for (E in f)
            ~Pc.indexOf(E) && (k || (k = {}), k[E] = f[E]);
        for (x = 0; x < C; x++)
          b = Ii(i, Tc), b.stagger = 0, $ && (b.yoyoEase = $), k && Co(b, k), A = M[x], b.duration = +O1(d, bn(s), x, A, M), b.delay = (+O1(c, bn(s), x, A, M) || 0) - s._delay, !f && C === 1 && b.delay && (s._delay = c = b.delay, s._start += c, b.delay = 0), S.to(A, b, T ? T(x, A, M) : 0), S._ease = ve.none;
        S.duration() ? d = c = 0 : s.timeline = 0;
      } else if (v) {
        P1(Qt(S.vars.defaults, {
          ease: "none"
        })), S._ease = wo(v.ease || i.ease || "none");
        var L = 0, V, O, D;
        if (ct(v))
          v.forEach(function(P) {
            return S.to(M, P, ">");
          }), S.duration();
        else {
          b = {};
          for (E in v)
            E === "ease" || E === "easeEach" || UF(E, v[E], b, v.easeEach);
          for (E in b)
            for (V = b[E].sort(function(P, F) {
              return P.t - F.t;
            }), L = 0, x = 0; x < V.length; x++)
              O = V[x], D = {
                ease: O.e,
                duration: (O.t - (x ? V[x - 1].t : 0)) / 100 * d
              }, D[E] = O.v, S.to(M, D, L), L += D.duration;
          S.duration() < d && S.to({}, {
            duration: d - S.duration()
          });
        }
      }
      d || s.duration(d = S.duration());
    } else
      s.timeline = 0;
    return m === !0 && !qr && (Hn = bn(s), Te.killTweensOf(M), Hn = 0), un(y, bn(s), r), i.reversed && s.reverse(), i.paused && s.paused(!0), (u || !d && !v && s._start === Qe(y._time) && It(u) && wF(bn(s)) && y.data !== "nested") && (s._tTime = -Se, s.render(Math.max(0, -c) || 0)), w && hc(bn(s), w), s;
  }
  var n = e.prototype;
  return n.render = function(i, r, a) {
    var s = this._time, l = this._tDur, d = this._dur, c = i < 0, u = i > l - Se && !c ? l : i < Se ? 0 : i, f, m, v, _, w, $, y, M, S;
    if (!d)
      MF(this, i, r, a);
    else if (u !== this._tTime || !i || a || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== c) {
      if (f = u, M = this.timeline, this._repeat) {
        if (_ = d + this._rDelay, this._repeat < -1 && c)
          return this.totalTime(_ * 100 + i, r, a);
        if (f = Qe(u % _), u === l ? (v = this._repeat, f = d) : (v = ~~(u / _), v && v === Qe(u / _) && (f = d, v--), f > d && (f = d)), $ = this._yoyo && v & 1, $ && (S = this._yEase, f = d - f), w = o1(this._tTime, _), f === s && !a && this._initted && v === w)
          return this._tTime = u, this;
        v !== w && (M && this._yEase && Ic(M, $), this.vars.repeatRefresh && !$ && !this._lock && this._time !== _ && this._initted && (this._lock = a = 1, this.render(Qe(_ * v), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (fc(this, c ? i : f, a, r, u))
          return this._tTime = 0, this;
        if (s !== this._time && !(a && this.vars.repeatRefresh && v !== w))
          return this;
        if (d !== this._dur)
          return this.render(i, r, a);
      }
      if (this._tTime = u, this._time = f, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = y = (S || this._ease)(f / d), this._from && (this.ratio = y = 1 - y), f && !s && !r && !v && (Zt(this, "onStart"), this._tTime !== u))
        return this;
      for (m = this._pt; m; )
        m.r(y, m.d), m = m._next;
      M && M.render(i < 0 ? i : M._dur * M._ease(f / this._dur), r, a) || this._startAt && (this._zTime = i), this._onUpdate && !r && (c && z0(this, i, r, a), Zt(this, "onUpdate")), this._repeat && v !== w && this.vars.onRepeat && !r && this.parent && Zt(this, "onRepeat"), (u === this._tDur || !u) && this._tTime === u && (c && !this._onUpdate && z0(this, i, !0, !0), (i || !d) && (u === this._tDur && this._ts > 0 || !u && this._ts < 0) && Kn(this, 1), !r && !(c && !s) && (u || s || $) && (Zt(this, u === l ? "onComplete" : "onReverseComplete", !0), this._prom && !(u < l && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, n.targets = function() {
    return this._targets;
  }, n.invalidate = function(i) {
    return (!i || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(i), t.prototype.invalidate.call(this, i);
  }, n.resetTo = function(i, r, a, s, l) {
    B1 || Nt.wake(), this._ts || this.play();
    var d = Math.min(this._dur, (this._dp._time - this._start) * this._ts), c;
    return this._initted || aa(this, d), c = this._ease(d / this._dur), FF(this, i, r, a, s, c, d, l) ? this.resetTo(i, r, a, s, 1) : (Qi(this, 0), this.parent || cc(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, n.kill = function(i, r) {
    if (r === void 0 && (r = "all"), !i && (!r || r === "all"))
      return this._lazy = this._pt = 0, this.parent ? I1(this) : this;
    if (this.timeline) {
      var a = this.timeline.totalDuration();
      return this.timeline.killTweensOf(i, r, Hn && Hn.vars.overwrite !== !0)._first || I1(this), this.parent && a !== this.timeline.totalDuration() && i1(this, this._dur * this.timeline._tDur / a, 0, 1), this;
    }
    var s = this._targets, l = i ? qt(i) : s, d = this._ptLookup, c = this._pt, u, f, m, v, _, w, $;
    if ((!r || r === "all") && gF(s, l))
      return r === "all" && (this._pt = 0), I1(this);
    for (u = this._op = this._op || [], r !== "all" && (tt(r) && (_ = {}, At(r, function(y) {
      return _[y] = 1;
    }), r = _), r = HF(s, r)), $ = s.length; $--; )
      if (~l.indexOf(s[$])) {
        f = d[$], r === "all" ? (u[$] = r, v = f, m = {}) : (m = u[$] = u[$] || {}, v = r);
        for (_ in v)
          w = f && f[_], w && ((!("kill" in w.d) || w.d.kill(_) === !0) && qi(this, w, "_pt"), delete f[_]), m !== "all" && (m[_] = 1);
      }
    return this._initted && !this._pt && c && I1(this), this;
  }, e.to = function(i, r) {
    return new e(i, r, arguments[2]);
  }, e.from = function(i, r) {
    return T1(1, arguments);
  }, e.delayedCall = function(i, r, a, s) {
    return new e(r, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: i,
      onComplete: r,
      onReverseComplete: r,
      onCompleteParams: a,
      onReverseCompleteParams: a,
      callbackScope: s
    });
  }, e.fromTo = function(i, r, a) {
    return T1(2, arguments);
  }, e.set = function(i, r) {
    return r.duration = 0, r.repeatDelay || (r.repeat = 0), new e(i, r);
  }, e.killTweensOf = function(i, r, a) {
    return Te.killTweensOf(i, r, a);
  }, e;
}(V1);
Qt(ze.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
At("staggerTo,staggerFrom,staggerFromTo", function(t) {
  ze[t] = function() {
    var e = new ft(), n = j0.call(arguments, 0);
    return n.splice(t === "staggerFromTo" ? 5 : 4, 0, 0), e[t].apply(e, n);
  };
});
var sa = function(e, n, o) {
  return e[n] = o;
}, Oc = function(e, n, o) {
  return e[n](o);
}, zF = function(e, n, o, i) {
  return e[n](i.fp, o);
}, WF = function(e, n, o) {
  return e.setAttribute(n, o);
}, la = function(e, n) {
  return Ne(e[n]) ? Oc : Jr(e[n]) && e.setAttribute ? WF : sa;
}, Lc = function(e, n) {
  return n.set(n.t, n.p, Math.round((n.s + n.c * e) * 1e6) / 1e6, n);
}, jF = function(e, n) {
  return n.set(n.t, n.p, !!(n.s + n.c * e), n);
}, Dc = function(e, n) {
  var o = n._pt, i = "";
  if (!e && n.b)
    i = n.b;
  else if (e === 1 && n.e)
    i = n.e;
  else {
    for (; o; )
      i = o.p + (o.m ? o.m(o.s + o.c * e) : Math.round((o.s + o.c * e) * 1e4) / 1e4) + i, o = o._next;
    i += n.c;
  }
  n.set(n.t, n.p, i, n);
}, da = function(e, n) {
  for (var o = n._pt; o; )
    o.r(e, o.d), o = o._next;
}, GF = function(e, n, o, i) {
  for (var r = this._pt, a; r; )
    a = r._next, r.p === i && r.modifier(e, n, o), r = a;
}, YF = function(e) {
  for (var n = this._pt, o, i; n; )
    i = n._next, n.p === e && !n.op || n.op === e ? qi(this, n, "_pt") : n.dep || (o = 1), n = i;
  return !o;
}, XF = function(e, n, o, i) {
  i.mSet(e, n, i.m.call(i.tween, o, i.mt), i);
}, Nc = function(e) {
  for (var n = e._pt, o, i, r, a; n; ) {
    for (o = n._next, i = r; i && i.pr > n.pr; )
      i = i._next;
    (n._prev = i ? i._prev : a) ? n._prev._next = n : r = n, (n._next = i) ? i._prev = n : a = n, n = o;
  }
  e._pt = r;
}, kt = /* @__PURE__ */ function() {
  function t(n, o, i, r, a, s, l, d, c) {
    this.t = o, this.s = r, this.c = a, this.p = i, this.r = s || Lc, this.d = l || this, this.set = d || sa, this.pr = c || 0, this._next = n, n && (n._prev = this);
  }
  var e = t.prototype;
  return e.modifier = function(o, i, r) {
    this.mSet = this.mSet || this.set, this.set = XF, this.m = o, this.mt = r, this.tween = i;
  }, t;
}();
At(oa + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(t) {
  return na[t] = 1;
});
Ht.TweenMax = Ht.TweenLite = ze;
Ht.TimelineLite = Ht.TimelineMax = ft;
Te = new ft({
  sortChildren: !1,
  defaults: n1,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
Vt.stringFilter = xc;
var yo = [], gi = {}, KF = [], ls = 0, qF = 0, M0 = function(e) {
  return (gi[e] || KF).map(function(n) {
    return n();
  });
}, K0 = function() {
  var e = Date.now(), n = [];
  e - ls > 2 && (M0("matchMediaInit"), yo.forEach(function(o) {
    var i = o.queries, r = o.conditions, a, s, l, d;
    for (s in i)
      a = dn.matchMedia(i[s]).matches, a && (l = 1), a !== r[s] && (r[s] = a, d = 1);
    d && (o.revert(), l && n.push(o));
  }), M0("matchMediaRevert"), n.forEach(function(o) {
    return o.onMatch(o, function(i) {
      return o.add(null, i);
    });
  }), ls = e, M0("matchMedia"));
}, Rc = /* @__PURE__ */ function() {
  function t(n, o) {
    this.selector = o && G0(o), this.data = [], this._r = [], this.isReverted = !1, this.id = qF++, n && this.add(n);
  }
  var e = t.prototype;
  return e.add = function(o, i, r) {
    Ne(o) && (r = i, i = o, o = Ne);
    var a = this, s = function() {
      var d = Ee, c = a.selector, u;
      return d && d !== a && d.data.push(a), r && (a.selector = G0(r)), Ee = a, u = i.apply(a, arguments), Ne(u) && a._r.push(u), Ee = d, a.selector = c, a.isReverted = !1, u;
    };
    return a.last = s, o === Ne ? s(a, function(l) {
      return a.add(null, l);
    }) : o ? a[o] = s : s;
  }, e.ignore = function(o) {
    var i = Ee;
    Ee = null, o(this), Ee = i;
  }, e.getTweens = function() {
    var o = [];
    return this.data.forEach(function(i) {
      return i instanceof t ? o.push.apply(o, i.getTweens()) : i instanceof ze && !(i.parent && i.parent.data === "nested") && o.push(i);
    }), o;
  }, e.clear = function() {
    this._r.length = this.data.length = 0;
  }, e.kill = function(o, i) {
    var r = this;
    if (o ? function() {
      for (var s = r.getTweens(), l = r.data.length, d; l--; )
        d = r.data[l], d.data === "isFlip" && (d.revert(), d.getChildren(!0, !0, !1).forEach(function(c) {
          return s.splice(s.indexOf(c), 1);
        }));
      for (s.map(function(c) {
        return {
          g: c._dur || c._delay || c._sat && !c._sat.vars.immediateRender ? c.globalTime(0) : -1 / 0,
          t: c
        };
      }).sort(function(c, u) {
        return u.g - c.g || -1 / 0;
      }).forEach(function(c) {
        return c.t.revert(o);
      }), l = r.data.length; l--; )
        d = r.data[l], d instanceof ft ? d.data !== "nested" && (d.scrollTrigger && d.scrollTrigger.revert(), d.kill()) : !(d instanceof ze) && d.revert && d.revert(o);
      r._r.forEach(function(c) {
        return c(o, r);
      }), r.isReverted = !0;
    }() : this.data.forEach(function(s) {
      return s.kill && s.kill();
    }), this.clear(), i)
      for (var a = yo.length; a--; )
        yo[a].id === this.id && yo.splice(a, 1);
  }, e.revert = function(o) {
    this.kill(o || {});
  }, t;
}(), JF = /* @__PURE__ */ function() {
  function t(n) {
    this.contexts = [], this.scope = n, Ee && Ee.data.push(this);
  }
  var e = t.prototype;
  return e.add = function(o, i, r) {
    gn(o) || (o = {
      matches: o
    });
    var a = new Rc(0, r || this.scope), s = a.conditions = {}, l, d, c;
    Ee && !a.selector && (a.selector = Ee.selector), this.contexts.push(a), i = a.add("onMatch", i), a.queries = o;
    for (d in o)
      d === "all" ? c = 1 : (l = dn.matchMedia(o[d]), l && (yo.indexOf(a) < 0 && yo.push(a), (s[d] = l.matches) && (c = 1), l.addListener ? l.addListener(K0) : l.addEventListener("change", K0)));
    return c && i(a, function(u) {
      return a.add(null, u);
    }), this;
  }, e.revert = function(o) {
    this.kill(o || {});
  }, e.kill = function(o) {
    this.contexts.forEach(function(i) {
      return i.kill(o, !0);
    });
  }, t;
}(), ki = {
  registerPlugin: function() {
    for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++)
      n[o] = arguments[o];
    n.forEach(function(i) {
      return Mc(i);
    });
  },
  timeline: function(e) {
    return new ft(e);
  },
  getTweensOf: function(e, n) {
    return Te.getTweensOf(e, n);
  },
  getProperty: function(e, n, o, i) {
    tt(e) && (e = qt(e)[0]);
    var r = go(e || {}).get, a = o ? dc : lc;
    return o === "native" && (o = ""), e && (n ? a((Lt[n] && Lt[n].get || r)(e, n, o, i)) : function(s, l, d) {
      return a((Lt[s] && Lt[s].get || r)(e, s, l, d));
    });
  },
  quickSetter: function(e, n, o) {
    if (e = qt(e), e.length > 1) {
      var i = e.map(function(c) {
        return Pt.quickSetter(c, n, o);
      }), r = i.length;
      return function(c) {
        for (var u = r; u--; )
          i[u](c);
      };
    }
    e = e[0] || {};
    var a = Lt[n], s = go(e), l = s.harness && (s.harness.aliases || {})[n] || n, d = a ? function(c) {
      var u = new a();
      zo._pt = 0, u.init(e, o ? c + o : c, zo, 0, [e]), u.render(1, u), zo._pt && da(1, zo);
    } : s.set(e, l);
    return a ? d : function(c) {
      return d(e, l, o ? c + o : c, s, 1);
    };
  },
  quickTo: function(e, n, o) {
    var i, r = Pt.to(e, Co((i = {}, i[n] = "+=0.1", i.paused = !0, i), o || {})), a = function(l, d, c) {
      return r.resetTo(n, l, d, c);
    };
    return a.tween = r, a;
  },
  isTweening: function(e) {
    return Te.getTweensOf(e, !0).length > 0;
  },
  defaults: function(e) {
    return e && e.ease && (e.ease = wo(e.ease, n1.ease)), os(n1, e || {});
  },
  config: function(e) {
    return os(Vt, e || {});
  },
  registerEffect: function(e) {
    var n = e.name, o = e.effect, i = e.plugins, r = e.defaults, a = e.extendTimeline;
    (i || "").split(",").forEach(function(s) {
      return s && !Lt[s] && !Ht[s] && N1(n + " effect requires " + s + " plugin.");
    }), g0[n] = function(s, l, d) {
      return o(qt(s), Qt(l || {}, r), d);
    }, a && (ft.prototype[n] = function(s, l, d) {
      return this.add(g0[n](s, gn(l) ? l : (d = l) && {}, this), d);
    });
  },
  registerEase: function(e, n) {
    ve[e] = wo(n);
  },
  parseEase: function(e, n) {
    return arguments.length ? wo(e, n) : ve;
  },
  getById: function(e) {
    return Te.getById(e);
  },
  exportRoot: function(e, n) {
    e === void 0 && (e = {});
    var o = new ft(e), i, r;
    for (o.smoothChildTiming = It(e.smoothChildTiming), Te.remove(o), o._dp = 0, o._time = o._tTime = Te._time, i = Te._first; i; )
      r = i._next, (n || !(!i._dur && i instanceof ze && i.vars.onComplete === i._targets[0])) && un(o, i, i._start - i._delay), i = r;
    return un(Te, o, 0), o;
  },
  context: function(e, n) {
    return e ? new Rc(e, n) : Ee;
  },
  matchMedia: function(e) {
    return new JF(e);
  },
  matchMediaRefresh: function() {
    return yo.forEach(function(e) {
      var n = e.conditions, o, i;
      for (i in n)
        n[i] && (n[i] = !1, o = 1);
      o && e.revert();
    }) || K0();
  },
  addEventListener: function(e, n) {
    var o = gi[e] || (gi[e] = []);
    ~o.indexOf(n) || o.push(n);
  },
  removeEventListener: function(e, n) {
    var o = gi[e], i = o && o.indexOf(n);
    i >= 0 && o.splice(i, 1);
  },
  utils: {
    wrap: EF,
    wrapYoyo: PF,
    distribute: _c,
    random: gc,
    snap: vc,
    normalize: kF,
    getUnit: lt,
    clamp: xF,
    splitColor: Cc,
    toArray: qt,
    selector: G0,
    mapRange: wc,
    pipe: IF,
    unitize: AF,
    interpolate: TF,
    shuffle: pc
  },
  install: oc,
  effects: g0,
  ticker: Nt,
  updateRoot: ft.updateRoot,
  plugins: Lt,
  globalTimeline: Te,
  core: {
    PropTween: kt,
    globals: ic,
    Tween: ze,
    Timeline: ft,
    Animation: V1,
    getCache: go,
    _removeLinkedListItem: qi,
    reverting: function() {
      return dt;
    },
    context: function(e) {
      return e && Ee && (Ee.data.push(e), e._ctx = Ee), Ee;
    },
    suppressOverwrites: function(e) {
      return qr = e;
    }
  }
};
At("to,from,fromTo,delayedCall,set,killTweensOf", function(t) {
  return ki[t] = ze[t];
});
Nt.add(ft.updateRoot);
zo = ki.to({}, {
  duration: 0
});
var QF = function(e, n) {
  for (var o = e._pt; o && o.p !== n && o.op !== n && o.fp !== n; )
    o = o._next;
  return o;
}, eH = function(e, n) {
  var o = e._targets, i, r, a;
  for (i in n)
    for (r = o.length; r--; )
      a = e._ptLookup[r][i], a && (a = a.d) && (a._pt && (a = QF(a, i)), a && a.modifier && a.modifier(n[i], e, o[r], i));
}, C0 = function(e, n) {
  return {
    name: e,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(i, r, a) {
      a._onInit = function(s) {
        var l, d;
        if (tt(r) && (l = {}, At(r, function(c) {
          return l[c] = 1;
        }), r = l), n) {
          l = {};
          for (d in r)
            l[d] = n(r[d]);
          r = l;
        }
        eH(s, r);
      };
    }
  };
}, Pt = ki.registerPlugin({
  name: "attr",
  init: function(e, n, o, i, r) {
    var a, s, l;
    this.tween = o;
    for (a in n)
      l = e.getAttribute(a) || "", s = this.add(e, "setAttribute", (l || 0) + "", n[a], i, r, 0, 0, a), s.op = a, s.b = l, this._props.push(a);
  },
  render: function(e, n) {
    for (var o = n._pt; o; )
      dt ? o.set(o.t, o.p, o.b, o) : o.r(e, o.d), o = o._next;
  }
}, {
  name: "endArray",
  init: function(e, n) {
    for (var o = n.length; o--; )
      this.add(e, o, e[o] || 0, n[o], 0, 0, 0, 0, 0, 1);
  }
}, C0("roundProps", Y0), C0("modifiers"), C0("snap", vc)) || ki;
ze.version = ft.version = Pt.version = "3.12.5";
nc = 1;
Qr() && r1();
ve.Power0;
ve.Power1;
ve.Power2;
ve.Power3;
ve.Power4;
ve.Linear;
ve.Quad;
ve.Cubic;
ve.Quart;
ve.Quint;
ve.Strong;
ve.Elastic;
ve.Back;
ve.SteppedEase;
ve.Bounce;
ve.Sine;
ve.Expo;
ve.Circ;
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var ds, Un, Xo, ca, _o, cs, ua, tH = function() {
  return typeof window < "u";
}, Ln = {}, po = 180 / Math.PI, Ko = Math.PI / 180, Ro = Math.atan2, us = 1e8, ha = /([A-Z])/g, nH = /(left|right|width|margin|padding|x)/i, oH = /[\s,\(]\S/, hn = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, q0 = function(e, n) {
  return n.set(n.t, n.p, Math.round((n.s + n.c * e) * 1e4) / 1e4 + n.u, n);
}, iH = function(e, n) {
  return n.set(n.t, n.p, e === 1 ? n.e : Math.round((n.s + n.c * e) * 1e4) / 1e4 + n.u, n);
}, rH = function(e, n) {
  return n.set(n.t, n.p, e ? Math.round((n.s + n.c * e) * 1e4) / 1e4 + n.u : n.b, n);
}, aH = function(e, n) {
  var o = n.s + n.c * e;
  n.set(n.t, n.p, ~~(o + (o < 0 ? -0.5 : 0.5)) + n.u, n);
}, Zc = function(e, n) {
  return n.set(n.t, n.p, e ? n.e : n.b, n);
}, Bc = function(e, n) {
  return n.set(n.t, n.p, e !== 1 ? n.b : n.e, n);
}, sH = function(e, n, o) {
  return e.style[n] = o;
}, lH = function(e, n, o) {
  return e.style.setProperty(n, o);
}, dH = function(e, n, o) {
  return e._gsap[n] = o;
}, cH = function(e, n, o) {
  return e._gsap.scaleX = e._gsap.scaleY = o;
}, uH = function(e, n, o, i, r) {
  var a = e._gsap;
  a.scaleX = a.scaleY = o, a.renderTransform(r, a);
}, hH = function(e, n, o, i, r) {
  var a = e._gsap;
  a[n] = o, a.renderTransform(r, a);
}, Oe = "transform", Et = Oe + "Origin", fH = function t(e, n) {
  var o = this, i = this.target, r = i.style, a = i._gsap;
  if (e in Ln && r) {
    if (this.tfm = this.tfm || {}, e !== "transform")
      e = hn[e] || e, ~e.indexOf(",") ? e.split(",").forEach(function(s) {
        return o.tfm[s] = Sn(i, s);
      }) : this.tfm[e] = a.x ? a[e] : Sn(i, e), e === Et && (this.tfm.zOrigin = a.zOrigin);
    else
      return hn.transform.split(",").forEach(function(s) {
        return t.call(o, s, n);
      });
    if (this.props.indexOf(Oe) >= 0)
      return;
    a.svg && (this.svgo = i.getAttribute("data-svg-origin"), this.props.push(Et, n, "")), e = Oe;
  }
  (r || n) && this.props.push(e, n, r[e]);
}, Vc = function(e) {
  e.translate && (e.removeProperty("translate"), e.removeProperty("scale"), e.removeProperty("rotate"));
}, mH = function() {
  var e = this.props, n = this.target, o = n.style, i = n._gsap, r, a;
  for (r = 0; r < e.length; r += 3)
    e[r + 1] ? n[e[r]] = e[r + 2] : e[r + 2] ? o[e[r]] = e[r + 2] : o.removeProperty(e[r].substr(0, 2) === "--" ? e[r] : e[r].replace(ha, "-$1").toLowerCase());
  if (this.tfm) {
    for (a in this.tfm)
      i[a] = this.tfm[a];
    i.svg && (i.renderTransform(), n.setAttribute("data-svg-origin", this.svgo || "")), r = ua(), (!r || !r.isStart) && !o[Oe] && (Vc(o), i.zOrigin && o[Et] && (o[Et] += " " + i.zOrigin + "px", i.zOrigin = 0, i.renderTransform()), i.uncache = 1);
  }
}, Fc = function(e, n) {
  var o = {
    target: e,
    props: [],
    revert: mH,
    save: fH
  };
  return e._gsap || Pt.core.getCache(e), n && n.split(",").forEach(function(i) {
    return o.save(i);
  }), o;
}, Hc, J0 = function(e, n) {
  var o = Un.createElementNS ? Un.createElementNS((n || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : Un.createElement(e);
  return o && o.style ? o : Un.createElement(e);
}, mn = function t(e, n, o) {
  var i = getComputedStyle(e);
  return i[n] || i.getPropertyValue(n.replace(ha, "-$1").toLowerCase()) || i.getPropertyValue(n) || !o && t(e, a1(n) || n, 1) || "";
}, hs = "O,Moz,ms,Ms,Webkit".split(","), a1 = function(e, n, o) {
  var i = n || _o, r = i.style, a = 5;
  if (e in r && !o)
    return e;
  for (e = e.charAt(0).toUpperCase() + e.substr(1); a-- && !(hs[a] + e in r); )
    ;
  return a < 0 ? null : (a === 3 ? "ms" : a >= 0 ? hs[a] : "") + e;
}, Q0 = function() {
  tH() && window.document && (ds = window, Un = ds.document, Xo = Un.documentElement, _o = J0("div") || {
    style: {}
  }, J0("div"), Oe = a1(Oe), Et = Oe + "Origin", _o.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", Hc = !!a1("perspective"), ua = Pt.core.reverting, ca = 1);
}, b0 = function t(e) {
  var n = J0("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), o = this.parentNode, i = this.nextSibling, r = this.style.cssText, a;
  if (Xo.appendChild(n), n.appendChild(this), this.style.display = "block", e)
    try {
      a = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = t;
    } catch {
    }
  else this._gsapBBox && (a = this._gsapBBox());
  return o && (i ? o.insertBefore(this, i) : o.appendChild(this)), Xo.removeChild(n), this.style.cssText = r, a;
}, fs = function(e, n) {
  for (var o = n.length; o--; )
    if (e.hasAttribute(n[o]))
      return e.getAttribute(n[o]);
}, Uc = function(e) {
  var n;
  try {
    n = e.getBBox();
  } catch {
    n = b0.call(e, !0);
  }
  return n && (n.width || n.height) || e.getBBox === b0 || (n = b0.call(e, !0)), n && !n.width && !n.x && !n.y ? {
    x: +fs(e, ["x", "cx", "x1"]) || 0,
    y: +fs(e, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : n;
}, zc = function(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && Uc(e));
}, bo = function(e, n) {
  if (n) {
    var o = e.style, i;
    n in Ln && n !== Et && (n = Oe), o.removeProperty ? (i = n.substr(0, 2), (i === "ms" || n.substr(0, 6) === "webkit") && (n = "-" + n), o.removeProperty(i === "--" ? n : n.replace(ha, "-$1").toLowerCase())) : o.removeAttribute(n);
  }
}, zn = function(e, n, o, i, r, a) {
  var s = new kt(e._pt, n, o, 0, 1, a ? Bc : Zc);
  return e._pt = s, s.b = i, s.e = r, e._props.push(o), s;
}, ms = {
  deg: 1,
  rad: 1,
  turn: 1
}, pH = {
  grid: 1,
  flex: 1
}, qn = function t(e, n, o, i) {
  var r = parseFloat(o) || 0, a = (o + "").trim().substr((r + "").length) || "px", s = _o.style, l = nH.test(n), d = e.tagName.toLowerCase() === "svg", c = (d ? "client" : "offset") + (l ? "Width" : "Height"), u = 100, f = i === "px", m = i === "%", v, _, w, $;
  if (i === a || !r || ms[i] || ms[a])
    return r;
  if (a !== "px" && !f && (r = t(e, n, o, "px")), $ = e.getCTM && zc(e), (m || a === "%") && (Ln[n] || ~n.indexOf("adius")))
    return v = $ ? e.getBBox()[l ? "width" : "height"] : e[c], Fe(m ? r / v * u : r / 100 * v);
  if (s[l ? "width" : "height"] = u + (f ? a : i), _ = ~n.indexOf("adius") || i === "em" && e.appendChild && !d ? e : e.parentNode, $ && (_ = (e.ownerSVGElement || {}).parentNode), (!_ || _ === Un || !_.appendChild) && (_ = Un.body), w = _._gsap, w && m && w.width && l && w.time === Nt.time && !w.uncache)
    return Fe(r / w.width * u);
  if (m && (n === "height" || n === "width")) {
    var y = e.style[n];
    e.style[n] = u + i, v = e[c], y ? e.style[n] = y : bo(e, n);
  } else
    (m || a === "%") && !pH[mn(_, "display")] && (s.position = mn(e, "position")), _ === e && (s.position = "static"), _.appendChild(_o), v = _o[c], _.removeChild(_o), s.position = "absolute";
  return l && m && (w = go(_), w.time = Nt.time, w.width = _[c]), Fe(f ? v * r / u : v && r ? u / v * r : 0);
}, Sn = function(e, n, o, i) {
  var r;
  return ca || Q0(), n in hn && n !== "transform" && (n = hn[n], ~n.indexOf(",") && (n = n.split(",")[0])), Ln[n] && n !== "transform" ? (r = H1(e, i), r = n !== "transformOrigin" ? r[n] : r.svg ? r.origin : Pi(mn(e, Et)) + " " + r.zOrigin + "px") : (r = e.style[n], (!r || r === "auto" || i || ~(r + "").indexOf("calc(")) && (r = Ei[n] && Ei[n](e, n, o) || mn(e, n) || ac(e, n) || (n === "opacity" ? 1 : 0))), o && !~(r + "").trim().indexOf(" ") ? qn(e, n, r, o) + o : r;
}, _H = function(e, n, o, i) {
  if (!o || o === "none") {
    var r = a1(n, e, 1), a = r && mn(e, r, 1);
    a && a !== o ? (n = r, o = a) : n === "borderColor" && (o = mn(e, "borderTopColor"));
  }
  var s = new kt(this._pt, e.style, n, 0, 1, Dc), l = 0, d = 0, c, u, f, m, v, _, w, $, y, M, S, x;
  if (s.b = o, s.e = i, o += "", i += "", i === "auto" && (_ = e.style[n], e.style[n] = i, i = mn(e, n) || i, _ ? e.style[n] = _ : bo(e, n)), c = [o, i], xc(c), o = c[0], i = c[1], f = o.match(Uo) || [], x = i.match(Uo) || [], x.length) {
    for (; u = Uo.exec(i); )
      w = u[0], y = i.substring(l, u.index), v ? v = (v + 1) % 5 : (y.substr(-5) === "rgba(" || y.substr(-5) === "hsla(") && (v = 1), w !== (_ = f[d++] || "") && (m = parseFloat(_) || 0, S = _.substr((m + "").length), w.charAt(1) === "=" && (w = Yo(m, w) + S), $ = parseFloat(w), M = w.substr(($ + "").length), l = Uo.lastIndex - M.length, M || (M = M || Vt.units[n] || S, l === i.length && (i += M, s.e += M)), S !== M && (m = qn(e, n, _, M) || 0), s._pt = {
        _next: s._pt,
        p: y || d === 1 ? y : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: m,
        c: $ - m,
        m: v && v < 4 || n === "zIndex" ? Math.round : 0
      });
    s.c = l < i.length ? i.substring(l, i.length) : "";
  } else
    s.r = n === "display" && i === "none" ? Bc : Zc;
  return ec.test(i) && (s.e = 0), this._pt = s, s;
}, ps = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, vH = function(e) {
  var n = e.split(" "), o = n[0], i = n[1] || "50%";
  return (o === "top" || o === "bottom" || i === "left" || i === "right") && (e = o, o = i, i = e), n[0] = ps[o] || o, n[1] = ps[i] || i, n.join(" ");
}, gH = function(e, n) {
  if (n.tween && n.tween._time === n.tween._dur) {
    var o = n.t, i = o.style, r = n.u, a = o._gsap, s, l, d;
    if (r === "all" || r === !0)
      i.cssText = "", l = 1;
    else
      for (r = r.split(","), d = r.length; --d > -1; )
        s = r[d], Ln[s] && (l = 1, s = s === "transformOrigin" ? Et : Oe), bo(o, s);
    l && (bo(o, Oe), a && (a.svg && o.removeAttribute("transform"), H1(o, 1), a.uncache = 1, Vc(i)));
  }
}, Ei = {
  clearProps: function(e, n, o, i, r) {
    if (r.data !== "isFromStart") {
      var a = e._pt = new kt(e._pt, n, o, 0, 0, gH);
      return a.u = i, a.pr = -10, a.tween = r, e._props.push(o), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, F1 = [1, 0, 0, 1, 0, 0], Wc = {}, jc = function(e) {
  return e === "matrix(1, 0, 0, 1, 0, 0)" || e === "none" || !e;
}, _s = function(e) {
  var n = mn(e, Oe);
  return jc(n) ? F1 : n.substr(7).match(Qd).map(Fe);
}, fa = function(e, n) {
  var o = e._gsap || go(e), i = e.style, r = _s(e), a, s, l, d;
  return o.svg && e.getAttribute("transform") ? (l = e.transform.baseVal.consolidate().matrix, r = [l.a, l.b, l.c, l.d, l.e, l.f], r.join(",") === "1,0,0,1,0,0" ? F1 : r) : (r === F1 && !e.offsetParent && e !== Xo && !o.svg && (l = i.display, i.display = "block", a = e.parentNode, (!a || !e.offsetParent) && (d = 1, s = e.nextElementSibling, Xo.appendChild(e)), r = _s(e), l ? i.display = l : bo(e, "display"), d && (s ? a.insertBefore(e, s) : a ? a.appendChild(e) : Xo.removeChild(e))), n && r.length > 6 ? [r[0], r[1], r[4], r[5], r[12], r[13]] : r);
}, er = function(e, n, o, i, r, a) {
  var s = e._gsap, l = r || fa(e, !0), d = s.xOrigin || 0, c = s.yOrigin || 0, u = s.xOffset || 0, f = s.yOffset || 0, m = l[0], v = l[1], _ = l[2], w = l[3], $ = l[4], y = l[5], M = n.split(" "), S = parseFloat(M[0]) || 0, x = parseFloat(M[1]) || 0, b, C, E, A;
  o ? l !== F1 && (C = m * w - v * _) && (E = S * (w / C) + x * (-_ / C) + (_ * y - w * $) / C, A = S * (-v / C) + x * (m / C) - (m * y - v * $) / C, S = E, x = A) : (b = Uc(e), S = b.x + (~M[0].indexOf("%") ? S / 100 * b.width : S), x = b.y + (~(M[1] || M[0]).indexOf("%") ? x / 100 * b.height : x)), i || i !== !1 && s.smooth ? ($ = S - d, y = x - c, s.xOffset = u + ($ * m + y * _) - $, s.yOffset = f + ($ * v + y * w) - y) : s.xOffset = s.yOffset = 0, s.xOrigin = S, s.yOrigin = x, s.smooth = !!i, s.origin = n, s.originIsAbsolute = !!o, e.style[Et] = "0px 0px", a && (zn(a, s, "xOrigin", d, S), zn(a, s, "yOrigin", c, x), zn(a, s, "xOffset", u, s.xOffset), zn(a, s, "yOffset", f, s.yOffset)), e.setAttribute("data-svg-origin", S + " " + x);
}, H1 = function(e, n) {
  var o = e._gsap || new kc(e);
  if ("x" in o && !n && !o.uncache)
    return o;
  var i = e.style, r = o.scaleX < 0, a = "px", s = "deg", l = getComputedStyle(e), d = mn(e, Et) || "0", c, u, f, m, v, _, w, $, y, M, S, x, b, C, E, A, T, k, L, V, O, D, P, F, N, H, W, te, ie, se, fe, $e;
  return c = u = f = _ = w = $ = y = M = S = 0, m = v = 1, o.svg = !!(e.getCTM && zc(e)), l.translate && ((l.translate !== "none" || l.scale !== "none" || l.rotate !== "none") && (i[Oe] = (l.translate !== "none" ? "translate3d(" + (l.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (l.rotate !== "none" ? "rotate(" + l.rotate + ") " : "") + (l.scale !== "none" ? "scale(" + l.scale.split(" ").join(",") + ") " : "") + (l[Oe] !== "none" ? l[Oe] : "")), i.scale = i.rotate = i.translate = "none"), C = fa(e, o.svg), o.svg && (o.uncache ? (N = e.getBBox(), d = o.xOrigin - N.x + "px " + (o.yOrigin - N.y) + "px", F = "") : F = !n && e.getAttribute("data-svg-origin"), er(e, F || d, !!F || o.originIsAbsolute, o.smooth !== !1, C)), x = o.xOrigin || 0, b = o.yOrigin || 0, C !== F1 && (k = C[0], L = C[1], V = C[2], O = C[3], c = D = C[4], u = P = C[5], C.length === 6 ? (m = Math.sqrt(k * k + L * L), v = Math.sqrt(O * O + V * V), _ = k || L ? Ro(L, k) * po : 0, y = V || O ? Ro(V, O) * po + _ : 0, y && (v *= Math.abs(Math.cos(y * Ko))), o.svg && (c -= x - (x * k + b * V), u -= b - (x * L + b * O))) : ($e = C[6], se = C[7], W = C[8], te = C[9], ie = C[10], fe = C[11], c = C[12], u = C[13], f = C[14], E = Ro($e, ie), w = E * po, E && (A = Math.cos(-E), T = Math.sin(-E), F = D * A + W * T, N = P * A + te * T, H = $e * A + ie * T, W = D * -T + W * A, te = P * -T + te * A, ie = $e * -T + ie * A, fe = se * -T + fe * A, D = F, P = N, $e = H), E = Ro(-V, ie), $ = E * po, E && (A = Math.cos(-E), T = Math.sin(-E), F = k * A - W * T, N = L * A - te * T, H = V * A - ie * T, fe = O * T + fe * A, k = F, L = N, V = H), E = Ro(L, k), _ = E * po, E && (A = Math.cos(E), T = Math.sin(E), F = k * A + L * T, N = D * A + P * T, L = L * A - k * T, P = P * A - D * T, k = F, D = N), w && Math.abs(w) + Math.abs(_) > 359.9 && (w = _ = 0, $ = 180 - $), m = Fe(Math.sqrt(k * k + L * L + V * V)), v = Fe(Math.sqrt(P * P + $e * $e)), E = Ro(D, P), y = Math.abs(E) > 2e-4 ? E * po : 0, S = fe ? 1 / (fe < 0 ? -fe : fe) : 0), o.svg && (F = e.getAttribute("transform"), o.forceCSS = e.setAttribute("transform", "") || !jc(mn(e, Oe)), F && e.setAttribute("transform", F))), Math.abs(y) > 90 && Math.abs(y) < 270 && (r ? (m *= -1, y += _ <= 0 ? 180 : -180, _ += _ <= 0 ? 180 : -180) : (v *= -1, y += y <= 0 ? 180 : -180)), n = n || o.uncache, o.x = c - ((o.xPercent = c && (!n && o.xPercent || (Math.round(e.offsetWidth / 2) === Math.round(-c) ? -50 : 0))) ? e.offsetWidth * o.xPercent / 100 : 0) + a, o.y = u - ((o.yPercent = u && (!n && o.yPercent || (Math.round(e.offsetHeight / 2) === Math.round(-u) ? -50 : 0))) ? e.offsetHeight * o.yPercent / 100 : 0) + a, o.z = f + a, o.scaleX = Fe(m), o.scaleY = Fe(v), o.rotation = Fe(_) + s, o.rotationX = Fe(w) + s, o.rotationY = Fe($) + s, o.skewX = y + s, o.skewY = M + s, o.transformPerspective = S + a, (o.zOrigin = parseFloat(d.split(" ")[2]) || !n && o.zOrigin || 0) && (i[Et] = Pi(d)), o.xOffset = o.yOffset = 0, o.force3D = Vt.force3D, o.renderTransform = o.svg ? wH : Hc ? Gc : $H, o.uncache = 0, o;
}, Pi = function(e) {
  return (e = e.split(" "))[0] + " " + e[1];
}, x0 = function(e, n, o) {
  var i = lt(n);
  return Fe(parseFloat(n) + parseFloat(qn(e, "x", o + "px", i))) + i;
}, $H = function(e, n) {
  n.z = "0px", n.rotationY = n.rotationX = "0deg", n.force3D = 0, Gc(e, n);
}, lo = "0deg", g1 = "0px", co = ") ", Gc = function(e, n) {
  var o = n || this, i = o.xPercent, r = o.yPercent, a = o.x, s = o.y, l = o.z, d = o.rotation, c = o.rotationY, u = o.rotationX, f = o.skewX, m = o.skewY, v = o.scaleX, _ = o.scaleY, w = o.transformPerspective, $ = o.force3D, y = o.target, M = o.zOrigin, S = "", x = $ === "auto" && e && e !== 1 || $ === !0;
  if (M && (u !== lo || c !== lo)) {
    var b = parseFloat(c) * Ko, C = Math.sin(b), E = Math.cos(b), A;
    b = parseFloat(u) * Ko, A = Math.cos(b), a = x0(y, a, C * A * -M), s = x0(y, s, -Math.sin(b) * -M), l = x0(y, l, E * A * -M + M);
  }
  w !== g1 && (S += "perspective(" + w + co), (i || r) && (S += "translate(" + i + "%, " + r + "%) "), (x || a !== g1 || s !== g1 || l !== g1) && (S += l !== g1 || x ? "translate3d(" + a + ", " + s + ", " + l + ") " : "translate(" + a + ", " + s + co), d !== lo && (S += "rotate(" + d + co), c !== lo && (S += "rotateY(" + c + co), u !== lo && (S += "rotateX(" + u + co), (f !== lo || m !== lo) && (S += "skew(" + f + ", " + m + co), (v !== 1 || _ !== 1) && (S += "scale(" + v + ", " + _ + co), y.style[Oe] = S || "translate(0, 0)";
}, wH = function(e, n) {
  var o = n || this, i = o.xPercent, r = o.yPercent, a = o.x, s = o.y, l = o.rotation, d = o.skewX, c = o.skewY, u = o.scaleX, f = o.scaleY, m = o.target, v = o.xOrigin, _ = o.yOrigin, w = o.xOffset, $ = o.yOffset, y = o.forceCSS, M = parseFloat(a), S = parseFloat(s), x, b, C, E, A;
  l = parseFloat(l), d = parseFloat(d), c = parseFloat(c), c && (c = parseFloat(c), d += c, l += c), l || d ? (l *= Ko, d *= Ko, x = Math.cos(l) * u, b = Math.sin(l) * u, C = Math.sin(l - d) * -f, E = Math.cos(l - d) * f, d && (c *= Ko, A = Math.tan(d - c), A = Math.sqrt(1 + A * A), C *= A, E *= A, c && (A = Math.tan(c), A = Math.sqrt(1 + A * A), x *= A, b *= A)), x = Fe(x), b = Fe(b), C = Fe(C), E = Fe(E)) : (x = u, E = f, b = C = 0), (M && !~(a + "").indexOf("px") || S && !~(s + "").indexOf("px")) && (M = qn(m, "x", a, "px"), S = qn(m, "y", s, "px")), (v || _ || w || $) && (M = Fe(M + v - (v * x + _ * C) + w), S = Fe(S + _ - (v * b + _ * E) + $)), (i || r) && (A = m.getBBox(), M = Fe(M + i / 100 * A.width), S = Fe(S + r / 100 * A.height)), A = "matrix(" + x + "," + b + "," + C + "," + E + "," + M + "," + S + ")", m.setAttribute("transform", A), y && (m.style[Oe] = A);
}, yH = function(e, n, o, i, r) {
  var a = 360, s = tt(r), l = parseFloat(r) * (s && ~r.indexOf("rad") ? po : 1), d = l - i, c = i + d + "deg", u, f;
  return s && (u = r.split("_")[1], u === "short" && (d %= a, d !== d % (a / 2) && (d += d < 0 ? a : -a)), u === "cw" && d < 0 ? d = (d + a * us) % a - ~~(d / a) * a : u === "ccw" && d > 0 && (d = (d - a * us) % a - ~~(d / a) * a)), e._pt = f = new kt(e._pt, n, o, i, d, iH), f.e = c, f.u = "deg", e._props.push(o), f;
}, vs = function(e, n) {
  for (var o in n)
    e[o] = n[o];
  return e;
}, MH = function(e, n, o) {
  var i = vs({}, o._gsap), r = "perspective,force3D,transformOrigin,svgOrigin", a = o.style, s, l, d, c, u, f, m, v;
  i.svg ? (d = o.getAttribute("transform"), o.setAttribute("transform", ""), a[Oe] = n, s = H1(o, 1), bo(o, Oe), o.setAttribute("transform", d)) : (d = getComputedStyle(o)[Oe], a[Oe] = n, s = H1(o, 1), a[Oe] = d);
  for (l in Ln)
    d = i[l], c = s[l], d !== c && r.indexOf(l) < 0 && (m = lt(d), v = lt(c), u = m !== v ? qn(o, l, d, v) : parseFloat(d), f = parseFloat(c), e._pt = new kt(e._pt, s, l, u, f - u, q0), e._pt.u = v || 0, e._props.push(l));
  vs(s, i);
};
At("padding,margin,Width,Radius", function(t, e) {
  var n = "Top", o = "Right", i = "Bottom", r = "Left", a = (e < 3 ? [n, o, i, r] : [n + r, n + o, i + o, i + r]).map(function(s) {
    return e < 2 ? t + s : "border" + s + t;
  });
  Ei[e > 1 ? "border" + t : t] = function(s, l, d, c, u) {
    var f, m;
    if (arguments.length < 4)
      return f = a.map(function(v) {
        return Sn(s, v, d);
      }), m = f.join(" "), m.split(f[0]).length === 5 ? f[0] : m;
    f = (c + "").split(" "), m = {}, a.forEach(function(v, _) {
      return m[v] = f[_] = f[_] || f[(_ - 1) / 2 | 0];
    }), s.init(l, m, u);
  };
});
var Yc = {
  name: "css",
  register: Q0,
  targetTest: function(e) {
    return e.style && e.nodeType;
  },
  init: function(e, n, o, i, r) {
    var a = this._props, s = e.style, l = o.vars.startAt, d, c, u, f, m, v, _, w, $, y, M, S, x, b, C, E;
    ca || Q0(), this.styles = this.styles || Fc(e), E = this.styles.props, this.tween = o;
    for (_ in n)
      if (_ !== "autoRound" && (c = n[_], !(Lt[_] && Ec(_, n, o, i, e, r)))) {
        if (m = typeof c, v = Ei[_], m === "function" && (c = c.call(o, i, e, r), m = typeof c), m === "string" && ~c.indexOf("random(") && (c = Z1(c)), v)
          v(this, e, _, c, o) && (C = 1);
        else if (_.substr(0, 2) === "--")
          d = (getComputedStyle(e).getPropertyValue(_) + "").trim(), c += "", Xn.lastIndex = 0, Xn.test(d) || (w = lt(d), $ = lt(c)), $ ? w !== $ && (d = qn(e, _, d, $) + $) : w && (c += w), this.add(s, "setProperty", d, c, i, r, 0, 0, _), a.push(_), E.push(_, 0, s[_]);
        else if (m !== "undefined") {
          if (l && _ in l ? (d = typeof l[_] == "function" ? l[_].call(o, i, e, r) : l[_], tt(d) && ~d.indexOf("random(") && (d = Z1(d)), lt(d + "") || d === "auto" || (d += Vt.units[_] || lt(Sn(e, _)) || ""), (d + "").charAt(1) === "=" && (d = Sn(e, _))) : d = Sn(e, _), f = parseFloat(d), y = m === "string" && c.charAt(1) === "=" && c.substr(0, 2), y && (c = c.substr(2)), u = parseFloat(c), _ in hn && (_ === "autoAlpha" && (f === 1 && Sn(e, "visibility") === "hidden" && u && (f = 0), E.push("visibility", 0, s.visibility), zn(this, s, "visibility", f ? "inherit" : "hidden", u ? "inherit" : "hidden", !u)), _ !== "scale" && _ !== "transform" && (_ = hn[_], ~_.indexOf(",") && (_ = _.split(",")[0]))), M = _ in Ln, M) {
            if (this.styles.save(_), S || (x = e._gsap, x.renderTransform && !n.parseTransform || H1(e, n.parseTransform), b = n.smoothOrigin !== !1 && x.smooth, S = this._pt = new kt(this._pt, s, Oe, 0, 1, x.renderTransform, x, 0, -1), S.dep = 1), _ === "scale")
              this._pt = new kt(this._pt, x, "scaleY", x.scaleY, (y ? Yo(x.scaleY, y + u) : u) - x.scaleY || 0, q0), this._pt.u = 0, a.push("scaleY", _), _ += "X";
            else if (_ === "transformOrigin") {
              E.push(Et, 0, s[Et]), c = vH(c), x.svg ? er(e, c, 0, b, 0, this) : ($ = parseFloat(c.split(" ")[2]) || 0, $ !== x.zOrigin && zn(this, x, "zOrigin", x.zOrigin, $), zn(this, s, _, Pi(d), Pi(c)));
              continue;
            } else if (_ === "svgOrigin") {
              er(e, c, 1, b, 0, this);
              continue;
            } else if (_ in Wc) {
              yH(this, x, _, f, y ? Yo(f, y + c) : c);
              continue;
            } else if (_ === "smoothOrigin") {
              zn(this, x, "smooth", x.smooth, c);
              continue;
            } else if (_ === "force3D") {
              x[_] = c;
              continue;
            } else if (_ === "transform") {
              MH(this, c, e);
              continue;
            }
          } else _ in s || (_ = a1(_) || _);
          if (M || (u || u === 0) && (f || f === 0) && !oH.test(c) && _ in s)
            w = (d + "").substr((f + "").length), u || (u = 0), $ = lt(c) || (_ in Vt.units ? Vt.units[_] : w), w !== $ && (f = qn(e, _, d, $)), this._pt = new kt(this._pt, M ? x : s, _, f, (y ? Yo(f, y + u) : u) - f, !M && ($ === "px" || _ === "zIndex") && n.autoRound !== !1 ? aH : q0), this._pt.u = $ || 0, w !== $ && $ !== "%" && (this._pt.b = d, this._pt.r = rH);
          else if (_ in s)
            _H.call(this, e, _, d, y ? y + c : c);
          else if (_ in e)
            this.add(e, _, d || e[_], y ? y + c : c, i, r);
          else if (_ !== "parseTransform") {
            ta(_, c);
            continue;
          }
          M || (_ in s ? E.push(_, 0, s[_]) : E.push(_, 1, d || e[_])), a.push(_);
        }
      }
    C && Nc(this);
  },
  render: function(e, n) {
    if (n.tween._time || !ua())
      for (var o = n._pt; o; )
        o.r(e, o.d), o = o._next;
    else
      n.styles.revert();
  },
  get: Sn,
  aliases: hn,
  getSetter: function(e, n, o) {
    var i = hn[n];
    return i && i.indexOf(",") < 0 && (n = i), n in Ln && n !== Et && (e._gsap.x || Sn(e, "x")) ? o && cs === o ? n === "scale" ? cH : dH : (cs = o || {}) && (n === "scale" ? uH : hH) : e.style && !Jr(e.style[n]) ? sH : ~n.indexOf("-") ? lH : la(e, n);
  },
  core: {
    _removeProperty: bo,
    _getMatrix: fa
  }
};
Pt.utils.checkPrefix = a1;
Pt.core.getStyleSaver = Fc;
(function(t, e, n, o) {
  var i = At(t + "," + e + "," + n, function(r) {
    Ln[r] = 1;
  });
  At(e, function(r) {
    Vt.units[r] = "deg", Wc[r] = 1;
  }), hn[i[13]] = t + "," + e, At(o, function(r) {
    var a = r.split(":");
    hn[a[1]] = i[a[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
At("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(t) {
  Vt.units[t] = "px";
});
Pt.registerPlugin(Yc);
var tr = Pt.registerPlugin(Yc) || Pt;
tr.core.Tween;
const CH = /* @__PURE__ */ oe({
  name: "PButtonFloatingGroup",
  __name: "PButtonFloatingGroup",
  props: {
    icon: { default: yd },
    placement: { default: "right" },
    position: { default: "fixed" },
    buttons: {},
    width: { default: 126 }
  },
  emits: ["update:opened"],
  setup(t, { emit: e }) {
    Nn((f) => ({
      "26e4cf69": f.position
    }));
    const n = t, o = e, i = cd(), r = U(!1), a = z(() => r.value ? jr : n.icon), s = () => {
      r.value = !r.value, o("update:opened", r.value);
    }, l = () => {
      r.value = !1, o("update:opened", !1);
    }, d = (f) => {
      f(), l();
    }, c = (f, m) => {
      const v = f.dataset.index || 0, { height: _ } = f.getBoundingClientRect(), w = v * (_ + 12) * -1, $ = i.text || n.buttons.some((y) => !!y.text);
      tr.to(f, 0.2, {
        opacity: 1,
        x: n.placement === "center" ? "50%" : 0,
        y: w,
        onComplete: m,
        width: $ ? n.width : "auto"
      });
    }, u = (f, m) => {
      tr.to(f, 0.2, {
        opacity: 0,
        onComplete: m,
        y: 0,
        width: 44
      });
    };
    return (f, m) => {
      const v = Xd;
      return p(), g("div", {
        ref: "buttonsContainer",
        class: ee(["button-floating-group", f.placement, { opened: r.value }])
      }, [
        q(Xe, { name: "fade" }, {
          default: G(() => [
            r.value ? (p(), g("div", {
              key: 0,
              class: "overlay",
              onClick: l
            })) : X("", !0)
          ]),
          _: 1
        }),
        f.buttons.length ? (p(), J(Br, {
          key: 0,
          tag: "div",
          class: "float-action",
          css: !1,
          onEnter: c,
          onLeave: u
        }, {
          default: G(() => [
            (p(!0), g(_e, null, Ie(f.buttons, (_, w) => (p(), g(_e, null, [
              r.value ? (p(), J(v, {
                key: w,
                "data-index": w + 1,
                class: "button",
                onClick: ($) => d(_.click)
              }, Pn({
                default: G(() => [
                  Y(f.$slots, "default", {
                    icon: _.icon
                  }, () => [
                    (p(), J(Ce(_.icon)))
                  ], !0)
                ]),
                _: 2
              }, [
                _.text ? {
                  name: "text",
                  fn: G(() => [
                    Y(f.$slots, "text", {
                      text: _.text
                    }, () => [
                      xe(ne(_.text), 1)
                    ], !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["data-index", "onClick"])) : X("", !0)
            ], 64))), 256))
          ]),
          _: 3
        })) : X("", !0),
        q(v, {
          id: "mainButton",
          class: "toggle-button",
          position: "initial",
          color: "primary",
          onClick: s
        }, {
          default: G(() => [
            (p(), J(Ce(a.value), { class: "icon" }))
          ]),
          _: 1
        })
      ], 2);
    };
  }
}), bH = /* @__PURE__ */ ae(CH, [["__scopeId", "data-v-e6d9f72e"]]), xH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, SH = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M18.19 4.776a1 1 0 0 1 .034 1.414L9.03 15.844a2 2 0 0 1-3.033-.16L1.707 10.11a1 1 0 1 1 1.586-1.22l4.288 5.575 9.195-9.655a1 1 0 0 1 1.414-.034Z",
  "clip-rule": "evenodd"
}, null, -1), IH = [
  SH
];
function AH(t, e) {
  return p(), g("svg", xH, [...IH]);
}
const kH = I({ name: "icon-check-md", render: AH }), EH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, PH = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M5.27 4.525 8.843 8 5.27 11.475a.88.88 0 0 0-.269.632.88.88 0 0 0 .27.631.933.933 0 0 0 .65.262.933.933 0 0 0 .65-.262l4.116-4a1.022 1.022 0 0 0 0-1.475L6.569 3.262A.933.933 0 0 0 5.92 3a.933.933 0 0 0-.65.262.88.88 0 0 0-.269.631c0 .237.097.465.27.632Z"
}, null, -1), TH = [
  PH
];
function OH(t, e) {
  return p(), g("svg", EH, [...TH]);
}
const ma = I({ name: "icon-arrow-right-sm", render: OH }), LH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, DH = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M10.73 4.525 7.157 8l3.575 3.475a.88.88 0 0 1 .269.632.88.88 0 0 1-.27.631.933.933 0 0 1-.65.262.933.933 0 0 1-.65-.262l-4.116-4a1.022 1.022 0 0 1 0-1.475l4.117-4.001A.933.933 0 0 1 10.08 3c.244 0 .477.094.65.262a.88.88 0 0 1 .269.631.88.88 0 0 1-.27.632Z"
}, null, -1), NH = [
  DH
];
function RH(t, e) {
  return p(), g("svg", LH, [...NH]);
}
const pa = I({ name: "icon-arrow-left-sm", render: RH });
var u1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ii(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Xc = { exports: {} };
(function(t, e) {
  (function(n, o) {
    t.exports = o();
  })(u1, function() {
    var n = 1e3, o = 6e4, i = 36e5, r = "millisecond", a = "second", s = "minute", l = "hour", d = "day", c = "week", u = "month", f = "quarter", m = "year", v = "date", _ = "Invalid Date", w = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, $ = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(O) {
      var D = ["th", "st", "nd", "rd"], P = O % 100;
      return "[" + O + (D[(P - 20) % 10] || D[P] || D[0]) + "]";
    } }, M = function(O, D, P) {
      var F = String(O);
      return !F || F.length >= D ? O : "" + Array(D + 1 - F.length).join(P) + O;
    }, S = { s: M, z: function(O) {
      var D = -O.utcOffset(), P = Math.abs(D), F = Math.floor(P / 60), N = P % 60;
      return (D <= 0 ? "+" : "-") + M(F, 2, "0") + ":" + M(N, 2, "0");
    }, m: function O(D, P) {
      if (D.date() < P.date()) return -O(P, D);
      var F = 12 * (P.year() - D.year()) + (P.month() - D.month()), N = D.clone().add(F, u), H = P - N < 0, W = D.clone().add(F + (H ? -1 : 1), u);
      return +(-(F + (P - N) / (H ? N - W : W - N)) || 0);
    }, a: function(O) {
      return O < 0 ? Math.ceil(O) || 0 : Math.floor(O);
    }, p: function(O) {
      return { M: u, y: m, w: c, d, D: v, h: l, m: s, s: a, ms: r, Q: f }[O] || String(O || "").toLowerCase().replace(/s$/, "");
    }, u: function(O) {
      return O === void 0;
    } }, x = "en", b = {};
    b[x] = y;
    var C = "$isDayjsObject", E = function(O) {
      return O instanceof L || !(!O || !O[C]);
    }, A = function O(D, P, F) {
      var N;
      if (!D) return x;
      if (typeof D == "string") {
        var H = D.toLowerCase();
        b[H] && (N = H), P && (b[H] = P, N = H);
        var W = D.split("-");
        if (!N && W.length > 1) return O(W[0]);
      } else {
        var te = D.name;
        b[te] = D, N = te;
      }
      return !F && N && (x = N), N || !F && x;
    }, T = function(O, D) {
      if (E(O)) return O.clone();
      var P = typeof D == "object" ? D : {};
      return P.date = O, P.args = arguments, new L(P);
    }, k = S;
    k.l = A, k.i = E, k.w = function(O, D) {
      return T(O, { locale: D.$L, utc: D.$u, x: D.$x, $offset: D.$offset });
    };
    var L = function() {
      function O(P) {
        this.$L = A(P.locale, null, !0), this.parse(P), this.$x = this.$x || P.x || {}, this[C] = !0;
      }
      var D = O.prototype;
      return D.parse = function(P) {
        this.$d = function(F) {
          var N = F.date, H = F.utc;
          if (N === null) return /* @__PURE__ */ new Date(NaN);
          if (k.u(N)) return /* @__PURE__ */ new Date();
          if (N instanceof Date) return new Date(N);
          if (typeof N == "string" && !/Z$/i.test(N)) {
            var W = N.match(w);
            if (W) {
              var te = W[2] - 1 || 0, ie = (W[7] || "0").substring(0, 3);
              return H ? new Date(Date.UTC(W[1], te, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, ie)) : new Date(W[1], te, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, ie);
            }
          }
          return new Date(N);
        }(P), this.init();
      }, D.init = function() {
        var P = this.$d;
        this.$y = P.getFullYear(), this.$M = P.getMonth(), this.$D = P.getDate(), this.$W = P.getDay(), this.$H = P.getHours(), this.$m = P.getMinutes(), this.$s = P.getSeconds(), this.$ms = P.getMilliseconds();
      }, D.$utils = function() {
        return k;
      }, D.isValid = function() {
        return this.$d.toString() !== _;
      }, D.isSame = function(P, F) {
        var N = T(P);
        return this.startOf(F) <= N && N <= this.endOf(F);
      }, D.isAfter = function(P, F) {
        return T(P) < this.startOf(F);
      }, D.isBefore = function(P, F) {
        return this.endOf(F) < T(P);
      }, D.$g = function(P, F, N) {
        return k.u(P) ? this[F] : this.set(N, P);
      }, D.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, D.valueOf = function() {
        return this.$d.getTime();
      }, D.startOf = function(P, F) {
        var N = this, H = !!k.u(F) || F, W = k.p(P), te = function($t, Re) {
          var Ke = k.w(N.$u ? Date.UTC(N.$y, Re, $t) : new Date(N.$y, Re, $t), N);
          return H ? Ke : Ke.endOf(d);
        }, ie = function($t, Re) {
          return k.w(N.toDate()[$t].apply(N.toDate("s"), (H ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Re)), N);
        }, se = this.$W, fe = this.$M, $e = this.$D, He = "set" + (this.$u ? "UTC" : "");
        switch (W) {
          case m:
            return H ? te(1, 0) : te(31, 11);
          case u:
            return H ? te(1, fe) : te(0, fe + 1);
          case c:
            var Tt = this.$locale().weekStart || 0, Me = (se < Tt ? se + 7 : se) - Tt;
            return te(H ? $e - Me : $e + (6 - Me), fe);
          case d:
          case v:
            return ie(He + "Hours", 0);
          case l:
            return ie(He + "Minutes", 1);
          case s:
            return ie(He + "Seconds", 2);
          case a:
            return ie(He + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, D.endOf = function(P) {
        return this.startOf(P, !1);
      }, D.$set = function(P, F) {
        var N, H = k.p(P), W = "set" + (this.$u ? "UTC" : ""), te = (N = {}, N[d] = W + "Date", N[v] = W + "Date", N[u] = W + "Month", N[m] = W + "FullYear", N[l] = W + "Hours", N[s] = W + "Minutes", N[a] = W + "Seconds", N[r] = W + "Milliseconds", N)[H], ie = H === d ? this.$D + (F - this.$W) : F;
        if (H === u || H === m) {
          var se = this.clone().set(v, 1);
          se.$d[te](ie), se.init(), this.$d = se.set(v, Math.min(this.$D, se.daysInMonth())).$d;
        } else te && this.$d[te](ie);
        return this.init(), this;
      }, D.set = function(P, F) {
        return this.clone().$set(P, F);
      }, D.get = function(P) {
        return this[k.p(P)]();
      }, D.add = function(P, F) {
        var N, H = this;
        P = Number(P);
        var W = k.p(F), te = function(fe) {
          var $e = T(H);
          return k.w($e.date($e.date() + Math.round(fe * P)), H);
        };
        if (W === u) return this.set(u, this.$M + P);
        if (W === m) return this.set(m, this.$y + P);
        if (W === d) return te(1);
        if (W === c) return te(7);
        var ie = (N = {}, N[s] = o, N[l] = i, N[a] = n, N)[W] || 1, se = this.$d.getTime() + P * ie;
        return k.w(se, this);
      }, D.subtract = function(P, F) {
        return this.add(-1 * P, F);
      }, D.format = function(P) {
        var F = this, N = this.$locale();
        if (!this.isValid()) return N.invalidDate || _;
        var H = P || "YYYY-MM-DDTHH:mm:ssZ", W = k.z(this), te = this.$H, ie = this.$m, se = this.$M, fe = N.weekdays, $e = N.months, He = N.meridiem, Tt = function(Re, Ke, Ut, zt) {
          return Re && (Re[Ke] || Re(F, H)) || Ut[Ke].slice(0, zt);
        }, Me = function(Re) {
          return k.s(te % 12 || 12, Re, "0");
        }, $t = He || function(Re, Ke, Ut) {
          var zt = Re < 12 ? "AM" : "PM";
          return Ut ? zt.toLowerCase() : zt;
        };
        return H.replace($, function(Re, Ke) {
          return Ke || function(Ut) {
            switch (Ut) {
              case "YY":
                return String(F.$y).slice(-2);
              case "YYYY":
                return k.s(F.$y, 4, "0");
              case "M":
                return se + 1;
              case "MM":
                return k.s(se + 1, 2, "0");
              case "MMM":
                return Tt(N.monthsShort, se, $e, 3);
              case "MMMM":
                return Tt($e, se);
              case "D":
                return F.$D;
              case "DD":
                return k.s(F.$D, 2, "0");
              case "d":
                return String(F.$W);
              case "dd":
                return Tt(N.weekdaysMin, F.$W, fe, 2);
              case "ddd":
                return Tt(N.weekdaysShort, F.$W, fe, 3);
              case "dddd":
                return fe[F.$W];
              case "H":
                return String(te);
              case "HH":
                return k.s(te, 2, "0");
              case "h":
                return Me(1);
              case "hh":
                return Me(2);
              case "a":
                return $t(te, ie, !0);
              case "A":
                return $t(te, ie, !1);
              case "m":
                return String(ie);
              case "mm":
                return k.s(ie, 2, "0");
              case "s":
                return String(F.$s);
              case "ss":
                return k.s(F.$s, 2, "0");
              case "SSS":
                return k.s(F.$ms, 3, "0");
              case "Z":
                return W;
            }
            return null;
          }(Re) || W.replace(":", "");
        });
      }, D.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, D.diff = function(P, F, N) {
        var H, W = this, te = k.p(F), ie = T(P), se = (ie.utcOffset() - this.utcOffset()) * o, fe = this - ie, $e = function() {
          return k.m(W, ie);
        };
        switch (te) {
          case m:
            H = $e() / 12;
            break;
          case u:
            H = $e();
            break;
          case f:
            H = $e() / 3;
            break;
          case c:
            H = (fe - se) / 6048e5;
            break;
          case d:
            H = (fe - se) / 864e5;
            break;
          case l:
            H = fe / i;
            break;
          case s:
            H = fe / o;
            break;
          case a:
            H = fe / n;
            break;
          default:
            H = fe;
        }
        return N ? H : k.a(H);
      }, D.daysInMonth = function() {
        return this.endOf(u).$D;
      }, D.$locale = function() {
        return b[this.$L];
      }, D.locale = function(P, F) {
        if (!P) return this.$L;
        var N = this.clone(), H = A(P, F, !0);
        return H && (N.$L = H), N;
      }, D.clone = function() {
        return k.w(this.$d, this);
      }, D.toDate = function() {
        return new Date(this.valueOf());
      }, D.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, D.toISOString = function() {
        return this.$d.toISOString();
      }, D.toString = function() {
        return this.$d.toUTCString();
      }, O;
    }(), V = L.prototype;
    return T.prototype = V, [["$ms", r], ["$s", a], ["$m", s], ["$H", l], ["$W", d], ["$M", u], ["$y", m], ["$D", v]].forEach(function(O) {
      V[O[1]] = function(D) {
        return this.$g(D, O[0], O[1]);
      };
    }), T.extend = function(O, D) {
      return O.$i || (O(D, L, T), O.$i = !0), T;
    }, T.locale = A, T.isDayjs = E, T.unix = function(O) {
      return T(1e3 * O);
    }, T.en = b[x], T.Ls = b, T.p = {}, T;
  });
})(Xc);
var Kc = Xc.exports;
const re = /* @__PURE__ */ ii(Kc);
var qc = { exports: {} };
(function(t, e) {
  (function(n, o) {
    t.exports = o();
  })(u1, function() {
    return function(n, o, i) {
      o.prototype.isToday = function() {
        var r = "YYYY-MM-DD", a = i();
        return this.format(r) === a.format(r);
      };
    };
  });
})(qc);
var ZH = qc.exports;
const BH = /* @__PURE__ */ ii(ZH);
var Jc = { exports: {} };
(function(t, e) {
  (function(n, o) {
    t.exports = o();
  })(u1, function() {
    return function(n, o) {
      o.prototype.isSameOrAfter = function(i, r) {
        return this.isSame(i, r) || this.isAfter(i, r);
      };
    };
  });
})(Jc);
var VH = Jc.exports;
const FH = /* @__PURE__ */ ii(VH);
var Qc = { exports: {} };
(function(t, e) {
  (function(n, o) {
    t.exports = o();
  })(u1, function() {
    return function(n, o) {
      o.prototype.isSameOrBefore = function(i, r) {
        return this.isSame(i, r) || this.isBefore(i, r);
      };
    };
  });
})(Qc);
var HH = Qc.exports;
const UH = /* @__PURE__ */ ii(HH);
var e2 = { exports: {} };
(function(t, e) {
  (function(n, o) {
    t.exports = o();
  })(u1, function() {
    return function(n, o, i) {
      var r = o.prototype, a = function(u) {
        return u && (u.indexOf ? u : u.s);
      }, s = function(u, f, m, v, _) {
        var w = u.name ? u : u.$locale(), $ = a(w[f]), y = a(w[m]), M = $ || y.map(function(x) {
          return x.slice(0, v);
        });
        if (!_) return M;
        var S = w.weekStart;
        return M.map(function(x, b) {
          return M[(b + (S || 0)) % 7];
        });
      }, l = function() {
        return i.Ls[i.locale()];
      }, d = function(u, f) {
        return u.formats[f] || function(m) {
          return m.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(v, _, w) {
            return _ || w.slice(1);
          });
        }(u.formats[f.toUpperCase()]);
      }, c = function() {
        var u = this;
        return { months: function(f) {
          return f ? f.format("MMMM") : s(u, "months");
        }, monthsShort: function(f) {
          return f ? f.format("MMM") : s(u, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return u.$locale().weekStart || 0;
        }, weekdays: function(f) {
          return f ? f.format("dddd") : s(u, "weekdays");
        }, weekdaysMin: function(f) {
          return f ? f.format("dd") : s(u, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(f) {
          return f ? f.format("ddd") : s(u, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(f) {
          return d(u.$locale(), f);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      r.localeData = function() {
        return c.bind(this)();
      }, i.localeData = function() {
        var u = l();
        return { firstDayOfWeek: function() {
          return u.weekStart || 0;
        }, weekdays: function() {
          return i.weekdays();
        }, weekdaysShort: function() {
          return i.weekdaysShort();
        }, weekdaysMin: function() {
          return i.weekdaysMin();
        }, months: function() {
          return i.months();
        }, monthsShort: function() {
          return i.monthsShort();
        }, longDateFormat: function(f) {
          return d(u, f);
        }, meridiem: u.meridiem, ordinal: u.ordinal };
      }, i.months = function() {
        return s(l(), "months");
      }, i.monthsShort = function() {
        return s(l(), "monthsShort", "months", 3);
      }, i.weekdays = function(u) {
        return s(l(), "weekdays", null, null, u);
      }, i.weekdaysShort = function(u) {
        return s(l(), "weekdaysShort", "weekdays", 3, u);
      }, i.weekdaysMin = function(u) {
        return s(l(), "weekdaysMin", "weekdays", 2, u);
      };
    };
  });
})(e2);
var zH = e2.exports;
const WH = /* @__PURE__ */ ii(zH);
var jH = { exports: {} };
(function(t, e) {
  (function(n, o) {
    t.exports = o(Kc);
  })(u1, function(n) {
    function o(v) {
      return v && typeof v == "object" && "default" in v ? v : { default: v };
    }
    var i = o(n), r = "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"), a = "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"), s = "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"), l = "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_"), d = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;
    function c(v, _, w) {
      var $, y;
      return w === "m" ? _ ? "минута" : "минуту" : v + " " + ($ = +v, y = { mm: _ ? "минута_минуты_минут" : "минуту_минуты_минут", hh: "час_часа_часов", dd: "день_дня_дней", MM: "месяц_месяца_месяцев", yy: "год_года_лет" }[w].split("_"), $ % 10 == 1 && $ % 100 != 11 ? y[0] : $ % 10 >= 2 && $ % 10 <= 4 && ($ % 100 < 10 || $ % 100 >= 20) ? y[1] : y[2]);
    }
    var u = function(v, _) {
      return d.test(_) ? r[v.month()] : a[v.month()];
    };
    u.s = a, u.f = r;
    var f = function(v, _) {
      return d.test(_) ? s[v.month()] : l[v.month()];
    };
    f.s = l, f.f = s;
    var m = { name: "ru", weekdays: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"), weekdaysShort: "вск_пнд_втр_срд_чтв_птн_сбт".split("_"), weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"), months: u, monthsShort: f, weekStart: 1, yearStart: 4, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY г.", LLL: "D MMMM YYYY г., H:mm", LLLL: "dddd, D MMMM YYYY г., H:mm" }, relativeTime: { future: "через %s", past: "%s назад", s: "несколько секунд", m: c, mm: c, h: "час", hh: c, d: "день", dd: c, M: "месяц", MM: c, y: "год", yy: c }, ordinal: function(v) {
      return v;
    }, meridiem: function(v) {
      return v < 4 ? "ночи" : v < 12 ? "утра" : v < 17 ? "дня" : "вечера";
    } };
    return i.default.locale(m, null, !0), m;
  });
})(jH);
re.locale("ru");
re.extend(BH);
re.extend(WH);
re.extend(FH);
re.extend(UH);
var Tn = /* @__PURE__ */ ((t) => (t.ISO = "ISO", t.YMD = "YYYY-MM-DD", t))(Tn || {}), ue = /* @__PURE__ */ ((t) => (t.ISO = "YYYY-MM-DDTHH:mm:ss.SSS", t.YMD = "YYYY-MM-DD", t))(ue || {});
const GH = { class: "p-calendar" }, YH = { class: "p-calendar-header" }, XH = { class: "header-month" }, KH = { class: "p-calendar-main" }, qH = { class: "weekdays" }, JH = { class: "days" }, QH = {
  key: 0,
  class: "preset"
}, S0 = 7, eU = 1, tU = /* @__PURE__ */ oe({
  name: "PCalendar",
  __name: "PCalendar",
  props: {
    modelValue: {},
    min: {},
    max: {},
    presets: {},
    selectedPresetKey: {},
    range: { type: Boolean },
    format: { default: Tn.ISO }
  },
  emits: ["update:modelValue", "update:selectedPresetKey", "selectDate"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = me(n, "modelValue", o), r = n.selectedPresetKey !== void 0 ? me(n, "selectedPresetKey", o) : U(null), a = (M) => !!n.range, s = U(re().startOf("day").date(1)), l = (M) => n.format === Tn.ISO ? re(M).toISOString() : re(M).format(ue.YMD), d = () => {
      let M, S;
      if (a(i.value)) {
        const [x, b] = i.value;
        M = re(x.replace(/.$/, ""), ue.ISO, !0).isValid() && re(b.replace(/.$/, ""), ue.ISO, !0).isValid(), S = re(x, ue.YMD, !0).isValid() && re(b, ue.YMD, !0).isValid();
      } else
        M = re(i.value.replace(/.$/, ""), ue.ISO, !0).isValid(), S = re(i.value, ue.YMD, !0).isValid();
      if (!M && !S) throw new Error('Неверный формат переданной даты. Необходимо использовать формат "ISO 8601" или "YYYY-MM-DD".');
    }, c = (M) => {
      if (r.value = M.key, Array.isArray(M.value)) {
        const [S, x] = M.value;
        i.value = [l(S), l(x)];
      } else
        M.value ? i.value = l(M.value) : i.value = M.value;
    }, u = () => {
      for (const { value: M, key: S } of n.presets)
        if (Array.isArray(M) && Array.isArray(i.value)) {
          const [x, b] = M, [C, E] = i.value, A = re(x).format(ue.YMD) === re(C).format(ue.YMD), T = re(b).format(ue.YMD) === re(E).format(ue.YMD);
          if (A && T) {
            r.value = S;
            break;
          }
        } else if (M === i.value) {
          r.value = S;
          break;
        }
    };
    ud(() => {
      i.value && (d(), n.presets && !n.selectedPresetKey && u(), a(i.value) ? s.value = re(i.value[0], ue.YMD).date(1) : i.value && (s.value = re(i.value, ue.YMD).date(1)));
    }), he(i, (M) => {
      i.value && (a() ? s.value = re(M[0], ue.YMD).date(1) : re(M, ue.YMD).isSame(s.value, "month") || (s.value = re(M, ue.YMD).date(1)));
    });
    const f = z(() => {
      const M = s.value.subtract(1, "M");
      return (M.date(M.daysInMonth()).day() - eU + S0) % S0;
    }), m = z(() => s.value.daysInMonth()), v = z(() => {
      let M = [];
      const S = s.value.subtract(1, "M").daysInMonth(), x = (C) => {
        if (!i.value) return !1;
        const E = re(i.value[1]).diff(i.value[0], "days"), A = [];
        for (let T = 0; T <= E; T++)
          A.push(re(i.value[0]).add(T, "days").format(ue.YMD));
        return !!A.find((T) => T === C.format(ue.YMD));
      }, b = i.value && !a(i.value) ? re(i.value).format(ue.YMD) : i.value;
      if (s.value.subtract(1, "M").date(S).get("day") !== 0)
        for (let C = S; S - C <= f.value; C--) {
          const E = re(s.value, ue.YMD).subtract(1, "M").set("date", C);
          M.unshift({
            value: E.format(ue.YMD),
            today: E.isToday(),
            selected: a(i.value) ? x(E) : b === E.format(ue.YMD),
            disabled: !0
          });
        }
      for (let C = 1; C <= m.value; C++) {
        const E = re(s.value, ue.YMD).set("date", C);
        M.push({
          value: E.format(ue.YMD),
          today: E.isToday(),
          selected: a(i.value) ? x(E) : b === E.format(ue.YMD),
          disabled: !!n.min && re(E).isBefore(re(n.min, ue.YMD), "D") || !!n.max && re(E).isAfter(re(n.max, ue.YMD), "D")
        });
      }
      for (let C = 1; M.length % S0 !== 0; C++) {
        const E = re(s.value, ue.YMD).add(1, "M").set("date", C);
        M.push({
          value: E.format(ue.YMD),
          today: re(s.value, ue.YMD).add(1, "M").set("date", C).isToday(),
          selected: a(i.value) ? x(E) : b === E.format(ue.YMD),
          disabled: !0
        });
      }
      return M;
    }), _ = (M) => {
      r.value && (r.value = null);
      const S = l(M);
      a(i.value) ? (i.value = [S, S], o("selectDate", [S, S])) : (i.value = S, o("selectDate", S));
    }, w = z(() => {
      const M = re.weekdaysMin();
      return M.slice(1).concat(M[0]);
    }), $ = z(() => !!n.min && re(n.min, ue.YMD).isSame(s.value, "month")), y = z(() => !!n.max && re(n.max, ue.YMD).isSame(s.value, "month"));
    return (M, S) => {
      const x = pa, b = vt, C = ma, E = kH;
      return p(), g("div", GH, [
        h("div", YH, [
          q(b, {
            variant: "text",
            class: ee(["header-arrow", { disabled: $.value }]),
            onClick: S[0] || (S[0] = (A) => s.value = s.value.subtract(1, "M"))
          }, {
            default: G(() => [
              q(x)
            ]),
            _: 1
          }, 8, ["class"]),
          h("div", XH, ne(s.value.format("MMMM YYYY")), 1),
          q(b, {
            variant: "text",
            class: ee(["header-arrow", { disabled: y.value }]),
            onClick: S[1] || (S[1] = (A) => s.value = s.value.add(1, "M"))
          }, {
            default: G(() => [
              q(C)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        h("div", KH, [
          h("div", qH, [
            (p(!0), g(_e, null, Ie(w.value, (A) => (p(), g("div", {
              key: A,
              class: "p-calendar-cell p-calendar-weekday"
            }, ne(A), 1))), 128))
          ]),
          h("div", JH, [
            (p(!0), g(_e, null, Ie(v.value, ({ value: A, disabled: T, today: k, selected: L }) => (p(), J(b, {
              key: A,
              variant: "text",
              class: ee(["p-calendar-cell", { disabled: T, today: k, selected: L }]),
              onClick: (V) => _(A)
            }, {
              default: G(() => [
                xe(ne(B(re)(A, B(ue).YMD).format("D")), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))), 128))
          ])
        ]),
        M.presets ? (p(), g("div", QH, [
          (p(!0), g(_e, null, Ie(M.presets, (A) => (p(), J(b, {
            key: A.key,
            class: "preset-option",
            variant: "text",
            onClick: (T) => c(A)
          }, {
            default: G(() => [
              h("div", null, ne(A.text), 1),
              B(r) === A.key ? (p(), J(E, {
                key: 0,
                class: "preset-check"
              })) : X("", !0)
            ]),
            _: 2
          }, 1032, ["onClick"]))), 128))
        ])) : X("", !0)
      ]);
    };
  }
}), nU = /* @__PURE__ */ ae(tU, [["__scopeId", "data-v-4766c1e7"]]);
var In = /* @__PURE__ */ ((t) => (t.bold = "bold", t.light = "light", t))(In || {}), k1 = /* @__PURE__ */ ((t) => (t.velvet = "velvet", t.cornflower = "cornflower", t.green = "green", t.orange = "orange", t.blue = "blue", t.pink = "pink", t.grass = "grass", t.black = "black", t))(k1 || {}), s1 = /* @__PURE__ */ ((t) => (t.fileToBig = "FILE_TOO_BIG", t.notInContactList = "NOT_IN_CONTACT_LIST", t.fileSizeLimitExceeded = "fileSizeLimitExceeded", t.fileTypeInvalid = "fileTypeInvalid", t))(s1 || {});
const Cne = [
  {
    name: "Afghanistan (‫افغانستان‬‎)",
    iso2: "af",
    dialCode: "93"
  },
  {
    name: "Albania (Shqipëri)",
    iso2: "al",
    dialCode: "355"
  },
  {
    name: "Algeria (‫الجزائر‬‎)",
    iso2: "dz",
    dialCode: "213"
  },
  {
    name: "American Samoa",
    iso2: "as",
    dialCode: "1684"
  },
  {
    name: "Andorra",
    iso2: "ad",
    dialCode: "376"
  },
  {
    name: "Angola",
    iso2: "ao",
    dialCode: "244"
  },
  {
    name: "Anguilla",
    iso2: "ai",
    dialCode: "1264"
  },
  {
    name: "Antigua and Barbuda",
    iso2: "ag",
    dialCode: "1268"
  },
  {
    name: "Argentina",
    iso2: "ar",
    dialCode: "54"
  },
  {
    name: "Armenia (Հայաստան)",
    iso2: "am",
    dialCode: "374"
  },
  {
    name: "Aruba",
    iso2: "aw",
    dialCode: "297"
  },
  {
    name: "Australia",
    iso2: "au",
    dialCode: "61"
  },
  {
    name: "Austria (Österreich)",
    iso2: "at",
    dialCode: "43",
    eu: !0,
    vat: 20
  },
  {
    name: "Azerbaijan (Azərbaycan)",
    iso2: "az",
    dialCode: "994"
  },
  {
    name: "Bahamas",
    iso2: "bs",
    dialCode: "1242"
  },
  {
    name: "Bahrain (‫البحرين‬‎)",
    iso2: "bh",
    dialCode: "973"
  },
  {
    name: "Bangladesh (বাংলাদেশ)",
    iso2: "bd",
    dialCode: "880"
  },
  {
    name: "Barbados",
    iso2: "bb",
    dialCode: "1246"
  },
  {
    name: "Belarus (Беларусь)",
    iso2: "by",
    dialCode: "375"
  },
  {
    name: "Belgium (België)",
    iso2: "be",
    dialCode: "32",
    eu: !0,
    vat: 21
  },
  {
    name: "Belize",
    iso2: "bz",
    dialCode: "501"
  },
  {
    name: "Benin (Bénin)",
    iso2: "bj",
    dialCode: "229"
  },
  {
    name: "Bermuda",
    iso2: "bm",
    dialCode: "1441"
  },
  {
    name: "Bhutan (འབྲུག)",
    iso2: "bt",
    dialCode: "975"
  },
  {
    name: "Bolivia",
    iso2: "bo",
    dialCode: "591"
  },
  {
    name: "Bosnia and Herzegovina (Босна и Херцеговина)",
    iso2: "ba",
    dialCode: "387"
  },
  {
    name: "Botswana",
    iso2: "bw",
    dialCode: "267"
  },
  {
    name: "Brazil (Brasil)",
    iso2: "br",
    dialCode: "55"
  },
  {
    name: "British Indian Ocean Territory",
    iso2: "io",
    dialCode: "246"
  },
  {
    name: "British Virgin Islands",
    iso2: "vg",
    dialCode: "1284"
  },
  {
    name: "Brunei",
    iso2: "bn",
    dialCode: "673"
  },
  {
    name: "Bulgaria (България)",
    iso2: "bg",
    dialCode: "359",
    eu: !0,
    vat: 20
  },
  {
    name: "Burkina Faso",
    iso2: "bf",
    dialCode: "226"
  },
  {
    name: "Burundi (Uburundi)",
    iso2: "bi",
    dialCode: "257"
  },
  {
    name: "Cambodia (កម្ពុជា)",
    iso2: "kh",
    dialCode: "855"
  },
  {
    name: "Cameroon (Cameroun)",
    iso2: "cm",
    dialCode: "237"
  },
  {
    name: "Canada",
    iso2: "ca",
    dialCode: "1"
  },
  {
    name: "Cape Verde (Kabu Verdi)",
    iso2: "cv",
    dialCode: "238"
  },
  {
    name: "Caribbean Netherlands",
    iso2: "bq",
    dialCode: "599"
  },
  {
    name: "Cayman Islands",
    iso2: "ky",
    dialCode: "1345"
  },
  {
    name: "Central African Republic (République centrafricaine)",
    iso2: "cf",
    dialCode: "236"
  },
  {
    name: "Chad (Tchad)",
    iso2: "td",
    dialCode: "235"
  },
  {
    name: "Chile",
    iso2: "cl",
    dialCode: "56"
  },
  {
    name: "China (中国)",
    iso2: "cn",
    dialCode: "86"
  },
  {
    name: "Christmas Island",
    iso2: "cx",
    dialCode: "61"
  },
  {
    name: "Cocos (Keeling) Islands",
    iso2: "cc",
    dialCode: "61"
  },
  {
    name: "Colombia",
    iso2: "co",
    dialCode: "57"
  },
  {
    name: "Comoros (‫جزر القمر‬‎)",
    iso2: "km",
    dialCode: "269"
  },
  {
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    iso2: "cd",
    dialCode: "243"
  },
  {
    name: "Congo (Republic) (Congo-Brazzaville)",
    iso2: "cg",
    dialCode: "242"
  },
  {
    name: "Cook Islands",
    iso2: "ck",
    dialCode: "682"
  },
  {
    name: "Costa Rica",
    iso2: "cr",
    dialCode: "506"
  },
  {
    name: "Côte d’Ivoire",
    iso2: "ci",
    dialCode: "225"
  },
  {
    name: "Croatia (Hrvatska)",
    iso2: "hr",
    dialCode: "385",
    eu: !0,
    vat: 25
  },
  {
    name: "Cuba",
    iso2: "cu",
    dialCode: "53"
  },
  {
    name: "Curaçao",
    iso2: "cw",
    dialCode: "599"
  },
  {
    name: "Cyprus (Κύπρος)",
    iso2: "cy",
    dialCode: "357",
    eu: !0,
    vat: 19
  },
  {
    name: "Czech Republic (Česká republika)",
    iso2: "cz",
    dialCode: "420",
    eu: !0,
    vat: 21
  },
  {
    name: "Denmark (Danmark)",
    iso2: "dk",
    dialCode: "45",
    eu: !0,
    vat: 25
  },
  {
    name: "Djibouti",
    iso2: "dj",
    dialCode: "253"
  },
  {
    name: "Dominica",
    iso2: "dm",
    dialCode: "1767"
  },
  {
    name: "Dominican Republic (República Dominicana)",
    iso2: "do",
    dialCode: "1"
  },
  {
    name: "Ecuador",
    iso2: "ec",
    dialCode: "593"
  },
  {
    name: "Egypt (‫مصر‬‎)",
    iso2: "eg",
    dialCode: "20"
  },
  {
    name: "El Salvador",
    iso2: "sv",
    dialCode: "503"
  },
  {
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    iso2: "gq",
    dialCode: "240"
  },
  {
    name: "Eritrea",
    iso2: "er",
    dialCode: "291"
  },
  {
    name: "Estonia (Eesti)",
    iso2: "ee",
    dialCode: "372",
    eu: !0,
    vat: 20
  },
  {
    name: "Ethiopia",
    iso2: "et",
    dialCode: "251"
  },
  {
    name: "Falkland Islands (Islas Malvinas)",
    iso2: "fk",
    dialCode: "500"
  },
  {
    name: "Faroe Islands (Føroyar)",
    iso2: "fo",
    dialCode: "298"
  },
  {
    name: "Fiji",
    iso2: "fj",
    dialCode: "679"
  },
  {
    name: "Finland (Suomi)",
    iso2: "fi",
    dialCode: "358",
    eu: !0,
    vat: 24
  },
  {
    name: "France",
    iso2: "fr",
    dialCode: "33",
    eu: !0,
    vat: 20
  },
  {
    name: "French Guiana (Guyane française)",
    iso2: "gf",
    dialCode: "594"
  },
  {
    name: "French Polynesia (Polynésie française)",
    iso2: "pf",
    dialCode: "689"
  },
  {
    name: "Gabon",
    iso2: "ga",
    dialCode: "241"
  },
  {
    name: "Gambia",
    iso2: "gm",
    dialCode: "220"
  },
  {
    name: "Georgia (საქართველო)",
    iso2: "ge",
    dialCode: "995"
  },
  {
    name: "Germany (Deutschland)",
    iso2: "de",
    dialCode: "49",
    eu: !0,
    vat: 19
  },
  {
    name: "Ghana (Gaana)",
    iso2: "gh",
    dialCode: "233"
  },
  {
    name: "Gibraltar",
    iso2: "gi",
    dialCode: "350"
  },
  {
    name: "Greece (Ελλάδα)",
    iso2: "gr",
    dialCode: "30",
    eu: !0,
    vat: 24
  },
  {
    name: "Greenland (Kalaallit Nunaat)",
    iso2: "gl",
    dialCode: "299"
  },
  {
    name: "Grenada",
    iso2: "gd",
    dialCode: "1473"
  },
  {
    name: "Guadeloupe",
    iso2: "gp",
    dialCode: "590"
  },
  {
    name: "Guam",
    iso2: "gu",
    dialCode: "1671"
  },
  {
    name: "Guatemala",
    iso2: "gt",
    dialCode: "502"
  },
  {
    name: "Guernsey",
    iso2: "gg",
    dialCode: "44"
  },
  {
    name: "Guinea (Guinée)",
    iso2: "gn",
    dialCode: "224"
  },
  {
    name: "Guinea-Bissau (Guiné Bissau)",
    iso2: "gw",
    dialCode: "245"
  },
  {
    name: "Guyana",
    iso2: "gy",
    dialCode: "592"
  },
  {
    name: "Haiti",
    iso2: "ht",
    dialCode: "509"
  },
  {
    name: "Honduras",
    iso2: "hn",
    dialCode: "504"
  },
  {
    name: "Hong Kong (香港)",
    iso2: "hk",
    dialCode: "852"
  },
  {
    name: "Hungary (Magyarország)",
    iso2: "hu",
    dialCode: "36",
    eu: !0,
    vat: 27
  },
  {
    name: "Iceland (Ísland)",
    iso2: "is",
    dialCode: "354",
    eu: !0,
    vat: 23
  },
  {
    name: "India (भारत)",
    iso2: "in",
    dialCode: "91"
  },
  {
    name: "Indonesia",
    iso2: "id",
    dialCode: "62"
  },
  {
    name: "Iran (‫ایران‬‎)",
    iso2: "ir",
    dialCode: "98"
  },
  {
    name: "Iraq (‫العراق‬‎)",
    iso2: "iq",
    dialCode: "964"
  },
  {
    name: "Ireland",
    iso2: "ie",
    dialCode: "353",
    eu: !0,
    vat: 23
  },
  {
    name: "Isle of Man",
    iso2: "im",
    dialCode: "44"
  },
  {
    name: "Israel (‫ישראל‬‎)",
    iso2: "il",
    dialCode: "972"
  },
  {
    name: "Italy (Italia)",
    iso2: "it",
    dialCode: "39",
    eu: !0,
    vat: 22
  },
  {
    name: "Jamaica",
    iso2: "jm",
    dialCode: "1"
  },
  {
    name: "Japan (日本)",
    iso2: "jp",
    dialCode: "81"
  },
  {
    name: "Jersey",
    iso2: "je",
    dialCode: "44"
  },
  {
    name: "Jordan (‫الأردن‬‎)",
    iso2: "jo",
    dialCode: "962"
  },
  {
    name: "Kazakhstan (Казахстан)",
    iso2: "kz",
    dialCode: "77"
  },
  {
    name: "Kenya",
    iso2: "ke",
    dialCode: "254"
  },
  {
    name: "Kiribati",
    iso2: "ki",
    dialCode: "686"
  },
  {
    name: "Kosovo",
    iso2: "xk",
    dialCode: "383"
  },
  {
    name: "Kuwait (‫الكويت‬‎)",
    iso2: "kw",
    dialCode: "965"
  },
  {
    name: "Kyrgyzstan (Кыргызстан)",
    iso2: "kg",
    dialCode: "996"
  },
  {
    name: "Laos (ລາວ)",
    iso2: "la",
    dialCode: "856"
  },
  {
    name: "Latvia (Latvija)",
    iso2: "lv",
    dialCode: "371",
    eu: !0,
    vat: 21
  },
  {
    name: "Lebanon (‫لبنان‬‎)",
    iso2: "lb",
    dialCode: "961"
  },
  {
    name: "Lesotho",
    iso2: "ls",
    dialCode: "266"
  },
  {
    name: "Liberia",
    iso2: "lr",
    dialCode: "231"
  },
  {
    name: "Libya (‫ليبيا‬‎)",
    iso2: "ly",
    dialCode: "218"
  },
  {
    name: "Liechtenstein",
    iso2: "li",
    dialCode: "423"
  },
  {
    name: "Lithuania (Lietuva)",
    iso2: "lt",
    dialCode: "370",
    eu: !0,
    vat: 21
  },
  {
    name: "Luxembourg",
    iso2: "lu",
    dialCode: "352",
    eu: !0,
    vat: 17
  },
  {
    name: "Macau (澳門)",
    iso2: "mo",
    dialCode: "853"
  },
  {
    name: "Macedonia (FYROM) (Македонија)",
    iso2: "mk",
    dialCode: "389"
  },
  {
    name: "Madagascar (Madagasikara)",
    iso2: "mg",
    dialCode: "261"
  },
  {
    name: "Malawi",
    iso2: "mw",
    dialCode: "265"
  },
  {
    name: "Malaysia",
    iso2: "my",
    dialCode: "60"
  },
  {
    name: "Maldives",
    iso2: "mv",
    dialCode: "960"
  },
  {
    name: "Mali",
    iso2: "ml",
    dialCode: "223"
  },
  {
    name: "Malta",
    iso2: "mt",
    dialCode: "356",
    eu: !0,
    vat: 18
  },
  {
    name: "Marshall Islands",
    iso2: "mh",
    dialCode: "692"
  },
  {
    name: "Martinique",
    iso2: "mq",
    dialCode: "596"
  },
  {
    name: "Mauritania (‫موريتانيا‬‎)",
    iso2: "mr",
    dialCode: "222"
  },
  {
    name: "Mauritius (Moris)",
    iso2: "mu",
    dialCode: "230"
  },
  {
    name: "Mayotte",
    iso2: "yt",
    dialCode: "262"
  },
  {
    name: "Mexico (México)",
    iso2: "mx",
    dialCode: "52"
  },
  {
    name: "Micronesia",
    iso2: "fm",
    dialCode: "691"
  },
  {
    name: "Moldova (Republica Moldova)",
    iso2: "md",
    dialCode: "373"
  },
  {
    name: "Monaco",
    iso2: "mc",
    dialCode: "377"
  },
  {
    name: "Mongolia (Монгол)",
    iso2: "mn",
    dialCode: "976"
  },
  {
    name: "Montenegro (Crna Gora)",
    iso2: "me",
    dialCode: "382"
  },
  {
    name: "Montserrat",
    iso2: "ms",
    dialCode: "1664"
  },
  {
    name: "Morocco (‫المغرب‬‎)",
    iso2: "ma",
    dialCode: "212"
  },
  {
    name: "Mozambique (Moçambique)",
    iso2: "mz",
    dialCode: "258"
  },
  {
    name: "Myanmar (Burma) (မြန်မာ)",
    iso2: "mm",
    dialCode: "95"
  },
  {
    name: "Namibia (Namibië)",
    iso2: "na",
    dialCode: "264"
  },
  {
    name: "Nauru",
    iso2: "nr",
    dialCode: "674"
  },
  {
    name: "Nepal (नेपाल)",
    iso2: "np",
    dialCode: "977"
  },
  {
    name: "Netherlands (Nederland)",
    iso2: "nl",
    dialCode: "31",
    eu: !0,
    vat: 21
  },
  {
    name: "New Caledonia (Nouvelle-Calédonie)",
    iso2: "nc",
    dialCode: "687"
  },
  {
    name: "New Zealand",
    iso2: "nz",
    dialCode: "64"
  },
  {
    name: "Nicaragua",
    iso2: "ni",
    dialCode: "505"
  },
  {
    name: "Niger (Nijar)",
    iso2: "ne",
    dialCode: "227"
  },
  {
    name: "Nigeria",
    iso2: "ng",
    dialCode: "234"
  },
  {
    name: "Niue",
    iso2: "nu",
    dialCode: "683"
  },
  {
    name: "Norfolk Island",
    iso2: "nf",
    dialCode: "672"
  },
  {
    name: "North Korea (조선 민주주의 인민 공화국)",
    iso2: "kp",
    dialCode: "850"
  },
  {
    name: "Northern Mariana Islands",
    iso2: "mp",
    dialCode: "1670"
  },
  {
    name: "Norway (Norge)",
    iso2: "no",
    dialCode: "47"
  },
  {
    name: "Oman (‫عُمان‬‎)",
    iso2: "om",
    dialCode: "968"
  },
  {
    name: "Pakistan (‫پاکستان‬‎)",
    iso2: "pk",
    dialCode: "92"
  },
  {
    name: "Palau",
    iso2: "pw",
    dialCode: "680"
  },
  {
    name: "Palestine (‫فلسطين‬‎)",
    iso2: "ps",
    dialCode: "970"
  },
  {
    name: "Panama (Panamá)",
    iso2: "pa",
    dialCode: "507"
  },
  {
    name: "Papua New Guinea",
    iso2: "pg",
    dialCode: "675"
  },
  {
    name: "Paraguay",
    iso2: "py",
    dialCode: "595"
  },
  {
    name: "Peru (Perú)",
    iso2: "pe",
    dialCode: "51"
  },
  {
    name: "Philippines",
    iso2: "ph",
    dialCode: "63"
  },
  {
    name: "Poland (Polska)",
    iso2: "pl",
    dialCode: "48",
    eu: !0,
    vat: 23
  },
  {
    name: "Portugal",
    iso2: "pt",
    dialCode: "351",
    eu: !0,
    vat: 23
  },
  {
    name: "Puerto Rico",
    iso2: "pr",
    dialCode: "1"
  },
  {
    name: "Qatar (‫قطر‬‎)",
    iso2: "qa",
    dialCode: "974"
  },
  {
    name: "Réunion (La Réunion)",
    iso2: "re",
    dialCode: "262"
  },
  {
    name: "Romania (România)",
    iso2: "ro",
    dialCode: "40",
    eu: !0,
    vat: 19
  },
  {
    name: "Russia (Россия)",
    iso2: "ru",
    dialCode: "7"
  },
  {
    name: "Rwanda",
    iso2: "rw",
    dialCode: "250"
  },
  {
    name: "Saint Barthélemy",
    iso2: "bl",
    dialCode: "590"
  },
  {
    name: "Saint Helena",
    iso2: "sh",
    dialCode: "290"
  },
  {
    name: "Saint Kitts and Nevis",
    iso2: "kn",
    dialCode: "1869"
  },
  {
    name: "Saint Lucia",
    iso2: "lc",
    dialCode: "1758"
  },
  {
    name: "Saint Martin (Saint-Martin (partie française))",
    iso2: "mf",
    dialCode: "590"
  },
  {
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    iso2: "pm",
    dialCode: "508"
  },
  {
    name: "Saint Vincent and the Grenadines",
    iso2: "vc",
    dialCode: "1784"
  },
  {
    name: "Samoa",
    iso2: "ws",
    dialCode: "685"
  },
  {
    name: "San Marino",
    iso2: "sm",
    dialCode: "378"
  },
  {
    name: "São Tomé and Príncipe (São Tomé e Príncipe)",
    iso2: "st",
    dialCode: "239"
  },
  {
    name: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    iso2: "sa",
    dialCode: "966"
  },
  {
    name: "Senegal (Sénégal)",
    iso2: "sn",
    dialCode: "221"
  },
  {
    name: "Serbia (Србија)",
    iso2: "rs",
    dialCode: "381"
  },
  {
    name: "Seychelles",
    iso2: "sc",
    dialCode: "248"
  },
  {
    name: "Sierra Leone",
    iso2: "sl",
    dialCode: "232"
  },
  {
    name: "Singapore",
    iso2: "sg",
    dialCode: "65"
  },
  {
    name: "Sint Maarten",
    iso2: "sx",
    dialCode: "1721"
  },
  {
    name: "Slovakia (Slovensko)",
    iso2: "sk",
    dialCode: "421",
    eu: !0,
    vat: 20
  },
  {
    name: "Slovenia (Slovenija)",
    iso2: "si",
    dialCode: "386",
    eu: !0,
    vat: 22
  },
  {
    name: "Solomon Islands",
    iso2: "sb",
    dialCode: "677"
  },
  {
    name: "Somalia (Soomaaliya)",
    iso2: "so",
    dialCode: "252"
  },
  {
    name: "South Africa",
    iso2: "za",
    dialCode: "27"
  },
  {
    name: "South Korea (대한민국)",
    iso2: "kr",
    dialCode: "82"
  },
  {
    name: "South Sudan (‫جنوب السودان‬‎)",
    iso2: "ss",
    dialCode: "211"
  },
  {
    name: "Spain (España)",
    iso2: "es",
    dialCode: "34",
    eu: !0,
    vat: 21
  },
  {
    name: "Sri Lanka (ශ්‍රී ලංකාව)",
    iso2: "lk",
    dialCode: "94"
  },
  {
    name: "Sudan (‫السودان‬‎)",
    iso2: "sd",
    dialCode: "249"
  },
  {
    name: "Suriname",
    iso2: "sr",
    dialCode: "597"
  },
  {
    name: "Svalbard and Jan Mayen",
    iso2: "sj",
    dialCode: "47"
  },
  {
    name: "Swaziland",
    iso2: "sz",
    dialCode: "268"
  },
  {
    name: "Sweden (Sverige)",
    iso2: "se",
    dialCode: "46",
    eu: !0,
    vat: 25
  },
  {
    name: "Switzerland (Schweiz)",
    iso2: "ch",
    dialCode: "41"
  },
  {
    name: "Syria (‫سوريا‬‎)",
    iso2: "sy",
    dialCode: "963"
  },
  {
    name: "Taiwan (台灣)",
    iso2: "tw",
    dialCode: "886"
  },
  {
    name: "Tajikistan",
    iso2: "tj",
    dialCode: "992"
  },
  {
    name: "Tanzania",
    iso2: "tz",
    dialCode: "255"
  },
  {
    name: "Thailand (ไทย)",
    iso2: "th",
    dialCode: "66"
  },
  {
    name: "Timor-Leste",
    iso2: "tl",
    dialCode: "670"
  },
  {
    name: "Togo",
    iso2: "tg",
    dialCode: "228"
  },
  {
    name: "Tokelau",
    iso2: "tk",
    dialCode: "690"
  },
  {
    name: "Tonga",
    iso2: "to",
    dialCode: "676"
  },
  {
    name: "Trinidad and Tobago",
    iso2: "tt",
    dialCode: "1868"
  },
  {
    name: "Tunisia (‫تونس‬‎)",
    iso2: "tn",
    dialCode: "216"
  },
  {
    name: "Turkey (Türkiye)",
    iso2: "tr",
    dialCode: "90"
  },
  {
    name: "Turkmenistan",
    iso2: "tm",
    dialCode: "993"
  },
  {
    name: "Turks and Caicos Islands",
    iso2: "tc",
    dialCode: "1649"
  },
  {
    name: "Tuvalu",
    iso2: "tv",
    dialCode: "688"
  },
  {
    name: "U.S. Virgin Islands",
    iso2: "vi",
    dialCode: "1340"
  },
  {
    name: "Uganda",
    iso2: "ug",
    dialCode: "256"
  },
  {
    name: "Ukraine (Україна)",
    iso2: "ua",
    dialCode: "380"
  },
  {
    name: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    iso2: "ae",
    dialCode: "971"
  },
  {
    name: "United Kingdom",
    iso2: "gb",
    dialCode: "44"
  },
  {
    name: "United States",
    iso2: "us",
    dialCode: "1"
  },
  {
    name: "Uruguay",
    iso2: "uy",
    dialCode: "598"
  },
  {
    name: "Uzbekistan (Oʻzbekiston)",
    iso2: "uz",
    dialCode: "998"
  },
  {
    name: "Vanuatu",
    iso2: "vu",
    dialCode: "678"
  },
  {
    name: "Vatican City (Città del Vaticano)",
    iso2: "va",
    dialCode: "39"
  },
  {
    name: "Venezuela",
    iso2: "ve",
    dialCode: "58"
  },
  {
    name: "Vietnam (Việt Nam)",
    iso2: "vn",
    dialCode: "84"
  },
  {
    name: "Wallis and Futuna (Wallis-et-Futuna)",
    iso2: "wf",
    dialCode: "681"
  },
  {
    name: "Western Sahara (‫الصحراء الغربية‬‎)",
    iso2: "eh",
    dialCode: "212"
  },
  {
    name: "Yemen (‫اليمن‬‎)",
    iso2: "ye",
    dialCode: "967"
  },
  {
    name: "Zambia",
    iso2: "zm",
    dialCode: "260"
  },
  {
    name: "Zimbabwe",
    iso2: "zw",
    dialCode: "263"
  },
  {
    name: "Åland Islands",
    iso2: "ax",
    dialCode: "358"
  }
];
var De = /* @__PURE__ */ ((t) => (t.audio = "audio", t.text = "text", t.application = "application", t.video = "video", t.image = "image", t.font = "font", t.model = "model", t))(De || {});
const oU = /* @__PURE__ */ oe({
  name: "PCalendarDay",
  __name: "PCalendarDay",
  props: {
    day: {}
  },
  emits: ["selectDay"],
  setup(t, { emit: e }) {
    const n = e;
    return (o, i) => (p(), g("div", {
      key: o.day.value,
      class: ee(["p-calendar-day", { ...o.day }]),
      onClick: i[0] || (i[0] = Ye((r) => n("selectDay", o.day.value), ["prevent"]))
    }, [
      o.day.pointed ? (p(), J(Xe, {
        key: 0,
        name: "fade",
        mode: "out-in"
      }, {
        default: G(() => [
          (p(), g("div", {
            key: Number(o.day.pointed),
            class: "day-point"
          }))
        ]),
        _: 1
      })) : X("", !0),
      xe(" " + ne(B(re)(o.day.value, B(ue).YMD).format("D")), 1)
    ], 2));
  }
}), t2 = /* @__PURE__ */ ae(oU, [["__scopeId", "data-v-2174382e"]]), iU = { class: "p-calendar-weekdays" }, n2 = /* @__PURE__ */ oe({
  name: "PCalendarWeekdays",
  __name: "PCalendarWeekdays",
  setup(t) {
    const e = function() {
      const n = re.weekdaysMin();
      return n.slice(1).concat(n[0]);
    }();
    return (n, o) => (p(), g("div", iU, [
      (p(!0), g(_e, null, Ie(B(e), (i) => (p(), g("div", {
        key: i,
        class: "p-calendar-weekday"
      }, ne(i), 1))), 128))
    ]));
  }
});
/*!
  * shared v10.0.0-beta.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const gs = typeof window < "u";
process.env.NODE_ENV;
const rU = /\{([0-9a-zA-Z]+)\}/g;
function aU(t, ...e) {
  return e.length === 1 && xt(e[0]) && (e = e[0]), (!e || !e.hasOwnProperty) && (e = {}), t.replace(rU, (n, o) => e.hasOwnProperty(o) ? e[o] : "");
}
const Rn = (t, e = !1) => e ? Symbol.for(t) : Symbol(t), nr = (t) => typeof t == "number" && isFinite(t), $s = (t) => cU(t) === "[object RegExp]", sU = (t) => xn(t) && Object.keys(t).length === 0, pn = Object.assign;
let ws;
const o2 = () => ws || (ws = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}), lU = Object.prototype.hasOwnProperty;
function Ti(t, e) {
  return lU.call(t, e);
}
const kn = Array.isArray, di = (t) => typeof t == "function", je = (t) => typeof t == "string", uo = (t) => typeof t == "boolean", xt = (t) => t !== null && typeof t == "object", dU = Object.prototype.toString, cU = (t) => dU.call(t), xn = (t) => {
  if (!xt(t))
    return !1;
  const e = Object.getPrototypeOf(t);
  return e === null || e.constructor === Object;
};
function _a(t, e) {
  typeof console < "u" && console.warn("[intlify] " + t);
}
function uU() {
  const t = /* @__PURE__ */ new Map();
  return {
    events: t,
    on(n, o) {
      const i = t.get(n);
      i && i.push(o) || t.set(n, [o]);
    },
    off(n, o) {
      const i = t.get(n);
      i && i.splice(i.indexOf(o) >>> 0, 1);
    },
    emit(n, o) {
      (t.get(n) || []).slice().map((i) => i(o)), (t.get("*") || []).slice().map((i) => i(n, o));
    }
  };
}
const ci = (t) => !xt(t) || kn(t);
function $i(t, e) {
  if (ci(t) || ci(e))
    throw new Error("Invalid value");
  const n = [{ src: t, des: e }];
  for (; n.length; ) {
    const { src: o, des: i } = n.pop();
    Object.keys(o).forEach((r) => {
      ci(o[r]) || ci(i[r]) ? i[r] = o[r] : n.push({ src: o[r], des: i[r] });
    });
  }
}
/*!
  * shared v10.0.0-beta.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const xo = typeof window < "u";
let Bt, So;
if (process.env.NODE_ENV !== "production") {
  const t = xo && window.performance;
  t && t.mark && t.measure && t.clearMarks && // @ts-ignore browser compat
  t.clearMeasures && (Bt = (e) => {
    t.mark(e);
  }, So = (e, n, o) => {
    t.measure(e, n, o), t.clearMarks(n), t.clearMarks(o);
  });
}
const hU = /\{([0-9a-zA-Z]+)\}/g;
function va(t, ...e) {
  return e.length === 1 && Ge(e[0]) && (e = e[0]), (!e || !e.hasOwnProperty) && (e = {}), t.replace(hU, (n, o) => e.hasOwnProperty(o) ? e[o] : "");
}
const fU = (t, e, n) => mU({ l: t, k: e, s: n }), mU = (t) => JSON.stringify(t).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Rt = (t) => typeof t == "number" && isFinite(t), pU = (t) => r2(t) === "[object Date]", ys = (t) => r2(t) === "[object RegExp]", ga = (t) => Pe(t) && Object.keys(t).length === 0, no = Object.assign;
let Ms;
const _U = () => Ms || (Ms = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Cs(t) {
  return t.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const _n = Array.isArray, Ue = (t) => typeof t == "function", ce = (t) => typeof t == "string", bt = (t) => typeof t == "boolean", Ge = (t) => t !== null && typeof t == "object", vU = (t) => Ge(t) && Ue(t.then) && Ue(t.catch), i2 = Object.prototype.toString, r2 = (t) => i2.call(t), Pe = (t) => {
  if (!Ge(t))
    return !1;
  const e = Object.getPrototypeOf(t);
  return e === null || e.constructor === Object;
}, gU = (t) => t == null ? "" : _n(t) || Pe(t) && t.toString === i2 ? JSON.stringify(t, null, 2) : String(t);
function $a(t, e = "") {
  return t.reduce((n, o, i) => i === 0 ? n + o : n + e + o, "");
}
const bs = 2;
function $U(t, e = 0, n = t.length) {
  const o = t.split(/\r?\n/);
  let i = 0;
  const r = [];
  for (let a = 0; a < o.length; a++)
    if (i += o[a].length + 1, i >= e) {
      for (let s = a - bs; s <= a + bs || n > i; s++) {
        if (s < 0 || s >= o.length)
          continue;
        const l = s + 1;
        r.push(`${l}${" ".repeat(3 - String(l).length)}|  ${o[s]}`);
        const d = o[s].length;
        if (s === a) {
          const c = e - (i - d) + 1, u = Math.max(1, n > i ? d - c : n - e);
          r.push("   |  " + " ".repeat(c) + "^".repeat(u));
        } else if (s > a) {
          if (n > i) {
            const c = Math.max(Math.min(n - i, d), 1);
            r.push("   |  " + "^".repeat(c));
          }
          i += d + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function ri(t, e) {
  typeof console < "u" && (console.warn("[intlify] " + t), e && console.warn(e.stack));
}
const xs = {};
function wU(t) {
  xs[t] || (xs[t] = !0, ri(t));
}
/*!
  * message-compiler v10.0.0-beta.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function yU(t, e, n) {
  return { line: t, column: e, offset: n };
}
function or(t, e, n) {
  return { start: t, end: e };
}
const de = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, MU = 17, CU = {
  // tokenizer error messages
  [de.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [de.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [de.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [de.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [de.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [de.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [de.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [de.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [de.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [de.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [de.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [de.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [de.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [de.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [de.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [de.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function h1(t, e, n = {}) {
  const { domain: o, messages: i, args: r } = n, a = process.env.NODE_ENV !== "production" ? va((i || CU)[t] || "", ...r || []) : t, s = new SyntaxError(String(a));
  return s.code = t, e && (s.location = e), s.domain = o, s;
}
function bU(t) {
  throw t;
}
const xU = /<\/?[\w\s="/.':;#-\/]+>/, SU = (t) => xU.test(t), Cn = " ", IU = "\r", ut = `
`, AU = "\u2028", kU = "\u2029";
function EU(t) {
  const e = t;
  let n = 0, o = 1, i = 1, r = 0;
  const a = (C) => e[C] === IU && e[C + 1] === ut, s = (C) => e[C] === ut, l = (C) => e[C] === kU, d = (C) => e[C] === AU, c = (C) => a(C) || s(C) || l(C) || d(C), u = () => n, f = () => o, m = () => i, v = () => r, _ = (C) => a(C) || l(C) || d(C) ? ut : e[C], w = () => _(n), $ = () => _(n + r);
  function y() {
    return r = 0, c(n) && (o++, i = 0), a(n) && n++, n++, i++, e[n];
  }
  function M() {
    return a(n + r) && r++, r++, e[n + r];
  }
  function S() {
    n = 0, o = 1, i = 1, r = 0;
  }
  function x(C = 0) {
    r = C;
  }
  function b() {
    const C = n + r;
    for (; C !== n; )
      y();
    r = 0;
  }
  return {
    index: u,
    line: f,
    column: m,
    peekOffset: v,
    charAt: _,
    currentChar: w,
    currentPeek: $,
    next: y,
    peek: M,
    reset: S,
    resetPeek: x,
    skipToPeek: b
  };
}
const Bn = void 0, PU = ".", Ss = "'", TU = "tokenizer";
function OU(t, e = {}) {
  const n = e.location !== !1, o = EU(t), i = () => o.index(), r = () => yU(o.line(), o.column(), o.index()), a = r(), s = i(), l = {
    currentType: 13,
    offset: s,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: s,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, d = () => l, { onError: c } = e;
  function u(R, Z, K, ...le) {
    const Ze = d();
    if (Z.column += K, Z.offset += K, c) {
      const Be = n ? or(Ze.startLoc, Z) : null, ge = h1(R, Be, {
        domain: TU,
        args: le
      });
      c(ge);
    }
  }
  function f(R, Z, K) {
    R.endLoc = r(), R.currentType = Z;
    const le = { type: Z };
    return n && (le.loc = or(R.startLoc, R.endLoc)), K != null && (le.value = K), le;
  }
  const m = (R) => f(
    R,
    13
    /* TokenTypes.EOF */
  );
  function v(R, Z) {
    return R.currentChar() === Z ? (R.next(), Z) : (u(de.EXPECTED_TOKEN, r(), 0, Z), "");
  }
  function _(R) {
    let Z = "";
    for (; R.currentPeek() === Cn || R.currentPeek() === ut; )
      Z += R.currentPeek(), R.peek();
    return Z;
  }
  function w(R) {
    const Z = _(R);
    return R.skipToPeek(), Z;
  }
  function $(R) {
    if (R === Bn)
      return !1;
    const Z = R.charCodeAt(0);
    return Z >= 97 && Z <= 122 || // a-z
    Z >= 65 && Z <= 90 || // A-Z
    Z === 95;
  }
  function y(R) {
    if (R === Bn)
      return !1;
    const Z = R.charCodeAt(0);
    return Z >= 48 && Z <= 57;
  }
  function M(R, Z) {
    const { currentType: K } = Z;
    if (K !== 2)
      return !1;
    _(R);
    const le = $(R.currentPeek());
    return R.resetPeek(), le;
  }
  function S(R, Z) {
    const { currentType: K } = Z;
    if (K !== 2)
      return !1;
    _(R);
    const le = R.currentPeek() === "-" ? R.peek() : R.currentPeek(), Ze = y(le);
    return R.resetPeek(), Ze;
  }
  function x(R, Z) {
    const { currentType: K } = Z;
    if (K !== 2)
      return !1;
    _(R);
    const le = R.currentPeek() === Ss;
    return R.resetPeek(), le;
  }
  function b(R, Z) {
    const { currentType: K } = Z;
    if (K !== 7)
      return !1;
    _(R);
    const le = R.currentPeek() === ".";
    return R.resetPeek(), le;
  }
  function C(R, Z) {
    const { currentType: K } = Z;
    if (K !== 8)
      return !1;
    _(R);
    const le = $(R.currentPeek());
    return R.resetPeek(), le;
  }
  function E(R, Z) {
    const { currentType: K } = Z;
    if (!(K === 7 || K === 11))
      return !1;
    _(R);
    const le = R.currentPeek() === ":";
    return R.resetPeek(), le;
  }
  function A(R, Z) {
    const { currentType: K } = Z;
    if (K !== 9)
      return !1;
    const le = () => {
      const Be = R.currentPeek();
      return Be === "{" ? $(R.peek()) : Be === "@" || Be === "|" || Be === ":" || Be === "." || Be === Cn || !Be ? !1 : Be === ut ? (R.peek(), le()) : k(R, !1);
    }, Ze = le();
    return R.resetPeek(), Ze;
  }
  function T(R) {
    _(R);
    const Z = R.currentPeek() === "|";
    return R.resetPeek(), Z;
  }
  function k(R, Z = !0) {
    const K = (Ze = !1, Be = "") => {
      const ge = R.currentPeek();
      return ge === "{" || ge === "@" || !ge ? Ze : ge === "|" ? !(Be === Cn || Be === ut) : ge === Cn ? (R.peek(), K(!0, Cn)) : ge === ut ? (R.peek(), K(!0, ut)) : !0;
    }, le = K();
    return Z && R.resetPeek(), le;
  }
  function L(R, Z) {
    const K = R.currentChar();
    return K === Bn ? Bn : Z(K) ? (R.next(), K) : null;
  }
  function V(R) {
    const Z = R.charCodeAt(0);
    return Z >= 97 && Z <= 122 || // a-z
    Z >= 65 && Z <= 90 || // A-Z
    Z >= 48 && Z <= 57 || // 0-9
    Z === 95 || // _
    Z === 36;
  }
  function O(R) {
    return L(R, V);
  }
  function D(R) {
    const Z = R.charCodeAt(0);
    return Z >= 97 && Z <= 122 || // a-z
    Z >= 65 && Z <= 90 || // A-Z
    Z >= 48 && Z <= 57 || // 0-9
    Z === 95 || // _
    Z === 36 || // $
    Z === 45;
  }
  function P(R) {
    return L(R, D);
  }
  function F(R) {
    const Z = R.charCodeAt(0);
    return Z >= 48 && Z <= 57;
  }
  function N(R) {
    return L(R, F);
  }
  function H(R) {
    const Z = R.charCodeAt(0);
    return Z >= 48 && Z <= 57 || // 0-9
    Z >= 65 && Z <= 70 || // A-F
    Z >= 97 && Z <= 102;
  }
  function W(R) {
    return L(R, H);
  }
  function te(R) {
    let Z = "", K = "";
    for (; Z = N(R); )
      K += Z;
    return K;
  }
  function ie(R) {
    let Z = "";
    for (; ; ) {
      const K = R.currentChar();
      if (K === "{" || K === "}" || K === "@" || K === "|" || !K)
        break;
      if (K === Cn || K === ut)
        if (k(R))
          Z += K, R.next();
        else {
          if (T(R))
            break;
          Z += K, R.next();
        }
      else
        Z += K, R.next();
    }
    return Z;
  }
  function se(R) {
    w(R);
    let Z = "", K = "";
    for (; Z = P(R); )
      K += Z;
    return R.currentChar() === Bn && u(de.UNTERMINATED_CLOSING_BRACE, r(), 0), K;
  }
  function fe(R) {
    w(R);
    let Z = "";
    return R.currentChar() === "-" ? (R.next(), Z += `-${te(R)}`) : Z += te(R), R.currentChar() === Bn && u(de.UNTERMINATED_CLOSING_BRACE, r(), 0), Z;
  }
  function $e(R) {
    return R !== Ss && R !== ut;
  }
  function He(R) {
    w(R), v(R, "'");
    let Z = "", K = "";
    for (; Z = L(R, $e); )
      Z === "\\" ? K += Tt(R) : K += Z;
    const le = R.currentChar();
    return le === ut || le === Bn ? (u(de.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, r(), 0), le === ut && (R.next(), v(R, "'")), K) : (v(R, "'"), K);
  }
  function Tt(R) {
    const Z = R.currentChar();
    switch (Z) {
      case "\\":
      case "'":
        return R.next(), `\\${Z}`;
      case "u":
        return Me(R, Z, 4);
      case "U":
        return Me(R, Z, 6);
      default:
        return u(de.UNKNOWN_ESCAPE_SEQUENCE, r(), 0, Z), "";
    }
  }
  function Me(R, Z, K) {
    v(R, Z);
    let le = "";
    for (let Ze = 0; Ze < K; Ze++) {
      const Be = W(R);
      if (!Be) {
        u(de.INVALID_UNICODE_ESCAPE_SEQUENCE, r(), 0, `\\${Z}${le}${R.currentChar()}`);
        break;
      }
      le += Be;
    }
    return `\\${Z}${le}`;
  }
  function $t(R) {
    return R !== "{" && R !== "}" && R !== Cn && R !== ut;
  }
  function Re(R) {
    w(R);
    let Z = "", K = "";
    for (; Z = L(R, $t); )
      K += Z;
    return K;
  }
  function Ke(R) {
    let Z = "", K = "";
    for (; Z = O(R); )
      K += Z;
    return K;
  }
  function Ut(R) {
    const Z = (K) => {
      const le = R.currentChar();
      return le === "{" || le === "@" || le === "|" || le === "(" || le === ")" || !le || le === Cn ? K : (K += le, R.next(), Z(K));
    };
    return Z("");
  }
  function zt(R) {
    w(R);
    const Z = v(
      R,
      "|"
      /* TokenChars.Pipe */
    );
    return w(R), Z;
  }
  function p1(R, Z) {
    let K = null;
    switch (R.currentChar()) {
      case "{":
        return Z.braceNest >= 1 && u(de.NOT_ALLOW_NEST_PLACEHOLDER, r(), 0), R.next(), K = f(
          Z,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), w(R), Z.braceNest++, K;
      case "}":
        return Z.braceNest > 0 && Z.currentType === 2 && u(de.EMPTY_PLACEHOLDER, r(), 0), R.next(), K = f(
          Z,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), Z.braceNest--, Z.braceNest > 0 && w(R), Z.inLinked && Z.braceNest === 0 && (Z.inLinked = !1), K;
      case "@":
        return Z.braceNest > 0 && u(de.UNTERMINATED_CLOSING_BRACE, r(), 0), K = ro(R, Z) || m(Z), Z.braceNest = 0, K;
      default: {
        let Ze = !0, Be = !0, ge = !0;
        if (T(R))
          return Z.braceNest > 0 && u(de.UNTERMINATED_CLOSING_BRACE, r(), 0), K = f(Z, 1, zt(R)), Z.braceNest = 0, Z.inLinked = !1, K;
        if (Z.braceNest > 0 && (Z.currentType === 4 || Z.currentType === 5 || Z.currentType === 6))
          return u(de.UNTERMINATED_CLOSING_BRACE, r(), 0), Z.braceNest = 0, _1(R, Z);
        if (Ze = M(R, Z))
          return K = f(Z, 4, se(R)), w(R), K;
        if (Be = S(R, Z))
          return K = f(Z, 5, fe(R)), w(R), K;
        if (ge = x(R, Z))
          return K = f(Z, 6, He(R)), w(R), K;
        if (!Ze && !Be && !ge)
          return K = f(Z, 12, Re(R)), u(de.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, K.value), w(R), K;
        break;
      }
    }
    return K;
  }
  function ro(R, Z) {
    const { currentType: K } = Z;
    let le = null;
    const Ze = R.currentChar();
    switch ((K === 7 || K === 8 || K === 11 || K === 9) && (Ze === ut || Ze === Cn) && u(de.INVALID_LINKED_FORMAT, r(), 0), Ze) {
      case "@":
        return R.next(), le = f(
          Z,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), Z.inLinked = !0, le;
      case ".":
        return w(R), R.next(), f(
          Z,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return w(R), R.next(), f(
          Z,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return T(R) ? (le = f(Z, 1, zt(R)), Z.braceNest = 0, Z.inLinked = !1, le) : b(R, Z) || E(R, Z) ? (w(R), ro(R, Z)) : C(R, Z) ? (w(R), f(Z, 11, Ke(R))) : A(R, Z) ? (w(R), Ze === "{" ? p1(R, Z) || le : f(Z, 10, Ut(R))) : (K === 7 && u(de.INVALID_LINKED_FORMAT, r(), 0), Z.braceNest = 0, Z.inLinked = !1, _1(R, Z));
    }
  }
  function _1(R, Z) {
    let K = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (Z.braceNest > 0)
      return p1(R, Z) || m(Z);
    if (Z.inLinked)
      return ro(R, Z) || m(Z);
    switch (R.currentChar()) {
      case "{":
        return p1(R, Z) || m(Z);
      case "}":
        return u(de.UNBALANCED_CLOSING_BRACE, r(), 0), R.next(), f(
          Z,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return ro(R, Z) || m(Z);
      default: {
        if (T(R))
          return K = f(Z, 1, zt(R)), Z.braceNest = 0, Z.inLinked = !1, K;
        if (k(R))
          return f(Z, 0, ie(R));
        break;
      }
    }
    return K;
  }
  function _0() {
    const { currentType: R, offset: Z, startLoc: K, endLoc: le } = l;
    return l.lastType = R, l.lastOffset = Z, l.lastStartLoc = K, l.lastEndLoc = le, l.offset = i(), l.startLoc = r(), o.currentChar() === Bn ? f(
      l,
      13
      /* TokenTypes.EOF */
    ) : _1(o, l);
  }
  return {
    nextToken: _0,
    currentOffset: i,
    currentPosition: r,
    context: d
  };
}
const LU = "parser", DU = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function NU(t, e, n) {
  switch (t) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(e || n, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function RU(t = {}) {
  const e = t.location !== !1, { onError: n } = t;
  function o($, y, M, S, ...x) {
    const b = $.currentPosition();
    if (b.offset += S, b.column += S, n) {
      const C = e ? or(M, b) : null, E = h1(y, C, {
        domain: LU,
        args: x
      });
      n(E);
    }
  }
  function i($, y, M) {
    const S = { type: $ };
    return e && (S.start = y, S.end = y, S.loc = { start: M, end: M }), S;
  }
  function r($, y, M, S) {
    e && ($.end = y, $.loc && ($.loc.end = M));
  }
  function a($, y) {
    const M = $.context(), S = i(3, M.offset, M.startLoc);
    return S.value = y, r(S, $.currentOffset(), $.currentPosition()), S;
  }
  function s($, y) {
    const M = $.context(), { lastOffset: S, lastStartLoc: x } = M, b = i(5, S, x);
    return b.index = parseInt(y, 10), $.nextToken(), r(b, $.currentOffset(), $.currentPosition()), b;
  }
  function l($, y) {
    const M = $.context(), { lastOffset: S, lastStartLoc: x } = M, b = i(4, S, x);
    return b.key = y, $.nextToken(), r(b, $.currentOffset(), $.currentPosition()), b;
  }
  function d($, y) {
    const M = $.context(), { lastOffset: S, lastStartLoc: x } = M, b = i(9, S, x);
    return b.value = y.replace(DU, NU), $.nextToken(), r(b, $.currentOffset(), $.currentPosition()), b;
  }
  function c($) {
    const y = $.nextToken(), M = $.context(), { lastOffset: S, lastStartLoc: x } = M, b = i(8, S, x);
    return y.type !== 11 ? (o($, de.UNEXPECTED_EMPTY_LINKED_MODIFIER, M.lastStartLoc, 0), b.value = "", r(b, S, x), {
      nextConsumeToken: y,
      node: b
    }) : (y.value == null && o($, de.UNEXPECTED_LEXICAL_ANALYSIS, M.lastStartLoc, 0, ln(y)), b.value = y.value || "", r(b, $.currentOffset(), $.currentPosition()), {
      node: b
    });
  }
  function u($, y) {
    const M = $.context(), S = i(7, M.offset, M.startLoc);
    return S.value = y, r(S, $.currentOffset(), $.currentPosition()), S;
  }
  function f($) {
    const y = $.context(), M = i(6, y.offset, y.startLoc);
    let S = $.nextToken();
    if (S.type === 8) {
      const x = c($);
      M.modifier = x.node, S = x.nextConsumeToken || $.nextToken();
    }
    switch (S.type !== 9 && o($, de.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, ln(S)), S = $.nextToken(), S.type === 2 && (S = $.nextToken()), S.type) {
      case 10:
        S.value == null && o($, de.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, ln(S)), M.key = u($, S.value || "");
        break;
      case 4:
        S.value == null && o($, de.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, ln(S)), M.key = l($, S.value || "");
        break;
      case 5:
        S.value == null && o($, de.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, ln(S)), M.key = s($, S.value || "");
        break;
      case 6:
        S.value == null && o($, de.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, ln(S)), M.key = d($, S.value || "");
        break;
      default: {
        o($, de.UNEXPECTED_EMPTY_LINKED_KEY, y.lastStartLoc, 0);
        const x = $.context(), b = i(7, x.offset, x.startLoc);
        return b.value = "", r(b, x.offset, x.startLoc), M.key = b, r(M, x.offset, x.startLoc), {
          nextConsumeToken: S,
          node: M
        };
      }
    }
    return r(M, $.currentOffset(), $.currentPosition()), {
      node: M
    };
  }
  function m($) {
    const y = $.context(), M = y.currentType === 1 ? $.currentOffset() : y.offset, S = y.currentType === 1 ? y.endLoc : y.startLoc, x = i(2, M, S);
    x.items = [];
    let b = null;
    do {
      const A = b || $.nextToken();
      switch (b = null, A.type) {
        case 0:
          A.value == null && o($, de.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, ln(A)), x.items.push(a($, A.value || ""));
          break;
        case 5:
          A.value == null && o($, de.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, ln(A)), x.items.push(s($, A.value || ""));
          break;
        case 4:
          A.value == null && o($, de.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, ln(A)), x.items.push(l($, A.value || ""));
          break;
        case 6:
          A.value == null && o($, de.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, ln(A)), x.items.push(d($, A.value || ""));
          break;
        case 7: {
          const T = f($);
          x.items.push(T.node), b = T.nextConsumeToken || null;
          break;
        }
      }
    } while (y.currentType !== 13 && y.currentType !== 1);
    const C = y.currentType === 1 ? y.lastOffset : $.currentOffset(), E = y.currentType === 1 ? y.lastEndLoc : $.currentPosition();
    return r(x, C, E), x;
  }
  function v($, y, M, S) {
    const x = $.context();
    let b = S.items.length === 0;
    const C = i(1, y, M);
    C.cases = [], C.cases.push(S);
    do {
      const E = m($);
      b || (b = E.items.length === 0), C.cases.push(E);
    } while (x.currentType !== 13);
    return b && o($, de.MUST_HAVE_MESSAGES_IN_PLURAL, M, 0), r(C, $.currentOffset(), $.currentPosition()), C;
  }
  function _($) {
    const y = $.context(), { offset: M, startLoc: S } = y, x = m($);
    return y.currentType === 13 ? x : v($, M, S, x);
  }
  function w($) {
    const y = OU($, no({}, t)), M = y.context(), S = i(0, M.offset, M.startLoc);
    return e && S.loc && (S.loc.source = $), S.body = _(y), t.onCacheKey && (S.cacheKey = t.onCacheKey($)), M.currentType !== 13 && o(y, de.UNEXPECTED_LEXICAL_ANALYSIS, M.lastStartLoc, 0, $[M.offset] || ""), r(S, y.currentOffset(), y.currentPosition()), S;
  }
  return { parse: w };
}
function ln(t) {
  if (t.type === 13)
    return "EOF";
  const e = (t.value || "").replace(/\r?\n/gu, "\\n");
  return e.length > 10 ? e.slice(0, 9) + "…" : e;
}
function ZU(t, e = {}) {
  const n = {
    ast: t,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (r) => (n.helpers.add(r), r) };
}
function Is(t, e) {
  for (let n = 0; n < t.length; n++)
    wa(t[n], e);
}
function wa(t, e) {
  switch (t.type) {
    case 1:
      Is(t.cases, e), e.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Is(t.items, e);
      break;
    case 6: {
      wa(t.key, e), e.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), e.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      e.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), e.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      e.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), e.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function BU(t, e = {}) {
  const n = ZU(t);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), t.body && wa(t.body, n);
  const o = n.context();
  t.helpers = Array.from(o.helpers);
}
function VU(t) {
  const e = t.body;
  return e.type === 2 ? As(e) : e.cases.forEach((n) => As(n)), t;
}
function As(t) {
  if (t.items.length === 1) {
    const e = t.items[0];
    (e.type === 3 || e.type === 9) && (t.static = e.value, delete e.value);
  } else {
    const e = [];
    for (let n = 0; n < t.items.length; n++) {
      const o = t.items[n];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      e.push(o.value);
    }
    if (e.length === t.items.length) {
      t.static = $a(e);
      for (let n = 0; n < t.items.length; n++) {
        const o = t.items[n];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const FU = "minifier";
function Vo(t) {
  switch (t.t = t.type, t.type) {
    case 0: {
      const e = t;
      Vo(e.body), e.b = e.body, delete e.body;
      break;
    }
    case 1: {
      const e = t, n = e.cases;
      for (let o = 0; o < n.length; o++)
        Vo(n[o]);
      e.c = n, delete e.cases;
      break;
    }
    case 2: {
      const e = t, n = e.items;
      for (let o = 0; o < n.length; o++)
        Vo(n[o]);
      e.i = n, delete e.items, e.static && (e.s = e.static, delete e.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const e = t;
      e.value && (e.v = e.value, delete e.value);
      break;
    }
    case 6: {
      const e = t;
      Vo(e.key), e.k = e.key, delete e.key, e.modifier && (Vo(e.modifier), e.m = e.modifier, delete e.modifier);
      break;
    }
    case 5: {
      const e = t;
      e.i = e.index, delete e.index;
      break;
    }
    case 4: {
      const e = t;
      e.k = e.key, delete e.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw h1(de.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: FU,
          args: [t.type]
        });
  }
  delete t.type;
}
const HU = "parser";
function UU(t, e) {
  const { sourceMap: n, filename: o, breakLineCode: i, needIndent: r } = e, a = e.location !== !1, s = {
    filename: o,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: i,
    needIndent: r,
    indentLevel: 0
  };
  a && t.loc && (s.source = t.loc.source);
  const l = () => s;
  function d(w, $) {
    s.code += w;
  }
  function c(w, $ = !0) {
    const y = $ ? i : "";
    d(r ? y + "  ".repeat(w) : y);
  }
  function u(w = !0) {
    const $ = ++s.indentLevel;
    w && c($);
  }
  function f(w = !0) {
    const $ = --s.indentLevel;
    w && c($);
  }
  function m() {
    c(s.indentLevel);
  }
  return {
    context: l,
    push: d,
    indent: u,
    deindent: f,
    newline: m,
    helper: (w) => `_${w}`,
    needIndent: () => s.needIndent
  };
}
function zU(t, e) {
  const { helper: n } = t;
  t.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), l1(t, e.key), e.modifier ? (t.push(", "), l1(t, e.modifier), t.push(", _type")) : t.push(", undefined, _type"), t.push(")");
}
function WU(t, e) {
  const { helper: n, needIndent: o } = t;
  t.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), t.indent(o());
  const i = e.items.length;
  for (let r = 0; r < i && (l1(t, e.items[r]), r !== i - 1); r++)
    t.push(", ");
  t.deindent(o()), t.push("])");
}
function jU(t, e) {
  const { helper: n, needIndent: o } = t;
  if (e.cases.length > 1) {
    t.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), t.indent(o());
    const i = e.cases.length;
    for (let r = 0; r < i && (l1(t, e.cases[r]), r !== i - 1); r++)
      t.push(", ");
    t.deindent(o()), t.push("])");
  }
}
function GU(t, e) {
  e.body ? l1(t, e.body) : t.push("null");
}
function l1(t, e) {
  const { helper: n } = t;
  switch (e.type) {
    case 0:
      GU(t, e);
      break;
    case 1:
      jU(t, e);
      break;
    case 2:
      WU(t, e);
      break;
    case 6:
      zU(t, e);
      break;
    case 8:
      t.push(JSON.stringify(e.value), e);
      break;
    case 7:
      t.push(JSON.stringify(e.value), e);
      break;
    case 5:
      t.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${e.index}))`, e);
      break;
    case 4:
      t.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(e.key)}))`, e);
      break;
    case 9:
      t.push(JSON.stringify(e.value), e);
      break;
    case 3:
      t.push(JSON.stringify(e.value), e);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw h1(de.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: HU,
          args: [e.type]
        });
  }
}
const YU = (t, e = {}) => {
  const n = ce(e.mode) ? e.mode : "normal", o = ce(e.filename) ? e.filename : "message.intl", i = !!e.sourceMap, r = e.breakLineCode != null ? e.breakLineCode : n === "arrow" ? ";" : `
`, a = e.needIndent ? e.needIndent : n !== "arrow", s = t.helpers || [], l = UU(t, {
    mode: n,
    filename: o,
    sourceMap: i,
    breakLineCode: r,
    needIndent: a
  });
  l.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(a), s.length > 0 && (l.push(`const { ${$a(s.map((u) => `${u}: _${u}`), ", ")} } = ctx`), l.newline()), l.push("return "), l1(l, t), l.deindent(a), l.push("}"), delete t.helpers;
  const { code: d, map: c } = l.context();
  return {
    ast: t,
    code: d,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function XU(t, e = {}) {
  const n = no({}, e), o = !!n.jit, i = !!n.minify, r = n.optimize == null ? !0 : n.optimize, s = RU(n).parse(t);
  return o ? (r && VU(s), i && Vo(s), { ast: s, code: "" }) : (BU(s, n), YU(s, n));
}
/*!
  * core-base v10.0.0-beta.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function KU() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (_U().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const oo = [];
oo[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
oo[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
oo[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
oo[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
oo[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
oo[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
oo[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const qU = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function JU(t) {
  return qU.test(t);
}
function QU(t) {
  const e = t.charCodeAt(0), n = t.charCodeAt(t.length - 1);
  return e === n && (e === 34 || e === 39) ? t.slice(1, -1) : t;
}
function ez(t) {
  if (t == null)
    return "o";
  switch (t.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return t;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function tz(t) {
  const e = t.trim();
  return t.charAt(0) === "0" && isNaN(parseInt(t)) ? !1 : JU(e) ? QU(e) : "*" + e;
}
function nz(t) {
  const e = [];
  let n = -1, o = 0, i = 0, r, a, s, l, d, c, u;
  const f = [];
  f[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = s : a += s;
  }, f[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (e.push(a), a = void 0);
  }, f[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    f[
      0
      /* Actions.APPEND */
    ](), i++;
  }, f[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (i > 0)
      i--, o = 4, f[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (i = 0, a === void 0 || (a = tz(a), a === !1))
        return !1;
      f[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function m() {
    const v = t[n + 1];
    if (o === 5 && v === "'" || o === 6 && v === '"')
      return n++, s = "\\" + v, f[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (n++, r = t[n], !(r === "\\" && m())) {
      if (l = ez(r), u = oo[o], d = u[l] || u.l || 8, d === 8 || (o = d[0], d[1] !== void 0 && (c = f[d[1]], c && (s = r, c() === !1))))
        return;
      if (o === 7)
        return e;
    }
}
const ks = /* @__PURE__ */ new Map();
function oz(t, e) {
  return Ge(t) ? t[e] : null;
}
function iz(t, e) {
  if (!Ge(t))
    return null;
  let n = ks.get(e);
  if (n || (n = nz(e), n && ks.set(e, n)), !n)
    return null;
  const o = n.length;
  let i = t, r = 0;
  for (; r < o; ) {
    const a = i[n[r]];
    if (a === void 0 || Ue(i))
      return null;
    i = a, r++;
  }
  return i;
}
const rz = (t) => t, az = (t) => "", sz = "text", lz = (t) => t.length === 0 ? "" : $a(t), dz = gU;
function Es(t, e) {
  return t = Math.abs(t), e === 2 ? t ? t > 1 ? 1 : 0 : 1 : t ? Math.min(t, 2) : 0;
}
function cz(t) {
  const e = Rt(t.pluralIndex) ? t.pluralIndex : -1;
  return t.named && (Rt(t.named.count) || Rt(t.named.n)) ? Rt(t.named.count) ? t.named.count : Rt(t.named.n) ? t.named.n : e : e;
}
function uz(t, e) {
  e.count || (e.count = t), e.n || (e.n = t);
}
function hz(t = {}) {
  const e = t.locale, n = cz(t), o = Ge(t.pluralRules) && ce(e) && Ue(t.pluralRules[e]) ? t.pluralRules[e] : Es, i = Ge(t.pluralRules) && ce(e) && Ue(t.pluralRules[e]) ? Es : void 0, r = ($) => $[o(n, $.length, i)], a = t.list || [], s = ($) => a[$], l = t.named || {};
  Rt(t.pluralIndex) && uz(n, l);
  const d = ($) => l[$];
  function c($) {
    const y = Ue(t.messages) ? t.messages($) : Ge(t.messages) ? t.messages[$] : !1;
    return y || (t.parent ? t.parent.message($) : az);
  }
  const u = ($) => t.modifiers ? t.modifiers[$] : rz, f = Pe(t.processor) && Ue(t.processor.normalize) ? t.processor.normalize : lz, m = Pe(t.processor) && Ue(t.processor.interpolate) ? t.processor.interpolate : dz, v = Pe(t.processor) && ce(t.processor.type) ? t.processor.type : sz, w = {
    list: s,
    named: d,
    plural: r,
    linked: ($, ...y) => {
      const [M, S] = y;
      let x = "text", b = "";
      y.length === 1 ? Ge(M) ? (b = M.modifier || b, x = M.type || x) : ce(M) && (b = M || b) : y.length === 2 && (ce(M) && (b = M || b), ce(S) && (x = S || x));
      const C = c($)(w), E = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        x === "vnode" && _n(C) && b ? C[0] : C
      );
      return b ? u(b)(E, x) : E;
    },
    message: c,
    type: v,
    interpolate: m,
    normalize: f,
    values: no({}, a, l)
  };
  return w;
}
let U1 = null;
function fz(t) {
  U1 = t;
}
function mz(t, e, n) {
  U1 && U1.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: t,
    version: e,
    meta: n
  });
}
const pz = /* @__PURE__ */ _z("function:translate");
function _z(t) {
  return (e) => U1 && U1.emit(t, e);
}
const Mt = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, vz = 8, gz = {
  [Mt.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Mt.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Mt.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Mt.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Mt.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Mt.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Mt.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Io(t, ...e) {
  return va(gz[t], ...e);
}
const at = {
  INVALID_ARGUMENT: MU,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, $z = 24;
function En(t) {
  return h1(t, null, process.env.NODE_ENV !== "production" ? { messages: wz } : void 0);
}
const wz = {
  [at.INVALID_ARGUMENT]: "Invalid arguments",
  [at.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [at.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [at.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [at.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [at.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [at.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function ya(t, e) {
  return e.locale != null ? Ps(e.locale) : Ps(t.locale);
}
let I0;
function Ps(t) {
  if (ce(t))
    return t;
  if (Ue(t)) {
    if (t.resolvedOnce && I0 != null)
      return I0;
    if (t.constructor.name === "Function") {
      const e = t();
      if (vU(e))
        throw En(at.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return I0 = e;
    } else
      throw En(at.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw En(at.NOT_SUPPORT_LOCALE_TYPE);
}
function yz(t, e, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ..._n(e) ? e : Ge(e) ? Object.keys(e) : ce(e) ? [e] : [n]
  ])];
}
function a2(t, e, n) {
  const o = ce(n) ? n : Oi, i = t;
  i.__localeChainCache || (i.__localeChainCache = /* @__PURE__ */ new Map());
  let r = i.__localeChainCache.get(o);
  if (!r) {
    r = [];
    let a = [n];
    for (; _n(a); )
      a = Ts(r, a, e);
    const s = _n(e) || !Pe(e) ? e : e.default ? e.default : null;
    a = ce(s) ? [s] : s, _n(a) && Ts(r, a, !1), i.__localeChainCache.set(o, r);
  }
  return r;
}
function Ts(t, e, n) {
  let o = !0;
  for (let i = 0; i < e.length && bt(o); i++) {
    const r = e[i];
    ce(r) && (o = Mz(t, e[i], n));
  }
  return o;
}
function Mz(t, e, n) {
  let o;
  const i = e.split("-");
  do {
    const r = i.join("-");
    o = Cz(t, r, n), i.splice(-1, 1);
  } while (i.length && o === !0);
  return o;
}
function Cz(t, e, n) {
  let o = !1;
  if (!t.includes(e) && (o = !0, e)) {
    o = e[e.length - 1] !== "!";
    const i = e.replace(/!/g, "");
    t.push(i), (_n(n) || Pe(n)) && n[i] && (o = n[i]);
  }
  return o;
}
const bz = "10.0.0-beta.5", e0 = -1, Oi = "en-US", Li = "", Os = (t) => `${t.charAt(0).toLocaleUpperCase()}${t.substr(1)}`;
function xz() {
  return {
    upper: (t, e) => e === "text" && ce(t) ? t.toUpperCase() : e === "vnode" && Ge(t) && "__v_isVNode" in t ? t.children.toUpperCase() : t,
    lower: (t, e) => e === "text" && ce(t) ? t.toLowerCase() : e === "vnode" && Ge(t) && "__v_isVNode" in t ? t.children.toLowerCase() : t,
    capitalize: (t, e) => e === "text" && ce(t) ? Os(t) : e === "vnode" && Ge(t) && "__v_isVNode" in t ? Os(t.children) : t
  };
}
let s2;
function Sz(t) {
  s2 = t;
}
let l2;
function Iz(t) {
  l2 = t;
}
let d2;
function Az(t) {
  d2 = t;
}
let c2 = null;
const kz = /* @__NO_SIDE_EFFECTS__ */ (t) => {
  c2 = t;
}, Ez = /* @__NO_SIDE_EFFECTS__ */ () => c2;
let u2 = null;
const Ls = (t) => {
  u2 = t;
}, Pz = () => u2;
let Ds = 0;
function Tz(t = {}) {
  const e = Ue(t.onWarn) ? t.onWarn : ri, n = ce(t.version) ? t.version : bz, o = ce(t.locale) || Ue(t.locale) ? t.locale : Oi, i = Ue(o) ? Oi : o, r = _n(t.fallbackLocale) || Pe(t.fallbackLocale) || ce(t.fallbackLocale) || t.fallbackLocale === !1 ? t.fallbackLocale : i, a = Pe(t.messages) ? t.messages : { [i]: {} }, s = Pe(t.datetimeFormats) ? t.datetimeFormats : { [i]: {} }, l = Pe(t.numberFormats) ? t.numberFormats : { [i]: {} }, d = no({}, t.modifiers || {}, xz()), c = t.pluralRules || {}, u = Ue(t.missing) ? t.missing : null, f = bt(t.missingWarn) || ys(t.missingWarn) ? t.missingWarn : !0, m = bt(t.fallbackWarn) || ys(t.fallbackWarn) ? t.fallbackWarn : !0, v = !!t.fallbackFormat, _ = !!t.unresolving, w = Ue(t.postTranslation) ? t.postTranslation : null, $ = Pe(t.processor) ? t.processor : null, y = bt(t.warnHtmlMessage) ? t.warnHtmlMessage : !0, M = !!t.escapeParameter, S = Ue(t.messageCompiler) ? t.messageCompiler : s2;
  process.env.NODE_ENV !== "production" && Ue(t.messageCompiler) && wU(Io(Mt.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const x = Ue(t.messageResolver) ? t.messageResolver : l2 || oz, b = Ue(t.localeFallbacker) ? t.localeFallbacker : d2 || yz, C = Ge(t.fallbackContext) ? t.fallbackContext : void 0, E = t, A = Ge(E.__datetimeFormatters) ? E.__datetimeFormatters : /* @__PURE__ */ new Map(), T = Ge(E.__numberFormatters) ? E.__numberFormatters : /* @__PURE__ */ new Map(), k = Ge(E.__meta) ? E.__meta : {};
  Ds++;
  const L = {
    version: n,
    cid: Ds,
    locale: o,
    fallbackLocale: r,
    messages: a,
    modifiers: d,
    pluralRules: c,
    missing: u,
    missingWarn: f,
    fallbackWarn: m,
    fallbackFormat: v,
    unresolving: _,
    postTranslation: w,
    processor: $,
    warnHtmlMessage: y,
    escapeParameter: M,
    messageCompiler: S,
    messageResolver: x,
    localeFallbacker: b,
    fallbackContext: C,
    onWarn: e,
    __meta: k
  };
  return L.datetimeFormats = s, L.numberFormats = l, L.__datetimeFormatters = A, L.__numberFormatters = T, process.env.NODE_ENV !== "production" && (L.__v_emitter = E.__v_emitter != null ? E.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && mz(L, n, k), L;
}
function t0(t, e) {
  return t instanceof RegExp ? t.test(e) : t;
}
function h2(t, e) {
  return t instanceof RegExp ? t.test(e) : t;
}
function Ma(t, e, n, o, i) {
  const { missing: r, onWarn: a } = t;
  if (process.env.NODE_ENV !== "production") {
    const s = t.__v_emitter;
    s && s.emit("missing", {
      locale: n,
      key: e,
      type: i,
      groupId: `${i}:${e}`
    });
  }
  if (r !== null) {
    const s = r(t, n, e, i);
    return ce(s) ? s : e;
  } else
    return process.env.NODE_ENV !== "production" && h2(o, e) && a(Io(Mt.NOT_FOUND_KEY, { key: e, locale: n })), e;
}
function $1(t, e, n) {
  const o = t;
  o.__localeChainCache = /* @__PURE__ */ new Map(), t.localeFallbacker(t, n, e);
}
function f2(t, e) {
  return t === e ? !1 : t.split("-")[0] === e.split("-")[0];
}
function Oz(t, e) {
  const n = e.indexOf(t);
  if (n === -1)
    return !1;
  for (let o = n + 1; o < e.length; o++)
    if (f2(t, e[o]))
      return !0;
  return !1;
}
function A0(t) {
  return (n) => Lz(n, t);
}
function Lz(t, e) {
  const n = e.b || e.body;
  if ((n.t || n.type) === 1) {
    const o = n, i = o.c || o.cases;
    return t.plural(i.reduce((r, a) => [
      ...r,
      Ns(t, a)
    ], []));
  } else
    return Ns(t, n);
}
function Ns(t, e) {
  const n = e.s || e.static;
  if (n)
    return t.type === "text" ? n : t.normalize([n]);
  {
    const o = (e.i || e.items).reduce((i, r) => [...i, ir(t, r)], []);
    return t.normalize(o);
  }
}
function ir(t, e) {
  const n = e.t || e.type;
  switch (n) {
    case 3: {
      const o = e;
      return o.v || o.value;
    }
    case 9: {
      const o = e;
      return o.v || o.value;
    }
    case 4: {
      const o = e;
      return t.interpolate(t.named(o.k || o.key));
    }
    case 5: {
      const o = e;
      return t.interpolate(t.list(o.i != null ? o.i : o.index));
    }
    case 6: {
      const o = e, i = o.m || o.modifier;
      return t.linked(ir(t, o.k || o.key), i ? ir(t, i) : void 0, t.type);
    }
    case 7: {
      const o = e;
      return o.v || o.value;
    }
    case 8: {
      const o = e;
      return o.v || o.value;
    }
    default:
      throw new Error(`unhandled node type on format message part: ${n}`);
  }
}
const Dz = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Nz(t, e) {
  e && SU(t) && ri(va(Dz, { source: t }));
}
const Rz = (t) => t;
let ui = /* @__PURE__ */ Object.create(null);
const Ao = (t) => Ge(t) && (t.t === 0 || t.type === 0) && ("b" in t || "body" in t);
function Zz(t, e = {}) {
  let n = !1;
  const o = e.onError || bU;
  return e.onError = (i) => {
    n = !0, o(i);
  }, { ...XU(t, e), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function Bz(t, e) {
  if (ce(t)) {
    const n = bt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Nz(t, n);
    const i = (e.onCacheKey || Rz)(t), r = ui[i];
    if (r)
      return r;
    const { ast: a, detectError: s } = Zz(t, {
      ...e,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = A0(a);
    return s ? l : ui[i] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !Ao(t))
      return ri(`the message that is resolve with key '${e.key}' is not supported for jit compilation`), () => t;
    const n = t.cacheKey;
    if (n) {
      const o = ui[n];
      return o || (ui[n] = A0(t));
    } else
      return A0(t);
  }
}
const Rs = () => "", Yt = (t) => Ue(t);
function Zs(t, ...e) {
  const { fallbackFormat: n, postTranslation: o, unresolving: i, messageCompiler: r, fallbackLocale: a, messages: s } = t, [l, d] = rr(...e), c = bt(d.missingWarn) ? d.missingWarn : t.missingWarn, u = bt(d.fallbackWarn) ? d.fallbackWarn : t.fallbackWarn, f = bt(d.escapeParameter) ? d.escapeParameter : t.escapeParameter, m = !!d.resolvedMessage, v = ce(d.default) || bt(d.default) ? bt(d.default) ? r ? l : () => l : d.default : n ? r ? l : () => l : null, _ = n || v != null && (ce(v) || Ue(v)), w = ya(t, d);
  f && Vz(d);
  let [$, y, M] = m ? [
    l,
    w,
    s[w] || {}
  ] : m2(t, l, w, a, u, c), S = $, x = l;
  if (!m && !(ce(S) || Ao(S) || Yt(S)) && _ && (S = v, x = S), !m && (!(ce(S) || Ao(S) || Yt(S)) || !ce(y)))
    return i ? e0 : l;
  if (process.env.NODE_ENV !== "production" && ce(S) && t.messageCompiler == null)
    return ri(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let b = !1;
  const C = () => {
    b = !0;
  }, E = Yt(S) ? S : p2(t, l, y, S, x, C);
  if (b)
    return S;
  const A = zz(t, y, M, d), T = hz(A), k = Fz(t, E, T), L = o ? o(k, l) : k;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const V = {
      timestamp: Date.now(),
      key: ce(l) ? l : Yt(S) ? S.key : "",
      locale: y || (Yt(S) ? S.locale : ""),
      format: ce(S) ? S : Yt(S) ? S.source : "",
      message: L
    };
    V.meta = no({}, t.__meta, /* @__PURE__ */ Ez() || {}), pz(V);
  }
  return L;
}
function Vz(t) {
  _n(t.list) ? t.list = t.list.map((e) => ce(e) ? Cs(e) : e) : Ge(t.named) && Object.keys(t.named).forEach((e) => {
    ce(t.named[e]) && (t.named[e] = Cs(t.named[e]));
  });
}
function m2(t, e, n, o, i, r) {
  const { messages: a, onWarn: s, messageResolver: l, localeFallbacker: d } = t, c = d(t, o, n);
  let u = {}, f, m = null, v = n, _ = null;
  const w = "translate";
  for (let $ = 0; $ < c.length; $++) {
    if (f = _ = c[$], process.env.NODE_ENV !== "production" && n !== f && !f2(n, f) && t0(i, e) && s(Io(Mt.FALLBACK_TO_TRANSLATE, {
      key: e,
      target: f
    })), process.env.NODE_ENV !== "production" && n !== f) {
      const x = t.__v_emitter;
      x && x.emit("fallback", {
        type: w,
        key: e,
        from: v,
        to: _,
        groupId: `${w}:${e}`
      });
    }
    u = a[f] || {};
    let y = null, M, S;
    if (process.env.NODE_ENV !== "production" && xo && (y = window.performance.now(), M = "intlify-message-resolve-start", S = "intlify-message-resolve-end", Bt && Bt(M)), (m = l(u, e)) === null && (m = u[e]), process.env.NODE_ENV !== "production" && xo) {
      const x = window.performance.now(), b = t.__v_emitter;
      b && y && m && b.emit("message-resolve", {
        type: "message-resolve",
        key: e,
        message: m,
        time: x - y,
        groupId: `${w}:${e}`
      }), M && S && Bt && So && (Bt(S), So("intlify message resolve", M, S));
    }
    if (ce(m) || Ao(m) || Yt(m))
      break;
    if (!Oz(f, c)) {
      const x = Ma(
        t,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        e,
        f,
        r,
        w
      );
      x !== e && (m = x);
    }
    v = _;
  }
  return [m, f, u];
}
function p2(t, e, n, o, i, r) {
  const { messageCompiler: a, warnHtmlMessage: s } = t;
  if (Yt(o)) {
    const f = o;
    return f.locale = f.locale || n, f.key = f.key || e, f;
  }
  if (a == null) {
    const f = () => o;
    return f.locale = n, f.key = e, f;
  }
  let l = null, d, c;
  process.env.NODE_ENV !== "production" && xo && (l = window.performance.now(), d = "intlify-message-compilation-start", c = "intlify-message-compilation-end", Bt && Bt(d));
  const u = a(o, Hz(t, n, i, o, s, r));
  if (process.env.NODE_ENV !== "production" && xo) {
    const f = window.performance.now(), m = t.__v_emitter;
    m && l && m.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: f - l,
      groupId: `translate:${e}`
    }), d && c && Bt && So && (Bt(c), So("intlify message compilation", d, c));
  }
  return u.locale = n, u.key = e, u.source = o, u;
}
function Fz(t, e, n) {
  let o = null, i, r;
  process.env.NODE_ENV !== "production" && xo && (o = window.performance.now(), i = "intlify-message-evaluation-start", r = "intlify-message-evaluation-end", Bt && Bt(i));
  const a = e(n);
  if (process.env.NODE_ENV !== "production" && xo) {
    const s = window.performance.now(), l = t.__v_emitter;
    l && o && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: a,
      time: s - o,
      groupId: `translate:${e.key}`
    }), i && r && Bt && So && (Bt(r), So("intlify message evaluation", i, r));
  }
  return a;
}
function rr(...t) {
  const [e, n, o] = t, i = {};
  if (!ce(e) && !Rt(e) && !Yt(e) && !Ao(e))
    throw En(at.INVALID_ARGUMENT);
  const r = Rt(e) ? String(e) : (Yt(e), e);
  return Rt(n) ? i.plural = n : ce(n) ? i.default = n : Pe(n) && !ga(n) ? i.named = n : _n(n) && (i.list = n), Rt(o) ? i.plural = o : ce(o) ? i.default = o : Pe(o) && no(i, o), [r, i];
}
function Hz(t, e, n, o, i, r) {
  return {
    locale: e,
    key: n,
    warnHtmlMessage: i,
    onError: (a) => {
      if (r && r(a), process.env.NODE_ENV !== "production") {
        const s = Uz(o), l = `Message compilation error: ${a.message}`, d = a.location && s && $U(s, a.location.start.offset, a.location.end.offset), c = t.__v_emitter;
        c && s && c.emit("compile-error", {
          message: s,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(d ? `${l}
${d}` : l);
      } else
        throw a;
    },
    onCacheKey: (a) => fU(e, n, a)
  };
}
function Uz(t) {
  if (ce(t))
    return t;
  if (t.loc && t.loc.source)
    return t.loc.source;
}
function zz(t, e, n, o) {
  const { modifiers: i, pluralRules: r, messageResolver: a, fallbackLocale: s, fallbackWarn: l, missingWarn: d, fallbackContext: c } = t, f = {
    locale: e,
    modifiers: i,
    pluralRules: r,
    messages: (m) => {
      let v = a(n, m);
      if (v == null && c) {
        const [, , _] = m2(c, m, e, s, l, d);
        v = a(_, m);
      }
      if (ce(v) || Ao(v)) {
        let _ = !1;
        const $ = p2(t, m, e, v, m, () => {
          _ = !0;
        });
        return _ ? Rs : $;
      } else return Yt(v) ? v : Rs;
    }
  };
  return t.processor && (f.processor = t.processor), o.list && (f.list = o.list), o.named && (f.named = o.named), Rt(o.plural) && (f.pluralIndex = o.plural), f;
}
const Bs = typeof Intl < "u", _2 = {
  dateTimeFormat: Bs && typeof Intl.DateTimeFormat < "u",
  numberFormat: Bs && typeof Intl.NumberFormat < "u"
};
function Vs(t, ...e) {
  const { datetimeFormats: n, unresolving: o, fallbackLocale: i, onWarn: r, localeFallbacker: a } = t, { __datetimeFormatters: s } = t;
  if (process.env.NODE_ENV !== "production" && !_2.dateTimeFormat)
    return r(Io(Mt.CANNOT_FORMAT_DATE)), Li;
  const [l, d, c, u] = ar(...e), f = bt(c.missingWarn) ? c.missingWarn : t.missingWarn, m = bt(c.fallbackWarn) ? c.fallbackWarn : t.fallbackWarn, v = !!c.part, _ = ya(t, c), w = a(
    t,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    _
  );
  if (!ce(l) || l === "")
    return new Intl.DateTimeFormat(_, u).format(d);
  let $ = {}, y, M = null, S = _, x = null;
  const b = "datetime format";
  for (let A = 0; A < w.length; A++) {
    if (y = x = w[A], process.env.NODE_ENV !== "production" && _ !== y && t0(m, l) && r(Io(Mt.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: y
    })), process.env.NODE_ENV !== "production" && _ !== y) {
      const T = t.__v_emitter;
      T && T.emit("fallback", {
        type: b,
        key: l,
        from: S,
        to: x,
        groupId: `${b}:${l}`
      });
    }
    if ($ = n[y] || {}, M = $[l], Pe(M))
      break;
    Ma(t, l, y, f, b), S = x;
  }
  if (!Pe(M) || !ce(y))
    return o ? e0 : l;
  let C = `${y}__${l}`;
  ga(u) || (C = `${C}__${JSON.stringify(u)}`);
  let E = s.get(C);
  return E || (E = new Intl.DateTimeFormat(y, no({}, M, u)), s.set(C, E)), v ? E.formatToParts(d) : E.format(d);
}
const v2 = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function ar(...t) {
  const [e, n, o, i] = t, r = {};
  let a = {}, s;
  if (ce(e)) {
    const l = e.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw En(at.INVALID_ISO_DATE_ARGUMENT);
    const d = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    s = new Date(d);
    try {
      s.toISOString();
    } catch {
      throw En(at.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (pU(e)) {
    if (isNaN(e.getTime()))
      throw En(at.INVALID_DATE_ARGUMENT);
    s = e;
  } else if (Rt(e))
    s = e;
  else
    throw En(at.INVALID_ARGUMENT);
  return ce(n) ? r.key = n : Pe(n) && Object.keys(n).forEach((l) => {
    v2.includes(l) ? a[l] = n[l] : r[l] = n[l];
  }), ce(o) ? r.locale = o : Pe(o) && (a = o), Pe(i) && (a = i), [r.key || "", s, r, a];
}
function Fs(t, e, n) {
  const o = t;
  for (const i in n) {
    const r = `${e}__${i}`;
    o.__datetimeFormatters.has(r) && o.__datetimeFormatters.delete(r);
  }
}
function Hs(t, ...e) {
  const { numberFormats: n, unresolving: o, fallbackLocale: i, onWarn: r, localeFallbacker: a } = t, { __numberFormatters: s } = t;
  if (process.env.NODE_ENV !== "production" && !_2.numberFormat)
    return r(Io(Mt.CANNOT_FORMAT_NUMBER)), Li;
  const [l, d, c, u] = sr(...e), f = bt(c.missingWarn) ? c.missingWarn : t.missingWarn, m = bt(c.fallbackWarn) ? c.fallbackWarn : t.fallbackWarn, v = !!c.part, _ = ya(t, c), w = a(
    t,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    _
  );
  if (!ce(l) || l === "")
    return new Intl.NumberFormat(_, u).format(d);
  let $ = {}, y, M = null, S = _, x = null;
  const b = "number format";
  for (let A = 0; A < w.length; A++) {
    if (y = x = w[A], process.env.NODE_ENV !== "production" && _ !== y && t0(m, l) && r(Io(Mt.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: y
    })), process.env.NODE_ENV !== "production" && _ !== y) {
      const T = t.__v_emitter;
      T && T.emit("fallback", {
        type: b,
        key: l,
        from: S,
        to: x,
        groupId: `${b}:${l}`
      });
    }
    if ($ = n[y] || {}, M = $[l], Pe(M))
      break;
    Ma(t, l, y, f, b), S = x;
  }
  if (!Pe(M) || !ce(y))
    return o ? e0 : l;
  let C = `${y}__${l}`;
  ga(u) || (C = `${C}__${JSON.stringify(u)}`);
  let E = s.get(C);
  return E || (E = new Intl.NumberFormat(y, no({}, M, u)), s.set(C, E)), v ? E.formatToParts(d) : E.format(d);
}
const g2 = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function sr(...t) {
  const [e, n, o, i] = t, r = {};
  let a = {};
  if (!Rt(e))
    throw En(at.INVALID_ARGUMENT);
  const s = e;
  return ce(n) ? r.key = n : Pe(n) && Object.keys(n).forEach((l) => {
    g2.includes(l) ? a[l] = n[l] : r[l] = n[l];
  }), ce(o) ? r.locale = o : Pe(o) && (a = o), Pe(i) && (a = i), [r.key || "", s, r, a];
}
function Us(t, e, n) {
  const o = t;
  for (const i in n) {
    const r = `${e}__${i}`;
    o.__numberFormatters.has(r) && o.__numberFormatters.delete(r);
  }
}
KU();
/*!
  * vue-i18n v10.0.0-beta.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const Wz = "10.0.0-beta.5";
function jz() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (o2().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const vo = {
  FALLBACK_TO_ROOT: vz,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  DEPRECATE_TC: 11
}, Gz = {
  [vo.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [vo.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [vo.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [vo.DEPRECATE_TC]: "'tc' and '$tc' has been deprecated in v10. Use 't' or '$t' instead. 'tc' and '$tc’ are going to remove in v11."
};
function Ca(t, ...e) {
  return aU(Gz[t], ...e);
}
const ot = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: $z,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function z1(t, ...e) {
  return h1(t, null, process.env.NODE_ENV !== "production" ? { messages: Yz, args: e } : void 0);
}
const Yz = {
  [ot.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [ot.INVALID_ARGUMENT]: "Invalid argument",
  [ot.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [ot.NOT_INSTALLED]: "Need to install with `app.use` function",
  [ot.UNEXPECTED_ERROR]: "Unexpected error",
  [ot.REQUIRED_VALUE]: "Required in value: {0}",
  [ot.INVALID_VALUE]: "Invalid value",
  [ot.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [ot.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [ot.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [ot.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, lr = /* @__PURE__ */ Rn("__translateVNode"), dr = /* @__PURE__ */ Rn("__datetimeParts"), cr = /* @__PURE__ */ Rn("__numberParts"), ur = /* @__PURE__ */ Rn("__enableEmitter"), hr = /* @__PURE__ */ Rn("__disableEmitter"), Xz = Rn("__setPluralRules"), Kz = /* @__PURE__ */ Rn("__injectWithOption"), fr = /* @__PURE__ */ Rn("__dispose");
function W1(t) {
  if (!xt(t))
    return t;
  for (const e in t)
    if (Ti(t, e))
      if (!e.includes("."))
        xt(t[e]) && W1(t[e]);
      else {
        const n = e.split("."), o = n.length - 1;
        let i = t, r = !1;
        for (let a = 0; a < o; a++) {
          if (n[a] in i || (i[n[a]] = {}), !xt(i[n[a]])) {
            process.env.NODE_ENV !== "production" && _a(Ca(vo.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), r = !0;
            break;
          }
          i = i[n[a]];
        }
        r || (i[n[o]] = t[e], delete t[e]), xt(i[n[o]]) && W1(i[n[o]]);
      }
  return t;
}
function $2(t, e) {
  const { messages: n, __i18n: o, messageResolver: i, flatJson: r } = e, a = xn(n) ? n : kn(o) ? {} : { [t]: {} };
  if (kn(o) && o.forEach((s) => {
    if ("locale" in s && "resource" in s) {
      const { locale: l, resource: d } = s;
      l ? (a[l] = a[l] || {}, $i(d, a[l])) : $i(d, a);
    } else
      je(s) && $i(JSON.parse(s), a);
  }), i == null && r)
    for (const s in a)
      Ti(a, s) && W1(a[s]);
  return a;
}
function w2(t) {
  return t.type;
}
function qz(t, e, n) {
  let o = xt(e.messages) ? e.messages : {};
  "__i18nGlobal" in n && (o = $2(t.locale.value, {
    messages: o,
    __i18n: n.__i18nGlobal
  }));
  const i = Object.keys(o);
  i.length && i.forEach((r) => {
    t.mergeLocaleMessage(r, o[r]);
  });
  {
    if (xt(e.datetimeFormats)) {
      const r = Object.keys(e.datetimeFormats);
      r.length && r.forEach((a) => {
        t.mergeDateTimeFormat(a, e.datetimeFormats[a]);
      });
    }
    if (xt(e.numberFormats)) {
      const r = Object.keys(e.numberFormats);
      r.length && r.forEach((a) => {
        t.mergeNumberFormat(a, e.numberFormats[a]);
      });
    }
  }
}
function zs(t) {
  return q(b3, null, t, 0);
}
const Ws = "__INTLIFY_META__", js = () => [], Jz = () => !1;
let Gs = 0;
function Ys(t) {
  return (e, n, o, i) => t(n, o, To() || void 0, i);
}
const Qz = /* @__NO_SIDE_EFFECTS__ */ () => {
  const t = To();
  let e = null;
  return t && (e = w2(t)[Ws]) ? { [Ws]: e } : null;
};
function eW(t = {}) {
  const { __root: e, __injectWithOption: n } = t, o = e === void 0, i = t.flatJson, r = gs ? U : fd;
  let a = uo(t.inheritLocale) ? t.inheritLocale : !0;
  const s = r(
    // prettier-ignore
    e && a ? e.locale.value : je(t.locale) ? t.locale : Oi
  ), l = r(
    // prettier-ignore
    e && a ? e.fallbackLocale.value : je(t.fallbackLocale) || kn(t.fallbackLocale) || xn(t.fallbackLocale) || t.fallbackLocale === !1 ? t.fallbackLocale : s.value
  ), d = r($2(s.value, t)), c = r(xn(t.datetimeFormats) ? t.datetimeFormats : { [s.value]: {} }), u = r(xn(t.numberFormats) ? t.numberFormats : { [s.value]: {} });
  let f = e ? e.missingWarn : uo(t.missingWarn) || $s(t.missingWarn) ? t.missingWarn : !0, m = e ? e.fallbackWarn : uo(t.fallbackWarn) || $s(t.fallbackWarn) ? t.fallbackWarn : !0, v = e ? e.fallbackRoot : uo(t.fallbackRoot) ? t.fallbackRoot : !0, _ = !!t.fallbackFormat, w = di(t.missing) ? t.missing : null, $ = di(t.missing) ? Ys(t.missing) : null, y = di(t.postTranslation) ? t.postTranslation : null, M = e ? e.warnHtmlMessage : uo(t.warnHtmlMessage) ? t.warnHtmlMessage : !0, S = !!t.escapeParameter;
  const x = e ? e.modifiers : xn(t.modifiers) ? t.modifiers : {};
  let b = t.pluralRules || e && e.pluralRules, C;
  C = (() => {
    o && Ls(null);
    const j = {
      version: Wz,
      locale: s.value,
      fallbackLocale: l.value,
      messages: d.value,
      modifiers: x,
      pluralRules: b,
      missing: $ === null ? void 0 : $,
      missingWarn: f,
      fallbackWarn: m,
      fallbackFormat: _,
      unresolving: !0,
      postTranslation: y === null ? void 0 : y,
      warnHtmlMessage: M,
      escapeParameter: S,
      messageResolver: t.messageResolver,
      messageCompiler: t.messageCompiler,
      __meta: { framework: "vue" }
    };
    j.datetimeFormats = c.value, j.numberFormats = u.value, j.__datetimeFormatters = xn(C) ? C.__datetimeFormatters : void 0, j.__numberFormatters = xn(C) ? C.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (j.__v_emitter = xn(C) ? C.__v_emitter : void 0);
    const Q = Tz(j);
    return o && Ls(Q), Q;
  })(), $1(C, s.value, l.value);
  function A() {
    return [
      s.value,
      l.value,
      d.value,
      c.value,
      u.value
    ];
  }
  const T = z({
    get: () => s.value,
    set: (j) => {
      s.value = j, C.locale = s.value;
    }
  }), k = z({
    get: () => l.value,
    set: (j) => {
      l.value = j, C.fallbackLocale = l.value, $1(C, s.value, j);
    }
  }), L = z(() => d.value), V = /* @__PURE__ */ z(() => c.value), O = /* @__PURE__ */ z(() => u.value);
  function D() {
    return di(y) ? y : null;
  }
  function P(j) {
    y = j, C.postTranslation = j;
  }
  function F() {
    return w;
  }
  function N(j) {
    j !== null && ($ = Ys(j)), w = j, C.missing = $;
  }
  function H(j, Q) {
    return j !== "translate" || !Q.resolvedMessage;
  }
  const W = (j, Q, we, Ve, ao, si) => {
    A();
    let Do;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (C.fallbackContext = e ? Pz() : void 0), Do = j(C);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (C.fallbackContext = void 0);
    }
    if (we !== "translate exists" && // for not `te` (e.g `t`)
    nr(Do) && Do === e0 || we === "translate exists" && !Do) {
      const [so, w3] = Q();
      if (process.env.NODE_ENV !== "production" && e && je(so) && H(we, w3) && (v && (t0(m, so) || h2(f, so)) && _a(Ca(vo.FALLBACK_TO_ROOT, {
        key: so,
        type: we
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Xa } = C;
        Xa && v && Xa.emit("fallback", {
          type: we,
          key: so,
          to: "global",
          groupId: `${we}:${so}`
        });
      }
      return e && v ? Ve(e) : ao(so);
    } else {
      if (si(Do))
        return Do;
      throw z1(ot.UNEXPECTED_RETURN_TYPE);
    }
  };
  function te(...j) {
    return W((Q) => Reflect.apply(Zs, null, [Q, ...j]), () => rr(...j), "translate", (Q) => Reflect.apply(Q.t, Q, [...j]), (Q) => Q, (Q) => je(Q));
  }
  function ie(...j) {
    const [Q, we, Ve] = j;
    if (Ve && !xt(Ve))
      throw z1(ot.INVALID_ARGUMENT);
    return te(Q, we, pn({ resolvedMessage: !0 }, Ve || {}));
  }
  function se(...j) {
    return W((Q) => Reflect.apply(Vs, null, [Q, ...j]), () => ar(...j), "datetime format", (Q) => Reflect.apply(Q.d, Q, [...j]), () => Li, (Q) => je(Q));
  }
  function fe(...j) {
    return W((Q) => Reflect.apply(Hs, null, [Q, ...j]), () => sr(...j), "number format", (Q) => Reflect.apply(Q.n, Q, [...j]), () => Li, (Q) => je(Q));
  }
  function $e(j) {
    return j.map((Q) => je(Q) || nr(Q) || uo(Q) ? zs(String(Q)) : Q);
  }
  const Tt = {
    normalize: $e,
    interpolate: (j) => j,
    type: "vnode"
  };
  function Me(...j) {
    return W((Q) => {
      let we;
      const Ve = Q;
      try {
        Ve.processor = Tt, we = Reflect.apply(Zs, null, [Ve, ...j]);
      } finally {
        Ve.processor = null;
      }
      return we;
    }, () => rr(...j), "translate", (Q) => Q[lr](...j), (Q) => [zs(Q)], (Q) => kn(Q));
  }
  function $t(...j) {
    return W((Q) => Reflect.apply(Hs, null, [Q, ...j]), () => sr(...j), "number format", (Q) => Q[cr](...j), js, (Q) => je(Q) || kn(Q));
  }
  function Re(...j) {
    return W((Q) => Reflect.apply(Vs, null, [Q, ...j]), () => ar(...j), "datetime format", (Q) => Q[dr](...j), js, (Q) => je(Q) || kn(Q));
  }
  function Ke(j) {
    b = j, C.pluralRules = b;
  }
  function Ut(j, Q) {
    return W(() => {
      if (!j)
        return !1;
      const we = je(Q) ? Q : s.value, Ve = ro(we), ao = C.messageResolver(Ve, j);
      return Ao(ao) || Yt(ao) || je(ao);
    }, () => [j], "translate exists", (we) => Reflect.apply(we.te, we, [j, Q]), Jz, (we) => uo(we));
  }
  function zt(j) {
    let Q = null;
    const we = a2(C, l.value, s.value);
    for (let Ve = 0; Ve < we.length; Ve++) {
      const ao = d.value[we[Ve]] || {}, si = C.messageResolver(ao, j);
      if (si != null) {
        Q = si;
        break;
      }
    }
    return Q;
  }
  function p1(j) {
    const Q = zt(j);
    return Q ?? (e ? e.tm(j) || {} : {});
  }
  function ro(j) {
    return d.value[j] || {};
  }
  function _1(j, Q) {
    if (i) {
      const we = { [j]: Q };
      for (const Ve in we)
        Ti(we, Ve) && W1(we[Ve]);
      Q = we[j];
    }
    d.value[j] = Q, C.messages = d.value;
  }
  function _0(j, Q) {
    d.value[j] = d.value[j] || {};
    const we = { [j]: Q };
    if (i)
      for (const Ve in we)
        Ti(we, Ve) && W1(we[Ve]);
    Q = we[j], $i(Q, d.value[j]), C.messages = d.value;
  }
  function R(j) {
    return c.value[j] || {};
  }
  function Z(j, Q) {
    c.value[j] = Q, C.datetimeFormats = c.value, Fs(C, j, Q);
  }
  function K(j, Q) {
    c.value[j] = pn(c.value[j] || {}, Q), C.datetimeFormats = c.value, Fs(C, j, Q);
  }
  function le(j) {
    return u.value[j] || {};
  }
  function Ze(j, Q) {
    u.value[j] = Q, C.numberFormats = u.value, Us(C, j, Q);
  }
  function Be(j, Q) {
    u.value[j] = pn(u.value[j] || {}, Q), C.numberFormats = u.value, Us(C, j, Q);
  }
  Gs++, e && gs && (he(e.locale, (j) => {
    a && (s.value = j, C.locale = j, $1(C, s.value, l.value));
  }), he(e.fallbackLocale, (j) => {
    a && (l.value = j, C.fallbackLocale = j, $1(C, s.value, l.value));
  }));
  const ge = {
    id: Gs,
    locale: T,
    fallbackLocale: k,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(j) {
      a = j, j && e && (s.value = e.locale.value, l.value = e.fallbackLocale.value, $1(C, s.value, l.value));
    },
    get availableLocales() {
      return Object.keys(d.value).sort();
    },
    messages: L,
    get modifiers() {
      return x;
    },
    get pluralRules() {
      return b || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return f;
    },
    set missingWarn(j) {
      f = j, C.missingWarn = f;
    },
    get fallbackWarn() {
      return m;
    },
    set fallbackWarn(j) {
      m = j, C.fallbackWarn = m;
    },
    get fallbackRoot() {
      return v;
    },
    set fallbackRoot(j) {
      v = j;
    },
    get fallbackFormat() {
      return _;
    },
    set fallbackFormat(j) {
      _ = j, C.fallbackFormat = _;
    },
    get warnHtmlMessage() {
      return M;
    },
    set warnHtmlMessage(j) {
      M = j, C.warnHtmlMessage = j;
    },
    get escapeParameter() {
      return S;
    },
    set escapeParameter(j) {
      S = j, C.escapeParameter = j;
    },
    t: te,
    getLocaleMessage: ro,
    setLocaleMessage: _1,
    mergeLocaleMessage: _0,
    getPostTranslationHandler: D,
    setPostTranslationHandler: P,
    getMissingHandler: F,
    setMissingHandler: N,
    [Xz]: Ke
  };
  return ge.datetimeFormats = V, ge.numberFormats = O, ge.rt = ie, ge.te = Ut, ge.tm = p1, ge.d = se, ge.n = fe, ge.getDateTimeFormat = R, ge.setDateTimeFormat = Z, ge.mergeDateTimeFormat = K, ge.getNumberFormat = le, ge.setNumberFormat = Ze, ge.mergeNumberFormat = Be, ge[Kz] = n, ge[lr] = Me, ge[dr] = Re, ge[cr] = $t, process.env.NODE_ENV !== "production" && (ge[ur] = (j) => {
    C.__v_emitter = j;
  }, ge[hr] = () => {
    C.__v_emitter = void 0;
  }), ge;
}
const ba = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (t) => t === "parent" || t === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function tW({ slots: t }, e) {
  return e.length === 1 && e[0] === "default" ? (t.default ? t.default() : []).reduce((o, i) => [
    ...o,
    // prettier-ignore
    ...i.type === _e ? i.children : [i]
  ], []) : e.reduce((n, o) => {
    const i = t[o];
    return i && (n[o] = i()), n;
  }, {});
}
function y2() {
  return _e;
}
pn({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (t) => nr(t) || !isNaN(t)
  }
}, ba);
function nW(t) {
  return kn(t) && !je(t[0]);
}
function M2(t, e, n, o) {
  const { slots: i, attrs: r } = e;
  return () => {
    const a = { part: !0 };
    let s = {};
    t.locale && (a.locale = t.locale), je(t.format) ? a.key = t.format : xt(t.format) && (je(t.format.key) && (a.key = t.format.key), s = Object.keys(t.format).reduce((f, m) => n.includes(m) ? pn({}, f, { [m]: t.format[m] }) : f, {}));
    const l = o(t.value, a, s);
    let d = [a.key];
    kn(l) ? d = l.map((f, m) => {
      const v = i[f.type], _ = v ? v({ [f.type]: f.value, index: m, parts: l }) : [f.value];
      return nW(_) && (_[0].key = `${f.type}-${m}`), _;
    }) : je(l) && (d = [l]);
    const c = pn({}, r), u = je(t.tag) || xt(t.tag) ? t.tag : y2();
    return hd(u, c, d);
  };
}
pn({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ba);
pn({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ba);
function Xs(t, e) {
}
const oW = /* @__PURE__ */ Rn("global-vue-i18n");
function Mn(t = {}) {
  const e = To();
  if (e == null)
    throw z1(ot.MUST_BE_CALL_SETUP_TOP);
  if (!e.isCE && e.appContext.app != null && !e.appContext.app.__VUE_I18N_SYMBOL__)
    throw z1(ot.NOT_INSTALLED);
  const n = iW(e), o = aW(n), i = w2(e), r = rW(t, i);
  if (r === "global")
    return qz(o, t, i), o;
  if (r === "parent") {
    let l = sW(n, e, t.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && _a(Ca(vo.NOT_FOUND_PARENT_SCOPE)), l = o), l;
  }
  const a = n;
  let s = a.__getInstance(e);
  if (s == null) {
    const l = pn({}, t);
    "__i18n" in i && (l.__i18n = i.__i18n), o && (l.__root = o), s = eW(l), a.__composerExtend && (s[fr] = a.__composerExtend(s)), dW(a, e, s), a.__setInstance(e, s);
  }
  return s;
}
function iW(t) {
  const e = Ci(t.isCE ? oW : t.appContext.app.__VUE_I18N_SYMBOL__);
  if (!e)
    throw z1(t.isCE ? ot.NOT_INSTALLED_WITH_PROVIDE : ot.UNEXPECTED_ERROR);
  return e;
}
function rW(t, e) {
  return sU(t) ? "__i18n" in e ? "local" : "global" : t.useScope ? t.useScope : "local";
}
function aW(t) {
  return t.mode === "composition" ? t.global : t.global.__composer;
}
function sW(t, e, n = !1) {
  let o = null;
  const i = e.root;
  let r = lW(e, n);
  for (; r != null; ) {
    const a = t;
    if (t.mode === "composition" && (o = a.__getInstance(r)), o != null || i === r)
      break;
    r = r.parent;
  }
  return o;
}
function lW(t, e = !1) {
  return t == null ? null : e && t.vnode.ctx || t.parent;
}
function dW(t, e, n) {
  let o = null;
  et(() => {
    if (process.env.NODE_ENV !== "production" && e.vnode.el) {
      e.vnode.el.__VUE_I18N__ = n, o = uU();
      const i = n;
      i[ur] && i[ur](o), o.on("*", Xs);
    }
  }, e), Zr(() => {
    const i = n;
    process.env.NODE_ENV !== "production" && e.vnode.el && e.vnode.el.__VUE_I18N__ && (o && o.off("*", Xs), i[hr] && i[hr](), delete e.vnode.el.__VUE_I18N__), t.__deleteInstance(e);
    const r = i[fr];
    r && (r(), delete i[fr]);
  }, e);
}
jz();
Sz(Bz);
Iz(iz);
Az(a2);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const t = o2();
  t.__INTLIFY__ = !0, fz(t.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const cW = { class: "header-title" };
var Fo = /* @__PURE__ */ ((t) => (t.prev = "prev", t.next = "next", t.toChosenDay = "toChosenDay", t))(Fo || {});
x3({
  name: "PCalendarMonth"
});
const C2 = /* @__PURE__ */ oe({
  __name: "PCalendarMonth",
  props: {
    day: {},
    month: {},
    switchButtons: { type: Boolean },
    nextButtonDisabled: { type: Boolean },
    prevButtonDisabled: { type: Boolean }
  },
  emits: ["changeMonth", "goToToday"],
  setup(t, { emit: e }) {
    const { t: n } = Mn({
      messages: {
        ru: {
          today: "Сегодня"
        },
        en: {
          today: "Today"
        }
      }
    }), o = t, i = e, r = z(() => {
      var s;
      return ((s = o.day) == null ? void 0 : s.isSame(re(), "d")) && o.month.isSame(re(), "M");
    }), a = (s) => i("changeMonth", s);
    return (s, l) => {
      const d = pa, c = vt, u = ma;
      return p(), g("div", {
        class: ee(["p-calendar-month", { switchButtons: s.switchButtons }])
      }, [
        h("div", cW, [
          s.switchButtons ? (p(), J(c, {
            key: 0,
            variant: "text",
            class: ee(["header-arrow", { disabled: s.prevButtonDisabled }]),
            onClick: l[0] || (l[0] = (f) => a(
              "prev"
              /* prev */
            ))
          }, {
            default: G(() => [
              q(d)
            ]),
            _: 1
          }, 8, ["class"])) : X("", !0),
          q(Xe, {
            name: "fade",
            mode: "out-in"
          }, {
            default: G(() => [
              (p(), g("div", {
                key: s.month.format("MYY"),
                class: ee(["header-month"])
              }, ne(s.month.format("MMMM YYYY")), 1))
            ]),
            _: 1
          }),
          s.switchButtons ? (p(), J(c, {
            key: 1,
            variant: "text",
            class: ee(["header-arrow", { disabled: s.nextButtonDisabled }]),
            onClick: l[1] || (l[1] = (f) => a(
              "next"
              /* next */
            ))
          }, {
            default: G(() => [
              q(u)
            ]),
            _: 1
          }, 8, ["class"])) : X("", !0)
        ]),
        s.switchButtons ? (p(), J(c, {
          key: 0,
          variant: "text",
          color: "primary",
          size: "medium",
          disabled: r.value,
          class: ee(["header-today", { isSameMonth: r.value }]),
          onClick: l[2] || (l[2] = (f) => i("goToToday"))
        }, {
          default: G(() => [
            xe(ne(B(n)("today")), 1)
          ]),
          _: 1
        }, 8, ["disabled", "class"])) : X("", !0)
      ], 2);
    };
  }
});
var nn = /* @__PURE__ */ ((t) => (t.pointedDates = "pointedDates", t.markedDates = "markedDates", t.modelValue = "modelValue", t.startMonth = "startMonth", t.min = "min", t.max = "max", t))(nn || {});
const yt = (t, e) => {
  if (typeof t == "string")
    try {
      if (re(t, ue.YMD, !0).isValid()) return re(t, ue.YMD);
      if (re(t.replace(/.$/, ""), ue.ISO, !0).isValid()) return re(t, ue.ISO);
      throw new Error(
        `Неверный формат переданной даты ${e ? `в - props.${e}` : ""}.
 Необходимо использовать формат строк "ISO 8601", "YYYY-MM-DD"`
      );
    } catch (n) {
      return console.error(n), null;
    }
  return null;
}, rt = (t) => t.format(ue.YMD), cn = (t, e) => e ?? (t && typeof t == "object" && t.startTime && t.endTime), E1 = (t, e) => typeof t == "string" ? e === Tn.YMD ? t : re(t, ue.YMD).toISOString() : e === Tn.YMD ? t.format(ue.YMD) : t.toISOString(), uW = { class: "p-calendar-multiply" }, hW = { class: "p-calendars" }, fW = { class: "p-calendar-main" }, mW = /* @__PURE__ */ oe({
  name: "PCalendarMultiply",
  __name: "PCalendarMultiply",
  props: {
    modelValue: {},
    format: { default: Tn.ISO },
    pointedDates: {},
    markedDates: {},
    range: { type: Boolean },
    numberOfMonths: { default: 1 },
    hideSelectedDate: { type: Boolean },
    startMonth: { default: re().date(1).toISOString() }
  },
  emits: ["update:modelValue", "selectDate"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = me(n, "modelValue", o), r = function() {
      const _ = yt(n.startMonth, nn.startMonth), w = [];
      for (let $ = 0; $ < n.numberOfMonths; $++)
        w.push(_.add($, "M"));
      return w;
    }(), a = (_) => _.format("MM-YY"), s = z(() => {
      if (!i.value) return null;
      if (cn(i.value, n.range)) {
        const w = yt(i.value.startTime, nn.modelValue), $ = yt(i.value.endTime, nn.modelValue);
        return !w || !$ ? null : { startTime: rt(w), endTime: rt($) };
      }
      const _ = yt(i.value, nn.modelValue);
      return _ ? rt(_) : null;
    }), l = (_) => _ ? _.reduce((w, $) => {
      const y = yt($);
      if (!y) return w;
      const M = a(y), S = rt(y);
      return w[M] ? w[M].push(S) : w[M] = [S], w;
    }, {}) : null, d = z(() => l(n.pointedDates)), c = z(() => l(n.markedDates)), u = (_) => {
      if (!s.value) return !1;
      if (cn(s.value, n.range)) {
        const { startTime: w, endTime: $ } = s.value, y = re(w).diff(re($), "days"), M = [];
        for (let S = 0; S <= y; S++) {
          const x = rt(re(w).add(S, "days"));
          M.push(x);
        }
        return !!M.find((S) => S === _);
      }
      return s.value === _;
    }, f = (_, w, $) => $ && $[w] ? $[w].some((y) => y === _) : !1, m = z(() => r.reduce((w, $) => {
      let y = [];
      const M = a($);
      if (!re().isSame($, "M")) {
        const x = $.startOf("w"), b = $.startOf("M");
        for (let C = 0; C < b.diff(x, "d"); C++)
          y.unshift("");
      }
      const S = re().startOf("w");
      for (let x = 1; x <= $.daysInMonth(); x++) {
        const b = $.set("date", x);
        if (b.isBefore(S, "d")) continue;
        const C = rt(b), E = u(C) && !n.hideSelectedDate, A = f(C, M, c.value);
        y.push({
          value: C,
          today: b.isToday(),
          selected: E,
          marked: A,
          pointed: f(C, M, d.value),
          disabled: b.isBefore(re(), "d"),
          anotherMonth: !1
        });
      }
      return w[M] = y, w;
    }, {})), v = (_) => {
      const w = E1(_, n.format);
      cn(s.value, n.range) ? i.value = { startTime: w, endTime: w } : i.value = w, Jt(() => {
        o("selectDate", i.value);
      });
    };
    return (_, w) => {
      const $ = C2, y = n2, M = t2;
      return p(), g("div", uW, [
        h("div", hW, [
          (p(!0), g(_e, null, Ie(B(r), (S, x) => (p(), g("div", {
            key: x,
            class: "p-calendar"
          }, [
            q($, { month: S }, null, 8, ["month"]),
            h("div", fW, [
              q(y),
              h("div", {
                ref_for: !0,
                ref: "daysRef",
                class: "p-calendar-days"
              }, [
                (p(!0), g(_e, null, Ie(m.value[a(S)], (b, C) => (p(), g(_e, null, [
                  b ? (p(), J(M, {
                    key: b.value,
                    day: b,
                    onSelectDay: v
                  }, null, 8, ["day"])) : (p(), g("div", {
                    key: `empty-cell-${C}`
                  }))
                ], 64))), 256))
              ], 512)
            ])
          ]))), 128))
        ])
      ]);
    };
  }
}), pW = /* @__PURE__ */ ae(mW, [["__scopeId", "data-v-445f9ba4"]]), _W = { class: "p-calendar" }, vW = { class: "p-calendar-body" }, gW = { class: "p-calendar-main" }, Ks = 7, $W = 1, wW = /* @__PURE__ */ oe({
  name: "PCalendarNew",
  __name: "PCalendarNew",
  props: {
    modelValue: {},
    min: {},
    max: {},
    format: { default: Tn.ISO },
    pointedDates: {},
    markedDates: {},
    range: { type: Boolean },
    hideSelectedDate: { type: Boolean },
    startMonth: {}
  },
  emits: ["update:modelValue", "selectDate", "changeMonth"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = me(n, "modelValue", o), r = yt(n.min, nn.min), a = yt(n.max, nn.max), l = U((() => {
      let k = re();
      switch (!0) {
        case !!n.startMonth:
          k = yt(n.startMonth, nn.startMonth);
          break;
        case !i.value:
          break;
        default:
          k = cn(i.value, n.range) ? yt(i.value.startTime, nn.modelValue) : yt(i.value, nn.modelValue);
      }
      return k.startOf("month");
    })()), d = z(() => {
      if (!i.value) return null;
      if (cn(i.value, n.range)) {
        const L = yt(i.value.startTime), V = yt(i.value.endTime);
        return !L || !V ? null : { startTime: rt(L), endTime: rt(V) };
      }
      const k = yt(i.value, nn.modelValue);
      return k ? rt(k) : null;
    }), c = (k) => k ? k.reduce((L, V) => {
      const O = yt(V);
      return O && L.push(rt(O)), L;
    }, []) : null, u = z(() => c(n.pointedDates)), f = z(() => c(n.markedDates)), m = (k) => {
      const L = k.subtract(1, "month");
      return (L.date(L.daysInMonth()).day() - $W) % Ks;
    }, v = (k) => {
      if (!d.value || n.hideSelectedDate) return !1;
      if (cn(d.value, n.range)) {
        const { startTime: L, endTime: V } = d.value, O = re(L).diff(re(V), "days"), D = [];
        for (let P = 0; P <= O; P++) {
          const F = rt(re(L).add(P, "days"));
          D.push(F);
        }
        return !!D.find((P) => P === k);
      }
      return d.value === k;
    }, _ = (k, L) => L ? !!(L != null && L.some((V) => V === k)) : !1, w = z(() => {
      let k = [];
      const V = l.value.subtract(1, "month").daysInMonth();
      for (let D = V; V - D <= m(l.value); D--) {
        const P = l.value.subtract(1, "month").set("date", D), F = rt(P);
        k.unshift({
          value: F,
          today: P.isToday(),
          selected: v(F),
          marked: _(F, f.value),
          pointed: _(F, u.value),
          disabled: !!r && P.isBefore(r, "day"),
          anotherMonth: !0
        });
      }
      for (let D = 1; D <= l.value.daysInMonth(); D++) {
        const P = l.value.set("date", D), F = rt(P), N = !!r && P.isBefore(r, "day") || !!a && P.isAfter(a, "day");
        k.push({
          value: F,
          today: P.isToday(),
          selected: v(F),
          marked: _(F, f.value),
          pointed: _(F, u.value),
          disabled: N,
          anotherMonth: !1
        });
      }
      const O = 6;
      for (let D = 1; k.length < Ks * O; D++) {
        const P = l.value.add(1, "month").set("date", D), F = rt(P);
        k.push({
          value: F,
          today: P.isToday(),
          selected: v(F),
          marked: _(F, f.value),
          pointed: _(F, u.value),
          disabled: !!a && P.isAfter(a, "day"),
          anotherMonth: !0
        });
      }
      return k;
    }), $ = U(), y = U({ transform: "", transition: "" }), M = U(
      "swipe-calendar-left"
      /* left */
    ), { direction: S, lengthX: x } = Wr($, {
      threshold: 0,
      onSwipe() {
        const k = S.value === "left" && !T.value, L = S.value === "right" && !A.value;
        (k || L) && (y.value.transform = `translateX(${-x.value}px)`);
      },
      onSwipeEnd() {
        y.value.transition = "transform 0.2s";
        let k = l.value;
        if (S.value === "left") {
          if (T.value) return;
          M.value = "swipe-calendar-left", y.value.transform = "translateX(-100%)", k = l.value.add(1, "month");
        }
        if (S.value === "right") {
          if (A.value) return;
          M.value = "swipe-calendar-right", y.value.transform = "translateX(100%)", k = l.value.subtract(1, "month");
        }
        Jt(() => {
          y.value.transform = "", y.value.transition = "", l.value = k;
        }), o("changeMonth", E1(l.value, n.format));
      }
    }), b = (k) => {
      switch (k) {
        case Fo.prev: {
          M.value = "swipe-calendar-right", l.value = l.value.subtract(1, "month").startOf("month");
          break;
        }
        case Fo.next: {
          M.value = "swipe-calendar-left", l.value = l.value.add(1, "month").startOf("month");
          break;
        }
        case Fo.toChosenDay: {
          let L;
          if (cn(d.value, n.range) ? L = re(d.value.startTime, Tn.YMD) : L = re(d.value, Tn.YMD), L = L.startOf("month"), L.isSame(l.value)) return;
          L.isBefore(l.value) ? M.value = "swipe-calendar-right" : M.value = "swipe-calendar-left", l.value = L;
        }
      }
      o("changeMonth", E1(l.value, n.format));
    }, C = (k) => {
      const L = re(k, ue.YMD), V = E1(k, n.format);
      if (cn(d.value, n.range)) {
        const O = E1(rt(L.endOf("day")), n.format);
        i.value = { startTime: V, endTime: O }, o("selectDate", { startTime: V, endTime: O });
      } else
        i.value = V, o("selectDate", V);
    };
    he(
      () => d.value,
      (k) => {
        k && b(Fo.toChosenDay);
      }
    );
    const E = () => {
      var O;
      if (!(!cn(d.value, n.range) && d.value && re(d.value, ue.YMD).isSame(re().startOf("day"), "day"))) {
        C(rt(re()));
        return;
      }
      ((O = l.value) == null ? void 0 : O.isSame(re().startOf("month"))) || b(Fo.toChosenDay);
    }, A = z(() => !!r && r.startOf("month").isSame(l.value)), T = z(() => !!a && a.startOf("month").isSame(l.value));
    return (k, L) => {
      const V = C2, O = n2, D = t2;
      return p(), g("div", _W, [
        h("div", vW, [
          q(V, {
            day: B(re)(B(cn)(B(i), !!k.range) ? B(i).startTime : B(i)),
            month: l.value,
            "switch-buttons": "",
            "prev-button-disabled": A.value,
            "next-button-disabled": T.value,
            onChangeMonth: b,
            onGoToToday: E
          }, null, 8, ["day", "month", "prev-button-disabled", "next-button-disabled"]),
          h("div", gW, [
            q(O),
            q(Xe, {
              name: M.value,
              mode: "out-in"
            }, {
              default: G(() => [
                (p(), g("div", {
                  ref_key: "daysRef",
                  ref: $,
                  key: l.value.format("MYY"),
                  class: "p-calendar-days",
                  style: en(y.value)
                }, [
                  (p(!0), g(_e, null, Ie(w.value, (P) => (p(), J(D, {
                    key: P.value,
                    day: P,
                    onSelectDay: C
                  }, null, 8, ["day"]))), 128))
                ], 4))
              ]),
              _: 1
            }, 8, ["name"])
          ])
        ])
      ]);
    };
  }
}), yW = /* @__PURE__ */ ae(wW, [["__scopeId", "data-v-76973c80"]]), MW = {
  key: 0,
  class: "card-title"
}, CW = { class: "card-content" }, bW = {
  key: 2,
  class: "card-actions"
}, xW = /* @__PURE__ */ oe({
  name: "PCard",
  __name: "PCard",
  props: {
    variant: { default: "elevated" }
  },
  setup(t) {
    const { mobile: e } = nt();
    return (n, o) => (p(), g("div", {
      class: ee(["p-card", ["p-card", `variant-${n.variant}`]])
    }, [
      n.$slots.title ? (p(), g("div", MW, [
        Y(n.$slots, "title", {}, void 0, !0)
      ])) : X("", !0),
      n.$slots.subtitle ? (p(), g("div", {
        key: 1,
        class: ee(["card-subtitle", { mobile: B(e) }])
      }, [
        Y(n.$slots, "subtitle", {}, void 0, !0)
      ], 2)) : X("", !0),
      h("div", CW, [
        Y(n.$slots, "default", {}, void 0, !0)
      ]),
      n.$slots.actions ? (p(), g("div", bW, [
        Y(n.$slots, "actions", {}, void 0, !0)
      ])) : X("", !0)
    ], 2));
  }
}), SW = /* @__PURE__ */ ae(xW, [["__scopeId", "data-v-02e3871c"]]), IW = ["disabled"], AW = { class: "label" }, kW = /* @__PURE__ */ oe({
  name: "PCheckbox",
  __name: "PCheckbox",
  props: {
    modelValue: { type: Boolean },
    label: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    labelPosition: { default: "right" },
    textSize: { default: "md" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = me(t, "modelValue", e), r = z(() => i.value ? Ud : Hd);
    return (a, s) => (p(), g("label", {
      class: ee(["p-checkbox", { active: B(i), disabled: a.disabled, readonly: a.readonly }, `label-position-${a.labelPosition}`, `text-size-${a.textSize}`])
    }, [
      it(h("input", {
        "onUpdate:modelValue": s[0] || (s[0] = (l) => Le(i) ? i.value = l : null),
        type: "checkbox",
        class: "input-checkbox",
        disabled: a.disabled
      }, null, 8, IW), [
        [md, B(i)]
      ]),
      q(B(r), { class: "icon" }),
      h("div", AW, [
        Y(a.$slots, "default", {}, () => [
          xe(ne(a.label), 1)
        ], !0)
      ])
    ], 2));
  }
}), EW = /* @__PURE__ */ ae(kW, [["__scopeId", "data-v-4e7e85b9"]]), Wn = {
  name: function(t) {
    return t.substring(0, t.length - this.extension(t).length);
  },
  extension: function(t) {
    var e;
    return ((e = t.match(/\.([^./]+)$/)) == null ? void 0 : e[1]) || "";
  }
}, Ot = {
  parent: (t) => t.split("/")[0],
  child: (t) => t.split("/")[1]
}, PW = (t) => {
  open(t);
}, j1 = (t) => t + "#t=0.001", qs = (t) => {
  let e = 1;
  const n = {}, o = (l) => Math.hypot(l.touches[0].pageX - l.touches[1].pageX, l.touches[0].pageY - l.touches[1].pageY), i = (l) => {
    t.style.transition = "unset", l.touches.length === 2 && (l.preventDefault(), l.stopPropagation(), n.x = (l.touches[0].pageX + l.touches[1].pageX) / 2, n.y = (l.touches[0].pageY + l.touches[1].pageY) / 2, n.distance = o(l));
  }, r = (l) => {
    if (l.touches.length === 2) {
      l.preventDefault(), l.stopPropagation();
      let d;
      l.scale ? d = l.scale : d = o(l) / n.distance, e = Math.min(Math.max(1, d), 4);
      const c = ((l.touches[0].pageX + l.touches[1].pageX) / 2 - n.x) * 2, u = ((l.touches[0].pageY + l.touches[1].pageY) / 2 - n.y) * 2, f = `translate3d(${c}px, ${u}px, 0) scale(${e})`;
      t.style.transform = f, t.style.webkitTransform = f, t.style.zIndex = "9999";
    }
  }, a = () => {
    t.style.transform = "", t.style.transition = "transform 0.4s ease-in-out", t.style.webkitTransform = "", t.style.zIndex = "";
  };
  return t.addEventListener("touchstart", i), t.addEventListener("touchmove", r), t.addEventListener("touchend", a), { destroy: () => {
    t.removeEventListener("touchstart", i), t.removeEventListener("touchmove", r), t.removeEventListener("touchend", a);
  } };
}, TW = (t, e) => {
  let n = e;
  for (let o = 0; o < t.length; o++)
    t.end(o) > e && (t.start(o) < e ? n += t.end(o) - e : n += t.end(o) - t.start(o));
  return n;
}, OW = (t, e) => JSON.stringify(t) === JSON.stringify(e), LW = /^[\s()+-]*([0-9][\s()+-]*){6,20}(?:[-. \\/]?(?:#|ext\.?|extension|x)[-. \\/]?(\d+))?$/i, DW = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, NW = { class: "p-chips" }, RW = { class: "chip-content" }, ZW = {
  key: 0,
  class: "chip-count"
}, BW = /* @__PURE__ */ oe({
  name: "PChips",
  __name: "PChips",
  props: {
    modelValue: { type: [String, Number, Boolean, Object, Array, null] },
    chips: { default: () => [] },
    multiple: { type: Boolean },
    divider: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, o = (c) => c.nuxt ? e1("NuxtLink") : c.href ? "a" : c.to ? e1("RouterLink") : "button", i = (c) => n.divider ? c + 1 === n.divider : !1, a = me(n, "modelValue", e), s = (c) => !!n.multiple, l = (c, u) => {
      var f;
      if (c.currentTarget.blur(), s(a.value) && (u.value === 0 || u.value)) {
        const m = typeof a.value != "number" ? ((f = a.value) == null ? void 0 : f.indexOf(u.value)) ?? -1 : -1;
        m === -1 ? a.value = a.value ? [...a.value, u.value] : [u.value] : a.value = a.value.filter((v, _) => _ !== m);
      } else
        a.value = u.value;
    }, d = (c) => {
      var u;
      if (c.value === 0 || c.value)
        return s(a.value) && typeof a.value != "number" ? (u = a.value) == null ? void 0 : u.includes(c.value) : OW(a.value, c.value);
    };
    return (c, u) => (p(), g("div", NW, [
      (p(!0), g(_e, null, Ie(c.chips, (f, m) => (p(), J(Ce(o(f)), {
        key: m,
        class: ee([
          "chip",
          {
            active: d(f),
            disabled: f.disabled,
            divider: i(m)
          }
        ]),
        to: f.to,
        href: f.href,
        "active-class": f.to ? "active" : null,
        disabled: f.disabled,
        onClick: (v) => l(v, f)
      }, {
        default: G(() => [
          h("div", RW, [
            Y(c.$slots, "default", { item: f }, () => [
              xe(ne(f.text), 1)
            ], !0),
            f.count ? (p(), g("div", ZW, ne(f.count), 1)) : X("", !0)
          ])
        ]),
        _: 2
      }, 1032, ["class", "to", "href", "active-class", "disabled", "onClick"]))), 128))
    ]));
  }
}), VW = /* @__PURE__ */ ae(BW, [["__scopeId", "data-v-9007e57f"]]), FW = { class: "p-circle-badge" }, HW = /* @__PURE__ */ oe({
  name: "PBadge",
  __name: "PBadge",
  props: {
    size: { default: "large" },
    color: { default: "green" },
    hide: { type: Boolean },
    floating: { type: Boolean },
    placement: { default: "top-left" }
  },
  setup(t) {
    return (e, n) => (p(), g("div", FW, [
      Y(e.$slots, "default", {}, void 0, !0),
      q(Xe, { name: "scale" }, {
        default: G(() => [
          e.hide ? X("", !0) : (p(), g("div", {
            key: 0,
            class: ee(["circle-badge", e.color, e.size, e.placement, { floating: e.floating }])
          }, [
            Y(e.$slots, "icon", {}, void 0, !0)
          ], 2))
        ]),
        _: 3
      })
    ]));
  }
}), UW = /* @__PURE__ */ ae(HW, [["__scopeId", "data-v-13908d12"]]), zW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, WW = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M9.756 3.923a.833.833 0 1 0-1.179-1.179L1.911 9.411a.833.833 0 0 0 0 1.178l6.666 6.667a.833.833 0 1 0 1.179-1.179l-5.244-5.244H17.5a.833.833 0 1 0 0-1.666H4.512l5.244-5.244Z"
}, null, -1), jW = [
  WW
];
function GW(t, e) {
  return p(), g("svg", zW, [...jW]);
}
const b2 = I({ name: "icon-arrow-left-md", render: GW }), YW = { class: "p-top-bar-arrow" }, XW = {
  key: 0,
  class: "left"
}, KW = { class: "p-top-bar-slot" }, qW = {
  key: 0,
  class: "content"
}, JW = {
  key: 0,
  class: "title"
}, QW = {
  key: 1,
  class: "subtitle"
}, ej = {
  key: 1,
  class: "right"
}, tj = { class: "p-top-bar-cross" }, nj = /* @__PURE__ */ oe({
  name: "PTopBar",
  __name: "index",
  props: {
    size: {},
    alignCenter: { type: Boolean },
    arrowButton: { type: Boolean },
    crossButton: { type: Boolean },
    borded: { type: Boolean },
    elevated: { type: Boolean },
    noPadding: { type: Boolean }
  },
  emits: ["click:back", "click:close"],
  setup(t, { emit: e }) {
    const n = t, o = e, { mobile: i, tablet: r, tabletUp: a } = nt(), s = z(() => {
      if (n.size) return `size-${n.size}`;
      const l = {
        small: i.value,
        medium: r.value,
        large: a.value
      };
      return `size-${Object.keys(l).find((d) => l[d])}`;
    });
    return (l, d) => {
      const c = b2, u = vt, f = Gi;
      return p(), g("div", {
        class: ee(["p-top-bar", `${s.value}`, { center: l.alignCenter, "no-padding": l.noPadding, borded: l.borded, elevated: l.elevated }])
      }, [
        Y(l.$slots, "content", {}, () => [
          h("div", YW, [
            Y(l.$slots, "left-button", {}, () => [
              l.arrowButton ? (p(), J(u, {
                key: 0,
                variant: "text",
                onClick: d[0] || (d[0] = (m) => o("click:back"))
              }, {
                default: G(() => [
                  q(c)
                ]),
                _: 1
              })) : X("", !0)
            ], !0)
          ]),
          l.$slots.left ? (p(), g("div", XW, [
            Y(l.$slots, "left", {}, void 0, !0)
          ])) : X("", !0),
          h("div", KW, [
            l.$slots.title || l.$slots.subtitle ? (p(), g("div", qW, [
              l.$slots.title ? (p(), g("div", JW, [
                Y(l.$slots, "title", {}, void 0, !0)
              ])) : X("", !0),
              l.$slots.subtitle ? (p(), g("div", QW, [
                Y(l.$slots, "subtitle", {}, void 0, !0)
              ])) : X("", !0)
            ])) : Y(l.$slots, "default", { key: 1 }, void 0, !0)
          ]),
          l.$slots.right ? (p(), g("div", ej, [
            Y(l.$slots, "right", {}, void 0, !0)
          ])) : X("", !0),
          h("div", tj, [
            Y(l.$slots, "right-button", {}, () => [
              l.crossButton ? (p(), J(u, {
                key: 0,
                variant: "text",
                onClick: d[1] || (d[1] = (m) => o("click:close"))
              }, {
                default: G(() => [
                  q(f)
                ]),
                _: 1
              })) : X("", !0)
            ], !0)
          ])
        ], !0)
      ], 2);
    };
  }
}), n0 = /* @__PURE__ */ ae(nj, [["__scopeId", "data-v-94fff65c"]]), fn = Math.min, Dt = Math.max, Di = Math.round, hi = Math.floor, Jn = (t) => ({
  x: t,
  y: t
}), oj = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ij = {
  start: "end",
  end: "start"
};
function mr(t, e, n) {
  return Dt(t, fn(e, n));
}
function f1(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Qn(t) {
  return t.split("-")[0];
}
function m1(t) {
  return t.split("-")[1];
}
function x2(t) {
  return t === "x" ? "y" : "x";
}
function xa(t) {
  return t === "y" ? "height" : "width";
}
function ko(t) {
  return ["top", "bottom"].includes(Qn(t)) ? "y" : "x";
}
function Sa(t) {
  return x2(ko(t));
}
function rj(t, e, n) {
  n === void 0 && (n = !1);
  const o = m1(t), i = Sa(t), r = xa(i);
  let a = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (a = Ni(a)), [a, Ni(a)];
}
function aj(t) {
  const e = Ni(t);
  return [pr(t), e, pr(e)];
}
function pr(t) {
  return t.replace(/start|end/g, (e) => ij[e]);
}
function sj(t, e, n) {
  const o = ["left", "right"], i = ["right", "left"], r = ["top", "bottom"], a = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : o : e ? o : i;
    case "left":
    case "right":
      return e ? r : a;
    default:
      return [];
  }
}
function lj(t, e, n, o) {
  const i = m1(t);
  let r = sj(Qn(t), n === "start", o);
  return i && (r = r.map((a) => a + "-" + i), e && (r = r.concat(r.map(pr)))), r;
}
function Ni(t) {
  return t.replace(/left|right|bottom|top/g, (e) => oj[e]);
}
function dj(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function S2(t) {
  return typeof t != "number" ? dj(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Ri(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: i
  } = t;
  return {
    width: o,
    height: i,
    top: n,
    left: e,
    right: e + o,
    bottom: n + i,
    x: e,
    y: n
  };
}
function Js(t, e, n) {
  let {
    reference: o,
    floating: i
  } = t;
  const r = ko(e), a = Sa(e), s = xa(a), l = Qn(e), d = r === "y", c = o.x + o.width / 2 - i.width / 2, u = o.y + o.height / 2 - i.height / 2, f = o[s] / 2 - i[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: c,
        y: o.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: c,
        y: o.y + o.height
      };
      break;
    case "right":
      m = {
        x: o.x + o.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: o.x - i.width,
        y: u
      };
      break;
    default:
      m = {
        x: o.x,
        y: o.y
      };
  }
  switch (m1(e)) {
    case "start":
      m[a] -= f * (n && d ? -1 : 1);
      break;
    case "end":
      m[a] += f * (n && d ? -1 : 1);
      break;
  }
  return m;
}
const cj = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: a
  } = n, s = r.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(e));
  let d = await a.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: c,
    y: u
  } = Js(d, o, l), f = o, m = {}, v = 0;
  for (let _ = 0; _ < s.length; _++) {
    const {
      name: w,
      fn: $
    } = s[_], {
      x: y,
      y: M,
      data: S,
      reset: x
    } = await $({
      x: c,
      y: u,
      initialPlacement: o,
      placement: f,
      strategy: i,
      middlewareData: m,
      rects: d,
      platform: a,
      elements: {
        reference: t,
        floating: e
      }
    });
    c = y ?? c, u = M ?? u, m = {
      ...m,
      [w]: {
        ...m[w],
        ...S
      }
    }, x && v <= 50 && (v++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (d = x.rects === !0 ? await a.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : x.rects), {
      x: c,
      y: u
    } = Js(d, f, l)), _ = -1);
  }
  return {
    x: c,
    y: u,
    placement: f,
    strategy: i,
    middlewareData: m
  };
};
async function Ia(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: i,
    platform: r,
    rects: a,
    elements: s,
    strategy: l
  } = t, {
    boundary: d = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = f1(e, t), v = S2(m), w = s[f ? u === "floating" ? "reference" : "floating" : u], $ = Ri(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(w))) == null || n ? w : w.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(s.floating)),
    boundary: d,
    rootBoundary: c,
    strategy: l
  })), y = u === "floating" ? {
    x: o,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, M = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(s.floating)), S = await (r.isElement == null ? void 0 : r.isElement(M)) ? await (r.getScale == null ? void 0 : r.getScale(M)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Ri(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: M,
    strategy: l
  }) : y);
  return {
    top: ($.top - x.top + v.top) / S.y,
    bottom: (x.bottom - $.bottom + v.bottom) / S.y,
    left: ($.left - x.left + v.left) / S.x,
    right: (x.right - $.right + v.right) / S.x
  };
}
const uj = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: r,
      platform: a,
      elements: s,
      middlewareData: l
    } = e, {
      element: d,
      padding: c = 0
    } = f1(t, e) || {};
    if (d == null)
      return {};
    const u = S2(c), f = {
      x: n,
      y: o
    }, m = Sa(i), v = xa(m), _ = await a.getDimensions(d), w = m === "y", $ = w ? "top" : "left", y = w ? "bottom" : "right", M = w ? "clientHeight" : "clientWidth", S = r.reference[v] + r.reference[m] - f[m] - r.floating[v], x = f[m] - r.reference[m], b = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(d));
    let C = b ? b[M] : 0;
    (!C || !await (a.isElement == null ? void 0 : a.isElement(b))) && (C = s.floating[M] || r.floating[v]);
    const E = S / 2 - x / 2, A = C / 2 - _[v] / 2 - 1, T = fn(u[$], A), k = fn(u[y], A), L = T, V = C - _[v] - k, O = C / 2 - _[v] / 2 + E, D = mr(L, O, V), P = !l.arrow && m1(i) != null && O !== D && r.reference[v] / 2 - (O < L ? T : k) - _[v] / 2 < 0, F = P ? O < L ? O - L : O - V : 0;
    return {
      [m]: f[m] + F,
      data: {
        [m]: D,
        centerOffset: O - D - F,
        ...P && {
          alignmentOffset: F
        }
      },
      reset: P
    };
  }
}), hj = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: i,
        middlewareData: r,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: d
      } = e, {
        mainAxis: c = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: _ = !0,
        ...w
      } = f1(t, e);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const $ = Qn(i), y = ko(s), M = Qn(s) === s, S = await (l.isRTL == null ? void 0 : l.isRTL(d.floating)), x = f || (M || !_ ? [Ni(s)] : aj(s)), b = v !== "none";
      !f && b && x.push(...lj(s, _, v, S));
      const C = [s, ...x], E = await Ia(e, w), A = [];
      let T = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (c && A.push(E[$]), u) {
        const O = rj(i, a, S);
        A.push(E[O[0]], E[O[1]]);
      }
      if (T = [...T, {
        placement: i,
        overflows: A
      }], !A.every((O) => O <= 0)) {
        var k, L;
        const O = (((k = r.flip) == null ? void 0 : k.index) || 0) + 1, D = C[O];
        if (D)
          return {
            data: {
              index: O,
              overflows: T
            },
            reset: {
              placement: D
            }
          };
        let P = (L = T.filter((F) => F.overflows[0] <= 0).sort((F, N) => F.overflows[1] - N.overflows[1])[0]) == null ? void 0 : L.placement;
        if (!P)
          switch (m) {
            case "bestFit": {
              var V;
              const F = (V = T.filter((N) => {
                if (b) {
                  const H = ko(N.placement);
                  return H === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  H === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((H) => H > 0).reduce((H, W) => H + W, 0)]).sort((N, H) => N[1] - H[1])[0]) == null ? void 0 : V[0];
              F && (P = F);
              break;
            }
            case "initialPlacement":
              P = s;
              break;
          }
        if (i !== P)
          return {
            reset: {
              placement: P
            }
          };
      }
      return {};
    }
  };
};
async function fj(t, e) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = t, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), a = Qn(n), s = m1(n), l = ko(n) === "y", d = ["left", "top"].includes(a) ? -1 : 1, c = r && l ? -1 : 1, u = f1(e, t);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: v
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return s && typeof v == "number" && (m = s === "end" ? v * -1 : v), l ? {
    x: m * c,
    y: f * d
  } : {
    x: f * d,
    y: m * c
  };
}
const mj = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: i,
        y: r,
        placement: a,
        middlewareData: s
      } = e, l = await fj(e, t);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: i + l.x,
        y: r + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, pj = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: i
      } = e, {
        mainAxis: r = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (w) => {
            let {
              x: $,
              y
            } = w;
            return {
              x: $,
              y
            };
          }
        },
        ...l
      } = f1(t, e), d = {
        x: n,
        y: o
      }, c = await Ia(e, l), u = ko(Qn(i)), f = x2(u);
      let m = d[f], v = d[u];
      if (r) {
        const w = f === "y" ? "top" : "left", $ = f === "y" ? "bottom" : "right", y = m + c[w], M = m - c[$];
        m = mr(y, m, M);
      }
      if (a) {
        const w = u === "y" ? "top" : "left", $ = u === "y" ? "bottom" : "right", y = v + c[w], M = v - c[$];
        v = mr(y, v, M);
      }
      const _ = s.fn({
        ...e,
        [f]: m,
        [u]: v
      });
      return {
        ..._,
        data: {
          x: _.x - n,
          y: _.y - o
        }
      };
    }
  };
}, _j = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      const {
        placement: n,
        rects: o,
        platform: i,
        elements: r
      } = e, {
        apply: a = () => {
        },
        ...s
      } = f1(t, e), l = await Ia(e, s), d = Qn(n), c = m1(n), u = ko(n) === "y", {
        width: f,
        height: m
      } = o.floating;
      let v, _;
      d === "top" || d === "bottom" ? (v = d, _ = c === (await (i.isRTL == null ? void 0 : i.isRTL(r.floating)) ? "start" : "end") ? "left" : "right") : (_ = d, v = c === "end" ? "top" : "bottom");
      const w = m - l.top - l.bottom, $ = f - l.left - l.right, y = fn(m - l[v], w), M = fn(f - l[_], $), S = !e.middlewareData.shift;
      let x = y, b = M;
      if (u ? b = c || S ? fn(M, $) : $ : x = c || S ? fn(y, w) : w, S && !c) {
        const E = Dt(l.left, 0), A = Dt(l.right, 0), T = Dt(l.top, 0), k = Dt(l.bottom, 0);
        u ? b = f - 2 * (E !== 0 || A !== 0 ? E + A : Dt(l.left, l.right)) : x = m - 2 * (T !== 0 || k !== 0 ? T + k : Dt(l.top, l.bottom));
      }
      await a({
        ...e,
        availableWidth: b,
        availableHeight: x
      });
      const C = await i.getDimensions(r.floating);
      return f !== C.width || m !== C.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Lo(t) {
  return Aa(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Ft(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Zn(t) {
  var e;
  return (e = (Aa(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Aa(t) {
  return t instanceof Node || t instanceof Ft(t).Node;
}
function rn(t) {
  return t instanceof Element || t instanceof Ft(t).Element;
}
function $n(t) {
  return t instanceof HTMLElement || t instanceof Ft(t).HTMLElement;
}
function Qs(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Ft(t).ShadowRoot;
}
function ai(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: i
  } = an(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !["inline", "contents"].includes(i);
}
function vj(t) {
  return ["table", "td", "th"].includes(Lo(t));
}
function o0(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function ka(t) {
  const e = Ea(), n = rn(t) ? an(t) : t;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function gj(t) {
  let e = eo(t);
  for (; $n(e) && !d1(e); ) {
    if (ka(e))
      return e;
    if (o0(e))
      return null;
    e = eo(e);
  }
  return null;
}
function Ea() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function d1(t) {
  return ["html", "body", "#document"].includes(Lo(t));
}
function an(t) {
  return Ft(t).getComputedStyle(t);
}
function i0(t) {
  return rn(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function eo(t) {
  if (Lo(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Qs(t) && t.host || // Fallback.
    Zn(t)
  );
  return Qs(e) ? e.host : e;
}
function I2(t) {
  const e = eo(t);
  return d1(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : $n(e) && ai(e) ? e : I2(e);
}
function G1(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = I2(t), r = i === ((o = t.ownerDocument) == null ? void 0 : o.body), a = Ft(i);
  if (r) {
    const s = _r(a);
    return e.concat(a, a.visualViewport || [], ai(i) ? i : [], s && n ? G1(s) : []);
  }
  return e.concat(i, G1(i, [], n));
}
function _r(t) {
  return Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function A2(t) {
  const e = an(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const i = $n(t), r = i ? t.offsetWidth : n, a = i ? t.offsetHeight : o, s = Di(n) !== r || Di(o) !== a;
  return s && (n = r, o = a), {
    width: n,
    height: o,
    $: s
  };
}
function Pa(t) {
  return rn(t) ? t : t.contextElement;
}
function qo(t) {
  const e = Pa(t);
  if (!$n(e))
    return Jn(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: i,
    $: r
  } = A2(e);
  let a = (r ? Di(n.width) : n.width) / o, s = (r ? Di(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const $j = /* @__PURE__ */ Jn(0);
function k2(t) {
  const e = Ft(t);
  return !Ea() || !e.visualViewport ? $j : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function wj(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Ft(t) ? !1 : e;
}
function Eo(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), r = Pa(t);
  let a = Jn(1);
  e && (o ? rn(o) && (a = qo(o)) : a = qo(t));
  const s = wj(r, n, o) ? k2(r) : Jn(0);
  let l = (i.left + s.x) / a.x, d = (i.top + s.y) / a.y, c = i.width / a.x, u = i.height / a.y;
  if (r) {
    const f = Ft(r), m = o && rn(o) ? Ft(o) : o;
    let v = f, _ = _r(v);
    for (; _ && o && m !== v; ) {
      const w = qo(_), $ = _.getBoundingClientRect(), y = an(_), M = $.left + (_.clientLeft + parseFloat(y.paddingLeft)) * w.x, S = $.top + (_.clientTop + parseFloat(y.paddingTop)) * w.y;
      l *= w.x, d *= w.y, c *= w.x, u *= w.y, l += M, d += S, v = Ft(_), _ = _r(v);
    }
  }
  return Ri({
    width: c,
    height: u,
    x: l,
    y: d
  });
}
function yj(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: i
  } = t;
  const r = i === "fixed", a = Zn(o), s = e ? o0(e.floating) : !1;
  if (o === a || s && r)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = Jn(1);
  const c = Jn(0), u = $n(o);
  if ((u || !u && !r) && ((Lo(o) !== "body" || ai(a)) && (l = i0(o)), $n(o))) {
    const f = Eo(o);
    d = qo(o), c.x = f.x + o.clientLeft, c.y = f.y + o.clientTop;
  }
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - l.scrollLeft * d.x + c.x,
    y: n.y * d.y - l.scrollTop * d.y + c.y
  };
}
function Mj(t) {
  return Array.from(t.getClientRects());
}
function E2(t) {
  return Eo(Zn(t)).left + i0(t).scrollLeft;
}
function Cj(t) {
  const e = Zn(t), n = i0(t), o = t.ownerDocument.body, i = Dt(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), r = Dt(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let a = -n.scrollLeft + E2(t);
  const s = -n.scrollTop;
  return an(o).direction === "rtl" && (a += Dt(e.clientWidth, o.clientWidth) - i), {
    width: i,
    height: r,
    x: a,
    y: s
  };
}
function bj(t, e) {
  const n = Ft(t), o = Zn(t), i = n.visualViewport;
  let r = o.clientWidth, a = o.clientHeight, s = 0, l = 0;
  if (i) {
    r = i.width, a = i.height;
    const d = Ea();
    (!d || d && e === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: r,
    height: a,
    x: s,
    y: l
  };
}
function xj(t, e) {
  const n = Eo(t, !0, e === "fixed"), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $n(t) ? qo(t) : Jn(1), a = t.clientWidth * r.x, s = t.clientHeight * r.y, l = i * r.x, d = o * r.y;
  return {
    width: a,
    height: s,
    x: l,
    y: d
  };
}
function el(t, e, n) {
  let o;
  if (e === "viewport")
    o = bj(t, n);
  else if (e === "document")
    o = Cj(Zn(t));
  else if (rn(e))
    o = xj(e, n);
  else {
    const i = k2(t);
    o = {
      ...e,
      x: e.x - i.x,
      y: e.y - i.y
    };
  }
  return Ri(o);
}
function P2(t, e) {
  const n = eo(t);
  return n === e || !rn(n) || d1(n) ? !1 : an(n).position === "fixed" || P2(n, e);
}
function Sj(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = G1(t, [], !1).filter((s) => rn(s) && Lo(s) !== "body"), i = null;
  const r = an(t).position === "fixed";
  let a = r ? eo(t) : t;
  for (; rn(a) && !d1(a); ) {
    const s = an(a), l = ka(a);
    !l && s.position === "fixed" && (i = null), (r ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || ai(a) && !l && P2(t, a)) ? o = o.filter((c) => c !== a) : i = s, a = eo(a);
  }
  return e.set(t, o), o;
}
function Ij(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = t;
  const a = [...n === "clippingAncestors" ? o0(e) ? [] : Sj(e, this._c) : [].concat(n), o], s = a[0], l = a.reduce((d, c) => {
    const u = el(e, c, i);
    return d.top = Dt(u.top, d.top), d.right = fn(u.right, d.right), d.bottom = fn(u.bottom, d.bottom), d.left = Dt(u.left, d.left), d;
  }, el(e, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Aj(t) {
  const {
    width: e,
    height: n
  } = A2(t);
  return {
    width: e,
    height: n
  };
}
function kj(t, e, n) {
  const o = $n(e), i = Zn(e), r = n === "fixed", a = Eo(t, !0, r, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Jn(0);
  if (o || !o && !r)
    if ((Lo(e) !== "body" || ai(i)) && (s = i0(e)), o) {
      const u = Eo(e, !0, r, e);
      l.x = u.x + e.clientLeft, l.y = u.y + e.clientTop;
    } else i && (l.x = E2(i));
  const d = a.left + s.scrollLeft - l.x, c = a.top + s.scrollTop - l.y;
  return {
    x: d,
    y: c,
    width: a.width,
    height: a.height
  };
}
function k0(t) {
  return an(t).position === "static";
}
function tl(t, e) {
  return !$n(t) || an(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function T2(t, e) {
  const n = Ft(t);
  if (o0(t))
    return n;
  if (!$n(t)) {
    let i = eo(t);
    for (; i && !d1(i); ) {
      if (rn(i) && !k0(i))
        return i;
      i = eo(i);
    }
    return n;
  }
  let o = tl(t, e);
  for (; o && vj(o) && k0(o); )
    o = tl(o, e);
  return o && d1(o) && k0(o) && !ka(o) ? n : o || gj(t) || n;
}
const Ej = async function(t) {
  const e = this.getOffsetParent || T2, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: kj(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Pj(t) {
  return an(t).direction === "rtl";
}
const Tj = {
  convertOffsetParentRelativeRectToViewportRelativeRect: yj,
  getDocumentElement: Zn,
  getClippingRect: Ij,
  getOffsetParent: T2,
  getElementRects: Ej,
  getClientRects: Mj,
  getDimensions: Aj,
  getScale: qo,
  isElement: rn,
  isRTL: Pj
};
function Oj(t, e) {
  let n = null, o;
  const i = Zn(t);
  function r() {
    var s;
    clearTimeout(o), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), r();
    const {
      left: d,
      top: c,
      width: u,
      height: f
    } = t.getBoundingClientRect();
    if (s || e(), !u || !f)
      return;
    const m = hi(c), v = hi(i.clientWidth - (d + u)), _ = hi(i.clientHeight - (c + f)), w = hi(d), y = {
      rootMargin: -m + "px " + -v + "px " + -_ + "px " + -w + "px",
      threshold: Dt(0, fn(1, l)) || 1
    };
    let M = !0;
    function S(x) {
      const b = x[0].intersectionRatio;
      if (b !== l) {
        if (!M)
          return a();
        b ? a(!1, b) : o = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      M = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...y,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, y);
    }
    n.observe(t);
  }
  return a(!0), r;
}
function Ta(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, d = Pa(t), c = i || r ? [...d ? G1(d) : [], ...G1(e)] : [];
  c.forEach(($) => {
    i && $.addEventListener("scroll", n, {
      passive: !0
    }), r && $.addEventListener("resize", n);
  });
  const u = d && s ? Oj(d, n) : null;
  let f = -1, m = null;
  a && (m = new ResizeObserver(($) => {
    let [y] = $;
    y && y.target === d && m && (m.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var M;
      (M = m) == null || M.observe(e);
    })), n();
  }), d && !l && m.observe(d), m.observe(e));
  let v, _ = l ? Eo(t) : null;
  l && w();
  function w() {
    const $ = Eo(t);
    _ && ($.x !== _.x || $.y !== _.y || $.width !== _.width || $.height !== _.height) && n(), _ = $, v = requestAnimationFrame(w);
  }
  return n(), () => {
    var $;
    c.forEach((y) => {
      i && y.removeEventListener("scroll", n), r && y.removeEventListener("resize", n);
    }), u == null || u(), ($ = m) == null || $.disconnect(), m = null, l && cancelAnimationFrame(v);
  };
}
const Y1 = mj, r0 = pj, a0 = hj, Lj = _j, Dj = uj, Nj = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: Tj,
    ...n
  }, r = {
    ...i.platform,
    _c: o
  };
  return cj(t, e, {
    ...i,
    platform: r
  });
};
function Rj(t) {
  return t != null && typeof t == "object" && "$el" in t;
}
function vr(t) {
  if (Rj(t)) {
    const e = t.$el;
    return Aa(e) && Lo(e) === "#comment" ? null : e;
  }
  return t;
}
function Ho(t) {
  return typeof t == "function" ? t() : B(t);
}
function Zj(t) {
  return {
    name: "arrow",
    options: t,
    fn(e) {
      const n = vr(Ho(t.element));
      return n == null ? {} : Dj({
        element: n,
        padding: t.padding
      }).fn(e);
    }
  };
}
function O2(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function nl(t, e) {
  const n = O2(t);
  return Math.round(e * n) / n;
}
function s0(t, e, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, i = z(() => {
    var C;
    return (C = Ho(n.open)) != null ? C : !0;
  }), r = z(() => Ho(n.middleware)), a = z(() => {
    var C;
    return (C = Ho(n.placement)) != null ? C : "bottom";
  }), s = z(() => {
    var C;
    return (C = Ho(n.strategy)) != null ? C : "absolute";
  }), l = z(() => {
    var C;
    return (C = Ho(n.transform)) != null ? C : !0;
  }), d = z(() => vr(t.value)), c = z(() => vr(e.value)), u = U(0), f = U(0), m = U(s.value), v = U(a.value), _ = fd({}), w = U(!1), $ = z(() => {
    const C = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return C;
    const E = nl(c.value, u.value), A = nl(c.value, f.value);
    return l.value ? {
      ...C,
      transform: "translate(" + E + "px, " + A + "px)",
      ...O2(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: E + "px",
      top: A + "px"
    };
  });
  let y;
  function M() {
    d.value == null || c.value == null || Nj(d.value, c.value, {
      middleware: r.value,
      placement: a.value,
      strategy: s.value
    }).then((C) => {
      u.value = C.x, f.value = C.y, m.value = C.strategy, v.value = C.placement, _.value = C.middlewareData, w.value = !0;
    });
  }
  function S() {
    typeof y == "function" && (y(), y = void 0);
  }
  function x() {
    if (S(), o === void 0) {
      M();
      return;
    }
    if (d.value != null && c.value != null) {
      y = o(d.value, c.value, M);
      return;
    }
  }
  function b() {
    i.value || (w.value = !1);
  }
  return he([r, a, s], M, {
    flush: "sync"
  }), he([d, c], x, {
    flush: "sync"
  }), he(i, b, {
    flush: "sync"
  }), ld() && dd(S), {
    x: No(u),
    y: No(f),
    strategy: No(m),
    placement: No(v),
    middlewareData: No(_),
    isPositioned: No(w),
    floatingStyles: $,
    update: M
  };
}
const Bj = {
  key: 0,
  class: "dropdown-header"
}, Vj = {
  key: 1,
  class: "dropdown-footer"
}, Fj = /* @__PURE__ */ oe({
  name: "PDropdown",
  __name: "index",
  props: {
    modelValue: { type: Boolean },
    autoHeight: { type: Boolean },
    closeOnSelfClick: { type: Boolean },
    flip: {},
    ignoreClickOutside: { type: Boolean },
    maxHeight: {},
    maxHeightSheet: {},
    noPadding: { type: Boolean },
    placement: { default: "bottom-start" },
    title: {},
    width: {},
    to: {}
  },
  emits: ["update:model-value"],
  setup(t, { emit: e }) {
    const n = t, o = e, { mobile: i } = nt(), r = me(n, "modelValue", o), a = U(), s = U(), l = (y) => s.value = y, d = U(), c = U();
    et(() => {
      c.value = s0(s, d, {
        placement: n.placement === "center" ? "bottom" : n.placement,
        strategy: "fixed",
        middleware: [
          Y1(8),
          a0(n.flip),
          r0({ crossAxis: !0 }),
          Lj({
            apply({ rects: y }) {
              Object.assign(d.value.style, {
                width: `${i.value ? "auto" : n.width || y.reference.width}px`
              });
            }
          }),
          Y1(({ rects: y }) => n.placement !== "center" ? 0 : -y.reference.height / 2 - y.floating.height / 2)
        ],
        whileElementsMounted: Ta
      });
    });
    const u = z(() => {
      if (!c.value) return {};
      const { x: y, y: M, strategy: S } = c.value;
      return {
        position: S,
        top: `${i.value ? 0 : M ?? 0}px`,
        left: `${i.value ? 0 : y ?? 0}px`,
        ...!i.value && n.maxHeight ? { maxHeight: `${n.maxHeight}px` } : {}
      };
    }), f = (y) => {
      y.stopPropagation(), r.value = !r.value;
    }, m = () => new Promise((y) => window.requestAnimationFrame(y)), v = async () => {
      n.closeOnSelfClick && (await m(), r.value = !1);
    }, _ = () => {
      n.ignoreClickOutside || (r.value = !1);
    };
    D1(d, _, {
      ignore: [s]
    });
    const w = U();
    D1(w, _, {
      ignore: [s]
    });
    const $ = U(!1);
    return et(() => $.value = !0), (y, M) => {
      const S = n0, x = Ki;
      return p(), g("div", {
        ref_key: "componentScope",
        ref: a,
        class: "p-dropdown"
      }, [
        Y(y.$slots, "activator", Vr(Fr({ setReference: l, click: f })), void 0, !0),
        $.value && !B(i) ? (p(), J(c1, {
          key: 0,
          to: y.to || a.value
        }, [
          q(Xe, { name: "fade" }, {
            default: G(() => [
              B(r) ? (p(), g("div", {
                key: 0,
                ref_key: "floatingElement",
                ref: d,
                class: "wrapper",
                style: en(u.value),
                onClick: v
              }, [
                h("div", {
                  ref_key: "dropdown",
                  ref: w,
                  class: "dropdown"
                }, [
                  y.$slots.header ? (p(), g("div", Bj, [
                    Y(y.$slots, "header", {}, void 0, !0)
                  ])) : X("", !0),
                  h("div", {
                    class: ee(["dropdown-content", { "no-padding": n.noPadding }])
                  }, [
                    Y(y.$slots, "default", {}, void 0, !0)
                  ], 2),
                  y.$slots.footer ? (p(), g("div", Vj, [
                    Y(y.$slots, "footer", {}, void 0, !0)
                  ])) : X("", !0)
                ], 512)
              ], 4)) : X("", !0)
            ]),
            _: 3
          })
        ], 8, ["to"])) : X("", !0),
        B(i) ? (p(), J(x, {
          key: 1,
          modelValue: B(r),
          "onUpdate:modelValue": M[1] || (M[1] = (b) => Le(r) ? r.value = b : null),
          "max-height": n.maxHeightSheet,
          "no-padding": n.noPadding,
          "close-on-self-click": n.closeOnSelfClick,
          "close-on-click-outside": !n.ignoreClickOutside,
          "auto-height": n.autoHeight,
          to: y.to
        }, Pn({
          header: G(() => [
            n.title ? (p(), J(S, {
              key: 0,
              size: "small",
              "cross-button": "",
              "align-center": "",
              "onClick:close": M[0] || (M[0] = (b) => r.value = !1)
            }, {
              title: G(() => [
                xe(ne(n.title), 1)
              ]),
              _: 1
            })) : Y(y.$slots, "header", { key: 1 }, void 0, !0)
          ]),
          default: G(() => [
            Y(y.$slots, "default", {}, void 0, !0)
          ]),
          _: 2
        }, [
          y.$slots.footer ? {
            name: "footer",
            fn: G(() => [
              Y(y.$slots, "footer", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["modelValue", "max-height", "no-padding", "close-on-self-click", "close-on-click-outside", "auto-height", "to"])) : X("", !0)
      ], 512);
    };
  }
}), L2 = /* @__PURE__ */ ae(Fj, [["__scopeId", "data-v-35399322"]]), Hj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Uj = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M12.251 4.251 7.108 9.836 3.963 6.75a.857.857 0 1 0-1.212 1.212l3.65 3.59a1 1 0 0 0 1.414 0l5.648-6.09a.857.857 0 1 0-1.212-1.212Z"
}, null, -1), zj = [
  Uj
];
function Wj(t, e) {
  return p(), g("svg", Hj, [...zj]);
}
const jj = I({ name: "icon-check-sm", render: Wj }), Gj = { class: "p-options" }, Yj = ["onClick"], Xj = { class: "p-options-option-title" }, Kj = /* @__PURE__ */ oe({
  name: "POptions",
  __name: "index",
  props: {
    modelValue: { type: [String, Number, Boolean, Array, null] },
    options: { default: () => [] },
    multiple: { type: Boolean },
    activeOptionIndex: {},
    textValue: { type: Boolean },
    itemTitle: { default: "text" },
    itemValue: { default: "value" },
    selectedOnTop: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, i = me(n, "modelValue", e), r = z(() => n.itemTitle || "text"), a = z(() => n.itemValue || "value"), s = (c) => n.multiple, l = (c) => {
      var u;
      if (s()) {
        Array.isArray(i.value) || (i.value = []);
        const f = ((u = i.value) == null ? void 0 : u.indexOf(c[a.value])) ?? -1;
        f === -1 ? i.value ? i.value.push(c[a.value]) : i.value = [c[a.value]] : i.value.splice(f, 1);
      } else
        i.value = n.textValue ? c[r.value] : c[a.value];
    }, d = (c) => {
      var u;
      return s(i.value) && Array.isArray(i.value) ? (u = i.value) == null ? void 0 : u.includes(c[a.value]) : i.value === c[a.value];
    };
    return (c, u) => {
      const f = jj;
      return p(), g("div", Gj, [
        (p(!0), g(_e, null, Ie(n.options, (m, v) => (p(), g("div", {
          key: v,
          class: ee(["p-options-option", {
            selected: d(m),
            active: v === n.activeOptionIndex
          }]),
          onClick: (_) => l(m)
        }, [
          Y(c.$slots, "default", { item: m }, () => [
            h("div", Xj, ne(m[r.value]), 1)
          ], !0),
          d(m) ? (p(), J(f, {
            key: 0,
            class: "p-options-option-icon"
          })) : X("", !0)
        ], 10, Yj))), 128))
      ]);
    };
  }
}), D2 = /* @__PURE__ */ ae(Kj, [["__scopeId", "data-v-687a7141"]]), qj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Jj = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17.071 17.071A10 10 0 1 1 2.93 2.928 10 10 0 0 1 17.07 17.071ZM11.212 10l3.334 3.334a.857.857 0 0 1-1.212 1.212L10 11.212l-3.334 3.334a.857.857 0 0 1-1.212-1.212L8.788 10 5.454 6.666a.857.857 0 0 1 1.212-1.212L10 8.788l3.334-3.334a.857.857 0 1 1 1.212 1.212L11.212 10Z",
  "clip-rule": "evenodd"
}, null, -1), Qj = [
  Jj
];
function eG(t, e) {
  return p(), g("svg", qj, [...Qj]);
}
const tG = I({ name: "icon-filled-cross-md", render: eG }), nG = { class: "content" }, oG = { class: "left" }, iG = { class: "value" }, rG = {
  key: 0,
  class: "label"
}, aG = { class: "right" }, sG = {
  key: 0,
  class: "error"
}, lG = {
  key: 1,
  class: "hint"
}, dG = /* @__PURE__ */ oe({
  name: "PField",
  __name: "index",
  props: {
    active: { type: Boolean },
    border: { default: "default" },
    disabled: { type: Boolean },
    error: { type: [String, Boolean] },
    hint: {},
    label: {},
    multiline: { type: Boolean },
    readonly: { type: Boolean },
    size: { default: "medium" },
    textSize: { default: "medium" },
    value: {},
    variant: { default: "default" }
  },
  emits: ["click:control"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = z(() => n.active && !n.error && !n.readonly && !n.disabled), r = z(() => n.label && n.size === "large" && (n.active || String(n.value)));
    return (a, s) => (p(), g("div", {
      class: ee([
        "p-field",
        `variant-${a.variant}`,
        `size-${a.size}`,
        `text-size-${a.textSize}`,
        { disabled: a.disabled, active: i.value, invalid: a.error, label: a.label, multiline: a.multiline }
      ]),
      onClick: s[0] || (s[0] = Ye((l) => o("click:control", l), ["stop"]))
    }, [
      h("div", {
        class: ee(["control", `border-${a.border}`, { readonly: a.readonly }])
      }, [
        h("div", nG, [
          h("div", oG, [
            Y(a.$slots, "left", {}, void 0, !0)
          ]),
          h("div", iG, [
            r.value ? (p(), g("div", rG, [
              Y(a.$slots, "label", {}, () => [
                xe(ne(a.label), 1)
              ], !0)
            ])) : X("", !0),
            Y(a.$slots, "value", {}, void 0, !0)
          ]),
          h("div", aG, [
            Y(a.$slots, "right", {}, void 0, !0)
          ])
        ]),
        Y(a.$slots, "dropdown", {}, void 0, !0)
      ], 2),
      typeof a.error == "string" ? (p(), g("div", sG, ne(a.error), 1)) : a.hint ? (p(), g("div", lG, ne(a.hint), 1)) : X("", !0)
    ], 2));
  }
}), Oa = /* @__PURE__ */ ae(dG, [["__scopeId", "data-v-aa3b5779"]]);
var cG = Object.defineProperty, uG = (t, e, n) => e in t ? cG(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Zi = (t, e, n) => uG(t, typeof e != "symbol" ? e + "" : e, n);
const ol = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, il = (t, e, n) => t.replaceAll(e, "").replace(n, ".").replace("..", ".").replace(/[^.\d]/g, ""), rl = (t, e, n) => {
  var o;
  return new Intl.NumberFormat(((o = n.number) == null ? void 0 : o.locale) ?? "en", {
    minimumFractionDigits: t,
    maximumFractionDigits: e,
    roundingMode: "trunc"
  });
}, hG = (t, e = !0, n) => {
  var o, i, r, a;
  const s = ((o = n.number) == null ? void 0 : o.unsigned) == null && t.startsWith("-") ? "-" : "", l = ((i = n.number) == null ? void 0 : i.fraction) ?? 0;
  let d = rl(0, l, n);
  const c = d.formatToParts(1000.12), u = ((r = c.find((w) => w.type === "group")) == null ? void 0 : r.value) ?? " ", f = ((a = c.find((w) => w.type === "decimal")) == null ? void 0 : a.value) ?? ".", m = il(t, u, f);
  if (m === "" || Number.isNaN(m)) return s;
  const v = m.split(".");
  if (v[1] != null && v[1].length >= 1) {
    const w = v[1].length <= l ? v[1].length : l;
    d = rl(w, l, n);
  }
  let _ = d.format(parseFloat(m));
  return e ? l > 0 && m.endsWith(".") && !m.slice(0, -1).includes(".") && (_ += f) : _ = il(_, u, f), s + _;
};
let fG = class {
  constructor(e = {}) {
    Zi(this, "opts", {}), Zi(this, "memo", /* @__PURE__ */ new Map());
    const n = { ...e };
    if (n.tokens != null) {
      n.tokens = n.tokensReplace ? { ...n.tokens } : { ...ol, ...n.tokens };
      for (const o of Object.values(n.tokens))
        typeof o.pattern == "string" && (o.pattern = new RegExp(o.pattern));
    } else
      n.tokens = ol;
    Array.isArray(n.mask) && (n.mask.length > 1 ? n.mask = [...n.mask].sort((o, i) => o.length - i.length) : n.mask = n.mask[0] ?? ""), n.mask === "" && (n.mask = null), this.opts = n;
  }
  masked(e) {
    return this.process(e, this.findMask(e));
  }
  unmasked(e) {
    return this.process(e, this.findMask(e), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(e) {
    const n = this.findMask(e);
    if (this.opts.mask == null || n == null) return !1;
    const o = this.process(e, n).length;
    return typeof this.opts.mask == "string" ? o >= this.opts.mask.length : o >= n.length;
  }
  findMask(e) {
    const n = this.opts.mask;
    if (n == null)
      return null;
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return n(e);
    const o = this.process(e, n.slice(-1).pop() ?? "", !1);
    return n.find((i) => this.process(e, i, !1).length >= o.length) ?? "";
  }
  escapeMask(e) {
    const n = [], o = [];
    return e.split("").forEach((i, r) => {
      i === "!" && e[r - 1] !== "!" ? o.push(r - o.length) : n.push(i);
    }), { mask: n.join(""), escaped: o };
  }
  process(e, n, o = !0) {
    if (this.opts.number != null) return hG(e, o, this.opts);
    if (n == null) return e;
    const i = `v=${e},mr=${n},m=${o ? 1 : 0}`;
    if (this.memo.has(i)) return this.memo.get(i);
    const { mask: r, escaped: a } = this.escapeMask(n), s = [], l = this.opts.tokens != null ? this.opts.tokens : {}, d = this.isReversed() ? -1 : 1, c = this.isReversed() ? "unshift" : "push", u = this.isReversed() ? 0 : r.length - 1, f = this.isReversed() ? () => w > -1 && $ > -1 : () => w < r.length && $ < e.length, m = (M) => !this.isReversed() && M <= u || this.isReversed() && M >= u;
    let v, _ = -1, w = this.isReversed() ? r.length - 1 : 0, $ = this.isReversed() ? e.length - 1 : 0, y = !1;
    for (; f(); ) {
      const M = r.charAt(w), S = l[M], x = (S == null ? void 0 : S.transform) != null ? S.transform(e.charAt($)) : e.charAt($);
      if (!a.includes(w) && S != null ? (x.match(S.pattern) != null ? (s[c](x), S.repeated ? (_ === -1 ? _ = w : w === u && w !== _ && (w = _ - d), u === _ && (w -= d)) : S.multiple && (y = !0, w -= d), w += d) : S.multiple ? y && (w += d, $ -= d, y = !1) : x === v ? v = void 0 : S.optional && (w += d, $ -= d), $ += d) : (o && !this.isEager() && s[c](M), x === M && !this.isEager() ? $ += d : v = M, this.isEager() || (w += d)), this.isEager())
        for (; m(w) && (l[r.charAt(w)] == null || a.includes(w)); ) {
          if (o) {
            if (s[c](r.charAt(w)), e.charAt($) === r.charAt(w)) {
              w += d, $ += d;
              continue;
            }
          } else r.charAt(w) === e.charAt($) && ($ += d);
          w += d;
        }
    }
    return this.memo.set(i, s.join("")), this.memo.get(i);
  }
};
const N2 = (t) => JSON.parse(t.replaceAll("'", '"')), mG = (t, e = {}) => {
  const n = { ...e };
  t.dataset.maska != null && t.dataset.maska !== "" && (n.mask = pG(t.dataset.maska)), t.dataset.maskaEager != null && (n.eager = fi(t.dataset.maskaEager)), t.dataset.maskaReversed != null && (n.reversed = fi(t.dataset.maskaReversed)), t.dataset.maskaTokensReplace != null && (n.tokensReplace = fi(t.dataset.maskaTokensReplace)), t.dataset.maskaTokens != null && (n.tokens = _G(t.dataset.maskaTokens));
  const o = {};
  return t.dataset.maskaNumberLocale != null && (o.locale = t.dataset.maskaNumberLocale), t.dataset.maskaNumberFraction != null && (o.fraction = parseInt(t.dataset.maskaNumberFraction)), t.dataset.maskaNumberUnsigned != null && (o.unsigned = fi(t.dataset.maskaNumberUnsigned)), (t.dataset.maskaNumber != null || Object.values(o).length > 0) && (n.number = o), n;
}, fi = (t) => t !== "" ? !!JSON.parse(t) : !0, pG = (t) => t.startsWith("[") && t.endsWith("]") ? N2(t) : t, _G = (t) => {
  if (t.startsWith("{") && t.endsWith("}"))
    return N2(t);
  const e = {};
  return t.split("|").forEach((n) => {
    const o = n.split(":");
    e[o[0]] = {
      pattern: new RegExp(o[1]),
      optional: o[2] === "optional",
      multiple: o[2] === "multiple",
      repeated: o[2] === "repeated"
    };
  }), e;
};
class vG {
  constructor(e, n = {}) {
    Zi(this, "items", /* @__PURE__ */ new Map()), Zi(this, "onInput", (o) => {
      if (o instanceof CustomEvent && o.type === "input")
        return;
      const i = o.target, r = this.items.get(i), a = "inputType" in o && o.inputType.startsWith("delete"), s = r.isEager(), l = a && s && r.unmasked(i.value) === "" ? "" : i.value;
      this.fixCursor(i, a, () => this.setValue(i, l));
    }), this.options = n, this.init(this.getInputs(e));
  }
  update(e = {}) {
    this.options = { ...e }, this.init(Array.from(this.items.keys()));
  }
  updateValue(e) {
    e.value !== "" && e.value !== this.processInput(e).masked && this.setValue(e, e.value);
  }
  destroy() {
    for (const e of this.items.keys())
      e.removeEventListener("input", this.onInput);
    this.items.clear();
  }
  init(e) {
    const n = this.getOptions(this.options);
    for (const o of e) {
      this.items.has(o) || o.addEventListener("input", this.onInput, { capture: !0 });
      const i = new fG(mG(o, n));
      this.items.set(o, i), queueMicrotask(() => this.updateValue(o)), o.selectionStart === null && i.isEager() && console.warn("Maska: input of `%s` type is not supported", o.type);
    }
  }
  getInputs(e) {
    return typeof e == "string" ? Array.from(document.querySelectorAll(e)) : "length" in e ? Array.from(e) : [e];
  }
  getOptions(e) {
    const { onMaska: n, preProcess: o, postProcess: i, ...r } = e;
    return r;
  }
  fixCursor(e, n, o) {
    const i = e.selectionStart, r = e.value;
    if (o(), i === null || i === r.length && !n) return;
    const a = e.value, s = r.slice(0, i), l = a.slice(0, i), d = this.processInput(e, s).unmasked, c = this.processInput(e, l).unmasked;
    let u = i;
    s !== l && (u += n ? a.length - r.length : d.length - c.length), e.setSelectionRange(u, u);
  }
  setValue(e, n) {
    const o = this.processInput(e, n);
    e.value = o.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((i) => i(o)) : this.options.onMaska(o)), e.dispatchEvent(new CustomEvent("maska", { detail: o })), e.dispatchEvent(new CustomEvent("input", { detail: o.masked }));
  }
  processInput(e, n) {
    const o = this.items.get(e);
    let i = n ?? e.value;
    this.options.preProcess != null && (i = this.options.preProcess(i));
    let r = o.masked(i);
    return this.options.postProcess != null && (r = this.options.postProcess(r)), {
      masked: r,
      unmasked: o.unmasked(i),
      completed: o.completed(i)
    };
  }
}
const gG = ["placeholder", "type", "autocomplete", "disabled", "readonly", "maxlength", "inputmode"], $G = /* @__PURE__ */ oe({
  name: "PInput",
  __name: "index",
  props: {
    modelValue: { default: "" },
    autocomplete: {},
    autofocus: { type: Boolean },
    inputMode: { default: "text" },
    lostFocusOnEnter: { type: Boolean },
    mask: {},
    maxLength: {},
    placeholder: {},
    type: { default: "text" },
    ignoreClick: { type: Boolean },
    active: { type: Boolean },
    border: { default: "default" },
    disabled: { type: Boolean },
    error: { type: [String, Boolean] },
    hint: {},
    label: {},
    multiline: { type: Boolean },
    readonly: { type: Boolean },
    size: { default: "medium" },
    textSize: { default: "medium" },
    value: {},
    variant: {}
  },
  emits: ["update:modelValue", "focus", "blur", "keydown", "input"],
  setup(t, { expose: e, emit: n }) {
    const o = t, i = n, r = me(o, "modelValue", i), a = U();
    et(() => {
      o.mask && new vG(a.value, { mask: o.mask });
    });
    const s = U(!1), l = z(() => s.value || !o.label), d = (f) => {
      var m;
      o.ignoreClick || (s.value = !0, (m = a.value) == null || m.focus(), i("focus", f));
    }, c = (f) => {
      s.value = !1, i("blur", f);
    }, u = () => {
      var f;
      o.lostFocusOnEnter && ((f = a.value) == null || f.blur());
    };
    return et(() => {
      o.autofocus && a.value && a.value.focus();
    }), e({ input: a }), (f, m) => {
      const v = Oa;
      return p(), J(v, {
        class: "p-input",
        variant: "default",
        value: B(r),
        label: f.label,
        active: s.value,
        error: f.error,
        hint: f.hint,
        size: f.size,
        disabled: f.disabled,
        "text-size": f.textSize,
        border: f.border,
        readonly: f.readonly,
        "onClick:control": m[3] || (m[3] = (_) => d(_))
      }, {
        label: G(() => [
          Y(f.$slots, "label", {}, void 0, !0)
        ]),
        left: G(() => [
          Y(f.$slots, "left", {}, void 0, !0)
        ]),
        value: G(() => [
          it(h("input", {
            ref_key: "inputRef",
            ref: a,
            "onUpdate:modelValue": m[0] || (m[0] = (_) => Le(r) ? r.value = _ : null),
            placeholder: l.value ? f.placeholder : f.label,
            type: f.type,
            autocomplete: f.autocomplete,
            disabled: f.disabled,
            readonly: f.readonly || f.ignoreClick,
            maxlength: f.maxLength,
            inputmode: f.inputMode,
            onFocus: d,
            onBlur: c,
            onKeydown: [
              m[1] || (m[1] = (_) => f.$emit("keydown", _)),
              pd(u, ["enter"])
            ],
            onInput: m[2] || (m[2] = (_) => f.$emit("input", _))
          }, null, 40, gG), [
            [S3, B(r)]
          ])
        ]),
        right: G(() => [
          Y(f.$slots, "right", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["value", "label", "active", "error", "hint", "size", "disabled", "text-size", "border", "readonly"]);
    };
  }
}), l0 = /* @__PURE__ */ ae($G, [["__scopeId", "data-v-a3974a7b"]]), wG = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, yG = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M11.333 6.251 8 9.585 4.666 6.25a.857.857 0 0 0-1.212 1.212l3.839 3.839a1 1 0 0 0 1.414 0l3.838-3.839a.857.857 0 1 0-1.212-1.212Z"
}, null, -1), MG = [
  yG
];
function CG(t, e) {
  return p(), g("svg", wG, [...MG]);
}
const La = I({ name: "icon-arrow-down-sm", render: CG }), bG = { class: "prefix" }, xG = /* @__PURE__ */ oe({
  name: "PSelect",
  __name: "index",
  props: {
    modelValue: { type: [String, Number, Boolean, Array, null] },
    opened: { type: Boolean, default: void 0 },
    options: { default: () => [] },
    prefix: {},
    multiple: { type: Boolean },
    allowCustomValue: { type: Boolean },
    itemTitle: { default: "text" },
    itemValue: { default: "value" },
    hideEmptyMenu: { type: Boolean },
    selectedOnTop: { type: Boolean },
    autoHeight: { type: Boolean },
    closeOnSelfClick: { type: Boolean },
    flip: {},
    ignoreClickOutside: { type: Boolean },
    maxHeight: {},
    maxHeightSheet: {},
    noPadding: { type: Boolean },
    placement: {},
    title: {},
    width: {},
    to: {},
    variant: { default: "default" },
    label: {},
    size: {},
    error: { type: [String, Boolean] },
    hint: {},
    disabled: { type: Boolean },
    border: { default: "default" },
    readonly: { type: Boolean },
    placeholder: {},
    maxLength: {},
    inputMode: { default: "text" },
    autocomplete: {},
    mask: {}
  },
  emits: ["close", "update:modelValue", "update:opened"],
  setup(t, { emit: e }) {
    const n = t, o = (k) => n.multiple, i = e, { mobile: r } = nt(), a = me(n, "modelValue", i), s = () => {
      n.multiple || M();
    }, l = z(() => n.itemTitle || "text"), d = z(() => n.itemValue || "value"), c = z(() => !n.allowCustomValue || n.readonly || r.value), u = U(""), f = () => {
      (n.allowCustomValue || n.multiple && r.value) && (v.value = n.options.filter((k) => k[l.value].includes(u.value)));
    }, m = U([...n.options]), v = z({
      get() {
        if (n.selectedOnTop) {
          const k = [], L = [];
          return n.options.forEach((V) => {
            o(a.value) && a.value.includes(V[d.value]) || a.value === V[d.value] ? k.push(V) : L.push(V);
          }), [...k, ...L];
        }
        return n.options;
      },
      set(k) {
        m.value = [...k];
      }
    }), _ = z(() => n.hideEmptyMenu && !r.value && !v.value.length), w = z(() => {
      var k;
      return n.allowCustomValue && n.hideEmptyMenu ? !!((k = x(l.value, u.value)) != null && k[d.value]) || !v.value.length : !1;
    }), $ = U(), y = typeof n.opened == "boolean" ? me(n, "opened", i) : U(!1);
    he(y, (k) => {
      k && (Jt(() => {
        var L;
        return (L = $.value) == null ? void 0 : L.input.focus();
      }), w.value && (v.value = n.options));
    });
    const M = () => {
      r.value && (u.value = n.allowCustomValue ? b.value ?? a.value : b.value), y.value = !1, i("close");
    }, S = () => {
      u.value = "", v.value = n.options, n.multiple && (a.value = []);
    }, x = (k, L) => n.options.find((V) => V[k] === L) || null, b = z(() => {
      var k;
      if (n.multiple)
        return n.options.reduce((L, V) => (Array.isArray(a.value) && a.value.includes(V[d.value]) && (L = (L && `${L}, `) + V[l.value]), L), "");
      {
        const L = n.allowCustomValue ? l.value : d.value;
        return (k = x(L, a.value)) == null ? void 0 : k[l.value];
      }
    });
    he(b, (k) => {
      var L;
      k && (!n.multiple && n.allowCustomValue && (a.value = ((L = x(l.value, k)) == null ? void 0 : L[d.value]) || k), u.value = k);
    }), et(() => {
      var k;
      a.value && (o(a.value) ? u.value = b.value : u.value = (k = x(d.value, a.value)) == null ? void 0 : k[l.value]);
    });
    const C = U(0), E = (k) => {
      var L;
      if (["ArrowDown", "ArrowUp", "Enter"].includes(k.key))
        switch (k.preventDefault(), k.key) {
          case "ArrowDown": {
            C.value === v.value.length - 1 ? C.value = 0 : C.value = C.value + 1;
            break;
          }
          case "ArrowUp": {
            C.value === 0 ? C.value = v.value.length - 1 : C.value = C.value - 1;
            break;
          }
          case "Enter": {
            const O = ((L = v.value.find((D, P) => P === C.value)) == null ? void 0 : L[d.value]) || (n.allowCustomValue ? u.value : a.value);
            o(a.value) ? a.value.includes(O) ? a.value.splice(C.value, 1) : a.value.push(O) : a.value = a.value !== O ? O : void 0, n.multiple || (M(), C.value = 0);
            break;
          }
        }
    }, A = (k) => {
      var L;
      if (k.key === "Enter") {
        k.preventDefault();
        const V = (L = x(l.value, u.value)) == null ? void 0 : L[d.value];
        n.allowCustomValue ? a.value = u.value : (a.value = V || a.value, u.value = b.value), M(), C.value = 0;
      }
    }, T = () => {
      n.allowCustomValue ? a.value = u.value : u.value = b.value;
    };
    return (k, L) => {
      const V = La, O = vt, D = l0, P = tG, F = n0, N = D2, H = L2;
      return p(), J(H, {
        modelValue: B(y),
        "onUpdate:modelValue": [
          L[4] || (L[4] = (W) => Le(y) ? y.value = W : null),
          L[5] || (L[5] = (W) => !W && M())
        ],
        width: k.width,
        "max-height": k.maxHeight,
        class: ee(["p-select", { opened: B(y), hidden: _.value, error: k.error }])
      }, Pn({
        activator: G(({ setReference: W }) => [
          q(D, {
            ref: W,
            modelValue: u.value,
            "onUpdate:modelValue": L[0] || (L[0] = (te) => u.value = te),
            variant: k.variant,
            label: k.label,
            size: k.size,
            error: k.error,
            hint: k.hint,
            disabled: k.disabled,
            border: k.border,
            placeholder: k.placeholder,
            readonly: k.readonly,
            "max-length": k.maxLength,
            "input-mode": k.inputMode,
            autocomplete: k.autocomplete,
            "ignore-click": c.value,
            mask: k.mask,
            "lost-focus-on-enter": !k.multiple,
            class: "target-input",
            onKeydown: E,
            onBlur: T,
            "onClick:control": L[1] || (L[1] = () => k.readonly ? null : y.value = !0),
            onInput: f
          }, Pn({
            right: G(() => [
              q(O, { variant: "text" }, {
                default: G(() => [
                  q(V, { class: "icon-arrow" })
                ]),
                _: 1
              })
            ]),
            _: 2
          }, [
            k.prefix ? {
              name: "left",
              fn: G(() => [
                h("div", bG, ne(k.prefix), 1)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["modelValue", "variant", "label", "size", "error", "hint", "disabled", "border", "placeholder", "readonly", "max-length", "input-mode", "autocomplete", "ignore-click", "mask", "lost-focus-on-enter"])
        ]),
        default: G(() => [
          v.value.length > 0 ? (p(), J(N, {
            key: 0,
            modelValue: B(a),
            "onUpdate:modelValue": [
              L[3] || (L[3] = (W) => Le(a) ? a.value = W : null),
              s
            ],
            options: v.value,
            multiple: k.multiple,
            "active-option-index": C.value,
            "text-value": k.allowCustomValue,
            "item-title": k.itemTitle,
            "item-value": k.itemValue
          }, {
            default: G((W) => [
              Y(k.$slots, "default", {
                item: W == null ? void 0 : W.item
              }, void 0, !0)
            ]),
            _: 3
          }, 8, ["modelValue", "options", "multiple", "active-option-index", "text-value", "item-title", "item-value"])) : Y(k.$slots, "empty", { key: 1 }, void 0, !0)
        ]),
        _: 2
      }, [
        B(r) || k.$slots.header ? {
          name: "header",
          fn: G(() => [
            B(r) ? (p(), J(F, {
              key: 0,
              borded: "",
              "no-padding": "",
              size: "medium",
              "cross-button": "",
              "onClick:close": M
            }, {
              default: G(() => [
                q(D, {
                  ref_key: "dropdownInput",
                  ref: $,
                  modelValue: u.value,
                  "onUpdate:modelValue": L[2] || (L[2] = (W) => u.value = W),
                  autocomplete: k.autocomplete,
                  class: "header-input",
                  mask: k.mask,
                  onKeydown: A,
                  onInput: f
                }, Pn({ _: 2 }, [
                  u.value ? {
                    name: "right",
                    fn: G(() => [
                      q(O, {
                        variant: "text",
                        color: "asphalt",
                        onClick: S
                      }, {
                        default: G(() => [
                          q(P)
                        ]),
                        _: 1
                      })
                    ]),
                    key: "0"
                  } : void 0
                ]), 1032, ["modelValue", "autocomplete", "mask"])
              ]),
              _: 1
            })) : X("", !0),
            Y(k.$slots, "header", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0,
        k.$slots.footer ? {
          name: "footer",
          fn: G(() => [
            Y(k.$slots, "footer", {}, void 0, !0)
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["modelValue", "width", "max-height", "class"]);
    };
  }
}), R2 = /* @__PURE__ */ ae(xG, [["__scopeId", "data-v-5619f0a3"]]), SG = /* @__PURE__ */ oe({
  name: "PCombobox",
  __name: "PCombobox",
  props: {
    modelValue: { type: [String, Number, Boolean, Array, null] },
    options: { default: () => [] },
    label: {},
    placeholder: {},
    error: { type: [String, Boolean] },
    size: {},
    hint: {},
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    maxHeight: {},
    width: {},
    autocomplete: {},
    allowCustomValue: { type: Boolean },
    itemTitle: { default: "text" },
    itemValue: { default: "value" },
    maxLength: {},
    hideEmptyMenu: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, i = me(n, "modelValue", e);
    return (r, a) => {
      const s = R2;
      return p(), J(s, {
        modelValue: B(i),
        "onUpdate:modelValue": a[0] || (a[0] = (l) => Le(i) ? i.value = l : null),
        options: n.options,
        label: n.label,
        placeholder: n.placeholder,
        error: n.error,
        size: n.size,
        hint: n.hint,
        multiple: n.multiple,
        disabled: n.disabled,
        "max-height": r.maxHeight,
        width: r.width,
        "max-length": r.maxLength,
        "hide-empty-menu": r.hideEmptyMenu,
        autocomplete: n.autocomplete,
        "allow-custom-value": n.allowCustomValue,
        "item-title": r.itemTitle,
        "item-value": r.itemValue
      }, {
        default: G((l) => [
          Y(r.$slots, "default", {
            item: l == null ? void 0 : l.item
          })
        ]),
        _: 3
      }, 8, ["modelValue", "options", "label", "placeholder", "error", "size", "hint", "multiple", "disabled", "max-height", "width", "max-length", "hide-empty-menu", "autocomplete", "allow-custom-value", "item-title", "item-value"]);
    };
  }
}), IG = { class: "dialog-container" }, AG = {
  key: 1,
  class: "bottom-bar-space"
}, kG = {
  key: 2,
  class: "loader"
}, EG = /* @__PURE__ */ oe({
  name: "PDialogCard",
  __name: "PDialogCard",
  props: {
    loading: { type: Boolean },
    full: { type: Boolean }
  },
  setup(t) {
    const e = U(), n = U(), o = U(), i = U(), { arrivedState: r } = q3(i), a = z(() => {
      var s, l;
      return Number((s = i.value) == null ? void 0 : s.scrollHeight) > Number((l = i.value) == null ? void 0 : l.clientHeight);
    });
    return (s, l) => {
      const d = _t;
      return p(), g("div", {
        ref_key: "card",
        ref: o,
        class: ee(["dialog-card", { full: s.full }])
      }, [
        s.$slots.header ? (p(), g("div", {
          key: 0,
          ref_key: "header",
          ref: e
        }, [
          Y(s.$slots, "header", {}, void 0, !0)
        ], 512)) : (p(), g("div", {
          key: 1,
          ref_key: "defaultHeader",
          ref: n,
          class: "top-bar-space"
        }, null, 512)),
        h("div", IG, [
          h("div", {
            ref_key: "content",
            ref: i,
            class: "dialog-card-main"
          }, [
            Y(s.$slots, "default", {}, void 0, !0)
          ], 512),
          s.$slots.footer ? (p(), g("div", {
            key: 0,
            class: ee(["dialog-card-footer", { shadow: a.value && !B(r).bottom }])
          }, [
            Y(s.$slots, "footer", {}, void 0, !0)
          ], 2)) : (p(), g("div", AG)),
          s.loading ? (p(), g("div", kG, [
            q(d, { absolute: "" })
          ])) : X("", !0)
        ])
      ], 2);
    };
  }
}), Da = /* @__PURE__ */ ae(EG, [["__scopeId", "data-v-871dd25b"]]), PG = /* @__PURE__ */ oe({
  name: "PDialog",
  __name: "PDialog",
  props: {
    modelValue: { type: Boolean },
    width: { default: "medium" },
    loading: { type: Boolean },
    maxHeight: {},
    autoHeight: { type: Boolean },
    closeOnClickOutside: { type: Boolean }
  },
  emits: ["click:outside"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = U(), r = me(n, "modelValue"), { mobile: a } = nt();
    he(r, () => document.documentElement.style.overflow = `${r.value ? "hidden" : "visible"}`);
    const s = () => {
      if (!n.closeOnClickOutside) {
        o("click:outside");
        return;
      }
      r.value = !1;
    };
    return (l, d) => {
      const c = Da, u = Ki;
      return p(), g(_e, null, [
        !B(a) && B(r) ? (p(), J(c1, {
          key: 0,
          to: ".p-teleport-container"
        }, [
          h("div", {
            class: ee(["dialog-container", `dialog-width-${l.width}`, { opened: B(r) }])
          }, [
            h("div", {
              class: "dialog-overlay",
              onClick: s
            }),
            q(c, {
              ref_key: "modal",
              ref: i,
              loading: l.loading,
              full: ""
            }, Pn({
              default: G(() => [
                Y(l.$slots, "default", {}, void 0, !0)
              ]),
              _: 2
            }, [
              l.$slots.header ? {
                name: "header",
                fn: G(() => [
                  Y(l.$slots, "header", {}, void 0, !0)
                ]),
                key: "0"
              } : void 0,
              l.$slots.footer ? {
                name: "footer",
                fn: G(() => [
                  Y(l.$slots, "footer", {}, void 0, !0)
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["loading"])
          ], 2)
        ])) : X("", !0),
        B(a) ? (p(), J(u, {
          key: 1,
          modelValue: B(r),
          "onUpdate:modelValue": d[0] || (d[0] = (f) => Le(r) ? r.value = f : null),
          loading: l.loading,
          "max-height": l.maxHeight,
          "auto-height": l.autoHeight,
          "close-on-click-outside": l.closeOnClickOutside,
          "onClick:outside": s
        }, {
          header: G(() => [
            Y(l.$slots, "header", {}, void 0, !0)
          ]),
          footer: G(() => [
            Y(l.$slots, "footer", {}, void 0, !0)
          ]),
          default: G(() => [
            Y(l.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["modelValue", "loading", "max-height", "auto-height", "close-on-click-outside"])) : X("", !0)
      ], 64);
    };
  }
}), TG = /* @__PURE__ */ ae(PG, [["__scopeId", "data-v-793f4962"]]), OG = /* @__PURE__ */ oe({
  name: "PDialogConfirm",
  __name: "PDialogConfirm",
  props: {
    modelValue: { type: Boolean },
    loading: { type: Boolean },
    closeOnClickOutside: { type: Boolean }
  },
  emits: ["click:outside"],
  setup(t, { emit: e }) {
    const { tabletUp: n } = nt(), o = t, i = e, r = U(), a = me(o, "modelValue"), s = () => {
      if (!o.closeOnClickOutside) {
        i("click:outside");
        return;
      }
      a.value = !1;
    };
    return (l, d) => {
      const c = Da;
      return B(a) ? (p(), J(c1, {
        key: 0,
        to: ".p-teleport-container"
      }, [
        h("div", {
          class: ee(["dialog-confirm-container", { opened: B(a), desktop: B(n) }])
        }, [
          h("div", {
            class: "dialog-confirm-overlay",
            onClick: s
          }),
          q(c, {
            ref_key: "modal",
            ref: r,
            loading: l.loading,
            full: ""
          }, Pn({
            default: G(() => [
              Y(l.$slots, "default", {}, void 0, !0)
            ]),
            _: 2
          }, [
            l.$slots.header ? {
              name: "header",
              fn: G(() => [
                Y(l.$slots, "header", {}, void 0, !0)
              ]),
              key: "0"
            } : void 0,
            l.$slots.footer ? {
              name: "footer",
              fn: G(() => [
                Y(l.$slots, "footer", {}, void 0, !0)
              ]),
              key: "1"
            } : void 0
          ]), 1032, ["loading"])
        ], 2)
      ])) : X("", !0);
    };
  }
}), LG = /* @__PURE__ */ ae(OG, [["__scopeId", "data-v-f3af9436"]]), DG = [
  {
    title: "people",
    emojis: [
      "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "🤣",
      "😂",
      "🙂",
      "🙃",
      "😉",
      "😊",
      "😇",
      "🥰",
      "😍",
      "🤩",
      "😘",
      "😗",
      "☺️",
      "😚",
      "😙",
      "😋",
      "😛",
      "😜",
      "🤪",
      "😝",
      "🤑",
      "🤗",
      "🤭",
      "🤫",
      "🤔",
      "🤐",
      "🤨",
      "😐",
      "😑",
      "😶",
      "😏",
      "😒",
      "🙄",
      "😬",
      "🤥",
      "😌",
      "😔",
      "😪",
      "🤤",
      "😴",
      "😷",
      "🤒",
      "🤕",
      "🤢",
      "🤮",
      "🤧",
      "🥵",
      "🥶",
      "🥴",
      "😵",
      "🤯",
      "🤠",
      "🥳",
      "😎",
      "🤓",
      "🧐",
      "😕",
      "😟",
      "🙁",
      "☹️",
      "😮",
      "😯",
      "😲",
      "😳",
      "🥺",
      "😦",
      "😧",
      "😨",
      "😰",
      "😥",
      "😢",
      "😭",
      "😱",
      "😖",
      "😣",
      "😞",
      "😓",
      "😩",
      "😫",
      "😤",
      "😡",
      "😠",
      "🤬",
      "😈",
      "👿",
      "💀",
      "☠️",
      "💩",
      "🤡",
      "👹",
      "👺",
      "👻",
      "👽",
      "👾",
      "🤖",
      "😺",
      "😸",
      "😹",
      "😻",
      "😼",
      "😽",
      "🙀",
      "😿",
      "😾",
      "💋",
      "👋",
      "🤚",
      "🖐",
      "✋",
      "🖖",
      "👌",
      "✌",
      "🤞",
      "🤟",
      "🤘",
      "🤙",
      "👈",
      "👉",
      "👆",
      "🖕",
      "👇",
      "☝",
      "👍",
      "👎",
      "✊",
      "👊",
      "🤛",
      "🤜",
      "👏",
      "🙌",
      "👐",
      "🤲",
      "🤝",
      "🙏",
      "✍",
      "💅",
      "🤳",
      "💪",
      "🦵",
      "🦶",
      "👂",
      "👃",
      "🧠",
      "🦷",
      "🦴",
      "👀",
      "👁️‍🗨️",
      "👅",
      "👄",
      "👶",
      "🧒",
      "👦",
      "👧",
      "🧑",
      "👱",
      "👨",
      "🧔",
      "👱‍♂",
      "👨‍🦰",
      "👨‍🦱",
      "👨‍🦳",
      "👨‍🦲",
      "👩",
      "👱‍♀",
      "👩‍🦰",
      "👩‍🦱",
      "👩‍🦳",
      "👩‍🦲",
      "🧓",
      "👴",
      "👵",
      "🙍",
      "🙍‍♂",
      "🙍‍♀",
      "🙎‍♂",
      "🙎‍♀",
      "🙅‍♂",
      "🙅‍♀",
      "🙆‍♂",
      "🙆‍♀",
      "💁",
      "💁‍♂",
      "💁‍♀",
      "🙋‍♂",
      "🙋‍♀",
      "🙇‍♂",
      "🙇‍♀",
      "🤦‍♂",
      "🤦‍♀",
      "🤷‍♂",
      "🤷‍♀",
      "👨‍⚕",
      "👩‍⚕",
      "👨‍🎓",
      "👩‍🎓",
      "👨‍🏫",
      "👩‍🏫",
      "👨‍⚖",
      "👩‍⚖",
      "👨‍🌾",
      "👩‍🌾",
      "👨‍🍳",
      "👩‍🍳",
      "👨‍🔧",
      "👩‍🔧",
      "👨‍🏭",
      "👩‍🏭",
      "👨‍💼",
      "👩‍💼",
      "👨‍🔬",
      "👩‍🔬",
      "👨‍💻",
      "👩‍💻",
      "👨‍🎤",
      "👩‍🎤",
      "👨‍🎨",
      "👩‍🎨",
      "👨‍✈",
      "👩‍✈",
      "👨‍🚀",
      "👩‍🚀",
      "👨‍🚒",
      "👩‍🚒",
      "👮‍♂",
      "👮‍♀",
      "🕵‍♂",
      "🕵‍♀",
      "💂‍♂",
      "💂‍♀",
      "👷‍♂",
      "👷‍♀",
      "🤴",
      "👸",
      "👳‍♂",
      "👳‍♀",
      "👲",
      "🧕",
      "🤵",
      "👰",
      "🤰",
      "🤱",
      "👼",
      "🎅",
      "🤶",
      "🦸‍♂",
      "🦸‍♀",
      "🦹‍♂",
      "🦹‍♀",
      "🧙‍♂",
      "🧙‍♀",
      "🧚‍♂",
      "🧚‍♀",
      "🧛‍♂",
      "🧛‍♀",
      "🧜‍♂",
      "🧜‍♀",
      "🧝‍♂",
      "🧝‍♀",
      "🧞‍♂",
      "🧞‍♀",
      "🧟‍♂",
      "🧟‍♀",
      "💆‍♂",
      "💆‍♀",
      "💇‍♂",
      "💇‍♀",
      "🚶‍♂",
      "🚶‍♀",
      "🏃‍♂",
      "🏃‍♀",
      "💃",
      "🕺",
      "🕴",
      "👯‍♂",
      "👯‍♀",
      "🧖‍♂",
      "🧖‍♀",
      "👭",
      "👫",
      "👬",
      "💏",
      "👨‍❤‍💋‍👨",
      "👩‍❤‍💋‍👩",
      "💑",
      "👨‍❤‍👨",
      "👩‍❤‍👩",
      "👨‍👩‍👦",
      "👨‍👩‍👧",
      "👨‍👩‍👧‍👦",
      "👨‍👩‍👦‍👦",
      "👨‍👩‍👧‍👧",
      "👨‍👨‍👦",
      "👨‍👨‍👧",
      "👨‍👨‍👧‍👦",
      "👨‍👨‍👦‍👦",
      "👨‍👨‍👧‍👧",
      "👩‍👩‍👦",
      "👩‍👩‍👧",
      "👩‍👩‍👧‍👦",
      "👩‍👩‍👦‍👦",
      "👩‍👩‍👧‍👧",
      "👨‍👦",
      "👨‍👦‍👦",
      "👨‍👧",
      "👨‍👧‍👦",
      "👨‍👧‍👧",
      "👩‍👦",
      "👩‍👦‍👦",
      "👩‍👧",
      "👩‍👧‍👦",
      "👩‍👧‍👧",
      "🗣️",
      "👤",
      "👥",
      "👣",
      "🧳",
      "🌂",
      "☂️",
      "🧵",
      "🧶",
      "👓",
      "🕶️",
      "🥽",
      "🥼",
      "👔",
      "👕",
      "👖",
      "🧣",
      "🧤",
      "🧥",
      "🧦",
      "👗",
      "👘",
      "👙",
      "👚",
      "👛",
      "👜",
      "👝",
      "🎒",
      "👞",
      "👟",
      "🥾",
      "🥿",
      "👠",
      "👡",
      "👢",
      "👑",
      "👒",
      "🎩",
      "🎓",
      "🧢",
      "⛑️",
      "💄",
      "💍",
      "💼",
      "🎃"
    ]
  },
  {
    title: "nature",
    emojis: [
      "🙈",
      "🙉",
      "🙊",
      "💥",
      "💫",
      "💦",
      "💨",
      "🐵",
      "🐒",
      "🦍",
      "🐶",
      "🐕",
      "🐩",
      "🐺",
      "🦊",
      "🦝",
      "🐱",
      "🐈",
      "🦁",
      "🐯",
      "🐅",
      "🐆",
      "🐴",
      "🐎",
      "🦄",
      "🦓",
      "🦌",
      "🐮",
      "🐂",
      "🐃",
      "🐄",
      "🐷",
      "🐖",
      "🐗",
      "🐽",
      "🐏",
      "🐑",
      "🐐",
      "🐪",
      "🐫",
      "🦙",
      "🦒",
      "🐘",
      "🦏",
      "🦛",
      "🐭",
      "🐁",
      "🐀",
      "🐹",
      "🐰",
      "🐇",
      "🐿️",
      "🦔",
      "🦇",
      "🐻",
      "🐨",
      "🐼",
      "🦘",
      "🦡",
      "🐾",
      "🦃",
      "🐔",
      "🐓",
      "🐣",
      "🐤",
      "🐥",
      "🐦",
      "🐧",
      "🕊️",
      "🦅",
      "🦆",
      "🦢",
      "🦉",
      "🦚",
      "🦜",
      "🐸",
      "🐊",
      "🐢",
      "🦎",
      "🐍",
      "🐲",
      "🐉",
      "🦕",
      "🦖",
      "🐳",
      "🐋",
      "🐬",
      "🐟",
      "🐠",
      "🐡",
      "🦈",
      "🐙",
      "🐚",
      "🐌",
      "🦋",
      "🐛",
      "🐜",
      "🐝",
      "🐞",
      "🦗",
      "🕷️",
      "🕸️",
      "🦂",
      "🦟",
      "🦠",
      "💐",
      "🌸",
      "💮",
      "🏵️",
      "🌹",
      "🥀",
      "🌺",
      "🌻",
      "🌼",
      "🌷",
      "🌱",
      "🌲",
      "🌳",
      "🌴",
      "🌵",
      "🌾",
      "🌿",
      "☘️",
      "🍀",
      "🍁",
      "🍂",
      "🍃",
      "🍄",
      "🌰",
      "🦀",
      "🦞",
      "🦐",
      "🦑",
      "🌍",
      "🌎",
      "🌏",
      "🌐",
      "🌑",
      "🌒",
      "🌓",
      "🌔",
      "🌕",
      "🌖",
      "🌗",
      "🌘",
      "🌙",
      "🌚",
      "🌛",
      "🌜",
      "☀️",
      "🌝",
      "🌞",
      "⭐",
      "🌟",
      "🌠",
      "☁️",
      "⛅",
      "🌥️",
      "🌦️",
      "🌧️",
      "🌨️",
      "🌩️",
      "🌪️",
      "🌫️",
      "🌬️",
      "🌈",
      "☂️",
      "☔",
      "⚡",
      "❄️",
      "☃️",
      "⛄",
      "☄️",
      "🔥",
      "💧",
      "🌊",
      "🎄",
      "✨",
      "🎋",
      "🎍"
    ]
  },
  {
    title: "foodDrink",
    emojis: [
      "🍇",
      "🍈",
      "🍉",
      "🍊",
      "🍋",
      "🍌",
      "🍍",
      "🥭",
      "🍎",
      "🍏",
      "🍐",
      "🍑",
      "🍒",
      "🍓",
      "🥝",
      "🍅",
      "🥥",
      "🥑",
      "🍆",
      "🥔",
      "🥕",
      "🌽",
      "🌶️",
      "🥒",
      "🥬",
      "🥦",
      "🍄",
      "🥜",
      "🌰",
      "🍞",
      "🥐",
      "🥖",
      "🥨",
      "🥯",
      "🥞",
      "🧀",
      "🍖",
      "🍗",
      "🥩",
      "🥓",
      "🍔",
      "🍟",
      "🍕",
      "🌭",
      "🥪",
      "🌮",
      "🌯",
      "🥙",
      "🍳",
      "🥘",
      "🍲",
      "🥣",
      "🥗",
      "🍿",
      "🧂",
      "🥫",
      "🍱",
      "🍘",
      "🍙",
      "🍚",
      "🍛",
      "🍜",
      "🍝",
      "🍠",
      "🍢",
      "🍣",
      "🍤",
      "🍥",
      "🥮",
      "🍡",
      "🥟",
      "🥠",
      "🥡",
      "🍦",
      "🍧",
      "🍨",
      "🍩",
      "🍪",
      "🎂",
      "🍰",
      "🧁",
      "🥧",
      "🍫",
      "🍬",
      "🍭",
      "🍮",
      "🍯",
      "🍼",
      "🥛",
      "☕",
      "🍵",
      "🍶",
      "🍾",
      "🍷",
      "🍸",
      "🍹",
      "🍺",
      "🍻",
      "🥂",
      "🥃",
      "🥤",
      "🥢",
      "🍽️",
      "🍴",
      "🥄",
      "🥚"
    ]
  },
  {
    title: "activity",
    emojis: [
      "🕴",
      "🧗‍♂",
      "🧗‍♀",
      "🏇",
      "⛷️",
      "🏂",
      "🏌‍♂",
      "🏌‍♀",
      "🏄‍♂",
      "🏄‍♀",
      "🚣‍♂",
      "🚣‍♀",
      "🏊‍♂",
      "🏊‍♀",
      "⛹‍♂",
      "⛹‍♀",
      "🏋‍♂",
      "🏋‍♀",
      "🚴‍♂",
      "🚴‍♀",
      "🚵‍♂",
      "🚵‍♀",
      "🤸‍♂",
      "🤸‍♀",
      "🤼‍♂",
      "🤼‍♀",
      "🤽‍♂",
      "🤽‍♀",
      "🤾‍♂",
      "🤾‍♀",
      "🤹‍♂",
      "🤹‍♀",
      "🧘‍♂",
      "🧘‍♀",
      "🎪",
      "🛹",
      "🎗️",
      "🎟️",
      "🎫",
      "🎖️",
      "🏆",
      "🏅",
      "🥇",
      "🥈",
      "🥉",
      "⚽",
      "⚾",
      "🥎",
      "🏀",
      "🏐",
      "🏈",
      "🏉",
      "🎾",
      "🥏",
      "🎳",
      "🏏",
      "🏑",
      "🏒",
      "🥍",
      "🏓",
      "🏸",
      "🥊",
      "🥋",
      "⛳",
      "⛸️",
      "🎣",
      "🎽",
      "🎿",
      "🛷",
      "🥌",
      "🎯",
      "🎱",
      "🎮",
      "🎰",
      "🎲",
      "🧩",
      "♟️",
      "🎭",
      "🎨",
      "🧵",
      "🧶",
      "🎼",
      "🎤",
      "🎧",
      "🎷",
      "🎸",
      "🎹",
      "🎺",
      "🎻",
      "🥁",
      "🎬",
      "🏹",
      "🥅",
      "🤺"
    ]
  },
  {
    title: "travelPlaces",
    emojis: [
      "🗾",
      "🏔️",
      "⛰️",
      "🌋",
      "🗻",
      "🏕️",
      "🏖️",
      "🏜️",
      "🏝️",
      "🏞️",
      "🏟️",
      "🏛️",
      "🏗️",
      "🏘️",
      "🏚️",
      "🏠",
      "🏡",
      "🏢",
      "🏣",
      "🏤",
      "🏥",
      "🏦",
      "🏨",
      "🏩",
      "🏪",
      "🏫",
      "🏬",
      "🏭",
      "🏯",
      "🏰",
      "💒",
      "🗼",
      "🗽",
      "⛪",
      "🕌",
      "🕍",
      "⛩️",
      "🕋",
      "⛲",
      "⛺",
      "🌁",
      "🌃",
      "🏙️",
      "🌄",
      "🌅",
      "🌆",
      "🌇",
      "🌉",
      "🎠",
      "🎡",
      "🎢",
      "🚂",
      "🚃",
      "🚄",
      "🚅",
      "🚆",
      "🚇",
      "🚈",
      "🚉",
      "🚊",
      "🚝",
      "🚞",
      "🚋",
      "🚌",
      "🚍",
      "🚎",
      "🚐",
      "🚑",
      "🚒",
      "🚓",
      "🚔",
      "🚕",
      "🚖",
      "🚗",
      "🚘",
      "🚚",
      "🚛",
      "🚜",
      "🏎️",
      "🏍️",
      "🛵",
      "🚲",
      "🛴",
      "🚏",
      "🛤️",
      "⛽",
      "🚨",
      "🚥",
      "🚦",
      "🚧",
      "⚓",
      "⛵",
      "🚤",
      "🛳️",
      "⛴️",
      "🛥️",
      "🚢",
      "✈️",
      "🛩️",
      "🛫",
      "🛬",
      "💺",
      "🚁",
      "🚟",
      "🚠",
      "🚡",
      "🛰️",
      "🚀",
      "🛸",
      "🌠",
      "🌌",
      "⛱️",
      "🎆",
      "🎇",
      "🎑",
      "💴",
      "💵",
      "💶",
      "💷",
      "🗿",
      "🛂",
      "🛃",
      "🛄",
      "🛅",
      "🚙",
      "🛶",
      "🛣️"
    ]
  },
  {
    title: "objects",
    emojis: [
      "💌",
      "🕳️",
      "💣",
      "🛀",
      "🛌",
      "🔪",
      "🏺",
      "🗺️",
      "🧭",
      "🧱",
      "💈",
      "🛢️",
      "🛎️",
      "🧳",
      "⌛",
      "⏳",
      "⌚",
      "⏰",
      "⏱",
      "⏲",
      "🕰️",
      "🌡️",
      "⛱️",
      "🧨",
      "🎈",
      "🎉",
      "🎊",
      "🎎",
      "🎏",
      "🎐",
      "🧧",
      "🎀",
      "🎁",
      "🔮",
      "🧿",
      "🕹️",
      "🧸",
      "🖼️",
      "🧵",
      "🧶",
      "🛍️",
      "📿",
      "💎",
      "📯",
      "🎙️",
      "🎚️",
      "🎛️",
      "📻",
      "📱",
      "📲",
      "☎️",
      "📞",
      "📟",
      "📠",
      "🔋",
      "🔌",
      "💻",
      "🖥️",
      "🖨️",
      "⌨️",
      "🖱️",
      "🖲️",
      "💽",
      "💾",
      "💿",
      "📀",
      "🧮",
      "🎥",
      "🎞️",
      "📽️",
      "📺",
      "📷",
      "📸",
      "📹",
      "📼",
      "🔍",
      "🔎",
      "🕯️",
      "💡",
      "🔦",
      "🏮",
      "📔",
      "📕",
      "📖",
      "📗",
      "📘",
      "📙",
      "📚",
      "📓",
      "📃",
      "📜",
      "📄",
      "📰",
      "🗞️",
      "📑",
      "🔖",
      "🏷️",
      "💰",
      "💴",
      "💵",
      "💶",
      "💷",
      "💸",
      "💳",
      "🧾",
      "✉️",
      "📧",
      "📨",
      "📩",
      "📤",
      "📥",
      "📦",
      "📫",
      "📪",
      "📬",
      "📭",
      "📮",
      "🗳️",
      "✏️",
      "✒️",
      "🖋️",
      "🖊️",
      "🖌️",
      "🖍️",
      "📝",
      "📁",
      "📂",
      "🗂️",
      "📅",
      "📆",
      "🗒️",
      "🗓️",
      "📇",
      "📈",
      "📉",
      "📊",
      "📋",
      "📌",
      "📍",
      "📎",
      "🖇️",
      "📏",
      "📐",
      "✂️",
      "🗃️",
      "🗄️",
      "🗑️",
      "🔒",
      "🔓",
      "🔏",
      "🔐",
      "🔑",
      "🗝️",
      "🔨",
      "⛏️",
      "⚒️",
      "🛠️",
      "🗡️",
      "⚔️",
      "🔫",
      "🛡️",
      "🔧",
      "🔩",
      "⚙️",
      "🗜️",
      "⚖️",
      "🔗",
      "⛓️",
      "🧰",
      "🧲",
      "⚗️",
      "🧪",
      "🧫",
      "🧬",
      "🔬",
      "🔭",
      "📡",
      "💉",
      "💊",
      "🚪",
      "🛏️",
      "🛋️",
      "🚽",
      "🚿",
      "🛁",
      "🧴",
      "🧷",
      "🧹",
      "🧺",
      "🧻",
      "🧼",
      "🧽",
      "🧯",
      "🚬",
      "⚰️",
      "⚱️",
      "🗿",
      "🚰",
      "📒",
      "🛒"
    ]
  },
  {
    title: "symbols",
    emojis: [
      "💘",
      "💝",
      "💖",
      "💗",
      "💓",
      "💞",
      "💕",
      "💟",
      "❣️",
      "💔",
      "❤️",
      "🧡",
      "💛",
      "💚",
      "💙",
      "💜",
      "🖤",
      "💯",
      "💢",
      "💬",
      "👁‍🗨",
      "🗯️",
      "💭",
      "💤",
      "💮",
      "♨️",
      "💈",
      "🛑",
      "🕛",
      "🕧",
      "🕐",
      "🕜",
      "🕑",
      "🕝",
      "🕒",
      "🕞",
      "🕓",
      "🕟",
      "🕔",
      "🕠",
      "🕕",
      "🕡",
      "🕖",
      "🕢",
      "🕗",
      "🕣",
      "🕘",
      "🕤",
      "🕙",
      "🕥",
      "🕚",
      "🕦",
      "🌀",
      "♠",
      "♥",
      "♦",
      "♣",
      "🃏",
      "🀄",
      "🎴",
      "🔇",
      "🔈",
      "🔉",
      "🔊",
      "📢",
      "📣",
      "📯",
      "🔔",
      "🔕",
      "🎵",
      "🎶",
      "🏧",
      "🚮",
      "🚰",
      "♿",
      "🚹",
      "🚺",
      "🚻",
      "🚼",
      "🚾",
      "⚠️",
      "🚸",
      "⛔",
      "🚫",
      "🚳",
      "🚭",
      "🚯",
      "🚱",
      "🚷",
      "🔞",
      "☢️",
      "☣️",
      "⬆️",
      "↗️",
      "➡️",
      "↘️",
      "⬇️",
      "↙️",
      "⬅️",
      "↖️",
      "↕",
      "↔",
      "↩️",
      "↪️",
      "⤴️",
      "⤵️",
      "🔃",
      "🔄",
      "🔙",
      "🔚",
      "🔛",
      "🔜",
      "🔝",
      "🛐",
      "⚛️",
      "🕉️",
      "✡️",
      "☸️",
      "☯️",
      "✝️",
      "☦️",
      "☪️",
      "☮️",
      "🕎",
      "🔯",
      "♈",
      "♉",
      "♊",
      "♋",
      "♌",
      "♍",
      "♎",
      "♏",
      "♐",
      "♑",
      "♒",
      "♓",
      "⛎",
      "🔀",
      "🔁",
      "🔂",
      "▶️",
      "⏩",
      "◀",
      "⏪",
      "🔼",
      "⏫",
      "🔽",
      "⏬",
      "⏹",
      "⏏️",
      "🎦",
      "🔅",
      "🔆",
      "📶",
      "📳",
      "📴",
      "♾️",
      "♻️",
      "🔱",
      "📛",
      "🔰",
      "⭕",
      "✅",
      "☑️",
      "✔️",
      "✖",
      "❌",
      "❎",
      "➕",
      "➖",
      "➗",
      "➰",
      "➿",
      "〽️",
      "✳️",
      "✴️",
      "❇️",
      "‼",
      "⁉",
      "❓",
      "❔",
      "❕",
      "❗",
      "©",
      "®",
      "™",
      "#️⃣",
      "0️⃣",
      "1️⃣",
      "2️⃣",
      "3️⃣",
      "4️⃣",
      "5️⃣",
      "6️⃣",
      "7️⃣",
      "8️⃣",
      "9️⃣",
      "🔟",
      "🔠",
      "🔡",
      "🔢",
      "🔣",
      "🔤",
      "🅰",
      "🆎",
      "🅱",
      "🆑",
      "🆒",
      "🆓",
      "ℹ",
      "🆔",
      "Ⓜ️",
      "🆕",
      "🆖",
      "🅾",
      "🆗",
      "🅿",
      "🆘",
      "🆙",
      "🆚",
      "🈁",
      "🈂️",
      "🈷️",
      "🈶",
      "🈯",
      "🉐",
      "🈹",
      "🈚",
      "🈲",
      "🉑",
      "🈸",
      "🈴",
      "🈳",
      "㊗️",
      "㊙️",
      "🈺",
      "🈵",
      "🔴",
      "🔵",
      "⚫",
      "⚪",
      "⬛",
      "⬜",
      "◼️",
      "◻️",
      "◾",
      "◽",
      "▪",
      "▫",
      "🔶",
      "🔷",
      "🔸",
      "🔹",
      "🔺",
      "🔻",
      "💠",
      "🔳",
      "🔲",
      "📵",
      "⚜️",
      "💹",
      "*️⃣",
      "⏸",
      "⏯",
      "⏺",
      "⏭",
      "⏮",
      "💲",
      "💱",
      "〰️",
      "🔘"
    ]
  },
  {
    title: "flags",
    emojis: [
      "🏁",
      "🚩",
      "🎌",
      "🏴",
      "🏳️",
      "🏳‍🌈",
      "🏴‍☠",
      "🇦🇨",
      "🇦🇩",
      "🇦🇪",
      "🇦🇫",
      "🇦🇬",
      "🇦🇮",
      "🇦🇱",
      "🇦🇲",
      "🇦🇴",
      "🇦🇶",
      "🇦🇷",
      "🇦🇸",
      "🇦🇹",
      "🇦🇺",
      "🇦🇼",
      "🇦🇽",
      "🇦🇿",
      "🇧🇦",
      "🇧🇧",
      "🇧🇩",
      "🇧🇪",
      "🇧🇫",
      "🇧🇬",
      "🇧🇭",
      "🇧🇮",
      "🇧🇯",
      "🇧🇱",
      "🇧🇲",
      "🇧🇳",
      "🇧🇴",
      "🇧🇶",
      "🇧🇷",
      "🇧🇸",
      "🇧🇹",
      "🇧🇻",
      "🇧🇼",
      "🇧🇾",
      "🇧🇿",
      "🇨🇦",
      "🇨🇨",
      "🇨🇩",
      "🇨🇫",
      "🇨🇬",
      "🇨🇭",
      "🇨🇮",
      "🇨🇰",
      "🇨🇱",
      "🇨🇲",
      "🇨🇳",
      "🇨🇴",
      "🇨🇵",
      "🇨🇷",
      "🇨🇺",
      "🇨🇻",
      "🇨🇼",
      "🇨🇽",
      "🇨🇾",
      "🇨🇿",
      "🇩🇪",
      "🇩🇬",
      "🇩🇯",
      "🇩🇰",
      "🇩🇲",
      "🇩🇴",
      "🇩🇿",
      "🇪🇦",
      "🇪🇨",
      "🇪🇪",
      "🇪🇬",
      "🇪🇭",
      "🇪🇷",
      "🇪🇸",
      "🇪🇹",
      "🇪🇺",
      "🇫🇮",
      "🇫🇯",
      "🇫🇰",
      "🇫🇲",
      "🇫🇴",
      "🇫🇷",
      "🇬🇦",
      "🇬🇧",
      "🇬🇩",
      "🇬🇪",
      "🇬🇫",
      "🇬🇬",
      "🇬🇭",
      "🇬🇮",
      "🇬🇱",
      "🇬🇲",
      "🇬🇳",
      "🇬🇵",
      "🇬🇶",
      "🇬🇷",
      "🇬🇸",
      "🇬🇹",
      "🇬🇺",
      "🇬🇼",
      "🇬🇾",
      "🇭🇰",
      "🇭🇲",
      "🇭🇳",
      "🇭🇷",
      "🇭🇹",
      "🇭🇺",
      "🇮🇨",
      "🇮🇩",
      "🇮🇪",
      "🇮🇱",
      "🇮🇲",
      "🇮🇳",
      "🇮🇴",
      "🇮🇶",
      "🇮🇷",
      "🇮🇸",
      "🇮🇹",
      "🇯🇪",
      "🇯🇲",
      "🇯🇴",
      "🇯🇵",
      "🇰🇪",
      "🇰🇬",
      "🇰🇭",
      "🇰🇮",
      "🇰🇲",
      "🇰🇳",
      "🇰🇵",
      "🇰🇷",
      "🇰🇼",
      "🇰🇾",
      "🇰🇿",
      "🇱🇦",
      "🇱🇧",
      "🇱🇨",
      "🇱🇮",
      "🇱🇰",
      "🇱🇷",
      "🇱🇸",
      "🇱🇹",
      "🇱🇺",
      "🇱🇻",
      "🇱🇾",
      "🇲🇦",
      "🇲🇨",
      "🇲🇩",
      "🇲🇪",
      "🇲🇫",
      "🇲🇬",
      "🇲🇭",
      "🇲🇰",
      "🇲🇱",
      "🇲🇲",
      "🇲🇳",
      "🇲🇴",
      "🇲🇵",
      "🇲🇶",
      "🇲🇷",
      "🇲🇸",
      "🇲🇹",
      "🇲🇺",
      "🇲🇻",
      "🇲🇼",
      "🇲🇽",
      "🇲🇾",
      "🇲🇿",
      "🇳🇦",
      "🇳🇨",
      "🇳🇪",
      "🇳🇫",
      "🇳🇬",
      "🇳🇮",
      "🇳🇱",
      "🇳🇴",
      "🇳🇵",
      "🇳🇷",
      "🇳🇺",
      "🇳🇿",
      "🇴🇲",
      "🇵🇦",
      "🇵🇪",
      "🇵🇫",
      "🇵🇬",
      "🇵🇭",
      "🇵🇰",
      "🇵🇱",
      "🇵🇲",
      "🇵🇳",
      "🇵🇷",
      "🇵🇸",
      "🇵🇹",
      "🇵🇼",
      "🇵🇾",
      "🇶🇦",
      "🇷🇪",
      "🇷🇴",
      "🇷🇸",
      "🇷🇺",
      "🇷🇼",
      "🇸🇦",
      "🇸🇧",
      "🇸🇨",
      "🇸🇩",
      "🇸🇪",
      "🇸🇬",
      "🇸🇭",
      "🇸🇮",
      "🇸🇯",
      "🇸🇰",
      "🇸🇱",
      "🇸🇲",
      "🇸🇳",
      "🇸🇴",
      "🇸🇷",
      "🇸🇸",
      "🇸🇹",
      "🇸🇻",
      "🇸🇽",
      "🇸🇾",
      "🇸🇿",
      "🇹🇦",
      "🇹🇨",
      "🇹🇩",
      "🇹🇫",
      "🇹🇬",
      "🇹🇭",
      "🇹🇯",
      "🇹🇰",
      "🇹🇱",
      "🇹🇲",
      "🇹🇳",
      "🇹🇴",
      "🇹🇷",
      "🇹🇹",
      "🇹🇻",
      "🇹🇼",
      "🇹🇿",
      "🇺🇦",
      "🇺🇬",
      "🇺🇲",
      "🇺🇳",
      "🇺🇸",
      "🇺🇾",
      "🇺🇿",
      "🇻🇦",
      "🇻🇨",
      "🇻🇪",
      "🇻🇬",
      "🇻🇮",
      "🇻🇳",
      "🇻🇺",
      "🇼🇫",
      "🇼🇸",
      "🇽🇰",
      "🇾🇪",
      "🇾🇹",
      "🇿🇦",
      "🇿🇲",
      "🇿🇼",
      "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
      "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
      "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
      "🏳️‍⚧️",
      "🏴󠁵󠁳󠁴󠁸󠁿"
    ]
  }
], NG = (t) => (ei("data-v-5a2246c2"), t = t(), ti(), t), RG = { class: "p-emoji-picker-wrapper" }, ZG = /* @__PURE__ */ NG(() => /* @__PURE__ */ h("div", { class: "tab-marker" }, null, -1)), BG = { class: "category-title" }, VG = ["id"], FG = ["onClick"], HG = /* @__PURE__ */ oe({
  name: "PEmojiPicker",
  __name: "PEmojiPicker",
  props: {
    opened: { type: Boolean },
    fullwidth: { type: Boolean },
    position: {},
    placement: { default: "top-end" }
  },
  emits: ["update:opened", "select:emoji"],
  setup(t, { emit: e }) {
    Nn((k) => ({
      "103d6464": $.value,
      "443812a5": S.value
    }));
    const n = t, o = e, i = n.opened ? me(n, "opened", o) : U(!1), r = U([
      {
        icon: I(Dd),
        key: "people"
      },
      {
        icon: I(xd),
        key: "nature"
      },
      {
        icon: I(bd),
        key: "foodDrink"
      },
      {
        icon: I(Nd),
        key: "activity"
      },
      {
        icon: I(Cd),
        key: "travelPlaces"
      },
      {
        icon: I(Pd),
        key: "objects"
      },
      {
        icon: I(kd),
        key: "symbols"
      },
      {
        icon: I(Ad),
        key: "flags"
      }
    ]), { t: a } = Mn({
      messages: {
        ru: {
          flags: "Флаги",
          symbols: "Символы",
          objects: "Объекты",
          people: "Смайлики и люди",
          foodDrink: "Еда и напитки",
          nature: "Животные и природа",
          activity: "Физическая активность",
          travelPlaces: "Путешествия и места",
          lastUsing: "Последние используемые"
        },
        en: {
          flags: "Флаги",
          symbols: "Символы",
          objects: "Объекты",
          people: "Смайлики и люди",
          foodDrink: "Еда и напитки",
          nature: "Животные и природа",
          activity: "Физическая активность",
          travelPlaces: "Путешествия и места",
          lastUsing: "Последние используемые"
        }
      }
    }), s = U(0), l = U(), d = U(), c = U(), u = U([]), f = U(), m = U([]), v = U(), _ = (k) => v.value = k, w = X3(c), $ = z(() => `${w.width.value / r.value.length}px`), y = s0(v, l, {
      placement: n.placement,
      strategy: "fixed",
      middleware: [Y1(8), a0(), r0({ crossAxis: !0 })]
    }), M = z(() => ({
      position: n.position ?? y.strategy.value,
      top: `${y.y.value}px`,
      left: `${y.x.value}px`
    })), S = z(() => `${s.value * 100}%`), x = U({
      title: "lastUsing",
      emojis: []
    }), b = U([...DG]), C = (k) => {
      var L, V;
      s.value = k, (L = f == null ? void 0 : f.value) != null && L[k] && ((V = d.value) == null || V.scrollTo({ top: f.value[k].offsetTop - 40 }));
    }, E = (k) => {
      const L = x.value.emojis;
      L.includes(k) || (L.length >= 21 && L.pop(), L.unshift(k), localStorage.recentEmojis = L);
    }, A = (k) => {
      o("select:emoji", k), E(k);
    }, T = (k) => {
      k.stopPropagation(), i.value = !i.value;
    };
    return D1(l, () => i.value = !1), he(
      () => i.value,
      () => {
        Jt(() => {
          var k;
          (k = u.value) == null || k.forEach((L, V) => {
            K3(
              L,
              ([{ isIntersecting: O }]) => {
                O && (s.value = V);
              },
              {
                root: d.value,
                rootMargin: "0px 0px -120px 0px",
                threshold: [0, 1]
              }
            );
          });
        });
      }
    ), et(() => {
      const k = localStorage.recentEmojis;
      k && (r.value.unshift({
        icon: I(Rd),
        key: "lastUsing"
      }), x.value.emojis = k.split(","), b.value.unshift(x.value));
    }), (k, L) => {
      var O;
      const V = vt;
      return p(), g("div", RG, [
        B(i) ? (p(), g("div", {
          key: 0,
          ref_key: "emojiPicker",
          ref: l,
          class: ee(["p-emoji-picker", { fullwidth: k.fullwidth }]),
          style: en(M.value)
        }, [
          h("div", {
            ref_key: "tabsContainer",
            ref: c,
            class: "emoji-tabs"
          }, [
            ZG,
            (p(!0), g(_e, null, Ie(r.value, (D, P) => (p(), J(V, {
              ref_for: !0,
              ref_key: "emojiPickerTabs",
              ref: m,
              key: P,
              class: ee(["emoji-tab", { "active-tab": s.value === P }]),
              variant: "text",
              color: "asphalt",
              onClick: (F) => C(P)
            }, {
              default: G(() => [
                (p(), J(Ce(D.icon)))
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))), 128))
          ], 512),
          (O = b.value) != null && O.length ? (p(), g("div", {
            key: 0,
            ref_key: "allCategories",
            ref: d,
            class: "all-categories"
          }, [
            (p(!0), g(_e, null, Ie(b.value, (D) => (p(), g("div", {
              key: D.title,
              ref_for: !0,
              ref_key: "categoriesRef",
              ref: f,
              class: "category-container"
            }, [
              h("p", BG, ne(B(a)(D.title)), 1),
              h("div", {
                id: D.title,
                ref_for: !0,
                ref_key: "emojisRef",
                ref: u,
                class: "emoji-container"
              }, [
                (p(!0), g(_e, null, Ie(D.emojis, (P, F) => (p(), g("div", {
                  key: F,
                  class: "emoji-item",
                  onClick: (N) => A(P)
                }, ne(P), 9, FG))), 128))
              ], 8, VG)
            ]))), 128))
          ], 512)) : X("", !0)
        ], 6)) : X("", !0),
        Y(k.$slots, "activator", Vr(Fr({ setReference: _, trigger: T })), void 0, !0)
      ]);
    };
  }
}), UG = /* @__PURE__ */ ae(HG, [["__scopeId", "data-v-5a2246c2"]]), zG = /* @__PURE__ */ oe({
  name: "PEmoji",
  __name: "index",
  props: {
    size: { default: "small" }
  },
  setup(t) {
    return (e, n) => (p(), g("div", {
      class: ee(["emoji", e.size])
    }, [
      Y(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), WG = /* @__PURE__ */ ae(zG, [["__scopeId", "data-v-52f7179e"]]), jG = { class: "title" }, GG = { class: "right" }, YG = {
  key: 0,
  class: "panel-content"
}, XG = /* @__PURE__ */ oe({
  name: "PExpansionPanel",
  __name: "index",
  props: {
    title: {},
    size: { default: "medium" },
    color: { default: "grey" },
    modelValue: { type: Boolean },
    borderedTitle: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = n.modelValue === void 0 ? U(!1) : me(n, "modelValue", o), r = () => {
      n.disabled || (o("change", !i.value), i.value = !i.value);
    };
    return (a, s) => {
      const l = _t, d = La;
      return p(), g("div", {
        class: ee(["p-expansion-panel", `color-${a.disabled ? "disabled" : a.color}`, `size-${a.size}`, { active: B(i) }])
      }, [
        h("div", {
          class: ee(["panel-title", { bordered: a.borderedTitle }]),
          onClick: Ye(r, ["stop"])
        }, [
          h("div", jG, [
            h("span", null, [
              Y(a.$slots, "title", {}, () => [
                xe(ne(a.title), 1)
              ], !0)
            ]),
            a.loading ? (p(), J(l, {
              key: 0,
              size: "small",
              class: "loader"
            })) : X("", !0)
          ]),
          h("div", GG, [
            Y(a.$slots, "right", {}, void 0, !0)
          ]),
          q(d, { class: "button-icon" })
        ], 2),
        q(Xe, { name: "slide-down" }, {
          default: G(() => [
            !a.loading && B(i) && a.$slots.default ? (p(), g("div", YG, [
              Y(a.$slots, "default", {}, void 0, !0)
            ])) : X("", !0)
          ]),
          _: 3
        })
      ], 2);
    };
  }
}), KG = /* @__PURE__ */ ae(XG, [["__scopeId", "data-v-e558f1e6"]]), qG = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, JG = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M13.657 13.657A8 8 0 1 1 2.343 2.342a8 8 0 0 1 11.314 11.315Z"
}, null, -1), QG = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 16A8 8 0 1 0 8-.001 8 8 0 0 0 8 16Zm1.137-8 3.127 3.127a.804.804 0 0 1-1.137 1.137L8 9.137l-3.127 3.127a.804.804 0 0 1-1.137-1.137L6.863 8 3.736 4.873a.804.804 0 1 1 1.137-1.137L8 6.863l3.127-3.127a.804.804 0 1 1 1.137 1.137L9.137 8Z",
  "clip-rule": "evenodd"
}, null, -1), eY = [
  JG,
  QG
];
function tY(t, e) {
  return p(), g("svg", qG, [...eY]);
}
const nY = I({ name: "icon-filled-cross-sm", render: tY }), oY = { class: "file-short-name" }, iY = { class: "name" }, rY = { class: "error-title" }, aY = { class: "name" }, sY = /* @__PURE__ */ oe({
  name: "PFileItem",
  __name: "PFileItem",
  props: {
    maxVisibleFiles: { default: 0 },
    totalFilesLength: { default: 0 },
    file: {},
    isExpanded: { type: Boolean },
    idx: {}
  },
  emits: ["expandFiles", "deleteFile"],
  setup(t, { emit: e }) {
    const n = t, o = e, { t: i, locale: r } = Mn({
      messages: {
        ru: {
          file: "файл",
          multipleFilesFirstRule: "файла",
          multipleFilesSecondRule: "файлов",
          error: "Ошибка"
        },
        en: {
          file: "file",
          multipleFilesFirstRule: "files",
          multipleFilesSecondRule: "files",
          error: "Error"
        }
      }
    }), { mobile: a } = nt(), s = ["tif", "tiff"], l = U(!1), d = U(!1), c = (E) => "fileContent" in n.file, u = z(() => c(n.file) ? n.file.fileMimetype : n.file.mimetype), f = z(() => c(n.file) ? n.file.fileName : n.file.name), m = {
      load: () => {
        Ot.parent(u.value) === De.video && (d.value = !0);
      },
      loaded: () => {
        Ot.parent(u.value) === De.video && (d.value = !1);
      },
      error: () => {
        Ot.parent(u.value) === De.video && (d.value = !1, l.value = !0);
      }
    }, v = () => {
      switch (!0) {
        case s.includes(Ot.child(u.value)):
          return "div";
        case Ot.parent(u.value) === De.image:
          return "img";
        case Ot.parent(u.value) === De.video:
          return "video";
        default:
          return "div";
      }
    }, w = (() => {
      if (!c(n.file) && n.file.icon) return I3(n.file.icon);
      if (s.includes(Ot.child(u.value))) return t1;
      switch (Ot.parent(u.value)) {
        case De.image:
          return "img";
        case De.video:
          return Kr;
        case De.audio:
          return Yi;
        default:
          return t1;
      }
    })();
    he(
      () => !c(n.file) && n.file.status,
      () => {
        c(n.file) || (n.file.status === "loading" ? (d.value = !0, l.value = !1) : n.file.status === "error" ? (l.value = !0, d.value = !1) : (l.value = !1, d.value = !1));
      },
      {
        immediate: !0
      }
    );
    const $ = z(() => {
      const E = u.value;
      return [De.image, De.video].includes(Ot.parent(E));
    }), y = z(() => j1(c(n.file) ? n.file.fileContent : n.file.src)), M = z(() => n.maxVisibleFiles && n.maxVisibleFiles - 1 === n.idx && n.totalFilesLength && n.totalFilesLength !== n.idx + 1 && !n.isExpanded), S = z(() => {
      const { maxVisibleFiles: E, totalFilesLength: A } = n;
      if (!E || !A) return "";
      let T;
      const k = A - E, L = k.toString(), V = parseInt(L.charAt(L.length - 1), 10);
      return r.value === "ru" ? V === 1 && k !== 11 ? T = i("file") : [2, 3, 4].includes(V) && ![12, 13, 14].includes(k) ? T = i("multipleFilesFirstRule") : T = i("multipleFilesSecondRule") : T = k > 1 ? i("multipleFilesFirstRule") : i("file"), `+${k} ${T}`;
    }), x = () => {
      var E, A;
      c(n.file) || (A = (E = n.file).refresh) == null || A.call(E);
    }, b = z(() => !d.value && !l.value && Ot.parent(u.value) === De.video), C = z(() => d.value || l.value || $.value);
    return (E, A) => {
      const T = _t, k = vt, L = nY;
      return p(), g("div", {
        class: ee(["p-file-item", { bordered: !$.value, mobile: B(a) }])
      }, [
        (p(), J(Ce(v()), {
          src: y.value,
          class: "file-content",
          alt: f.value,
          onLoad: A[0] || (A[0] = (V) => m.loaded()),
          onLoadstart: A[1] || (A[1] = (V) => m.load()),
          onLoadedmetadata: A[2] || (A[2] = (V) => m.loaded()),
          onError: A[3] || (A[3] = (V) => m.error())
        }, {
          default: G(() => [
            (p(), J(Ce(B(w)), { class: "icon" })),
            h("div", oY, [
              h("span", iY, ne(B(Wn).name(f.value)), 1),
              h("span", null, ne("." + B(Wn).extension(f.value)), 1)
            ])
          ]),
          _: 1
        }, 40, ["src", "alt"])),
        d.value || l.value ? (p(), g("div", {
          key: 0,
          class: ee(["asset-container", { transparent: M.value }])
        }, null, 2)) : X("", !0),
        d.value ? (p(), J(T, {
          key: 1,
          absolute: "",
          class: "file-loader"
        })) : X("", !0),
        l.value ? (p(), J(k, {
          key: 2,
          class: "error",
          variant: "text",
          onClick: Ye(x, ["stop"])
        }, {
          default: G(() => [
            q(B($d)),
            h("span", rY, ne(B(i)("error")), 1)
          ]),
          _: 1
        })) : X("", !0),
        b.value ? (p(), J(B(wd), {
          key: 3,
          class: "success"
        })) : X("", !0),
        C.value ? (p(), g("div", {
          key: 4,
          class: ee(["asset-short-name", { "has-overlay": $.value && !d.value && !l.value }])
        }, [
          h("span", aY, ne(B(Wn).name(f.value)), 1),
          h("span", null, ne("." + B(Wn).extension(f.value)), 1)
        ], 2)) : X("", !0),
        M.value ? (p(), g("div", {
          key: 5,
          class: "extendable-item",
          onClick: A[4] || (A[4] = Ye((V) => o("expandFiles"), ["stop"]))
        }, ne(S.value), 1)) : X("", !0),
        M.value ? X("", !0) : (p(), J(k, {
          key: 6,
          variant: "text",
          color: "asphalt",
          class: "extendable-button",
          onClick: A[5] || (A[5] = Ye((V) => o("deleteFile", E.file.id), ["stop"]))
        }, {
          default: G(() => [
            q(L)
          ]),
          _: 1
        }))
      ], 2);
    };
  }
}), lY = /* @__PURE__ */ ae(sY, [["__scopeId", "data-v-9c166c50"]]), dY = ["accept", "multiple"], cY = /* @__PURE__ */ oe({
  name: "PInputFile",
  __name: "index",
  props: {
    modelValue: {},
    accept: { default: () => [] },
    multiple: { type: Boolean },
    readonly: { type: Boolean },
    uploadLimit: { default: 1024 * 500 }
  },
  emits: ["update:modelValue", "change:error"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = me(n, "modelValue", o), r = z(() => n.accept.join(",")), a = U(), s = () => {
      a.value.value = "", a.value.click();
    }, l = async (f) => {
      const v = Array.from(f.target.files).filter((_) => d(_) && c(_));
      if (v.length !== 0)
        if (n.multiple)
          i.value = await Promise.all(
            v.map(async (_) => ({
              fileContent: await u(_),
              fileMimetype: _.type,
              fileName: _.name,
              fileExtension: _.name.split(".").pop(),
              fileBinary: _
            }))
          );
        else {
          const _ = v[0];
          i.value = {
            fileContent: await u(_),
            fileMimetype: _.type,
            fileName: _.name,
            fileExtension: _.name.substring(_.name.lastIndexOf(".") + 1),
            fileBinary: _
          };
        }
    }, d = (f) => {
      if (!n.accept.length) return !0;
      const m = f.type.toLowerCase(), v = f.name.substring(f.name.lastIndexOf(".")).toLowerCase(), _ = n.accept.some((w) => {
        if (w.includes("/*")) {
          const [$] = w.split("/"), [y] = m.split("/");
          return $.toLowerCase() === y;
        } else
          return w.toLowerCase() === m || v === w;
      });
      return _ || o("change:error", {
        errorType: s1.fileTypeInvalid,
        fileName: f.name
      }), _;
    }, c = (f) => f.size > n.uploadLimit ? (o("change:error", {
      errorType: s1.fileSizeLimitExceeded,
      fileName: f.name
    }), !1) : !0, u = (f) => new Promise((m, v) => {
      let _ = new FileReader();
      _.onload = (w) => {
        m(w.target.result);
      }, _.onerror = (w) => {
        v(w);
      }, _.readAsDataURL(f);
    });
    return (f, m) => (p(), g("div", {
      class: ee(["p-input-file", { readonly: f.readonly }])
    }, [
      Y(f.$slots, "activator", { selectFile: s }, void 0, !0),
      h("input", {
        ref_key: "fileInput",
        ref: a,
        type: "file",
        accept: r.value,
        multiple: f.multiple,
        onChange: l
      }, null, 40, dY)
    ], 2));
  }
}), d0 = /* @__PURE__ */ ae(cY, [["__scopeId", "data-v-b1481b30"]]), uY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, hY = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17.572 8.943h-6.886V2.057a1.057 1.057 0 0 0-2.115 0v6.886H2.057a1.057 1.057 0 0 0 0 2.114h6.514v6.886a1.057 1.057 0 0 0 2.115 0v-6.886h6.886a1.057 1.057 0 1 0 0-2.114Z",
  "clip-rule": "evenodd"
}, null, -1), fY = [
  hY
];
function mY(t, e) {
  return p(), g("svg", uY, [...fY]);
}
const Z2 = I({ name: "icon-add-md", render: mY }), pY = ["onClick"], _Y = /* @__PURE__ */ oe({
  name: "PFileItemList",
  __name: "index",
  props: {
    modelValue: {},
    fileWidth: { default: 0 },
    display: { default: "block" },
    maxVisibleFiles: { default: 0 },
    visibleAddition: { type: Boolean },
    clickableItems: { type: Boolean },
    accept: {},
    multiple: { type: Boolean },
    readonly: { type: Boolean },
    uploadLimit: {}
  },
  emits: ["change:error", "change:added", "change:delete", "update:modelValue", "click:file"],
  setup(t, { emit: e }) {
    Nn((_) => ({
      "3dc2bddc": c.value
    }));
    const n = t, o = e, i = me(n, "modelValue", o);
    he(
      () => i.value.length,
      () => l.value = i.value
    );
    const r = U(0), a = U(!1), s = U(null), l = U(i.value), d = (_) => {
      i.value = l.value.filter((w) => w.id !== _), o("change:delete", _);
    };
    he(
      () => n.maxVisibleFiles,
      (_) => {
        r.value = _ ? _ + 1 : 0, l.value = _ ? i.value.slice(0, r.value) : i.value, a.value = !1;
      },
      {
        immediate: !0
      }
    );
    const c = z(() => {
      if (!n.fileWidth || n.fileWidth > 104 || n.fileWidth < 76) return "100px";
      if (n.display === "block" && s.value && !n.fileWidth) {
        const _ = s.value.clientWidth, w = Math.floor((_ + 8) / 84), $ = 8 * (w - 1), M = (_ - $) / w;
        return `${Math.min(Math.max(M, 76), 104)}px`;
      }
      return `${n.fileWidth}px`;
    }), u = U(null), f = (_) => {
      if (!_) return;
      o("change:added", _);
      const w = (Array.isArray(_) ? _ : [_]).map(($) => ({
        id: Symbol("addedFile"),
        ...$
      }));
      i.value = i.value.concat(w);
    }, m = (_) => {
      n.clickableItems && o("click:file", _);
    }, v = () => {
      l.value = i.value, a.value = !0;
    };
    return (_, w) => {
      var S;
      const $ = Z2, y = d0, M = lY;
      return p(), g("div", {
        ref_key: "fileItemListRef",
        ref: s
      }, [
        h("div", {
          class: ee([`p-file-item-list ${_.display}`])
        }, [
          _.visibleAddition ? (p(), J(y, {
            key: 0,
            modelValue: u.value,
            "onUpdate:modelValue": [
              w[0] || (w[0] = (x) => u.value = x),
              f
            ],
            multiple: _.multiple,
            accept: _.accept,
            readonly: _.readonly,
            "upload-limit": _.uploadLimit
          }, {
            activator: G(({ selectFile: x }) => [
              h("div", {
                class: "item addition-area",
                onClick: x
              }, [
                q($)
              ], 8, pY)
            ]),
            _: 1
          }, 8, ["modelValue", "multiple", "accept", "readonly", "upload-limit"])) : X("", !0),
          (S = B(i)) != null && S.length ? (p(!0), g(_e, { key: 1 }, Ie(l.value, (x, b) => (p(), J(M, {
            key: x.id,
            file: x,
            idx: b,
            "max-visible-files": r.value,
            "total-files-length": B(i).length,
            "file-width": c.value,
            "is-expanded": a.value,
            class: ee(["item", { clickable: _.clickableItems }]),
            onExpandFiles: v,
            onDeleteFile: d,
            onClick: (C) => m(x)
          }, null, 8, ["file", "idx", "max-visible-files", "total-files-length", "file-width", "is-expanded", "class", "onClick"]))), 128)) : X("", !0)
        ], 2)
      ], 512);
    };
  }
}), vY = /* @__PURE__ */ ae(_Y, [["__scopeId", "data-v-052941bd"]]), gY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, $Y = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.293 16.707a1 1 0 0 1 0-1.414L11.586 10 6.293 4.707a1 1 0 0 1 1.414-1.414l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0Z",
  "clip-rule": "evenodd"
}, null, -1), wY = [
  $Y
];
function yY(t, e) {
  return p(), g("svg", gY, [...wY]);
}
const MY = I({ name: "icon-arrow-right-short-md", render: yY }), CY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, bY = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.707 3.293a1 1 0 0 1 0 1.414L8.414 10l5.293 5.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z",
  "clip-rule": "evenodd"
}, null, -1), xY = [
  bY
];
function SY(t, e) {
  return p(), g("svg", CY, [...xY]);
}
const IY = I({ name: "icon-arrow-left-short-md", render: SY }), AY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, kY = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2 13a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2a1 1 0 1 1 2 0v2a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2a1 1 0 0 1 1-1Z",
  "clip-rule": "evenodd"
}, null, -1), EY = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 1a1 1 0 0 1 1 1v9.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L9 11.586V2a1 1 0 0 1 1-1Z",
  "clip-rule": "evenodd"
}, null, -1), PY = [
  kY,
  EY
];
function TY(t, e) {
  return p(), g("svg", AY, [...PY]);
}
const OY = I({ name: "icon-download-md", render: TY });
var Wo = function() {
  return Wo = Object.assign || function(t) {
    for (var e, n = 1, o = arguments.length; n < o; n++) for (var i in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    return t;
  }, Wo.apply(this, arguments);
};
function B2(t, e, n) {
  for (var o, i = 0, r = e.length; i < r; i++) !o && i in e || (o || (o = Array.prototype.slice.call(e, 0, i)), o[i] = e[i]);
  return t.concat(o || Array.prototype.slice.call(e));
}
function al(t) {
  return Array.prototype.slice.call(t);
}
function sl(t, e) {
  var n = Math.floor(t);
  return n === e || n + 1 === e ? t : e;
}
function ll() {
  return Date.now();
}
function E0(t, e, n) {
  if (e = "data-keen-slider-" + e, n === null) return t.removeAttribute(e);
  t.setAttribute(e, n || "");
}
function Bi(t, e) {
  return e = e || document, typeof t == "function" && (t = t(e)), Array.isArray(t) ? t : typeof t == "string" ? al(e.querySelectorAll(t)) : t instanceof HTMLElement ? [t] : t instanceof NodeList ? al(t) : [];
}
function w1(t) {
  t.raw && (t = t.raw), t.cancelable && !t.defaultPrevented && t.preventDefault();
}
function y1(t) {
  t.raw && (t = t.raw), t.stopPropagation && t.stopPropagation();
}
function V2() {
  var t = [];
  return { add: function(e, n, o, i) {
    e.addListener ? e.addListener(o) : e.addEventListener(n, o, i), t.push([e, n, o, i]);
  }, input: function(e, n, o, i) {
    this.add(e, n, /* @__PURE__ */ function(r) {
      return function(a) {
        a.nativeEvent && (a = a.nativeEvent);
        var s = a.changedTouches || [], l = a.targetTouches || [], d = a.detail && a.detail.x ? a.detail : null;
        return r({ id: d ? d.identifier ? d.identifier : "i" : l[0] ? l[0] ? l[0].identifier : "e" : "d", idChanged: d ? d.identifier ? d.identifier : "i" : s[0] ? s[0] ? s[0].identifier : "e" : "d", raw: a, x: d && d.x ? d.x : l[0] ? l[0].screenX : d ? d.x : a.pageX, y: d && d.y ? d.y : l[0] ? l[0].screenY : d ? d.y : a.pageY });
      };
    }(o), i);
  }, purge: function() {
    t.forEach(function(e) {
      e[0].removeListener ? e[0].removeListener(e[2]) : e[0].removeEventListener(e[1], e[2], e[3]);
    }), t = [];
  } };
}
function Na(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
function on(t) {
  return (t > 0 ? 1 : 0) - (t < 0 ? 1 : 0) || +t;
}
function dl(t) {
  var e = t.getBoundingClientRect();
  return { height: sl(e.height, t.offsetHeight), width: sl(e.width, t.offsetWidth) };
}
function ht(t, e, n, o) {
  var i = t && t[e];
  return i == null ? n : o && typeof i == "function" ? i() : i;
}
function Wt(t) {
  return Math.round(1e6 * t) / 1e6;
}
function LY(t) {
  var e, n, o, i, r, a;
  function s(f) {
    a || (a = f), l(!0);
    var m = f - a;
    m > o && (m = o);
    var v = i[n];
    if (v[3] < m) return n++, s(f);
    var _ = v[2], w = v[4], $ = v[0], y = v[1] * (0, v[5])(w === 0 ? 1 : (m - _) / w);
    if (y && t.track.to($ + y), m < o) return c();
    a = null, l(!1), d(null), t.emit("animationEnded");
  }
  function l(f) {
    e.active = f;
  }
  function d(f) {
    e.targetIdx = f;
  }
  function c() {
    var f;
    f = s, r = window.requestAnimationFrame(f);
  }
  function u() {
    var f;
    f = r, window.cancelAnimationFrame(f), l(!1), d(null), a && t.emit("animationStopped"), a = null;
  }
  return e = { active: !1, start: function(f) {
    if (u(), t.track.details) {
      var m = 0, v = t.track.details.position;
      n = 0, o = 0, i = f.map(function(_) {
        var w, $ = Number(v), y = (w = _.earlyExit) !== null && w !== void 0 ? w : _.duration, M = _.easing, S = _.distance * M(y / _.duration) || 0;
        v += S;
        var x = o;
        return o += y, m += S, [$, _.distance, x, o, _.duration, M];
      }), d(t.track.distToIdx(m)), c(), t.emit("animationStarted");
    }
  }, stop: u, targetIdx: null };
}
function DY(t) {
  var e, n, o, i, r, a, s, l, d, c, u, f, m, v, _ = 1 / 0, w = [], $ = null, y = 0;
  function M(O) {
    L(y + O);
  }
  function S(O) {
    var D = x(y + O).abs;
    return E(D) ? D : null;
  }
  function x(O) {
    var D = Math.floor(Math.abs(Wt(O / n))), P = Wt((O % n + n) % n);
    P === n && (P = 0);
    var F = on(O), N = s.indexOf(B2([], s).reduce(function(W, te) {
      return Math.abs(te - P) < Math.abs(W - P) ? te : W;
    })), H = N;
    return F < 0 && D++, N === a && (H = 0, D += F > 0 ? 1 : -1), { abs: H + D * a * F, origin: N, rel: H };
  }
  function b(O, D, P) {
    var F;
    if (D || !T()) return C(O, P);
    if (!E(O)) return null;
    var N = x(P ?? y), H = N.abs, W = O - N.rel, te = H + W;
    F = C(te);
    var ie = C(te - a * on(W));
    return (ie !== null && Math.abs(ie) < Math.abs(F) || F === null) && (F = ie), Wt(F);
  }
  function C(O, D) {
    if (D == null && (D = Wt(y)), !E(O) || O === null) return null;
    O = Math.round(O);
    var P = x(D), F = P.abs, N = P.rel, H = P.origin, W = k(O), te = (D % n + n) % n, ie = s[H], se = Math.floor((O - (F - N)) / a) * n;
    return Wt(ie - te - ie + s[W] + se + (H === a ? n : 0));
  }
  function E(O) {
    return A(O) === O;
  }
  function A(O) {
    return Na(O, d, c);
  }
  function T() {
    return i.loop;
  }
  function k(O) {
    return (O % a + a) % a;
  }
  function L(O) {
    var D;
    D = O - y, w.push({ distance: D, timestamp: ll() }), w.length > 6 && (w = w.slice(-6)), y = Wt(O);
    var P = V().abs;
    if (P !== $) {
      var F = $ !== null;
      $ = P, F && t.emit("slideChanged");
    }
  }
  function V(O) {
    var D = O ? null : function() {
      if (a) {
        var P = T(), F = P ? (y % n + n) % n : y, N = (P ? y % n : y) - r[0][2], H = 0 - (N < 0 && P ? n - Math.abs(N) : N), W = 0, te = x(y), ie = te.abs, se = te.rel, fe = r[se][2], $e = r.map(function(He, Tt) {
          var Me = H + W;
          (Me < 0 - He[0] || Me > 1) && (Me += (Math.abs(Me) > n - 1 && P ? n : 0) * on(-Me));
          var $t = Tt - se, Re = on($t), Ke = $t + ie;
          P && (Re === -1 && Me > fe && (Ke += a), Re === 1 && Me < fe && (Ke -= a), u !== null && Ke < u && (Me += n), f !== null && Ke > f && (Me -= n));
          var Ut = Me + He[0] + He[1], zt = Math.max(Me >= 0 && Ut <= 1 ? 1 : Ut < 0 || Me > 1 ? 0 : Me < 0 ? Math.min(1, (He[0] + Me) / He[0]) : (1 - Me) / He[0], 0);
          return W += He[0] + He[1], { abs: Ke, distance: i.rtl ? -1 * Me + 1 - He[0] : Me, portion: zt, size: He[0] };
        });
        return ie = A(ie), se = k(ie), { abs: A(ie), length: o, max: v, maxIdx: c, min: m, minIdx: d, position: y, progress: P ? F / n : y / o, rel: se, slides: $e, slidesLength: n };
      }
    }();
    return e.details = D, t.emit("detailsChanged"), D;
  }
  return e = { absToRel: k, add: M, details: null, distToIdx: S, idxToDist: b, init: function(O) {
    if (function() {
      if (i = t.options, r = (i.trackConfig || []).map(function(N) {
        return [ht(N, "size", 1), ht(N, "spacing", 0), ht(N, "origin", 0)];
      }), a = r.length) {
        n = Wt(r.reduce(function(N, H) {
          return N + H[0] + H[1];
        }, 0));
        var P, F = a - 1;
        o = Wt(n + r[0][2] - r[F][0] - r[F][2] - r[F][1]), s = r.reduce(function(N, H) {
          if (!N) return [0];
          var W = r[N.length - 1], te = N[N.length - 1] + (W[0] + W[2]) + W[1];
          return te -= H[2], N[N.length - 1] > te && (te = N[N.length - 1]), te = Wt(te), N.push(te), (!P || P < te) && (l = N.length - 1), P = te, N;
        }, null), o === 0 && (l = 0), s.push(Wt(n));
      }
    }(), !a) return V(!0);
    var D;
    (function() {
      var P = t.options.range, F = t.options.loop;
      u = d = F ? ht(F, "min", -1 / 0) : 0, f = c = F ? ht(F, "max", _) : l;
      var N = ht(P, "min", null), H = ht(P, "max", null);
      N !== null && (d = N), H !== null && (c = H), m = d === -1 / 0 ? d : t.track.idxToDist(d || 0, !0, 0), v = c === _ ? c : b(c, !0, 0), H === null && (f = c), ht(P, "align", !1) && c !== _ && r[k(c)][2] === 0 && (v -= 1 - r[k(c)][0], c = S(v - y)), m = Wt(m), v = Wt(v);
    })(), D = O, Number(D) === D ? M(C(A(O))) : V();
  }, to: L, velocity: function() {
    var O = ll(), D = w.reduce(function(P, F) {
      var N = F.distance, H = F.timestamp;
      return O - H > 200 || (on(N) !== on(P.distance) && P.distance && (P = { distance: 0, lastTimestamp: 0, time: 0 }), P.time && (P.distance += N), P.lastTimestamp && (P.time += H - P.lastTimestamp), P.lastTimestamp = H), P;
    }, { distance: 0, lastTimestamp: 0, time: 0 });
    return D.distance / D.time || 0;
  } };
}
function NY(t) {
  var e, n, o, i, r, a, s, l;
  function d($) {
    return 2 * $;
  }
  function c($) {
    return Na($, s, l);
  }
  function u($) {
    return 1 - Math.pow(1 - $, 3);
  }
  function f() {
    return o ? t.track.velocity() : 0;
  }
  function m() {
    w();
    var $ = t.options.mode === "free-snap", y = t.track, M = f();
    i = on(M);
    var S = t.track.details, x = [];
    if (M || !$) {
      var b = v(M), C = b.dist, E = b.dur;
      if (E = d(E), C *= i, $) {
        var A = y.idxToDist(y.distToIdx(C), !0);
        A && (C = A);
      }
      x.push({ distance: C, duration: E, easing: u });
      var T = S.position, k = T + C;
      if (k < r || k > a) {
        var L = k < r ? r - T : a - T, V = 0, O = M;
        if (on(L) === i) {
          var D = Math.min(Math.abs(L) / Math.abs(C), 1), P = function(H) {
            return 1 - Math.pow(1 - H, 1 / 3);
          }(D) * E;
          x[0].earlyExit = P, O = M * (1 - D);
        } else x[0].earlyExit = 0, V += L;
        var F = v(O, 100), N = F.dist * i;
        t.options.rubberband && (x.push({ distance: N, duration: d(F.dur), easing: u }), x.push({ distance: -N + V, duration: 500, easing: u }));
      }
      t.animator.start(x);
    } else t.moveToIdx(c(S.abs), !0, { duration: 500, easing: function(H) {
      return 1 + --H * H * H * H * H;
    } });
  }
  function v($, y) {
    y === void 0 && (y = 1e3);
    var M = 147e-9 + ($ = Math.abs($)) / y;
    return { dist: Math.pow($, 2) / M, dur: $ / M };
  }
  function _() {
    var $ = t.track.details;
    $ && (r = $.min, a = $.max, s = $.minIdx, l = $.maxIdx);
  }
  function w() {
    t.animator.stop();
  }
  t.on("updated", _), t.on("optionsChanged", _), t.on("created", _), t.on("dragStarted", function() {
    o = !1, w(), e = n = t.track.details.abs;
  }), t.on("dragChecked", function() {
    o = !0;
  }), t.on("dragEnded", function() {
    var $ = t.options.mode;
    $ === "snap" && function() {
      var y = t.track, M = t.track.details, S = M.position, x = on(f());
      (S > a || S < r) && (x = 0);
      var b = e + x;
      M.slides[y.absToRel(b)].portion === 0 && (b -= x), e !== n && (b = n), on(y.idxToDist(b, !0)) !== x && (b += x), b = c(b);
      var C = y.idxToDist(b, !0);
      t.animator.start([{ distance: C, duration: 500, easing: function(E) {
        return 1 + --E * E * E * E * E;
      } }]);
    }(), $ !== "free" && $ !== "free-snap" || m();
  }), t.on("dragged", function() {
    n = t.track.details.abs;
  });
}
function RY(t) {
  var e, n, o, i, r, a, s, l, d, c, u, f, m, v, _, w, $, y, M = V2();
  function S(V) {
    if (a && l === V.id) {
      var O = E(V);
      if (d) {
        if (!C(V)) return b(V);
        c = O, d = !1, t.emit("dragChecked");
      }
      if (w) return c = O;
      w1(V);
      var D = function(F) {
        if ($ === -1 / 0 && y === 1 / 0) return F;
        var N = t.track.details, H = N.length, W = N.position, te = Na(F, $ - W, y - W);
        if (H === 0) return 0;
        if (!t.options.rubberband) return te;
        if (W <= y && W >= $ || W < $ && n > 0 || W > y && n < 0) return F;
        var ie = (W < $ ? W - $ : W - y) / H, se = i * H, fe = Math.abs(ie * se), $e = Math.max(0, 1 - fe / r * 2);
        return $e * $e * F;
      }(s(c - O) / i * o);
      n = on(D);
      var P = t.track.details.position;
      (P > $ && P < y || P === $ && n > 0 || P === y && n < 0) && y1(V), u += D, !f && Math.abs(u * i) > 5 && (f = !0), t.track.add(D), c = O, t.emit("dragged");
    }
  }
  function x(V) {
    !a && t.track.details && t.track.details.length && (u = 0, a = !0, f = !1, d = !0, l = V.id, C(V), c = E(V), t.emit("dragStarted"));
  }
  function b(V) {
    a && l === V.idChanged && (a = !1, t.emit("dragEnded"));
  }
  function C(V) {
    var O = A(), D = O ? V.y : V.x, P = O ? V.x : V.y, F = m !== void 0 && v !== void 0 && Math.abs(v - P) <= Math.abs(m - D);
    return m = D, v = P, F;
  }
  function E(V) {
    return A() ? V.y : V.x;
  }
  function A() {
    return t.options.vertical;
  }
  function T() {
    i = t.size, r = A() ? window.innerHeight : window.innerWidth;
    var V = t.track.details;
    V && ($ = V.min, y = V.max);
  }
  function k(V) {
    f && (y1(V), w1(V));
  }
  function L() {
    if (M.purge(), t.options.drag && !t.options.disabled) {
      var V;
      V = t.options.dragSpeed || 1, s = typeof V == "function" ? V : function(D) {
        return D * V;
      }, o = t.options.rtl ? -1 : 1, T(), e = t.container, function() {
        var D = "data-keen-slider-clickable";
        Bi("[".concat(D, "]:not([").concat(D, "=false])"), e).map(function(P) {
          M.add(P, "dragstart", y1), M.add(P, "mousedown", y1), M.add(P, "touchstart", y1);
        });
      }(), M.add(e, "dragstart", function(D) {
        w1(D);
      }), M.add(e, "click", k, { capture: !0 }), M.input(e, "ksDragStart", x), M.input(e, "ksDrag", S), M.input(e, "ksDragEnd", b), M.input(e, "mousedown", x), M.input(e, "mousemove", S), M.input(e, "mouseleave", b), M.input(e, "mouseup", b), M.input(e, "touchstart", x, { passive: !0 }), M.input(e, "touchmove", S, { passive: !1 }), M.input(e, "touchend", b), M.input(e, "touchcancel", b), M.add(window, "wheel", function(D) {
        a && w1(D);
      });
      var O = "data-keen-slider-scrollable";
      Bi("[".concat(O, "]:not([").concat(O, "=false])"), t.container).map(function(D) {
        return function(P) {
          var F;
          M.input(P, "touchstart", function(N) {
            F = E(N), w = !0, _ = !0;
          }, { passive: !0 }), M.input(P, "touchmove", function(N) {
            var H = A(), W = H ? P.scrollHeight - P.clientHeight : P.scrollWidth - P.clientWidth, te = F - E(N), ie = H ? P.scrollTop : P.scrollLeft, se = H && P.style.overflowY === "scroll" || !H && P.style.overflowX === "scroll";
            if (F = E(N), (te < 0 && ie > 0 || te > 0 && ie < W) && _ && se) return w = !0;
            _ = !1, w1(N), w = !1;
          }), M.input(P, "touchend", function() {
            w = !1;
          });
        }(D);
      });
    }
  }
  t.on("updated", T), t.on("optionsChanged", L), t.on("created", L), t.on("destroyed", M.purge);
}
function ZY(t) {
  var e, n, o = null;
  function i(m, v, _) {
    t.animator.active ? a(m, v, _) : requestAnimationFrame(function() {
      return a(m, v, _);
    });
  }
  function r() {
    i(!1, !1, n);
  }
  function a(m, v, _) {
    var w = 0, $ = t.size, y = t.track.details;
    if (y && e) {
      var M = y.slides;
      e.forEach(function(S, x) {
        if (m) !o && v && l(S, null, _), d(S, null, _);
        else {
          if (!M[x]) return;
          var b = M[x].size * $;
          !o && v && l(S, b, _), d(S, M[x].distance * $ - w, _), w += b;
        }
      });
    }
  }
  function s(m) {
    return t.options.renderMode === "performance" ? Math.round(m) : m;
  }
  function l(m, v, _) {
    var w = _ ? "height" : "width";
    v !== null && (v = s(v) + "px"), m.style["min-" + w] = v, m.style["max-" + w] = v;
  }
  function d(m, v, _) {
    if (v !== null) {
      v = s(v);
      var w = _ ? v : 0;
      v = "translate3d(".concat(_ ? 0 : v, "px, ").concat(w, "px, 0)");
    }
    m.style.transform = v, m.style["-webkit-transform"] = v;
  }
  function c() {
    e && (a(!0, !0, n), e = null), t.on("detailsChanged", r, !0);
  }
  function u() {
    i(!1, !0, n);
  }
  function f() {
    c(), n = t.options.vertical, t.options.disabled || t.options.renderMode === "custom" || (o = ht(t.options.slides, "perView", null) === "auto", t.on("detailsChanged", r), (e = t.slides).length && u());
  }
  t.on("created", f), t.on("optionsChanged", f), t.on("beforeOptionsChanged", function() {
    c();
  }), t.on("updated", u), t.on("destroyed", c);
}
function BY(t, e) {
  return function(n) {
    var o, i, r, a, s, l = V2();
    function d(C) {
      var E;
      E0(n.container, "reverse", (E = n.container, window.getComputedStyle(E, null).getPropertyValue("direction") !== "rtl" || C ? null : "")), E0(n.container, "v", n.options.vertical && !C ? "" : null), E0(n.container, "disabled", n.options.disabled && !C ? "" : null);
    }
    function c() {
      u() && w();
    }
    function u() {
      var C = null;
      if (a.forEach(function(A) {
        A.matches && (C = A.__media);
      }), C === o) return !1;
      o || n.emit("beforeOptionsChanged"), o = C;
      var E = C ? r.breakpoints[C] : r;
      return n.options = Wo(Wo({}, r), E), d(), x(), b(), y(), !0;
    }
    function f(C) {
      var E = dl(C);
      return (n.options.vertical ? E.height : E.width) / n.size || 1;
    }
    function m() {
      return n.options.trackConfig.length;
    }
    function v(C) {
      for (var E in o = !1, r = Wo(Wo({}, e), C), l.purge(), i = n.size, a = [], r.breakpoints || []) {
        var A = window.matchMedia(E);
        A.__media = E, a.push(A), l.add(A, "change", c);
      }
      l.add(window, "orientationchange", S), l.add(window, "resize", M), u();
    }
    function _(C) {
      n.animator.stop();
      var E = n.track.details;
      n.track.init(C ?? (E ? E.abs : 0));
    }
    function w(C) {
      _(C), n.emit("optionsChanged");
    }
    function $(C, E) {
      if (C) return v(C), void w(E);
      x(), b();
      var A = m();
      y(), m() !== A ? w(E) : _(E), n.emit("updated");
    }
    function y() {
      var C = n.options.slides;
      if (typeof C == "function") return n.options.trackConfig = C(n.size, n.slides);
      for (var E = n.slides, A = E.length, T = typeof C == "number" ? C : ht(C, "number", A, !0), k = [], L = ht(C, "perView", 1, !0), V = ht(C, "spacing", 0, !0) / n.size || 0, O = L === "auto" ? V : V / L, D = ht(C, "origin", "auto"), P = 0, F = 0; F < T; F++) {
        var N = L === "auto" ? f(E[F]) : 1 / L - V + O, H = D === "center" ? 0.5 - N / 2 : D === "auto" ? 0 : D;
        k.push({ origin: H, size: N, spacing: V }), P += N;
      }
      if (P += V * (T - 1), D === "auto" && !n.options.loop && L !== 1) {
        var W = 0;
        k.map(function(te) {
          var ie = P - W;
          return W += te.size + V, ie >= 1 || (te.origin = 1 - ie - (P > 1 ? 0 : 1 - P)), te;
        });
      }
      n.options.trackConfig = k;
    }
    function M() {
      x();
      var C = n.size;
      n.options.disabled || C === i || (i = C, $());
    }
    function S() {
      M(), setTimeout(M, 500), setTimeout(M, 2e3);
    }
    function x() {
      var C = dl(n.container);
      n.size = (n.options.vertical ? C.height : C.width) || 1;
    }
    function b() {
      n.slides = Bi(n.options.selector, n.container);
    }
    n.container = (s = Bi(t, document)).length ? s[0] : null, n.destroy = function() {
      l.purge(), n.emit("destroyed"), d(!0);
    }, n.prev = function() {
      n.moveToIdx(n.track.details.abs - 1, !0);
    }, n.next = function() {
      n.moveToIdx(n.track.details.abs + 1, !0);
    }, n.update = $, v(n.options);
  };
}
var VY = function(t, e, n) {
  try {
    return function(o, i) {
      var r, a = {};
      return r = { emit: function(s) {
        a[s] && a[s].forEach(function(d) {
          d(r);
        });
        var l = r.options && r.options[s];
        l && l(r);
      }, moveToIdx: function(s, l, d) {
        var c = r.track.idxToDist(s, l);
        if (c) {
          var u = r.options.defaultAnimation;
          r.animator.start([{ distance: c, duration: ht(d || u, "duration", 500), easing: ht(d || u, "easing", function(f) {
            return 1 + --f * f * f * f * f;
          }) }]);
        }
      }, on: function(s, l, d) {
        d === void 0 && (d = !1), a[s] || (a[s] = []);
        var c = a[s].indexOf(l);
        c > -1 ? d && delete a[s][c] : d || a[s].push(l);
      }, options: o }, function() {
        if (r.track = DY(r), r.animator = LY(r), i) for (var s = 0, l = i; s < l.length; s++) (0, l[s])(r);
        r.track.init(r.options.initial || 0), r.emit("created");
      }(), r;
    }(e, B2([BY(t, { drag: !0, mode: "snap", renderMode: "precision", rubberband: !0, selector: ".keen-slider__slide" }), ZY, RY, NY], n || [], !0));
  } catch (o) {
    console.error(o);
  }
};
function cl(t, e) {
  var n = U(), o = U();
  return Le(t) && he(t, function(i, r) {
    o.value && o.value.update(i);
  }), et(function() {
    n.value && (o.value = new VY(n.value, Le(t) ? t.value : t, e));
  }), Zr(function() {
    o.value && o.value.destroy();
  }), [n, o];
}
const FY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, HY = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M20.106 6.959A2 2 0 0 1 23 8.747v6.765a2 2 0 0 1-2.894 1.788 1 1 0 0 1-.296-.225l-2.56-2.325v-5l2.56-2.566a1 1 0 0 1 .296-.225ZM1 7.75a3 3 0 0 1 3-3h8.75a3 3 0 0 1 3 3v8.5a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-8.5Z",
  "clip-rule": "evenodd"
}, null, -1), UY = [
  HY
];
function zY(t, e) {
  return p(), g("svg", FY, [...UY]);
}
const WY = I({ name: "icon-video-lg", render: zY }), jY = (t) => (ei("data-v-8c95d2df"), t = t(), ti(), t), GY = ["poster", "src", "controls", "preload"], YY = ["src", "type"], XY = { class: "p-video-player-loading" }, KY = { key: 2 }, qY = {
  key: 3,
  class: "video-error-text"
}, JY = { class: "volume-container" }, QY = ["min", "max", "disabled"], eX = { class: "timeline" }, tX = /* @__PURE__ */ jY(() => /* @__PURE__ */ h("div", { class: "thumb-indicator" }, null, -1)), nX = { class: "duration-container" }, ul = "0:00", oX = /* @__PURE__ */ oe({
  name: "PVideoPlayer",
  __name: "PVideoPlayer",
  props: {
    src: {},
    mimeType: { default: De.video },
    poster: {},
    defaultControls: { type: Boolean, default: !1 },
    skipStep: { default: 5 },
    skipStepDisabled: { type: Boolean, default: !1 },
    volumeStep: { default: 0.25 },
    preload: { default: "metadata" },
    videoLoadingText: { default: "Видео обрабатывается..." },
    videoErrorText: { default: "Ваш браузер не поддерживает данный формат видео-файла" }
  },
  emits: ["click:play", "click:pause", "videoLoaded", "videoEnded", "videoReady", "videoNotReady", "videoTimeUpdated", "keyPressed"],
  setup(t, { emit: e }) {
    const { mobile: n } = nt(), o = t, i = e, r = U(null), a = U(null), s = U(!0), l = (N) => {
      if (!x.value && C.value) {
        switch (k.toggleControlsContainer(), N.key.toLowerCase()) {
          case " ":
            k.togglePlay();
            break;
          case "escape":
            a.value.pause(), s.value = !0;
            break;
          case "arrowup":
            m.value.setAttribute("step", o.volumeStep.toString()), a.value.volume < v.maxValue && a.value.volume < v.maxValue - o.volumeStep ? v.change(o.volumeStep) : v.set(v.maxValue);
            break;
          case "arrowdown":
            m.value.setAttribute("step", o.volumeStep.toString()), a.value.volume > v.minValue && a.value.volume > v.minValue + o.volumeStep ? v.change(-o.volumeStep) : v.set(v.minValue);
            break;
          case "arrowleft":
            o.skipStepDisabled || S.skip(-o.skipStep);
            break;
          case "arrowright":
            o.skipStepDisabled || S.skip(o.skipStep);
            break;
          case "m":
            v.toggleMute();
            break;
        }
        i("keyPressed", N.key);
      }
    }, d = U(!1);
    St(r, "mouseup", (N) => {
      d.value && P.scrubbing(N);
    }), St(r, "mousemove", (N) => {
      d.value && P.update(N);
    });
    const c = new Intl.NumberFormat(void 0, {
      minimumIntegerDigits: 2
    }), u = U(!0), f = U(""), m = U(), v = {
      toggleMute: () => a.value.muted = !a.value.muted,
      slide: (N) => {
        m.value.setAttribute("step", "any");
        const H = +N.target.value;
        a.value.volume = H, a.value.muted = H === 0;
      },
      change: (N) => {
        if (N) {
          a.value.volume += N;
          return;
        }
        m.value.value = String(a.value.volume), a.value.muted || a.value.volume === 0 ? (m.value.value = String(0), f.value = "muted") : f.value = "high", r.value.dataset.volumeLevel = f.value;
      },
      set: (N) => {
        a.value && (a.value.volume = N);
      },
      checkForAudioExist: () => {
        var N;
        a.value && (u.value = a.value.mozHasAudio || !!a.value.webkitAudioDecodedByteCount || !!(a.value.audioTracks && ((N = a.value.audioTracks) != null && N.length))), u.value || v.set(v.minValue);
      },
      maxValue: 1,
      minValue: 0
    }, _ = z(() => f.value === "muted" ? Vd : Bd), w = U(), $ = U(), y = U(), M = U(null), S = {
      durationFormatter: function(N) {
        const H = Math.floor(N % 60), W = Math.floor(N / 60) % 60, te = Math.floor(N / 3600);
        return te === 0 ? `${W}:${c.format(H)}` : `${te}:${c.format(W)}:${c.format(H)}`;
      },
      timeUpdate: function() {
        var H;
        let N = "0";
        a.value && $.value && ($.value.textContent = this.durationFormatter(a.value.currentTime) || "0:00", N = (a.value.currentTime / a.value.duration).toString()), (H = y.value) == null || H.style.setProperty("--progress-position", N), i("videoTimeUpdated");
      },
      skip: (N) => a.value.currentTime += N
    }, x = U(!0), b = U(!1), C = U(!1), E = U(!1), A = U(!1), T = U(null), k = {
      togglePlay: function() {
        if (!x.value && C.value) {
          if (L(), b.value = !1, a.value.paused) {
            a.value.play(), s.value = !1, n.value && !s.value && (a.value.ontouchstart = () => {
              a.value.pause(), s.value = !0;
            });
            return;
          }
          a.value.pause(), s.value = !0, this.toggleControlsContainer(!1);
        }
      },
      loading: function() {
        x.value = !0;
      },
      end: () => {
        b.value = !0, i("videoEnded");
      },
      progress: () => {
        if (F.value && a.value.duration > 0) {
          const N = TW(a.value.buffered, a.value.currentTime);
          M.value.style.width = N / a.value.duration * 100 + "%";
        }
      },
      ready: () => {
        C.value = !0, E.value = !1, x.value = !1, w.value && (w.value.textContent = S.durationFormatter(a.value.duration), i("videoLoaded")), v.checkForAudioExist(), i("videoReady", C.value), i("videoNotReady", E.value);
      },
      notReady: () => {
        C.value = !1, E.value = !0, i("videoReady", C.value), i("videoNotReady", E.value);
      },
      onError: () => {
        C.value = !1, E.value = !0, A.value = !0, x.value = !1;
      },
      setControlsContainerVisible: function(N) {
        T.value && (N ? (T.value.style.pointerEvents = "auto", T.value.style.opacity = "1") : (T.value.style.pointerEvents = "none", T.value.style.opacity = "0"));
      },
      toggleControlsContainer: function(N = !0) {
        this.setControlsContainerVisible(!0), N ? L() : V();
      }
    }, L = bi(() => k.setControlsContainerVisible(!1), 1e3), V = bi(() => k.setControlsContainerVisible(!0), 1e3), O = z(() => b.value || s.value ? Xr : Yr), D = U(!1), P = {
      rect: function() {
        return y.value.getBoundingClientRect();
      },
      _percent: function(N) {
        return Math.min(Math.max(0, N.x - this.rect().x), this.rect().width) / this.rect().width;
      },
      update: function(N) {
        !x.value && C.value && (y.value.style.setProperty("--preview-position", this._percent(N).toString()), d.value && (N.preventDefault(), y.value.style.setProperty("--progress-position", this._percent(N).toString())));
      },
      scrubbing: function(N) {
        !x.value && C.value && (d.value = (N.buttons & 1) === 1, d.value ? (D.value = a.value.paused, a.value.pause()) : (a.value.currentTime = this._percent(N) * a.value.duration, D.value || a.value.play()), this.update(N));
      }
    }, F = U(!1);
    return et(() => {
      F.value = !0;
    }), Hr(() => {
      F.value = !1;
    }), (N, H) => {
      const W = _t, te = WY, ie = vt;
      return p(), g("div", {
        ref_key: "videoContainer",
        ref: r,
        class: ee(["p-video-player", { scrubbing: d.value, paused: s.value }]),
        "data-volume-level": "high",
        tabindex: "-1",
        onKeydown: H[18] || (H[18] = (se) => l(se)),
        onMousemove: H[19] || (H[19] = (se) => k.toggleControlsContainer())
      }, [
        it(h("video", {
          ref_key: "video",
          ref: a,
          playsinline: "",
          poster: o.poster,
          src: B(j1)(o.src),
          controls: o.defaultControls,
          preload: o.preload,
          class: "p-video-player-screen",
          tabindex: "-1",
          onPlay: H[0] || (H[0] = (se) => i("click:play")),
          onPause: H[1] || (H[1] = (se) => i("click:pause")),
          onClick: H[2] || (H[2] = (se) => k.togglePlay()),
          onLoadstart: H[3] || (H[3] = (se) => k.loading()),
          onTimeupdate: H[4] || (H[4] = (se) => S.timeUpdate()),
          onVolumechange: H[5] || (H[5] = (se) => v.change()),
          onEnded: H[6] || (H[6] = (se) => k.end()),
          onCanplay: H[7] || (H[7] = (se) => k.ready()),
          onEmptied: H[8] || (H[8] = (se) => k.notReady()),
          onError: H[9] || (H[9] = (se) => k.onError()),
          onProgress: H[10] || (H[10] = (se) => k.progress())
        }, [
          h("source", {
            src: B(j1)(o.src),
            type: o.mimeType
          }, null, 8, YY)
        ], 40, GY), [
          [Xt, !x.value && !A.value]
        ]),
        it(h("div", XY, [
          x.value ? (p(), J(W, { key: 0 })) : (p(), J(te, { key: 1 })),
          x.value ? (p(), g("p", KY, ne(o.videoLoadingText), 1)) : (p(), g("p", qY, ne(o.videoErrorText), 1))
        ], 512), [
          [Xt, x.value || A.value]
        ]),
        it(h("div", {
          ref_key: "controlsContainer",
          ref: T,
          class: "controls-container",
          onTouchmove: H[17] || (H[17] = Ye(() => {
          }, ["stop"]))
        }, [
          h("div", {
            class: "controls",
            onMousemove: H[16] || (H[16] = Ye((se) => k.toggleControlsContainer(), ["stop"]))
          }, [
            h("div", {
              class: ee(["actions-container", { mobile: !B(n) }, { "no-audio": !u.value }])
            }, [
              it(h("div", JY, [
                q(ie, {
                  class: "volume-muted",
                  variant: "text",
                  disabled: E.value || !u.value && !x.value && C.value,
                  onClick: H[11] || (H[11] = (se) => v.toggleMute())
                }, {
                  default: G(() => [
                    (p(), J(Ce(_.value), { class: "volume" }))
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                it(h("input", {
                  ref_key: "volumeSlider",
                  ref: m,
                  class: "volume-slider",
                  type: "range",
                  min: v.minValue,
                  max: v.maxValue,
                  step: "any",
                  value: "1",
                  disabled: E.value || !u.value && !x.value && C.value,
                  onInput: H[12] || (H[12] = (se) => v.slide(se))
                }, null, 40, QY), [
                  [Xt, u.value && !x.value && C.value]
                ])
              ], 512), [
                [Xt, !B(n)]
              ]),
              h("div", {
                class: "play-pause-btn",
                onClick: H[13] || (H[13] = (se) => k.togglePlay())
              }, [
                (p(), J(Ce(O.value)))
              ])
            ], 2),
            h("div", {
              ref_key: "timelineContainer",
              ref: y,
              class: "timeline-container",
              onMousemove: H[14] || (H[14] = (se) => P.update(se)),
              onMousedown: H[15] || (H[15] = (se) => P.scrubbing(se))
            }, [
              h("div", eX, [
                tX,
                h("div", {
                  ref_key: "bufferedAmount",
                  ref: M,
                  class: "buffered-amount"
                }, null, 512)
              ])
            ], 544),
            h("div", nX, [
              h("div", {
                ref_key: "currentTime",
                ref: $,
                class: "current-time"
              }, ne(ul), 512),
              h("div", {
                ref_key: "totalTime",
                ref: w,
                class: "total-time"
              }, ne(ul), 512)
            ])
          ], 32)
        ], 544), [
          [Xt, !o.defaultControls && !x.value && C.value && !A.value]
        ])
      ], 34);
    };
  }
}), F2 = /* @__PURE__ */ ae(oX, [["__scopeId", "data-v-8c95d2df"]]), iX = {
  key: 0,
  class: "gesture-content loading"
}, rX = { class: "filename" }, aX = { class: "name" }, sX = { class: "extension" }, lX = /* @__PURE__ */ oe({
  name: "PGalleryGestureImage",
  __name: "PGalleryGestureImage",
  props: {
    src: {},
    alt: {},
    imageLoadingText: { default: "Медиа-файл обрабатывается..." }
  },
  emits: ["click:download"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = U(null), r = U(!1), a = U(!0), s = () => {
      r.value = !0, a.value = !1;
    }, l = () => {
      a.value = !1, r.value = !1;
    }, d = z(() => r.value ? "div" : "img");
    return Hr(() => {
      qs(i.value).destroy();
    }), he(
      () => [r.value, a.value],
      () => {
        !r.value && !a.value && qs(i.value);
      }
    ), (c, u) => {
      const f = _t;
      return p(), g("div", null, [
        (p(), J(Ce(d.value), {
          ref_key: "imageContainer",
          ref: i,
          class: ee(["gesture-image", { error: r.value }]),
          src: n.src,
          onLoad: l,
          onError: s
        }, {
          default: G(() => [
            a.value ? (p(), g("div", iX, [
              q(f),
              h("p", null, ne(n.imageLoadingText), 1)
            ])) : X("", !0),
            r.value && !a.value ? (p(), g("div", {
              key: 1,
              class: "gesture-content",
              onClick: u[0] || (u[0] = (m) => o("click:download"))
            }, [
              q(B(t1), { class: "icon" }),
              h("div", rX, [
                h("span", aX, ne(B(Wn).name(n.alt)), 1),
                h("span", sX, ne(B(Wn).extension(n.alt)), 1)
              ])
            ])) : X("", !0)
          ]),
          _: 1
        }, 40, ["class", "src"]))
      ]);
    };
  }
}), dX = /* @__PURE__ */ ae(lX, [["__scopeId", "data-v-c612c9af"]]), cX = { class: "thumb" }, uX = ["src", "type"], hX = /* @__PURE__ */ oe({
  name: "PGalleryThumbComponent",
  __name: "PGalleryThumbComponent",
  props: {
    src: {},
    alt: {},
    mimeType: {},
    preload: { default: "metadata" }
  },
  setup(t) {
    const e = t, n = U(!1), o = U(!1), i = {
      load: () => {
        n.value = !0;
      },
      loaded: () => {
        n.value = !1;
      },
      error: () => {
        n.value = !1, o.value = !0;
      }
    }, r = z(() => Ot.parent(e.mimeType)), a = z(() => {
      switch (r.value) {
        case De.image:
          return "img";
        case De.video:
          return "video";
        default:
          return "div";
      }
    }), s = z(() => {
      if (n.value) return _t;
      switch (r.value) {
        case De.audio:
          return Yi;
        case De.video:
          return Kr;
        default:
          return t1;
      }
    });
    return (l, d) => (p(), g("div", cX, [
      it((p(), J(Ce(a.value), {
        class: "thumb-component",
        preload: e.preload,
        src: B(j1)(e.src),
        onLoad: d[0] || (d[0] = (c) => i.loaded()),
        onLoadstart: d[1] || (d[1] = (c) => i.load()),
        onLoadedmetadata: d[2] || (d[2] = (c) => i.loaded()),
        onError: d[3] || (d[3] = (c) => i.error())
      }, {
        default: G(() => [
          r.value === B(De).video ? (p(), g("source", {
            key: 0,
            src: B(j1)(e.src),
            type: e.mimeType
          }, null, 8, uX)) : X("", !0),
          (p(), J(Ce(s.value)))
        ]),
        _: 1
      }, 40, ["preload", "src"])), [
        [Xt, !n.value && !o.value]
      ]),
      it((p(), J(Ce(s.value), null, null, 512)), [
        [Xt, n.value || o.value]
      ])
    ]));
  }
}), fX = /* @__PURE__ */ ae(hX, [["__scopeId", "data-v-789bbd71"]]), mX = ["data-ios-app"], pX = { class: "p-gallery-actions" }, _X = {
  key: 0,
  class: "loading"
}, vX = { class: "slide-application-content" }, gX = ["onClick"], $X = { class: "name" }, wX = { class: "extension" }, yX = /* @__PURE__ */ oe({
  name: "PGallery",
  __name: "index",
  props: {
    slides: { default: () => [] },
    activeSlideId: {},
    modelValue: { type: Boolean },
    videoLoadingText: { default: "Видео обрабатывается..." },
    imageErrorMessage: { default: "Ваш браузер не поддерживает данный формат" },
    slidePreload: { default: "metadata" },
    thumbPreload: { default: "metadata" },
    exceptionFileList: { default: () => ["tiff"] },
    customDownload: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["click:close", "click:download", "update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = me(n, "modelValue", o), { mobile: r } = nt(), { isIosApp: a } = p0();
    St(document, "keydown", (E) => {
      if (i.value)
        switch (E.key.toLowerCase()) {
          case "escape":
            w();
            break;
          case "arrowleft":
            b.value.prev();
            break;
          case "arrowright":
            b.value.next();
            break;
        }
    });
    const s = U(0), l = z(() => Array.isArray(n.slides) ? n.slides : [n.slides]), d = {
      getCurrentElement: (E, A) => {
        var T;
        return ((T = E.children[0]) == null ? void 0 : T.tagName.toLowerCase()) === A ? E.children[0] : E;
      },
      isFirstSlide: () => s.value === 0,
      isLastSlide: () => s.value === l.value.length - 1,
      hasNavigation: () => b && l.value.length > 1
    }, c = z(() => {
      var E;
      if (!n.customDownload)
        return (E = $.value) == null ? void 0 : E.src;
    }), u = (E) => {
      o("click:download", E), !n.customDownload && PW(E.src);
    }, f = (E) => {
      switch (Ot.parent(E.mimetype)) {
        case De.video:
          return F2;
        case De.image:
          return dX;
        default:
          return "div";
      }
    }, m = z(() => r.value ? Md : jr), v = (E) => Ot.parent(E) === De.audio ? Yi : t1, _ = z(() => l.value.length > 1 && l.value.findIndex((E) => n.activeSlideId === E.id) || 0), w = () => {
      i.value = !1, o("click:close");
    }, $ = U(null), y = (E) => (A) => {
      function T() {
        A.slides.forEach((O) => {
          O.classList.remove("active");
        }), $.value = null;
      }
      function k(O) {
        A.slides[O].classList.add("active"), $.value = l.value[O];
      }
      function L() {
        A.slides.forEach((O, D) => {
          O.addEventListener("click", () => {
            E.value.moveToIdx(D);
          });
        });
      }
      function V() {
        k(A.track.details.rel), L(), E.value.on("animationStarted", () => {
          T();
          const O = E.value.animator.targetIdx || 0;
          k(E.value.track.absToRel(O)), A.moveToIdx(Math.min(A.track.details.maxIdx, O));
        });
      }
      A.on("created", () => {
        V(), n.activeSlideId && E.value.moveToIdx(_.value);
      });
    }, M = (E) => {
      function A() {
        s.value = E.track.details.rel;
        let T = d.getCurrentElement(E.slides[s.value], "div");
        T.classList.contains("p-video-player") && !T.classList.contains("paused") && (T = d.getCurrentElement(E.slides[s.value], "video"), T.click());
      }
      E.on("detailsChanged", () => {
        A();
      }), E.on("dragChecked", () => {
        A();
      });
    };
    function S(E) {
      function A() {
        s.value = E.track.details.rel;
        const T = d.getCurrentElement(E.slides[s.value], "video");
        T !== document.activeElement && T.focus();
      }
      E.on("animationEnded", () => {
        A();
      });
    }
    const [x, b] = cl(
      {
        initial: s.value
      },
      [M, S]
    ), [C] = cl(
      {
        initial: 0,
        drag: !1,
        breakpoints: {
          "(min-width: 720px)": {
            slides: {
              origin: "center",
              perView: "auto",
              spacing: 12
            }
          },
          "(max-width: 720px)": {
            slides: {
              origin: "center",
              perView: "auto",
              spacing: 8
            }
          }
        }
      },
      [y(b)]
    );
    return (E, A) => {
      var D;
      const T = OY, k = vt, L = _t, V = IY, O = MY;
      return p(), g("div", {
        class: ee(["dialog-container", { opened: B(i) }]),
        "data-ios-app": B(a)
      }, [
        h("div", {
          class: ee(["p-gallery", d.hasNavigation() ? "with-thumbs" : "one-slide"]),
          onClick: A[3] || (A[3] = Ye(() => {
          }, ["stop"]))
        }, [
          h("div", pX, [
            q(k, {
              variant: "text",
              href: c.value,
              target: "_blank",
              download: (D = $.value) == null ? void 0 : D.name,
              onClick: A[0] || (A[0] = (P) => o("click:download", $.value))
            }, {
              default: G(() => [
                q(T)
              ]),
              _: 1
            }, 8, ["href", "download"]),
            q(k, {
              variant: "text",
              onClick: w
            }, {
              default: G(() => [
                (p(), J(Ce(m.value), { class: "close-gallery-icon" }))
              ]),
              _: 1
            })
          ]),
          h("div", {
            class: ee(["p-gallery-slide", d.hasNavigation() ? "with-thumbs" : "one-slide"])
          }, [
            h("div", {
              ref_key: "container",
              ref: x,
              class: "keen-slider p-gallery-slide-wrapper"
            }, [
              n.loading ? (p(), g("div", _X, [
                q(L)
              ])) : X("", !0),
              (p(!0), g(_e, null, Ie(l.value, (P, F) => (p(), J(Ce(f(P)), {
                key: F,
                alt: P.name,
                src: P.src,
                class: ee(["keen-slider__slide", d.hasNavigation() ? "with-thumbs" : "one-slide", B(De).application]),
                "skip-step-disabled": d.hasNavigation(),
                "video-loading-text": n.videoLoadingText,
                preload: n.slidePreload,
                "error-message": n.imageErrorMessage,
                "mime-type": P.mimetype,
                "onClick:download": (N) => u(P)
              }, {
                default: G(() => [
                  h("div", vX, [
                    (p(), J(Ce(v(P.mimetype)), {
                      class: "icon",
                      onClick: (N) => u(P)
                    }, null, 8, ["onClick"])),
                    h("div", {
                      class: "filename",
                      onClick: (N) => u(P)
                    }, [
                      h("span", $X, ne(B(Wn).name(P.name)), 1),
                      h("span", wX, ne(B(Wn).extension(P.name)), 1)
                    ], 8, gX)
                  ])
                ]),
                _: 2
              }, 1064, ["alt", "src", "class", "skip-step-disabled", "video-loading-text", "preload", "error-message", "mime-type", "onClick:download"]))), 128))
            ], 512),
            it(q(k, {
              disabled: !d.hasNavigation() || d.isFirstSlide(),
              variant: "rounded",
              color: "secondary",
              class: "arrow arrow--left",
              onClick: A[1] || (A[1] = (P) => B(b).prev())
            }, {
              default: G(() => [
                q(V)
              ]),
              _: 1
            }, 8, ["disabled"]), [
              [Xt, d.hasNavigation() && !d.isFirstSlide()]
            ]),
            it(q(k, {
              disabled: !d.hasNavigation() || d.isLastSlide(),
              variant: "rounded",
              color: "secondary",
              class: "arrow arrow--right",
              onClick: A[2] || (A[2] = (P) => B(b).next())
            }, {
              default: G(() => [
                q(O)
              ]),
              _: 1
            }, 8, ["disabled"]), [
              [Xt, d.hasNavigation() && !d.isLastSlide()]
            ])
          ], 2),
          it(h("div", {
            ref_key: "thumbnail",
            ref: C,
            class: "keen-slider p-gallery-thumbs"
          }, [
            (p(!0), g(_e, null, Ie(l.value, (P, F) => (p(), g("div", {
              key: F,
              class: "keen-slider__slide thumbnail application"
            }, [
              q(fX, {
                src: P.src,
                alt: P.name,
                "mime-type": P.mimetype,
                preload: n.thumbPreload
              }, null, 8, ["src", "alt", "mime-type", "preload"])
            ]))), 128))
          ], 512), [
            [Xt, d.hasNavigation()]
          ])
        ], 2)
      ], 10, mX);
    };
  }
}), MX = /* @__PURE__ */ ae(yX, [["__scopeId", "data-v-1f87ff61"]]), CX = { class: "p-group-avatars" };
var H2 = /* @__PURE__ */ ((t) => (t["x-small"] = "-12px", t.small = "-18px", t.medium = "-16px", t.large = "-24px", t["x-large"] = "-30px", t))(H2 || {});
const bX = /* @__PURE__ */ oe({
  name: "PGroupAvatars",
  __name: "PGroupAvatars",
  props: {
    avatars: {},
    size: { default: "small" }
  },
  setup(t) {
    Nn((i) => ({
      "3de5e4b2": o.value
    }));
    const e = t, n = z(() => e.avatars.length <= 4 ? e.avatars : [
      ...e.avatars.slice(0, 3),
      {
        name: `+ ${e.avatars.length - 3}`
      }
    ]), o = z(() => n.value.length > 1 ? H2[e.size] : 0);
    return (i, r) => {
      const a = Xi;
      return p(), g("div", CX, [
        (p(!0), g(_e, null, Ie(n.value, (s, l) => (p(), J(a, {
          key: l,
          size: i.size,
          src: s.src,
          name: s.name,
          class: ee(["avatar", { rest: e.avatars.length > 4 && l === 3 }])
        }, null, 8, ["size", "src", "name", "class"]))), 128))
      ]);
    };
  }
}), xX = /* @__PURE__ */ ae(bX, [["__scopeId", "data-v-41aa42d0"]]), SX = { class: "p-hint" }, IX = /* @__PURE__ */ oe({
  name: "PHint",
  __name: "PHint",
  props: {
    placement: { default: "bottom-start" }
  },
  setup(t) {
    const e = t, { mobile: n } = nt(), o = U(), i = U(), r = U(), a = U(!1), s = s0(o, i, {
      placement: e.placement,
      strategy: "fixed",
      middleware: [Y1(4), a0({ fallbackAxisSideDirection: "end" }), r0(), Zj({ element: r })],
      whileElementsMounted: Ta
    }), l = z(() => ({
      position: s.strategy.value,
      top: `${s.y.value}px`,
      left: `${s.x.value}px`
    })), d = () => {
      if (n.value) return;
      let m;
      (($) => {
        $.top = "bottom", $.right = "left", $.bottom = "top", $.left = "right";
      })(m || (m = {}));
      const v = m[s.placement.value.split("-")[0]], _ = r.value, w = i.value;
      v === "top" || v === "bottom" ? (_.style[v] = `-${_.offsetWidth / 2}px`, _.style.left = `${w.offsetWidth / 2 - _.offsetWidth / 2}px`) : (_.style[v] = `-${_.offsetWidth / 2}px`, _.style.bottom = `${w.offsetHeight / 2 - _.offsetWidth / 2}px`);
    }, c = (m) => {
      o.value = m;
    }, u = async (m) => {
      m.stopPropagation(), a.value = !0, await Jt(), d();
    }, f = (m) => {
      m.stopPropagation(), a.value = !1;
    };
    return (m, v) => (p(), g("div", SX, [
      Y(m.$slots, "activator", Vr(Fr({ setReference: c, onHover: u, outHover: f })), void 0, !0),
      q(Xe, { name: "fade" }, {
        default: G(() => [
          a.value && !B(n) ? (p(), g("div", {
            key: 0,
            ref_key: "floating",
            ref: i,
            style: en(l.value),
            class: "hint"
          }, [
            Y(m.$slots, "hint", {}, void 0, !0),
            h("div", {
              ref_key: "floatingArrow",
              ref: r,
              class: "hint-arrow"
            }, null, 512)
          ], 4)) : X("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Ra = /* @__PURE__ */ ae(IX, [["__scopeId", "data-v-816029d8"]]), AX = /* @__PURE__ */ oe({
  name: "PInfinityList",
  __name: "PInfinityList",
  props: {
    loading: { type: Boolean },
    options: {}
  },
  emits: ["load"],
  setup(t, { emit: e }) {
    Nn((s) => ({
      babd3cfc: r.value
    }));
    const n = U(), o = e, i = t, r = U("auto");
    he(n, (s) => {
      if (s && i.options) {
        const l = s.querySelector(`${i.options.elementSelector}`);
        l && (r.value = `${(i.options.showedElementsCount - 0.1) * l.clientHeight}px`);
      }
    });
    const a = (s) => {
      const { scrollTop: l, scrollHeight: d, clientHeight: c } = s.target;
      d - c <= l + 1 && !i.loading && o("load");
    };
    return (s, l) => (p(), g("div", {
      ref_key: "container",
      ref: n,
      class: "p-infinity-list",
      onScroll: a
    }, [
      Y(s.$slots, "default", {}, void 0, !0)
    ], 544));
  }
}), kX = /* @__PURE__ */ ae(AX, [["__scopeId", "data-v-7b984959"]]), EX = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function PX(t, e) {
  var n = Array.prototype.slice.call(e);
  return n.push(EX), t.apply(this, n);
}
function gr(t) {
  "@babel/helpers - typeof";
  return gr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, gr(t);
}
function TX(t, e, n) {
  return Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function OX(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function LX(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && X1(t, e);
}
function DX(t) {
  var e = z2();
  return function() {
    var o = K1(t), i;
    if (e) {
      var r = K1(this).constructor;
      i = Reflect.construct(o, arguments, r);
    } else
      i = o.apply(this, arguments);
    return NX(this, i);
  };
}
function NX(t, e) {
  if (e && (gr(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return U2(t);
}
function U2(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function $r(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return $r = function(o) {
    if (o === null || !RX(o)) return o;
    if (typeof o != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(o)) return e.get(o);
      e.set(o, i);
    }
    function i() {
      return wi(o, arguments, K1(this).constructor);
    }
    return i.prototype = Object.create(o.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), X1(i, o);
  }, $r(t);
}
function wi(t, e, n) {
  return z2() ? wi = Reflect.construct : wi = function(i, r, a) {
    var s = [null];
    s.push.apply(s, r);
    var l = Function.bind.apply(i, s), d = new l();
    return a && X1(d, a.prototype), d;
  }, wi.apply(null, arguments);
}
function z2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function RX(t) {
  return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function X1(t, e) {
  return X1 = Object.setPrototypeOf || function(o, i) {
    return o.__proto__ = i, o;
  }, X1(t, e);
}
function K1(t) {
  return K1 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, K1(t);
}
var An = /* @__PURE__ */ function(t) {
  LX(n, t);
  var e = DX(n);
  function n(o) {
    var i;
    return OX(this, n), i = e.call(this, o), Object.setPrototypeOf(U2(i), n.prototype), i.name = i.constructor.name, i;
  }
  return TX(n);
}(/* @__PURE__ */ $r(Error)), Za = 2, ZX = 17, BX = 3, sn = "0-9０-９٠-٩۰-۹", VX = "-‐-―−ー－", FX = "／/", HX = "．.", UX = "  ­​⁠　", zX = "()（）［］\\[\\]", WX = "~⁓∼～", Vi = "".concat(VX).concat(FX).concat(HX).concat(UX).concat(zX).concat(WX), Ba = "+＋";
function hl(t, e) {
  t = t.split("-"), e = e.split("-");
  for (var n = t[0].split("."), o = e[0].split("."), i = 0; i < 3; i++) {
    var r = Number(n[i]), a = Number(o[i]);
    if (r > a) return 1;
    if (a > r) return -1;
    if (!isNaN(r) && isNaN(a)) return 1;
    if (isNaN(r) && !isNaN(a)) return -1;
  }
  return t[1] && e[1] ? t[1] > e[1] ? 1 : t[1] < e[1] ? -1 : 0 : !t[1] && e[1] ? 1 : t[1] && !e[1] ? -1 : 0;
}
var jX = {}.constructor;
function yi(t) {
  return t != null && t.constructor === jX;
}
function wr(t) {
  "@babel/helpers - typeof";
  return wr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, wr(t);
}
function c0(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function GX(t, e) {
  for (var n = 0; n < e.length; n++) {
    var o = e[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
  }
}
function u0(t, e, n) {
  return e && GX(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var YX = "1.2.0", XX = "1.7.35", fl = " ext. ", KX = /^\d+$/, gt = /* @__PURE__ */ function() {
  function t(e) {
    c0(this, t), eK(e), this.metadata = e, W2.call(this, e);
  }
  return u0(t, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var o = this.countryCallingCodes()[n];
        if (o && o.length === 1 && o[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, o) {
      if (n && KX.test(n) && (o = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new ml(this.getCountryMetadata(n), this);
      } else if (o) {
        if (!this.hasCallingCode(o))
          throw new Error("Unknown calling code: ".concat(o));
        this.numberingPlan = new ml(this.getNumberingPlanMetadata(o), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var o = this.countryCallingCodes()[n];
      if (o)
        return o.length === 1 && o[0].length === 3 ? void 0 : o;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var o = this.getCountryCodesForCallingCode(n);
      if (o)
        return o[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var o = this.getCountryCodeForCallingCode(n);
      if (o)
        return this.getCountryMetadata(o);
      if (this.nonGeographic()) {
        var i = this.nonGeographic()[n];
        if (i)
          return i;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), t;
}(), ml = /* @__PURE__ */ function() {
  function t(e, n) {
    c0(this, t), this.globalMetadataObject = n, this.metadata = e, W2.call(this, n.metadata);
  }
  return u0(t, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, o = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return o.map(function(i) {
        return new qX(i, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && pl(this.types(), n))
        return new QX(pl(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? fl : this.metadata[13] || fl;
    }
  }]), t;
}(), qX = /* @__PURE__ */ function() {
  function t(e, n) {
    c0(this, t), this._format = e, this.metadata = n;
  }
  return u0(t, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !JX.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), t;
}(), JX = /^\(?\$1\)?$/, QX = /* @__PURE__ */ function() {
  function t(e, n) {
    c0(this, t), this.type = e, this.metadata = n;
  }
  return u0(t, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), t;
}();
function pl(t, e) {
  switch (e) {
    case "FIXED_LINE":
      return t[0];
    case "MOBILE":
      return t[1];
    case "TOLL_FREE":
      return t[2];
    case "PREMIUM_RATE":
      return t[3];
    case "PERSONAL_NUMBER":
      return t[4];
    case "VOICEMAIL":
      return t[5];
    case "UAN":
      return t[6];
    case "PAGER":
      return t[7];
    case "VOIP":
      return t[8];
    case "SHARED_COST":
      return t[9];
  }
}
function eK(t) {
  if (!t)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!yi(t) || !yi(t.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(yi(t) ? "an object of shape: { " + Object.keys(t).join(", ") + " }" : "a " + tK(t) + ": " + t, "."));
}
var tK = function(e) {
  return wr(e);
};
function Va(t, e) {
  if (e = new gt(e), e.hasCountry(t))
    return e.country(t).countryCallingCode();
  throw new Error("Unknown country: ".concat(t));
}
function nK(t, e) {
  return e.countries.hasOwnProperty(t);
}
function W2(t) {
  var e = t.version;
  typeof e == "number" ? (this.v1 = e === 1, this.v2 = e === 2, this.v3 = e === 3, this.v4 = e === 4) : e ? hl(e, YX) === -1 ? this.v2 = !0 : hl(e, XX) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var oK = ";ext=", Zo = function(e) {
  return "([".concat(sn, "]{1,").concat(e, "})");
};
function j2(t) {
  var e = "20", n = "15", o = "9", i = "6", r = "[  \\t,]*", a = "[:\\.．]?[  \\t,-]*", s = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", u = "[  \\t]*", f = "(?:,{2}|;)", m = oK + Zo(e), v = r + l + a + Zo(e) + s, _ = r + d + a + Zo(o) + s, w = c + Zo(i) + "#", $ = u + f + a + Zo(n) + s, y = u + "(?:,)+" + a + Zo(o) + s;
  return m + "|" + v + "|" + _ + "|" + w + "|" + $ + "|" + y;
}
var iK = "[" + sn + "]{" + Za + "}", rK = "[" + Ba + "]{0,1}(?:[" + Vi + "]*[" + sn + "]){3,}[" + Vi + sn + "]*", aK = new RegExp("^[" + Ba + "]{0,1}(?:[" + Vi + "]*[" + sn + "]){1,2}$", "i"), sK = rK + // Phone number extensions
"(?:" + j2() + ")?", lK = new RegExp(
  // Either a short two-digit-only phone number
  "^" + iK + "$|^" + sK + "$",
  "i"
);
function dK(t) {
  return t.length >= Za && lK.test(t);
}
function cK(t) {
  return aK.test(t);
}
var _l = new RegExp("(?:" + j2() + ")$", "i");
function uK(t) {
  var e = t.search(_l);
  if (e < 0)
    return {};
  for (var n = t.slice(0, e), o = t.match(_l), i = 1; i < o.length; ) {
    if (o[i])
      return {
        number: n,
        ext: o[i]
      };
    i++;
  }
}
var hK = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function fK(t) {
  return hK[t];
}
function mK(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = pK(t)) || e) {
    n && (t = n);
    var o = 0;
    return function() {
      return o >= t.length ? { done: !0 } : { done: !1, value: t[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pK(t, e) {
  if (t) {
    if (typeof t == "string") return vl(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return vl(t, e);
  }
}
function vl(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, o = new Array(e); n < e; n++)
    o[n] = t[n];
  return o;
}
function gl(t) {
  for (var e = "", n = mK(t.split("")), o; !(o = n()).done; ) {
    var i = o.value;
    e += _K(i, e) || "";
  }
  return e;
}
function _K(t, e, n) {
  return t === "+" ? e ? void 0 : "+" : fK(t);
}
function Fa(t, e) {
  return vK(t, void 0, e);
}
function vK(t, e, n) {
  var o = n.type(e), i = o && o.possibleLengths() || n.possibleLengths();
  if (!i)
    return "IS_POSSIBLE";
  var r = t.length, a = i[0];
  return a === r ? "IS_POSSIBLE" : a > r ? "TOO_SHORT" : i[i.length - 1] < r ? "TOO_LONG" : i.indexOf(r, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function gK(t, e, n) {
  if (e === void 0 && (e = {}), n = new gt(n), e.v2) {
    if (!t.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(t.countryCallingCode);
  } else {
    if (!t.phone)
      return !1;
    if (t.country) {
      if (!n.hasCountry(t.country))
        throw new Error("Unknown country: ".concat(t.country));
      n.country(t.country);
    } else {
      if (!t.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(t.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return G2(t.phone || t.nationalNumber, n);
  if (t.countryCallingCode && n.isNonGeographicCallingCode(t.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function G2(t, e) {
  switch (Fa(t, e)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function Dn(t, e) {
  return t = t || "", new RegExp("^(?:" + e + ")$").test(t);
}
function $K(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = wK(t)) || e) {
    n && (t = n);
    var o = 0;
    return function() {
      return o >= t.length ? { done: !0 } : { done: !1, value: t[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wK(t, e) {
  if (t) {
    if (typeof t == "string") return $l(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $l(t, e);
  }
}
function $l(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, o = new Array(e); n < e; n++)
    o[n] = t[n];
  return o;
}
var yK = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Ha(t, e, n) {
  if (e = e || {}, !(!t.country && !t.countryCallingCode)) {
    n = new gt(n), n.selectNumberingPlan(t.country, t.countryCallingCode);
    var o = e.v2 ? t.nationalNumber : t.phone;
    if (Dn(o, n.nationalNumberPattern())) {
      if (P0(o, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || P0(o, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var i = $K(yK), r; !(r = i()).done; ) {
        var a = r.value;
        if (P0(o, a, n))
          return a;
      }
    }
  }
}
function P0(t, e, n) {
  return e = n.type(e), !e || !e.pattern() || e.possibleLengths() && e.possibleLengths().indexOf(t.length) < 0 ? !1 : Dn(t, e.pattern());
}
function MK(t, e, n) {
  if (e = e || {}, n = new gt(n), n.selectNumberingPlan(t.country, t.countryCallingCode), n.hasTypes())
    return Ha(t, e, n.metadata) !== void 0;
  var o = e.v2 ? t.nationalNumber : t.phone;
  return Dn(o, n.nationalNumberPattern());
}
function CK(t, e, n) {
  var o = new gt(n), i = o.getCountryCodesForCallingCode(t);
  return i ? i.filter(function(r) {
    return bK(e, r, n);
  }) : [];
}
function bK(t, e, n) {
  var o = new gt(n);
  return o.selectNumberingPlan(e), o.numberingPlan.possibleLengths().indexOf(t.length) >= 0;
}
function xK(t) {
  return t.replace(new RegExp("[".concat(Vi, "]+"), "g"), " ").trim();
}
var SK = /(\$\d)/;
function IK(t, e, n) {
  var o = n.useInternationalFormat, i = n.withNationalPrefix, r = t.replace(new RegExp(e.pattern()), o ? e.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && e.nationalPrefixFormattingRule() ? e.format().replace(SK, e.nationalPrefixFormattingRule()) : e.format()
  ));
  return o ? xK(r) : r;
}
var AK = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function kK(t, e, n) {
  var o = new gt(n);
  if (o.selectNumberingPlan(t, e), o.defaultIDDPrefix())
    return o.defaultIDDPrefix();
  if (AK.test(o.IDDPrefix()))
    return o.IDDPrefix();
}
function EK(t) {
  var e = t.number, n = t.ext;
  if (!e)
    return "";
  if (e[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(e).concat(n ? ";ext=" + n : "");
}
function PK(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = TK(t)) || e) {
    n && (t = n);
    var o = 0;
    return function() {
      return o >= t.length ? { done: !0 } : { done: !1, value: t[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function TK(t, e) {
  if (t) {
    if (typeof t == "string") return wl(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return wl(t, e);
  }
}
function wl(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, o = new Array(e); n < e; n++)
    o[n] = t[n];
  return o;
}
function yl(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Ml(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? yl(Object(n), !0).forEach(function(o) {
      OK(t, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : yl(Object(n)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return t;
}
function OK(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Cl = {
  formatExtension: function(e, n, o) {
    return "".concat(e).concat(o.ext()).concat(n);
  }
};
function LK(t, e, n, o) {
  if (n ? n = Ml(Ml({}, Cl), n) : n = Cl, o = new gt(o), t.country && t.country !== "001") {
    if (!o.hasCountry(t.country))
      throw new Error("Unknown country: ".concat(t.country));
    o.country(t.country);
  } else if (t.countryCallingCode)
    o.selectNumberingPlan(t.countryCallingCode);
  else return t.phone || "";
  var i = o.countryCallingCode(), r = n.v2 ? t.nationalNumber : t.phone, a;
  switch (e) {
    case "NATIONAL":
      return r ? (a = Fi(r, t.carrierCode, "NATIONAL", o, n), T0(a, t.ext, o, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return r ? (a = Fi(r, null, "INTERNATIONAL", o, n), a = "+".concat(i, " ").concat(a), T0(a, t.ext, o, n.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(r);
    case "RFC3966":
      return EK({
        number: "+".concat(i).concat(r),
        ext: t.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var s = NK(r, t.carrierCode, i, n.fromCountry, o);
      return T0(s, t.ext, o, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e, '"'));
  }
}
function Fi(t, e, n, o, i) {
  var r = DK(o.formats(), t);
  return r ? IK(t, r, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(r.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1),
    carrierCode: e,
    metadata: o
  }) : t;
}
function DK(t, e) {
  for (var n = PK(t), o; !(o = n()).done; ) {
    var i = o.value;
    if (i.leadingDigitsPatterns().length > 0) {
      var r = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
      if (e.search(r) !== 0)
        continue;
    }
    if (Dn(e, i.pattern()))
      return i;
  }
}
function T0(t, e, n, o) {
  return e ? o(t, e, n) : t;
}
function NK(t, e, n, o, i) {
  var r = Va(o, i.metadata);
  if (r === n) {
    var a = Fi(t, e, "NATIONAL", i);
    return n === "1" ? n + " " + a : a;
  }
  var s = kK(o, void 0, i.metadata);
  if (s)
    return "".concat(s, " ").concat(n, " ").concat(Fi(t, null, "INTERNATIONAL", i));
}
function bl(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function xl(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? bl(Object(n), !0).forEach(function(o) {
      RK(t, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : bl(Object(n)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return t;
}
function RK(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function ZK(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function BK(t, e) {
  for (var n = 0; n < e.length; n++) {
    var o = e[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
  }
}
function VK(t, e, n) {
  return e && BK(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var FK = /* @__PURE__ */ function() {
  function t(e, n, o) {
    if (ZK(this, t), !e)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!o)
      throw new TypeError("`metadata` not passed");
    var i = UK(e, o), r = i.country, a = i.countryCallingCode;
    this.country = r, this.countryCallingCode = a, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return o;
    };
  }
  return VK(t, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : CK(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return gK(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return MK(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new gt(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return Ha(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, o) {
      return LK(this, n, o ? xl(xl({}, o), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), t;
}(), HK = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function UK(t, e) {
  var n, o, i = new gt(e);
  return HK(t) ? (n = t, i.selectNumberingPlan(n), o = i.countryCallingCode()) : o = t, {
    country: n,
    countryCallingCode: o
  };
}
var zK = new RegExp("([" + sn + "])");
function WK(t, e, n, o) {
  if (e) {
    var i = new gt(o);
    i.selectNumberingPlan(e, n);
    var r = new RegExp(i.IDDPrefix());
    if (t.search(r) === 0) {
      t = t.slice(t.match(r)[0].length);
      var a = t.match(zK);
      if (!(a && a[1] != null && a[1].length > 0 && a[1] === "0"))
        return t;
    }
  }
}
function jK(t, e) {
  if (t && e.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + e.numberingPlan.nationalPrefixForParsing() + ")"), o = n.exec(t);
    if (o) {
      var i, r, a = o.length - 1, s = a > 0 && o[a];
      if (e.nationalPrefixTransformRule() && s)
        i = t.replace(n, e.nationalPrefixTransformRule()), a > 1 && (r = o[1]);
      else {
        var l = o[0];
        i = t.slice(l.length), s && (r = o[1]);
      }
      var d;
      if (s) {
        var c = t.indexOf(o[1]), u = t.slice(0, c);
        u === e.numberingPlan.nationalPrefix() && (d = e.numberingPlan.nationalPrefix());
      } else
        d = o[0];
      return {
        nationalNumber: i,
        nationalPrefix: d,
        carrierCode: r
      };
    }
  }
  return {
    nationalNumber: t
  };
}
function yr(t, e) {
  var n = jK(t, e), o = n.carrierCode, i = n.nationalNumber;
  if (i !== t) {
    if (!GK(t, i, e))
      return {
        nationalNumber: t
      };
    if (e.possibleLengths() && !YK(i, e))
      return {
        nationalNumber: t
      };
  }
  return {
    nationalNumber: i,
    carrierCode: o
  };
}
function GK(t, e, n) {
  return !(Dn(t, n.nationalNumberPattern()) && !Dn(e, n.nationalNumberPattern()));
}
function YK(t, e) {
  switch (Fa(t, e)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function XK(t, e, n, o) {
  var i = e ? Va(e, o) : n;
  if (t.indexOf(i) === 0) {
    o = new gt(o), o.selectNumberingPlan(e, n);
    var r = t.slice(i.length), a = yr(r, o), s = a.nationalNumber, l = yr(t, o), d = l.nationalNumber;
    if (!Dn(d, o.nationalNumberPattern()) && Dn(s, o.nationalNumberPattern()) || Fa(d, o) === "TOO_LONG")
      return {
        countryCallingCode: i,
        number: r
      };
  }
  return {
    number: t
  };
}
function KK(t, e, n, o) {
  if (!t)
    return {};
  var i;
  if (t[0] !== "+") {
    var r = WK(t, e, n, o);
    if (r && r !== t)
      i = !0, t = "+" + r;
    else {
      if (e || n) {
        var a = XK(t, e, n, o), s = a.countryCallingCode, l = a.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: t
      };
    }
  }
  if (t[1] === "0")
    return {};
  o = new gt(o);
  for (var d = 2; d - 1 <= BX && d <= t.length; ) {
    var c = t.slice(1, d);
    if (o.hasCallingCode(c))
      return o.selectNumberingPlan(c), {
        countryCallingCodeSource: i ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: c,
        number: t.slice(d)
      };
    d++;
  }
  return {};
}
function qK(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = JK(t)) || e) {
    n && (t = n);
    var o = 0;
    return function() {
      return o >= t.length ? { done: !0 } : { done: !1, value: t[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JK(t, e) {
  if (t) {
    if (typeof t == "string") return Sl(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Sl(t, e);
  }
}
function Sl(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, o = new Array(e); n < e; n++)
    o[n] = t[n];
  return o;
}
function QK(t, e) {
  var n = e.countries, o = e.defaultCountry, i = e.metadata;
  i = new gt(i);
  for (var r = [], a = qK(n), s; !(s = a()).done; ) {
    var l = s.value;
    if (i.country(l), i.leadingDigits()) {
      if (t && t.search(i.leadingDigits()) === 0)
        return l;
    } else if (Ha({
      phone: t,
      country: l
    }, void 0, i.metadata))
      if (o) {
        if (l === o)
          return l;
        r.push(l);
      } else
        return l;
  }
  if (r.length > 0)
    return r[0];
}
function eq(t, e) {
  var n = e.nationalNumber, o = e.defaultCountry, i = e.metadata, r = i.getCountryCodesForCallingCode(t);
  if (r)
    return r.length === 1 ? r[0] : QK(n, {
      countries: r,
      defaultCountry: o,
      metadata: i.metadata
    });
}
var Y2 = "+", tq = "[\\-\\.\\(\\)]?", Il = "([" + sn + "]|" + tq + ")", nq = "^\\" + Y2 + Il + "*[" + sn + "]" + Il + "*$", oq = new RegExp(nq, "g"), Mr = sn, iq = "[" + Mr + "]+((\\-)*[" + Mr + "])*", rq = "a-zA-Z", aq = "[" + rq + "]+((\\-)*[" + Mr + "])*", sq = "^(" + iq + "\\.)*" + aq + "\\.?$", lq = new RegExp(sq, "g"), Al = "tel:", Cr = ";phone-context=", dq = ";isub=";
function cq(t) {
  var e = t.indexOf(Cr);
  if (e < 0)
    return null;
  var n = e + Cr.length;
  if (n >= t.length)
    return "";
  var o = t.indexOf(";", n);
  return o >= 0 ? t.substring(n, o) : t.substring(n);
}
function uq(t) {
  return t === null ? !0 : t.length === 0 ? !1 : oq.test(t) || lq.test(t);
}
function hq(t, e) {
  var n = e.extractFormattedPhoneNumber, o = cq(t);
  if (!uq(o))
    throw new An("NOT_A_NUMBER");
  var i;
  if (o === null)
    i = n(t) || "";
  else {
    i = "", o.charAt(0) === Y2 && (i += o);
    var r = t.indexOf(Al), a;
    r >= 0 ? a = r + Al.length : a = 0;
    var s = t.indexOf(Cr);
    i += t.substring(a, s);
  }
  var l = i.indexOf(dq);
  if (l > 0 && (i = i.substring(0, l)), i !== "")
    return i;
}
var fq = 250, mq = new RegExp("[" + Ba + sn + "]"), pq = new RegExp("[^" + sn + "#]+$");
function _q(t, e, n) {
  if (e = e || {}, n = new gt(n), e.defaultCountry && !n.hasCountry(e.defaultCountry))
    throw e.v2 ? new An("INVALID_COUNTRY") : new Error("Unknown country: ".concat(e.defaultCountry));
  var o = gq(t, e.v2, e.extract), i = o.number, r = o.ext, a = o.error;
  if (!i) {
    if (e.v2)
      throw a === "TOO_SHORT" ? new An("TOO_SHORT") : new An("NOT_A_NUMBER");
    return {};
  }
  var s = wq(i, e.defaultCountry, e.defaultCallingCode, n), l = s.country, d = s.nationalNumber, c = s.countryCallingCode, u = s.countryCallingCodeSource, f = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (e.v2)
      throw new An("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < Za) {
    if (e.v2)
      throw new An("TOO_SHORT");
    return {};
  }
  if (d.length > ZX) {
    if (e.v2)
      throw new An("TOO_LONG");
    return {};
  }
  if (e.v2) {
    var m = new FK(c, d, n.metadata);
    return l && (m.country = l), f && (m.carrierCode = f), r && (m.ext = r), m.__countryCallingCodeSource = u, m;
  }
  var v = (e.extended ? n.hasSelectedNumberingPlan() : l) ? Dn(d, n.nationalNumberPattern()) : !1;
  return e.extended ? {
    country: l,
    countryCallingCode: c,
    carrierCode: f,
    valid: v,
    possible: v ? !0 : !!(e.extended === !0 && n.possibleLengths() && G2(d, n)),
    phone: d,
    ext: r
  } : v ? $q(l, d, r) : {};
}
function vq(t, e, n) {
  if (t) {
    if (t.length > fq) {
      if (n)
        throw new An("TOO_LONG");
      return;
    }
    if (e === !1)
      return t;
    var o = t.search(mq);
    if (!(o < 0))
      return t.slice(o).replace(pq, "");
  }
}
function gq(t, e, n) {
  var o = hq(t, {
    extractFormattedPhoneNumber: function(a) {
      return vq(a, n, e);
    }
  });
  if (!o)
    return {};
  if (!dK(o))
    return cK(o) ? {
      error: "TOO_SHORT"
    } : {};
  var i = uK(o);
  return i.ext ? i : {
    number: o
  };
}
function $q(t, e, n) {
  var o = {
    country: t,
    phone: e
  };
  return n && (o.ext = n), o;
}
function wq(t, e, n, o) {
  var i = KK(gl(t), e, n, o.metadata), r = i.countryCallingCodeSource, a = i.countryCallingCode, s = i.number, l;
  if (a)
    o.selectNumberingPlan(a);
  else if (s && (e || n))
    o.selectNumberingPlan(e, n), e && (l = e), a = n || Va(e, o.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: r,
      countryCallingCode: a
    };
  var d = yr(gl(s), o), c = d.nationalNumber, u = d.carrierCode, f = eq(a, {
    nationalNumber: c,
    defaultCountry: e,
    metadata: o
  });
  return f && (l = f, f === "001" || o.country(l)), {
    country: l,
    countryCallingCode: a,
    countryCallingCodeSource: r,
    nationalNumber: c,
    carrierCode: u
  };
}
function kl(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function El(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? kl(Object(n), !0).forEach(function(o) {
      yq(t, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : kl(Object(n)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return t;
}
function yq(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Mq(t, e, n) {
  return _q(t, El(El({}, e), {}, {
    v2: !0
  }), n);
}
function Pl(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Cq(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Pl(Object(n), !0).forEach(function(o) {
      bq(t, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Pl(Object(n)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return t;
}
function bq(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function xq(t, e) {
  return kq(t) || Aq(t, e) || Iq(t, e) || Sq();
}
function Sq() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Iq(t, e) {
  if (t) {
    if (typeof t == "string") return Tl(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Tl(t, e);
  }
}
function Tl(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, o = new Array(e); n < e; n++)
    o[n] = t[n];
  return o;
}
function Aq(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var o = [], i = !0, r = !1, a, s;
    try {
      for (n = n.call(t); !(i = (a = n.next()).done) && (o.push(a.value), !(e && o.length === e)); i = !0)
        ;
    } catch (l) {
      r = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (r) throw s;
      }
    }
    return o;
  }
}
function kq(t) {
  if (Array.isArray(t)) return t;
}
function Eq(t) {
  var e = Array.prototype.slice.call(t), n = xq(e, 4), o = n[0], i = n[1], r = n[2], a = n[3], s, l, d;
  if (typeof o == "string")
    s = o;
  else throw new TypeError("A text for parsing must be a string.");
  if (!i || typeof i == "string")
    a ? (l = r, d = a) : (l = void 0, d = r), i && (l = Cq({
      defaultCountry: i
    }, l));
  else if (yi(i))
    r ? (l = i, d = r) : d = i;
  else throw new Error("Invalid second argument: ".concat(i));
  return {
    text: s,
    options: l,
    metadata: d
  };
}
function Ol(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Ll(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ol(Object(n), !0).forEach(function(o) {
      Pq(t, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ol(Object(n)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return t;
}
function Pq(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Tq(t, e, n) {
  e && e.defaultCountry && !nK(e.defaultCountry, n) && (e = Ll(Ll({}, e), {}, {
    defaultCountry: void 0
  }));
  try {
    return Mq(t, e, n);
  } catch (o) {
    if (!(o instanceof An)) throw o;
  }
}
function Oq() {
  var t = Eq(arguments), e = t.text, n = t.options, o = t.metadata;
  return Tq(e, n, o);
}
function Dl() {
  return PX(Oq, arguments);
}
function Nl(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function q1(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Nl(Object(n), !0).forEach(function(o) {
      Lq(t, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Nl(Object(n)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return t;
}
function Lq(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function Hi(t) {
  return typeof t == "function";
}
function br(t) {
  return t !== null && typeof t == "object" && !Array.isArray(t);
}
function h0(t) {
  return Hi(t.$validator) ? q1({}, t) : {
    $validator: t
  };
}
function X2(t) {
  return typeof t == "object" ? t.$valid : t;
}
function K2(t) {
  return t.$validator || t;
}
function Dq(t, e) {
  if (!br(t)) throw new Error(`[@vuelidate/validators]: First parameter to "withParams" should be an object, provided ${typeof t}`);
  if (!br(e) && !Hi(e)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const n = h0(e);
  return n.$params = q1(q1({}, n.$params || {}), t), n;
}
function Nq(t, e) {
  if (!Hi(t) && typeof B(t) != "string") throw new Error(`[@vuelidate/validators]: First parameter to "withMessage" should be string or a function returning a string, provided ${typeof t}`);
  if (!br(e) && !Hi(e)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const n = h0(e);
  return n.$message = t, n;
}
function Rq(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  const n = h0(t);
  return q1(q1({}, n), {}, {
    $async: !0,
    $watchTargets: e
  });
}
function Zq(t) {
  return {
    $validator(e) {
      for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
        o[i - 1] = arguments[i];
      return B(e).reduce((r, a, s) => {
        const l = Object.entries(a).reduce((d, c) => {
          let [u, f] = c;
          const m = t[u] || {}, v = Object.entries(m).reduce((_, w) => {
            let [$, y] = w;
            const S = K2(y).call(this, f, a, s, ...o), x = X2(S);
            if (_.$data[$] = S, _.$data.$invalid = !x || !!_.$data.$invalid, _.$data.$error = _.$data.$invalid, !x) {
              let b = y.$message || "";
              const C = y.$params || {};
              typeof b == "function" && (b = b({
                $pending: !1,
                $invalid: !x,
                $params: C,
                $model: f,
                $response: S
              })), _.$errors.push({
                $property: u,
                $message: b,
                $params: C,
                $response: S,
                $model: f,
                $pending: !1,
                $validator: $
              });
            }
            return {
              $valid: _.$valid && x,
              $data: _.$data,
              $errors: _.$errors
            };
          }, {
            $valid: !0,
            $data: {},
            $errors: []
          });
          return d.$data[u] = v.$data, d.$errors[u] = v.$errors, {
            $valid: d.$valid && v.$valid,
            $data: d.$data,
            $errors: d.$errors
          };
        }, {
          $valid: !0,
          $data: {},
          $errors: {}
        });
        return {
          $valid: r.$valid && l.$valid,
          $data: r.$data.concat(l.$data),
          $errors: r.$errors.concat(l.$errors)
        };
      }, {
        $valid: !0,
        $data: [],
        $errors: []
      });
    },
    $message: (e) => {
      let {
        $response: n
      } = e;
      return n ? n.$errors.map((o) => Object.values(o).map((i) => i.map((r) => r.$message)).reduce((i, r) => i.concat(r), [])) : [];
    }
  };
}
const Ua = (t) => {
  if (t = B(t), Array.isArray(t)) return !!t.length;
  if (t == null)
    return !1;
  if (t === !1)
    return !0;
  if (t instanceof Date)
    return !isNaN(t.getTime());
  if (typeof t == "object") {
    for (let e in t) return !0;
    return !1;
  }
  return !!String(t).length;
}, Bq = (t) => (t = B(t), Array.isArray(t) ? t.length : typeof t == "object" ? Object.keys(t).length : String(t).length);
function io() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return (o) => (o = B(o), !Ua(o) || e.every((i) => (i.lastIndex = 0, i.test(o))));
}
var ho = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  forEach: Zq,
  len: Bq,
  normalizeValidatorObject: h0,
  regex: io,
  req: Ua,
  unwrap: B,
  unwrapNormalizedValidator: K2,
  unwrapValidatorResponse: X2,
  withAsync: Rq,
  withMessage: Nq,
  withParams: Dq
});
io(/^[a-zA-Z]*$/);
io(/^[a-zA-Z0-9]*$/);
io(/^\d*(\.\d+)?$/);
const Vq = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
io(Vq);
function Fq(t) {
  return typeof t == "string" && (t = t.trim()), Ua(t);
}
var Hq = {
  $validator: Fq,
  $message: "Value is required",
  $params: {
    type: "required"
  }
};
const Uq = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
io(Uq);
io(/(^[0-9]*$)|(^-[0-9]+$)/);
io(/^[-]?\d*(\.\d+)?$/);
function Rl(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Fn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Rl(Object(n), !0).forEach(function(o) {
      zq(t, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Rl(Object(n)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return t;
}
function zq(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function Zl(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return Object.keys(t).reduce((n, o) => (e.includes(o) || (n[o] = B(t[o])), n), {});
}
function Ui(t) {
  return typeof t == "function";
}
function Wq(t) {
  return A3(t) || k3(t);
}
function q2(t, e, n) {
  let o = t;
  const i = e.split(".");
  for (let r = 0; r < i.length; r++) {
    if (!o[i[r]]) return n;
    o = o[i[r]];
  }
  return o;
}
function O0(t, e, n) {
  return z(() => t.some((o) => q2(e, o, {
    [n]: !1
  })[n]));
}
function Bl(t, e, n) {
  return z(() => t.reduce((o, i) => {
    const r = q2(e, i, {
      [n]: !1
    })[n] || [];
    return o.concat(r);
  }, []));
}
function J2(t, e, n, o) {
  return t.call(o, B(e), B(n), o);
}
function Q2(t) {
  return t.$valid !== void 0 ? !t.$valid : !t;
}
function jq(t, e, n, o, i, r, a) {
  let {
    $lazy: s,
    $rewardEarly: l
  } = i, d = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [], c = arguments.length > 8 ? arguments[8] : void 0, u = arguments.length > 9 ? arguments[9] : void 0, f = arguments.length > 10 ? arguments[10] : void 0;
  const m = U(!!o.value), v = U(0);
  n.value = !1;
  const _ = he([e, o].concat(d, f), () => {
    if (s && !o.value || l && !u.value && !n.value)
      return;
    let w;
    try {
      w = J2(t, e, c, a);
    } catch ($) {
      w = Promise.reject($);
    }
    v.value++, n.value = !!v.value, m.value = !1, Promise.resolve(w).then(($) => {
      v.value--, n.value = !!v.value, r.value = $, m.value = Q2($);
    }).catch(($) => {
      v.value--, n.value = !!v.value, r.value = $, m.value = !0;
    });
  }, {
    immediate: !0,
    deep: typeof e == "object"
  });
  return {
    $invalid: m,
    $unwatch: _
  };
}
function Gq(t, e, n, o, i, r, a, s) {
  let {
    $lazy: l,
    $rewardEarly: d
  } = o;
  const c = () => ({}), u = z(() => {
    if (l && !n.value || d && !s.value)
      return !1;
    let f = !0;
    try {
      const m = J2(t, e, a, r);
      i.value = m, f = Q2(m);
    } catch (m) {
      i.value = m;
    }
    return f;
  });
  return {
    $unwatch: c,
    $invalid: u
  };
}
function Yq(t, e, n, o, i, r, a, s, l, d, c) {
  const u = U(!1), f = t.$params || {}, m = U(null);
  let v, _;
  t.$async ? {
    $invalid: v,
    $unwatch: _
  } = jq(t.$validator, e, u, n, o, m, i, t.$watchTargets, l, d, c) : {
    $invalid: v,
    $unwatch: _
  } = Gq(t.$validator, e, n, o, m, i, l, d);
  const w = t.$message;
  return {
    $message: Ui(w) ? z(() => w(Zl({
      $pending: u,
      $invalid: v,
      $params: Zl(f),
      $model: e,
      $response: m,
      $validator: r,
      $propertyPath: s,
      $property: a
    }))) : w || "",
    $params: f,
    $pending: u,
    $invalid: v,
    $response: m,
    $unwatch: _
  };
}
function Xq() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const e = B(t), n = Object.keys(e), o = {}, i = {}, r = {};
  let a = null;
  return n.forEach((s) => {
    const l = e[s];
    switch (!0) {
      case Ui(l.$validator):
        o[s] = l;
        break;
      case Ui(l):
        o[s] = {
          $validator: l
        };
        break;
      case s === "$validationGroups":
        a = l;
        break;
      case s.startsWith("$"):
        r[s] = l;
        break;
      default:
        i[s] = l;
    }
  }), {
    rules: o,
    nestedValidators: i,
    config: r,
    validationGroups: a
  };
}
const Kq = "__root";
function qq(t, e, n, o, i, r, a, s, l) {
  const d = Object.keys(t), c = o.get(i, t), u = U(!1), f = U(!1), m = U(0);
  if (c) {
    if (!c.$partial) return c;
    c.$unwatch(), u.value = c.$dirty.value;
  }
  const v = {
    $dirty: u,
    $path: i,
    $touch: () => {
      u.value || (u.value = !0);
    },
    $reset: () => {
      u.value && (u.value = !1);
    },
    $commit: () => {
    }
  };
  return d.length ? (d.forEach((_) => {
    v[_] = Yq(t[_], e, v.$dirty, r, a, _, n, i, l, f, m);
  }), v.$externalResults = z(() => s.value ? [].concat(s.value).map((_, w) => ({
    $propertyPath: i,
    $property: n,
    $validator: "$externalResults",
    $uid: `${i}-externalResult-${w}`,
    $message: _,
    $params: {},
    $response: null,
    $pending: !1
  })) : []), v.$invalid = z(() => {
    const _ = d.some((w) => B(v[w].$invalid));
    return f.value = _, !!v.$externalResults.value.length || _;
  }), v.$pending = z(() => d.some((_) => B(v[_].$pending))), v.$error = z(() => v.$dirty.value ? v.$pending.value || v.$invalid.value : !1), v.$silentErrors = z(() => d.filter((_) => B(v[_].$invalid)).map((_) => {
    const w = v[_];
    return Mo({
      $propertyPath: i,
      $property: n,
      $validator: _,
      $uid: `${i}-${_}`,
      $message: w.$message,
      $params: w.$params,
      $response: w.$response,
      $pending: w.$pending
    });
  }).concat(v.$externalResults.value)), v.$errors = z(() => v.$dirty.value ? v.$silentErrors.value : []), v.$unwatch = () => d.forEach((_) => {
    v[_].$unwatch();
  }), v.$commit = () => {
    f.value = !0, m.value = Date.now();
  }, o.set(i, t, v), v) : (c && o.set(i, t, v), v);
}
function Jq(t, e, n, o, i, r, a) {
  const s = Object.keys(t);
  return s.length ? s.reduce((l, d) => (l[d] = xr({
    validations: t[d],
    state: e,
    key: d,
    parentKey: n,
    resultsCache: o,
    globalConfig: i,
    instance: r,
    externalResults: a
  }), l), {}) : {};
}
function Qq(t, e, n) {
  const o = z(() => [e, n].filter((v) => v).reduce((v, _) => v.concat(Object.values(B(_))), [])), i = z({
    get() {
      return t.$dirty.value || (o.value.length ? o.value.every((v) => v.$dirty) : !1);
    },
    set(v) {
      t.$dirty.value = v;
    }
  }), r = z(() => {
    const v = B(t.$silentErrors) || [], _ = o.value.filter((w) => (B(w).$silentErrors || []).length).reduce((w, $) => w.concat(...$.$silentErrors), []);
    return v.concat(_);
  }), a = z(() => {
    const v = B(t.$errors) || [], _ = o.value.filter((w) => (B(w).$errors || []).length).reduce((w, $) => w.concat(...$.$errors), []);
    return v.concat(_);
  }), s = z(() => o.value.some((v) => v.$invalid) || B(t.$invalid) || !1), l = z(() => o.value.some((v) => B(v.$pending)) || B(t.$pending) || !1), d = z(() => o.value.some((v) => v.$dirty) || o.value.some((v) => v.$anyDirty) || i.value), c = z(() => i.value ? l.value || s.value : !1), u = () => {
    t.$touch(), o.value.forEach((v) => {
      v.$touch();
    });
  }, f = () => {
    t.$commit(), o.value.forEach((v) => {
      v.$commit();
    });
  }, m = () => {
    t.$reset(), o.value.forEach((v) => {
      v.$reset();
    });
  };
  return o.value.length && o.value.every((v) => v.$dirty) && u(), {
    $dirty: i,
    $errors: a,
    $invalid: s,
    $anyDirty: d,
    $error: c,
    $pending: l,
    $touch: u,
    $reset: m,
    $silentErrors: r,
    $commit: f
  };
}
function xr(t) {
  let {
    validations: e,
    state: n,
    key: o,
    parentKey: i,
    childResults: r,
    resultsCache: a,
    globalConfig: s = {},
    instance: l,
    externalResults: d
  } = t;
  const c = i ? `${i}.${o}` : o, {
    rules: u,
    nestedValidators: f,
    config: m,
    validationGroups: v
  } = Xq(e), _ = Fn(Fn({}, s), m), w = o ? z(() => {
    const W = B(n);
    return W ? B(W[o]) : void 0;
  }) : n, $ = Fn({}, B(d) || {}), y = z(() => {
    const W = B(d);
    return o ? W ? B(W[o]) : void 0 : W;
  }), M = qq(u, w, o, a, c, _, l, y, n), S = Jq(f, w, c, a, _, l, y), x = {};
  v && Object.entries(v).forEach((W) => {
    let [te, ie] = W;
    x[te] = {
      $invalid: O0(ie, S, "$invalid"),
      $error: O0(ie, S, "$error"),
      $pending: O0(ie, S, "$pending"),
      $errors: Bl(ie, S, "$errors"),
      $silentErrors: Bl(ie, S, "$silentErrors")
    };
  });
  const {
    $dirty: b,
    $errors: C,
    $invalid: E,
    $anyDirty: A,
    $error: T,
    $pending: k,
    $touch: L,
    $reset: V,
    $silentErrors: O,
    $commit: D
  } = Qq(M, S, r), P = o ? z({
    get: () => B(w),
    set: (W) => {
      b.value = !0;
      const te = B(n), ie = B(d);
      ie && (ie[o] = $[o]), Le(te[o]) ? te[o].value = W : te[o] = W;
    }
  }) : null;
  o && _.$autoDirty && he(w, () => {
    b.value || L();
    const W = B(d);
    W && (W[o] = $[o]);
  }, {
    flush: "sync"
  });
  async function F() {
    return L(), _.$rewardEarly && (D(), await Jt()), await Jt(), new Promise((W) => {
      if (!k.value) return W(!E.value);
      const te = he(k, () => {
        W(!E.value), te();
      });
    });
  }
  function N(W) {
    return (r.value || {})[W];
  }
  function H() {
    Le(d) ? d.value = $ : Object.keys($).length === 0 ? Object.keys(d).forEach((W) => {
      delete d[W];
    }) : Object.assign(d, $);
  }
  return Mo(Fn(Fn(Fn({}, M), {}, {
    $model: P,
    $dirty: b,
    $error: T,
    $errors: C,
    $invalid: E,
    $anyDirty: A,
    $pending: k,
    $touch: L,
    $reset: V,
    $path: c || Kq,
    $silentErrors: O,
    $validate: F,
    $commit: D
  }, r && {
    $getResultsForChild: N,
    $clearExternalResults: H,
    $validationGroups: x
  }), S));
}
class eJ {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  set(e, n, o) {
    this.storage.set(e, {
      rules: n,
      result: o
    });
  }
  checkRulesValidity(e, n, o) {
    const i = Object.keys(o), r = Object.keys(n);
    return r.length !== i.length || !r.every((s) => i.includes(s)) ? !1 : r.every((s) => n[s].$params ? Object.keys(n[s].$params).every((l) => B(o[s].$params[l]) === B(n[s].$params[l])) : !0);
  }
  get(e, n) {
    const o = this.storage.get(e);
    if (!o) return;
    const {
      rules: i,
      result: r
    } = o, a = this.checkRulesValidity(e, n, i), s = r.$unwatch ? r.$unwatch : () => ({});
    return a ? r : {
      $dirty: r.$dirty,
      $partial: !0,
      $unwatch: s
    };
  }
}
const Mi = {
  COLLECT_ALL: !0,
  COLLECT_NONE: !1
}, Vl = Symbol("vuelidate#injectChildResults"), Fl = Symbol("vuelidate#removeChildResults");
function tJ(t) {
  let {
    $scope: e,
    instance: n
  } = t;
  const o = {}, i = U([]), r = z(() => i.value.reduce((c, u) => (c[u] = B(o[u]), c), {}));
  function a(c, u) {
    let {
      $registerAs: f,
      $scope: m,
      $stopPropagation: v
    } = u;
    v || e === Mi.COLLECT_NONE || m === Mi.COLLECT_NONE || e !== Mi.COLLECT_ALL && e !== m || (o[f] = c, i.value.push(f));
  }
  n.__vuelidateInjectInstances = [].concat(n.__vuelidateInjectInstances || [], a);
  function s(c) {
    i.value = i.value.filter((u) => u !== c), delete o[c];
  }
  n.__vuelidateRemoveInstances = [].concat(n.__vuelidateRemoveInstances || [], s);
  const l = Ci(Vl, []);
  Ka(Vl, n.__vuelidateInjectInstances);
  const d = Ci(Fl, []);
  return Ka(Fl, n.__vuelidateRemoveInstances), {
    childResults: r,
    sendValidationResultsToParent: l,
    removeValidationResultsFromParent: d
  };
}
function e3(t) {
  return new Proxy(t, {
    get(e, n) {
      return typeof e[n] == "object" ? e3(e[n]) : z(() => e[n]);
    }
  });
}
let Hl = 0;
function nJ(t, e) {
  var n;
  let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  arguments.length === 1 && (o = t, t = void 0, e = void 0);
  let {
    $registerAs: i,
    $scope: r = Mi.COLLECT_ALL,
    $stopPropagation: a,
    $externalResults: s,
    currentVueInstance: l
  } = o;
  const d = l || ((n = To()) === null || n === void 0 ? void 0 : n.proxy), c = d ? d.$options : {};
  i || (Hl += 1, i = `_vuelidate_${Hl}`);
  const u = U({}), f = new eJ(), {
    childResults: m,
    sendValidationResultsToParent: v,
    removeValidationResultsFromParent: _
  } = d ? tJ({
    $scope: r,
    instance: d
  }) : {
    childResults: U({})
  };
  if (!t && c.validations) {
    const w = c.validations;
    e = U({}), ud(() => {
      e.value = d, he(() => Ui(w) ? w.call(e.value, new e3(e.value)) : w, ($) => {
        u.value = xr({
          validations: $,
          state: e,
          childResults: m,
          resultsCache: f,
          globalConfig: o,
          instance: d,
          externalResults: s || d.vuelidateExternalResults
        });
      }, {
        immediate: !0
      });
    }), o = c.validationsConfig || o;
  } else {
    const w = Le(t) || Wq(t) ? t : Mo(t || {});
    he(w, ($) => {
      u.value = xr({
        validations: $,
        state: e,
        childResults: m,
        resultsCache: f,
        globalConfig: o,
        instance: d ?? {},
        externalResults: s
      });
    }, {
      immediate: !0
    });
  }
  return d && (v.forEach((w) => w(u, {
    $registerAs: i,
    $scope: r,
    $stopPropagation: a
  })), Hr(() => _.forEach((w) => w(i)))), z(() => Fn(Fn({}, B(u.value)), m.value));
}
const oJ = /* @__PURE__ */ oe({
  name: "PInputPhoneEmail",
  __name: "PInputPhoneEmail",
  props: {
    modelValue: { default: "" },
    fieldMode: { default: "both" },
    type: { default: "email" },
    defaultCountry: { default: "RU" },
    internationalFormat: { type: Boolean, default: !1 },
    internationalFormatTimer: { default: 1e3 },
    isRequired: { type: Boolean, default: !0 },
    isLazy: { type: Boolean, default: !0 },
    requiredMessage: { default: "Поле не может быть пустым" },
    emailOrPhoneMessage: { default: "Это не похоже на email или номер телефона" },
    emailOrPhoneLabel: { default: "Email или телефон" },
    emailOrPhoneIcon: { default: null },
    emailMessage: { default: "Это не похоже на email" },
    emailLabel: { default: "Email" },
    emailIcon: { default: Td },
    phoneMessage: { default: "Это не похоже на номер телефона" },
    phoneLabel: { default: "Телефон" },
    phoneIcon: { default: Ld },
    size: { default: "medium" },
    hint: { default: "" },
    textSize: { default: "medium" },
    border: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 },
    lostFocusOnEnter: { type: Boolean, default: !1 },
    ignoreClick: { type: Boolean, default: !1 },
    maxLength: { default: 30 }
  },
  emits: ["update:modelValue", "validate:isValid", "validate:rule", "validate:phone-details", "validate:errors"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = me(n, "modelValue", o), r = U("both"), a = U(!1), s = U(!1), l = U(), d = z(() => {
      switch (r.value) {
        case "tel":
          return {
            label: n.phoneLabel,
            icon: n.phoneIcon
          };
        case "email":
          return {
            label: n.emailLabel,
            icon: n.emailIcon
          };
        default:
          return {
            label: n.emailOrPhoneLabel,
            icon: n.emailOrPhoneIcon
          };
      }
    }), c = z(() => n.fieldMode === "both" || n.fieldMode === "email" ? "email" : "tel"), u = (A) => {
      if (n.fieldMode === "email")
        return !1;
      const T = Dl(A, n.defaultCountry), k = !!(!ho.req(A) || T != null && T.isValid() && LW.test(A));
      return k ? (a.value = !0, r.value = "tel", T && (l.value = {
        phoneNumber: T,
        internationalValue: T.formatInternational()
      }, o("validate:phone-details", l.value)), o("validate:rule", r.value)) : M("tel"), o("validate:isValid", k), k;
    }, f = (A) => {
      if (n.fieldMode === "tel")
        return !1;
      const T = !ho.req(A) || DW.test(A);
      return T ? (s.value = !0, r.value = "email", l.value && (o("validate:phone-details", {
        phoneNumber: void 0,
        internationalValue: ""
      }), l.value = void 0), o("validate:rule", r.value)) : M("email"), o("validate:isValid", T), T;
    }, m = (A) => !A && !!i.value.length, v = (A, T) => {
      if (m(A)) {
        if (n.fieldMode === "both")
          return ho.withMessage(n.emailOrPhoneMessage, T);
        switch (n.fieldMode) {
          case "tel":
            return ho.withMessage(n.phoneMessage, T);
          case "email":
            return ho.withMessage(n.emailMessage, T);
          default:
            return ho.withMessage(n.emailOrPhoneMessage, T);
        }
      }
      return !1;
    }, _ = z(() => ({
      modelValue: {
        required: n.isRequired && ho.withMessage(n.requiredMessage, Hq),
        isEmail: v(a.value, f),
        isPhone: v(s.value, u),
        $lazy: n.isLazy,
        $autoDirty: !n.isLazy
      }
    })), w = nJ(_, n), $ = (A) => {
      if (A.length)
        return o("validate:errors", A), A[0].$message;
      o("validate:errors", []);
    }, y = () => {
      if (a.value) {
        const A = Dl(i.value, n.defaultCountry);
        n.internationalFormat && (A != null && A.isValid()) ? i.value = A.formatInternational() : i.value = i.value.replace(/\s/g, "");
      }
    }, M = (A) => {
      const T = {
        tel: {
          clear: () => {
            a.value = !1, l.value = void 0, o("validate:phone-details", {
              phoneNumber: void 0,
              internationalValue: ""
            });
          }
        },
        email: {
          clear: () => {
            s.value = !1;
          }
        },
        both: {
          clear: () => {
            T.email.clear(), T.tel.clear();
          }
        }
      };
      T[A].clear(), n.fieldMode === "both" && (r.value = "both"), o("validate:rule", r.value), o("validate:isValid", !n.isRequired);
    }, S = () => {
      w.value.modelValue.$touch(), y();
    }, x = () => {
      if (n.isLazy && w.value.$reset(), n.internationalFormat)
        return E();
    }, b = () => {
      n.isLazy && w.value.$reset();
    }, C = () => {
      n.isLazy && (w.value.modelValue.$touch(), w.value.$reset(), w.value.modelValue.$touch());
    }, E = bi(() => y(), n.internationalFormatTimer);
    return he(
      () => i.value,
      (A) => {
        A.length || M("both");
      }
    ), he(
      () => [n.internationalFormat, n.defaultCountry],
      () => y()
    ), he(
      () => n.fieldMode,
      (A) => {
        var T;
        M(A), (T = w.value) == null || T.$reset(), r.value = A;
      },
      {
        immediate: !0
      }
    ), (A, T) => {
      const k = l0;
      return p(), J(k, {
        modelValue: B(i),
        "onUpdate:modelValue": T[0] || (T[0] = (L) => Le(i) ? i.value = L : null),
        class: ee(["formatted-input", `formatted-input-${n.size}`]),
        autofocus: n.autofocus,
        placeholder: d.value.label,
        size: n.size,
        label: d.value.label,
        error: $(B(w).$errors),
        "max-length": n.maxLength,
        disabled: n.disabled,
        "text-size": n.textSize,
        border: n.border,
        readonly: n.readonly,
        hint: n.hint,
        "input-mode": c.value,
        type: n.type,
        "ignore-click": n.ignoreClick,
        "lost-focus-on-enter": n.lostFocusOnEnter,
        onBlur: S,
        onInput: x,
        onFocus: Ye(b, ["self"]),
        onKeyup: pd(C, ["enter"])
      }, {
        right: G(() => [
          q(Xe, { name: "slide-fade" }, {
            default: G(() => [
              (p(), J(Ce(d.value.icon), {
                class: ee(["formatted-input-icon", `formatted-input-icon-${n.size}`])
              }, null, 8, ["class"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "class", "autofocus", "placeholder", "size", "label", "error", "max-length", "disabled", "text-size", "border", "readonly", "hint", "input-mode", "type", "ignore-click", "lost-focus-on-enter"]);
    };
  }
}), iJ = /* @__PURE__ */ ae(oJ, [["__scopeId", "data-v-826f70d6"]]), rJ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, aJ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1 4.5a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z",
  "clip-rule": "evenodd"
}, null, -1), sJ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.933 3.502a1 1 0 0 1 1.065.931L5.936 17.5h8.128l.938-13.067a1 1 0 0 1 1.996.134l-.938 13.066a2 2 0 0 1-1.996 1.867H5.936a2 2 0 0 1-1.996-1.867L3.002 4.567a1 1 0 0 1 .931-1.065Z",
  "clip-rule": "evenodd"
}, null, -1), lJ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5 2.5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2a1 1 0 1 1-2 0v-2H7v2a1 1 0 0 1-2 0v-2Z",
  "clip-rule": "evenodd"
}, null, -1), dJ = [
  aJ,
  sJ,
  lJ
];
function cJ(t, e) {
  return p(), g("svg", rJ, [...dJ]);
}
const t3 = I({ name: "icon-trash-md", render: cJ }), uJ = { class: "p-input-avatar" }, hJ = ["onClick"], fJ = { class: "left-side" }, mJ = { class: "upload-text" }, pJ = { key: 0 }, _J = { key: 1 }, vJ = {
  key: 0,
  class: "loading"
}, gJ = /* @__PURE__ */ oe({
  name: "PInputAvatar",
  __name: "PInputAvatar",
  props: {
    modelValue: {},
    accept: { default: () => [".png", ".jpg", ".jpeg", "image/png", "image/jpg", "image/jpeg"] },
    loading: { type: Boolean, default: !1 },
    name: {},
    src: {},
    label: {},
    icon: {}
  },
  emits: ["update:modelValue", "change:error", "delete"],
  setup(t, { emit: e }) {
    const { t: n } = Mn({
      messages: {
        ru: {
          uploadText: "Загрузить фото",
          fileSizeLimitExceeded: "Размер фото слишком большой. Загрузите JPEG, PNG до 10 MB",
          formatImage: "Формат JPEG, PNG до 10 MB"
        },
        en: {
          uploadText: "Upload photo",
          fileSizeLimitExceeded: "Photo size is too big. Upload JPEG, PNG up to 10 MB",
          formatImage: "Format JPEG, PNG up to 10 MB"
        }
      }
    }), o = U(null), i = t, r = e, a = me(i, "modelValue", r);
    he(a, () => {
      o.value = null;
    });
    const s = (d) => {
      var c;
      !i.src && !((c = a.value) != null && c.fileContent) || (d.stopPropagation(), a.value = null, o.value = null, r("delete"));
    }, l = (d) => {
      o.value = d.errorType, r("change:error", d);
    };
    return (d, c) => {
      const u = _t, f = t3, m = Xi, v = d0;
      return p(), g("div", uJ, [
        q(v, {
          modelValue: B(a),
          "onUpdate:modelValue": c[0] || (c[0] = (_) => Le(a) ? a.value = _ : null),
          class: "input-file",
          accept: d.accept,
          "upload-limit": 10 * 1024 * 1024,
          "onChange:error": l
        }, {
          activator: G(({ selectFile: _ }) => {
            var w, $;
            return [
              h("div", {
                class: "activator",
                onClick: _
              }, [
                h("div", fJ, [
                  h("div", mJ, ne(d.label ? d.label : B(n)("uploadText")), 1),
                  h("div", {
                    class: ee(["secondary-text", { "error-text": o.value }])
                  }, [
                    o.value === B(s1).fileSizeLimitExceeded ? (p(), g("div", pJ, ne(B(n)("fileSizeLimitExceeded")), 1)) : (p(), g("div", _J, ne(B(n)("formatImage")), 1))
                  ], 2)
                ]),
                d.loading ? (p(), g("div", vJ, [
                  q(u, {
                    size: "small",
                    color: "primary"
                  })
                ])) : (p(), J(m, {
                  key: 1,
                  name: i.name,
                  src: i.src ? i.src : (w = B(a)) == null ? void 0 : w.fileContent,
                  overlay: !!(i.src || ($ = B(a)) != null && $.fileContent),
                  icon: d.icon,
                  class: "avatar",
                  size: "x-large",
                  onClick: s
                }, {
                  overlay: G(({ width: y, height: M }) => [
                    q(f, {
                      color: "white",
                      width: y,
                      height: M
                    }, null, 8, ["width", "height"])
                  ]),
                  _: 1
                }, 8, ["name", "src", "overlay", "icon"]))
              ], 8, hJ)
            ];
          }),
          _: 1
        }, 8, ["modelValue", "accept"])
      ]);
    };
  }
}), $J = /* @__PURE__ */ ae(gJ, [["__scopeId", "data-v-077066d7"]]), wJ = { class: "p-input-file-uploader" }, yJ = ["onClick"], MJ = { class: "left-side" }, CJ = { class: "upload-text" }, bJ = { key: 1 }, xJ = { key: 2 }, SJ = /* @__PURE__ */ oe({
  name: "PInputFileUploader",
  __name: "PInputFileUploader",
  props: {
    modelValue: {},
    loading: { type: Boolean },
    name: {},
    src: {},
    type: { default: "img" }
  },
  emits: ["update:modelValue", "delete"],
  setup(t, { emit: e }) {
    const { t: n } = Mn({
      messages: {
        ru: {
          img: {
            uploadText: "Загрузить фото",
            afterLoadLabel: "Загрузить другое фото",
            fileSizeLimitExceeded: "Размер фото слишком большой. Загрузите JPEG, PNG до 10 MB",
            fileTypeInvalid: "Неверный формат. Загрузите фото JPEG, PNG до 10 МБ. ",
            format: "Формат JPEG, PNG до 10 MB"
          },
          audio: {
            uploadText: "Загрузить аудио",
            afterLoadLabel: "Загрузить другое аудио",
            fileSizeLimitExceeded: "Размер аудио слишком большой. Загрузите MP3, WAV до 10 MB",
            fileTypeInvalid: "Неверный формат. Загрузите аудио MP3, WAV до 10 МБ. ",
            format: "Формат MP3, WAV до 10 MB"
          },
          video: {
            uploadText: "Загрузить видео",
            afterLoadLabel: "Загрузить другое видео",
            fileSizeLimitExceeded: "Размер видео слишком большой. Загрузите MOV, AVI, MP4 до 10 MB",
            fileTypeInvalid: "Неверный формат. Загрузите видео MOV, AVI, MP4 до 10 МБ. ",
            format: "Формат MOV, AVI, MP4 до 10 MB"
          },
          file: {
            uploadText: "Загрузить файл",
            afterLoadLabel: "Загрузить другой файл",
            fileSizeLimitExceeded: "Размер файла слишком большой. Загрузите PDF, DOCX до 10 MB",
            fileTypeInvalid: "Неверный формат. Загрузите файл PDF, DOCX до 10 MB",
            format: "Формат PDF, DOCX до 10 MB"
          }
        },
        en: {
          img: {
            uploadText: "Загрузить фото",
            afterLoadLabel: "Загрузить другое фото",
            fileSizeLimitExceeded: "Размер фото слишком большой. Загрузите JPEG, PNG до 10 MB",
            fileTypeInvalid: "Неверный формат. Загрузите фото JPEG, PNG до 10 МБ. ",
            format: "Формат JPEG, PNG до 10 MB"
          },
          audio: {
            uploadText: "Загрузить аудио",
            afterLoadLabel: "Загрузить другое аудио",
            fileSizeLimitExceeded: "Размер аудио слишком большой. Загрузите MP3, WAV до 10 MB",
            fileTypeInvalid: "Неверный формат. Загрузите аудио MP3, WAV до 10 МБ. ",
            format: "Формат MP3, WAV до 10 MB"
          },
          video: {
            uploadText: "Загрузить видео",
            afterLoadLabel: "Загрузить другое видео",
            fileSizeLimitExceeded: "Размер видео слишком большой. Загрузите MOV, AVI, MP4 до 10 MB",
            fileTypeInvalid: "Неверный формат. Загрузите видео MOV, AVI, MP4 до 10 МБ. ",
            format: "Формат MOV, AVI, MP4 до 10 MB"
          },
          file: {
            uploadText: "Загрузить файл",
            afterLoadLabel: "Загрузить другой файл",
            fileSizeLimitExceeded: "Размер файла слишком большой. Загрузите PDF, DOCX до 10 MB",
            fileTypeInvalid: "Неверный формат. Загрузите файл PDF, DOCX до 10 MB",
            format: "Формат PDF, DOCX до 10 MB"
          }
        }
      }
    }), o = U(null), i = t, r = e, a = me(i, "modelValue", r);
    he(a, () => o.value = null);
    const s = (f) => {
      var m;
      !i.src && !((m = a.value) != null && m.fileContent) || (f.stopPropagation(), a.value = null, o.value = null, r("delete"));
    }, l = (f) => o.value = f.errorType, d = U("");
    async function c() {
      var v;
      if (!((v = a == null ? void 0 : a.value) != null && v.fileContent)) return "";
      const f = document.createElement("video");
      return f.src = a.value.fileContent, f.currentTime = 0.01, f.pause(), await new Promise((_) => {
        f.onseeked = function() {
          const w = document.createElement("canvas");
          w.width = f.videoWidth, w.height = f.videoHeight, w.getContext("2d").drawImage(f, 0, 0, w.width, w.height), _(w.toDataURL());
        };
      });
    }
    const u = z(() => {
      var f;
      switch (i.type) {
        case "img":
          return {
            accept: [".png", ".jpg", ".jpeg", "image/png", "image/jpg", "image/jpeg"],
            icon: Gr,
            preview: i.src ? i.src : (f = a == null ? void 0 : a.value) == null ? void 0 : f.fileContent
          };
        case "audio":
          return {
            accept: [".mp3", ".wav", "audio/mp3", "audio/wav"],
            icon: Od,
            preview: ""
          };
        case "video":
          return {
            accept: [".mov", ".avi", ".mp4", "video/quicktime", "video/x-msvideo", "video/mp4"],
            icon: Zd,
            preview: (c().then((m) => d.value = m), d.value)
          };
        case "file":
          return {
            accept: [".pdf", ".docx", "application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
            icon: Id,
            preview: ""
          };
        default:
          return {};
      }
    });
    return (f, m) => {
      var y;
      const v = _t, _ = t3, w = Xi, $ = d0;
      return p(), g("div", wJ, [
        q($, {
          modelValue: B(a),
          "onUpdate:modelValue": m[0] || (m[0] = (M) => Le(a) ? a.value = M : null),
          class: "input-file",
          accept: (y = u.value) == null ? void 0 : y.accept,
          "upload-limit": 10 * 1024 * 1024,
          "onChange:error": l
        }, {
          activator: G(({ selectFile: M }) => {
            var S, x, b, C;
            return [
              h("div", {
                class: "activator",
                onClick: M
              }, [
                h("div", MJ, [
                  h("div", CJ, [
                    (S = B(a)) != null && S.fileContent ? Y(f.$slots, "afterLoadLabel", { key: 1 }, () => [
                      xe(ne(B(n)(`${f.type}.afterLoadLabel`)), 1)
                    ], !0) : Y(f.$slots, "label", { key: 0 }, () => [
                      xe(ne(B(n)(`${f.type}.uploadText`)), 1)
                    ], !0)
                  ]),
                  h("div", {
                    class: ee(["secondary-text", { "error-text": o.value }])
                  }, [
                    f.$slots.subtext ? Y(f.$slots, "subtext", { key: 0 }, void 0, !0) : [B(s1).fileSizeLimitExceeded, B(s1).fileTypeInvalid].includes(o.value) ? (p(), g("div", bJ, ne(B(n)(`${f.type}.${o.value}`)), 1)) : (p(), g("div", xJ, ne(B(n)(`${f.type}.format`)), 1))
                  ], 2)
                ]),
                f.loading ? (p(), J(v, {
                  key: 0,
                  size: "small",
                  color: "primary"
                })) : (p(), J(w, {
                  key: 1,
                  name: i.name,
                  src: (x = u.value) == null ? void 0 : x.preview,
                  overlay: !!(i.src || (b = B(a)) != null && b.fileContent),
                  icon: (C = u.value) == null ? void 0 : C.icon,
                  class: "avatar",
                  size: "x-large",
                  onClick: s
                }, {
                  overlay: G(({ width: E, height: A }) => [
                    q(_, {
                      color: "white",
                      width: E,
                      height: A
                    }, null, 8, ["width", "height"])
                  ]),
                  _: 1
                }, 8, ["name", "src", "overlay", "icon"]))
              ], 8, yJ)
            ];
          }),
          _: 3
        }, 8, ["modelValue", "accept"])
      ]);
    };
  }
}), IJ = /* @__PURE__ */ ae(SJ, [["__scopeId", "data-v-c9f98a55"]]), AJ = { class: "p-list-item" }, kJ = {
  key: 0,
  class: "left-content"
}, EJ = { class: "center-content" }, PJ = { class: "title" }, TJ = {
  key: 0,
  class: "subtitle"
}, OJ = {
  key: 1,
  class: "rigth-content"
}, LJ = /* @__PURE__ */ oe({
  name: "PListItem",
  __name: "PListItem",
  setup(t) {
    return (e, n) => (p(), g("div", AJ, [
      e.$slots.left ? (p(), g("div", kJ, [
        Y(e.$slots, "left", {}, void 0, !0)
      ])) : X("", !0),
      h("div", EJ, [
        h("div", PJ, [
          Y(e.$slots, "title", {}, void 0, !0)
        ]),
        e.$slots.subtitle ? (p(), g("div", TJ, [
          Y(e.$slots, "subtitle", {}, void 0, !0)
        ])) : X("", !0)
      ]),
      e.$slots.right ? (p(), g("div", OJ, [
        Y(e.$slots, "right", {}, void 0, !0)
      ])) : X("", !0)
    ]));
  }
}), DJ = /* @__PURE__ */ ae(LJ, [["__scopeId", "data-v-e34221b4"]]), NJ = { class: "p-progress-circular" }, RJ = /* @__PURE__ */ oe({
  name: "PProgressCircular",
  __name: "PProgressCircular",
  props: {
    variant: { default: "large" },
    indeterminate: { type: Boolean, default: !1 },
    progress: {}
  },
  setup(t) {
    const e = t, n = U(), o = U();
    he(
      () => e.progress,
      (a) => {
        a && r(a);
      }
    ), et(() => {
      const a = e.variant === "large" ? "18" : "10", s = e.variant === "large" ? "16" : "8", l = e.variant === "large" ? "4" : "2", d = 2 * Math.PI * Number(s), c = `${d} ${d}`, u = String(d);
      [
        {
          name: "cx",
          value: a
        },
        {
          name: "cy",
          value: a
        },
        {
          name: "stroke-width",
          value: l
        },
        {
          name: "stroke-dasharray",
          value: c
        },
        {
          name: "stroke-dashoffset",
          value: u
        },
        {
          name: "r",
          value: s
        }
      ].forEach(({ name: m, value: v }) => {
        i(n.value, m, v), i(o.value, m, v);
      });
    });
    const i = (a, s, l) => {
      a.setAttribute(s, l);
    }, r = async (a) => {
      const s = 2 * Math.PI * Number(n.value.getAttribute("r")), l = s - Number(a) / 100 * s;
      n.value.setAttribute("stroke-dashoffset", String(l < 0 ? 0 : l));
    };
    return (a, s) => (p(), g("div", NJ, [
      (p(), g("svg", {
        class: ee(["p-progress-circular-element", `variant-${a.variant}`])
      }, [
        h("circle", {
          ref_key: "progressValue",
          ref: o,
          class: "p-progress-circular-value"
        }, null, 512),
        h("circle", {
          ref_key: "progressBar",
          ref: n,
          class: ee(["p-progress-circular-bar", { indeterminate: a.indeterminate }])
        }, null, 2)
      ], 2))
    ]));
  }
}), ZJ = /* @__PURE__ */ ae(RJ, [["__scopeId", "data-v-d2bc612e"]]), BJ = { class: "p-progress-linear" }, VJ = { class: "p-progress-linear-bar" }, FJ = /* @__PURE__ */ oe({
  name: "PProgressLinear",
  __name: "PProgressLinear",
  props: {
    indeterminate: { type: Boolean, default: !1 },
    progress: {}
  },
  setup(t) {
    const e = t, n = U({});
    return he(
      () => e.progress,
      (o) => {
        o && (n.value = { width: `${o}%` });
      }
    ), (o, i) => (p(), g("div", BJ, [
      h("div", VJ, [
        h("div", {
          class: ee(["p-progress-linear-value", { indeterminate: o.indeterminate }]),
          style: en(n.value)
        }, null, 6)
      ])
    ]));
  }
}), HJ = /* @__PURE__ */ ae(FJ, [["__scopeId", "data-v-af012b52"]]), UJ = ["value", "disabled"], zJ = { class: "label" }, WJ = /* @__PURE__ */ oe({
  name: "PRadioButton",
  __name: "PRadioButton",
  props: {
    modelValue: {},
    value: {},
    label: {},
    disabled: { type: Boolean },
    labelPosition: { default: "right" },
    textSize: { default: "md" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, i = me(n, "modelValue", e), r = z(() => i.value === n.value ? Wd : zd);
    return (a, s) => (p(), g("label", {
      class: ee(["p-radio-button", `label-position-${a.labelPosition}`, `text-size-${a.textSize}`])
    }, [
      it(h("input", {
        "onUpdate:modelValue": s[0] || (s[0] = (l) => Le(i) ? i.value = l : null),
        type: "radio",
        class: "input-radio",
        value: a.value,
        disabled: a.disabled
      }, null, 8, UJ), [
        [E3, B(i)]
      ]),
      q(B(r), { class: "icon" }),
      h("div", zJ, [
        Y(a.$slots, "default", {}, () => [
          xe(ne(a.label), 1)
        ], !0)
      ])
    ], 2));
  }
}), jJ = /* @__PURE__ */ ae(WJ, [["__scopeId", "data-v-be567640"]]), GJ = /* @__PURE__ */ oe({
  name: "PStepper",
  __name: "PStepper",
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    size: { default: "small" },
    error: { type: [String, Boolean] },
    minValue: { default: 1 },
    maxValue: { default: 1 / 0 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, i = me(n, "modelValue", e), r = () => {
      i.value < n.maxValue && i.value++;
    }, a = () => {
      i.value > n.minValue && i.value--;
    };
    let s = i.value;
    const l = () => {
      if (!/^-?([1-9]\d*)?$|^0$| /y.test(String(i.value))) {
        i.value = s;
        return;
      }
      s = i.value;
    }, d = (u) => {
      const f = /(-|\d|Backspace|Enter|ArrowLeft|ArrowRight|Control|Alt)$/, m = /(ArrowUp|ArrowDown)$/;
      if (u.key === "-" && n.minValue >= 0 || !f.test(u.key) && !m.test(u.key)) {
        u.preventDefault();
        return;
      }
      if (u.key === "Enter") {
        c();
        return;
      }
      if (m.test(u.key)) {
        u.preventDefault(), u.key === "ArrowUp" ? r() : a();
        return;
      }
    }, c = () => {
      i.value > n.maxValue && (i.value = n.maxValue), i.value < n.minValue && (i.value = n.minValue);
    };
    return (u, f) => {
      const m = pa, v = vt, _ = ma, w = l0;
      return p(), g("div", {
        class: ee(["p-stepper", `size-${u.size}`])
      }, [
        q(w, {
          modelValue: B(i),
          "onUpdate:modelValue": f[2] || (f[2] = ($) => Le(i) ? i.value = $ : null),
          size: u.size,
          error: u.error,
          disabled: u.disabled,
          "lost-focus-on-enter": "",
          "show-error-text": !1,
          "input-mode": "numeric",
          type: "text",
          onInput: l,
          onKeydown: d,
          onBlur: c
        }, {
          left: G(() => [
            q(v, {
              variant: "text",
              disabled: u.disabled,
              onMousedown: f[0] || (f[0] = Ye(() => {
              }, ["prevent", "stop"])),
              onClick: a
            }, {
              default: G(() => [
                q(m)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          right: G(() => [
            q(v, {
              variant: "text",
              disabled: u.disabled,
              onMousedown: f[1] || (f[1] = Ye(() => {
              }, ["prevent", "stop"])),
              onClick: r
            }, {
              default: G(() => [
                q(_)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue", "size", "error", "disabled"])
      ], 2);
    };
  }
}), n3 = /* @__PURE__ */ ae(GJ, [["__scopeId", "data-v-46e38814"]]), YJ = (t) => (ei("data-v-c96d78be"), t = t(), ti(), t), XJ = { class: "p-range-stepper" }, KJ = { class: "steppers-container" }, qJ = /* @__PURE__ */ YJ(() => /* @__PURE__ */ h("div", { class: "divider" }, "一", -1)), JJ = {
  key: 0,
  class: "error-container"
}, QJ = /* @__PURE__ */ oe({
  name: "PRangeStepper",
  __name: "PRangeStepper",
  props: {
    modelValue: {},
    size: {},
    error: { type: [String, Boolean] }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = me(t, "modelValue", e);
    return (r, a) => {
      const s = n3;
      return p(), g("div", XJ, [
        h("div", KJ, [
          q(s, {
            modelValue: B(i).from,
            "onUpdate:modelValue": a[0] || (a[0] = (l) => B(i).from = l),
            size: r.size,
            error: !!r.error
          }, null, 8, ["modelValue", "size", "error"]),
          qJ,
          q(s, {
            modelValue: B(i).to,
            "onUpdate:modelValue": a[1] || (a[1] = (l) => B(i).to = l),
            size: r.size,
            error: !!r.error
          }, null, 8, ["modelValue", "size", "error"])
        ]),
        r.error ? (p(), g("div", JJ, ne(r.error), 1)) : X("", !0)
      ]);
    };
  }
}), eQ = /* @__PURE__ */ ae(QJ, [["__scopeId", "data-v-c96d78be"]]);
var f0 = /* @__PURE__ */ ((t) => (t.static = "static", t.dynamic = "dynamic", t))(f0 || {});
const xne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ModeTypes: f0
}, Symbol.toStringTag, { value: "Module" })), tQ = { class: "left-side" }, nQ = { class: "inline" }, oQ = { key: 0 }, iQ = {
  key: 0,
  class: "item-text"
}, rQ = {
  key: 0,
  class: "item-wrapper"
}, aQ = { class: "item-text" }, sQ = /* @__PURE__ */ oe({
  name: "PSideBarItem",
  __name: "PSideBarItem",
  props: {
    item: {},
    active: { type: Boolean },
    collapsed: { type: Boolean },
    padding: {},
    mode: {}
  },
  setup(t) {
    const e = t, n = z(() => e.item.href ? "a" : e.item.to ? e1("RouterLink") : "div"), o = z(() => f0.static === e.mode);
    return (i, r) => {
      const a = Ra;
      return p(), g("div", {
        class: ee(["p-side-bar-item", { static: o.value, opened: !i.collapsed }])
      }, [
        (p(), J(a, {
          key: i.item.value,
          placement: "right",
          class: "item-hint"
        }, Pn({
          activator: G(({ setReference: s, onHover: l, outHover: d }) => [
            (p(), J(Ce(n.value), {
              ref: s,
              to: i.item.to,
              href: i.item.href,
              target: i.item.target || "_self",
              class: ee([`item ${i.padding}`, { active: i.active, disabled: i.item.disabled, [`color-${i.item.color}`]: i.item.color }]),
              onMouseover: (c) => i.collapsed && !o.value && l(c),
              onMouseleave: d,
              onClick: i.item.onClick
            }, {
              default: G(() => [
                h("div", tQ, [
                  h("div", nQ, [
                    !i.item.disabled && i.item.indicatorColor ? (p(), g("div", {
                      key: 0,
                      class: ee([`indicator ${i.item.indicatorColor}`])
                    }, null, 2)) : X("", !0),
                    Y(i.$slots, "left-side-item", {}, () => [
                      typeof i.item.icon == "string" ? (p(), g("div", oQ, ne(i.item.icon), 1)) : (p(), J(Ce(i.item.icon), { key: 1 }))
                    ], !0)
                  ]),
                  o.value && i.item.text ? (p(), g("div", iQ, ne(i.item.text), 1)) : X("", !0)
                ]),
                q(Xe, { name: "fade" }, {
                  default: G(() => [
                    i.item.text && !i.collapsed ? (p(), g("div", rQ, [
                      h("div", aQ, ne(i.item.text), 1),
                      Y(i.$slots, "right-side-item", {}, void 0, !0)
                    ])) : X("", !0)
                  ]),
                  _: 3
                })
              ]),
              _: 2
            }, 1064, ["to", "href", "target", "class", "onMouseover", "onMouseleave", "onClick"]))
          ]),
          _: 2
        }, [
          i.item.text ? {
            name: "hint",
            fn: G(() => [
              xe(ne(i.item.text), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1024))
      ], 2);
    };
  }
}), lQ = /* @__PURE__ */ ae(sQ, [["__scopeId", "data-v-1f34786e"]]), dQ = {
  key: 0,
  class: "icon"
}, cQ = {
  key: 2,
  class: "text"
}, uQ = /* @__PURE__ */ oe({
  name: "PSideBarGroupItem",
  __name: "PSideBarGroupItem",
  props: {
    item: {},
    active: { type: Boolean }
  },
  setup(t) {
    const e = t, n = z(() => e.item.href ? "a" : e.item.to ? e1("RouterLink") : "div");
    return (o, i) => (p(), J(Ce(n.value), {
      class: ee(["p-sidebar-group-item", { active: o.active, disabled: o.item.disabled, [`color-${o.item.color}`]: o.item.color }]),
      disabled: o.item.disabled,
      to: o.item.to,
      href: o.item.href,
      target: o.item.target,
      onClick: Ye(o.item.onClick, ["stop"])
    }, {
      default: G(() => [
        typeof o.item.icon == "string" ? (p(), g("div", dQ, ne(o.item.icon), 1)) : (p(), J(Ce(o.item.icon), {
          key: 1,
          class: "icon"
        })),
        o.item.text ? (p(), g("div", cQ, ne(o.item.text), 1)) : X("", !0)
      ]),
      _: 1
    }, 8, ["class", "disabled", "to", "href", "target", "onClick"]));
  }
}), hQ = /* @__PURE__ */ ae(uQ, [["__scopeId", "data-v-86d1dfd3"]]), fQ = { class: "p-sidebar-group" }, mQ = ["onMouseover", "onMouseleave"], pQ = { class: "left-side" }, _Q = { key: 0 }, vQ = {
  key: 0,
  class: "wrapper"
}, gQ = { class: "text" }, $Q = {
  key: 0,
  class: "group-items"
}, wQ = /* @__PURE__ */ oe({
  name: "PSideBarGroup",
  __name: "PSideBarGroup",
  props: {
    group: {},
    collapsed: { type: Boolean },
    selected: {},
    isMobile: { type: Boolean },
    padding: {}
  },
  emits: ["click:group-item"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = U(!1), r = z(() => {
      var l;
      return (l = n.group.items) == null ? void 0 : l.some(({ value: d }) => d === n.selected);
    }), a = () => {
      n.group.disabled || (o("click:group-item", n.group), !(n.collapsed && i.value) && (i.value = !i.value));
    }, s = (l) => {
      if (l.disabled)
        return !1;
      o("click:group-item", l);
    };
    return (l, d) => {
      const c = La, u = Ra;
      return p(), g("div", fQ, [
        q(u, {
          placement: "right",
          class: "group-hint"
        }, Pn({
          activator: G(({ setReference: f, onHover: m, outHover: v }) => [
            h("div", {
              ref: f,
              class: ee([
                "accordeon",
                l.padding,
                {
                  opened: i.value,
                  active: r.value && (l.collapsed || !i.value),
                  disabled: l.group.disabled,
                  [`color-${l.group.color}`]: l.group.color
                }
              ]),
              onClick: a,
              onMouseover: (_) => l.collapsed && m(_),
              onMouseleave: v
            }, [
              h("div", pQ, [
                l.group.icon ? (p(), g(_e, { key: 0 }, [
                  typeof l.group.icon == "string" ? (p(), g("div", _Q, ne(l.group.icon), 1)) : (p(), J(Ce(l.group.icon), {
                    key: 1,
                    class: "icon"
                  }))
                ], 64)) : X("", !0)
              ]),
              q(Xe, { name: "fade" }, {
                default: G(() => [
                  l.group.text && !l.collapsed ? (p(), g("div", vQ, [
                    h("div", gQ, ne(l.group.text), 1),
                    q(c, {
                      class: ee(["toggler", { opened: i.value }])
                    }, null, 8, ["class"])
                  ])) : X("", !0)
                ]),
                _: 1
              })
            ], 42, mQ),
            q(Br, { name: "fade" }, {
              default: G(() => [
                !l.collapsed && i.value ? (p(), g("div", $Q, [
                  (p(!0), g(_e, null, Ie(l.group.items, (_) => (p(), J(hQ, {
                    key: _.value,
                    item: _,
                    "group-name": l.group.value,
                    active: _.value === l.selected,
                    onClick: Ye((w) => s(_), ["stop"])
                  }, null, 8, ["item", "group-name", "active", "onClick"]))), 128))
                ])) : X("", !0)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, [
          l.group.text ? {
            name: "hint",
            fn: G(() => [
              xe(ne(l.group.text), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1024)
      ]);
    };
  }
}), yQ = /* @__PURE__ */ ae(wQ, [["__scopeId", "data-v-4b93d10f"]]), MQ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, CQ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.293 15.293a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6a1 1 0 0 0-1.414 1.414L8.586 10l-5.293 5.293Zm6 0a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6a1 1 0 0 0-1.414 1.414L14.586 10l-5.293 5.293Z",
  "clip-rule": "evenodd"
}, null, -1), bQ = [
  CQ
];
function xQ(t, e) {
  return p(), g("svg", MQ, [...bQ]);
}
const SQ = I({ name: "icon-arrow-double-right-md", render: xQ }), IQ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}, AQ = /* @__PURE__ */ h("rect", {
  width: "32",
  height: "32",
  fill: "currentColor",
  rx: "6.4"
}, null, -1), kQ = ["clip-path"], EQ = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "m27.2 16-2.783-3.733a15.16 15.16 0 0 1-8.814 2.817c-2.916 0-5.766-.852-8.218-2.424l-2.584 3.865c3.18 2.096 6.958 3.21 10.802 3.21 4.242 0 8.218-1.31 11.598-3.734Z"
}, null, -1), PQ = [
  EQ
], TQ = ["id"], OQ = /* @__PURE__ */ h("path", {
  fill: "#fff",
  d: "M4.8 4.8h22.4v22.4H4.8z"
}, null, -1), LQ = [
  OQ
];
function DQ(t, e) {
  return p(), g("svg", IQ, [
    AQ,
    h("g", {
      "clip-path": "url(#" + t.idMap.a + ")"
    }, [...PQ], 8, kQ),
    h("defs", null, [
      h("clipPath", {
        id: t.idMap.a
      }, [...LQ], 8, TQ)
    ])
  ]);
}
const NQ = I({ name: "icon-product-logo", render: DQ, data() {
  return { idMap: { a: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), RQ = { class: "header" }, ZQ = { class: "header-default" }, BQ = { class: "menu" }, Ul = "256px", zl = "480px", Wl = "52px", VQ = /* @__PURE__ */ oe({
  name: "PSideBar",
  __name: "index",
  props: {
    opened: { type: Boolean },
    selected: {},
    items: {},
    title: {},
    padding: { default: "medium" },
    product: {},
    mode: { default: "dynamic" }
  },
  emits: ["update:selected", "update:opened", "click:item"],
  setup(t, { emit: e }) {
    Nn((x) => ({
      "705366e8": Wl,
      "4cd42fb5": zl
    }));
    const n = t, o = e, i = me(n, "selected", o), r = me(n, "opened", o), { tabletUp: a } = nt(), s = U(Ul), l = U(null), { x: d, isDragging: c } = Y3(l, { preventDefault: !0 });
    he(d, () => {
      d.value < parseFloat(Ul) || d.value > parseFloat(zl) || (s.value = `${d.value}px`);
    });
    const u = U({ transform: "", transition: "" }), f = U(), { direction: m, lengthX: v, isSwiping: _ } = Wr(f, {
      threshold: 0,
      onSwipe() {
        m.value === "left" && (u.value.transform = `translateX(${-v.value}px)`);
      },
      onSwipeEnd() {
        var x, b;
        if (m.value === "left") {
          if (v.value < Number((x = f.value) == null ? void 0 : x.offsetWidth) / 3) {
            u.value.transform = "";
            return;
          }
          u.value.transition = "all 0.2s ease", u.value.transform = `translateX(${-Number((b = f.value) == null ? void 0 : b.offsetWidth)}px)`, Jt(() => {
            u.value.transform = "", u.value.transition = "", r.value = !1;
          });
        }
      }
    }), w = () => r.value = !1, $ = (x) => {
      var b;
      x.disabled || (i.value = x.value, o("click:item", x), a.value && ((b = x.items) != null && b.length) && (r.value = !0));
    }, y = z(() => f0.static === n.mode), M = z(() => {
      const x = a.value ? { minWidth: r.value ? s.value : Wl } : {};
      return { ...u.value, ...x };
    }), S = (x, { templateBy: b = "" }) => [x, b].filter(Boolean).join("-");
    return (x, b) => {
      const C = NQ, E = SQ, A = yQ, T = lQ;
      return p(), g(_e, null, [
        q(Xe, {
          name: "fade",
          appear: ""
        }, {
          default: G(() => [
            !B(a) && B(r) ? (p(), g("div", {
              key: 0,
              class: "overlay",
              onClick: w
            })) : X("", !0)
          ]),
          _: 1
        }),
        q(Xe, { name: "slide-left" }, {
          default: G(() => [
            B(a) || !B(a) && B(r) ? (p(), g("div", {
              key: 0,
              ref_key: "sidebar",
              ref: f,
              class: ee([
                `p-side-bar padding-${x.padding}`,
                { opened: B(r), static: y.value, mobile: !B(a), "no-transition": B(c) || B(_) }
              ]),
              style: en(M.value)
            }, [
              h("div", RQ, [
                Y(x.$slots, "header", {}, () => [
                  h("div", ZQ, [
                    h("div", {
                      class: ee(["header-title", { static: y.value }])
                    }, [
                      n.product || y.value ? (p(), J(C, {
                        key: 0,
                        class: ee(["header-logo", n.product])
                      }, null, 8, ["class"])) : X("", !0),
                      n.title && !y.value ? (p(), g(_e, { key: 1 }, [
                        xe(ne(x.title), 1)
                      ], 64)) : X("", !0)
                    ], 2),
                    y.value ? X("", !0) : (p(), g("div", {
                      key: 0,
                      class: "button-toggle",
                      onClick: b[0] || (b[0] = (k) => r.value = !B(r))
                    }, [
                      q(E)
                    ]))
                  ])
                ], !0)
              ]),
              h("div", BQ, [
                (p(!0), g(_e, null, Ie(x.items.menu, (k) => (p(), g(_e, null, [
                  k === "divider" ? (p(), g("div", {
                    key: k,
                    class: "divider"
                  })) : k.items ? (p(), J(A, {
                    key: `group-${k.value}`,
                    selected: B(i),
                    padding: x.padding,
                    group: k,
                    "is-mobile": !B(a),
                    collapsed: !B(r),
                    "onClick:groupItem": b[1] || (b[1] = (L) => $(L))
                  }, null, 8, ["selected", "padding", "group", "is-mobile", "collapsed"])) : (p(), J(T, {
                    key: k.value,
                    item: k,
                    collapsed: !B(r),
                    active: B(i) === k.value,
                    padding: x.padding,
                    mode: x.mode,
                    onClick: (L) => $(k)
                  }, {
                    "left-side-item": G(() => [
                      Y(x.$slots, S("left-side-item", k), { item: k }, void 0, !0)
                    ]),
                    "right-side-item": G(() => [
                      Y(x.$slots, "right-side-item", { item: k }, void 0, !0)
                    ]),
                    _: 2
                  }, 1032, ["item", "collapsed", "active", "padding", "mode", "onClick"]))
                ], 64))), 256))
              ]),
              x.items.bottom ? (p(), g("div", {
                key: 0,
                class: ee(["footer", { single: x.items.bottom.length === 1 }])
              }, [
                (p(!0), g(_e, null, Ie(x.items.bottom, (k, L) => (p(), g(_e, null, [
                  k === "divider" ? (p(), g("div", {
                    key: `divider-${L}`,
                    class: "divider"
                  })) : (p(), J(T, {
                    key: k.value,
                    item: k,
                    collapsed: !B(r),
                    padding: x.padding,
                    mode: x.mode,
                    class: "bottom-item",
                    onClick: (V) => $(k)
                  }, {
                    "left-side-item": G(() => [
                      Y(x.$slots, S("bottom-left", k), { item: k }, void 0, !0)
                    ]),
                    "right-side-item": G(() => [
                      Y(x.$slots, S("bottom-right", k), { item: k }, void 0, !0)
                    ]),
                    _: 2
                  }, 1032, ["item", "collapsed", "padding", "mode", "onClick"]))
                ], 64))), 256))
              ], 2)) : X("", !0),
              B(a) ? (p(), g("div", {
                key: 1,
                ref_key: "resizeSide",
                ref: l,
                class: "resize-side"
              }, null, 512)) : X("", !0)
            ], 6)) : X("", !0)
          ]),
          _: 3
        })
      ], 64);
    };
  }
}), FQ = /* @__PURE__ */ ae(VQ, [["__scopeId", "data-v-16476152"]]), HQ = {
  key: 0,
  class: "p-side-page-header"
}, UQ = {
  key: 1,
  class: "p-side-page-footer"
}, zQ = /* @__PURE__ */ oe({
  name: "PSidePage",
  __name: "PSidePage",
  props: {
    modelValue: { type: Boolean },
    maxWidth: {},
    maxHeight: {},
    left: { type: Boolean },
    fullscreen: { type: Boolean },
    fullscreenMobile: { type: Boolean },
    closeOnClickOutside: { type: Boolean, default: !0 },
    loading: { type: Boolean },
    hideOverlay: { type: Boolean },
    autoHeight: { type: Boolean },
    to: { default: ".p-teleport-container" },
    noPadding: { type: Boolean }
  },
  emits: ["update:modelValue", "click:outside"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = me(n, "modelValue", o), { tabletUp: r } = nt(), a = U(!1);
    et(() => {
      a.value = !0;
    });
    const s = z(() => i.value && !n.fullscreen), l = z(() => n.left ? "slide-left" : "slide-right"), d = z(() => n.fullscreenMobile ?? n.fullscreen), c = z(() => n.fullscreen ? "" : `${n.maxWidth}px`), u = () => {
      if (!n.closeOnClickOutside) {
        o("click:outside");
        return;
      }
      i.value = !1;
    };
    return (f, m) => {
      const v = _t, _ = Ki;
      return p(), g(_e, null, [
        a.value && B(r) ? (p(), J(c1, {
          key: 0,
          to: f.to
        }, [
          h("div", P3({ class: "p-side-page" }, f.$attrs), [
            q(Xe, {
              name: "fade",
              appear: ""
            }, {
              default: G(() => [
                s.value ? (p(), g("div", {
                  key: 0,
                  class: ee(["p-side-page-overlay", { hidden: f.hideOverlay }]),
                  onClick: u
                }, null, 2)) : X("", !0)
              ]),
              _: 1
            }),
            q(Xe, {
              name: l.value,
              appear: ""
            }, {
              default: G(() => [
                B(i) ? (p(), g("div", {
                  key: 0,
                  class: ee(["p-side-page-wrapper", { left: f.left, fullscreen: f.fullscreen }]),
                  style: en({ "max-width": c.value })
                }, [
                  f.$slots.header ? (p(), g("div", HQ, [
                    Y(f.$slots, "header", {}, void 0, !0)
                  ])) : X("", !0),
                  h("div", {
                    class: ee(["p-side-page-content", { "no-padding": f.noPadding }])
                  }, [
                    f.loading ? (p(), J(v, {
                      key: 0,
                      absolute: ""
                    })) : Y(f.$slots, "default", { key: 1 }, void 0, !0)
                  ], 2),
                  f.$slots.footer ? (p(), g("div", UQ, [
                    Y(f.$slots, "footer", {}, void 0, !0)
                  ])) : X("", !0)
                ], 6)) : X("", !0)
              ]),
              _: 3
            }, 8, ["name"])
          ], 16)
        ], 8, ["to"])) : X("", !0),
        a.value && !B(r) ? (p(), J(_, {
          key: 1,
          modelValue: B(i),
          "onUpdate:modelValue": m[0] || (m[0] = (w) => Le(i) ? i.value = w : null),
          loading: f.loading,
          fullscreen: d.value,
          "max-height": f.maxHeight,
          "close-on-click-outside": f.closeOnClickOutside,
          "auto-height": f.autoHeight,
          "no-padding": f.noPadding,
          to: f.to,
          "onClick:outside": m[1] || (m[1] = (w) => o("click:outside"))
        }, {
          header: G(() => [
            Y(f.$slots, "header", {}, void 0, !0)
          ]),
          footer: G(() => [
            Y(f.$slots, "footer", {}, void 0, !0)
          ]),
          default: G(() => [
            Y(f.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["modelValue", "loading", "fullscreen", "max-height", "close-on-click-outside", "auto-height", "no-padding", "to"])) : X("", !0)
      ], 64);
    };
  }
}), WQ = /* @__PURE__ */ ae(zQ, [["__scopeId", "data-v-ec65a371"]]), jQ = (t) => (ei("data-v-d8f86878"), t = t(), ti(), t), GQ = ["disabled"], YQ = /* @__PURE__ */ jQ(() => /* @__PURE__ */ h("div", { class: "track" }, [
  /* @__PURE__ */ h("div", { class: "thumb" })
], -1)), XQ = {
  key: 0,
  class: "text"
}, KQ = /* @__PURE__ */ oe({
  name: "PSwitch",
  __name: "PSwitch",
  props: {
    label: {},
    labelPosition: { default: "right" },
    modelValue: { type: Boolean },
    disabled: { type: Boolean },
    textSize: { default: "md" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = me(t, "modelValue", e);
    return (r, a) => (p(), g("div", {
      class: ee(["p-switch", `text-size-${r.textSize}`, { disabled: r.disabled }]),
      onMousedown: a[1] || (a[1] = Ye(() => {
      }, ["prevent"]))
    }, [
      h("label", {
        class: ee(["p-switch-label", `label-position-${r.labelPosition}`, { active: B(i), disabled: r.disabled }])
      }, [
        it(h("input", {
          "onUpdate:modelValue": a[0] || (a[0] = (s) => Le(i) ? i.value = s : null),
          type: "checkbox",
          class: "input-switch",
          disabled: r.disabled
        }, null, 8, GQ), [
          [md, B(i)]
        ]),
        YQ,
        r.label ? (p(), g("div", XQ, ne(r.label), 1)) : X("", !0)
      ], 2)
    ], 34));
  }
}), qQ = /* @__PURE__ */ ae(KQ, [["__scopeId", "data-v-d8f86878"]]), JQ = ["tabindex", "onClick"], QQ = {
  key: 1,
  class: "title-text"
}, eee = /* @__PURE__ */ oe({
  name: "PTabs",
  __name: "PTabs",
  props: {
    modelValue: {},
    tabs: { default: () => [] },
    maxWidth: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    Nn((s) => ({
      "39fd3c7f": n.tabs.length
    }));
    const n = t, i = me(n, "modelValue", e), r = z(() => ({ maxWidth: n.maxWidth })), a = (s, l) => {
      s.currentTarget.blur(), i.value = l;
    };
    return (s, l) => (p(), g("div", {
      class: "p-tabs",
      style: en({ ...r.value })
    }, [
      (p(!0), g(_e, null, Ie(n.tabs, (d, c) => (p(), g("button", {
        key: d.value,
        class: ee(["p-tab", { active: d.value === B(i), disabled: d.disabled }]),
        tabindex: d.disabled ? c : void 0,
        onClick: (u) => a(u, d.value)
      }, [
        d.icon ? (p(), J(Ce(d.icon), {
          key: 0,
          class: ee(["icon", { "icon-left": !!d.title }])
        }, null, 8, ["class"])) : X("", !0),
        d.title ? (p(), g("div", QQ, ne(d.title), 1)) : X("", !0),
        d.iconRight ? (p(), J(Ce(d.iconRight), {
          key: 2,
          class: "icon icon-right"
        })) : X("", !0)
      ], 10, JQ))), 128))
    ], 4));
  }
}), tee = /* @__PURE__ */ ae(eee, [["__scopeId", "data-v-2774fd36"]]), nee = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, oee = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  d: "M12.546 11.334 9.212 8l3.334-3.334a.857.857 0 1 0-1.213-1.212L8 6.788 4.666 3.454a.857.857 0 1 0-1.212 1.212L6.788 8l-3.334 3.334a.857.857 0 1 0 1.212 1.212L8 9.212l3.333 3.334a.857.857 0 0 0 1.213-1.212Z"
}, null, -1), iee = [
  oee
];
function ree(t, e) {
  return p(), g("svg", nee, [...iee]);
}
const o3 = I({ name: "icon-cross-sm", render: ree }), aee = {
  key: 0,
  class: "content"
}, see = /* @__PURE__ */ oe({
  name: "PTag",
  __name: "index",
  props: {
    color: { default: "black" },
    text: { default: "" },
    closable: { type: Boolean, default: !1 }
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    const n = e;
    return (o, i) => {
      const r = o3, a = vt;
      return p(), g("div", {
        class: ee(["p-tag", `color-${o.color}`])
      }, [
        o.text || o.$slots.default ? (p(), g("div", aee, [
          Y(o.$slots, "default", {}, () => [
            xe(ne(o.text), 1)
          ], !0)
        ])) : X("", !0),
        Y(o.$slots, "right", {}, () => [
          o.closable ? (p(), J(a, {
            key: 0,
            variant: "text",
            color: "secondary-white",
            onClick: i[0] || (i[0] = (s) => n("close"))
          }, {
            default: G(() => [
              q(r)
            ]),
            _: 1
          })) : X("", !0)
        ], !0)
      ], 2);
    };
  }
}), lee = /* @__PURE__ */ ae(see, [["__scopeId", "data-v-60e13c74"]]), dee = { class: "p-teleport-container" }, cee = /* @__PURE__ */ oe({
  name: "PTeleportContainer",
  __name: "PTeleportContainer",
  setup(t) {
    return (e, n) => (p(), g("div", dee));
  }
}), uee = /* @__PURE__ */ ae(cee, [["__scopeId", "data-v-31f5e7cc"]]), hee = ["rows", "placeholder", "disabled", "readonly", "maxlength", "autofocus"], fee = /* @__PURE__ */ oe({
  name: "PTextarea",
  __name: "PTextarea",
  props: {
    modelValue: {},
    label: {},
    placeholder: {},
    rows: { default: 1 },
    maxHeight: { default: "auto" },
    maxLength: {},
    error: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    autoGrow: { type: Boolean },
    autofocus: { type: Boolean },
    textSize: {}
  },
  emits: ["update:modelValue", "blur"],
  setup(t, { expose: e, emit: n }) {
    const o = t, i = n, r = me(o, "modelValue", i), { textarea: a, input: s } = Q3({ input: r }), l = z(() => {
      const m = getComputedStyle(a.value).getPropertyValue("line-height");
      return `${Number(o.rows) * parseFloat(m)}px`;
    });
    he(
      [a, () => [o.rows, o.autoGrow, o.maxHeight]],
      () => {
        a.value && (o.maxHeight === "auto" && (o.autoGrow || (a.value.style.maxHeight = l.value)), o.rows && (a.value.style.minHeight = l.value));
      },
      { immediate: !0 }
    );
    const d = U(!1), c = z(() => d.value || !o.label), u = () => {
      var m;
      d.value = !0, (m = a.value) == null || m.focus();
    }, f = (m) => {
      d.value = !1, i("blur", m);
    };
    return et(() => {
      o.autofocus && u();
    }), e({ focus: u, active: d }), (m, v) => {
      const _ = Oa;
      return p(), J(_, {
        class: "p-textarea",
        multiline: "",
        value: B(r),
        error: m.error,
        active: !m.readonly && d.value,
        disabled: m.disabled,
        "text-size": m.textSize,
        readonly: m.readonly,
        "onClick:control": u
      }, {
        left: G(() => [
          Y(m.$slots, "left")
        ]),
        value: G(() => [
          it(h("textarea", {
            ref_key: "textarea",
            ref: a,
            "onUpdate:modelValue": v[0] || (v[0] = (w) => Le(s) ? s.value = w : null),
            rows: m.rows,
            style: en({ maxHeight: m.maxHeight }),
            placeholder: c.value ? m.placeholder : m.label,
            disabled: m.disabled,
            readonly: m.readonly,
            maxlength: m.maxLength,
            autofocus: m.autofocus,
            onFocus: Ye(u, ["stop"]),
            onBlur: f
          }, null, 44, hee), [
            [T3, B(s)]
          ])
        ]),
        right: G(() => [
          Y(m.$slots, "right")
        ]),
        _: 3
      }, 8, ["value", "error", "active", "disabled", "text-size", "readonly"]);
    };
  }
}), mee = ["src"], pee = { class: "content" }, _ee = { class: "content-text" }, vee = {
  key: 0,
  class: "content-actions"
}, gee = /* @__PURE__ */ oe({
  name: "PToast",
  __name: "PToast",
  props: {
    color: { default: "default" },
    text: {},
    image: {},
    timer: {},
    actions: {}
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    const { tabletUp: n } = nt(), o = e;
    return (i, r) => {
      const a = vt, s = Gi;
      return p(), g("div", {
        class: ee(["p-toast", `color-${i.color}`, { desktop: B(n) }])
      }, [
        i.image ? (p(), g("img", {
          key: 0,
          src: i.image,
          class: "image"
        }, null, 8, mee)) : X("", !0),
        h("div", pee, [
          h("div", _ee, ne(i.text), 1),
          i.actions ? (p(), g("div", vee, [
            (p(!0), g(_e, null, Ie(i.actions, (l) => (p(), g("div", {
              key: l.name,
              class: "content-action"
            }, [
              q(a, {
                size: "x-small",
                color: "secondary-white",
                onClick: Ye(l.action, ["stop"])
              }, {
                default: G(() => [
                  xe(ne(l.name), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))), 128))
          ])) : X("", !0)
        ]),
        q(a, {
          class: "button-close",
          variant: "text",
          color: "secondary-white",
          onClick: r[0] || (r[0] = (l) => o("close"))
        }, {
          default: G(() => [
            q(s)
          ]),
          _: 1
        })
      ], 2);
    };
  }
}), i3 = /* @__PURE__ */ ae(gee, [["__scopeId", "data-v-e80a15d2"]]), $ee = /* @__PURE__ */ oe({
  name: "PToastContainer",
  __name: "PToastContainer",
  setup(t) {
    const { tabletUp: e } = nt(), { toasts: n, closeToast: o } = _ne(), { isIosApp: i } = p0(), r = (a) => {
      o(a);
    };
    return (a, s) => {
      const l = i3;
      return p(), J(Br, {
        class: ee(["p-toast-container", { desktop: B(e) }]),
        tag: "div",
        name: "show-toast",
        "data-ios-app": B(i)
      }, {
        default: G(() => [
          (p(!0), g(_e, null, Ie(B(n), ([d, c]) => (p(), J(l, {
            key: d,
            color: c.color,
            text: c.text,
            image: c.image,
            actions: c.actions,
            onClose: (u) => r(d)
          }, null, 8, ["color", "text", "image", "actions", "onClose"]))), 128))
        ]),
        _: 1
      }, 8, ["class", "data-ios-app"]);
    };
  }
}), wee = /* @__PURE__ */ ae($ee, [["__scopeId", "data-v-d0aaa1c3"]]), yee = /* @__PURE__ */ oe({
  __name: "BaseModal",
  props: {
    modelValue: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, o = e, { mobile: i } = nt(), r = U(), a = me(n, "modelValue", o);
    return he(a, () => {
      document.documentElement.style.overflow = `${a.value ? "hidden" : "visible"}`;
    }), D1(r, () => {
      a.value = !1;
    }), (s, l) => B(a) ? (p(), J(c1, {
      key: 0,
      to: ".p-teleport-container"
    }, [
      h("div", {
        class: ee(["base-modal", [s.$attrs.class, { mobile: B(i), opened: B(a) }]])
      }, [
        h("div", {
          class: "overlay",
          onClick: l[0] || (l[0] = (d) => a.value = !1)
        }),
        h("div", {
          ref_key: "container",
          ref: r,
          class: "container"
        }, [
          Y(s.$slots, "default", {}, void 0, !0)
        ], 512)
      ], 2)
    ])) : X("", !0);
  }
}), Mee = /* @__PURE__ */ ae(yee, [["__scopeId", "data-v-4966b446"]]), Cee = { class: "p-tooltip-mobile" }, bee = { class: "modal" }, xee = { class: "content" }, See = { class: "title" }, Iee = { class: "text" }, Aee = /* @__PURE__ */ oe({
  name: "PTooltipMobile",
  __name: "PTooltipMobile",
  props: {
    modelValue: { type: Boolean, default: !1 },
    title: { default: "" },
    text: { default: "" },
    buttonText: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, o = e, { t: i } = Mn({
      messages: {
        ru: {
          buttonText: "Понятно"
        },
        en: {
          buttonText: "Got it"
        }
      }
    }), r = me(n, "modelValue", o), a = () => {
      r.value = !0;
    }, s = () => {
      r.value = !1;
    };
    return (l, d) => {
      const c = vt, u = Mee;
      return p(), g("div", Cee, [
        h("div", {
          class: "activator",
          onClick: a
        }, [
          Y(l.$slots, "activator", {}, void 0, !0)
        ]),
        q(u, {
          modelValue: B(r),
          "onUpdate:modelValue": d[0] || (d[0] = (f) => Le(r) ? r.value = f : null)
        }, {
          default: G(() => [
            h("div", bee, [
              h("div", xee, [
                h("div", See, [
                  Y(l.$slots, "title", {}, () => [
                    xe(ne(l.title), 1)
                  ], !0)
                ]),
                h("div", Iee, [
                  Y(l.$slots, "text", {}, () => [
                    xe(ne(l.text), 1)
                  ], !0)
                ])
              ]),
              q(c, {
                class: "button",
                color: "secondary",
                onClick: s
              }, {
                default: G(() => [
                  Y(l.$slots, "button-text", {}, () => [
                    xe(ne(B(i)("buttonText")), 1)
                  ], !0)
                ]),
                _: 3
              })
            ])
          ]),
          _: 3
        }, 8, ["modelValue"])
      ]);
    };
  }
}), kee = /* @__PURE__ */ ae(Aee, [["__scopeId", "data-v-aa54a500"]]), Eee = { class: "p-tooltip-desktop" }, Pee = {
  key: 0,
  class: "title"
}, Tee = {
  key: 1,
  class: "text"
}, Oee = /* @__PURE__ */ oe({
  name: "PTooltipDesktop",
  __name: "PTooltipDesktop",
  props: {
    placement: { default: "bottom-end" },
    modelValue: { type: Boolean, default: !1 },
    title: { default: "" },
    text: { default: "" },
    buttonText: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, i = me(n, "modelValue", e), r = U(), a = U();
    D1(a, () => {
      i.value = !1;
    });
    const s = z(() => s0(r, a, {
      placement: n.placement,
      strategy: "fixed",
      middleware: [Y1(8), a0({ fallbackAxisSideDirection: "end" }), r0()],
      whileElementsMounted: Ta
    })), l = z(() => {
      const { strategy: u, x: f, y: m } = s.value;
      return {
        position: u.value,
        top: `${m.value}px`,
        left: `${f.value}px`
      };
    }), d = async () => {
      i.value = !i.value, await Jt();
    }, c = () => {
      i.value = !1;
    };
    return (u, f) => {
      const m = o3;
      return p(), g("div", Eee, [
        h("div", {
          ref_key: "reference",
          ref: r,
          class: "target",
          onClick: Ye(d, ["stop"])
        }, [
          Y(u.$slots, "activator", {}, void 0, !0)
        ], 512),
        q(Xe, { name: "fade" }, {
          default: G(() => [
            B(i) ? (p(), g("div", {
              key: 0,
              ref_key: "floating",
              ref: a,
              class: "container",
              style: en(l.value)
            }, [
              q(m, {
                class: "close",
                onClick: Ye(c, ["stop"])
              }),
              u.title || u.$slots.title ? (p(), g("div", Pee, [
                Y(u.$slots, "title", {}, () => [
                  xe(ne(u.title), 1)
                ], !0)
              ])) : X("", !0),
              u.text || u.$slots.text ? (p(), g("div", Tee, [
                Y(u.$slots, "text", {}, () => [
                  xe(ne(u.text), 1)
                ], !0)
              ])) : X("", !0)
            ], 4)) : X("", !0)
          ]),
          _: 3
        })
      ]);
    };
  }
}), Lee = /* @__PURE__ */ ae(Oee, [["__scopeId", "data-v-fd56c88d"]]), Dee = /* @__PURE__ */ oe({
  name: "PTooltip",
  __name: "index",
  props: {
    placement: { default: "bottom-end" },
    modelValue: { type: Boolean, default: !1 },
    title: { default: "" },
    text: { default: "" },
    buttonText: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, o = e, i = U(n.modelValue), { mobile: r } = nt();
    he(
      () => n.modelValue,
      (l) => {
        l !== i.value && (i.value = l);
      }
    );
    const a = z(() => r.value ? I(kee) : I(Lee)), s = (l) => {
      i.value = l, o("update:modelValue", l);
    };
    return (l, d) => (p(), J(Ce(a.value), {
      "model-value": i.value,
      placement: l.placement,
      title: l.title,
      text: l.text,
      "onUpdate:modelValue": s
    }, {
      activator: G(() => [
        Y(l.$slots, "activator")
      ]),
      text: G(() => [
        Y(l.$slots, "text")
      ]),
      _: 3
    }, 8, ["model-value", "placement", "title", "text"]));
  }
}), Nee = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Ree = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17.572 8.943H2.056a1.057 1.057 0 0 0 0 2.114h15.514a1.057 1.057 0 0 0 0-2.114Z",
  "clip-rule": "evenodd"
}, null, -1), Zee = [
  Ree
];
function Bee(t, e) {
  return p(), g("svg", Nee, [...Zee]);
}
const Vee = I({ name: "icon-minus-md", render: Bee }), Fee = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Hee = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.652 1.812a8.843 8.843 0 0 1 8.942 15.016h2.174a1 1 0 1 1 0 2h-4.883a1 1 0 0 1-1-1V12.945a1 1 0 1 1 2 0v2.673A6.842 6.842 0 0 0 7.4 3.668a1 1 0 1 1-.747-1.856ZM2.734 5.289a1 1 0 0 1 2 0v.01a1 1 0 1 1-2 0v-.01Zm6.244 11.48a1 1 0 0 0-1 1v.01a1 1 0 1 0 2 0v-.01a1 1 0 0 0-1-1Zm-4.75-.533a1 1 0 1 1 2 0v.01a1 1 0 1 1-2 0v-.01Zm-1.47-4.193a1 1 0 0 0-1 1v.01a1 1 0 1 0 2 0v-.01a1 1 0 0 0-1-1ZM1.201 9.039a1 1 0 1 1 2 0v.01a1 1 0 0 1-2 0v-.01Z",
  "clip-rule": "evenodd"
}, null, -1), Uee = [
  Hee
];
function zee(t, e) {
  return p(), g("svg", Fee, [...Uee]);
}
const Wee = I({ name: "icon-rotate-right-md", render: zee }), jee = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Gee = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.348 1.812a8.843 8.843 0 0 0-8.942 15.016H2.232a1 1 0 1 0 0 2h4.883a1 1 0 0 0 1-1V12.945a1 1 0 1 0-2 0v2.673A6.843 6.843 0 0 1 12.6 3.668a1 1 0 0 0 .747-1.856Zm3.917 3.477a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0v-.01Zm-6.243 11.48a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1Zm4.75-.533a1 1 0 1 0-2 0v.01a1 1 0 0 0 2 0v-.01Zm1.47-4.193a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1Zm1.557-3.004a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0v-.01Z",
  "clip-rule": "evenodd"
}, null, -1), Yee = [
  Gee
];
function Xee(t, e) {
  return p(), g("svg", jee, [...Yee]);
}
const Kee = I({ name: "icon-rotate-left-md", render: Xee }), qee = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Jee = /* @__PURE__ */ h("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.973 2.41a7.75 7.75 0 0 0-6.64 2.379v-.622a1 1 0 0 0-2 0V7.5a1 1 0 0 0 1 1h3.334a1 1 0 1 0 0-2H5.494a5.75 5.75 0 0 1 10.183 2.804 1 1 0 1 0 1.98-.275 7.75 7.75 0 0 0-6.684-6.62Zm-6.649 8.286a1 1 0 0 0-1.98.275 7.75 7.75 0 0 0 13.323 4.24v.622a1 1 0 1 0 2 0V12.5a1 1 0 0 0-1-1h-3.333a1 1 0 1 0 0 2h1.172a5.75 5.75 0 0 1-10.182-2.804Z",
  "clip-rule": "evenodd"
}, null, -1), Qee = [
  Jee
];
function ete(t, e) {
  return p(), g("svg", qee, [...Qee]);
}
const tte = I({ name: "icon-refresh-md", render: ete });
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function jl(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function r3(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? jl(Object(n), !0).forEach(function(o) {
      rte(t, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : jl(Object(n)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return t;
}
function nte(t, e) {
  if (typeof t != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(t, e || "default");
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function a3(t) {
  var e = nte(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function Sr(t) {
  "@babel/helpers - typeof";
  return Sr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Sr(t);
}
function ote(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Gl(t, e) {
  for (var n = 0; n < e.length; n++) {
    var o = e[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, a3(o.key), o);
  }
}
function ite(t, e, n) {
  return e && Gl(t.prototype, e), n && Gl(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function rte(t, e, n) {
  return e = a3(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function s3(t) {
  return ate(t) || ste(t) || lte(t) || dte();
}
function ate(t) {
  if (Array.isArray(t)) return Ir(t);
}
function ste(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function lte(t, e) {
  if (t) {
    if (typeof t == "string") return Ir(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ir(t, e);
  }
}
function Ir(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, o = new Array(e); n < e; n++) o[n] = t[n];
  return o;
}
function dte() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var m0 = typeof window < "u" && typeof window.document < "u", wn = m0 ? window : {}, za = m0 && wn.document.documentElement ? "ontouchstart" in wn.document.documentElement : !1, Wa = m0 ? "PointerEvent" in wn : !1, Ae = "cropper", ja = "all", l3 = "crop", d3 = "move", c3 = "zoom", fo = "e", mo = "w", Bo = "s", Vn = "n", M1 = "ne", C1 = "nw", b1 = "se", x1 = "sw", Ar = "".concat(Ae, "-crop"), Yl = "".concat(Ae, "-disabled"), Ct = "".concat(Ae, "-hidden"), Xl = "".concat(Ae, "-hide"), cte = "".concat(Ae, "-invisible"), zi = "".concat(Ae, "-modal"), kr = "".concat(Ae, "-move"), J1 = "".concat(Ae, "Action"), mi = "".concat(Ae, "Preview"), Ga = "crop", u3 = "move", h3 = "none", Er = "crop", Pr = "cropend", Tr = "cropmove", Or = "cropstart", Kl = "dblclick", ute = za ? "touchstart" : "mousedown", hte = za ? "touchmove" : "mousemove", fte = za ? "touchend touchcancel" : "mouseup", ql = Wa ? "pointerdown" : ute, Jl = Wa ? "pointermove" : hte, Ql = Wa ? "pointerup pointercancel" : fte, ed = "ready", td = "resize", nd = "wheel", Lr = "zoom", od = "image/jpeg", mte = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, pte = /^data:/, _te = /^data:image\/jpeg;base64,/, vte = /^img|canvas$/i, f3 = 200, m3 = 100, id = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: Ga,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: f3,
  minContainerHeight: m3,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, gte = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', $te = Number.isNaN || wn.isNaN;
function pe(t) {
  return typeof t == "number" && !$te(t);
}
var rd = function(e) {
  return e > 0 && e < 1 / 0;
};
function L0(t) {
  return typeof t > "u";
}
function Po(t) {
  return Sr(t) === "object" && t !== null;
}
var wte = Object.prototype.hasOwnProperty;
function jo(t) {
  if (!Po(t))
    return !1;
  try {
    var e = t.constructor, n = e.prototype;
    return e && n && wte.call(n, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function wt(t) {
  return typeof t == "function";
}
var yte = Array.prototype.slice;
function p3(t) {
  return Array.from ? Array.from(t) : yte.call(t);
}
function We(t, e) {
  return t && wt(e) && (Array.isArray(t) || pe(t.length) ? p3(t).forEach(function(n, o) {
    e.call(t, n, o, t);
  }) : Po(t) && Object.keys(t).forEach(function(n) {
    e.call(t, t[n], n, t);
  })), t;
}
var ke = Object.assign || function(e) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    o[i - 1] = arguments[i];
  return Po(e) && o.length > 0 && o.forEach(function(r) {
    Po(r) && Object.keys(r).forEach(function(a) {
      e[a] = r[a];
    });
  }), e;
}, Mte = /\.\d*(?:0|9){12}\d*$/;
function Jo(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return Mte.test(t) ? Math.round(t * e) / e : t;
}
var Cte = /^width|height|left|top|marginLeft|marginTop$/;
function jn(t, e) {
  var n = t.style;
  We(e, function(o, i) {
    Cte.test(i) && pe(o) && (o = "".concat(o, "px")), n[i] = o;
  });
}
function bte(t, e) {
  return t.classList ? t.classList.contains(e) : t.className.indexOf(e) > -1;
}
function Je(t, e) {
  if (e) {
    if (pe(t.length)) {
      We(t, function(o) {
        Je(o, e);
      });
      return;
    }
    if (t.classList) {
      t.classList.add(e);
      return;
    }
    var n = t.className.trim();
    n ? n.indexOf(e) < 0 && (t.className = "".concat(n, " ").concat(e)) : t.className = e;
  }
}
function vn(t, e) {
  if (e) {
    if (pe(t.length)) {
      We(t, function(n) {
        vn(n, e);
      });
      return;
    }
    if (t.classList) {
      t.classList.remove(e);
      return;
    }
    t.className.indexOf(e) >= 0 && (t.className = t.className.replace(e, ""));
  }
}
function Go(t, e, n) {
  if (e) {
    if (pe(t.length)) {
      We(t, function(o) {
        Go(o, e, n);
      });
      return;
    }
    n ? Je(t, e) : vn(t, e);
  }
}
var xte = /([a-z\d])([A-Z])/g;
function Ya(t) {
  return t.replace(xte, "$1-$2").toLowerCase();
}
function Dr(t, e) {
  return Po(t[e]) ? t[e] : t.dataset ? t.dataset[e] : t.getAttribute("data-".concat(Ya(e)));
}
function Q1(t, e, n) {
  Po(n) ? t[e] = n : t.dataset ? t.dataset[e] = n : t.setAttribute("data-".concat(Ya(e)), n);
}
function Ste(t, e) {
  if (Po(t[e]))
    try {
      delete t[e];
    } catch {
      t[e] = void 0;
    }
  else if (t.dataset)
    try {
      delete t.dataset[e];
    } catch {
      t.dataset[e] = void 0;
    }
  else
    t.removeAttribute("data-".concat(Ya(e)));
}
var _3 = /\s\s*/, v3 = function() {
  var t = !1;
  if (m0) {
    var e = !1, n = function() {
    }, o = Object.defineProperty({}, "once", {
      get: function() {
        return t = !0, e;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(r) {
        e = r;
      }
    });
    wn.addEventListener("test", n, o), wn.removeEventListener("test", n, o);
  }
  return t;
}();
function tn(t, e, n) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = n;
  e.trim().split(_3).forEach(function(r) {
    if (!v3) {
      var a = t.listeners;
      a && a[r] && a[r][n] && (i = a[r][n], delete a[r][n], Object.keys(a[r]).length === 0 && delete a[r], Object.keys(a).length === 0 && delete t.listeners);
    }
    t.removeEventListener(r, i, o);
  });
}
function jt(t, e, n) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = n;
  e.trim().split(_3).forEach(function(r) {
    if (o.once && !v3) {
      var a = t.listeners, s = a === void 0 ? {} : a;
      i = function() {
        delete s[r][n], t.removeEventListener(r, i, o);
        for (var d = arguments.length, c = new Array(d), u = 0; u < d; u++)
          c[u] = arguments[u];
        n.apply(t, c);
      }, s[r] || (s[r] = {}), s[r][n] && t.removeEventListener(r, s[r][n], o), s[r][n] = i, t.listeners = s;
    }
    t.addEventListener(r, i, o);
  });
}
function Qo(t, e, n) {
  var o;
  return wt(Event) && wt(CustomEvent) ? o = new CustomEvent(e, {
    detail: n,
    bubbles: !0,
    cancelable: !0
  }) : (o = document.createEvent("CustomEvent"), o.initCustomEvent(e, !0, !0, n)), t.dispatchEvent(o);
}
function g3(t) {
  var e = t.getBoundingClientRect();
  return {
    left: e.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: e.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var D0 = wn.location, Ite = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function ad(t) {
  var e = t.match(Ite);
  return e !== null && (e[1] !== D0.protocol || e[2] !== D0.hostname || e[3] !== D0.port);
}
function sd(t) {
  var e = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return t + (t.indexOf("?") === -1 ? "?" : "&") + e;
}
function L1(t) {
  var e = t.rotate, n = t.scaleX, o = t.scaleY, i = t.translateX, r = t.translateY, a = [];
  pe(i) && i !== 0 && a.push("translateX(".concat(i, "px)")), pe(r) && r !== 0 && a.push("translateY(".concat(r, "px)")), pe(e) && e !== 0 && a.push("rotate(".concat(e, "deg)")), pe(n) && n !== 1 && a.push("scaleX(".concat(n, ")")), pe(o) && o !== 1 && a.push("scaleY(".concat(o, ")"));
  var s = a.length ? a.join(" ") : "none";
  return {
    WebkitTransform: s,
    msTransform: s,
    transform: s
  };
}
function Ate(t) {
  var e = r3({}, t), n = 0;
  return We(t, function(o, i) {
    delete e[i], We(e, function(r) {
      var a = Math.abs(o.startX - r.startX), s = Math.abs(o.startY - r.startY), l = Math.abs(o.endX - r.endX), d = Math.abs(o.endY - r.endY), c = Math.sqrt(a * a + s * s), u = Math.sqrt(l * l + d * d), f = (u - c) / c;
      Math.abs(f) > Math.abs(n) && (n = f);
    });
  }), n;
}
function pi(t, e) {
  var n = t.pageX, o = t.pageY, i = {
    endX: n,
    endY: o
  };
  return e ? i : r3({
    startX: n,
    startY: o
  }, i);
}
function kte(t) {
  var e = 0, n = 0, o = 0;
  return We(t, function(i) {
    var r = i.startX, a = i.startY;
    e += r, n += a, o += 1;
  }), e /= o, n /= o, {
    pageX: e,
    pageY: n
  };
}
function Gn(t) {
  var e = t.aspectRatio, n = t.height, o = t.width, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", r = rd(o), a = rd(n);
  if (r && a) {
    var s = n * e;
    i === "contain" && s > o || i === "cover" && s < o ? n = o / e : o = n * e;
  } else r ? n = o / e : a && (o = n * e);
  return {
    width: o,
    height: n
  };
}
function Ete(t) {
  var e = t.width, n = t.height, o = t.degree;
  if (o = Math.abs(o) % 180, o === 90)
    return {
      width: n,
      height: e
    };
  var i = o % 90 * Math.PI / 180, r = Math.sin(i), a = Math.cos(i), s = e * a + n * r, l = e * r + n * a;
  return o > 90 ? {
    width: l,
    height: s
  } : {
    width: s,
    height: l
  };
}
function Pte(t, e, n, o) {
  var i = e.aspectRatio, r = e.naturalWidth, a = e.naturalHeight, s = e.rotate, l = s === void 0 ? 0 : s, d = e.scaleX, c = d === void 0 ? 1 : d, u = e.scaleY, f = u === void 0 ? 1 : u, m = n.aspectRatio, v = n.naturalWidth, _ = n.naturalHeight, w = o.fillColor, $ = w === void 0 ? "transparent" : w, y = o.imageSmoothingEnabled, M = y === void 0 ? !0 : y, S = o.imageSmoothingQuality, x = S === void 0 ? "low" : S, b = o.maxWidth, C = b === void 0 ? 1 / 0 : b, E = o.maxHeight, A = E === void 0 ? 1 / 0 : E, T = o.minWidth, k = T === void 0 ? 0 : T, L = o.minHeight, V = L === void 0 ? 0 : L, O = document.createElement("canvas"), D = O.getContext("2d"), P = Gn({
    aspectRatio: m,
    width: C,
    height: A
  }), F = Gn({
    aspectRatio: m,
    width: k,
    height: V
  }, "cover"), N = Math.min(P.width, Math.max(F.width, v)), H = Math.min(P.height, Math.max(F.height, _)), W = Gn({
    aspectRatio: i,
    width: C,
    height: A
  }), te = Gn({
    aspectRatio: i,
    width: k,
    height: V
  }, "cover"), ie = Math.min(W.width, Math.max(te.width, r)), se = Math.min(W.height, Math.max(te.height, a)), fe = [-ie / 2, -se / 2, ie, se];
  return O.width = Jo(N), O.height = Jo(H), D.fillStyle = $, D.fillRect(0, 0, N, H), D.save(), D.translate(N / 2, H / 2), D.rotate(l * Math.PI / 180), D.scale(c, f), D.imageSmoothingEnabled = M, D.imageSmoothingQuality = x, D.drawImage.apply(D, [t].concat(s3(fe.map(function($e) {
    return Math.floor(Jo($e));
  })))), D.restore(), O;
}
var $3 = String.fromCharCode;
function Tte(t, e, n) {
  var o = "";
  n += e;
  for (var i = e; i < n; i += 1)
    o += $3(t.getUint8(i));
  return o;
}
var Ote = /^data:.*,/;
function Lte(t) {
  var e = t.replace(Ote, ""), n = atob(e), o = new ArrayBuffer(n.length), i = new Uint8Array(o);
  return We(i, function(r, a) {
    i[a] = n.charCodeAt(a);
  }), o;
}
function Dte(t, e) {
  for (var n = [], o = 8192, i = new Uint8Array(t); i.length > 0; )
    n.push($3.apply(null, p3(i.subarray(0, o)))), i = i.subarray(o);
  return "data:".concat(e, ";base64,").concat(btoa(n.join("")));
}
function Nte(t) {
  var e = new DataView(t), n;
  try {
    var o, i, r;
    if (e.getUint8(0) === 255 && e.getUint8(1) === 216)
      for (var a = e.byteLength, s = 2; s + 1 < a; ) {
        if (e.getUint8(s) === 255 && e.getUint8(s + 1) === 225) {
          i = s;
          break;
        }
        s += 1;
      }
    if (i) {
      var l = i + 4, d = i + 10;
      if (Tte(e, l, 4) === "Exif") {
        var c = e.getUint16(d);
        if (o = c === 18761, (o || c === 19789) && e.getUint16(d + 2, o) === 42) {
          var u = e.getUint32(d + 4, o);
          u >= 8 && (r = d + u);
        }
      }
    }
    if (r) {
      var f = e.getUint16(r, o), m, v;
      for (v = 0; v < f; v += 1)
        if (m = r + v * 12 + 2, e.getUint16(m, o) === 274) {
          m += 8, n = e.getUint16(m, o), e.setUint16(m, 1, o);
          break;
        }
    }
  } catch {
    n = 1;
  }
  return n;
}
function Rte(t) {
  var e = 0, n = 1, o = 1;
  switch (t) {
    case 2:
      n = -1;
      break;
    case 3:
      e = -180;
      break;
    case 4:
      o = -1;
      break;
    case 5:
      e = 90, o = -1;
      break;
    case 6:
      e = 90;
      break;
    case 7:
      e = 90, n = -1;
      break;
    case 8:
      e = -90;
      break;
  }
  return {
    rotate: e,
    scaleX: n,
    scaleY: o
  };
}
var Zte = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var e = this.element, n = this.options, o = this.container, i = this.cropper, r = Number(n.minContainerWidth), a = Number(n.minContainerHeight);
    Je(i, Ct), vn(e, Ct);
    var s = {
      width: Math.max(o.offsetWidth, r >= 0 ? r : f3),
      height: Math.max(o.offsetHeight, a >= 0 ? a : m3)
    };
    this.containerData = s, jn(i, {
      width: s.width,
      height: s.height
    }), Je(e, Ct), vn(i, Ct);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var e = this.containerData, n = this.imageData, o = this.options.viewMode, i = Math.abs(n.rotate) % 180 === 90, r = i ? n.naturalHeight : n.naturalWidth, a = i ? n.naturalWidth : n.naturalHeight, s = r / a, l = e.width, d = e.height;
    e.height * s > e.width ? o === 3 ? l = e.height * s : d = e.width / s : o === 3 ? d = e.width / s : l = e.height * s;
    var c = {
      aspectRatio: s,
      naturalWidth: r,
      naturalHeight: a,
      width: l,
      height: d
    };
    this.canvasData = c, this.limited = o === 1 || o === 2, this.limitCanvas(!0, !0), c.width = Math.min(Math.max(c.width, c.minWidth), c.maxWidth), c.height = Math.min(Math.max(c.height, c.minHeight), c.maxHeight), c.left = (e.width - c.width) / 2, c.top = (e.height - c.height) / 2, c.oldLeft = c.left, c.oldTop = c.top, this.initialCanvasData = ke({}, c);
  },
  limitCanvas: function(e, n) {
    var o = this.options, i = this.containerData, r = this.canvasData, a = this.cropBoxData, s = o.viewMode, l = r.aspectRatio, d = this.cropped && a;
    if (e) {
      var c = Number(o.minCanvasWidth) || 0, u = Number(o.minCanvasHeight) || 0;
      s > 1 ? (c = Math.max(c, i.width), u = Math.max(u, i.height), s === 3 && (u * l > c ? c = u * l : u = c / l)) : s > 0 && (c ? c = Math.max(c, d ? a.width : 0) : u ? u = Math.max(u, d ? a.height : 0) : d && (c = a.width, u = a.height, u * l > c ? c = u * l : u = c / l));
      var f = Gn({
        aspectRatio: l,
        width: c,
        height: u
      });
      c = f.width, u = f.height, r.minWidth = c, r.minHeight = u, r.maxWidth = 1 / 0, r.maxHeight = 1 / 0;
    }
    if (n)
      if (s > (d ? 0 : 1)) {
        var m = i.width - r.width, v = i.height - r.height;
        r.minLeft = Math.min(0, m), r.minTop = Math.min(0, v), r.maxLeft = Math.max(0, m), r.maxTop = Math.max(0, v), d && this.limited && (r.minLeft = Math.min(a.left, a.left + (a.width - r.width)), r.minTop = Math.min(a.top, a.top + (a.height - r.height)), r.maxLeft = a.left, r.maxTop = a.top, s === 2 && (r.width >= i.width && (r.minLeft = Math.min(0, m), r.maxLeft = Math.max(0, m)), r.height >= i.height && (r.minTop = Math.min(0, v), r.maxTop = Math.max(0, v))));
      } else
        r.minLeft = -r.width, r.minTop = -r.height, r.maxLeft = i.width, r.maxTop = i.height;
  },
  renderCanvas: function(e, n) {
    var o = this.canvasData, i = this.imageData;
    if (n) {
      var r = Ete({
        width: i.naturalWidth * Math.abs(i.scaleX || 1),
        height: i.naturalHeight * Math.abs(i.scaleY || 1),
        degree: i.rotate || 0
      }), a = r.width, s = r.height, l = o.width * (a / o.naturalWidth), d = o.height * (s / o.naturalHeight);
      o.left -= (l - o.width) / 2, o.top -= (d - o.height) / 2, o.width = l, o.height = d, o.aspectRatio = a / s, o.naturalWidth = a, o.naturalHeight = s, this.limitCanvas(!0, !1);
    }
    (o.width > o.maxWidth || o.width < o.minWidth) && (o.left = o.oldLeft), (o.height > o.maxHeight || o.height < o.minHeight) && (o.top = o.oldTop), o.width = Math.min(Math.max(o.width, o.minWidth), o.maxWidth), o.height = Math.min(Math.max(o.height, o.minHeight), o.maxHeight), this.limitCanvas(!1, !0), o.left = Math.min(Math.max(o.left, o.minLeft), o.maxLeft), o.top = Math.min(Math.max(o.top, o.minTop), o.maxTop), o.oldLeft = o.left, o.oldTop = o.top, jn(this.canvas, ke({
      width: o.width,
      height: o.height
    }, L1({
      translateX: o.left,
      translateY: o.top
    }))), this.renderImage(e), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(e) {
    var n = this.canvasData, o = this.imageData, i = o.naturalWidth * (n.width / n.naturalWidth), r = o.naturalHeight * (n.height / n.naturalHeight);
    ke(o, {
      width: i,
      height: r,
      left: (n.width - i) / 2,
      top: (n.height - r) / 2
    }), jn(this.image, ke({
      width: o.width,
      height: o.height
    }, L1(ke({
      translateX: o.left,
      translateY: o.top
    }, o)))), e && this.output();
  },
  initCropBox: function() {
    var e = this.options, n = this.canvasData, o = e.aspectRatio || e.initialAspectRatio, i = Number(e.autoCropArea) || 0.8, r = {
      width: n.width,
      height: n.height
    };
    o && (n.height * o > n.width ? r.height = r.width / o : r.width = r.height * o), this.cropBoxData = r, this.limitCropBox(!0, !0), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), r.width = Math.max(r.minWidth, r.width * i), r.height = Math.max(r.minHeight, r.height * i), r.left = n.left + (n.width - r.width) / 2, r.top = n.top + (n.height - r.height) / 2, r.oldLeft = r.left, r.oldTop = r.top, this.initialCropBoxData = ke({}, r);
  },
  limitCropBox: function(e, n) {
    var o = this.options, i = this.containerData, r = this.canvasData, a = this.cropBoxData, s = this.limited, l = o.aspectRatio;
    if (e) {
      var d = Number(o.minCropBoxWidth) || 0, c = Number(o.minCropBoxHeight) || 0, u = s ? Math.min(i.width, r.width, r.width + r.left, i.width - r.left) : i.width, f = s ? Math.min(i.height, r.height, r.height + r.top, i.height - r.top) : i.height;
      d = Math.min(d, i.width), c = Math.min(c, i.height), l && (d && c ? c * l > d ? c = d / l : d = c * l : d ? c = d / l : c && (d = c * l), f * l > u ? f = u / l : u = f * l), a.minWidth = Math.min(d, u), a.minHeight = Math.min(c, f), a.maxWidth = u, a.maxHeight = f;
    }
    n && (s ? (a.minLeft = Math.max(0, r.left), a.minTop = Math.max(0, r.top), a.maxLeft = Math.min(i.width, r.left + r.width) - a.width, a.maxTop = Math.min(i.height, r.top + r.height) - a.height) : (a.minLeft = 0, a.minTop = 0, a.maxLeft = i.width - a.width, a.maxTop = i.height - a.height));
  },
  renderCropBox: function() {
    var e = this.options, n = this.containerData, o = this.cropBoxData;
    (o.width > o.maxWidth || o.width < o.minWidth) && (o.left = o.oldLeft), (o.height > o.maxHeight || o.height < o.minHeight) && (o.top = o.oldTop), o.width = Math.min(Math.max(o.width, o.minWidth), o.maxWidth), o.height = Math.min(Math.max(o.height, o.minHeight), o.maxHeight), this.limitCropBox(!1, !0), o.left = Math.min(Math.max(o.left, o.minLeft), o.maxLeft), o.top = Math.min(Math.max(o.top, o.minTop), o.maxTop), o.oldLeft = o.left, o.oldTop = o.top, e.movable && e.cropBoxMovable && Q1(this.face, J1, o.width >= n.width && o.height >= n.height ? d3 : ja), jn(this.cropBox, ke({
      width: o.width,
      height: o.height
    }, L1({
      translateX: o.left,
      translateY: o.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), Qo(this.element, Er, this.getData());
  }
}, Bte = {
  initPreview: function() {
    var e = this.element, n = this.crossOrigin, o = this.options.preview, i = n ? this.crossOriginUrl : this.url, r = e.alt || "The image to preview", a = document.createElement("img");
    if (n && (a.crossOrigin = n), a.src = i, a.alt = r, this.viewBox.appendChild(a), this.viewBoxImage = a, !!o) {
      var s = o;
      typeof o == "string" ? s = e.ownerDocument.querySelectorAll(o) : o.querySelector && (s = [o]), this.previews = s, We(s, function(l) {
        var d = document.createElement("img");
        Q1(l, mi, {
          width: l.offsetWidth,
          height: l.offsetHeight,
          html: l.innerHTML
        }), n && (d.crossOrigin = n), d.src = i, d.alt = r, d.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', l.innerHTML = "", l.appendChild(d);
      });
    }
  },
  resetPreview: function() {
    We(this.previews, function(e) {
      var n = Dr(e, mi);
      jn(e, {
        width: n.width,
        height: n.height
      }), e.innerHTML = n.html, Ste(e, mi);
    });
  },
  preview: function() {
    var e = this.imageData, n = this.canvasData, o = this.cropBoxData, i = o.width, r = o.height, a = e.width, s = e.height, l = o.left - n.left - e.left, d = o.top - n.top - e.top;
    !this.cropped || this.disabled || (jn(this.viewBoxImage, ke({
      width: a,
      height: s
    }, L1(ke({
      translateX: -l,
      translateY: -d
    }, e)))), We(this.previews, function(c) {
      var u = Dr(c, mi), f = u.width, m = u.height, v = f, _ = m, w = 1;
      i && (w = f / i, _ = r * w), r && _ > m && (w = m / r, v = i * w, _ = m), jn(c, {
        width: v,
        height: _
      }), jn(c.getElementsByTagName("img")[0], ke({
        width: a * w,
        height: s * w
      }, L1(ke({
        translateX: -l * w,
        translateY: -d * w
      }, e))));
    }));
  }
}, Vte = {
  bind: function() {
    var e = this.element, n = this.options, o = this.cropper;
    wt(n.cropstart) && jt(e, Or, n.cropstart), wt(n.cropmove) && jt(e, Tr, n.cropmove), wt(n.cropend) && jt(e, Pr, n.cropend), wt(n.crop) && jt(e, Er, n.crop), wt(n.zoom) && jt(e, Lr, n.zoom), jt(o, ql, this.onCropStart = this.cropStart.bind(this)), n.zoomable && n.zoomOnWheel && jt(o, nd, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), n.toggleDragModeOnDblclick && jt(o, Kl, this.onDblclick = this.dblclick.bind(this)), jt(e.ownerDocument, Jl, this.onCropMove = this.cropMove.bind(this)), jt(e.ownerDocument, Ql, this.onCropEnd = this.cropEnd.bind(this)), n.responsive && jt(window, td, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var e = this.element, n = this.options, o = this.cropper;
    wt(n.cropstart) && tn(e, Or, n.cropstart), wt(n.cropmove) && tn(e, Tr, n.cropmove), wt(n.cropend) && tn(e, Pr, n.cropend), wt(n.crop) && tn(e, Er, n.crop), wt(n.zoom) && tn(e, Lr, n.zoom), tn(o, ql, this.onCropStart), n.zoomable && n.zoomOnWheel && tn(o, nd, this.onWheel, {
      passive: !1,
      capture: !0
    }), n.toggleDragModeOnDblclick && tn(o, Kl, this.onDblclick), tn(e.ownerDocument, Jl, this.onCropMove), tn(e.ownerDocument, Ql, this.onCropEnd), n.responsive && tn(window, td, this.onResize);
  }
}, Fte = {
  resize: function() {
    if (!this.disabled) {
      var e = this.options, n = this.container, o = this.containerData, i = n.offsetWidth / o.width, r = n.offsetHeight / o.height, a = Math.abs(i - 1) > Math.abs(r - 1) ? i : r;
      if (a !== 1) {
        var s, l;
        e.restore && (s = this.getCanvasData(), l = this.getCropBoxData()), this.render(), e.restore && (this.setCanvasData(We(s, function(d, c) {
          s[c] = d * a;
        })), this.setCropBoxData(We(l, function(d, c) {
          l[c] = d * a;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === h3 || this.setDragMode(bte(this.dragBox, Ar) ? u3 : Ga);
  },
  wheel: function(e) {
    var n = this, o = Number(this.options.wheelZoomRatio) || 0.1, i = 1;
    this.disabled || (e.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      n.wheeling = !1;
    }, 50), e.deltaY ? i = e.deltaY > 0 ? 1 : -1 : e.wheelDelta ? i = -e.wheelDelta / 120 : e.detail && (i = e.detail > 0 ? 1 : -1), this.zoom(-i * o, e)));
  },
  cropStart: function(e) {
    var n = e.buttons, o = e.button;
    if (!(this.disabled || (e.type === "mousedown" || e.type === "pointerdown" && e.pointerType === "mouse") && // No primary button (Usually the left button)
    (pe(n) && n !== 1 || pe(o) && o !== 0 || e.ctrlKey))) {
      var i = this.options, r = this.pointers, a;
      e.changedTouches ? We(e.changedTouches, function(s) {
        r[s.identifier] = pi(s);
      }) : r[e.pointerId || 0] = pi(e), Object.keys(r).length > 1 && i.zoomable && i.zoomOnTouch ? a = c3 : a = Dr(e.target, J1), mte.test(a) && Qo(this.element, Or, {
        originalEvent: e,
        action: a
      }) !== !1 && (e.preventDefault(), this.action = a, this.cropping = !1, a === l3 && (this.cropping = !0, Je(this.dragBox, zi)));
    }
  },
  cropMove: function(e) {
    var n = this.action;
    if (!(this.disabled || !n)) {
      var o = this.pointers;
      e.preventDefault(), Qo(this.element, Tr, {
        originalEvent: e,
        action: n
      }) !== !1 && (e.changedTouches ? We(e.changedTouches, function(i) {
        ke(o[i.identifier] || {}, pi(i, !0));
      }) : ke(o[e.pointerId || 0] || {}, pi(e, !0)), this.change(e));
    }
  },
  cropEnd: function(e) {
    if (!this.disabled) {
      var n = this.action, o = this.pointers;
      e.changedTouches ? We(e.changedTouches, function(i) {
        delete o[i.identifier];
      }) : delete o[e.pointerId || 0], n && (e.preventDefault(), Object.keys(o).length || (this.action = ""), this.cropping && (this.cropping = !1, Go(this.dragBox, zi, this.cropped && this.options.modal)), Qo(this.element, Pr, {
        originalEvent: e,
        action: n
      }));
    }
  }
}, Hte = {
  change: function(e) {
    var n = this.options, o = this.canvasData, i = this.containerData, r = this.cropBoxData, a = this.pointers, s = this.action, l = n.aspectRatio, d = r.left, c = r.top, u = r.width, f = r.height, m = d + u, v = c + f, _ = 0, w = 0, $ = i.width, y = i.height, M = !0, S;
    !l && e.shiftKey && (l = u && f ? u / f : 1), this.limited && (_ = r.minLeft, w = r.minTop, $ = _ + Math.min(i.width, o.width, o.left + o.width), y = w + Math.min(i.height, o.height, o.top + o.height));
    var x = a[Object.keys(a)[0]], b = {
      x: x.endX - x.startX,
      y: x.endY - x.startY
    }, C = function(A) {
      switch (A) {
        case fo:
          m + b.x > $ && (b.x = $ - m);
          break;
        case mo:
          d + b.x < _ && (b.x = _ - d);
          break;
        case Vn:
          c + b.y < w && (b.y = w - c);
          break;
        case Bo:
          v + b.y > y && (b.y = y - v);
          break;
      }
    };
    switch (s) {
      case ja:
        d += b.x, c += b.y;
        break;
      case fo:
        if (b.x >= 0 && (m >= $ || l && (c <= w || v >= y))) {
          M = !1;
          break;
        }
        C(fo), u += b.x, u < 0 && (s = mo, u = -u, d -= u), l && (f = u / l, c += (r.height - f) / 2);
        break;
      case Vn:
        if (b.y <= 0 && (c <= w || l && (d <= _ || m >= $))) {
          M = !1;
          break;
        }
        C(Vn), f -= b.y, c += b.y, f < 0 && (s = Bo, f = -f, c -= f), l && (u = f * l, d += (r.width - u) / 2);
        break;
      case mo:
        if (b.x <= 0 && (d <= _ || l && (c <= w || v >= y))) {
          M = !1;
          break;
        }
        C(mo), u -= b.x, d += b.x, u < 0 && (s = fo, u = -u, d -= u), l && (f = u / l, c += (r.height - f) / 2);
        break;
      case Bo:
        if (b.y >= 0 && (v >= y || l && (d <= _ || m >= $))) {
          M = !1;
          break;
        }
        C(Bo), f += b.y, f < 0 && (s = Vn, f = -f, c -= f), l && (u = f * l, d += (r.width - u) / 2);
        break;
      case M1:
        if (l) {
          if (b.y <= 0 && (c <= w || m >= $)) {
            M = !1;
            break;
          }
          C(Vn), f -= b.y, c += b.y, u = f * l;
        } else
          C(Vn), C(fo), b.x >= 0 ? m < $ ? u += b.x : b.y <= 0 && c <= w && (M = !1) : u += b.x, b.y <= 0 ? c > w && (f -= b.y, c += b.y) : (f -= b.y, c += b.y);
        u < 0 && f < 0 ? (s = x1, f = -f, u = -u, c -= f, d -= u) : u < 0 ? (s = C1, u = -u, d -= u) : f < 0 && (s = b1, f = -f, c -= f);
        break;
      case C1:
        if (l) {
          if (b.y <= 0 && (c <= w || d <= _)) {
            M = !1;
            break;
          }
          C(Vn), f -= b.y, c += b.y, u = f * l, d += r.width - u;
        } else
          C(Vn), C(mo), b.x <= 0 ? d > _ ? (u -= b.x, d += b.x) : b.y <= 0 && c <= w && (M = !1) : (u -= b.x, d += b.x), b.y <= 0 ? c > w && (f -= b.y, c += b.y) : (f -= b.y, c += b.y);
        u < 0 && f < 0 ? (s = b1, f = -f, u = -u, c -= f, d -= u) : u < 0 ? (s = M1, u = -u, d -= u) : f < 0 && (s = x1, f = -f, c -= f);
        break;
      case x1:
        if (l) {
          if (b.x <= 0 && (d <= _ || v >= y)) {
            M = !1;
            break;
          }
          C(mo), u -= b.x, d += b.x, f = u / l;
        } else
          C(Bo), C(mo), b.x <= 0 ? d > _ ? (u -= b.x, d += b.x) : b.y >= 0 && v >= y && (M = !1) : (u -= b.x, d += b.x), b.y >= 0 ? v < y && (f += b.y) : f += b.y;
        u < 0 && f < 0 ? (s = M1, f = -f, u = -u, c -= f, d -= u) : u < 0 ? (s = b1, u = -u, d -= u) : f < 0 && (s = C1, f = -f, c -= f);
        break;
      case b1:
        if (l) {
          if (b.x >= 0 && (m >= $ || v >= y)) {
            M = !1;
            break;
          }
          C(fo), u += b.x, f = u / l;
        } else
          C(Bo), C(fo), b.x >= 0 ? m < $ ? u += b.x : b.y >= 0 && v >= y && (M = !1) : u += b.x, b.y >= 0 ? v < y && (f += b.y) : f += b.y;
        u < 0 && f < 0 ? (s = C1, f = -f, u = -u, c -= f, d -= u) : u < 0 ? (s = x1, u = -u, d -= u) : f < 0 && (s = M1, f = -f, c -= f);
        break;
      case d3:
        this.move(b.x, b.y), M = !1;
        break;
      case c3:
        this.zoom(Ate(a), e), M = !1;
        break;
      case l3:
        if (!b.x || !b.y) {
          M = !1;
          break;
        }
        S = g3(this.cropper), d = x.startX - S.left, c = x.startY - S.top, u = r.minWidth, f = r.minHeight, b.x > 0 ? s = b.y > 0 ? b1 : M1 : b.x < 0 && (d -= u, s = b.y > 0 ? x1 : C1), b.y < 0 && (c -= f), this.cropped || (vn(this.cropBox, Ct), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    M && (r.width = u, r.height = f, r.left = d, r.top = c, this.action = s, this.renderCropBox()), We(a, function(E) {
      E.startX = E.endX, E.startY = E.endY;
    });
  }
}, Ute = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && Je(this.dragBox, zi), vn(this.cropBox, Ct), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = ke({}, this.initialImageData), this.canvasData = ke({}, this.initialCanvasData), this.cropBoxData = ke({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (ke(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), vn(this.dragBox, zi), Je(this.cropBox, Ct)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && e && (this.isImg && (this.element.src = e), n ? (this.url = e, this.image.src = e, this.ready && (this.viewBoxImage.src = e, We(this.previews, function(o) {
      o.getElementsByTagName("img")[0].src = e;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(e))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, vn(this.cropper, Yl)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, Je(this.cropper, Yl)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var e = this.element;
    return e[Ae] ? (e[Ae] = void 0, this.isImg && this.replaced && (e.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, o = this.canvasData, i = o.left, r = o.top;
    return this.moveTo(L0(e) ? e : i + Number(e), L0(n) ? n : r + Number(n));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, o = this.canvasData, i = !1;
    return e = Number(e), n = Number(n), this.ready && !this.disabled && this.options.movable && (pe(e) && (o.left = e, i = !0), pe(n) && (o.top = n, i = !0), i && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(e, n) {
    var o = this.canvasData;
    return e = Number(e), e < 0 ? e = 1 / (1 - e) : e = 1 + e, this.zoomTo(o.width * e / o.naturalWidth, null, n);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(e, n, o) {
    var i = this.options, r = this.canvasData, a = r.width, s = r.height, l = r.naturalWidth, d = r.naturalHeight;
    if (e = Number(e), e >= 0 && this.ready && !this.disabled && i.zoomable) {
      var c = l * e, u = d * e;
      if (Qo(this.element, Lr, {
        ratio: e,
        oldRatio: a / l,
        originalEvent: o
      }) === !1)
        return this;
      if (o) {
        var f = this.pointers, m = g3(this.cropper), v = f && Object.keys(f).length ? kte(f) : {
          pageX: o.pageX,
          pageY: o.pageY
        };
        r.left -= (c - a) * ((v.pageX - m.left - r.left) / a), r.top -= (u - s) * ((v.pageY - m.top - r.top) / s);
      } else jo(n) && pe(n.x) && pe(n.y) ? (r.left -= (c - a) * ((n.x - r.left) / a), r.top -= (u - s) * ((n.y - r.top) / s)) : (r.left -= (c - a) / 2, r.top -= (u - s) / 2);
      r.width = c, r.height = u, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(e) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(e));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(e) {
    return e = Number(e), pe(e) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(e) {
    var n = this.imageData.scaleY;
    return this.scale(e, pe(n) ? n : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(e) {
    var n = this.imageData.scaleX;
    return this.scale(pe(n) ? n : 1, e);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, o = this.imageData, i = !1;
    return e = Number(e), n = Number(n), this.ready && !this.disabled && this.options.scalable && (pe(e) && (o.scaleX = e, i = !0), pe(n) && (o.scaleY = n, i = !0), i && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, n = this.options, o = this.imageData, i = this.canvasData, r = this.cropBoxData, a;
    if (this.ready && this.cropped) {
      a = {
        x: r.left - i.left,
        y: r.top - i.top,
        width: r.width,
        height: r.height
      };
      var s = o.width / o.naturalWidth;
      if (We(a, function(c, u) {
        a[u] = c / s;
      }), e) {
        var l = Math.round(a.y + a.height), d = Math.round(a.x + a.width);
        a.x = Math.round(a.x), a.y = Math.round(a.y), a.width = d - a.x, a.height = l - a.y;
      }
    } else
      a = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return n.rotatable && (a.rotate = o.rotate || 0), n.scalable && (a.scaleX = o.scaleX || 1, a.scaleY = o.scaleY || 1), a;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(e) {
    var n = this.options, o = this.imageData, i = this.canvasData, r = {};
    if (this.ready && !this.disabled && jo(e)) {
      var a = !1;
      n.rotatable && pe(e.rotate) && e.rotate !== o.rotate && (o.rotate = e.rotate, a = !0), n.scalable && (pe(e.scaleX) && e.scaleX !== o.scaleX && (o.scaleX = e.scaleX, a = !0), pe(e.scaleY) && e.scaleY !== o.scaleY && (o.scaleY = e.scaleY, a = !0)), a && this.renderCanvas(!0, !0);
      var s = o.width / o.naturalWidth;
      pe(e.x) && (r.left = e.x * s + i.left), pe(e.y) && (r.top = e.y * s + i.top), pe(e.width) && (r.width = e.width * s), pe(e.height) && (r.height = e.height * s), this.setCropBoxData(r);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? ke({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? ke({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var e = this.canvasData, n = {};
    return this.ready && We(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(o) {
      n[o] = e[o];
    }), n;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(e) {
    var n = this.canvasData, o = n.aspectRatio;
    return this.ready && !this.disabled && jo(e) && (pe(e.left) && (n.left = e.left), pe(e.top) && (n.top = e.top), pe(e.width) ? (n.width = e.width, n.height = e.width / o) : pe(e.height) && (n.height = e.height, n.width = e.height * o), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var e = this.cropBoxData, n;
    return this.ready && this.cropped && (n = {
      left: e.left,
      top: e.top,
      width: e.width,
      height: e.height
    }), n || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(e) {
    var n = this.cropBoxData, o = this.options.aspectRatio, i, r;
    return this.ready && this.cropped && !this.disabled && jo(e) && (pe(e.left) && (n.left = e.left), pe(e.top) && (n.top = e.top), pe(e.width) && e.width !== n.width && (i = !0, n.width = e.width), pe(e.height) && e.height !== n.height && (r = !0, n.height = e.height), o && (i ? n.height = n.width / o : r && (n.width = n.height * o)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var n = this.canvasData, o = Pte(this.image, this.imageData, n, e);
    if (!this.cropped)
      return o;
    var i = this.getData(e.rounded), r = i.x, a = i.y, s = i.width, l = i.height, d = o.width / Math.floor(n.naturalWidth);
    d !== 1 && (r *= d, a *= d, s *= d, l *= d);
    var c = s / l, u = Gn({
      aspectRatio: c,
      width: e.maxWidth || 1 / 0,
      height: e.maxHeight || 1 / 0
    }), f = Gn({
      aspectRatio: c,
      width: e.minWidth || 0,
      height: e.minHeight || 0
    }, "cover"), m = Gn({
      aspectRatio: c,
      width: e.width || (d !== 1 ? o.width : s),
      height: e.height || (d !== 1 ? o.height : l)
    }), v = m.width, _ = m.height;
    v = Math.min(u.width, Math.max(f.width, v)), _ = Math.min(u.height, Math.max(f.height, _));
    var w = document.createElement("canvas"), $ = w.getContext("2d");
    w.width = Jo(v), w.height = Jo(_), $.fillStyle = e.fillColor || "transparent", $.fillRect(0, 0, v, _);
    var y = e.imageSmoothingEnabled, M = y === void 0 ? !0 : y, S = e.imageSmoothingQuality;
    $.imageSmoothingEnabled = M, S && ($.imageSmoothingQuality = S);
    var x = o.width, b = o.height, C = r, E = a, A, T, k, L, V, O;
    C <= -s || C > x ? (C = 0, A = 0, k = 0, V = 0) : C <= 0 ? (k = -C, C = 0, A = Math.min(x, s + C), V = A) : C <= x && (k = 0, A = Math.min(s, x - C), V = A), A <= 0 || E <= -l || E > b ? (E = 0, T = 0, L = 0, O = 0) : E <= 0 ? (L = -E, E = 0, T = Math.min(b, l + E), O = T) : E <= b && (L = 0, T = Math.min(l, b - E), O = T);
    var D = [C, E, A, T];
    if (V > 0 && O > 0) {
      var P = v / s;
      D.push(k * P, L * P, V * P, O * P);
    }
    return $.drawImage.apply($, [o].concat(s3(D.map(function(F) {
      return Math.floor(Jo(F));
    })))), w;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(e) {
    var n = this.options;
    return !this.disabled && !L0(e) && (n.aspectRatio = Math.max(0, e) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(e) {
    var n = this.options, o = this.dragBox, i = this.face;
    if (this.ready && !this.disabled) {
      var r = e === Ga, a = n.movable && e === u3;
      e = r || a ? e : h3, n.dragMode = e, Q1(o, J1, e), Go(o, Ar, r), Go(o, kr, a), n.cropBoxMovable || (Q1(i, J1, e), Go(i, Ar, r), Go(i, kr, a));
    }
    return this;
  }
}, zte = wn.Cropper, Nr = /* @__PURE__ */ function() {
  function t(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (ote(this, t), !e || !vte.test(e.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = e, this.options = ke({}, id, jo(n) && n), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return ite(t, [{
    key: "init",
    value: function() {
      var n = this.element, o = n.tagName.toLowerCase(), i;
      if (!n[Ae]) {
        if (n[Ae] = this, o === "img") {
          if (this.isImg = !0, i = n.getAttribute("src") || "", this.originalUrl = i, !i)
            return;
          i = n.src;
        } else o === "canvas" && window.HTMLCanvasElement && (i = n.toDataURL());
        this.load(i);
      }
    }
  }, {
    key: "load",
    value: function(n) {
      var o = this;
      if (n) {
        this.url = n, this.imageData = {};
        var i = this.element, r = this.options;
        if (!r.rotatable && !r.scalable && (r.checkOrientation = !1), !r.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (pte.test(n)) {
          _te.test(n) ? this.read(Lte(n)) : this.clone();
          return;
        }
        var a = new XMLHttpRequest(), s = this.clone.bind(this);
        this.reloading = !0, this.xhr = a, a.onabort = s, a.onerror = s, a.ontimeout = s, a.onprogress = function() {
          a.getResponseHeader("content-type") !== od && a.abort();
        }, a.onload = function() {
          o.read(a.response);
        }, a.onloadend = function() {
          o.reloading = !1, o.xhr = null;
        }, r.checkCrossOrigin && ad(n) && i.crossOrigin && (n = sd(n)), a.open("GET", n, !0), a.responseType = "arraybuffer", a.withCredentials = i.crossOrigin === "use-credentials", a.send();
      }
    }
  }, {
    key: "read",
    value: function(n) {
      var o = this.options, i = this.imageData, r = Nte(n), a = 0, s = 1, l = 1;
      if (r > 1) {
        this.url = Dte(n, od);
        var d = Rte(r);
        a = d.rotate, s = d.scaleX, l = d.scaleY;
      }
      o.rotatable && (i.rotate = a), o.scalable && (i.scaleX = s, i.scaleY = l), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var n = this.element, o = this.url, i = n.crossOrigin, r = o;
      this.options.checkCrossOrigin && ad(o) && (i || (i = "anonymous"), r = sd(o)), this.crossOrigin = i, this.crossOriginUrl = r;
      var a = document.createElement("img");
      i && (a.crossOrigin = i), a.src = r || o, a.alt = n.alt || "The image to crop", this.image = a, a.onload = this.start.bind(this), a.onerror = this.stop.bind(this), Je(a, Xl), n.parentNode.insertBefore(a, n.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var n = this, o = this.image;
      o.onload = null, o.onerror = null, this.sizing = !0;
      var i = wn.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(wn.navigator.userAgent), r = function(d, c) {
        ke(n.imageData, {
          naturalWidth: d,
          naturalHeight: c,
          aspectRatio: d / c
        }), n.initialImageData = ke({}, n.imageData), n.sizing = !1, n.sized = !0, n.build();
      };
      if (o.naturalWidth && !i) {
        r(o.naturalWidth, o.naturalHeight);
        return;
      }
      var a = document.createElement("img"), s = document.body || document.documentElement;
      this.sizingImage = a, a.onload = function() {
        r(a.width, a.height), i || s.removeChild(a);
      }, a.src = o.src, i || (a.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", s.appendChild(a));
    }
  }, {
    key: "stop",
    value: function() {
      var n = this.image;
      n.onload = null, n.onerror = null, n.parentNode.removeChild(n), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var n = this.element, o = this.options, i = this.image, r = n.parentNode, a = document.createElement("div");
        a.innerHTML = gte;
        var s = a.querySelector(".".concat(Ae, "-container")), l = s.querySelector(".".concat(Ae, "-canvas")), d = s.querySelector(".".concat(Ae, "-drag-box")), c = s.querySelector(".".concat(Ae, "-crop-box")), u = c.querySelector(".".concat(Ae, "-face"));
        this.container = r, this.cropper = s, this.canvas = l, this.dragBox = d, this.cropBox = c, this.viewBox = s.querySelector(".".concat(Ae, "-view-box")), this.face = u, l.appendChild(i), Je(n, Ct), r.insertBefore(s, n.nextSibling), vn(i, Xl), this.initPreview(), this.bind(), o.initialAspectRatio = Math.max(0, o.initialAspectRatio) || NaN, o.aspectRatio = Math.max(0, o.aspectRatio) || NaN, o.viewMode = Math.max(0, Math.min(3, Math.round(o.viewMode))) || 0, Je(c, Ct), o.guides || Je(c.getElementsByClassName("".concat(Ae, "-dashed")), Ct), o.center || Je(c.getElementsByClassName("".concat(Ae, "-center")), Ct), o.background && Je(s, "".concat(Ae, "-bg")), o.highlight || Je(u, cte), o.cropBoxMovable && (Je(u, kr), Q1(u, J1, ja)), o.cropBoxResizable || (Je(c.getElementsByClassName("".concat(Ae, "-line")), Ct), Je(c.getElementsByClassName("".concat(Ae, "-point")), Ct)), this.render(), this.ready = !0, this.setDragMode(o.dragMode), o.autoCrop && this.crop(), this.setData(o.data), wt(o.ready) && jt(n, ed, o.ready, {
          once: !0
        }), Qo(n, ed);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var n = this.cropper.parentNode;
        n && n.removeChild(this.cropper), vn(this.element, Ct);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = zte, t;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(n) {
      ke(id, jo(n) && n);
    }
  }]);
}();
ke(Nr.prototype, Zte, Bte, Vte, Fte, Hte, Ute);
const Wte = { class: "p-image-cropper" }, jte = { class: "header-title" }, Gte = { class: "content" }, Yte = { class: "loader" }, Xte = { class: "loader-title" }, Kte = { class: "image-content" }, qte = ["src"], Jte = {
  key: 0,
  class: "controllers"
}, Qte = { class: "left-side" }, ene = { class: "rotate-controllers" }, tne = {
  key: 0,
  class: "size-controllers"
}, nne = ["onClick"], one = { class: "size-value" }, ine = { class: "right-side" }, rne = { class: "zoom-controllers" }, ane = {
  key: 1,
  class: "mobile-controllers"
}, sne = { class: "controllers-row" }, lne = { class: "rotate-controllers" }, dne = { class: "zoom-controllers" }, cne = /* @__PURE__ */ oe({
  name: "PImageCropper",
  __name: "PImageCropper",
  props: {
    modelValue: {},
    circleMode: { type: Boolean }
  },
  emits: ["close", "changeUploadedPicture", "save", "update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, o = e, { mobile: i } = nt(), { t: r } = Mn({
      messages: {
        ru: {
          editPhoto: "Редактировать фото",
          loadingPhoto: "Загружаем изображение...",
          replacePhoto: "Заменить фото",
          save: "Сохранить"
        },
        en: {
          editPhoto: "Редактировать фото",
          loadingPhoto: "Загружаем изображение...",
          replacePhoto: "Заменить фото",
          save: "Сохранить"
        }
      }
    });
    et(() => a.value = new Nr(c.value, { aspectRatio: 1 / 1 }));
    const a = U(), s = U(1), l = U(!1), d = me(n, "modelValue", o), c = U(null), u = U(null), f = [
      {
        w: 24,
        h: 24,
        value: "1:1",
        ratio: 1 / 1,
        active: !0
      },
      {
        w: 24,
        h: 12,
        value: "2:1",
        ratio: 2 / 1,
        active: !1
      },
      {
        w: 12,
        h: 24,
        value: "1:2",
        ratio: 1 / 2,
        active: !1
      },
      {
        w: 24,
        h: 18,
        value: "4:3",
        ratio: 4 / 3,
        active: !1
      },
      {
        w: 18,
        h: 24,
        value: "3:4",
        ratio: 3 / 4,
        active: !1
      }
    ], m = (y) => new Promise((M, S) => {
      let x = new FileReader();
      x.onload = (b) => M(b.target.result), x.onerror = (b) => S(b), x.readAsDataURL(y);
    }), v = (y) => y === s.value, _ = () => u.value.click(), w = async (y) => {
      l.value = !0, d.value = await m(Array.from(y.target.files)[0]) ?? null, await a.value.destroy(), a.value = new Nr(c.value, { aspectRatio: 1 / 1 }), o("changeUploadedPicture"), l.value = !1;
    }, $ = (y) => {
      a.value.setAspectRatio(y), s.value = y;
    };
    return (y, M) => {
      const S = b2, x = Gi, b = tte, C = n0, E = _t, A = vt, T = Kee, k = Wee, L = Vee, V = Z2;
      return p(), g("div", Wte, [
        q(C, {
          id: "header",
          "no-padding": ""
        }, {
          left: G(() => [
            B(i) ? (p(), J(S, {
              key: 0,
              onClick: M[0] || (M[0] = (O) => y.$emit("close"))
            })) : X("", !0)
          ]),
          title: G(() => [
            h("div", jte, ne(B(r)("editPhoto")), 1)
          ]),
          right: G(() => [
            B(i) ? X("", !0) : (p(), J(x, {
              key: 0,
              onClick: M[1] || (M[1] = (O) => y.$emit("close"))
            })),
            B(i) ? (p(), J(b, {
              key: 1,
              onClick: _
            })) : X("", !0)
          ]),
          _: 1
        }),
        h("div", Gte, [
          it(h("div", Yte, [
            q(E),
            h("div", Xte, ne(B(r)("loadingPhoto")), 1)
          ], 512), [
            [Xt, l.value]
          ]),
          it(h("div", Kte, [
            h("div", null, [
              h("img", {
                ref_key: "cropperImage",
                ref: c,
                class: ee({ circleMode: y.circleMode }),
                src: B(d)
              }, null, 10, qte)
            ])
          ], 512), [
            [Xt, !l.value]
          ]),
          B(i) ? (p(), g("div", ane, [
            h("div", sne, [
              h("div", lne, [
                q(T, {
                  onClick: M[7] || (M[7] = (O) => a.value.rotate(-90))
                }),
                q(k, {
                  onClick: M[8] || (M[8] = (O) => a.value.rotate(90))
                })
              ]),
              h("div", dne, [
                q(L, {
                  onClick: M[9] || (M[9] = (O) => a.value.zoom(-0.1))
                }),
                q(V, {
                  onClick: M[10] || (M[10] = (O) => a.value.zoom(0.1))
                })
              ])
            ]),
            q(A, {
              block: "",
              onClick: M[11] || (M[11] = (O) => y.$emit("save", a.value.getCroppedCanvas().toDataURL("image/png")))
            }, {
              default: G(() => [
                xe(ne(B(r)("save")), 1)
              ]),
              _: 1
            })
          ])) : (p(), g("div", Jte, [
            h("div", Qte, [
              q(A, {
                class: "change-picture",
                color: "secondary",
                block: "",
                onClick: _
              }, {
                default: G(() => [
                  xe(ne(B(r)("replacePhoto")), 1)
                ]),
                _: 1
              }),
              h("div", ene, [
                q(T, {
                  onClick: M[2] || (M[2] = (O) => a.value.rotate(-90))
                }),
                q(k, {
                  onClick: M[3] || (M[3] = (O) => a.value.rotate(90))
                })
              ])
            ]),
            y.circleMode ? X("", !0) : (p(), g("div", tne, [
              (p(), g(_e, null, Ie(f, ({ w: O, h: D, value: P, ratio: F }, N) => h("div", {
                key: N,
                class: ee(["size-controller-item", { active: v(F) }]),
                onClick: (H) => $(F)
              }, [
                h("div", {
                  class: "size-view",
                  style: en(`width: ${O}px; height: ${D}px`)
                }, null, 4),
                h("div", one, ne(P), 1)
              ], 10, nne)), 64))
            ])),
            h("div", ine, [
              h("div", rne, [
                q(L, {
                  onClick: M[4] || (M[4] = (O) => a.value.zoom(-0.1))
                }),
                q(V, {
                  onClick: M[5] || (M[5] = (O) => a.value.zoom(0.1))
                })
              ]),
              q(A, {
                class: "save-picture",
                block: "",
                onClick: M[6] || (M[6] = (O) => y.$emit("save", a.value.getCroppedCanvas().toDataURL("image/png")))
              }, {
                default: G(() => [
                  xe(ne(B(r)("save")), 1)
                ]),
                _: 1
              })
            ])
          ])),
          h("input", {
            ref_key: "inputPicture",
            ref: u,
            type: "file",
            accept: "image/png, image/jpeg",
            hidden: "",
            onChange: w
          }, null, 544)
        ])
      ]);
    };
  }
}), une = /* @__PURE__ */ ae(cne, [["__scopeId", "data-v-8636d77b"]]), hne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PAlert: jd,
  PAlertContainer: OV,
  PAudioPlayer: WV,
  PAvatar: Xi,
  PBadge: UW,
  PBottomBar: QV,
  PBottomSheet: Ki,
  PButton: vt,
  PButtonFloating: Xd,
  PButtonFloatingGroup: bH,
  PCalendar: nU,
  PCalendarMultiply: pW,
  PCalendarNew: yW,
  PCard: SW,
  PCheckbox: EW,
  PChips: VW,
  PCombobox: SG,
  PCounter: qV,
  PDialog: TG,
  PDialogCard: Da,
  PDialogConfirm: LG,
  PDropdown: L2,
  PEmoji: WG,
  PEmojiPicker: UG,
  PExpansionPanel: KG,
  PField: Oa,
  PFileItemList: vY,
  PGallery: MX,
  PGroupAvatars: xX,
  PHint: Ra,
  PImageCropper: une,
  PInfinityList: kX,
  PInput: l0,
  PInputAvatar: $J,
  PInputFile: d0,
  PInputFileUploader: IJ,
  PInputPhoneEmail: iJ,
  PListItem: DJ,
  PLoader: _t,
  POptions: D2,
  PProgressCircular: ZJ,
  PProgressLinear: HJ,
  PRadioButton: jJ,
  PRangeStepper: eQ,
  PSelect: R2,
  PSideBar: FQ,
  PSidePage: WQ,
  PStepper: n3,
  PSwitch: qQ,
  PTabs: tee,
  PTag: lee,
  PTeleportContainer: uee,
  PTextarea: fee,
  PToast: i3,
  PToastContainer: wee,
  PTooltip: Dee,
  PTopBar: n0,
  PVideoPlayer: F2
}, Symbol.toStringTag, { value: "Module" }));
let fne = 0;
const Wi = U(/* @__PURE__ */ new Map()), mne = (t) => {
  const e = fne++;
  Wi.value.set(e, t), setTimeout(() => {
    Wi.value.delete(e);
  }, t.timer || 4e3);
}, pne = (t) => {
  Wi.value.delete(t);
}, _ne = () => ({ toasts: Wi, showToast: mne, closeToast: pne }), S1 = {
  [In.bold]: {
    velvet: "#9c65d9",
    cornflower: "#2db2e3",
    green: "#24c28a",
    orange: "#ef755a",
    blue: "#1c7ef1",
    pink: "#e05f8f",
    grass: "#d2dd26",
    black: "#2B3238"
  },
  [In.light]: {
    velvet: "#e2c9fe",
    cornflower: "#a5ebf4",
    green: "#ace4c9",
    orange: "#ffb8a8",
    blue: "#b6d7ff",
    pink: "#ffb9d3",
    grass: "#e6f145",
    black: "#2B3238"
  }
}, vne = () => ({ createBrandColors: () => {
  for (const n in k1)
    document.documentElement.style.setProperty(
      `--color-${In.bold}-${n}`,
      S1[In.bold][n]
    ), document.documentElement.style.setProperty(
      `--color-${In.light}-${n}`,
      S1[In.light][n]
    );
}, setupTheme: (n) => {
  const o = document.documentElement.style;
  o.setProperty("--color-primary", S1[In.bold][n || k1.blue]), o.setProperty("--color-primary-light", S1[In.light][n || k1.blue]), n && [k1.grass].includes(n) ? o.setProperty("--brand-text-color", "#1B1B1B") : o.setProperty("--brand-text-color", "#FFFFFF");
}, themes: S1 }), p0 = () => {
  const t = "data-yourgood-ios-app", e = () => document.documentElement.setAttribute(t, "true"), n = !!document.documentElement.getAttribute(t);
  return { setIosDataAttr: e, isIosApp: n };
};
function gne() {
  const t = document.createElement("link");
  t.rel = "stylesheet", t.href = "https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&display=swap", document.head.appendChild(t);
}
const Sne = {
  install: (t, e = {}) => {
    e = { iosAppFriendly: !1, fonts: !0, ...e }, t.provide("ProfeatUI", e);
    const { createBrandColors: n, setupTheme: o } = vne();
    n(), o(e.theme);
    const i = { ...hne, ...SV };
    if (e.iosAppFriendly) {
      const { setIosDataAttr: r } = p0();
      r();
    }
    Object.keys(i).forEach((r) => {
      t.component(r, i[r]);
    }), e.fonts && gne();
  }
};
export {
  qe as Breakpoints,
  Tn as CalendarReturningDateFormats,
  In as ColorsSchemes,
  k1 as ColorsThemes,
  ue as DateFormats,
  s1 as Errors,
  uC as IconAddFileMd,
  D6 as IconAddFileSm,
  yd as IconAddMd,
  wC as IconAddPeopleMd,
  V6 as IconAddPeopleSm,
  W6 as IconArrowBackSm,
  xC as IconArrowDoubleLeftMd,
  K6 as IconArrowDoubleLeftSm,
  EC as IconArrowDoubleRightMd,
  t4 as IconArrowDoubleRightSm,
  u4 as IconArrowDown2Sm,
  DC as IconArrowDownMd,
  VC as IconArrowDownShortMd,
  a4 as IconArrowDownSm,
  Md as IconArrowLeftMd,
  AL as IconArrowLeftRightMd,
  V$ as IconArrowLeftRightSm,
  XC as IconArrowLeftShortMd,
  _4 as IconArrowLeftSm,
  eb as IconArrowRightMd,
  rb as IconArrowRightShortMd,
  y4 as IconArrowRightSm,
  S4 as IconArrowToSm,
  P4 as IconArrowUp2Sm,
  cb as IconArrowUpMd,
  pb as IconArrowUpShortMd,
  N4 as IconArrowUpSm,
  wb as IconAttachmentMd,
  W4 as IconAttachmentSm,
  wu as IconAttachmentXS,
  Yi as IconAudioLg,
  kb as IconBackMd,
  K4 as IconBackSm,
  Lb as IconBanMd,
  th as IconBanSm,
  fZ as IconBellMd,
  Ub as IconBotMd,
  ah as IconBotSm,
  Yb as IconBoxMd,
  uh as IconBoxSm,
  Qb as IconBurgerMd,
  _h as IconBurgerSm,
  ix as IconCalendarEventMd,
  xh as IconCalendarEventSm,
  cx as IconCalendarMd,
  yx as IconCalendarNumberMd,
  Nh as IconCalendarNumberSm,
  Ix as IconCalendarPostponedMd,
  Hh as IconCalendarPostponedSm,
  Yh as IconCalendarSm,
  Ox as IconCalendarWarningMd,
  e5 as IconCalendarWarningSm,
  Eu as IconCalendarXS,
  gO as IconCancelMd,
  Eg as IconCancelSm,
  Cd as IconCarMd,
  u5 as IconCarSm,
  Bx as IconCardMd,
  a5 as IconCardSm,
  Yx as IconChatMd,
  w5 as IconChatSm,
  Qx as IconCheckMd,
  x5 as IconCheckSm,
  Ud as IconCheckboxActive,
  Hd as IconCheckboxDefault,
  rS as IconChecksMd,
  P5 as IconChecksSm,
  cS as IconCircleCheckMd,
  V5 as IconCircleCheckSm,
  sZ as IconClockMd,
  pS as IconCodeMd,
  W5 as IconCodeSm,
  bd as IconCoffeeMd,
  K5 as IconCoffeeSm,
  bS as IconCollapseLeftMd,
  t8 as IconCollapseLeftSm,
  kS as IconCollapseRightMd,
  a8 as IconCollapseRightSm,
  eD as IconConditionMd,
  _w as IconConditionSm,
  JR as IconConfettiMd,
  LS as IconCopyMd,
  u8 as IconCopySm,
  jr as IconCrossMd,
  _8 as IconCrossSm,
  US as IconCudosMd,
  y8 as IconCudosSm,
  YS as IconDislikeMd,
  S8 as IconDislikeSm,
  xd as IconDogMd,
  P8 as IconDogSm,
  iI as IconDownloadMd,
  F8 as IconDownloadSm,
  cI as IconEnterMd,
  G8 as IconEnterSm,
  Sd as IconErrorMd,
  Q8 as IconErrorSm,
  $I as IconExtendLeftMd,
  i7 as IconExtendLeftSm,
  bI as IconExtendRightMd,
  d7 as IconExtendRightSm,
  OL as IconEyeClosedMd,
  W$ as IconEyeClosedSm,
  BL as IconEyeMd,
  q$ as IconEyeSm,
  t1 as IconFileLg,
  Id as IconFileMd,
  m7 as IconFileSm,
  BD as IconFilledArrowLeftMd,
  gy as IconFilledArrowLeftSm,
  zD as IconFilledArrowRightMd,
  Iy as IconFilledArrowRightSm,
  XD as IconFilledCrossMd,
  Oy as IconFilledCrossSm,
  eN as IconFilledDesktopMd,
  Zy as IconFilledDesktopSm,
  rN as IconFilledDevicesMd,
  Uy as IconFilledDevicesSm,
  cN as IconFilledEditMd,
  Yy as IconFilledEditSm,
  pN as IconFilledGoogleMd,
  Qy as IconFilledGoogleSm,
  u6 as IconFilledGoogleXS,
  wN as IconFilledMobileMd,
  iM as IconFilledMobileSm,
  xN as IconFilledMoreMd,
  dM as IconFilledMoreSm,
  EN as IconFilledMoveMd,
  mM as IconFilledMoveSm,
  Yr as IconFilledPauseMd,
  $M as IconFilledPauseSm,
  BN as IconFilledPersonMd,
  bM as IconFilledPersonSm,
  Xr as IconFilledPlayMd,
  wd as IconFilledPlaySm,
  YN as IconFilledQRMd,
  dy as IconFilledReplySm,
  QN as IconFilledStarMd,
  OM as IconFilledStarSm,
  iR as IconFilledStopMd,
  ZM as IconFilledStopSm,
  _6 as IconFilledTelegramXS,
  dR as IconFilledTextStyleBoldMd,
  UM as IconFilledTextStyleBoldSm,
  mR as IconFilledTextStyleItalicMd,
  YM as IconFilledTextStyleItalicSm,
  $R as IconFilledTextStyleStrikethroughMd,
  QM as IconFilledTextStyleStrikethroughSm,
  aC as IconFilterOnMd,
  OI as IconFilterSortOffMd,
  $7 as IconFilterSortOffSm,
  BI as IconFilterSortOnMd,
  x7 as IconFilterSortOnSm,
  zI as IconFiltresMd,
  Ad as IconFlagMd,
  E7 as IconFlagSm,
  zL as IconFolderMd,
  nw as IconFolderSm,
  JT as IconFullscreenMd,
  Yv as IconFullscreenSm,
  RZ as IconGoogleDriveLg,
  IR as IconGoogleMd,
  kd as IconHashMd,
  N7 as IconHashSm,
  zO as IconHeartHandshakeMd,
  n$ as IconHeartHandshakeSm,
  iA as IconImageMd,
  F7 as IconImageSm,
  JB as IconImageXXL,
  cD as IconIncomingChatMd,
  Lw as IconIncomingChatSm,
  Ed as IconInfoMd,
  G7 as IconInfoSm,
  YZ as IconInstagramXL,
  $A as IconLaterMd,
  rf as IconLaterSm,
  Pd as IconLightBulbMd,
  cf as IconLightBulbSm,
  pD as IconLightningMd,
  Bw as IconLightningSm,
  AA as IconLinkMd,
  $f as IconLinkSm,
  tL as IconListCheckMd,
  f$ as IconListCheckSm,
  OA as IconListMd,
  bf as IconListSm,
  LO as IconLockMd,
  jg as IconLockSm,
  Td as IconMailMd,
  kf as IconMailSm,
  UA as IconMicrophoneMd,
  Df as IconMicrophoneSm,
  Nu as IconMicrophoneXS,
  YA as IconMinusMd,
  Vf as IconMinusSm,
  Od as IconMusicMd,
  Wf as IconMusicSm,
  ok as IconNoteMd,
  em as IconNoteSm,
  lk as IconNotificationMd,
  rm as IconNotificationSm,
  CO as IconNumbersMd,
  Dg as IconNumbersSm,
  vk as IconOkMd,
  mm as IconOkSm,
  Mk as IconOutMd,
  $m as IconOutSm,
  rD as IconOutgoingChatMd,
  xw as IconOutgoingChatSm,
  Ik as IconParametrMd,
  bm as IconParametrSm,
  XL as IconPartyMd,
  uw as IconPartySm,
  Tk as IconPeopleMd,
  km as IconPeopleSm,
  Fu as IconPeopleXS,
  Ld as IconPhoneMd,
  Fk as IconPhoneMissedMd,
  Zm as IconPhoneMissedSm,
  Gm as IconPhoneSm,
  jk as IconPinMd,
  Jm as IconPinSm,
  qk as IconPlaceholderMd,
  op as IconPlaceholderSm,
  fp as IconPlusMd,
  lp as IconPlusSm,
  jB as IconProductLogo,
  Gr as IconProfileMd,
  gp as IconProfileSm,
  ju as IconProfileXS,
  Wd as IconRadioActive,
  kO as IconRadioButtonMd,
  Fg as IconRadioButtonSm,
  zd as IconRadioDefault,
  sE as IconReassignMd,
  bp as IconReassignSm,
  hE as IconRefreshMd,
  $d as IconRefreshSm,
  yE as IconReopenMd,
  Rp as IconReopenSm,
  LD as IconRepeatEventMd,
  iy as IconRepeatEventSm,
  SE as IconRepeatMd,
  Hp as IconRepeatSm,
  AD as IconRepeatTaskMd,
  Jw as IconRepeatTaskSm,
  qu as IconRepeatXS,
  oO as IconRotateLeftMd,
  og as IconRotateLeftSm,
  PE as IconRotateMd,
  lO as IconRotateRightMd,
  hg as IconRotateRightSm,
  Gp as IconRotateSm,
  NE as IconRubelMd,
  Jp as IconRubelSm,
  FE as IconSearchMd,
  o9 as IconSearchSm,
  jE as IconSendMd,
  l9 as IconSendSm,
  f9 as IconSettings2Sm,
  JE as IconSettingsMd,
  $9 as IconSettingsSm,
  oP as IconShareMd,
  b9 as IconShareSm,
  Dd as IconSmileMd,
  O9 as IconSmileSm,
  Nd as IconSoccerMd,
  H9 as IconSoccerSm,
  _P as IconSocialsMd,
  q9 as IconSocialsSm,
  aL as IconSquareCheckMd,
  g$ as IconSquareCheckSm,
  BO as IconStagesMd,
  qg as IconStagesSm,
  fO as IconStarMd,
  yg as IconStarSm,
  yP as IconStatisticMd,
  n_ as IconStatisticSm,
  SP as IconSubtaskMd,
  s_ as IconSubtaskSm,
  n6 as IconSubtaskXS,
  PP as IconSuitcaseMd,
  h_ as IconSuitcaseSm,
  x6 as IconSuitcaseXS,
  RP as IconTagMd,
  M_ as IconTagSm,
  HP as IconTaskMd,
  I_ as IconTaskSm,
  E6 as IconTaskXS,
  UR as IconTelegramMd,
  vB as IconTelegramXL,
  GP as IconTemplateMd,
  T_ as IconTemplateSm,
  XO as IconTextMd,
  s$ as IconTextSm,
  Rd as IconTimeMd,
  Y_ as IconTimeSm,
  iT as IconTimerMd,
  B_ as IconTimerSm,
  uL as IconToggleMd,
  C$ as IconToggleSm,
  uT as IconTrashMd,
  Q_ as IconTrashSm,
  MD as IconUserCancelMd,
  jw as IconUserCancelSm,
  gL as IconUserStarMd,
  E$ as IconUserStarSm,
  Kr as IconVideoLg,
  Zd as IconVideoMd,
  iv as IconVideoSm,
  oV as IconVideoXXL,
  Bd as IconVolumeMd,
  Vd as IconVolumeOffMd,
  dv as IconVolumeOffSm,
  mv as IconVolumeSm,
  kT as IconWABATemplateMd,
  wv as IconWABATemplateSm,
  LT as IconWalletMd,
  kv as IconWalletSm,
  Fd as IconWarningMd,
  Lv as IconWarningSm,
  GT as IconWeekMd,
  Uv as IconWeekSm,
  NB as IconWhatsAppBusinessApiXL,
  LR as IconWhatsAppMd,
  lB as IconWhatsAppXL,
  CL as IconWorldMd,
  D$ as IconWorldSm,
  De as MimeType,
  jd as PAlert,
  OV as PAlertContainer,
  WV as PAudioPlayer,
  Xi as PAvatar,
  UW as PBadge,
  QV as PBottomBar,
  Ki as PBottomSheet,
  vt as PButton,
  Xd as PButtonFloating,
  bH as PButtonFloatingGroup,
  nU as PCalendar,
  pW as PCalendarMultiply,
  yW as PCalendarNew,
  SW as PCard,
  EW as PCheckbox,
  VW as PChips,
  SG as PCombobox,
  qV as PCounter,
  TG as PDialog,
  Da as PDialogCard,
  LG as PDialogConfirm,
  L2 as PDropdown,
  WG as PEmoji,
  UG as PEmojiPicker,
  KG as PExpansionPanel,
  Oa as PField,
  vY as PFileItemList,
  MX as PGallery,
  xX as PGroupAvatars,
  Ra as PHint,
  une as PImageCropper,
  kX as PInfinityList,
  l0 as PInput,
  $J as PInputAvatar,
  d0 as PInputFile,
  IJ as PInputFileUploader,
  iJ as PInputPhoneEmail,
  DJ as PListItem,
  _t as PLoader,
  D2 as POptions,
  ZJ as PProgressCircular,
  HJ as PProgressLinear,
  jJ as PRadioButton,
  eQ as PRangeStepper,
  R2 as PSelect,
  FQ as PSideBar,
  xne as PSideBarTypes,
  WQ as PSidePage,
  n3 as PStepper,
  qQ as PSwitch,
  tee as PTabs,
  lee as PTag,
  uee as PTeleportContainer,
  fee as PTextarea,
  i3 as PToast,
  wee as PToastContainer,
  Dee as PTooltip,
  n0 as PTopBar,
  F2 as PVideoPlayer,
  Sne as ProfeatUI,
  Cne as internationalCallingCodes,
  nt as useBreakpoints,
  p0 as useMobileApp,
  vne as useTheme,
  _ne as useToast
};
//# sourceMappingURL=index.js.map
